import { useContext, createContext, useRef, useEffect, useReducer, useCallback, useState, cloneElement, createElement, Fragment, Component, forwardRef, memo, Children } from 'react';
import styled, { css, keyframes, createGlobalStyle } from 'styled-components';
import { string, func, number, object } from 'prop-types';
import accounting from 'accounting';

var MOBILE_S = '(min-width: 320px)';
var MOBILE_M = '(min-width: 375px)';
var MOBILE_L = '(min-width: 425px)';
var TABLET = '(min-width: 768px)';
var LAPTOP = '(min-width: 1024px)';
var LAPTOP_L = '(min-width: 1440px)';
var DESKTOP = '(min-width: 2560px)';

var breakpoints = /*#__PURE__*/Object.freeze({
  __proto__: null,
  MOBILE_S: MOBILE_S,
  MOBILE_M: MOBILE_M,
  MOBILE_L: MOBILE_L,
  TABLET: TABLET,
  LAPTOP: LAPTOP,
  LAPTOP_L: LAPTOP_L,
  DESKTOP: DESKTOP
});

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var hexToRgb = function hexToRgb(hex, alpha) {
  var r = parseInt(hex.slice(1, 3), 16);
  var g = parseInt(hex.slice(3, 5), 16);
  var b = parseInt(hex.slice(5, 7), 16);

  if (alpha) {
    return "rgba(".concat(r, ",").concat(g, ",").concat(b, ",").concat(alpha, ")");
  } else {
    return "rgb(".concat(r, ",").concat(g, ",").concat(b, ")");
  }
};

var _PRIMARY_HOVER_HEX;
/**
 * Colors palette
 *
 * Please respect these rules:
 * - all color constants should correctly named (human named)
 * - the named should be capitalized
 * - constant have to be exported
 * - constant must be sorted in a logical category
 */
// Shades of blue

var BLUE_SHADE_1 = '#D1EDF7';
var BLUE_SHADE_2 = '#004E69';
var BLUE_SHADE_3 = '#E7F8FC'; // Shades of red

var RED_SHADE_1 = '#FDDCE3';
var RED_SHADE_2 = '#8B0020'; // Primary colors

var PRIMARY_BLACK = '#232221';
var PRIMARY_BLACK_HOVER = '#363636'; // TODO: Update with new value?

var PRIMARY_BLUE = '#18A5D6';
var PRIMARY_BLUE_HOVER = '#007199';
var PRIMARY_GREEN = '#66DC88'; // NOTE: Deprecated

var PRIMARY_GREEN_HOVER = '#64D088'; // NOTE: Deprecated

var PRIMARY_RED = '#F01446';
var PRIMARY_RED_HOVER = '#BD0A33';
var PRIMARY_SAND = '#F6F1EB';
var PRIMARY_WHITE = '#FFFFFF'; // Secondary colors

var SECONDARY_YELLOW = '#F7C884'; // NOTE: Deprecated

var SECONDARY_INDIGO = '#3E51B5'; // NOTE: Deprecated

var SECONDARY_PURPLE = '#8B66C5'; // NOTE: Deprecated

var SECONDARY_RED = '#FF4336'; // NOTE: Deprecated

var SECONDARY_PINK = '#FF5858'; // NOTE: Deprecated
// Shades of grey

var GREY_SHADE_1 = '#59544E';
var GREY_SHADE_2 = '#807A74';
var GREY_SHADE_3 = '#999999';
var GREY_SHADE_4 = '#BDBDBD';
var GREY_SHADE_5 = '#E3DDD3';
var GREY_SHADE_6 = '#F5F6F9';
var GREY_SHADE_7 = '#B8AFA4'; // Brand accent colors

var BRAND_ACCENT_GREEN = '#02715C';
var BRAND_ACCENT_PURPLE = '#9E3F78';
var BRAND_ACCENT_YELLOW = '#FDCE03'; // Social colors

var FACEBOOK = '#3B5998';
var MESSENGER = '#057FF5';
var TWITTER = '#55ACEE';
var INSTAGRAM = '#E1306C';
var LINKEDIN = '#0077B5';
var YOUTUBE = '#E52D27';
var WHATSAPP = '#2DBEA5';
var BANDCAMP = '#60A8B9';
var SOUNDCLOUD = '#FF4300';
var SPOTIFY = '#1ED660';
var TWITCH = '#6C2498';
var VIMEO = '#00B9D8'; // Helper for the colors utils

var PRIMARY_COLORS = {
  'primary-black': PRIMARY_BLACK,
  'primary-blue': PRIMARY_BLUE,
  'primary-red': PRIMARY_RED,
  'primary-white': PRIMARY_WHITE,
  // NOTE: Deprecated
  'primary-green': PRIMARY_GREEN
};
var PRIMARY_HOVER = {
  'primary-black': PRIMARY_BLACK_HOVER,
  'primary-blue': PRIMARY_BLUE_HOVER,
  'primary-red': PRIMARY_RED_HOVER,
  // NOTE: Deprecated
  'primary-green': PRIMARY_GREEN_HOVER
};
var PRIMARY_HOVER_HEX = (_PRIMARY_HOVER_HEX = {}, _defineProperty(_PRIMARY_HOVER_HEX, PRIMARY_BLACK.toLowerCase(), PRIMARY_BLACK_HOVER), _defineProperty(_PRIMARY_HOVER_HEX, PRIMARY_BLUE.toLowerCase(), PRIMARY_BLUE_HOVER), _defineProperty(_PRIMARY_HOVER_HEX, PRIMARY_RED.toLowerCase(), PRIMARY_RED_HOVER), _defineProperty(_PRIMARY_HOVER_HEX, PRIMARY_GREEN.toLowerCase(), PRIMARY_GREEN_HOVER), _PRIMARY_HOVER_HEX); // Utils

var primary = function primary(props) {
  var primaryColor = props.theme && props.theme.colors && props.theme.colors.primary;

  if (primaryColor && primaryColor.charAt(0) === '#') {
    return primaryColor;
  }

  if (PRIMARY_COLORS[primaryColor]) {
    return PRIMARY_COLORS[primaryColor];
  }

  return PRIMARY_BLUE;
};
var primaryHover = function primaryHover(props) {
  var color = props.theme && props.theme.colors && props.theme.colors.primary;

  if (!color) {
    return PRIMARY_BLUE_HOVER;
  }

  if (PRIMARY_HOVER[color]) {
    return PRIMARY_HOVER[color];
  }

  var lowerCaseColor = color.toLowerCase();

  if (lowerCaseColor && lowerCaseColor.charAt(0) === '#') {
    if (PRIMARY_HOVER_HEX[lowerCaseColor]) {
      return PRIMARY_HOVER_HEX[lowerCaseColor];
    }

    return hexToRgb(lowerCaseColor, 0.85);
  }

  return PRIMARY_BLUE_HOVER;
};

var colors = /*#__PURE__*/Object.freeze({
  __proto__: null,
  hexToRgb: hexToRgb,
  BLUE_SHADE_1: BLUE_SHADE_1,
  BLUE_SHADE_2: BLUE_SHADE_2,
  BLUE_SHADE_3: BLUE_SHADE_3,
  RED_SHADE_1: RED_SHADE_1,
  RED_SHADE_2: RED_SHADE_2,
  PRIMARY_BLACK: PRIMARY_BLACK,
  PRIMARY_BLACK_HOVER: PRIMARY_BLACK_HOVER,
  PRIMARY_BLUE: PRIMARY_BLUE,
  PRIMARY_BLUE_HOVER: PRIMARY_BLUE_HOVER,
  PRIMARY_GREEN: PRIMARY_GREEN,
  PRIMARY_GREEN_HOVER: PRIMARY_GREEN_HOVER,
  PRIMARY_RED: PRIMARY_RED,
  PRIMARY_RED_HOVER: PRIMARY_RED_HOVER,
  PRIMARY_SAND: PRIMARY_SAND,
  PRIMARY_WHITE: PRIMARY_WHITE,
  SECONDARY_YELLOW: SECONDARY_YELLOW,
  SECONDARY_INDIGO: SECONDARY_INDIGO,
  SECONDARY_PURPLE: SECONDARY_PURPLE,
  SECONDARY_RED: SECONDARY_RED,
  SECONDARY_PINK: SECONDARY_PINK,
  GREY_SHADE_1: GREY_SHADE_1,
  GREY_SHADE_2: GREY_SHADE_2,
  GREY_SHADE_3: GREY_SHADE_3,
  GREY_SHADE_4: GREY_SHADE_4,
  GREY_SHADE_5: GREY_SHADE_5,
  GREY_SHADE_6: GREY_SHADE_6,
  GREY_SHADE_7: GREY_SHADE_7,
  BRAND_ACCENT_GREEN: BRAND_ACCENT_GREEN,
  BRAND_ACCENT_PURPLE: BRAND_ACCENT_PURPLE,
  BRAND_ACCENT_YELLOW: BRAND_ACCENT_YELLOW,
  FACEBOOK: FACEBOOK,
  MESSENGER: MESSENGER,
  TWITTER: TWITTER,
  INSTAGRAM: INSTAGRAM,
  LINKEDIN: LINKEDIN,
  YOUTUBE: YOUTUBE,
  WHATSAPP: WHATSAPP,
  BANDCAMP: BANDCAMP,
  SOUNDCLOUD: SOUNDCLOUD,
  SPOTIFY: SPOTIFY,
  TWITCH: TWITCH,
  VIMEO: VIMEO,
  primary: primary,
  primaryHover: primaryHover
});

/**
 * Fonts
 */
var PRIMARY_FONT = 'sofia-pro, sans-serif';
var SECONDARY_FONT = 'ff-tisa-web-pro, serif';
var TERTIARY_FONT = 'Roboto Light';
var EMPHASIS_FONT = 'sofia-pro-condensed, sans-serif';

var fonts = /*#__PURE__*/Object.freeze({
  __proto__: null,
  PRIMARY_FONT: PRIMARY_FONT,
  SECONDARY_FONT: SECONDARY_FONT,
  TERTIARY_FONT: TERTIARY_FONT,
  EMPHASIS_FONT: EMPHASIS_FONT
});

var HEADER_HEIGHT = '60px';
var HEADER_INTERNAL_HEIGHT = '57px';

var sizes = /*#__PURE__*/Object.freeze({
  __proto__: null,
  HEADER_HEIGHT: HEADER_HEIGHT,
  HEADER_INTERNAL_HEIGHT: HEADER_INTERNAL_HEIGHT
});

/**
 * Z-Index list
 *
 */
var BELOW = -1;
var NEUTRAL = 0;
var ABOVE = 1;
var HIGH = 100;
var NAVIGATION_MENU = 200;
var TOAST = 250;
var HEADER = 300;
var HEADER_BRAND = 301;
var HEADER_NAV_ITEM = 302;
var HEADER_NAV_SHUTTER = 303;
var SHUTTER = 800;
var MODAL = 900;

var zindex = /*#__PURE__*/Object.freeze({
  __proto__: null,
  BELOW: BELOW,
  NEUTRAL: NEUTRAL,
  ABOVE: ABOVE,
  HIGH: HIGH,
  NAVIGATION_MENU: NAVIGATION_MENU,
  TOAST: TOAST,
  HEADER: HEADER,
  HEADER_BRAND: HEADER_BRAND,
  HEADER_NAV_ITEM: HEADER_NAV_ITEM,
  HEADER_NAV_SHUTTER: HEADER_NAV_SHUTTER,
  SHUTTER: SHUTTER,
  MODAL: MODAL
});

var autocompleteContext = /*#__PURE__*/createContext(function () {
  throw Error('AutocompleteItem outside of AutocompleteList');
});
function useAutocompleteContext() {
  return useContext(autocompleteContext);
}
var AutocompleteContextProvider = autocompleteContext.Provider;

function useAutocompleteItem(result) {
  var register = useAutocompleteContext();
  return register(result);
}

function useDebounce(call) {
  var immediate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
  var handle = useRef();
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var firstCall = handle.current === undefined;

    if (!firstCall) {
      clearTimeout(handle.current);
    }

    handle.current = setTimeout(function () {
      call.apply(void 0, args);
      handle.current = undefined;
    }, timeout);

    if (firstCall && immediate) {
      call.apply(void 0, args);
    }
  };
}

function reducer(state, action) {
  switch (action.type) {
    case 'focus':
      {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          focused: action.focused
        });
      }

    case 'result':
      {
        if (action.for !== state.currentQuery || !state.isOpen) {
          return state;
        }

        return _objectSpread2(_objectSpread2({}, state), {}, {
          results: action.results,
          isLoading: false,
          focused: undefined
        });
      }

    case 'query':
      {
        if (action.query === state.currentQuery) {
          return state;
        }

        return _objectSpread2(_objectSpread2({}, state), {}, {
          currentQuery: action.query,
          focused: undefined,
          isLoading: true,
          isOpen: true
        });
      }

    case 'close':
      {
        var _action$result$label, _action$result;

        return _objectSpread2(_objectSpread2({}, state), {}, {
          focused: undefined,
          isOpen: false,
          currentQuery: (_action$result$label = (_action$result = action.result) === null || _action$result === void 0 ? void 0 : _action$result.label) !== null && _action$result$label !== void 0 ? _action$result$label : state.currentQuery,
          results: []
        });
      }

    default:
      {
        return state;
      }
  }
}

var navigableContext = /*#__PURE__*/createContext(function () {
  throw Error('NavigableItem outside of NavigableList');
});
function useNavigableContext() {
  return useContext(navigableContext);
}
var NavigableContextProvider = navigableContext.Provider;

function useNavigableItem(item) {
  var register = useNavigableContext();
  return register(item);
}

function getItem(items, identifier) {
  return items.find(function (item) {
    return item.identifier === identifier;
  });
}
function getFocusedItem(state, identifier) {
  var disableInitFocus = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var targetItem = identifier !== undefined ? getItem(state.registered, identifier) : disableInitFocus ? undefined : state.head;
  var item = targetItem; // while item exists, is disabled or filtered

  while (item !== undefined && (item.disabled || item.filtered)) {
    item = item.next;

    if (item === targetItem) {
      // we went full circle on options, break to avoid infinite loop
      break;
    }
  }

  return item;
}
function getItemIndex(items, identifier) {
  return items.findIndex(function (item) {
    return item.identifier === identifier;
  });
}
function normalize(str) {
  try {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  } catch (error) {
    return str.toLowerCase();
  }
}
function matchQuery(item, query) {
  return normalize(item.label).startsWith(query);
}
function includesQuery(item, query) {
  return normalize(item.label).includes(query);
}

function reducer$1(state, action) {
  switch (action.type) {
    case 'register':
      {
        var linkedItem = getItem(state.registered, action.item.identifier);

        if (linkedItem !== undefined) {
          return state;
        }

        var newLinkedItem = _objectSpread2(_objectSpread2({}, action.item), {}, {
          next: undefined,
          previous: undefined
        });

        var nextState = _objectSpread2(_objectSpread2({}, state), {}, {
          registered: [].concat(_toConsumableArray(state.registered), [newLinkedItem])
        });

        if (nextState.head === undefined) {
          nextState.head = newLinkedItem;
        }

        if (nextState.tail === undefined) {
          nextState.tail = newLinkedItem;
        } else {
          nextState.tail.next = newLinkedItem;
          newLinkedItem.previous = nextState.tail;
          nextState.tail = newLinkedItem;
        }

        return nextState;
      }

    case 'deregister':
      {
        var linkedItemIndex = getItemIndex(state.registered, action.identifier);

        if (linkedItemIndex === -1) {
          return state;
        }

        var _linkedItem = state.registered[linkedItemIndex];
        var head = state.head;
        var tail = state.tail;

        if (_linkedItem.previous) {
          _linkedItem.previous.next = _linkedItem.next;
        }

        if (_linkedItem.next) {
          _linkedItem.next.previous = _linkedItem.previous;
        }

        if (head && _linkedItem.identifier === head.identifier) {
          head = _linkedItem.next;
        }

        if (tail && _linkedItem.identifier === tail.identifier) {
          tail = _linkedItem.previous;
        }

        return _objectSpread2(_objectSpread2({}, state), {}, {
          head: head,
          tail: tail,
          registered: [].concat(_toConsumableArray(state.registered.slice(0, linkedItemIndex)), _toConsumableArray(state.registered.slice(linkedItemIndex + 1)))
        });
      }

    case 'disable':
      {
        var _linkedItemIndex = getItemIndex(state.registered, action.identifier);

        var _linkedItem2 = state.registered[_linkedItemIndex];

        if (_linkedItem2 === undefined || _linkedItem2.disabled === action.disabled) {
          return state;
        }

        var nextRegistered = [].concat(_toConsumableArray(state.registered.slice(0, _linkedItemIndex)), [_objectSpread2(_objectSpread2({}, _linkedItem2), {}, {
          disabled: action.disabled
        })], _toConsumableArray(state.registered.slice(_linkedItemIndex + 1)));

        for (var i = 0; i < nextRegistered.length; i += 1) {
          var previous = i === 0 ? nextRegistered[nextRegistered.length - 1] : nextRegistered[i - 1];
          var next = i === nextRegistered.length - 1 ? nextRegistered[0] : nextRegistered[i + 1];
          nextRegistered[i].next = next;
          nextRegistered[i].previous = previous;
        }

        return _objectSpread2(_objectSpread2({}, state), {}, {
          tail: nextRegistered[nextRegistered.length - 1],
          head: nextRegistered[0],
          registered: nextRegistered
        });
      }

    case 'type-ahead':
      {
        var now = Date.now();
        var query = state.typeAhead.query;

        if (now - state.typeAhead.timestamp < 300) {
          query += action.key;
        } else {
          query = action.key;
        }

        return _objectSpread2(_objectSpread2({}, state), {}, {
          typeAhead: {
            timestamp: now,
            query: query
          }
        });
      }

    case 'filter':
      {
        var filter = normalize(action.filter);

        var _nextRegistered = state.registered.map(function (linkedItem) {
          if (includesQuery(linkedItem, filter)) {
            return _objectSpread2(_objectSpread2({}, linkedItem), {}, {
              filtered: false
            });
          }

          return _objectSpread2(_objectSpread2({}, linkedItem), {}, {
            filtered: true
          });
        });

        for (var _i = 0; _i < _nextRegistered.length; _i += 1) {
          var _previous = _i === 0 ? _nextRegistered[_nextRegistered.length - 1] : _nextRegistered[_i - 1];

          var _next = _i === _nextRegistered.length - 1 ? _nextRegistered[0] : _nextRegistered[_i + 1];

          _nextRegistered[_i].next = _next;
          _nextRegistered[_i].previous = _previous;
        }

        return _objectSpread2(_objectSpread2({}, state), {}, {
          tail: _nextRegistered[_nextRegistered.length - 1],
          head: _nextRegistered[0],
          registered: _nextRegistered
        });
      }

    default:
      {
        return state;
      }
  }
}

/*
  Creates a ref that is kept updated on each render. Useful for event handlers,
  so they can access current values without needing to de-registerer/re-register
*/

function useCommittedRef(value) {
  var ref = useRef(value);
  useEffect(function () {
    ref.current = value;
  }, [value]);
  return ref;
}

function useNavigableList(active, focused) {
  var typeahead = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var disableInitFocus = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var filter = arguments.length > 4 ? arguments[4] : undefined;

  var _React$useReducer = useReducer(reducer$1, {
    registered: [],
    typeAhead: {
      timestamp: 0,
      query: ''
    }
  }),
      _React$useReducer2 = _slicedToArray(_React$useReducer, 2),
      state = _React$useReducer2[0],
      dispatch = _React$useReducer2[1];

  var stateCommittedRef = useCommittedRef(state);
  var activeCommittedRef = useCommittedRef(active);
  var focusedItem = getFocusedItem(state, focused, disableInitFocus);
  var focusedItemCommittedRef = useCommittedRef(focusedItem);
  useEffect(function () {
    window.addEventListener('keydown', handleKeyDown);
    return function () {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);
  useEffect(function () {
    if (focusedItem !== undefined && active) {
      focusedItem.handleFocus();
    }
  }, [focusedItem, active]);
  useEffect(function () {
    if (filter !== undefined) {
      dispatch({
        type: 'filter',
        filter: filter
      });
    }
  }, [filter]);
  useEffect(function () {
    var focusedItem = focusedItemCommittedRef.current;
    var state = stateCommittedRef.current;

    if (typeahead) {
      var query = normalize(state.typeAhead.query);

      if (focusedItem !== undefined && !focusedItem.disabled && !focusedItem.filtered && matchQuery(focusedItem, query)) {
        if (focusedItem.next !== undefined && !focusedItem.next.disabled && !focusedItem.next.filtered && matchQuery(focusedItem.next, query)) {
          focusedItem.next.handleFocus();
        } else {
          var match = state.registered.find(function (item) {
            return matchQuery(item, query);
          });

          if (match !== undefined) {
            match.handleFocus();
          }
        }
      } else {
        var _match = state.registered.find(function (item) {
          return matchQuery(item, query);
        });

        if (_match !== undefined) {
          _match.handleFocus();
        }
      }
    }
  }, [state.typeAhead]);
  return {
    register: useCallback(register, [])
  };

  function handleKeyDown(event) {
    var active = activeCommittedRef.current;
    var focusedItem = focusedItemCommittedRef.current;

    if (!active) {
      return;
    }

    if (event.key === 'ArrowUp' || event.key === 'Up') {
      event.preventDefault();
      var toFocus = focusedItem ? focusedItem.previous : stateCommittedRef.current.tail;

      while (toFocus !== undefined && (toFocus.disabled || toFocus.filtered)) {
        toFocus = toFocus.previous;
      }

      if (toFocus) {
        toFocus.handleFocus();
      }

      return;
    }

    if (event.key === 'ArrowDown' || event.key === 'Down') {
      event.preventDefault();

      var _toFocus = focusedItem ? focusedItem.next : stateCommittedRef.current.head;

      while (_toFocus !== undefined && (_toFocus.disabled || _toFocus.filtered)) {
        _toFocus = _toFocus.next;
      }

      if (_toFocus) {
        _toFocus.handleFocus();
      }

      return;
    }

    if (event.key && event.key.length === 1) {
      // only printable chars
      dispatch({
        type: 'type-ahead',
        key: event.key
      });
    }
  } // register an item in the NavigableList. Usually not used directly, but passed
  // down the tree in a context, to allow child self-registration.
  // see /src/behaviours/README.md


  function register(item) {
    useEffect(function () {
      dispatch({
        type: 'register',
        item: item
      });
      return function () {
        dispatch({
          type: 'deregister',
          identifier: item.identifier
        });
      };
    }, []);
    useEffect(function () {
      if (isDisabled(item.identifier) !== item.disabled) {
        dispatch({
          type: 'disable',
          identifier: item.identifier,
          disabled: item.disabled
        });
      }
    }, [item.identifier, item.disabled]);
    return {
      focus: useCallback(focus, []),
      isFocused: isFocused(item.identifier),
      isFiltered: isFiltered(item.identifier)
    };
  }

  function focus(identifier) {
    var state = stateCommittedRef.current;
    var item = getItem(state.registered, identifier);

    if (item !== undefined && !item.disabled && !item.filtered && !isFocused(identifier)) {
      item.handleFocus();
    }
  }

  function isFocused(identifier) {
    var focusedItem = focusedItemCommittedRef.current;

    if (focusedItem === undefined) {
      return false;
    }

    return focusedItem.identifier === identifier;
  }

  function isFiltered(identifier) {
    var state = stateCommittedRef.current;
    var item = getItem(state.registered, identifier);

    if (item === undefined) {
      return false;
    }

    return item.filtered;
  }

  function isDisabled(identifier) {
    var state = stateCommittedRef.current;
    var item = getItem(state.registered, identifier);

    if (item === undefined) {
      return undefined;
    }

    return item.disabled;
  }
}

function useAutocompleteList(query, onSelect, fetch) {
  var _React$useReducer = useReducer(reducer, {
    isLoading: false,
    isOpen: false,
    currentQuery: query,
    focused: undefined,
    results: []
  }),
      _React$useReducer2 = _slicedToArray(_React$useReducer, 2),
      state = _React$useReducer2[0],
      dispatch = _React$useReducer2[1]; // this ref will always point to the current state. Event handlers can close over
  // this ref and be able to access current state without deregister/reregister.


  var stateCommittedRef = useCommittedRef(state);
  var debouncedHandleQuery = useDebounce(handleQuery, false, 400);
  var navigable = useNavigableList(state.isOpen, state.focused, false, false);
  useEffect(function () {
    if (query !== state.currentQuery) {
      debouncedHandleQuery(query);
    }
  }, [query, state.currentQuery]);
  useEffect(function () {
    window.addEventListener('keydown', handleKeyDown);
    return function () {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);
  return {
    results: state.results,
    isOpen: state.isOpen,
    isLoading: state.isLoading,
    close: function close() {
      return dispatch({
        type: 'close'
      });
    },
    register: register
  }; // register an item in the AutocompleteList. Usually not used directly, but passed
  // down the tree in a context, to allow child self-registration.
  // see /src/behaviours/README.md

  function register(result) {
    var _navigable$register = navigable.register({
      identifier: result.value,
      label: result.label,
      disabled: false,
      handleFocus: function handleFocus() {
        dispatch({
          type: 'focus',
          focused: result.value
        });
      },
      filtered: false
    }),
        focus = _navigable$register.focus,
        isFocused = _navigable$register.isFocused;

    return {
      select: function select() {
        onSelect(result);
        dispatch({
          type: 'close',
          result: result
        });
      },
      focus: focus,
      isFocused: isFocused,
      isFiltered: false
    };
  }

  function handleKeyDown(event) {
    var state = stateCommittedRef.current;

    if (state.isOpen) {
      if (event.key === 'Escape' || event.key === 'Esc') {
        event.preventDefault();
        dispatch({
          type: 'close'
        });
        return;
      }

      if (event.key === 'Enter') {
        event.preventDefault();

        if (state.focused === undefined) {
          return;
        }

        var selected = state.results.find(function (result) {
          return result.value === state.focused;
        });

        if (selected !== undefined) {
          onSelect(selected);
          dispatch({
            type: 'close',
            result: selected
          });
        }

        return;
      }
    }
  }

  function handleQuery(query) {
    dispatch({
      type: 'query',
      query: query
    });

    if (query.length === 0) {
      dispatch({
        type: 'close'
      });
    } else {
      fetch(query).then(function (results) {
        dispatch({
          type: 'result',
          for: query,
          results: results
        });
      });
    }
  }
}

function reducer$2(state, action) {
  switch (action.type) {
    case 'register':
      {
        var optionIndex = state.registered.findIndex(function (option) {
          return option.value === action.option.value;
        });

        if (optionIndex !== -1) {
          var option = state.registered[optionIndex];

          if (option.disabled !== action.option.disabled) {
            return _objectSpread2(_objectSpread2({}, state), {}, {
              registered: [].concat(_toConsumableArray(state.registered.slice(0, optionIndex)), [_objectSpread2(_objectSpread2({}, option), {}, {
                disabled: action.option.disabled
              })], _toConsumableArray(state.registered.slice(optionIndex + 1)))
            });
          }

          return state;
        }

        var nextState = _objectSpread2(_objectSpread2({}, state), {}, {
          registered: [].concat(_toConsumableArray(state.registered), [action.option])
        });

        return nextState;
      }

    case 'deregister':
      {
        var _optionIndex = state.registered.findIndex(function (option) {
          return option.value === action.value;
        });

        if (_optionIndex !== -1) {
          return _objectSpread2(_objectSpread2({}, state), {}, {
            registered: [].concat(_toConsumableArray(state.registered.slice(0, _optionIndex)), _toConsumableArray(state.registered.slice(_optionIndex + 1)))
          });
        }

        return state;
      }

    case 'focus':
      {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          focused: action.focused
        });
      }

    case 'open':
      {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          focused: action.focused,
          open: true
        });
      }

    case 'close':
      {
        if (!state.open) {
          return state;
        }

        return _objectSpread2(_objectSpread2({}, state), {}, {
          focused: undefined,
          open: false
        });
      }

    default:
      {
        return state;
      }
  }
}

function useSelect(selected, selectBoxRef, handleClose, handleChange, multiple, disableInitFocus, filter) {
  var selectedHead = selected[0];

  var _React$useReducer = useReducer(reducer$2, {
    registered: [],
    open: false,
    focused: selectedHead
  }),
      _React$useReducer2 = _slicedToArray(_React$useReducer, 2),
      state = _React$useReducer2[0],
      dispatch = _React$useReducer2[1];

  var stateCommittedRef = useCommittedRef(state);
  var selectedOptions = state.registered.filter(function (option) {
    return selected.includes(option.value);
  });
  var selectedOptionsCommittedRef = useCommittedRef(selectedOptions);
  selectedOptionsCommittedRef.current = selectedOptions;
  var handleChangeComittedRef = useCommittedRef(handleChange);
  var navigable = useNavigableList(state.open, state.focused, filter === undefined, // type-ahead if no filter
  disableInitFocus, filter);
  useEffect(function () {
    window.addEventListener('keydown', handleKeyDown);
    return function () {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);
  return {
    register: register,
    isOpen: state.open,
    open: function open() {
      return dispatch({
        type: 'open',
        focused: selectedHead
      });
    },
    close: close,
    clear: function clear() {
      var handleChange = handleChangeComittedRef.current;
      selected.forEach(function (value) {
        var option = getOption(value);

        if (option === undefined) {
          return;
        }

        option.handleToggle(false);
      });
      handleChange([]);
    },
    selectedOptions: state.registered.filter(function (option) {
      return selected.includes(option.value);
    })
  };

  function handleKeyDown(event) {
    var state = stateCommittedRef.current;
    var selectBox = selectBoxRef.current;

    if (selectBox === null || !selectBox.contains(document.activeElement)) {
      return;
    }

    if (!state.open) {
      if (event.key === 'ArrowUp' || event.key === 'ArrowDown' || event.key === 'Down' || event.key === 'Up') {
        return dispatch({
          type: 'open',
          focused: selectedHead
        });
      }
    } else {
      if (event.key === 'Escape' || event.key === 'Esc') {
        event.preventDefault();
        close();
        return;
      }

      if (event.key === 'Enter') {
        event.preventDefault();

        if (state.focused === undefined) {
          return;
        }

        var option = getOption(state.focused);

        if (option !== undefined) {
          handleOptionToggle(option);
        }

        return;
      }
    }
  } // register an option in the Select. Usually not used directly, but passed
  // down the tree in a context, to allow child self-registration.
  // see /src/behaviours/README.md


  function register(option) {
    var _navigable$register = navigable.register({
      identifier: option.value,
      label: option.label,
      disabled: option.disabled,
      handleFocus: function handleFocus() {
        option.handleFocus();
        dispatch({
          type: 'focus',
          focused: option.value
        });
      },
      filtered: false
    }),
        focus = _navigable$register.focus,
        isFocused = _navigable$register.isFocused,
        isFiltered = _navigable$register.isFiltered;

    useEffect(function () {
      dispatch({
        type: 'register',
        option: option
      });
      return function () {
        dispatch({
          type: 'deregister',
          value: option.value
        });
      };
    }, [option.disabled]);
    return {
      toggle: useCallback(function () {
        return handleOptionToggle(option);
      }, [option.value]),
      isSelected: isSelected(option),
      multiple: multiple,
      focus: focus,
      isFocused: isFocused,
      isFiltered: isFiltered
    };
  }

  function getOption(value) {
    var state = stateCommittedRef.current;
    return state.registered.find(function (option) {
      return option.value === value;
    });
  }

  function isSelected(option) {
    var selectedOptions = selectedOptionsCommittedRef.current;
    return selectedOptions.some(function (_ref) {
      var value = _ref.value;
      return value === option.value;
    });
  }

  function close() {
    var state = stateCommittedRef.current;

    if (state.open) {
      handleClose(selectedOptions);
      dispatch({
        type: 'close'
      });
    }
  }

  function handleOptionToggle(option) {
    var selectedOptions = selectedOptionsCommittedRef.current;
    var handleChange = handleChangeComittedRef.current;

    if (option.disabled === true) {
      return;
    }

    var isOptionSelected = isSelected(option);

    if (multiple) {
      if (isOptionSelected) {
        var index = selectedOptions.findIndex(function (_ref2) {
          var value = _ref2.value;
          return value === option.value;
        });
        handleChange([].concat(_toConsumableArray(selectedOptions.slice(0, index)), _toConsumableArray(selectedOptions.slice(index + 1))));
        option.handleToggle(false);
      } else {
        handleChange([].concat(_toConsumableArray(selectedOptions), [option]));
        option.handleToggle(true);
      }
    } else {
      if (!isOptionSelected) {
        if (selectedOptions[0] !== undefined) {
          selectedOptions[0].handleToggle(false);
        }

        handleChange([option]);
        option.handleToggle(true);
      }

      close();
    }
  }
}

var selectContext = /*#__PURE__*/createContext(function () {
  throw Error('Option outside of Select');
});
function useSelectContext() {
  return useContext(selectContext);
}
var SelectContextProvider = selectContext.Provider;

function useOption(option) {
  var register = useSelectContext();
  return register(option);
}

var _templateObject, _templateObject2, _templateObject3;
function fromBottom(component) {
  return styled(component)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    transition: transform 200ms cubic-bezier(0.645, 0.045, 0.355, 1);\n    ", "\n  "])), function (_ref) {
    var step = _ref.step;

    switch (step) {
      case 'before':
        {
          return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n            transform: translate(0, 100vh);\n          "])));
        }

      case 'after':
        {
          return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n            transform: translate(0, 100vh);\n          "])));
        }
    }
  });
}

var transitions = /*#__PURE__*/Object.freeze({
  __proto__: null,
  fromBottom: fromBottom
});

function useTransition(visible) {
  var _React$useState = useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      shouldRender = _React$useState2[0],
      setRender = _React$useState2[1];

  useEffect(function () {
    if (visible) {
      setRender(true);
    }
  }, [visible]);

  var onTransitionEnd = function onTransitionEnd() {
    if (!visible) setRender(false);
  };

  var step = visible && !shouldRender ? 'before' : !visible && shouldRender ? 'after' : 'during';
  var unmounted = !visible && !shouldRender;
  return {
    step: step,
    unmounted: unmounted,
    onTransitionEnd: onTransitionEnd
  };
}

function getLazyImageObserver() {
  return new window.IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var element = entry.target;

      if (!(element instanceof HTMLImageElement)) {
        return;
      }

      var dataSrc = element.dataset.src;

      if (entry.isIntersecting && dataSrc !== undefined) {
        element.src = dataSrc;
        delete element.dataset.src;
      }
    });
  }, {
    rootMargin: '0px 0px 100px 0px'
  });
}

function LazyImage(_ref) {
  var nativeLazyLoad = _ref.nativeLazyLoad,
      children = _ref.children;
  var imageRef = useRef(null);
  var lazyImageObserver = getLazyImageObserver();
  var src = children.props.src;
  useEffect(function () {
    if (nativeLazyLoad) {
      return;
    }

    if (imageRef.current !== null) {
      imageRef.current.dataset.src = src;
      lazyImageObserver.observe(imageRef.current);
    }

    return function () {
      if (imageRef.current !== null) {
        lazyImageObserver.unobserve(imageRef.current);
      }
    };
  }, []);

  if (nativeLazyLoad) {
    return /*#__PURE__*/cloneElement(children, {
      loading: 'lazy'
    });
  } else {
    return /*#__PURE__*/cloneElement(children, {
      src: '',
      ref: imageRef
    });
  }
}

function makeLazyReady(html) {
  var nativeLazyLoad = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return html.replace(/<img([\w\W]+?)>/g, function (_, attributes) {
    if (nativeLazyLoad) {
      return "<img loading=\"lazy\"".concat(attributes, ">");
    } else {
      return "<img".concat(attributes.replace(/src="(.*?)"/, 'data-src="$1"'), ">");
    }
  });
}

function LazyWysiwyg(_ref) {
  var _ref$nativeLazyLoad = _ref.nativeLazyLoad,
      nativeLazyLoad = _ref$nativeLazyLoad === void 0 ? false : _ref$nativeLazyLoad,
      children = _ref.children;
  var wrapperRef = useRef(null);
  var lazyImageObserver = getLazyImageObserver();
  var lazyReady = makeLazyReady(children.props.dangerouslySetInnerHTML.__html, nativeLazyLoad);
  useEffect(function () {
    if (nativeLazyLoad) {
      return;
    }

    if (wrapperRef.current !== null) {
      wrapperRef.current.querySelectorAll('img').forEach(function (img) {
        lazyImageObserver.observe(img);
      });
    }

    return function () {
      if (wrapperRef.current !== null) {
        wrapperRef.current.querySelectorAll('img').forEach(function (img) {
          lazyImageObserver.unobserve(img);
        });
      }
    };
  }, []);
  var wysiwygWithoutSrc = /*#__PURE__*/cloneElement(children, {
    dangerouslySetInnerHTML: {
      __html: lazyReady
    }
  });
  return /*#__PURE__*/createElement("div", {
    ref: wrapperRef
  }, wysiwygWithoutSrc);
}



var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  useAutocompleteItem: useAutocompleteItem,
  useAutocompleteList: useAutocompleteList,
  AutocompleteContextProvider: AutocompleteContextProvider,
  useNavigableItem: useNavigableItem,
  useNavigableList: useNavigableList,
  NavigableContextProvider: NavigableContextProvider,
  useSelect: useSelect,
  useOption: useOption,
  SelectContextProvider: SelectContextProvider,
  transition: transitions,
  useTransition: useTransition,
  LazyImage: LazyImage,
  LazyWysiwyg: LazyWysiwyg
});

var _templateObject$1;
var InlineSvg = styled.svg(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n  display: inline-block;\n  color: inherit;\n  fill: currentColor;\n"])));

var _templateObject$2;
var SizedSvg = styled(InlineSvg)(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteral(["\n  height: ", ";\n  vertical-align: middle;\n  width: ", ";\n"])), function (_ref) {
  var $size = _ref.$size;
  return Number.isInteger($size) ? "".concat($size, "px") : $size;
}, function (_ref2) {
  var $size = _ref2.$size;
  return Number.isInteger($size) ? "".concat($size, "px") : $size;
});

var _templateObject$3;

/** Base SVG Icon Component */
function IconComponent(_ref) {
  var children = _ref.children,
      className = _ref.className,
      name = _ref.name,
      onClick = _ref.onClick,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 32 : _ref$size,
      title = _ref.title,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 32 32' : _ref$viewBox;
  return /*#__PURE__*/createElement(SizedSvg, {
    "aria-labelledby": title && 'title',
    className: className,
    clipRule: "evenodd",
    fillRule: "evenodd",
    height: size,
    id: "icon-".concat(name),
    onClick: onClick,
    preserveAspectRatio: "xMidYMid meet",
    $size: size,
    viewBox: viewBox,
    width: size,
    xmlns: "http://www.w3.org/2000/svg"
  }, title && /*#__PURE__*/createElement("title", {
    id: "title"
  }, name), children);
}

var Icon = styled(IconComponent)(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteral([""])));
Icon.displayName = 'glyphs.Icon';

var _templateObject$4, _templateObject2$1, _templateObject3$1, _templateObject4;
var DoubleDose = styled(function DoubleDose(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "double-dose",
    viewBox: "0 0 48 48"
  }), /*#__PURE__*/createElement("circle", {
    cx: "24",
    cy: "24",
    r: "24",
    fill: PRIMARY_SAND
  }), /*#__PURE__*/createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: GREY_SHADE_7
  }, /*#__PURE__*/createElement("path", {
    strokeWidth: "2",
    d: "M25 17a1 1 0 011 1h0v14a3 3 0 01-3 3h0-10a3 3 0 01-3-3h0V18a1 1 0 011-1h0z"
  }), /*#__PURE__*/createElement("path", {
    strokeWidth: "0",
    fill: GREY_SHADE_2,
    d: "M12 26h12v6a1 1 0 01-1 1H13a1 1 0 01-1-1v-6z"
  }), /*#__PURE__*/createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M15 13v-1.71l1-2.58V7M20 13v-1.71l1-2.58V7"
  }), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
    fill: PRIMARY_SAND,
    strokeWidth: "2",
    d: "M35 21a1 1 0 011 1h0v14a3 3 0 01-3 3h0-10a3 3 0 01-3-3h0V22a1 1 0 011-1h0z"
  }), /*#__PURE__*/createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M36 34a4.5 4.5 0 100-9"
  }), /*#__PURE__*/createElement("path", {
    strokeWidth: "0",
    fill: GREY_SHADE_2,
    d: "M22 30h12v6a1 1 0 01-1 1H23a1 1 0 01-1-1v-6z"
  }), /*#__PURE__*/createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M25 17v-1.71l1-2.58V11M30 17v-1.71l1-2.58V11"
  }))));
})(_templateObject$4 || (_templateObject$4 = _taggedTemplateLiteral([""])));
var Espresso = styled(function Espresso(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "espresso",
    viewBox: "0 0 48 48"
  }), /*#__PURE__*/createElement("circle", {
    cx: "24",
    cy: "24",
    r: "24",
    fill: PRIMARY_SAND
  }), /*#__PURE__*/createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: GREY_SHADE_7
  }, /*#__PURE__*/createElement("path", {
    strokeWidth: "2",
    d: "M30 18a1 1 0 011 1h0v14a3 3 0 01-3 3h0-10a3 3 0 01-3-3h0V19a1 1 0 011-1h0z"
  }), /*#__PURE__*/createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M31 31a4.5 4.5 0 100-9"
  }), /*#__PURE__*/createElement("path", {
    strokeWidth: "0",
    fill: GREY_SHADE_2,
    d: "M17 27h12v6a1 1 0 01-1 1H18a1 1 0 01-1-1v-6z"
  }), /*#__PURE__*/createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M20 14v-1.71l1-2.58V8M25 14v-1.71l1-2.58V8"
  })));
})(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral([""])));
var Lungo = styled(function Lungo(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "lungo",
    viewBox: "0 0 48 48"
  }), /*#__PURE__*/createElement("circle", {
    cx: "24",
    cy: "24",
    r: "24",
    fill: PRIMARY_SAND
  }), /*#__PURE__*/createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: GREY_SHADE_7
  }, /*#__PURE__*/createElement("path", {
    strokeWidth: "2",
    d: "M33 18a1 1 0 011 1h0v14a3 3 0 01-3 3h0-16a3 3 0 01-3-3h0V19a1 1 0 011-1h0z"
  }), /*#__PURE__*/createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M34 31a4.5 4.5 0 100-9"
  }), /*#__PURE__*/createElement("path", {
    strokeWidth: "0",
    fill: GREY_SHADE_2,
    d: "M14 25h18v8a1 1 0 01-1 1H15a1 1 0 01-1-1v-8z"
  }), /*#__PURE__*/createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M18 14v-1.71l1-2.58V8M23 14v-1.71l1-2.58V8M28 14v-1.71l1-2.58V8"
  })));
})(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteral([""])));
var Mystery = styled(function Mystery(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "mystery",
    viewBox: "0 0 48 48"
  }), /*#__PURE__*/createElement("circle", {
    cx: "24",
    cy: "24",
    r: "24",
    fill: PRIMARY_SAND
  }), /*#__PURE__*/createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: GREY_SHADE_7
  }, /*#__PURE__*/createElement("path", {
    strokeWidth: "2",
    d: "M33 18a1 1 0 011 1h0v14a3 3 0 01-3 3h0-16a3 3 0 01-3-3h0V19a1 1 0 011-1h0z"
  }), /*#__PURE__*/createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M34 31a4.5 4.5 0 100-9"
  }), /*#__PURE__*/createElement("path", {
    strokeWidth: "0",
    fill: GREY_SHADE_7,
    fillRule: "nonzero",
    d: "M23.06 29.84l.04-.87c0-.75.35-1.07 1.12-1.3a3.3 3.3 0 002.41-3.2c0-1-.34-1.8-1.02-2.4a3.6 3.6 0 00-2.5-.92c-.96 0-1.76.32-2.43.99-.64.64-.97 1.5-.97 2.56h1.69c0-1.08.76-1.81 1.71-1.81.97 0 1.79.64 1.79 1.58 0 .52-.22.95-.68 1.27-.5.34-1.33.73-1.72.95-.18.12-.39.27-.6.46-.38.36-.54.94-.54 1.82v.87h1.7zm-.83 3.31c.68 0 1.2-.47 1.2-1.14 0-.66-.52-1.15-1.2-1.15-.66 0-1.2.5-1.2 1.15 0 .67.54 1.14 1.2 1.14z"
  }), /*#__PURE__*/createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M18 14v-1.71l1-2.58V8M23 14v-1.71l1-2.58V8M28 14v-1.71l1-2.58V8"
  })));
})(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral([""])));

var Coffee = /*#__PURE__*/Object.freeze({
  __proto__: null,
  DoubleDose: DoubleDose,
  Espresso: Espresso,
  Lungo: Lungo,
  Mystery: Mystery
});

var _templateObject$5, _templateObject2$2, _templateObject3$2;
var EggFull = styled(function EggFull(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    viewBox: "0 0 60 78",
    name: "owl-egg-full"
  }), /*#__PURE__*/createElement("g", {
    fill: PRIMARY_GREEN
  }, /*#__PURE__*/createElement("path", {
    d: "M 16.3647 33.3086 L 31.5018 18.1715 L 41.1246 27.7943 L 51.9057 17.0132 C 51.4602 16.1816 50.9949 15.3599 50.5098 14.5778 C 45.0945 5.9153 37.7289 0.5 29.7099 0.5 C 29.7099 0.5 29.7 0.5 29.7 0.5 C 18.9387 0.5099 9.5337 10.3109 4.6134 23.8145 L 16.3647 33.3086 Z"
  }), /*#__PURE__*/createElement("path", {
    d: "M 40.9068 35.7786 L 31.4325 26.3043 L 16.8993 40.8375 L 2.7621 29.4129 C 1.5939 34.2342 0.9504 39.4614 0.9504 44.9064 C 0.9603 53.5986 3.9006 62.5383 9.2763 68.3199 C 14.6124 74.0619 21.8592 77.22 29.6802 77.22 C 29.6901 77.22 29.6901 77.22 29.7 77.22 C 37.5507 77.22 44.7975 74.0817 50.1039 68.3991 C 55.4796 62.6472 58.4595 53.6679 58.4501 44.8767 C 58.4501 36.729 57.0636 28.9476 54.4896 22.1958 L 40.9068 35.7786 Z"
  })));
})(_templateObject$5 || (_templateObject$5 = _taggedTemplateLiteral([""])));
var EggPartial = styled(function EggPartial(_ref) {
  var _ref$progress = _ref.progress,
      progress = _ref$progress === void 0 ? 60 : _ref$progress,
      iconProps = _objectWithoutProperties(_ref, ["progress"]);

  var offset = 74 - (74 - 8.22) * progress / 100;
  var id = String(Math.random());
  return /*#__PURE__*/createElement(Icon, _extends({}, iconProps, {
    viewBox: "0 0 60 78",
    name: "owl-egg-partial"
  }), /*#__PURE__*/createElement("g", {
    fill: BLUE_SHADE_2,
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("clipPath", {
    id: id
  }, /*#__PURE__*/createElement("path", {
    d: "m0 ".concat(offset, "h53v62h-55z")
  }))), /*#__PURE__*/createElement("path", {
    d: "M 28.991 2.18 C 28.991 2.18 28.982 2.18 28.982 2.18 C 21.728 2.18 15.005 6.626 10.055 14.681 C 5.42 22.223 2.864 32.078 2.873 42.428 C 2.882 50.33 5.573 57.575 10.46 62.831 C 15.311 68.051 21.899 70.922 29.009 70.922 C 29.018 70.922 29.018 70.922 29.027 70.922 C 36.164 70.922 42.752 68.069 47.576 62.903 C 52.463 57.674 55.154 50.393 55.145 42.401 C 55.127 19.847 43.643 2.18 28.991 2.18 Z",
    clipPath: "url(#".concat(id, ")")
  }), /*#__PURE__*/createElement("path", {
    d: "M30,77.19 C22.1,77.19 14.78,74 9.39,68.2 C3.96,62.36 0.959988485,54.31 0.959988485,45.53 C0.95,20.88 13.96,0.82 29.98,0.81 C46.23,0.83 59.03,20.43 59.050012,45.5 C59.06,63.56 46.58,77.18 30.02,77.19 C30.01,77.19 30.01,77.19 30,77.19 Z M29.9490874,7.81 C16.9255077,7.82 5.9491127,25.09 5.95997773,45.53 C5.95997773,52.54 8.49720439,58.89 13.1033701,63.44 C17.5135288,67.8 23.5026332,70.19 29.9708659,70.19 C29.9708659,70.19 29.9817552,70.19 29.9817552,70.19 C43.8873667,70.18 53.9708406,59.8 53.9599777,45.5 C53.9490621,24.72 43.1795634,7.81 29.9490874,7.81 Z"
  }), /*#__PURE__*/createElement("path", {
    fill: PRIMARY_WHITE,
    d: "M29.9834716,6 C22.9342823,6 16.4557658,10.3397739 11.7398793,18.1203144 C7.3815744,25.3105061 4.99161282,34.6670856 4.99997836,44.4724448 C5.00856386,52.0755658 7.57010405,59.0617713 12.2299505,64.1430228 C16.7687133,69.0948194 22.9081266,71.8747609 29.5466153,71.9958685 L30.0165295,72 C36.8458854,72 43.1634385,69.2296734 47.7851311,64.2116321 C52.4503342,59.1506719 55.0085105,52.1272725 55.0000206,44.445344 C54.9830673,22.9617513 44.1057232,6 29.9834716,6 Z M29.9834716,8 C42.7676675,8 52.9838303,23.9307283 53.0000203,44.4472401 C53.007971,51.6415109 50.6273329,58.1774844 46.3143018,62.8563975 C42.1696767,67.3564586 36.5550976,69.8809081 30.4531951,69.9958906 L30,70 C23.7500114,70 17.9683156,67.4436655 13.7041404,62.7914444 C9.39212747,58.0894821 7.00801505,51.5871835 6.9999781,44.4704631 C6.99191339,35.0176098 9.29013691,26.0201802 13.4502228,19.1570039 C17.8291469,11.9324034 23.6995311,8 29.9834716,8 Z"
  })));
})(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteral([""])));

function ProgressEggComponent(_ref2) {
  var progress = _ref2.progress,
      iconProps = _objectWithoutProperties(_ref2, ["progress"]);

  if (progress >= 100) {
    return /*#__PURE__*/createElement(EggFull, iconProps);
  }

  return /*#__PURE__*/createElement(EggPartial, _extends({
    progress: progress
  }, iconProps));
}

var ProgressEgg = styled(ProgressEggComponent)(_templateObject3$2 || (_templateObject3$2 = _taggedTemplateLiteral([""])));

var Crowdfunding = /*#__PURE__*/Object.freeze({
  __proto__: null,
  EggFull: EggFull,
  EggPartial: EggPartial,
  ProgressEgg: ProgressEgg
});

function Chf(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "currency-chf"
  }), /*#__PURE__*/createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/createElement("path", {
    d: "M19.944597 2.6186408l-.3419217 1.7704145c-.0073087.0378967 0 .0778056.0200196.1106718.0203373.0328662.05275.0556713.0886581.0633848.8068209.1737213 1.599342.4453705 2.3553195.80824.0905648.0439334.1824006.0892083.2723298.1354892 2.6359114 1.3565688 4.613401 3.7152211 5.5676677 6.6413181.4010271 1.2281224.6037651 2.5008489.6037651 3.7816242 0 1.7606888-.376241 3.4660417-1.1172832 5.0697776-1.2002215 2.5974352-3.2291901 4.5959008-5.7373574 5.6610337l1.1201431-2.4243846c.0162064-.0352138.0187485-.0757935.0063554-.1126841-.0117575-.0368906-.0371792-.0674092-.0708629-.0845131l-1.5386477-.7921423c-.0695919-.0355491-.1531657-.0053659-.187485.06808l-2.4713059 5.3484695c-.033366.0731105-.0050843.1613126.063872.1971972l.7683705.3977479 3.2253768 1.671816c.0073087.0040244.0155708.0070427.0235151.0093903l1.055.5453105c.0695919.03588449.1531657.0057013.187485-.0674093l.7534353-1.6225166c.0168419-.0348784.0187485-.0757935.0066732-.1126841-.0120753-.0368906-.0371792-.0674092-.070863-.0848484l-2.0140333-1.0419924c1.0086055-.4430228 1.9555635-1.013486 2.8189476-1.6989808 1.6473254-1.3072696 2.943196-2.9676829 3.8523391-4.9349592.7670995-1.6604134 1.2033992-3.4304925 1.2965062-5.2609381.012393-.2454903.019384-.4946697.019384-.7394893 0-1.5141924-.2389639-3.0132931-.7099007-4.4567225-.5481551-1.6805356-1.3845287-3.2091488-2.4868767-4.5435832-1.1407983-1.3820569-2.5173827-2.4931354-4.0906675-3.3033876-.1061355-.0543298-.2141777-.1079889-.3215843-.1593004-.8919835-.4282666-1.8278195-.7498857-2.7817683-.9551317-.0756296-.0160978-.1496702.0355491-.1646055.1157024zM7.3177687.0077205c-.0380036.012395-.069443.0391951-.0874083.0747052l-.822951 1.6187247c-.0179654.0351751-.0207293.0753752-.0076007.1125603.0131285.0371851.0407675.0673352.0766982.0850902L8.7104284 2.966114c-1.4202987.5684967-2.7258956 1.353069-3.8850058 2.3339518-1.4199533 1.2016485-2.5624801 2.6505277-3.39510475 4.3061025C.59596577 11.26475807.12161157 13.03289319.02038376 14.86166349.00690975 15.1068842 0 15.35545492 0 15.60000562c0 1.51252938.25946104 3.01031872.77147337 4.4521629.59631126 1.67868986 1.50597963 3.20562428 2.70378443 4.53859314 1.2406453 1.38020399 2.7369512 2.49039721 4.4478048 3.29942455 1.0661741.50417646 2.1907356.87669754 3.3425906 1.10684321.0393856.00770502.0804986.000335.1143564-.02110506.0338577-.02144007.0573509-.05494016.0652971-.09346528l.3758903-1.76780011c.0169289-.07973023-.0359307-.15778546-.1181567-.17420051-.97462-.19497056-1.9271287-.51020648-2.8305783-.93766771-2.8654725-1.35507893-5.0154406-3.71147575-6.0532848-6.63435921-.4356596-1.22677356-.6564261-2.49776724-.6564261-3.77780594 0-1.75808509.4087116-3.46190003 1.2143883-5.0635397 1.2883225-2.5614174 3.4714574-4.5466331 6.1745508-5.6250013L8.379797 7.2594865c-.0362762.0737002-.0048369.1614704.0711704.1969805l1.6769958.7839023c.0756618.0351751.1665249.004355.2028011-.0690102l2.6543797-5.3399154C12.9951632 2.8103386 13 2.7888985 13 2.7674585c0-.0542702-.0310939-.1065303-.0849899-.1323254L7.4345434.0160955c-.0366216-.0184251-.0784256-.0207701-.1167747-.008375z"
  }), /*#__PURE__*/createElement("path", {
    d: "M12.254 18.18l-1.898-.884c-.312.624-.728.871-1.092.871-.962 0-1.651-.988-1.651-2.626s.689-2.639 1.651-2.639c.364 0 .78.247 1.092.871l1.898-.884c-.702-1.391-1.716-1.95-2.99-1.95-2.236 0-3.861 1.742-3.861 4.602 0 2.873 1.625 4.589 3.861 4.589 1.274 0 2.288-.559 2.99-1.95zm5.122-7.137v3.536h-1.898v-3.536h-2.21V20h2.21v-3.432h1.898V20h2.21v-8.957h-2.21zM21.224 20v-8.957h5.148v1.963h-2.938v1.56h2.392v1.976h-2.392V20h-2.21z"
  })));
}
function Dolls(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "currency-dolls"
  }), /*#__PURE__*/createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/createElement("path", {
    d: "M19.944597 2.6186408l-.3419217 1.7704145c-.0073087.0378967 0 .0778056.0200196.1106718.0203373.0328662.05275.0556713.0886581.0633848.8068209.1737213 1.599342.4453705 2.3553195.80824.0905648.0439334.1824006.0892083.2723298.1354892 2.6359114 1.3565688 4.613401 3.7152211 5.5676677 6.6413181.4010271 1.2281224.6037651 2.5008489.6037651 3.7816242 0 1.7606888-.376241 3.4660417-1.1172832 5.0697776-1.2002215 2.5974352-3.2291901 4.5959008-5.7373574 5.6610337l1.1201431-2.4243846c.0162064-.0352138.0187485-.0757935.0063554-.1126841-.0117575-.0368906-.0371792-.0674092-.0708629-.0845131l-1.5386477-.7921423c-.0695919-.0355491-.1531657-.0053659-.187485.06808l-2.4713059 5.3484695c-.033366.0731105-.0050843.1613126.063872.1971972l.7683705.3977479 3.2253768 1.671816c.0073087.0040244.0155708.0070427.0235151.0093903l1.055.5453105c.0695919.03588449.1531657.0057013.187485-.0674093l.7534353-1.6225166c.0168419-.0348784.0187485-.0757935.0066732-.1126841-.0120753-.0368906-.0371792-.0674092-.070863-.0848484l-2.0140333-1.0419924c1.0086055-.4430228 1.9555635-1.013486 2.8189476-1.6989808 1.6473254-1.3072696 2.943196-2.9676829 3.8523391-4.9349592.7670995-1.6604134 1.2033992-3.4304925 1.2965062-5.2609381.012393-.2454903.019384-.4946697.019384-.7394893 0-1.5141924-.2389639-3.0132931-.7099007-4.4567225-.5481551-1.6805356-1.3845287-3.2091488-2.4868767-4.5435832-1.1407983-1.3820569-2.5173827-2.4931354-4.0906675-3.3033876-.1061355-.0543298-.2141777-.1079889-.3215843-.1593004-.8919835-.4282666-1.8278195-.7498857-2.7817683-.9551317-.0756296-.0160978-.1496702.0355491-.1646055.1157024zM7.3177687.0077205c-.0380036.012395-.069443.0391951-.0874083.0747052l-.822951 1.6187247c-.0179654.0351751-.0207293.0753752-.0076007.1125603.0131285.0371851.0407675.0673352.0766982.0850902L8.7104284 2.966114c-1.4202987.5684967-2.7258956 1.353069-3.8850058 2.3339518-1.4199533 1.2016485-2.5624801 2.6505277-3.39510475 4.3061025C.59596577 11.26475807.12161157 13.03289319.02038376 14.86166349.00690975 15.1068842 0 15.35545492 0 15.60000562c0 1.51252938.25946104 3.01031872.77147337 4.4521629.59631126 1.67868986 1.50597963 3.20562428 2.70378443 4.53859314 1.2406453 1.38020399 2.7369512 2.49039721 4.4478048 3.29942455 1.0661741.50417646 2.1907356.87669754 3.3425906 1.10684321.0393856.00770502.0804986.000335.1143564-.02110506.0338577-.02144007.0573509-.05494016.0652971-.09346528l.3758903-1.76780011c.0169289-.07973023-.0359307-.15778546-.1181567-.17420051-.97462-.19497056-1.9271287-.51020648-2.8305783-.93766771-2.8654725-1.35507893-5.0154406-3.71147575-6.0532848-6.63435921-.4356596-1.22677356-.6564261-2.49776724-.6564261-3.77780594 0-1.75808509.4087116-3.46190003 1.2143883-5.0635397 1.2883225-2.5614174 3.4714574-4.5466331 6.1745508-5.6250013L8.379797 7.2594865c-.0362762.0737002-.0048369.1614704.0711704.1969805l1.6769958.7839023c.0756618.0351751.1665249.004355.2028011-.0690102l2.6543797-5.3399154C12.9951632 2.8103386 13 2.7888985 13 2.7674585c0-.0542702-.0310939-.1065303-.0849899-.1323254L7.4345434.0160955c-.0366216-.0184251-.0784256-.0207701-.1167747-.008375z"
  }), /*#__PURE__*/createElement("path", {
    d: "M16.06 6.1v2.04c1.9.3 3.22 1.66 3.22 4.24h-2.92c0-1.08-.4-1.66-1.32-1.66-.68 0-1.16.48-1.16 1.26 0 .46.2 1.14 1 1.44l1.38.42c1.54.44 3.64 1.72 3.4 4.68-.22 1.74-1.2 3.3-3.6 3.62v2.26h-1.64v-2.24c-2.74-.32-3.8-2.5-3.8-4.7h2.9l.02.02c0 1.04.38 2.06 1.66 2.06.88 0 1.36-.34 1.5-1.16.1515789-1.0042105-.6481994-1.487867-1.2599738-1.7060504L14.06 16.22c-2.6-.82-3.1-2.82-3.1-4.08 0-2.26 1.36-3.74 3.46-4.02V6.1h1.64z"
  })));
}
function Eur(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "currency-eur"
  }), /*#__PURE__*/createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/createElement("path", {
    d: "M19.944597 2.6186408l-.3419217 1.7704145c-.0073087.0378967 0 .0778056.0200196.1106718.0203373.0328662.05275.0556713.0886581.0633848.8068209.1737213 1.599342.4453705 2.3553195.80824.0905648.0439334.1824006.0892083.2723298.1354892 2.6359114 1.3565688 4.613401 3.7152211 5.5676677 6.6413181.4010271 1.2281224.6037651 2.5008489.6037651 3.7816242 0 1.7606888-.376241 3.4660417-1.1172832 5.0697776-1.2002215 2.5974352-3.2291901 4.5959008-5.7373574 5.6610337l1.1201431-2.4243846c.0162064-.0352138.0187485-.0757935.0063554-.1126841-.0117575-.0368906-.0371792-.0674092-.0708629-.0845131l-1.5386477-.7921423c-.0695919-.0355491-.1531657-.0053659-.187485.06808l-2.4713059 5.3484695c-.033366.0731105-.0050843.1613126.063872.1971972l.7683705.3977479 3.2253768 1.671816c.0073087.0040244.0155708.0070427.0235151.0093903l1.055.5453105c.0695919.03588449.1531657.0057013.187485-.0674093l.7534353-1.6225166c.0168419-.0348784.0187485-.0757935.0066732-.1126841-.0120753-.0368906-.0371792-.0674092-.070863-.0848484l-2.0140333-1.0419924c1.0086055-.4430228 1.9555635-1.013486 2.8189476-1.6989808 1.6473254-1.3072696 2.943196-2.9676829 3.8523391-4.9349592.7670995-1.6604134 1.2033992-3.4304925 1.2965062-5.2609381.012393-.2454903.019384-.4946697.019384-.7394893 0-1.5141924-.2389639-3.0132931-.7099007-4.4567225-.5481551-1.6805356-1.3845287-3.2091488-2.4868767-4.5435832-1.1407983-1.3820569-2.5173827-2.4931354-4.0906675-3.3033876-.1061355-.0543298-.2141777-.1079889-.3215843-.1593004-.8919835-.4282666-1.8278195-.7498857-2.7817683-.9551317-.0756296-.0160978-.1496702.0355491-.1646055.1157024zM7.3177687.0077205c-.0380036.012395-.069443.0391951-.0874083.0747052l-.822951 1.6187247c-.0179654.0351751-.0207293.0753752-.0076007.1125603.0131285.0371851.0407675.0673352.0766982.0850902L8.7104284 2.966114c-1.4202987.5684967-2.7258956 1.353069-3.8850058 2.3339518-1.4199533 1.2016485-2.5624801 2.6505277-3.39510475 4.3061025C.59596577 11.26475807.12161157 13.03289319.02038376 14.86166349.00690975 15.1068842 0 15.35545492 0 15.60000562c0 1.51252938.25946104 3.01031872.77147337 4.4521629.59631126 1.67868986 1.50597963 3.20562428 2.70378443 4.53859314 1.2406453 1.38020399 2.7369512 2.49039721 4.4478048 3.29942455 1.0661741.50417646 2.1907356.87669754 3.3425906 1.10684321.0393856.00770502.0804986.000335.1143564-.02110506.0338577-.02144007.0573509-.05494016.0652971-.09346528l.3758903-1.76780011c.0169289-.07973023-.0359307-.15778546-.1181567-.17420051-.97462-.19497056-1.9271287-.51020648-2.8305783-.93766771-2.8654725-1.35507893-5.0154406-3.71147575-6.0532848-6.63435921-.4356596-1.22677356-.6564261-2.49776724-.6564261-3.77780594 0-1.75808509.4087116-3.46190003 1.2143883-5.0635397 1.2883225-2.5614174 3.4714574-4.5466331 6.1745508-5.6250013L8.379797 7.2594865c-.0362762.0737002-.0048369.1614704.0711704.1969805l1.6769958.7839023c.0756618.0351751.1665249.004355.2028011-.0690102l2.6543797-5.3399154C12.9951632 2.8103386 13 2.7888985 13 2.7674585c0-.0542702-.0310939-.1065303-.0849899-.1323254L7.4345434.0160955c-.0366216-.0184251-.0784256-.0207701-.1167747-.008375z"
  }), /*#__PURE__*/createElement("path", {
    d: "M17.438 16.4v1.166h-3.432c.44 1.606 1.474 2.618 2.706 2.618.858 0 1.584-.484 2.112-1.43l2.684 1.518c-1.122 2.024-2.728 2.948-4.774 2.948-3.08 0-5.412-2.112-6.006-5.654H8.726V16.4h8.712zm-.704-7.964c2.046 0 3.652.924 4.774 2.948l-2.684 1.518-.022-.022c-.528-.924-1.254-1.408-2.09-1.408-1.188 0-2.2.99-2.662 2.486h3.388v1.188H8.726v-1.188h2.024c.638-3.41 2.948-5.522 5.984-5.522z"
  })));
}
function Kr(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "currency-kr"
  }), /*#__PURE__*/createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/createElement("path", {
    d: "M19.944597 2.6186408l-.3419217 1.7704145c-.0073087.0378967 0 .0778056.0200196.1106718.0203373.0328662.05275.0556713.0886581.0633848.8068209.1737213 1.599342.4453705 2.3553195.80824.0905648.0439334.1824006.0892083.2723298.1354892 2.6359114 1.3565688 4.613401 3.7152211 5.5676677 6.6413181.4010271 1.2281224.6037651 2.5008489.6037651 3.7816242 0 1.7606888-.376241 3.4660417-1.1172832 5.0697776-1.2002215 2.5974352-3.2291901 4.5959008-5.7373574 5.6610337l1.1201431-2.4243846c.0162064-.0352138.0187485-.0757935.0063554-.1126841-.0117575-.0368906-.0371792-.0674092-.0708629-.0845131l-1.5386477-.7921423c-.0695919-.0355491-.1531657-.0053659-.187485.06808l-2.4713059 5.3484695c-.033366.0731105-.0050843.1613126.063872.1971972l.7683705.3977479 3.2253768 1.671816c.0073087.0040244.0155708.0070427.0235151.0093903l1.055.5453105c.0695919.03588449.1531657.0057013.187485-.0674093l.7534353-1.6225166c.0168419-.0348784.0187485-.0757935.0066732-.1126841-.0120753-.0368906-.0371792-.0674092-.070863-.0848484l-2.0140333-1.0419924c1.0086055-.4430228 1.9555635-1.013486 2.8189476-1.6989808 1.6473254-1.3072696 2.943196-2.9676829 3.8523391-4.9349592.7670995-1.6604134 1.2033992-3.4304925 1.2965062-5.2609381.012393-.2454903.019384-.4946697.019384-.7394893 0-1.5141924-.2389639-3.0132931-.7099007-4.4567225-.5481551-1.6805356-1.3845287-3.2091488-2.4868767-4.5435832-1.1407983-1.3820569-2.5173827-2.4931354-4.0906675-3.3033876-.1061355-.0543298-.2141777-.1079889-.3215843-.1593004-.8919835-.4282666-1.8278195-.7498857-2.7817683-.9551317-.0756296-.0160978-.1496702.0355491-.1646055.1157024zM7.3177687.0077205c-.0380036.012395-.069443.0391951-.0874083.0747052l-.822951 1.6187247c-.0179654.0351751-.0207293.0753752-.0076007.1125603.0131285.0371851.0407675.0673352.0766982.0850902L8.7104284 2.966114c-1.4202987.5684967-2.7258956 1.353069-3.8850058 2.3339518-1.4199533 1.2016485-2.5624801 2.6505277-3.39510475 4.3061025C.59596577 11.26475807.12161157 13.03289319.02038376 14.86166349.00690975 15.1068842 0 15.35545492 0 15.60000562c0 1.51252938.25946104 3.01031872.77147337 4.4521629.59631126 1.67868986 1.50597963 3.20562428 2.70378443 4.53859314 1.2406453 1.38020399 2.7369512 2.49039721 4.4478048 3.29942455 1.0661741.50417646 2.1907356.87669754 3.3425906 1.10684321.0393856.00770502.0804986.000335.1143564-.02110506.0338577-.02144007.0573509-.05494016.0652971-.09346528l.3758903-1.76780011c.0169289-.07973023-.0359307-.15778546-.1181567-.17420051-.97462-.19497056-1.9271287-.51020648-2.8305783-.93766771-2.8654725-1.35507893-5.0154406-3.71147575-6.0532848-6.63435921-.4356596-1.22677356-.6564261-2.49776724-.6564261-3.77780594 0-1.75808509.4087116-3.46190003 1.2143883-5.0635397 1.2883225-2.5614174 3.4714574-4.5466331 6.1745508-5.6250013L8.379797 7.2594865c-.0362762.0737002-.0048369.1614704.0711704.1969805l1.6769958.7839023c.0756618.0351751.1665249.004355.2028011-.0690102l2.6543797-5.3399154C12.9951632 2.8103386 13 2.7888985 13 2.7674585c0-.0542702-.0310939-.1065303-.0849899-.1323254L7.4345434.0160955c-.0366216-.0184251-.0784256-.0207701-.1167747-.008375z"
  }), /*#__PURE__*/createElement("path", {
    d: "M16.816 22l-3.762-4.94 3.097-3.933h-3.173l-1.292 2.09V8.301H8.969V22h2.717v-3.04L13.681 22h3.135zm3.534-4.218V22h-2.717v-8.873h2.717v1.843c.304-1.368 1.083-2.033 1.786-2.033l.174344.004104c.277856.013376.718656.068096 1.098656.280896l-.437 2.584c-.437-.342-1.064-.342-1.273-.342-.665 0-1.349.608-1.349 2.318z"
  })));
}
function Pound(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "currency-pound"
  }), /*#__PURE__*/createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/createElement("path", {
    d: "M19.944597 2.6186408l-.3419217 1.7704145c-.0073087.0378967 0 .0778056.0200196.1106718.0203373.0328662.05275.0556713.0886581.0633848.8068209.1737213 1.599342.4453705 2.3553195.80824.0905648.0439334.1824006.0892083.2723298.1354892 2.6359114 1.3565688 4.613401 3.7152211 5.5676677 6.6413181.4010271 1.2281224.6037651 2.5008489.6037651 3.7816242 0 1.7606888-.376241 3.4660417-1.1172832 5.0697776-1.2002215 2.5974352-3.2291901 4.5959008-5.7373574 5.6610337l1.1201431-2.4243846c.0162064-.0352138.0187485-.0757935.0063554-.1126841-.0117575-.0368906-.0371792-.0674092-.0708629-.0845131l-1.5386477-.7921423c-.0695919-.0355491-.1531657-.0053659-.187485.06808l-2.4713059 5.3484695c-.033366.0731105-.0050843.1613126.063872.1971972l.7683705.3977479 3.2253768 1.671816c.0073087.0040244.0155708.0070427.0235151.0093903l1.055.5453105c.0695919.03588449.1531657.0057013.187485-.0674093l.7534353-1.6225166c.0168419-.0348784.0187485-.0757935.0066732-.1126841-.0120753-.0368906-.0371792-.0674092-.070863-.0848484l-2.0140333-1.0419924c1.0086055-.4430228 1.9555635-1.013486 2.8189476-1.6989808 1.6473254-1.3072696 2.943196-2.9676829 3.8523391-4.9349592.7670995-1.6604134 1.2033992-3.4304925 1.2965062-5.2609381.012393-.2454903.019384-.4946697.019384-.7394893 0-1.5141924-.2389639-3.0132931-.7099007-4.4567225-.5481551-1.6805356-1.3845287-3.2091488-2.4868767-4.5435832-1.1407983-1.3820569-2.5173827-2.4931354-4.0906675-3.3033876-.1061355-.0543298-.2141777-.1079889-.3215843-.1593004-.8919835-.4282666-1.8278195-.7498857-2.7817683-.9551317-.0756296-.0160978-.1496702.0355491-.1646055.1157024zM7.3177687.0077205c-.0380036.012395-.069443.0391951-.0874083.0747052l-.822951 1.6187247c-.0179654.0351751-.0207293.0753752-.0076007.1125603.0131285.0371851.0407675.0673352.0766982.0850902L8.7104284 2.966114c-1.4202987.5684967-2.7258956 1.353069-3.8850058 2.3339518-1.4199533 1.2016485-2.5624801 2.6505277-3.39510475 4.3061025C.59596577 11.26475807.12161157 13.03289319.02038376 14.86166349.00690975 15.1068842 0 15.35545492 0 15.60000562c0 1.51252938.25946104 3.01031872.77147337 4.4521629.59631126 1.67868986 1.50597963 3.20562428 2.70378443 4.53859314 1.2406453 1.38020399 2.7369512 2.49039721 4.4478048 3.29942455 1.0661741.50417646 2.1907356.87669754 3.3425906 1.10684321.0393856.00770502.0804986.000335.1143564-.02110506.0338577-.02144007.0573509-.05494016.0652971-.09346528l.3758903-1.76780011c.0169289-.07973023-.0359307-.15778546-.1181567-.17420051-.97462-.19497056-1.9271287-.51020648-2.8305783-.93766771-2.8654725-1.35507893-5.0154406-3.71147575-6.0532848-6.63435921-.4356596-1.22677356-.6564261-2.49776724-.6564261-3.77780594 0-1.75808509.4087116-3.46190003 1.2143883-5.0635397 1.2883225-2.5614174 3.4714574-4.5466331 6.1745508-5.6250013L8.379797 7.2594865c-.0362762.0737002-.0048369.1614704.0711704.1969805l1.6769958.7839023c.0756618.0351751.1665249.004355.2028011-.0690102l2.6543797-5.3399154C12.9951632 2.8103386 13 2.7888985 13 2.7674585c0-.0542702-.0310939-.1065303-.0849899-.1323254L7.4345434.0160955c-.0366216-.0184251-.0784256-.0207701-.1167747-.008375z"
  }), /*#__PURE__*/createElement("path", {
    d: "M18.505 23h-7.812v-2.688h1.764V17.33h-1.449v-1.974h1.449v-2.772c0-2.583 1.869-4.221 3.906-4.221 2.058 0 3.78 1.638 3.738 4.473h-2.94c.021-.924-.189-1.617-.882-1.617-.651 0-.819.63-.819 1.365v2.772h2.079v1.974H15.46v2.982h2.037c.252 0 .441-.147.441-.504v-.714h2.73v1.449c0 1.764-.861 2.457-2.163 2.457z"
  })));
}

var Currencies = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Chf: Chf,
  Dolls: Dolls,
  Eur: Eur,
  Kr: Kr,
  Pound: Pound
});

var _templateObject$6, _templateObject2$3, _templateObject3$3, _templateObject4$1, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;
var Alert = styled(function Alert(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "alert"
  }), /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("path", {
    d: "M 18,17.058 C 18,18.131 17.105,19 16,19 14.895,19 14,18.13 14,17.058 V 8.942 C 14,7.869 14.895,7 16,7 c 1.105,0 2,0.87 2,1.942 z M 16,0 C 24.837,0 32,7.163 32,16 32,24.837 24.837,32 16,32 7.163,32 0,24.837 0,16 0,7.163 7.163,0 16,0 Z m 0,21 c 1.105,0 2,0.707 2,1.579 v 0.842 C 18,24.293 17.105,25 16,25 14.895,25 14,24.293 14,23.421 V 22.579 C 14,21.707 14.895,21 16,21 Z"
  })));
})(_templateObject$6 || (_templateObject$6 = _taggedTemplateLiteral([""])));
var CaretDown = styled(function CaretDown(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "caret-down"
  }), /*#__PURE__*/createElement("g", {
    transform: "translate(0, 12)"
  }, /*#__PURE__*/createElement("path", {
    d: "M32 .9c-.32-.6-.96-.9-1.918-.9H1.918C.958 0 .319.3 0 .9 0 1.8 0 2.4.32 3l14.079 14.7c.642 0 .96.3 1.6.3.64 0 .96-.3 1.283-.602L31.362 3C32 2.4 32 1.8 32 .9"
  }), ' '));
})(_templateObject2$3 || (_templateObject2$3 = _taggedTemplateLiteral([""])));
var Check = styled(function Check(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "check"
  }), /*#__PURE__*/createElement("g", {
    transform: "scale(3.2, 3.2)"
  }, /*#__PURE__*/createElement("path", {
    d: "M3.4963 6.1035L8.3098 1.29c.3867-.3867 1.0135-.3867 1.4002 0 .3867.3867.3867 1.0135 0 1.4002L4.1964 8.2038c-.3867.3867-1.0136.3867-1.4002 0L.29 5.6976c-.3867-.3866-.3867-1.0135 0-1.4002.3867-.3866 1.0135-.3866 1.4002 0l1.806 1.8061z",
    fillRule: "nonzero"
  })));
})(_templateObject3$3 || (_templateObject3$3 = _taggedTemplateLiteral([""])));
var CheckCircle = styled(function CheckCircle(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "check-circle"
  }), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
    d: "M16,32 C7.163444,32 0,24.836556 0,16 C0,7.163444 7.163444,0 16,0 C24.836556,0 32,7.163444 32,16 C32,24.836556 24.836556,32 16,32 Z M12.5,22.3 C12.9,22.3 13.3,22.2 13.6,21.9 L23.5,12.3 C24.1,11.7 24.1,10.8 23.5,10.2 C22.9,9.6 22,9.6 21.4,10.2 L12.5,18.8 L9,15.4 C8.4,14.8 7.5,14.8 6.9,15.4 C6.3,16 6.4,16.9 7,17.5 L11.5,21.9 C11.7,22.2 12.1,22.3 12.5,22.3 Z"
  })));
})(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteral([""])));
var Heart = styled(function Heart(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "heart"
  }), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
    d: "M29.3,4.68a9.31,9.31,0,0,0-13,0l0,0L16,4.9l-.24-.22a9.34,9.34,0,0,0-13.07,0,9,9,0,0,0,0,12.87L14.8,29.51A1.63,1.63,0,0,0,16,30a1.78,1.78,0,0,0,1.21-.49L29.3,17.57A9.06,9.06,0,0,0,29.3,4.68Z"
  })));
})(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral([""])));
var Info = styled(function Info(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "info"
  }), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
    d: "M18.571 14.64c0-1.38-.863-2.497-1.928-2.497s-1.929 1.117-1.929 2.496v10.436c0 1.379.864 2.496 1.929 2.496s1.928-1.117 1.928-2.496zm0-8.181c0-1.122-.863-2.03-1.928-2.03s-1.929.908-1.929 2.03V7.54c0 1.122.864 2.03 1.929 2.03s1.928-.908 1.928-2.03zM16 0c8.837 0 16 7.163 16 16s-7.163 16-16 16S0 23.542 0 16 7.163 0 16 0z"
  })));
})(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral([""])));
var Star = styled(function Star(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "star"
  }), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
    d: "M11.615 10.463l3.707-7.515a1.25 1.25 0 0 1 2.243 0l3.71 7.514 8.295 1.213a1.25 1.25 0 0 1 .692 2.13l-6.002 5.848 1.417 8.257a1.25 1.25 0 0 1-1.814 1.317l-7.418-3.902-7.42 3.9a1.25 1.25 0 0 1-1.815-1.318l1.417-8.257-6-5.847a1.25 1.25 0 0 1 .69-2.13l8.296-1.213.002.002z"
  })));
})(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral([""])));
var Success = styled(function Success(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "success"
  }), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
    d: "M14.1483421 18.2996568c-1.5812922-1.5794357-3.0885191-3.0903613-4.59574604-4.5938804-.73880043-.7369466-1.436865-.7369466-2.17196216-.014813-.53512111.5203065-1.06653896 1.0443162-1.59240193 1.568326-.73880042.72954-.73880042 1.5035191-.00740652 2.2367624 2.1312263 2.1293682 4.25874935 4.2568848 6.38627235 6.3844014.3221837.3221826.6369608.6499202.9684026.966548.5888184.5647454 1.3220639.5758552 1.9349535.0240711.0777684-.0685101.1425755-.1370202.2166407-.207382 3.6366016-3.6384422 7.2732032-7.2731811 10.9116564-10.9153265.0796201-.0777683.1518337-.1555365.220344-.2425628.4684625-.5684488.455501-1.3220599-.0481424-1.8442181-.6202961-.640662-1.2498503-1.2665111-1.8960692-1.87754723-.5665988-.53882274-1.2628118-.52586136-1.8553334-.01296137-.0796201.07036173-.1499821.13887184-.2184924.20923357-2.6644958 2.65893283-5.3308432 5.31601403-7.9934873 7.98235333-.0925815.0944328-.1610918.2092336-.2592282.3369956M16.0221918.0000517c8.8563469.01666461 16.0073426 7.18430314 15.9777165 16.0147005-.0296261 8.8803912-7.199138 16.0258102-16.0388203 15.9850745C7.07881818 31.9553877-.01848015 24.8155235.00003615 15.936984.01670082 7.12139961 7.19176762-.0221678 16.0221918.0000517"
  })));
})(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral([""])));
var TimesCircle = styled(function TimesCircle(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "times-circle"
  }), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
    d: "M19.0757647 15.9830588c.1374118-.1185882.2371765-.1938823.3256471-.2804706 1.6225882-1.6207058 3.2395294-3.2395294 4.8602353-4.8583529.5628235-.5628235.5590588-1.08047059-.0037647-1.64705883-.4837648-.48941176-.9694118-.97317647-1.4569412-1.45882353-.5609412-.56282353-1.082353-.56282353-1.6451765-.00188235C19.52 9.37035294 17.8861176 11.0061176 16.2503529 12.64c-.0771764.0790588-.1618823.1543529-.2522353.2371765-.0752941-.0696471-.1374117-.1261177-.192-.1807059C14.1496471 11.04 12.4894118 9.38352941 10.8329412 7.72329412c-.544-.54211765-1.07670591-.54211765-1.62447061.0037647-.49505883.49317647-.9882353.98635294-1.47764706 1.47952942-.54776471.55152941-.54776471 1.08235296 0 1.62635296C9.38729412 12.4894118 11.0418824 14.144 12.6983529 15.8042353c.064.0621176.1167059.1336471.2070589.2334118-.1110589.0884705-.2051765.1562353-.2861177.2371764-1.6432941 1.6376471-3.28658822 3.2809412-4.92611763 4.9261177-.50447059.5044706-.49882353 1.0484706.00188235 1.5548235.49317647.4950588.9882353.9882353 1.47952942 1.4814118.60047058.5929411 1.09929416.5929411 1.69035296 0 1.6225882-1.6188236 3.2414117-3.2414118 4.8602353-4.8602353.0884706-.0865883.1750588-.1694118.3275294-.3068236.0790588.1110589.1298823.2164706.2127059.2992942 1.6395294 1.6395294 3.2790588 3.2828235 4.9223529 4.9261176.5195294.5157647 1.0616471.512 1.5830588-.005647.5082353-.5025883 1.0164706-1.0145883 1.5209412-1.5247059.5214118-.5214118.5214118-1.0578824.0056471-1.5774118-.8847059-.8865882-1.7712942-1.7694118-2.6541177-2.6522353-.837647-.8357647-1.6790588-1.6715294-2.5675294-2.5524706M15.1887059 0h1.6244706c.1110588.02070588.2202353.04517647.3331764.064.698353.0922353 1.4098824.13741176 2.0969412.2842353 3.5896471.76047058 6.5882353 2.54117646 8.9637647 5.33835294 1.9745883 2.33223529 3.1830588 5.02023526 3.6122353 8.05270586.064.48.1204706.9618824.1807059 1.4475294v1.6244706c-.0207059.1016471-.0508235.2032941-.0602353.3030588-.1995294 2.9345883-1.1275294 5.6244706-2.8291765 8.0169412-2.6597647 3.744-6.272 5.9821177-10.816 6.6804706-.4950588.0752941-.9863529.1261177-1.4814117.1882353h-1.6244706c-.2352941-.0263529-.4705883-.0564706-.7058824-.0847059-3.2094117-.3294117-6.08752938-1.477647-8.57788232-3.5312941C2.71811765 25.7543529.8 22.3868235.18823529 18.2908235.11294118 17.8014118.0602353 17.3044706 0 16.8112941v-1.6244706c.02447059-.1223529.05082353-.2409411.064-.3651764.09788235-.6964706.14870588-1.4061177.29741176-2.0950589C1.12 9.13317647 2.912 6.14211765 5.71294119 3.77411765 8.03011765 1.81270588 10.7011765.61364705 13.7072941.18635295 14.2004706.11294117 14.6955294.06211764 15.1887059 0"
  })));
})(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral([""])));
var VideoPlay = styled(function VideoPlay(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "video-play"
  }), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("circle", {
    opacity: ".9",
    cx: "16",
    cy: "16",
    r: "16"
  }), /*#__PURE__*/createElement("polygon", {
    points: "22.667 16 12.444 22.222 12.444 9.778"
  })));
})(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral([""])));

var Fill = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Alert: Alert,
  CaretDown: CaretDown,
  Check: Check,
  CheckCircle: CheckCircle,
  Heart: Heart,
  Info: Info,
  Star: Star,
  Success: Success,
  TimesCircle: TimesCircle,
  VideoPlay: VideoPlay
});

var _templateObject$7, _templateObject2$4, _templateObject3$4, _templateObject4$2, _templateObject5$1, _templateObject6$1;
var Bankwire = styled(function Bankwire(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    viewBox: "0 0 58 40",
    name: "bankwire"
  }), /*#__PURE__*/createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("rect", {
    width: "57",
    height: "39",
    x: ".5",
    y: ".5",
    fill: "#FFF",
    stroke: "#E3DDD3",
    rx: "4"
  }), /*#__PURE__*/createElement("path", {
    fill: "#B8AFA4",
    fillRule: "nonzero",
    d: "M1.00653595,7.8317041 C0.450641494,7.8317041 0,7.38597869 0,6.83614854 C0,6.28631839 0.450641494,5.84059299 1.00653595,5.84059299 L17.1111111,5.84059299 C17.6670056,5.84059299 18.1176471,6.28631839 18.1176471,6.83614854 C18.1176471,7.38597869 17.6670056,7.8317041 17.1111111,7.8317041 L1.00653595,7.8317041 Z M15.6713878,6.83614854 L10.3682084,1.70738481 C9.97074015,1.32298886 9.9635799,0.692677732 10.3522155,0.299545508 C10.7408511,-0.0935867171 11.3781142,-0.100668865 11.7755825,0.283727089 L17.8147981,6.12431968 C18.2185967,6.51483775 18.2185967,7.15745933 17.8147981,7.5479774 L11.7755825,13.38857 C11.3781142,13.7729659 10.7408511,13.7658838 10.3522155,13.3727516 C9.9635799,12.9796194 9.97074015,12.3493082 10.3682084,11.9649123 L15.6713878,6.83614854 Z",
    transform: "translate(28 7)"
  }), /*#__PURE__*/createElement("path", {
    fill: "#B8AFA4",
    fillRule: "nonzero",
    d: "M1.00653595,7.8317041 C0.450641494,7.8317041 0,7.38597869 0,6.83614854 C0,6.28631839 0.450641494,5.84059299 1.00653595,5.84059299 L17.1111111,5.84059299 C17.6670056,5.84059299 18.1176471,6.28631839 18.1176471,6.83614854 C18.1176471,7.38597869 17.6670056,7.8317041 17.1111111,7.8317041 L1.00653595,7.8317041 Z M15.6713878,6.83614854 L10.3682084,1.70738481 C9.97074015,1.32298886 9.9635799,0.692677732 10.3522155,0.299545508 C10.7408511,-0.0935867171 11.3781142,-0.100668865 11.7755825,0.283727089 L17.8147981,6.12431968 C18.2185967,6.51483775 18.2185967,7.15745933 17.8147981,7.5479774 L11.7755825,13.38857 C11.3781142,13.7729659 10.7408511,13.7658838 10.3522155,13.3727516 C9.9635799,12.9796194 9.97074015,12.3493082 10.3682084,11.9649123 L15.6713878,6.83614854 Z",
    transform: "rotate(-180 16.059 16.5)"
  })));
})(_templateObject$7 || (_templateObject$7 = _taggedTemplateLiteral([""])));
var CreditCard = styled(function CreditCard(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    viewBox: "0 0 58 40",
    name: "creditcard"
  }), /*#__PURE__*/createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("rect", {
    width: "57",
    height: "39",
    x: ".5",
    y: ".5",
    fill: "#FFF",
    stroke: "#E3DDD3",
    rx: "4"
  }), /*#__PURE__*/createElement("polygon", {
    fill: "#B8AFA4",
    fillRule: "nonzero",
    points: "58 8 58 18 0 18 0 8"
  }), /*#__PURE__*/createElement("polygon", {
    fill: "#B8AFA4",
    fillRule: "nonzero",
    points: "23 27 23 31 7 31 7 27"
  })));
})(_templateObject2$4 || (_templateObject2$4 = _taggedTemplateLiteral([""])));
var IDeal = styled(function IDeal(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    viewBox: "0 0 58 40",
    name: "ideal"
  }), /*#__PURE__*/createElement("g", {
    id: "Components",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("g", {
    id: "PaymentIcons",
    transform: "translate(-54.000000, -298.000000)"
  }, /*#__PURE__*/createElement("g", {
    id: "Group",
    transform: "translate(54.000000, 298.000000)"
  }, /*#__PURE__*/createElement("rect", {
    id: "Rectangle",
    stroke: "#E3DDD3",
    fill: "#FFFFFF",
    x: "0.5",
    y: "0.5",
    width: "57",
    height: "39",
    rx: "4"
  }), /*#__PURE__*/createElement("g", {
    id: "ideal-logo",
    transform: "translate(10.000000, 3.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/createElement("g", {
    id: "Group"
  }, /*#__PURE__*/createElement("path", {
    d: "M0,2.47557003 L0,30.9198697 C0,32.2814332 1.11400651,33.3954397 2.47557003,33.3954397 L19.4703583,33.3954397 C32.3185668,33.3954397 37.8885993,26.2039088 37.8885993,16.6605863 C37.8885993,7.16677524 32.3185668,0 19.4703583,0 L2.47557003,0 C1.11400651,0 0,1.11400651 0,2.47557003 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/createElement("path", {
    d: "M11.3752443,6.98110749 L11.3752443,27.9986971 L20.5224756,27.9986971 C28.828013,27.9986971 32.4299674,23.3074919 32.4299674,16.6729642 C32.4299674,10.323127 28.828013,5.39674267 20.5224756,5.39674267 L12.9596091,5.39674267 C12.0807818,5.39674267 11.3752443,6.11465798 11.3752443,6.98110749 Z",
    id: "Path",
    fill: "#CC0066"
  }), /*#__PURE__*/createElement("path", {
    d: "M19.4703583,31.1302932 L4.69120521,31.1302932 C3.37915309,31.1302932 2.31465798,30.065798 2.31465798,28.7537459 L2.31465798,4.65407166 C2.31465798,3.34201954 3.37915309,2.27752443 4.69120521,2.27752443 L19.4703583,2.27752443 C33.4944625,2.27752443 35.5863192,11.3009772 35.5863192,16.6729642 C35.5863192,25.9934853 29.8553746,31.1302932 19.4703583,31.1302932 Z M4.69120521,3.06970684 C3.81237785,3.06970684 3.10684039,3.7752443 3.10684039,4.65407166 L3.10684039,28.7537459 C3.10684039,29.6325733 3.81237785,30.3381107 4.69120521,30.3381107 L19.4703583,30.3381107 C29.3478827,30.3381107 34.7941368,25.4859935 34.7941368,16.6729642 C34.7941368,4.83973941 25.1889251,3.06970684 19.4703583,3.06970684 L4.69120521,3.06970684 Z",
    id: "Shape",
    fill: "#000000"
  })), /*#__PURE__*/createElement("g", {
    id: "Group",
    transform: "translate(12.377850, 13.739414)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/createElement("path", {
    d: "M2.21563518,0.0990228013 C2.53745928,0.0990228013 2.83452769,0.148534202 3.11921824,0.247557003 C3.40390879,0.346579805 3.63908795,0.507491857 3.8495114,0.705537459 C4.047557,0.915960912 4.20846906,1.17589577 4.33224756,1.47296417 C4.44364821,1.78241042 4.50553746,2.14136808 4.50553746,2.56221498 C4.50553746,2.93355049 4.45602606,3.26775244 4.36938111,3.5771987 C4.27035831,3.88664495 4.13420195,4.15895765 3.9485342,4.38175896 C3.76286645,4.60456026 3.5276873,4.77785016 3.24299674,4.91400651 C2.95830619,5.03778502 2.62410423,5.11205212 2.24039088,5.11205212 L0.074267101,5.11205212 L0.074267101,0.0866449511 L2.21563518,0.0866449511 L2.21563518,0.0990228013 Z M2.14136808,4.19609121 C2.30228013,4.19609121 2.45081433,4.1713355 2.61172638,4.1218241 C2.76026059,4.0723127 2.89641694,3.98566775 3.00781759,3.86188925 C3.11921824,3.73811075 3.21824104,3.58957655 3.29250814,3.39153094 C3.36677524,3.19348534 3.40390879,2.97068404 3.40390879,2.68599349 C3.40390879,2.43843648 3.37915309,2.20325733 3.32964169,2.00521173 C3.28013029,1.80716612 3.19348534,1.62149837 3.08208469,1.48534202 C2.97068404,1.34918567 2.82214984,1.22540717 2.63648208,1.15114007 C2.45081433,1.07687296 2.22801303,1.03973941 1.95570033,1.03973941 L1.16351792,1.03973941 L1.16351792,4.20846906 L2.14136808,4.20846906 L2.14136808,4.19609121 Z",
    id: "Shape"
  }), /*#__PURE__*/createElement("polygon", {
    id: "Path",
    points: "8.97394137 0.0990228013 8.97394137 1.02736156 6.32508143 1.02736156 6.32508143 2.10423453 8.76351792 2.10423453 8.76351792 2.95830619 6.32508143 2.95830619 6.32508143 4.18371336 9.03583062 4.18371336 9.03583062 5.11205212 5.22345277 5.11205212 5.22345277 0.0866449511 8.97394137 0.0866449511"
  }), /*#__PURE__*/createElement("path", {
    d: "M12.7615635,0.0990228013 L14.6429967,5.12442997 L13.4918567,5.12442997 L13.1081433,4.01042345 L11.2267101,4.01042345 L10.8306189,5.12442997 L9.71661238,5.12442997 L11.6104235,0.0990228013 L12.7615635,0.0990228013 L12.7615635,0.0990228013 Z M12.8234528,3.18110749 L12.1921824,1.33680782 L12.1798046,1.33680782 L11.5237785,3.18110749 L12.8234528,3.18110749 Z",
    id: "Shape"
  }), /*#__PURE__*/createElement("polygon", {
    id: "Path",
    points: "16.437785 0.0990228013 16.437785 4.19609121 18.8885993 4.19609121 18.8885993 5.12442997 15.3361564 5.12442997 15.3361564 0.0990228013 16.437785 0.0990228013"
  })), /*#__PURE__*/createElement("circle", {
    id: "Oval",
    fill: "#000000",
    cx: "7.24104235",
    cy: "16.3511401",
    r: "2.31465798"
  }), /*#__PURE__*/createElement("path", {
    d: "M8.98631922,27.9986971 L8.98631922,27.9986971 C7.04299674,27.9986971 5.48338762,26.4267101 5.48338762,24.4957655 L5.48338762,21.7602606 C5.48338762,20.7947883 6.26319218,20.0026059 7.24104235,20.0026059 L7.24104235,20.0026059 C8.20651466,20.0026059 8.99869707,20.7824104 8.99869707,21.7602606 L8.99869707,27.9986971 L8.98631922,27.9986971 Z",
    id: "Path",
    fill: "#000000"
  }))))));
})(_templateObject3$4 || (_templateObject3$4 = _taggedTemplateLiteral([""])));
var NeutralCard = styled(function NeutralCard(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    viewBox: "0 0 33 24",
    name: "neutralcard"
  }), /*#__PURE__*/createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    transform: "translate(1 1)"
  }, /*#__PURE__*/createElement("rect", {
    width: "30.378",
    height: "21.818",
    rx: "2"
  }), /*#__PURE__*/createElement("path", {
    d: "M16.57 15h6.904"
  })));
})(_templateObject4$2 || (_templateObject4$2 = _taggedTemplateLiteral([""])));
var Paylib = styled(function Paylib(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    viewBox: "0 0 58 40",
    name: "paylib"
  }), ' ', /*#__PURE__*/createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("rect", {
    width: "57",
    height: "39",
    x: ".5",
    y: ".5",
    fill: "#FFF",
    stroke: "#E3DDD3",
    rx: "4"
  }), /*#__PURE__*/createElement("path", {
    fill: "#16D6FF",
    fillRule: "nonzero",
    d: "M20.7465217,15.21 L20.7610559,15.8008333 C20.1961801,15.3102778 19.4429193,15.085 18.3981366,15.085 C16.0668012,15.085 15.1106211,16.1863889 15.098323,18.8863889 L15.0952484,19.6047222 C15.0888199,21.1155556 15.3795031,22.1102778 16.0109006,22.7361111 C16.5640373,23.2847222 17.3835404,23.5513889 18.516646,23.5513889 C19.3381056,23.5513889 19.9552484,23.4066667 20.4245342,23.1005556 L20.4214596,23.5544444 L22.3849689,23.5544444 L22.3715528,15.225 L20.7465217,15.21 Z M18.7100621,21.9816667 C18.1320497,21.9816667 17.7508075,21.8711111 17.5109938,21.6330556 C17.1839752,21.3091667 17.0467391,20.6983333 17.0512112,19.5902778 L17.0537267,19.0636111 C17.0615528,17.1852778 17.4330124,16.6711111 18.7807764,16.6711111 C19.4144099,16.6711111 19.8437267,16.7902778 20.092205,17.0361111 C20.3322981,17.2733333 20.4429814,17.6586111 20.4410503,18.2483333 L20.4337578,20.4194444 C20.4301242,21.5144444 19.914441,21.9816667 18.7100621,21.9816667 Z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#16D6FF",
    d: "M30.3038509 15.2233333L28.3763975 15.2233333 28.3696894 20.6116667C28.3682919 21.1791667 28.2869565 21.4563889 28.0686646 21.6358333 27.8173913 21.8441667 27.4364286 21.9416667 26.8684783 21.9416667 26.308913 21.9416667 25.9374534 21.8555556 25.7001553 21.6722222 25.4785093 21.4997222 25.3887888 21.2013889 25.3901863 20.6430556L25.405 15.2233333 23.4585404 15.2233333 23.467764 20.8508333C23.4652484 21.8252778 23.7740994 22.5144444 24.4119255 22.9561111 25.0064286 23.3769444 25.7272671 23.5486111 26.8983851 23.5486111 27.473882 23.5486111 27.9574224 23.4994444 28.3677329 23.3997222L28.3769565 24.1191667C28.375559 24.7005556 28.2863975 24.8186111 27.8436646 24.8186111L26.9649068 24.8186111 26.9649068 26.4205556 28.1614596 26.4205556C29.6763665 26.4205556 30.2954658 25.8275 30.2985404 24.3736111L30.3038509 15.2233333zM9.69245342 21.9311111L9.69552795 23.5572222C9.69552795 23.5572222 10.8319876 23.5594444 10.8778261 23.5594444 13.2642236 23.5594444 14.2874845 22.3894444 14.2997826 19.6461111L14.3031366 18.9280556C14.3104037 17.4413889 14.0278261 16.4663889 13.4143168 15.8591667 12.8857764 15.3369444 12.1204969 15.0933333 11.0063975 15.0933333 9.97 15.0933333 9.18767081 15.3283333 8.62559006 15.8097222L8.62083851 15.2352778 7 15.2247222 7.01956522 26.4202778 8.98307453 26.4202778 8.98419255 18.2897222C8.99145963 17.1008333 9.4210559 16.6791667 10.6760248 16.6791667 11.2719255 16.6791667 11.6604348 16.7894444 11.900528 17.0266667 12.218882 17.3416667 12.3524845 17.9436111 12.3468944 19.0380556L12.3446584 19.5647222C12.3359938 21.4430556 11.9449689 21.9261111 10.6304658 21.9288889L9.69245342 21.9311111z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#16D6FF",
    fillRule: "nonzero",
    d: "M44.2546894,10.2977778 L44.2546894,20.4841667 C44.2532919,21.0733333 44.352236,21.4502778 44.5736025,21.6694444 C44.8036335,21.8977778 45.1722981,21.9947222 45.8445031,21.9947222 C47.0547516,21.9947222 47.6254969,21.7541667 47.6280124,19.5547222 L47.6285714,19.0397222 C47.630528,18.0122222 47.504472,17.5416667 47.2068012,17.2336111 C46.9996894,17.0194444 46.685528,16.9066667 46.1952795,16.875 L45.0196894,16.875 L45.0196894,15.2269444 L46.3347516,15.2280556 L46.3350311,15.2269444 C47.3879193,15.2438889 48.1565528,15.5083333 48.6820186,16.0269444 C49.3097826,16.6466667 49.6004658,17.52 49.5990683,18.9875 L49.5976708,19.6308333 C49.5940373,22.3972222 48.4648447,23.5772222 45.8199068,23.5772222 C44.438882,23.5772222 43.5743789,23.3308333 43.0170497,22.7788889 C42.5298758,22.2966667 42.2990062,21.5783333 42.3009627,20.5830556 L42.3009627,10.0427778 C42.193354,10.0394444 42.0865839,10.0347222 41.9781366,10.0347222 C39.8846584,10.0347222 37.9426708,10.6780556 36.3391615,11.775 L36.3391615,21.1533333 C36.338323,21.4925 36.3721429,21.68 36.4534783,21.7625 C36.5186025,21.8280556 36.6482919,21.8602778 36.8509317,21.8602778 L37.7878261,21.8602778 C37.7878261,21.8602778 37.7878261,22.2472222 37.7878261,22.3519444 L37.7861491,23.0772222 C37.7850311,23.3986111 37.7850311,23.555 37.7850311,23.555 L36.5806522,23.5547222 C35.7645031,23.5547222 35.218354,23.3858333 34.8617081,23.0241667 C34.5128882,22.67 34.3532919,22.1402778 34.3552484,21.3580556 L34.3552484,13.5652778 C32.8984783,15.2861111 32.0197205,17.5061111 32.0197205,19.9305556 C32.0197205,24.3547222 34.9424845,28.1005556 38.9737578,29.3666667 L38.9737578,18.1647222 L41.0295031,18.1647222 L41.0295031,29.7802778 C41.3417081,29.8094444 41.6581056,29.8261111 41.9781366,29.8261111 C47.4768012,29.8261111 51.9343168,25.3958333 51.9343168,19.9305556 C51.9345963,15.2441667 48.6557453,11.3213889 44.2546894,10.2977778 Z M41.1681366,16.4166667 C41.1653416,17.0877778 40.7650932,17.4722222 40.0680124,17.4722222 L39.9858385,17.4722222 C39.6322671,17.4722222 39.3396273,17.3666667 39.1378261,17.1666667 C38.9435714,16.9752778 38.8454658,16.7136111 38.846299,16.3877778 L38.8468634,16.2794444 C38.8485404,15.6183333 39.2658385,15.2241667 39.9631988,15.2241667 L40.0450932,15.2241667 C40.3953106,15.2241667 40.6837578,15.3263889 40.8791304,15.5191667 C41.0714286,15.7088889 41.1684161,15.9747222 41.1678571,16.3083333 L41.1678571,16.4166667 L41.1681366,16.4166667 Z"
  })), ' ');
})(_templateObject5$1 || (_templateObject5$1 = _taggedTemplateLiteral([""])));
var Paypal = styled(function Paypal(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    viewBox: "0 0 58 40",
    name: "paypal"
  }), /*#__PURE__*/createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("rect", {
    width: "57",
    height: "39",
    x: ".5",
    y: ".5",
    fill: "#FFF",
    stroke: "#E3DDD3",
    rx: "4"
  }), /*#__PURE__*/createElement("path", {
    fill: "#28356A",
    d: "M26.4388121,20.2561496 L26.6913146,18.6476956 L26.1288305,18.6345393 L23.4428638,18.6345393 L25.309516,6.76501939 C25.3153315,6.72907704 25.3341306,6.69571169 25.3615853,6.67197618 C25.3891753,6.64824067 25.424339,6.63522004 25.4611257,6.63522004 L29.9900766,6.63522004 C31.493731,6.63522004 32.5313311,6.94893571 33.0729875,7.56822917 C33.3269777,7.85875185 33.4887308,8.16243079 33.5670376,8.49649119 C33.6491314,8.84709863 33.6504838,9.26592872 33.5704188,9.7768526 L33.5646032,9.81401563 L33.5646032,10.1414301 L33.8185934,10.285742 C34.0324158,10.3995368 34.2024189,10.5297431 34.3327951,10.6788021 C34.5499986,10.927279 34.6905183,11.2430292 34.7498908,11.6172365 C34.8112921,12.0021587 34.7910053,12.4603219 34.6905183,12.9789768 C34.5746132,13.5754842 34.3872989,14.0950885 34.1342554,14.5201576 C33.9016339,14.9118614 33.6051767,15.2368345 33.2531339,15.4885666 C32.9170499,15.7278205 32.5178065,15.9094311 32.0663586,16.0256673 C31.6288408,16.139869 31.1300571,16.1975124 30.5829909,16.1975124 L30.2305423,16.1975124 C29.9785808,16.1975124 29.7337872,16.2885212 29.541604,16.4516859 C29.3488798,16.6182414 29.221479,16.845831 29.1823932,17.0947148 L29.1557499,17.2395693 L28.7095765,20.0746747 L28.689425,20.178704 C28.6840152,20.2116625 28.6748185,20.2280739 28.661294,20.2391957 C28.6492572,20.249368 28.6319458,20.2561496 28.6150402,20.2561496 L26.4388121,20.2561496"
  }), /*#__PURE__*/createElement("path", {
    fill: "#298FC2",
    d: "M34.0589239,9.85185682 C34.0455346,9.93852536 34.0299814,10.0270927 34.0126701,10.1181015 C33.4154279,13.1934102 31.3720105,14.2558118 28.762322,14.2558118 L27.4335394,14.2558118 C27.1143611,14.2558118 26.8453587,14.4881486 26.7957238,14.8038987 L25.922717,20.3573307 C25.8903934,20.5647113 26.0497121,20.7514759 26.25826,20.7514759 L28.6150402,20.7514759 C28.8940507,20.7514759 29.1311353,20.5481642 29.1750899,20.2721541 L29.1982168,20.1521202 L29.6419558,17.3281367 L29.6704925,17.1732455 C29.7139062,16.896286 29.9515318,16.6928387 30.2305423,16.6928387 L30.5829909,16.6928387 C32.866333,16.6928387 34.6538668,15.7632204 35.1763185,13.0728338 C35.3944687,11.9489912 35.2815391,11.0105568 34.7040428,10.3505739 C34.5293062,10.1516025 34.3125083,9.98640328 34.0589239,9.85185682"
  }), /*#__PURE__*/createElement("path", {
    fill: "#22284F",
    d: "M33.434227,9.60202359 C33.3429366,9.57530418 33.248806,9.55116178 33.1522411,9.5293251 C33.0551351,9.50803096 32.95573,9.48917818 32.8533495,9.47263114 C32.4950854,9.41458085 32.102469,9.38704766 31.6819921,9.38704766 L28.1322154,9.38704766 C28.0447118,9.38704766 27.9616714,9.40684986 27.8874218,9.44265657 C27.7236401,9.52159411 27.6020548,9.67702781 27.5725714,9.86731882 L26.817363,14.6640626 L26.7957238,14.8038987 C26.8453587,14.4881486 27.1143611,14.2558118 27.4335394,14.2558118 L28.762322,14.2558118 C31.3720105,14.2558118 33.4154279,13.1928677 34.0126701,10.1181015 C34.0305224,10.0270927 34.0455346,9.93852536 34.0589239,9.85185682 C33.9078552,9.77142734 33.7442086,9.70266217 33.5679843,9.64406936 C33.5244354,9.62955679 33.4795341,9.61558674 33.434227,9.60202359"
  }), /*#__PURE__*/createElement("path", {
    fill: "#28356A",
    d: "M27.5725714 9.86731882C27.6020548 9.67702781 27.7236401 9.52159411 27.8874218 9.4431991 27.9622123 9.40725675 28.0447118 9.38745455 28.1322154 9.38745455L31.6819921 9.38745455C32.102469 9.38745455 32.4950854 9.41512338 32.8533495 9.47317366 32.95573 9.48958507 33.0551351 9.50857348 33.1522411 9.52986763 33.248806 9.55156867 33.3429366 9.57584671 33.434227 9.60243049 33.4795341 9.61599364 33.5244354 9.63009931 33.5683901 9.64406936 33.7446144 9.70266217 33.9083961 9.77196987 34.0594649 9.85185682 34.2371768 8.71540044 34.0579772 7.9416227 33.4453171 7.24095034 32.7697681 6.46947834 31.5506692 6.13935126 29.9906176 6.13935126L25.4615314 6.13935126C25.1428941 6.13935126 24.8710515 6.37168803 24.8218223 6.6879807L22.9354244 18.679569C22.898232 18.9167885 23.0806776 19.130815 23.3192498 19.130815L26.115306 19.130815 27.5725714 9.86731882M13.094619 23.5208333L9.79247587 23.5208333C9.5664814 23.5208333 9.37429818 23.68549 9.33899923 23.909282L8.00345437 32.4008993C7.97694634 32.5685398 8.10637585 32.7194977 8.2758379 32.7194977L9.85225418 32.7194977C10.0782487 32.7194977 10.2704319 32.5549766 10.3057308 32.3307778L10.6658884 30.0403685C10.7006464 29.8161697 10.8932353 29.651513 11.1188241 29.651513L12.164133 29.651513C14.3392792 29.651513 15.5946237 28.595893 15.9225929 26.5041839 16.0702805 25.5889425 15.9288142 24.8699599 15.5014399 24.3663601 15.0321395 23.8133905 14.1997063 23.5208333 13.094619 23.5208333zM13.475469 26.622319C13.2949169 27.8105866 12.3895865 27.8105866 11.5142806 27.8105866L11.0159026 27.8105866 11.365511 25.5913839C11.3863388 25.4572443 11.5021085 25.3585046 11.6373536 25.3585046L11.8657825 25.3585046C12.4620779 25.3585046 13.024562 25.3585046 13.3152036 25.6993466 13.4885878 25.9026582 13.5416039 26.2048452 13.475469 26.622319L13.475469 26.622319zM23.0495572 26.5198708L21.4682721 26.5198708C21.333568 26.5198708 21.217122 26.6186105 21.1964296 26.7527501L21.1263726 27.1962651 21.0158774 27.0355417C20.6735722 26.5372316 19.9101139 26.3706761 19.1482785 26.3706761 17.4007773 26.3706761 15.9083482 27.697966 15.6177065 29.5597797 15.4666378 30.4884486 15.681407 31.3765637 16.206834 31.9958572 16.6887121 32.5652382 17.3781913 32.8025934 18.1984526 32.8025934 19.6064888 32.8025934 20.3871232 31.8946761 20.3871232 31.8946761L20.3166605 32.3353428C20.2901525 32.5037971 20.419582 32.6548906 20.5880973 32.6548906L22.0123629 32.6548906C22.2388984 32.6548906 22.4301349 32.490234 22.4658396 32.2660351L23.320453 26.8384692C23.347502 26.6713711 23.2184783 26.5198708 23.0495572 26.5198708zM20.8453334 29.6063013C20.692777 30.5121841 19.975843 31.1203558 19.061316 31.1203558 18.602159 31.1203558 18.2352392 30.9726531 17.9995071 30.6928453 17.7658037 30.4149363 17.6770829 30.0192992 17.7513324 29.5786325 17.8938807 28.6804806 18.6228515 28.0523711 19.5234483 28.0523711 19.9724619 28.0523711 20.3374882 28.2021083 20.5779539 28.4842218 20.8188254 28.7694549 20.9144436 29.1675334 20.8453334 29.6063013L20.8453334 29.6063013zM31.349511 26.6556604L29.7603816 26.6556604C29.6087719 26.6556604 29.4663589 26.7312071 29.3804783 26.8576157L27.1888323 30.0950041 26.259834 26.9838886C26.2014082 26.7892574 26.0223437 26.6556604 25.8194762 26.6556604L24.2580721 26.6556604C24.068188 26.6556604 23.9364594 26.8416112 23.9967787 27.0207804L25.7471201 32.1717937 24.1015936 34.5014004C23.9721641 34.6849099 24.1025403 34.9371845 24.3261003 34.9371845L25.913201 34.9371845C26.063864 34.9371845 26.2047893 34.8635366 26.2902642 34.739705L31.5753702 27.089003C31.7019596 26.9060361 31.5719891 26.6556604 31.349511 26.6556604"
  }), /*#__PURE__*/createElement("path", {
    fill: "#298FC2",
    d: "M36.64691 23.5208333L33.3443612 23.5208333C33.1189077 23.5208333 32.9267245 23.68549 32.8914255 23.909282L31.5558807 32.4008993C31.5293727 32.5685398 31.6588022 32.7194977 31.8273175 32.7194977L33.5220732 32.7194977C33.6793632 32.7194977 33.8140673 32.6043465 33.8386819 32.4474209L34.2177737 30.0403685C34.2525317 29.8161697 34.4452559 29.651513 34.6707094 29.651513L35.7156126 29.651513C37.8911645 29.651513 39.1461033 28.595893 39.4744783 26.5041839 39.6227068 25.5889425 39.4802938 24.8699599 39.0529194 24.3663601 38.5840249 23.8133905 37.7521326 23.5208333 36.64691 23.5208333zM37.0278953 26.622319C36.8477489 27.8105866 35.9424186 27.8105866 35.0665716 27.8105866L34.5688699 27.8105866 34.9188841 25.5913839C34.9395765 25.4572443 35.0545348 25.3585046 35.1901856 25.3585046L35.4186145 25.3585046C36.0143689 25.3585046 36.5773941 25.3585046 36.8680357 25.6993466 37.0414198 25.9026582 37.0940302 26.2048452 37.0278953 26.622319L37.0278953 26.622319zM46.5998574 26.5198708L45.019519 26.5198708C44.8838683 26.5198708 44.7685042 26.6186105 44.7482175 26.7527501L44.6781605 27.1962651 44.5671244 27.0355417C44.2248191 26.5372316 43.4619018 26.3706761 42.6999312 26.3706761 40.9525652 26.3706761 39.4606771 27.697966 39.1700355 29.5597797 39.0193725 30.4884486 39.2331949 31.3765637 39.7584867 31.9958572 40.2414467 32.5652382 40.929844 32.8025934 41.7502405 32.8025934 43.1581414 32.8025934 43.9389111 31.8946761 43.9389111 31.8946761L43.8684484 32.3353428C43.8419404 32.5037971 43.9712347 32.6548906 44.140832 32.6548906L45.5646918 32.6548906C45.7901453 32.6548906 45.9823285 32.490234 46.0176275 32.2660351L46.8726467 26.8384692C46.898749 26.6713711 46.7693195 26.5198708 46.5998574 26.5198708zM44.3957689 29.6063013C44.2441592 30.5121841 43.5261432 31.1203558 42.6116162 31.1203558 42.153406 31.1203558 41.7855394 30.9726531 41.5498073 30.6928453 41.3162391 30.4149363 41.2283298 30.0192992 41.3016327 29.5786325 41.4451277 28.6804806 42.1731518 28.0523711 43.0737485 28.0523711 43.5227621 28.0523711 43.8877885 28.2021083 44.1282542 28.4842218 44.3700723 28.7694549 44.4656906 29.1675334 44.3957689 29.6063013L44.3957689 29.6063013zM48.3324054 23.7542552L46.9771147 32.4013062C46.9506067 32.5689467 47.079901 32.7199046 47.2484163 32.7199046L48.6110102 32.7199046C48.8375456 32.7199046 49.0295936 32.5553835 49.0643516 32.3311847L50.4008431 23.8399743C50.4274864 23.6723337 50.2980569 23.5208333 50.1295416 23.5208333L48.6038422 23.5208333C48.4691381 23.5212402 48.3532331 23.6201156 48.3324054 23.7542552"
  })));
})(_templateObject6$1 || (_templateObject6$1 = _taggedTemplateLiteral([""])));

var PaymentMethods = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Bankwire: Bankwire,
  CreditCard: CreditCard,
  IDeal: IDeal,
  NeutralCard: NeutralCard,
  Paylib: Paylib,
  Paypal: Paypal
});

var _templateObject$8, _templateObject2$5, _templateObject3$5, _templateObject4$3, _templateObject5$2, _templateObject6$2, _templateObject7$1, _templateObject8$1, _templateObject9$1, _templateObject10$1, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28, _templateObject29, _templateObject30, _templateObject31, _templateObject32, _templateObject33;
var Alert$1 = styled(function Alert(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "alert"
  }), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
    d: "M18 17.058C18 18.131 17.105 19 16 19s-2-.87-2-1.942V8.942C14 7.869 14.895 7 16 7s2 .87 2 1.942v8.116zM16 0c8.837 0 16 7.163 16 16s-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0zm0 3.556C9.127 3.556 3.556 9.127 3.556 16c0 6.873 5.571 12.444 12.444 12.444 6.873 0 12.444-5.571 12.444-12.444 0-6.873-5.571-12.444-12.444-12.444zM16 21c1.105 0 2 .707 2 1.579v.842c0 .872-.895 1.579-2 1.579s-2-.707-2-1.579v-.842c0-.872.895-1.579 2-1.579z",
    fillRule: "evenodd"
  })));
})(_templateObject$8 || (_templateObject$8 = _taggedTemplateLiteral([""])));
var ArrowLeft = styled(function ArrowLeft(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "arrow-left"
  }), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
    d: "m 30.179517,13.985 a -1.778,1.778 0 1 0 0,-3.555 H 1.7355173 a -1.778,1.778 0 0 0 0,3.555 z M 4.2785173,12.207 13.644517,3.05 a -1.778,1.778 0 1 0 -2.485,-2.543 L 0.49251728,10.937 a -1.778,1.778 0 0 0 0,2.542 L 11.159517,23.909 a -1.778,1.778 0 1 0 2.485,-2.543 z",
    fillRule: "nonzero"
  })));
})(_templateObject2$5 || (_templateObject2$5 = _taggedTemplateLiteral([""])));
var ArrowRight = styled(function ArrowRight(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "arrow-right",
    transform: "translate(0 3)"
  }), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
    d: "M1.778 13.985a1.778 1.778 0 110-3.555h28.444a1.778 1.778 0 010 3.555H1.778zm25.901-1.778L18.313 3.05A1.778 1.778 0 1120.798.507l10.667 10.43a1.778 1.778 0 010 2.542l-10.667 10.43a1.778 1.778 0 11-2.485-2.543l9.366-9.159z",
    fillRule: "nonzero"
  })));
})(_templateObject3$5 || (_templateObject3$5 = _taggedTemplateLiteral([""])));
var Bubble = styled(function Bubble(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "bubble",
    viewBox: "0 0 34 32"
  }), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.3887 22.0074C32.4514 19.9035 33.0041 17.5708 32.9983 15.2062V14.4184C32.5695 6.59636 26.402 0.428835 18.6779 0.00270422L17.7899 5.18107e-06C15.4291 -0.00615625 13.0956 0.546514 10.9841 1.61301C5.83911 4.18438 2.58375 9.44837 2.58152 15.2077C2.57602 17.316 3.01592 19.402 3.8692 21.3275L1.09265 29.6572C0.629427 31.0468 1.9515 32.3689 3.34116 31.9057L11.6708 29.1291C13.5964 29.9824 15.6827 30.4223 17.7945 30.4168C23.5499 30.4146 28.8139 27.1592 31.3887 22.0074ZM12.587 25.6304C12.164 25.4167 11.6731 25.3808 11.2234 25.5307L5.58969 27.4086L7.46761 21.7749C7.61749 21.3252 7.5816 20.8344 7.36791 20.4113C6.55388 18.7997 6.13203 17.0186 6.13674 15.213C6.13845 10.7961 8.63282 6.76265 12.5803 4.78977C14.1986 3.97235 15.9798 3.55051 17.7853 3.55521L18.58 3.55522C24.3967 3.87883 29.1195 8.60159 29.4458 14.5163L29.4431 15.213C29.4478 17.0186 29.026 18.7997 28.2119 20.4113C26.2357 24.3655 22.2022 26.8599 17.7892 26.8616C15.9798 26.8663 14.1986 26.4445 12.587 25.6304Z"
  })));
})(_templateObject4$3 || (_templateObject4$3 = _taggedTemplateLiteral([""])));
var Bulb = styled(function Bulb(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "bulb",
    viewBox: "0 0 22 32"
  }), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
    d: "M11 0C4.608 0 0 5.186 0 11c0 2.773 1.028 5.303 2.723 7.237 1.04 1.187 2.67 3.675 3.276 5.76V24h3v-.007c0-.298-.045-.594-.135-.88C8.515 22 7.438 19.066 4.98 16.26A7.975 7.975 0 013.003 11C2.991 6.398 6.733 3 11 3c4.411 0 8 3.589 8 8a7.976 7.976 0 01-1.978 5.26c-2.445 2.787-3.526 5.716-3.881 6.84-.092.29-.139.591-.14.894V24h3v-.003c.606-2.085 2.237-4.573 3.277-5.76A10.945 10.945 0 0022 11c0-6.075-4.925-11-11-11zM6.004 28.699c0 .197.058.388.167.552l1.532 2.303a1 1 0 00.833.446h4.928a.999.999 0 00.832-.446l1.532-2.303c.109-.164.167-.356.168-.552l.003-2.7H6l.003 2.7zM11 5c-3.309 0-6 2.691-6 6a1 1 0 102 0c0-2.206 1.795-4 4-4a1 1 0 100-2z",
    fillRule: "evenodd"
  })));
})(_templateObject5$2 || (_templateObject5$2 = _taggedTemplateLiteral([""])));
var Calendar = styled(function Calendar(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "calendar"
  }), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
    d: "M21 0c.828427 0 1.5.651222 1.5 1.454545V2.909l3 .000091c2.485281 0 4.5 1.953666 4.5 4.363636v20.363637C30 30.046333 27.985281 32 25.5 32h-21C2.014719 32 0 30.046333 0 27.636364V7.272727c0-2.40997 2.014719-4.363636 4.5-4.363636l3-.000091V1.454545C7.5.698476 8.094888.077141 8.85554.006658L9 0c.828427 0 1.5.651222 1.5 1.454545V2.909h9V1.454545c0-.756069.594888-1.377404 1.35554-1.447887zm6 14.545H3v13.091364c0 .803323.671573 1.454545 1.5 1.454545h21c.828427 0 1.5-.651222 1.5-1.454545V14.545zM7.5 5.818l-3 .000182c-.828427 0-1.5.651222-1.5 1.454545V11.636h24V7.272727c0-.803323-.671573-1.454545-1.5-1.454545l-3-.000182v1.454727c0 .756069-.594888 1.377405-1.35554 1.447887L21 8.727273c-.828427 0-1.5-.651222-1.5-1.454546V5.818h-9v1.454727c0 .756069-.594888 1.377405-1.35554 1.447887L9 8.727273c-.828427 0-1.5-.651222-1.5-1.454546V5.818z",
    fillRule: "nonzero"
  })));
})(_templateObject6$2 || (_templateObject6$2 = _taggedTemplateLiteral([""])));
var CaretDown$1 = styled(function CaretDown(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "caret-down",
    viewBox: "0 0 32 20"
  }), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
    d: "M28.965144.527208c.694265-.702944 1.819892-.702944 2.514157 0 .694265.702944.694265 1.84264 0 2.545584l-14.222222 14.4c-.694266.702944-1.819892.702944-2.514158 0l-14.222222-14.4c-.694265-.702944-.694265-1.84264 0-2.545584.694265-.702944 1.819892-.702944 2.514157 0L16 13.654416 28.965144.527208z",
    fillRule: "nonzero"
  })));
})(_templateObject7$1 || (_templateObject7$1 = _taggedTemplateLiteral([""])));
var CaretUp = styled(function CaretUp(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "caret-up"
  }), /*#__PURE__*/createElement("g", {
    transform: "rotate(180 16 16), translate(0, 7)"
  }, /*#__PURE__*/createElement("path", {
    d: "M28.965144.527208c.694265-.702944 1.819892-.702944 2.514157 0 .694265.702944.694265 1.84264 0 2.545584l-14.222222 14.4c-.694266.702944-1.819892.702944-2.514158 0l-14.222222-14.4c-.694265-.702944-.694265-1.84264 0-2.545584.694265-.702944 1.819892-.702944 2.514157 0L16 13.654416 28.965144.527208z",
    fillRule: "nonzero"
  }), ' '));
})(_templateObject8$1 || (_templateObject8$1 = _taggedTemplateLiteral([""])));
var Chain = styled(function Chain(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "chain"
  }), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
    d: "M11.71 18.502a1.79 1.79 0 01.36-2.503c.79-.592 1.91-.43 2.502.36a5.36 5.36 0 008.085.58l4.267-4.27a5.368 5.368 0 00-.066-7.52c-2.068-2.07-5.411-2.1-7.496-.084l-2.46 2.446c-.7.696-1.83.693-2.527-.007a1.79 1.79 0 01.008-2.53L16.86 2.51a8.93 8.93 0 0112.526.109c3.446 3.45 3.495 9.026.087 12.557l-4.289 4.292a8.932 8.932 0 01-13.474-.966zm8.58-5.004a1.79 1.79 0 01-.36 2.503c-.79.592-1.91.43-2.502-.36a5.36 5.36 0 00-8.085-.58l-4.267 4.27a5.368 5.368 0 00.066 7.52c2.068 2.07 5.411 2.1 7.493.088l2.444-2.446a1.786 1.786 0 012.528 0 1.79 1.79 0 010 2.529L15.14 29.49a8.93 8.93 0 01-12.526-.109c-3.446-3.45-3.495-9.026-.087-12.557l4.289-4.292a8.932 8.932 0 0113.474.966z",
    fillRule: "nonzero"
  })));
})(_templateObject9$1 || (_templateObject9$1 = _taggedTemplateLiteral([""])));
var Check$1 = styled(function Check(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "check"
  }), /*#__PURE__*/createElement("g", {
    transform: "translate(0, 7)"
  }, /*#__PURE__*/createElement("path", {
    d: "M10.6666667 18.8191759L28.9651435.52069906c.6942654-.69426541 1.819892-.69426541 2.5141574 0 .6942655.6942654.6942655 1.81989203 0 2.51415744L11.9237454 22.5904121c-.6942654.6942654-1.819892.6942654-2.51415746 0L.52069906 13.7015232c-.69426541-.6942654-.69426541-1.8198921 0-2.5141575.6942654-.6942654 1.81989203-.6942654 2.51415744 0l7.6318102 7.6318102z",
    fillRule: "evenodd"
  })));
})(_templateObject10$1 || (_templateObject10$1 = _taggedTemplateLiteral([""])));
var CheckCircle$1 = styled(function CheckCircle(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "check-circle"
  }), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
    d: "M16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zm0-3.556c6.873 0 12.444-5.571 12.444-12.444 0-6.873-5.571-12.444-12.444-12.444C9.127 3.556 3.556 9.127 3.556 16c0 6.873 5.571 12.444 12.444 12.444zm6.328-18.442a1.778 1.778 0 112.514 2.514l-10.43 10.43a1.778 1.778 0 01-2.514 0l-4.74-4.74a1.778 1.778 0 012.514-2.515l3.484 3.484 9.172-9.173z",
    fillRule: "nonzero"
  })));
})(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral([""])));
var Close = styled(function Close(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "close",
    viewBox: "0 0 19 19"
  }), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
    d: "M2.7464 4.1606c-.4122-.4122-.4298-1.063-.0393-1.4535.3905-.3905 1.0413-.373 1.4535.0393L16.103 14.6886c.4122.4123.4298 1.063.0392 1.4535-.3905.3906-1.0412.373-1.4535-.0392L2.7464 4.1606Z"
  }), /*#__PURE__*/createElement("path", {
    d: "M4.1606 16.1029c-.4122.4122-1.063.4298-1.4535.0392-.3905-.3905-.373-1.0412.0393-1.4535L14.6886 2.7464c.4123-.4122 1.063-.4298 1.4535-.0393.3906.3905.373 1.0413-.0392 1.4535L4.1606 16.1029Z"
  })));
})(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral([""])));
var CodeBlock = styled(function CodeBlock(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "code-block",
    viewBox: "1 0 20 14"
  }), /*#__PURE__*/createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2"
  }, /*#__PURE__*/createElement("path", {
    d: "M6.28 2.546L1.8 7.026l4.48 4.48M15.987 11.507l4.48-4.48-4.48-4.48M9.476 12.2207l3.0562-9.9962"
  })));
})(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral([""])));
var Edit = styled(function Edit(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "edit"
  }), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
    d: "M16.937 4.419L3.632 17.829v2.953h2.93l13.305-13.41-2.93-2.953zM18.22.536l5.498 5.542a1.84 1.84 0 010 2.588L8.6 23.906c-.341.344-.803.537-1.285.537H1.816A1.823 1.823 0 010 22.613V17.07c0-.486.191-.951.532-1.295L15.652.536a1.806 1.806 0 012.569 0zM1.816 32A1.823 1.823 0 010 30.17c0-1.011.813-1.83 1.816-1.83h24.368c1.003 0 1.816.819 1.816 1.83 0 1.01-.813 1.83-1.816 1.83H1.816z",
    fillRule: "nonzero"
  })));
})(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral([""])));
var Hash = styled(function Hash(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "hash"
  }), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("text", {
    fontFamily: PRIMARY_FONT,
    fontWeight: "bold",
    fontSize: "40"
  }, /*#__PURE__*/createElement("tspan", {
    x: "4",
    y: "31"
  }, "#"))));
})(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral([""])));
var Heart$1 = styled(function Heart(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "heart"
  }), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
    d: "M16,30a1.63,1.63,0,0,1-1.2-.49L2.71,17.57a9,9,0,0,1,0-12.87,9.34,9.34,0,0,1,13.07,0L16,4.9l.24-.22a9.3,9.3,0,0,1,13,0l.05,0h0a9.06,9.06,0,0,1,0,12.89L17.21,29.51A1.78,1.78,0,0,1,16,30ZM9.23,5.38a5.74,5.74,0,0,0-4.1,1.75,5.66,5.66,0,0,0,0,8.11h0L16,25.92,26.88,15.18a5.8,5.8,0,0,0,1.78-4.06,5.68,5.68,0,0,0-1.78-4.06h0a6,6,0,0,0-8.23,0L17.21,8.49A1.75,1.75,0,0,1,16,9h0a1.77,1.77,0,0,1-1.2-.49L13.34,7.06A5.76,5.76,0,0,0,9.23,5.38Z"
  })));
})(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral([""])));
var Letter = styled(function Letter(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "letter",
    viewBox: "0 0 32 26"
  }), /*#__PURE__*/createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/createElement("path", {
    d: "M4.622 3.514c-.582 0-1.066.478-1.066 1.054v16.864c0 .576.484 1.054 1.066 1.054h22.756c.582 0 1.066-.478 1.066-1.054V4.568c0-.576-.484-1.054-1.066-1.054H4.622zm0-3.514h22.756C29.924 0 32 2.051 32 4.568v16.864C32 23.95 29.924 26 27.378 26H4.622C2.076 26 0 23.949 0 21.432V4.568C0 2.05 2.076 0 4.622 0zm24.58 3.128a1.791 1.791 0 012.476.432c.564.795.368 1.89-.436 2.447l-14.223 9.838a1.795 1.795 0 01-2.038 0L.758 6.007A1.744 1.744 0 01.322 3.56a1.791 1.791 0 012.475-.432L16 12.261l13.203-9.133z"
  })));
})(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral([""])));
var Link = styled(function Link(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "link"
  }), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8998 14.6539C11.1378 15.2242 10.9822 16.3047 11.5521 17.0672C12.7499 18.6695 14.5841 19.6722 16.5787 19.8152C18.5733 19.9581 20.5316 19.2271 21.9453 17.812L25.0465 14.7088C27.6794 11.9814 27.642 7.6801 24.9835 5.01992C22.3251 2.35973 18.0265 2.32236 15.3222 4.93591L13.5262 6.72229C12.8514 7.39363 12.8482 8.48527 13.5191 9.16053C14.19 9.8358 15.281 9.83898 15.9558 9.16764L17.734 7.39871C19.0683 6.10939 21.2176 6.12808 22.5468 7.45817C23.8761 8.78826 23.8948 10.9389 22.5888 12.2919L19.5084 15.3739C18.8013 16.0817 17.8222 16.4472 16.8249 16.3758C15.8276 16.3043 14.9105 15.8029 14.3116 15.0018C13.7416 14.2393 12.6618 14.0835 11.8998 14.6539ZM18.0997 15.3461C18.8617 14.7758 19.0173 13.6953 18.4473 12.9328C17.2496 11.3305 15.4154 10.3278 13.4208 10.1848C11.4262 10.0419 9.46789 10.7729 8.05415 12.188L4.95296 15.2912C2.32008 18.0186 2.35743 22.3199 5.01592 24.9801C7.67441 27.6403 11.973 27.6776 14.6773 25.0641L16.4665 23.2742C17.1393 22.6009 17.1393 21.5092 16.4665 20.8359C15.7936 20.1626 14.7026 20.1626 14.0298 20.8359L12.262 22.6048C10.9312 23.8906 8.78187 23.8719 7.45263 22.5418C6.12338 21.2117 6.1047 19.0611 7.41065 17.7081L10.4911 14.6261C11.1982 13.9183 12.1773 13.5528 13.1746 13.6242C14.1719 13.6957 15.089 14.1971 15.6879 14.9982C16.2579 15.7607 17.3377 15.9165 18.0997 15.3461Z"
  })));
})(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral([""])));
var Lock = styled(function Lock(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "social-facebook"
  }), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
    d: "M14 0c4.6391919 0 8.4 3.90733309 8.4 8.72727273V13.09l1.4.0009091c2.3195959 0 4.2 1.9536665 4.2 4.3636364v10.1818181C28 30.0463335 26.1195959 32 23.8 32H4.2C1.88040405 32 0 30.0463335 0 27.6363636V17.4545455c0-2.4099699 1.88040405-4.3636364 4.2-4.3636364L5.6 13.09V8.72727273c0-4.73230437 3.62529469-8.5848862 8.1478416-8.72341569zm9.8 16H4.2c-.77319865 0-1.4.6512222-1.4 1.4545455v10.1818181c0 .8033233.62680135 1.4545455 1.4 1.4545455h19.6c.7731986 0 1.4-.6512222 1.4-1.4545455V17.4545455C25.2 16.6512222 24.5731986 16 23.8 16zM14 2.90909091c-3.0927946 0-5.6 2.60488873-5.6 5.81818182V13.09h11.2V8.72727273c0-3.13856535-2.3919472-5.69669516-5.3851979-5.8139805z",
    fillRule: "nonzero"
  })));
})(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral([""])));
var MapCursor = styled(function MapCursor(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "map-cursor",
    viewBox: "0 0 32 33"
  }), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
    d: "M13.5 0C20.956 0 27 6.006 27 13.414c0 4.51-2.401 8.884-6.346 13.02a40.897 40.897 0 01-4.21 3.825 30.81 30.81 0 01-1.952 1.442 1.799 1.799 0 01-1.984 0 30.81 30.81 0 01-1.952-1.442 40.897 40.897 0 01-4.21-3.824C2.4 22.298 0 17.923 0 13.415 0 6.004 6.044 0 13.5 0zm0 3.556c-5.48 0-9.922 4.413-9.922 9.858 0 3.41 1.99 7.036 5.365 10.575a37.369 37.369 0 004.557 4.04 37.369 37.369 0 004.557-4.04c3.374-3.54 5.365-7.165 5.365-10.575 0-5.445-4.442-9.858-9.922-9.858zm0 4.202c3.144 0 5.693 2.532 5.693 5.656 0 3.124-2.549 5.657-5.693 5.657-3.144 0-5.693-2.533-5.693-5.657s2.549-5.656 5.693-5.656zm0 3.555c-1.168 0-2.114.94-2.114 2.101 0 1.16.946 2.101 2.114 2.101s2.114-.94 2.114-2.1c0-1.161-.946-2.102-2.114-2.102z",
    fillRule: "nonzero"
  })));
})(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral([""])));
var Minus = styled(function Minus(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "minus"
  }), /*#__PURE__*/createElement("g", {
    transform: "translate(0, 15)"
  }, /*#__PURE__*/createElement("path", {
    d: "M1.7778 4.2222c-.9819 0-1.7778-.8954-1.7778-2 0-1.1045.796-2 1.7778-2h28.4444c.9819 0 1.7778.8955 1.7778 2 0 1.1046-.796 2-1.7778 2H1.7778z",
    fillRule: "nonzero"
  })));
})(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral([""])));
var Person = styled(function Person(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "person",
    viewBox: "0 0 19 19"
  }), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
    d: "M9.5255 11.2812c5.5833 0 8.3347 2.483 8.3347 6.7844 0 .5161-.4146.9344-.9261.9344-.5115 0-.9261-.4183-.9261-.9344 0-3.22-1.879-4.9156-6.4825-4.9156-4.6036 0-6.4826 1.6956-6.4826 4.9156 0 .5161-.4146.9344-.926.9344-.5115 0-.9262-.4183-.9262-.9344 0-4.3014 2.7515-6.7844 8.3348-6.7844ZM9.5254 0c2.8576 0 4.7627 1.9 4.7627 4.75 0 2.7952-1.7537 4.6355-4.4198 4.7442l-.1578.0044c-.0613.001-.123.0014-.1851.0014-2.8576 0-4.7627-1.9-4.7627-4.75S6.6677 0 9.5254 0Zm0 1.7813c-1.8712 0-2.9767 1.1025-2.9767 2.9687s1.1055 2.9688 2.9767 2.9688l.1582-.0012c1.7829-.0267 2.8185-1.0955 2.8185-2.9676 0-1.8662-1.1055-2.9688-2.9767-2.9688Z"
  })));
})(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral([""])));
var Plus = styled(function Plus(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "plus"
  }), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
    d: "M14.222 1.778a1.778 1.778 0 113.556 0v28.444a1.778 1.778 0 11-3.556 0V1.778zm-12.444 16a1.778 1.778 0 110-3.556h28.444a1.778 1.778 0 110 3.556H1.778z",
    fillRule: "nonzero"
  })));
})(_templateObject23 || (_templateObject23 = _taggedTemplateLiteral([""])));
var Read = styled(function Read(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "read"
  }), /*#__PURE__*/createElement("g", {
    transform: "translate(0 3)"
  }, /*#__PURE__*/createElement("path", {
    d: "M16 0c4.506403 0 8.45159 2.176655 11.80605 5.754745 1.152448 1.229279 2.153283 2.541848 3.001503 3.855221.512491.793535.864259 1.418901 1.051683 1.793749.187685.37537.187685.8172 0 1.19257-.187424.374848-.539192 1.000214-1.051683 1.793749-.84822 1.313373-1.849055 2.625942-3.001503 3.855221C24.45159 21.823345 20.506403 24 16 24c-4.506403 0-8.45159-2.176655-11.80605-5.754745-1.152448-1.229279-2.153283-2.541848-3.001503-3.855221-.512491-.793535-.864259-1.418901-1.051683-1.793749-.187685-.37537-.187685-.8172 0-1.19257.187424-.374848.539192-1.000214 1.051683-1.793749.84822-1.313373 1.849055-2.625942 3.001503-3.855221C7.54841 2.176655 11.493597 0 16 0zm0 2.666667c-3.660263 0-6.965077 1.823345-9.860617 4.911921-1.035051 1.104055-1.940467 2.291485-2.70683 3.478113-.217517.336799-.410435.653125-.57827.943299.167835.290174.360753.6065.57827.943299.766363 1.186628 1.671779 2.374058 2.70683 3.478113C9.034923 19.509988 12.339737 21.333333 16 21.333333c3.660263 0 6.965077-1.823345 9.860617-4.911921 1.035051-1.104055 1.940467-2.291485 2.70683-3.478113.217517-.336799.410435-.653125.57827-.943299-.167835-.290174-.360753-.6065-.57827-.943299-.766363-1.186628-1.671779-2.374058-2.70683-3.478113C22.965077 4.490012 19.660263 2.666667 16 2.666667zm0 4c2.945519 0 5.333333 2.387814 5.333333 5.333333 0 2.945519-2.387814 5.333333-5.333333 5.333333-2.945519 0-5.333333-2.387814-5.333333-5.333333 0-2.945519 2.387814-5.333333 5.333333-5.333333zm0 2.666666c-1.472759 0-2.666667 1.193908-2.666667 2.666667S14.527241 14.666667 16 14.666667 18.666667 13.472759 18.666667 12 17.472759 9.333333 16 9.333333z",
    fillRule: "nonzero"
  })));
})(_templateObject24 || (_templateObject24 = _taggedTemplateLiteral([""])));
var Search = styled(function Search(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "search",
    viewBox: "0 0 19 19"
  }), /*#__PURE__*/createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/createElement("path", {
    d: "M8.2582 15.3987c-3.9436 0-7.1406-3.1969-7.1406-7.1405 0-3.9436 3.197-7.1406 7.1406-7.1406s7.1405 3.197 7.1405 7.1406-3.1969 7.1405-7.1405 7.1405Zm0-1.8628c2.9148 0 5.2777-2.3629 5.2777-5.2777 0-2.9149-2.3629-5.2778-5.2777-5.2778-2.9149 0-5.2778 2.363-5.2778 5.2778s2.363 5.2777 5.2778 5.2777Zm9.3514 2.7565c.3637.3637.3637.9534 0 1.3172-.3638.3637-.9535.3637-1.3172 0l-4.305-4.3051a.9313.9313 0 0 1 1.3171-1.3171l4.3051 4.305Z"
  })));
})(_templateObject25 || (_templateObject25 = _taggedTemplateLiteral([""])));
var Share = styled(function Share(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "share"
  }), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
    d: "M21 0c3 0 6 3 6 6s-3 5-6 5l-3-1-7 4a6 6 0 010 2l7 4 3-1c3 0 6 2 6 5s-3 6-6 6a6 6 0 01-5-7l-7-4-3 2c-3 0-6-3-6-6s3-6 6-6l3 2 7-4V6c0-3 2-6 5-6zm0 22l-2 1v1c0 2 1 3 2 3 2 0 3-1 3-3 0-1-1-2-3-2zM6 13c-2 0-3 1-3 2s1 2 3 2a2 2 0 002-1 2 2 0 000-2l-2-1zM21 3c-1 0-2 1-2 3a2 2 0 000 1 2 2 0 005-1c0-2-1-3-3-3z",
    fillRule: "nonzero"
  })));
})(_templateObject26 || (_templateObject26 = _taggedTemplateLiteral([""])));
var Shipping = styled(function Shipping(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "shipping"
  }), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
    d: "M16.82061.424171L27.729572 5.83782C29.119765 6.523452 29.999176 7.930986 30 9.472451v12.898738c-.000824 1.540746-.880235 2.94828-2.267409 3.632419l-10.908572 5.413456c-.319572.158716-.65486.273417-.997137.344105-.238117.150683-.52204.238831-.826706.238831-.301479 0-.582647-.086314-.819785-.235403-.348888-.069335-.691294-.185426-1.017302-.34734l-10.91273-5.415526C.86153 25.307181-.010404 23.891106.000094 22.356937V9.471646c.001116-1.540721.880527-2.94821 2.267668-3.632332L13.179743.424171c1.146735-.565561 2.494131-.565561 3.640867 0zM2.727 9.984l.000462 12.382269c-.003542.514564.287129.986632.746323 1.216281L13.466 28.541V15.312L2.727 9.984zm24.545 0l-10.738 5.328v13.222l9.98195-4.952943c.463398-.228544.756535-.697722.75681-1.210586L27.272 9.984zM14.396384 2.846722L4.419 7.797l10.56204 5.241808c.00637-.000077.012748-.000116.019136-.000116L15.019 13.039 25.58 7.797l-9.976031-4.950278.003018.001493c-.382245-.18852-.831377-.18852-1.210603-.001493z",
    fillRule: "nonzero"
  })));
})(_templateObject27 || (_templateObject27 = _taggedTemplateLiteral([""])));
var Star$1 = styled(function Star(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "star"
  }), /*#__PURE__*/createElement("g", {
    fill: "transparent",
    stroke: "currentColor",
    strokeWidth: 3
  }, /*#__PURE__*/createElement("path", {
    d: "M11.615 10.463l3.707-7.515a1.25 1.25 0 0 1 2.243 0l3.71 7.514 8.295 1.213a1.25 1.25 0 0 1 .692 2.13l-6.002 5.848 1.417 8.257a1.25 1.25 0 0 1-1.814 1.317l-7.418-3.902-7.42 3.9a1.25 1.25 0 0 1-1.815-1.318l1.417-8.257-6-5.847a1.25 1.25 0 0 1 .69-2.13l8.296-1.213.002.002z"
  })));
})(_templateObject28 || (_templateObject28 = _taggedTemplateLiteral([""])));
var Stopwatch = styled(function Stopwatch(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "stopwatch",
    viewBox: "0 0 32 33"
  }), /*#__PURE__*/createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/createElement("path", {
    d: "M13 6.5a13 13 0 100 26 13 13 0 000-26zm0 3.25a9.75 9.75 0 110 19.5 9.75 9.75 0 010-19.5z"
  }), /*#__PURE__*/createElement("path", {
    d: "M13 13c.83 0 1.52.63 1.61 1.44l.02.19v4.2l1.96 1.96c.58.58.63 1.5.13 2.14l-.13.16c-.59.58-1.51.63-2.15.13l-.15-.13-2.44-2.44a1.63 1.63 0 01-.46-.94l-.02-.21v-4.88c0-.9.73-1.62 1.63-1.62zM13 9.75c-.83 0-1.52-.63-1.61-1.44l-.02-.19v-6.5a1.63 1.63 0 013.24-.18l.02.19v6.5c0 .9-.73 1.62-1.63 1.62z"
  }), /*#__PURE__*/createElement("path", {
    d: "M9.75 3.25A1.63 1.63 0 019.56.01L9.75 0h6.5a1.62 1.62 0 01.19 3.24l-.19.01h-6.5z"
  })));
})(_templateObject29 || (_templateObject29 = _taggedTemplateLiteral([""])));
var Tag = styled(function Tag(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "tag",
    viewBox: "0 0 32 26"
  }), /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("path", {
    d: "M15.57 0H1.73C.77 0 0 .77 0 1.73v13.85c0 .46.18.9.5 1.22l11.9 11.88a4.5 4.5 0 006.36 0l9.93-9.93a4.5 4.5 0 000-6.35L16.8.5c-.32-.32-.76-.5-1.22-.5zM3.47 3.46h11.39l11.38 11.39c.4.4.4 1.05 0 1.46l-9.92 9.92c-.2.2-.46.3-.74.3h-.16a1.04 1.04 0 01-.57-.3L3.46 14.86V3.46z",
    fillRule: "nonzero"
  })));
})(_templateObject30 || (_templateObject30 = _taggedTemplateLiteral([""])));
var TimesCircle$1 = styled(function TimesCircle(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "times-circle"
  }), /*#__PURE__*/createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/createElement("path", {
    d: "M27.314 27.314c-6.249 6.248-16.38 6.248-22.628 0-6.248-6.249-6.248-16.38 0-22.628 6.249-6.248 16.38-6.248 22.628 0 6.248 6.249 6.248 16.38 0 22.628zM24.8 24.8c4.86-4.86 4.86-12.74 0-17.6-4.86-4.86-12.74-4.86-17.6 0-4.86 4.86-4.86 12.74 0 17.6 4.86 4.86 12.74 4.86 17.6 0z"
  }), /*#__PURE__*/createElement("path", {
    d: "M9.767 12.281a1.778 1.778 0 112.514-2.514l9.386 9.386a1.778 1.778 0 11-2.514 2.514l-9.386-9.386zm2.514 9.386a1.778 1.778 0 11-2.514-2.514l9.386-9.386a1.778 1.778 0 112.514 2.514l-9.386 9.386z"
  })));
})(_templateObject31 || (_templateObject31 = _taggedTemplateLiteral([""])));
var Tip = styled(function Tip(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "tip"
  }), /*#__PURE__*/createElement("g", {
    fillRule: "nonzero",
    transform: "translate(5, 6), scale(1.15)"
  }, /*#__PURE__*/createElement("path", {
    d: "M14.5 13c-.3841 0-.7567-.1268-1.056-.3592l-.036-.031-1.012-.8416-.484-.386C9.06 9.0655 7 7.386 7 4.7065 7 2.0272 9 .0002 11.568.0002c1.0876-.0109 2.1377.3832 2.932 1.1004.7926-.7173 1.8416-1.1115 2.928-1.1004 2.564 0 4.568 2.0656 4.572 4.7064 0 2.0502-1.308 3.5328-2.588 4.7103-.636.5907-1.356 1.1815-2.188 1.8648l-.144.1159c-.472.386-.976.7914-1.492 1.2277l-.036.0309c-.3002.2263-.6711.3475-1.052.3437zM11.568 1.9151C10.128 1.9152 9 3.1314 9 4.6912c0 1.7065 1.364 2.8918 4.2 5.2006l.496.4093c.26.2162.532.4362.8.6679.448-.386.884-.7336 1.292-1.0617l.136-.112c.8-.664 1.504-1.2355 2.1-1.7876 1.2-1.0926 1.972-2.0733 1.972-3.3165 0-1.5444-1.132-2.776-2.572-2.776-.8671.008-1.6642.4612-2.092 1.1892-.1854.266-.496.4252-.828.4247-.3335.0018-.6458-.1576-.832-.4247-.43-.7316-1.2326-1.1853-2.104-1.1892zM5.0146 21.2961a1.2488 1.2488 0 011.1828 0c3.3795 1.7748 5.0308 1.7785 5.6606 1.6612 0 0 5.1153-.1665 10.3688-4.9761l.4224-.4163c.3803-.3749.4604-.9536.1959-1.4152-.2086-.3605-.5622-.6172-.9735-.7066a1.5078 1.5078 0 00-1.1848.2373l-1.636.9045a26.9317 26.9317 0 00-3.122 1.9866c-1.8777 1.5265-4.5682 1.5998-6.5286.1779 2.3503.8136 4.6084.1551 5.6376-.6698.9332-.7266.8986-1.6007-.9063-1.718-2.7766-.1854-3.6368-.6812-3.9018-.9801a3.161 3.161 0 00-.8333-.6925C5.6636 12.6229 2 15.862 2 15.862l.2112.3785 2.3772 4.3517.384.6736a.0502.0502 0 00.0576.0227"
  }), /*#__PURE__*/createElement("path", {
    d: "M2.187 16L5 21.5674 2.8633 23 0 17.2113z"
  })));
})(_templateObject32 || (_templateObject32 = _taggedTemplateLiteral([""])));
var Unread = styled(function Unread(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "unread"
  }), /*#__PURE__*/createElement("g", {
    transform: "translate(0 1)"
  }, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.520699 1.39961C-0.173566 2.09387 -0.173566 3.2195 0.520699 3.91376L5.74707 9.14013C3.50862 11.1343 1.63348 13.5092 0.211279 16.1596C-0.0618479 16.6686 -0.0706466 17.2785 0.187685 17.7952C0.376978 18.1738 0.726684 18.7955 1.23387 19.5808C2.07127 20.8774 3.05912 22.173 4.19799 23.3878C7.53424 26.9464 11.4763 29.1214 16 29.1214C18.6875 29.0776 21.2837 28.3165 23.5378 26.9309L28.9651 32.3582C29.6594 33.0525 30.785 33.0525 31.4793 32.3582C32.1736 31.6639 32.1736 30.5383 31.4793 29.844L3.03486 1.39961C2.34059 0.70534 1.21496 0.70534 0.520699 1.39961ZM10.9578 14.3509L8.26609 11.6592C6.51064 13.194 5.00855 14.998 3.81663 17.0046C3.93285 17.1979 4.06764 17.4149 4.22068 17.6518C4.94893 18.7795 5.80956 19.9081 6.7919 20.956C9.51626 23.862 12.6045 25.5658 15.9709 25.5661C17.7061 25.5377 19.4018 25.1083 20.9295 24.3225L18.6493 22.0424C17.4052 22.733 15.9243 22.9404 14.5036 22.5776C12.4994 22.0657 10.9344 20.5008 10.4226 18.4966C10.0597 17.0758 10.2672 15.595 10.9578 14.3509ZM13.8046 17.1977C13.8113 17.3376 13.8321 17.478 13.8676 17.6168C14.0577 18.3612 14.639 18.9425 15.3834 19.1326C15.5222 19.168 15.6626 19.1888 15.8025 19.1956L13.8046 17.1977ZM27.7793 16.3485C27.0511 15.2209 26.1904 14.0922 25.2081 13.0443C22.4837 10.1384 19.3955 8.4345 15.9958 8.43449C15.2196 8.43267 14.4458 8.5211 13.69 8.69801C12.734 8.92179 11.7776 8.3282 11.5539 7.3722C11.3301 6.4162 11.9237 5.45981 12.8797 5.23604C13.9038 4.99631 14.9524 4.87648 16 4.87894C20.5237 4.87894 24.4658 7.05388 27.802 10.6125C28.9409 11.8273 29.9287 13.1229 30.7661 14.4195C31.2733 15.2048 31.623 15.8265 31.8123 16.2051C32.0702 16.7209 32.0619 17.3297 31.7901 17.8382C30.9469 19.4156 29.9414 20.9007 28.7898 22.2692C28.1576 23.0205 27.0361 23.117 26.2849 22.4849C25.5336 21.8527 25.4371 20.7312 26.0692 19.98C26.8556 19.0454 27.563 18.0477 28.1844 16.9974C28.0679 16.8036 27.9328 16.5861 27.7793 16.3485Z"
  })));
})(_templateObject33 || (_templateObject33 = _taggedTemplateLiteral([""])));

var Stroke = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Alert: Alert$1,
  ArrowLeft: ArrowLeft,
  ArrowRight: ArrowRight,
  Bubble: Bubble,
  Bulb: Bulb,
  Calendar: Calendar,
  CaretDown: CaretDown$1,
  CaretUp: CaretUp,
  Chain: Chain,
  Check: Check$1,
  CheckCircle: CheckCircle$1,
  Close: Close,
  CodeBlock: CodeBlock,
  Edit: Edit,
  Hash: Hash,
  Heart: Heart$1,
  Letter: Letter,
  Link: Link,
  Lock: Lock,
  MapCursor: MapCursor,
  Minus: Minus,
  Person: Person,
  Plus: Plus,
  Read: Read,
  Search: Search,
  Share: Share,
  Shipping: Shipping,
  Star: Star$1,
  Stopwatch: Stopwatch,
  Tag: Tag,
  TimesCircle: TimesCircle$1,
  Tip: Tip,
  Unread: Unread
});

var _templateObject$9, _templateObject2$6, _templateObject3$6, _templateObject4$4, _templateObject5$3, _templateObject6$3, _templateObject7$2, _templateObject8$2, _templateObject9$2, _templateObject10$2, _templateObject11$1, _templateObject12$1;
var Bandcamp = styled(function Bandcamp(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "bandcamp"
  }), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
    d: "M15.0289765,20.3975208 C15.288459,19.6381309 15.3059426,18.8657394 15.1157444,18.0894476 C14.9953095,17.5976147 14.7746947,17.1540585 14.4040152,16.8012047 C13.8112839,16.2369741 13.0905906,16.0522502 12.299039,16.1663897 C11.7510603,16.2454251 11.2972397,16.5172932 10.975658,16.983431 C10.9697731,16.9919846 10.9589955,16.997151 10.9384669,17.0134713 L10.9384669,14.1554348 L10.8385948,14.1554348 L9.76819548,14.1554348 C9.78160755,14.1681626 9.78331827,14.1896493 9.77507259,14.2061064 C9.78215498,14.1919759 9.7748673,14.2073724 9.77394351,14.2095279 C9.77230122,14.2133599 9.77031678,14.2168156 9.76792177,14.2200317 C9.76922192,14.241621 9.75608356,14.2642026 9.72826721,14.2642026 C9.71276806,14.2642026 9.70195629,14.2571202 9.69545554,14.247198 C9.70089564,14.8441035 9.7100309,19.473354 9.7100309,21.8664502 L10.8779073,21.8664502 L10.8779073,21.1059996 C10.8936117,21.1147927 10.8990518,21.1161271 10.9016179,21.1195827 C10.9077081,21.12776 10.9127376,21.1367584 10.9176302,21.1457568 C11.0702952,21.4269997 11.2932366,21.6356394 11.5798169,21.7741396 C12.0261103,21.9898275 12.5030256,22.0350248 12.989829,22.0128196 C13.4141225,21.9934542 13.8054333,21.8698374 14.1528811,21.6221589 C14.5843254,21.3145367 14.8601282,20.8915091 15.0289765,20.3975208 Z M26.8552044,9.00273725 L27,9.00273725 C26.9956205,9.00697984 26.9916517,9.01176986 26.9887092,9.01762053 C26.9869643,9.02111041 26.9856641,9.02480557 26.9840903,9.02839809 C26.983406,9.02921924 26.982927,9.02997195 26.9823453,9.03075889 C26.9782054,9.03616477 26.9752287,9.04232337 26.9732101,9.04892677 C26.9731759,9.04885834 26.9731759,9.04848198 26.9731416,9.04848198 C26.9107687,9.16026062 26.8468561,9.27125232 26.7863649,9.38402318 C25.8197722,11.184867 24.8541718,12.9862583 23.8872369,14.7869311 C22.868912,16.6833702 21.8500738,18.5796039 20.8322963,20.4763509 C20.9157111,20.2548807 20.9727808,20.0222224 21.0126749,19.7806683 C20.9926937,19.7772126 20.9829083,19.7740649 20.973123,19.7740307 C20.5937873,19.7736885 20.2144174,19.7741675 19.8350816,19.7726963 C19.7862918,19.772491 19.7774645,19.7963385 19.7701084,19.8378064 C19.7202921,20.1180571 19.6213439,20.3775053 19.4404863,20.6018837 C19.0336421,21.1067181 18.3088088,21.151847 17.8186525,20.9047844 C17.4621378,20.7251242 17.2489133,20.4194523 17.1241674,20.0515442 C16.9121404,19.4259328 16.927229,18.793718 17.1062048,18.1643088 C17.2048109,17.8175453 17.3909375,17.5242247 17.7013995,17.3255756 C18.0052239,17.131169 18.3404914,17.0833714 18.6951243,17.1143697 C19.2554545,17.1633648 19.6688678,17.5291858 19.7680897,18.0808255 C19.7787989,18.1404271 19.7997039,18.154763 19.8565341,18.1543866 C20.2177704,18.1520258 20.5791093,18.1532575 20.9403797,18.153018 C20.9626534,18.1529838 20.9848928,18.1503835 21.0090482,18.1488781 C21.0090482,18.1294443 21.0103141,18.1164428 21.0087745,18.1038176 C21.0047029,18.0705954 20.9994681,18.0374758 20.9946097,18.0043904 C20.8826942,17.2419554 20.4755079,16.697227 19.7728113,16.3860807 C19.124071,16.0988161 18.4452903,16.0634726 17.7588114,16.2151111 C16.9976081,16.3832409 16.4408704,16.8253944 16.0897274,17.5214191 C15.8911467,17.9151249 15.79148,18.3366813 15.7572997,18.7749685 C15.7149422,19.3183283 15.757026,19.8520397 15.9508509,20.3656329 C16.2182711,21.0741117 16.6941601,21.5824702 17.4117399,21.8455109 C17.9190035,22.0314665 18.4433743,22.0597961 18.9744853,21.9790842 C19.6030392,21.8835232 20.1251518,21.6053596 20.5036322,21.0888239 C20.3499408,21.37537 20.1959758,21.6617793 20.0423186,21.9483938 C20.0028009,22.0221602 19.9554481,22.0378646 19.8801421,22.0376935 C19.097589,22.0356407 18.3150359,22.0364276 17.5324827,22.0364276 C13.4101194,22.0364276 9.28775604,22.0363934 5.1653927,22.0367697 C5.1102732,22.0367697 5.05511949,22.0419703 5,22.0447075 L5,22.0190467 C5.25643737,21.547024 5.51485918,21.0760277 5.76907262,20.6028418 C7.38269495,17.5996676 8.99532506,14.5960144 10.6083315,11.5924981 C11.0484321,10.7729592 11.4900724,9.95427557 11.9268542,9.13295748 C11.9764651,9.03962043 12.0292922,8.99993166 12.140455,9.00000009 C17.0454057,9.00314782 21.9502879,9.00273725 26.8552044,9.00273725 Z M12.5796695,17.1104282 C13.1772934,17.1578494 13.5574845,17.5071791 13.7942143,18.0311051 C14.0150687,18.5199271 14.0518834,19.0345467 13.9728822,19.5601493 C13.9280613,19.8581572 13.8400617,20.1422056 13.6764482,20.3980614 C13.3648229,20.8853437 12.907136,21.0846429 12.3442055,21.0413959 C11.6422617,20.9874054 11.2389417,20.5624618 11.02298,19.9268598 C10.9809988,19.8033114 10.951506,19.6738781 10.9321748,19.5447528 C10.9084984,19.3871952 10.9016213,19.2271399 10.894402,19.1459832 C10.901416,18.6566138 10.9556801,18.2566468 11.1435517,17.8839145 C11.4395068,17.2968286 11.987554,17.0634517 12.5796695,17.1104282 Z"
  })));
})(_templateObject$9 || (_templateObject$9 = _taggedTemplateLiteral([""])));
var Facebook = styled(function Facebook(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "social-facebook"
  }), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
    d: "M26.676,4 L5.324,4 C4.593,4 4,4.593 4,5.324 L4,26.676 C4,27.408 4.593,28 5.324,28 L16.818,28 L16.818,18.706 L13.689,18.706 L13.689,15.085 L16.818,15.085 L16.818,12.41 C16.818,9.311 18.712,7.625 21.477,7.625 C22.802,7.625 23.941,7.722 24.273,7.766 L24.273,11.006 L22.352,11.006 C20.852,11.006 20.56,11.727 20.56,12.777 L20.56,15.088 L24.144,15.088 L23.679,18.718 L20.56,18.718 L20.56,28 L26.675,28 C27.408,28 28,27.408 28,26.676 L28,5.324 C28,4.593 27.408,4 26.676,4"
  })));
})(_templateObject2$6 || (_templateObject2$6 = _taggedTemplateLiteral([""])));
var Instagram = styled(function Instagram(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "social-instagram"
  }), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
    d: "M16,4 C12.74,4 12.333,4.015 11.053,4.072 C9.775,4.132 8.905,4.333 8.14,4.63 C7.351,4.936 6.681,5.347 6.014,6.014 C5.347,6.681 4.935,7.35 4.63,8.14 C4.333,8.905 4.131,9.775 4.072,11.053 C4.012,12.333 4,12.74 4,16 C4,19.26 4.015,19.667 4.072,20.947 C4.132,22.224 4.333,23.095 4.63,23.86 C4.936,24.648 5.347,25.319 6.014,25.986 C6.681,26.652 7.35,27.065 8.14,27.37 C8.906,27.666 9.776,27.869 11.053,27.928 C12.333,27.988 12.74,28 16,28 C19.26,28 19.667,27.985 20.947,27.928 C22.224,27.868 23.095,27.666 23.86,27.37 C24.648,27.064 25.319,26.652 25.986,25.986 C26.652,25.319 27.065,24.651 27.37,23.86 C27.666,23.095 27.869,22.224 27.928,20.947 C27.988,19.667 28,19.26 28,16 C28,12.74 27.985,12.333 27.928,11.053 C27.868,9.776 27.666,8.904 27.37,8.14 C27.064,7.351 26.652,6.681 25.986,6.014 C25.319,5.347 24.651,4.935 23.86,4.63 C23.095,4.333 22.224,4.131 20.947,4.072 C19.667,4.012 19.26,4 16,4 Z M16,6.16 C19.203,6.16 19.585,6.176 20.85,6.231 C22.02,6.286 22.655,6.48 23.077,6.646 C23.639,6.863 24.037,7.123 24.459,7.542 C24.878,7.962 25.138,8.361 25.355,8.923 C25.519,9.345 25.715,9.98 25.768,11.15 C25.825,12.416 25.838,12.796 25.838,16 C25.838,19.204 25.823,19.585 25.764,20.85 C25.703,22.02 25.508,22.655 25.343,23.077 C25.119,23.639 24.864,24.037 24.444,24.459 C24.025,24.878 23.62,25.138 23.064,25.355 C22.644,25.519 21.999,25.715 20.829,25.768 C19.555,25.825 19.18,25.838 15.97,25.838 C12.759,25.838 12.384,25.823 11.111,25.764 C9.94,25.703 9.295,25.508 8.875,25.343 C8.306,25.119 7.915,24.864 7.496,24.444 C7.075,24.025 6.806,23.62 6.596,23.064 C6.431,22.644 6.237,21.999 6.176,20.829 C6.131,19.569 6.115,19.18 6.115,15.985 C6.115,12.789 6.131,12.399 6.176,11.124 C6.237,9.954 6.431,9.31 6.596,8.89 C6.806,8.32 7.075,7.93 7.496,7.509 C7.915,7.09 8.306,6.82 8.875,6.611 C9.295,6.445 9.926,6.25 11.096,6.19 C12.371,6.145 12.746,6.13 15.955,6.13 L16,6.16 Z M16,9.838 C12.595,9.838 9.838,12.598 9.838,16 C9.838,19.405 12.598,22.162 16,22.162 C19.405,22.162 22.162,19.402 22.162,16 C22.162,12.595 19.402,9.838 16,9.838 Z M16,20 C13.79,20 12,18.21 12,16 C12,13.79 13.79,12 16,12 C18.21,12 20,13.79 20,16 C20,18.21 18.21,20 16,20 Z M23.846,9.595 C23.846,10.39 23.2,11.035 22.406,11.035 C21.611,11.035 20.966,10.389 20.966,9.595 C20.966,8.801 21.612,8.156 22.406,8.156 C23.199,8.155 23.846,8.801 23.846,9.595 Z"
  })));
})(_templateObject3$6 || (_templateObject3$6 = _taggedTemplateLiteral([""])));
var LinkedIn = styled(function LinkedIn(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "social-linkedin"
  }), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
    d: "M24.447,24.452 L20.893,24.452 L20.893,18.883 C20.893,17.555 20.866,15.846 19.041,15.846 C17.188,15.846 16.905,17.291 16.905,18.785 L16.905,24.452 L13.351,24.452 L13.351,13 L16.765,13 L16.765,14.561 L16.811,14.561 C17.288,13.661 18.448,12.711 20.181,12.711 C23.782,12.711 24.448,15.081 24.448,18.166 L24.448,24.452 L24.447,24.452 Z M9.337,11.433 C8.193,11.433 7.274,10.507 7.274,9.368 C7.274,8.23 8.194,7.305 9.337,7.305 C10.477,7.305 11.401,8.23 11.401,9.368 C11.401,10.507 10.476,11.433 9.337,11.433 Z M11.119,24.452 L7.555,24.452 L7.555,13 L11.119,13 L11.119,24.452 Z M26.225,4 L5.771,4 C4.792,4 4,4.774 4,5.729 L4,26.271 C4,27.227 4.792,28 5.771,28 L26.222,28 C27.2,28 28,27.227 28,26.271 L28,5.729 C28,4.774 27.2,4 26.222,4 L26.225,4 Z"
  })));
})(_templateObject4$4 || (_templateObject4$4 = _taggedTemplateLiteral([""])));
var Messenger = styled(function Messenger(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "social-messenger"
  }), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
    d: "M16,4 C9.373,4 4,8.974 4,15.111 C4,18.609 5.744,21.725 8.469,23.765 L8.469,28 L12.557,25.758 C13.649,26.058 14.803,26.222 16,26.222 C22.627,26.222 28,21.247 28,15.112 C28,8.977 22.627,4 16,4 Z M17.191,18.963 L14.136,15.703 L8.173,18.963 L14.732,12 L17.863,15.259 L23.752,12 L17.191,18.963 Z"
  })));
})(_templateObject5$3 || (_templateObject5$3 = _taggedTemplateLiteral([""])));
var Soundcloud = styled(function Soundcloud(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "soundcloud"
  }), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
    d: "M13.7353365,13.7672309 C13.7353399,12.7849642 13.7353456,11.8026952 13.7353456,10.820432 C13.7353456,10.8009591 13.7360232,10.781463 13.7352639,10.7620252 C13.7287457,10.5939188 13.8056908,10.4768249 13.9593473,10.4154628 C14.1089621,10.355736 14.2601421,10.298474 14.4140556,10.251258 C15.0812595,10.0466241 15.7641748,9.96117495 16.4602316,10.0164511 C17.9490201,10.1346781 19.2011911,10.7468511 20.206173,11.8508792 C20.8779326,12.588837 21.3128294,13.4530235 21.5174984,14.4303323 C21.558056,14.6240675 21.5791876,14.8218679 21.6092204,15.0178109 C21.6121407,15.0368515 21.6147106,15.0559505 21.6161941,15.0662885 C21.8337593,15.0080219 22.0443391,14.9344995 22.2611567,14.8965001 C23.2610455,14.7212681 24.1541784,14.9627917 24.9223092,15.626608 C25.4970551,16.1232875 25.8435124,16.7570944 25.9608983,17.5075629 C26.2219298,19.176069 25.1481214,20.6990839 23.5734283,21.0758192 C23.3301407,21.1340157 23.0833488,21.1612333 22.8331342,21.1611048 C19.9365206,21.1595745 17.0398954,21.1584531 14.1432819,21.1572499 C13.8940952,21.1571448 13.7354157,20.9985821 13.7354041,20.7484026 C13.735383,20.4042556 13.7353673,20.0601082 13.7353556,19.7159606 C13.7106454,20.1075538 13.6866923,20.4992165 13.6603104,20.8906569 C13.6498672,21.0455957 13.5433917,21.1571308 13.4183311,21.1536499 C13.2884345,21.1500485 13.1924838,21.0341088 13.1835826,20.8751804 C13.1464243,20.2119409 13.1081678,19.5487684 13.0704371,18.8855692 C13.0501816,18.5295031 13.0195414,18.1736511 13.0131167,17.8172235 C13.007054,17.4808645 13.0260713,17.143903 13.0349958,16.807236 C13.0537911,16.0981964 13.0732406,15.3891701 13.0922345,14.6801305 C13.0931923,14.6445051 13.092363,14.6088128 13.092363,14.5731473 L13.0961944,14.5731473 C13.1136347,13.9310073 13.1311334,13.2888673 13.1484919,12.6467273 C13.1604652,12.2030236 13.1717845,11.7592931 13.1843303,11.3156162 C13.1887341,11.1601017 13.2927916,11.0412568 13.4217771,11.0406409 C13.5520476,11.0400117 13.6557663,11.1595795 13.6615486,11.3207839 C13.6698657,11.5525696 13.676454,11.7844491 13.6833694,12.0163017 C13.7007879,12.5999399 13.7179813,13.1835879 13.7353365,13.7672309 Z M12.0594404,15.6467628 C12.0914006,14.7675891 12.1232907,13.8884153 12.1554028,13.00923 C12.1600519,12.8817864 12.2530589,12.7873076 12.372162,12.7877398 C12.4909964,12.7881837 12.582952,12.8827092 12.5881619,13.0108069 C12.6200169,13.7964714 12.6513463,14.5821592 12.6835284,15.367812 C12.7204766,16.2701499 12.7624126,17.1723125 12.7924571,18.0748723 C12.8000616,18.3033011 12.7739187,18.5331902 12.7576466,18.7620045 C12.7307678,19.140457 12.6992632,19.5185941 12.6697795,19.896883 C12.6422699,20.2499403 12.6157299,20.6030909 12.5868652,20.956043 C12.5770996,21.0754732 12.4786609,21.1616115 12.3632841,21.158072 C12.2510847,21.154626 12.1637783,21.0651352 12.155578,20.9458102 C12.1005238,20.1440254 12.0511116,19.3417968 11.9877286,18.5406779 C11.9571702,18.1543522 11.987273,17.7704679 11.997541,17.3856958 C12.0109395,16.8837363 12.0332041,16.3820105 12.0507028,15.8801562 C12.0534012,15.8024752 12.0510766,15.7246073 12.0510766,15.6468095 C12.0538568,15.6467978 12.0566603,15.6467744 12.0594404,15.6467628 Z M11.0329871,16.1197665 C11.0657533,15.419773 11.0983559,14.7197562 11.1315777,14.0197862 C11.1332248,13.9849991 11.1357596,13.9490906 11.1458056,13.9161142 C11.1726376,13.82799 11.2612174,13.7706463 11.347344,13.7809843 C11.4450001,13.792724 11.5166769,13.8700663 11.5236039,13.9757475 C11.5325051,14.1117068 11.5389999,14.2478179 11.5462073,14.3838706 C11.5866599,15.1497235 11.6266568,15.9155881 11.6675416,16.6814176 C11.692563,17.1498516 11.7262287,17.6179701 11.741356,18.0867078 C11.7483415,18.303502 11.7238457,18.5216864 11.7074217,18.7387726 C11.6807064,19.0919233 11.6485827,19.4446651 11.6193209,19.7976172 C11.5871622,20.1854849 11.5561949,20.5734577 11.5235338,20.9612786 C11.5142822,21.0710483 11.4321039,21.1515679 11.3319479,21.1541378 C11.2324929,21.1566726 11.1460976,21.0790383 11.1365423,20.9678435 C11.1155742,20.7235514 11.099197,20.4788621 11.0811142,20.234313 C11.0475537,19.7801653 11.014075,19.3259943 10.9806312,18.8718232 C10.9646044,18.6544333 10.9408329,18.4372535 10.935331,18.2195949 C10.9309621,18.0468627 10.948893,17.8735465 10.9571517,17.7004989 C10.9789491,17.2435828 11.0008633,16.7866666 11.0227542,16.3297505 C11.0260951,16.2597441 11.0295527,16.1897611 11.0329871,16.1197665 Z M9.90894182,18.2115382 C9.92293608,18.0367268 9.9375845,17.8505611 9.95281699,17.6644304 C9.98218391,17.3057427 10.0118429,16.9470785 10.0414317,16.5884142 C10.0686259,16.2588131 10.095236,15.929177 10.1235516,15.5996694 C10.1315884,15.5061017 10.2043399,15.43842 10.2920201,15.4368664 C10.3769202,15.4353595 10.4526621,15.4979482 10.4625679,15.5897402 C10.4882201,15.8275843 10.5095152,16.0659072 10.5318967,16.3041017 C10.5697443,16.7069332 10.6071363,17.1097997 10.6446451,17.5126546 C10.6654029,17.7353946 10.6929826,17.9578076 10.7039864,18.1810382 C10.7101542,18.3063207 10.6904711,18.4331218 10.6795607,18.5589884 C10.6426243,18.9853461 10.6043211,19.4115871 10.5666838,19.8378864 C10.5345133,20.2021811 10.5025298,20.5664991 10.4704411,20.9308055 C10.4701024,20.934672 10.4695066,20.9385268 10.4690043,20.9423817 C10.4533163,21.0620805 10.3881226,21.1321336 10.2931649,21.1313743 C10.1953569,21.1305917 10.1306305,21.0585644 10.1208182,20.9345902 C10.0816623,20.4400368 10.0434993,19.9454249 10.0049859,19.4508247 C9.9738551,19.0512757 9.94274766,18.651715 9.91164021,18.2521543 C9.91089261,18.2424471 9.91034358,18.2327282 9.90894182,18.2115382 Z M9.67620487,18.2169339 C9.66025982,18.3878437 9.64439655,18.5602255 9.62805433,18.7325722 C9.5948092,19.0830595 9.56109681,19.4335118 9.52799186,19.7840342 C9.49195488,20.1655355 9.4569225,20.5471303 9.42023137,20.9285732 C9.41096806,21.0249443 9.34557584,21.0887829 9.26457734,21.0865635 C9.18194344,21.0842973 9.12539401,21.0220707 9.1170068,20.9218447 C9.06621628,20.3150568 9.01578787,19.7082572 8.96525434,19.1014693 C8.94183322,18.8203575 8.91070242,18.5395962 8.89807487,18.2580172 C8.89106606,18.1016623 8.91312046,17.9437654 8.92532747,17.7868264 C8.95366643,17.422193 8.98395618,17.0577231 9.01352169,16.6931831 C9.04841389,16.2627135 9.08296734,15.8322089 9.11865387,15.4018094 C9.12554587,15.3184513 9.18444325,15.2605702 9.25981135,15.2571709 C9.33823995,15.2536315 9.40284952,15.3010578 9.41411034,15.3859111 C9.43301077,15.5284704 9.44368753,15.6721393 9.4569225,15.8154345 C9.49485186,16.2260691 9.53244245,16.6367388 9.56992792,17.0474084 C9.60547428,17.4367713 9.64071692,17.8261692 9.67620487,18.2169339 Z M8.65145113,18.2178462 C8.63437299,18.3838382 8.61693273,18.5541173 8.59932893,18.724373 C8.56231072,19.0823364 8.52505889,19.4402648 8.48818085,19.7982515 C8.4523191,20.1465428 8.41722831,20.4949275 8.38082921,20.843172 C8.3720682,20.9269623 8.31744619,20.9817712 8.2488416,20.9809535 C8.1808094,20.9801475 8.13048613,20.9310274 8.12214564,20.8462091 C8.09474119,20.5674219 8.07001176,20.2883544 8.04449969,20.0093803 C8.00676891,19.5967248 7.96924841,19.1840576 7.93161109,18.7713905 C7.91517542,18.5912056 7.88840176,18.4112076 7.88532956,18.2308008 C7.8827363,18.0779152 7.90696343,17.9245391 7.92028017,17.7714549 C7.95352531,17.3896382 7.98742459,17.0078799 8.02086831,16.6260749 C8.0534476,16.2539537 8.08573486,15.8818091 8.1182908,15.5096879 C8.11948229,15.4961375 8.12176016,15.4826573 8.12411979,15.4692354 C8.13602309,15.4017288 8.18257328,15.3563117 8.2432696,15.3527489 C8.3066059,15.3490109 8.36218577,15.3900008 8.37436943,15.4614322 C8.38904121,15.5475121 8.39569958,15.6350405 8.4043905,15.7220783 C8.46662876,16.3453719 8.52859834,16.9686773 8.59042774,17.5920177 C8.61097524,17.7991397 8.63084522,18.0063436 8.65145113,18.2178462 Z M6.88206718,18.2180635 C6.89162252,18.1264583 6.90308193,18.0124599 6.91548753,17.8985784 C6.96078782,17.4829559 7.0063451,17.0673684 7.05192574,16.6517809 C7.07886294,16.4062855 7.10568333,16.1607785 7.13332141,15.915365 C7.14066898,15.8500428 7.18035054,15.8091114 7.23496086,15.8063663 C7.29340268,15.8034226 7.33656528,15.839039 7.34628416,15.9102135 C7.37442454,16.1163193 7.39917733,16.3228923 7.42493472,16.5293135 C7.47764098,16.9518515 7.53009026,17.3744127 7.58277316,17.7969507 C7.59937237,17.930083 7.62670673,18.0629 7.63000088,18.1963361 C7.63276936,18.307858 7.60877586,18.4202326 7.59464142,18.5319765 C7.53854756,18.9756226 7.4815776,19.4191519 7.42512162,19.8627513 C7.40033379,20.0575495 7.37604825,20.2524062 7.35137723,20.4472278 C7.34991706,20.4587807 7.3473238,20.4702401 7.34466046,20.4815827 C7.33018726,20.5431668 7.29035384,20.5773581 7.2359421,20.575162 C7.18323583,20.5730477 7.1425964,20.53381 7.13412742,20.4729385 C7.12503933,20.4074762 7.11839264,20.3416517 7.11103339,20.2759441 C7.0451856,19.6885005 6.97936117,19.1010453 6.91370028,18.5135783 C6.90354919,18.4227441 6.89421578,18.3318165 6.88206718,18.2180635 Z M6,18.2176067 C6.0205475,18.058495 6.04033571,17.9022452 6.06096498,17.7461122 C6.10246883,17.4318838 6.14468524,17.1177489 6.18595547,16.8034971 C6.19243862,16.7540967 6.2084888,16.7123475 6.25954799,16.6946386 C6.3212489,16.6732383 6.37921178,16.7118686 6.39294905,16.7874586 C6.4110201,16.886902 6.42513118,16.9870579 6.44060897,17.0869568 C6.49687805,17.45006 6.55718888,17.8126259 6.60612207,18.176722 C6.61760484,18.2622645 6.59411364,18.353566 6.58049318,18.4412579 C6.52048607,18.8273617 6.45807259,19.2130917 6.3968623,19.5990202 C6.38888394,19.6492968 6.37409534,19.6941648 6.32040784,19.7132288 C6.25755048,19.7355285 6.19822089,19.6922024 6.18729882,19.6138906 C6.16341045,19.4424901 6.1406435,19.2709377 6.11764291,19.0994087 C6.07992382,18.81804 6.04237995,18.5366478 6.00477767,18.2552674 C6.00297875,18.2417871 6.00135504,18.2282835 6,18.2176067 Z"
  })));
})(_templateObject6$3 || (_templateObject6$3 = _taggedTemplateLiteral([""])));
var Spotify = styled(function Spotify(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "spotify"
  }), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
    d: "M23.8578156,14.5542691 C24.3521936,17.4379229 23.5095811,19.911643 21.3762524,21.9126843 C20.1208303,23.0907209 18.605801,23.7529417 16.8912949,23.945621 C16.661753,23.9712419 16.4306424,23.9819608 16.2003161,24 L15.7990098,24 C14.7211036,23.964706 13.682936,23.7437914 12.704376,23.2891519 C10.7888247,22.3984349 9.41392572,20.977523 8.59562686,19.026939 C8.21680416,18.1241959 8.03562809,17.1772699 8.00033405,16.2010629 C7.99536674,15.514267 8.0447784,14.8316541 8.2170656,14.1649889 C8.92425359,11.4340145 10.5883022,9.5378095 13.215486,8.51062222 C14.5707772,7.98016586 15.9786172,7.87898961 17.4105095,8.1331067 C20.6884108,8.71506621 23.297294,11.2839495 23.8578156,14.5542691 Z M21.7676241,14.8125692 C21.9694537,14.4468183 21.8397808,14.0112637 21.4630496,13.7911335 C20.9054038,13.4648597 20.3179541,13.2028995 19.7064522,12.9961026 C18.1333837,12.4640776 16.5106422,12.245516 14.7689467,12.2353199 C14.4507774,12.2444702 14.0460724,12.2470846 13.6421517,12.2776728 C12.7537877,12.3448622 11.8771883,12.4800253 11.0215039,12.7336195 C10.8353605,12.7887828 10.687387,12.8964949 10.5856879,13.0640763 C10.4264725,13.3265594 10.4424202,13.6593691 10.6256878,13.903813 C10.8199357,14.1634203 11.1279089,14.2604135 11.4727447,14.1594987 C12.3354879,13.9072117 13.2191461,13.7900878 14.1135233,13.7477349 C15.120057,13.6998919 16.1224077,13.7493035 17.1190069,13.903813 C18.3877622,14.1006753 19.607106,14.446034 20.7294565,15.0912614 C21.1103706,15.3103459 21.5642259,15.1809344 21.7676241,14.8125692 Z M20.6476266,17.3600146 C20.8238353,17.0750479 20.7433126,16.7058984 20.4544244,16.5163563 C20.1942942,16.3451148 19.917955,16.2021086 19.6369098,16.0692984 C18.0638414,15.3244635 16.3990084,15.0005426 14.6664632,14.9908694 C14.1631963,14.9856407 13.662021,15.0183204 13.1631985,15.0815882 C12.585422,15.1553135 12.0154886,15.2695616 11.45915,15.4439403 C11.1373206,15.5448551 10.9574517,15.8591028 11.0290856,16.1749191 C11.1009808,16.4923041 11.3971893,16.6980552 11.7294762,16.6523037 C11.8343126,16.6379246 11.9360117,16.601062 12.0387566,16.5733496 C13.3527406,16.219102 14.6855481,16.1623701 16.0306432,16.3291672 C17.3715553,16.4951799 18.6424022,16.8755712 19.8084127,17.5754389 C20.1009611,17.7513863 20.4701106,17.6473342 20.6476266,17.3600146 Z M19.6667137,19.5388333 C19.8233146,19.285762 19.7352103,18.9932136 19.4536423,18.8243251 C18.2371743,18.0936077 16.9119485,17.7158308 15.5025398,17.6206676 C14.2369217,17.5351776 12.9906499,17.6763537 11.7579729,17.9592289 C11.4683003,18.025634 11.3012418,18.2724309 11.3577123,18.5388355 C11.4191501,18.8287695 11.6682999,18.9919064 11.9665999,18.9286386 C12.6539186,18.7827565 13.3451589,18.6666784 14.047641,18.6211883 C15.7914281,18.5085088 17.4489408,18.7822337 18.9678917,19.6956957 C19.0528588,19.746676 19.1433161,19.7814472 19.2455381,19.777787 C19.4267142,19.7704668 19.5705047,19.6941271 19.6667137,19.5388333 Z"
  })));
})(_templateObject7$2 || (_templateObject7$2 = _taggedTemplateLiteral([""])));
var Twitch = styled(function Twitch(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "twitch"
  }), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
    d: "M31 0v19.3c0 .12-.04.2-.12.29l-8.2 8.09c-.1.1-.2.14-.34.14h-5.95a.42.42 0 00-.33.13l-3.96 3.92a.39.39 0 01-.3.13H7.95c-.2 0-.2 0-.2-.2v-3.86c0-.13-.02-.13-.19-.13H0V5.72c0-.08.02-.15.04-.22L2.13 0zm-2.82 2.78H5.12c-.2 0-.2 0-.2.2v19.98l.23.01h5.92c.15 0 .2.04.2.19l-.01 3.78v.2l.14-.13 3.95-3.9c.1-.1.2-.14.34-.14h7.36c.14 0 .23-.03.33-.13l4.7-4.64c.08-.08.1-.16.1-.26V2.78zm-4.96 5.6v8.3h-2.78v-8.3h2.78zm-7.74 0v8.3H12.7v-8.3h2.78z"
  })));
})(_templateObject8$2 || (_templateObject8$2 = _taggedTemplateLiteral([""])));
var Twitter = styled(function Twitter(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "social-twitter"
  }), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
    d: "M27.954,8.569 C27.069,8.958 26.124,9.223 25.129,9.344 C26.143,8.733 26.923,7.77 27.292,6.621 C26.341,7.176 25.287,7.58 24.165,7.805 C23.269,6.846 21.992,6.246 20.574,6.246 C17.857,6.246 15.654,8.449 15.654,11.163 C15.654,11.553 15.699,11.928 15.781,12.287 C11.691,12.094 8.066,10.13 5.64,7.161 C5.213,7.883 4.974,8.722 4.974,9.636 C4.974,11.346 5.844,12.849 7.162,13.732 C6.355,13.706 5.596,13.484 4.934,13.116 L4.934,13.177 C4.934,15.562 6.627,17.551 8.88,18.004 C8.467,18.115 8.031,18.175 7.584,18.175 C7.27,18.175 6.969,18.145 6.668,18.089 C7.299,20.042 9.113,21.466 11.272,21.506 C9.592,22.825 7.463,23.611 5.17,23.611 C4.78,23.611 4.391,23.588 4,23.544 C6.189,24.938 8.768,25.753 11.557,25.753 C20.611,25.753 25.556,18.257 25.556,11.767 C25.556,11.558 25.556,11.347 25.541,11.137 C26.502,10.448 27.341,9.577 28.001,8.589 L27.954,8.569 Z"
  })));
})(_templateObject9$2 || (_templateObject9$2 = _taggedTemplateLiteral([""])));
var Vimeo = styled(function Vimeo(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "vimeo"
  }), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
    d: "M22.9252179,12.141242 C22.0869844,16.8641016 17.4040018,20.8624281 15.9952215,21.7759165 C14.5858278,22.6875643 13.3009728,21.4084352 12.8351285,20.4423911 C12.3015956,19.3395385 10.7022241,13.360658 10.2840277,12.8647526 C9.86521768,12.3688472 8.60878775,13.360658 8.60878775,13.360658 L8,12.5606655 C8,12.5606655 10.5511008,9.51447726 12.4919824,9.13227226 C14.5506543,8.73023104 14.5475868,12.2942058 15.0434922,14.2731238 C15.5218108,16.1886478 15.8434847,17.2822981 16.2618857,17.2822981 C16.6806957,17.2822981 17.4802792,16.2160504 18.3557311,14.5784379 C19.2330235,12.9400075 18.3183081,11.4929863 16.6038048,12.5220155 C17.2896879,8.41039764 23.7636558,7.42124536 22.9252179,12.141242"
  })));
})(_templateObject10$2 || (_templateObject10$2 = _taggedTemplateLiteral([""])));
var WhatsApp = styled(function WhatsApp(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "social-whatsapp"
  }), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.408 8.39351C9.88577 8.35217 9.48301 8.56913 9.13646 8.94007C8.76225 9.34065 8.46288 9.78667 8.26409 10.3001C7.83393 11.4111 7.94476 12.5031 8.3625 13.59C8.68942 14.4407 9.20918 15.1744 9.72479 15.9108C10.6761 17.2697 11.8054 18.4613 13.1226 19.4611C14.6029 20.5845 16.3098 21.2207 18.0894 21.6545C19.486 21.9949 20.6772 21.5413 21.6763 20.5329C22.2208 19.9835 22.3112 19.2771 22.3422 18.5498C22.3506 18.3541 22.2812 18.2167 22.1104 18.1273C21.8347 17.9829 21.5649 17.8257 21.2831 17.6945C20.5582 17.3569 19.8317 17.0219 19.0983 16.7036C18.732 16.5446 18.6291 16.5912 18.3757 16.8934C18.0234 17.3135 17.6581 17.7229 17.3132 18.149C17.0974 18.4156 16.8721 18.4635 16.5507 18.3342C15.35 17.8514 14.2753 17.1801 13.3612 16.2554C12.7488 15.6359 12.2265 14.9471 11.789 14.1911C11.6703 13.9859 11.6705 13.815 11.8249 13.6349C11.9784 13.456 12.1287 13.2734 12.2675 13.0829C12.4361 12.8516 12.6006 12.6161 12.7488 12.3714C12.8426 12.2164 12.881 12.0399 12.8045 11.8571C12.3688 10.8159 11.9338 9.77443 11.4995 8.73259C11.4393 8.58837 11.3287 8.51236 11.1811 8.49171C10.9239 8.4557 10.6658 8.42591 10.408 8.39351ZM3.84996 26.4443C3.99261 25.9783 4.11517 25.5563 4.25096 25.1387C4.56081 24.1857 4.87435 23.234 5.19372 22.2842C5.24331 22.1367 5.22905 22.0175 5.15199 21.8872C4.84691 21.3712 4.52072 20.8655 4.25157 20.3308C3.25416 18.3496 2.8735 16.2424 3.03635 14.0308C3.37798 9.39113 6.45944 5.41207 10.7544 3.75534C12.397 3.12176 14.0908 2.92821 15.8392 3.02256C17.9822 3.13826 19.933 3.81315 21.6967 5.0161C24.3704 6.83985 26.0492 9.36802 26.789 12.529C27.0198 13.5151 27.0174 14.5233 26.9831 15.527C26.8637 19.0168 25.3843 21.8491 22.7938 24.1087C21.1415 25.5499 19.2117 26.4625 17.0572 26.8217C14.1398 27.308 11.3823 26.8022 8.83306 25.2715C8.50362 25.0737 8.23067 25.0384 7.86853 25.161C6.60084 25.5903 5.32117 25.9839 4.04596 26.3906C3.99916 26.4056 3.95118 26.4167 3.84996 26.4443Z"
  })));
})(_templateObject11$1 || (_templateObject11$1 = _taggedTemplateLiteral([""])));
var Youtube = styled(function Youtube(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "youtube"
  }), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
    d: "M19.3368346,16.0520676 L14.7455844,18.5327928 L14.7443035,14.7137109 L14.7443035,13.5526403 L16.8148623,14.6796371 L19.3368346,16.0520676 Z M24.8291187,12.6890108 C24.8291187,12.6890108 24.6636175,11.4664537 24.1545603,10.9287028 C23.5076707,10.2236572 22.7831545,10.2193019 22.452152,10.1783109 C20.0715986,10 16.5040991,10 16.5040991,10 L16.4964133,10 C16.4964133,10 12.9268642,10 10.5488727,10.1793357 C10.2165893,10.2193019 9.49309784,10.2236572 8.84518356,10.9292151 C8.33663874,11.4672223 8.17062511,12.6895232 8.17062511,12.6895232 C8.17062511,12.6895232 8,14.123184 8,15.5581259 L8,15.7310567 L8,16.9021189 C8,18.3375731 8.17062511,19.7720025 8.17062511,19.7720025 C8.17062511,19.7720025 8.33663874,20.9937911 8.84518356,21.5312858 C9.49309784,22.2373561 10.3431491,22.214811 10.7202664,22.2880825 C12.0806559,22.4238652 16.5,22.4666496 16.5,22.4666496 C16.5,22.4666496 20.0715986,22.4602447 22.452152,22.2819338 C22.7831545,22.2404304 23.5076707,22.2373561 24.1545603,21.5305172 C24.6636175,20.9930225 24.8291187,19.7717463 24.8291187,19.7717463 C24.8291187,19.7717463 25,18.3375731 25,16.9021189 L25,15.8056091 L25,15.5581259 C25,14.123184 24.8291187,12.6890108 24.8291187,12.6890108 Z"
  })));
})(_templateObject12$1 || (_templateObject12$1 = _taggedTemplateLiteral([""])));

var ThirdParty = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Bandcamp: Bandcamp,
  Facebook: Facebook,
  Instagram: Instagram,
  LinkedIn: LinkedIn,
  Messenger: Messenger,
  Soundcloud: Soundcloud,
  Spotify: Spotify,
  Twitch: Twitch,
  Twitter: Twitter,
  Vimeo: Vimeo,
  WhatsApp: WhatsApp,
  Youtube: Youtube
});

var _templateObject$a, _templateObject2$7, _templateObject3$7, _templateObject4$5, _templateObject5$4, _templateObject6$4;
var Binoculars = styled(function Binoculars(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "binoculars",
    viewBox: "0 0 130 85"
  }), /*#__PURE__*/createElement("circle", {
    cx: "29.95",
    cy: "54.57",
    r: "26.08",
    fill: PRIMARY_SAND
  }), /*#__PURE__*/createElement("circle", {
    cx: "97.77",
    cy: "54.57",
    r: "26.08",
    fill: PRIMARY_SAND
  }), /*#__PURE__*/createElement("circle", {
    cx: "66.84",
    cy: "34.74",
    r: "9.98",
    fill: PRIMARY_SAND
  }), /*#__PURE__*/createElement("path", {
    fill: PRIMARY_BLACK,
    d: "M124.75,20.15 L124.77,19.95 C125.02,18.9 125.17,17.8 125.17,16.67 C125.17,16.37 125.14,16.07 125.12,15.77 L125.15,15.39 C125.21,14.74 125.08,14.1 124.8,13.55 C123.37,7.24 117.73,2.51 111,2.51 C106.32,2.51 102.17,4.81 99.6,8.33 C99.46,8.48 99.34,8.64 99.23,8.81 L96.22,13.59 C94.22,14.58 92.37,15.84 90.74,17.35 C89.31,15.56 87.43,14.14 85.28,13.27 C84.38,6.33 78.44,0.94 71.26,0.94 C67.87,0.94 64.77,2.14 62.33,4.13 L51.71,11.43 C50.62,11.27 49.51,11.19 48.39,11.19 C45,11.19 41.78,11.93 38.88,13.24 C38.82,13.26 38.77,13.29 38.71,13.32 C36.57,14.31 34.61,15.61 32.88,17.16 L15.52,28.76 C14.18,29.51 12.91,30.36 11.71,31.3 L11.66,31.33 C11.63,31.35 11.6,31.38 11.57,31.41 C4.76,36.84 0.37,45.2 0.37,54.57 C0.37,70.88 13.64,84.15 29.95,84.15 C39.5,84.15 48,79.6 53.41,72.56 C53.44,72.52 53.47,72.49 53.5,72.46 L53.55,72.39 C54.14,71.61 54.7,70.8 55.21,69.95 C55.21,69.95 65.64,54.77 66.09,54 C66.54,53.23 68.21,53.18 68.21,54.58 C68.21,70.89 81.48,84.16 97.79,84.16 C110.87,84.16 121.99,75.62 125.88,63.82 C125.9,63.78 125.91,63.74 125.92,63.69 C126.85,60.82 129.4,37.66 129.4,37.66 C129.4,37.65 129.4,37.64 129.4,37.63 C129.55,36.56 129.64,35.47 129.64,34.36 C129.63,29 127.8,24.07 124.75,20.15 Z M29.95,77.14 C17.5,77.14 7.37,67.01 7.37,54.56 C7.37,42.11 17.5,31.99 29.95,31.99 C42.4,31.99 52.53,42.12 52.53,54.57 C52.53,67.02 42.39,77.14 29.95,77.14 Z M66.84,41.21 C63.27,41.21 60.36,38.3 60.36,34.73 C60.36,31.16 63.27,28.25 66.84,28.25 C70.41,28.25 73.32,31.16 73.32,34.73 C73.32,38.3 70.41,41.21 66.84,41.21 Z M97.77,77.14 C85.32,77.14 75.19,67.01 75.19,54.56 C75.19,42.11 85.32,31.98 97.77,31.98 C110.22,31.98 120.35,42.11 120.35,54.56 C120.35,67.01 110.22,77.14 97.77,77.14 Z"
  }));
})(_templateObject$a || (_templateObject$a = _taggedTemplateLiteral([""])));
var Calendar$1 = styled(function Calendar(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "calendar",
    viewBox: "0 0 122 93"
  }), /*#__PURE__*/createElement("path", {
    fill: PRIMARY_SAND,
    d: "M34.59,3.99 C34.59,3.99 33.37,21.65 25.43,45.63 C19.79,62.69 4.02,81.52 4.02,81.52 L75.3,81.52 C83.81,81.52 91.81,77.4 96.68,70.41 C100.72,64.61 105.27,56.69 108.49,47.01 C116.74,22.18 118.01,3.99 118.01,3.99 L34.59,3.99 Z"
  }), /*#__PURE__*/createElement("g", {
    fill: PRIMARY_BLACK
  }, /*#__PURE__*/createElement("path", {
    d: "M121.5,4.24 C121.51,4.12 121.49,4 121.49,3.88 C121.49,3.77 121.49,3.66 121.48,3.55 C121.46,3.42 121.42,3.29 121.39,3.16 C121.36,3.06 121.35,2.95 121.31,2.85 C121.27,2.73 121.2,2.61 121.15,2.49 C121.1,2.39 121.07,2.29 121.01,2.2 C120.94,2.08 120.85,1.97 120.76,1.86 C120.7,1.78 120.65,1.7 120.59,1.63 C120.59,1.63 120.58,1.62 120.58,1.62 C120.58,1.62 120.57,1.61 120.57,1.6 C120.48,1.5 120.36,1.42 120.26,1.33 C120.19,1.27 120.12,1.19 120.04,1.14 C119.92,1.06 119.79,1 119.67,0.93 C119.58,0.88 119.51,0.83 119.42,0.79 C119.28,0.73 119.13,0.69 118.98,0.65 C118.9,0.63 118.82,0.59 118.74,0.57 C118.5,0.52 118.26,0.49 118.02,0.49 L34.59,0.49 C34.36,0.49 34.14,0.51 33.92,0.55 C33.85,0.56 33.79,0.59 33.72,0.61 C33.58,0.65 33.43,0.68 33.3,0.74 C33.23,0.77 33.16,0.81 33.09,0.85 C32.97,0.91 32.84,0.96 32.73,1.04 C32.66,1.08 32.6,1.14 32.54,1.18 C32.43,1.26 32.32,1.33 32.22,1.42 C32.16,1.47 32.11,1.54 32.06,1.6 C31.97,1.7 31.88,1.79 31.8,1.9 C31.75,1.97 31.71,2.05 31.66,2.12 C31.59,2.23 31.52,2.33 31.46,2.45 C31.42,2.53 31.39,2.62 31.36,2.71 C31.31,2.83 31.26,2.94 31.23,3.06 C31.2,3.16 31.19,3.26 31.17,3.36 C31.15,3.47 31.12,3.57 31.11,3.68 L30.99,5.03 C30.54,9.44 28.62,24.9 22.12,44.54 C16.75,60.74 1.49,79.09 1.33,79.27 C0.46,80.31 0.27,81.77 0.84,83 C1.42,84.23 2.65,85.02 4.01,85.02 L23.71,85.02 L23.41,88.34 C23.32,89.32 23.65,90.29 24.31,91.02 C24.97,91.75 25.91,92.16 26.89,92.16 L110.3,92.16 C112.11,92.16 113.62,90.78 113.79,88.98 L121.33,6.07 C121.44,4.99 121.49,4.36 121.5,4.24 Z M28.76,46.73 C34.84,28.35 37.04,13.73 37.77,7.49 L114.12,7.49 C113.31,13.97 111.02,28.29 105.17,45.91 C102.55,53.79 98.73,61.36 93.81,68.41 C89.61,74.43 82.69,78.02 75.3,78.02 L11.19,78.02 C16.43,70.98 24.84,58.57 28.76,46.73 Z"
  }), /*#__PURE__*/createElement("circle", {
    cx: "49.77",
    cy: "17.87",
    r: "5.11"
  }), /*#__PURE__*/createElement("circle", {
    cx: "98.95",
    cy: "17.87",
    r: "5.11"
  })));
})(_templateObject2$7 || (_templateObject2$7 = _taggedTemplateLiteral([""])));
var Owl = styled(function Owl(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "owl",
    viewBox: "0 0 110 114"
  }), /*#__PURE__*/createElement("path", {
    fill: PRIMARY_SAND,
    d: "M93.18,28.12 C85,13.57 69.41,3.74 51.52,3.74 C33.63,3.74 18.04,13.57 9.85,28.13 L5.28,23.82 C4.7,23.27 3.74,23.68 3.74,24.49 L3.74,51 C3.74,77.41 24.94,99.21 51.35,99.3002824 C77.82,99.39 99.3,77.96 99.3,51.52 L99.3,24.77 C99.3,23.86 98.21,23.39 97.54,24.01 L93.18,28.12 Z"
  }), /*#__PURE__*/createElement("path", {
    fill: PRIMARY_BLACK,
    d: "M107.02,31.57 C105.62,30.97 104.05,31.12 102.79,31.91 L102.79,24.77 C102.79,22.96 101.71,21.32 100.05,20.6 C98.38,19.88 96.45,20.22 95.13,21.47 L93.89,22.64 C84.39,8.72 68.53,0.24 51.52,0.24 C34.5,0.24 18.64,8.72 9.14,22.65 L7.69,21.28 C6.41,20.07 4.53,19.74 2.91,20.44 C1.29,21.14 0.24,22.73 0.24,24.5 L0.24,51 C0.24,63.61 4.74,75.18 12.2,84.18 C20.43,101.59 37.99,113.69 58.31,113.76 C58.37,113.76 58.43,113.76 58.49,113.76 C72.16,113.76 85,108.45 94.69,98.8 C104.42,89.11 109.77,76.21 109.77,62.48 L109.77,35.74 C109.76,33.93 108.69,32.29 107.02,31.57 Z M7.24,30.47 L7.45,30.67 C8.23,31.41 9.31,31.75 10.38,31.58 C11.44,31.42 12.38,30.77 12.9,29.84 C20.74,15.9 35.54,7.24 51.52,7.24 C67.5,7.24 82.29,15.9 90.14,29.84 C90.67,30.78 91.6,31.42 92.66,31.58 C93.73,31.74 94.81,31.4 95.59,30.67 L95.8,30.47 L95.8,51.51 C95.8,63.37 91.18,74.51 82.78,82.88 C74.42,91.21 63.33,95.79 51.53,95.79 C51.48,95.79 51.42,95.79 51.37,95.79 C27.03,95.71 7.24,75.62 7.24,51 L7.24,30.47 Z"
  }));
})(_templateObject3$7 || (_templateObject3$7 = _taggedTemplateLiteral([""])));
var PaperPlane = styled(function PaperPlane(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "paper-plane",
    viewBox: "0 0 126 106"
  }), /*#__PURE__*/createElement("polygon", {
    fill: PRIMARY_SAND,
    points: "122.1 4.21 3.9 39.73 36.9 62.67 31.4 93.89 51.57 73.4 73.87 88.36"
  }), /*#__PURE__*/createElement("path", {
    fill: PRIMARY_BLACK,
    d: "M125.48,5.1 C125.49,5.07 125.5,5.04 125.51,5.01 C125.57,4.77 125.59,4.53 125.6,4.28 C125.6,4.25 125.61,4.23 125.61,4.2 C125.61,4.16 125.6,4.11 125.6,4.07 C125.6,3.99 125.59,3.91 125.58,3.82 C125.57,3.73 125.56,3.64 125.54,3.55 C125.52,3.47 125.51,3.39 125.49,3.31 C125.47,3.22 125.44,3.14 125.41,3.05 C125.38,2.97 125.35,2.89 125.32,2.81 C125.29,2.73 125.25,2.66 125.21,2.58 C125.17,2.5 125.12,2.42 125.07,2.34 C125.05,2.3 125.03,2.26 125,2.23 C124.98,2.2 124.96,2.19 124.94,2.16 C124.91,2.12 124.88,2.07 124.85,2.03 C124.78,1.94 124.69,1.86 124.61,1.77 C124.58,1.74 124.55,1.7 124.52,1.67 C124.37,1.53 124.21,1.4 124.04,1.29 C123.99,1.26 123.94,1.23 123.89,1.2 C123.76,1.12 123.63,1.06 123.5,1 C123.43,0.97 123.37,0.95 123.3,0.92 C123.16,0.87 123.03,0.83 122.89,0.8 C122.83,0.79 122.77,0.77 122.71,0.76 C122.52,0.73 122.32,0.71 122.12,0.71 C122.07,0.71 122.01,0.72 121.96,0.72 C121.81,0.73 121.66,0.74 121.52,0.77 C121.44,0.78 121.37,0.8 121.3,0.82 C121.24,0.83 121.18,0.84 121.11,0.86 L2.89,36.38 C1.6,36.77 0.65,37.86 0.44,39.18 C0.23,40.51 0.8,41.84 1.9,42.6 L16.02,52.41 L9.84,54.27 C8.55,54.66 7.6,55.75 7.39,57.07 C7.18,58.4 7.75,59.73 8.85,60.49 L31.01,75.89 L27.95,93.27 C27.68,94.78 28.43,96.29 29.79,96.99 C30.3,97.25 30.85,97.38 31.39,97.38 C32.31,97.38 33.21,97.02 33.89,96.34 L44.67,85.39 L72.41,104.67 C73,105.08 73.7,105.3 74.41,105.3 C74.67,105.3 74.92,105.27 75.18,105.21 C76.14,105 76.96,104.39 77.45,103.54 L121.25,27.11 C121.96,25.87 121.84,24.32 120.95,23.19 C120.06,22.07 118.57,21.61 117.2,22.01 L115.67,22.47 L125.14,5.94 C125.16,5.91 125.17,5.88 125.18,5.85 C125.2,5.8 125.22,5.76 125.25,5.71 C125.34,5.52 125.42,5.31 125.48,5.1 Z M72.73,83.31 L44.38,63.61 L42.95,62.53 L111.47,15.71 L72.73,83.31 Z M101.48,14.06 L36.74,58.29 L11.85,41 L101.48,14.06 Z M39.4,68.67 L40.28,69.28 L46.27,73.79 L36.8,83.41 L39.4,68.67 Z"
  }));
})(_templateObject4$5 || (_templateObject4$5 = _taggedTemplateLiteral([""])));
var Stopwatch$1 = styled(function Stopwatch(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "stopwatch",
    viewBox: "0 0 106 126"
  }), /*#__PURE__*/createElement("circle", {
    cx: "48.49",
    cy: "69.5",
    r: "44.3",
    fill: PRIMARY_SAND
  }), /*#__PURE__*/createElement("g", {
    fill: PRIMARY_BLACK
  }, /*#__PURE__*/createElement("path", {
    d: "M46.97,77.27 C51.3,77.56 55.04,74.29 55.33,69.96 C55.37,69.34 55.33,68.74 55.24,68.16 L70.64,50.65 C71.14,50.08 71.14,49.22 70.63,48.66 C70.12,48.1 69.27,48 68.65,48.44 L49.59,61.86 C49.09,61.72 48.56,61.63 48.02,61.59 C43.69,61.3 39.95,64.57 39.66,68.9 C39.37,73.23 42.64,76.98 46.97,77.27 Z"
  }), /*#__PURE__*/createElement("path", {
    d: "M90.72,43.51 L93.16,41.37 C94.62,40.1 94.76,37.89 93.49,36.43 L87.73,29.84 C87.12,29.14 86.26,28.71 85.33,28.65 C84.41,28.58 83.49,28.9 82.79,29.51 L79.08,32.76 C72.78,27.49 65.27,23.97 57.15,22.49 L57.63,15.3 L64.69,15.77 C64.77,15.78 64.85,15.78 64.92,15.78 C65.76,15.78 66.58,15.47 67.22,14.91 C67.92,14.3 68.35,13.44 68.41,12.51 L68.86,5.77 C68.99,3.84 67.53,2.17 65.6,2.04 L40.5,0.36 C39.56,0.3 38.66,0.61 37.96,1.22 C37.26,1.83 36.83,2.69 36.77,3.62 L36.32,10.36 C36.19,12.29 37.65,13.96 39.58,14.09 L46.64,14.56 L46.16,21.75 C22.27,22.9 2.44,41.86 0.8,66.3 C-0.05,79.04 4.1,91.35 12.51,100.96 C15.04,103.86 17.88,106.4 20.94,108.57 C29.71,118.99 42.85,125.63 57.51,125.63 C83.87,125.63 105.32,104.18 105.32,77.83 C105.31,64.37 99.71,52.2 90.72,43.51 Z M7.78,66.77 C9.22,45.25 27.2,28.7 48.47,28.7 C49.38,28.7 50.3,28.73 51.23,28.79 C62.1,29.52 72.04,34.44 79.22,42.65 C86.39,50.86 89.94,61.36 89.21,72.24 C89.21,72.24 89.21,72.24 89.21,72.24 C88.48,83.11 83.56,93.05 75.36,100.23 C67.15,107.4 56.65,110.95 45.77,110.22 C34.89,109.49 24.96,104.57 17.78,96.37 C10.6,88.15 7.05,77.65 7.78,66.77 Z"
  })));
})(_templateObject5$4 || (_templateObject5$4 = _taggedTemplateLiteral([""])));
var StopwatchPlus = styled(function StopwatchPlus(props) {
  return /*#__PURE__*/createElement(Icon, _extends({}, props, {
    name: "stopwatch-plus",
    viewBox: "0 0 113 143"
  }), /*#__PURE__*/createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("path", {
    d: "M-15-5h142v153H-15z"
  }), /*#__PURE__*/createElement("g", {
    transform: "rotate(5 55.95 -32.55)"
  }, /*#__PURE__*/createElement("circle", {
    cx: "72.35",
    cy: "90.14",
    r: "47.5",
    fill: PRIMARY_BLACK,
    stroke: PRIMARY_BLACK,
    strokeWidth: "7"
  }), /*#__PURE__*/createElement("path", {
    fill: PRIMARY_SAND,
    stroke: PRIMARY_BLACK,
    strokeDasharray: "156,400",
    strokeLinecap: "round",
    strokeWidth: "7",
    d: "M16.6 91.6a51 51 0 1096.44-33.21 51 51 0 00-96.44 33.2z"
  }), /*#__PURE__*/createElement("path", {
    stroke: PRIMARY_BLACK,
    strokeDasharray: "86,400",
    strokeLinecap: "round",
    strokeWidth: "7",
    d: "M78.02 25.73a51 51 0 10-26.4 98.53 51 51 0 0026.4-98.53z"
  }), /*#__PURE__*/createElement("path", {
    fill: PRIMARY_BLACK,
    fillRule: "nonzero",
    d: "M65.17 85.42c-4.97.32-9.26-3.27-9.6-8.03-.04-.68 0-1.34.1-1.98L38.02 56.17a1.6 1.6 0 010-2.19 1.78 1.78 0 012.28-.24L62.16 68.5a9.61 9.61 0 011.8-.3c4.97-.32 9.27 3.28 9.6 8.03.33 4.76-3.42 8.88-8.39 9.2z"
  }), /*#__PURE__*/createElement("path", {
    fill: PRIMARY_BLACK,
    d: "M59.82 14.99h10v10h-10z"
  }), /*#__PURE__*/createElement("rect", {
    width: "34",
    height: "16",
    x: "47.82",
    y: ".99",
    fill: PRIMARY_BLACK,
    rx: "5"
  }), /*#__PURE__*/createElement("path", {
    fill: PRIMARY_BLACK,
    fillRule: "nonzero",
    d: "M119.28 42.41c0-2.97-2.4-5.38-5.38-5.38h-10.76a1 1 0 01-1-1V25.27a5.37 5.37 0 10-10.76 0v10.76a1 1 0 01-1 1H79.62a5.37 5.37 0 100 10.75h10.75a1 1 0 011 1v10.76a5.38 5.38 0 1010.75-.01V48.77a1 1 0 011-1h10.76c3 .02 5.4-2.38 5.4-5.36zM16.5 113.18l20.14-8.78c1.58-.7 1.57-3.16-.02-4.45L16.37 83.49c-1.58-1.29-3.56-.43-3.55 1.55l.12 25.23c0 1.99 1.98 3.6 3.56 2.91z"
  }))));
})(_templateObject6$4 || (_templateObject6$4 = _taggedTemplateLiteral([""])));

var TwoToned = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Binoculars: Binoculars,
  Calendar: Calendar$1,
  Owl: Owl,
  PaperPlane: PaperPlane,
  Stopwatch: Stopwatch$1,
  StopwatchPlus: StopwatchPlus
});

var _templateObject$b;

function CurrencyComponent(_ref) {
  var currency = _ref.currency,
      iconProps = _objectWithoutProperties(_ref, ["currency"]);

  switch (currency) {
    case 'EUR':
      {
        return /*#__PURE__*/createElement(Eur, iconProps);
      }

    case 'CHF':
      {
        return /*#__PURE__*/createElement(Chf, iconProps);
      }

    case 'DKK':
    case 'NOK':
    case 'SEK':
      {
        return /*#__PURE__*/createElement(Kr, iconProps);
      }

    case 'GBP':
      {
        return /*#__PURE__*/createElement(Pound, iconProps);
      }

    default:
      {
        return /*#__PURE__*/createElement(Dolls, iconProps);
      }
  }
}

var Currency = styled(CurrencyComponent)(_templateObject$b || (_templateObject$b = _taggedTemplateLiteral([""])));



var index$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  coffee: Coffee,
  crowdfunding: Crowdfunding,
  currencies: Currencies,
  fill: Fill,
  paymentMethods: PaymentMethods,
  stroke: Stroke,
  thirdParty: ThirdParty,
  twoToned: TwoToned,
  Currency: Currency,
  Icon: Icon,
  InlineSvg: InlineSvg,
  SizedSvg: SizedSvg
});

function useLoseFocus(ref, onLoseFocus, deps) {
  // ref to avoid blur running after mousedown
  var hasRunLock = useRef(false); // ref to detect if mousedown outside was done after mousedown inside

  var lastClickTarget = useRef();
  useEffect(function () {
    if (ref.current !== null) {
      ref.current.addEventListener('blur', handleLoseFocus, {
        capture: true
      });
    }

    window.addEventListener('mousedown', handleClickOutside);
    return function () {
      if (ref.current !== null) {
        ref.current.removeEventListener('blur', handleLoseFocus, {
          capture: true
        });
      }

      window.removeEventListener('mousedown', handleClickOutside);
    };
  }, deps);

  function handleClickOutside(event) {
    if (ref.current === null) {
      return;
    }

    if (!ref.current.contains(event.target) && ref.current.contains(lastClickTarget.current || null)) {
      hasRunLock.current = true;
      onLoseFocus();
    }

    lastClickTarget.current = event.target;
  }

  function handleLoseFocus(event) {
    if (ref.current === null) {
      return;
    }

    if (!ref.current.contains(event.relatedTarget)) {
      if (!hasRunLock.current) {
        onLoseFocus();
      }

      hasRunLock.current = false;
    }
  }
}

function useOnClickOutside(refs, onClickOutside) {
  useEffect(function () {
    document.addEventListener("mousedown", handler);
    document.addEventListener("touchstart", handler);
    return function () {
      document.removeEventListener("mousedown", handler);
      document.removeEventListener("touchstart", handler);
    };
  }, [onClickOutside]);

  function handler(event) {
    var isEventOutside = refs.every(function (ref) {
      var el = ref === null || ref === void 0 ? void 0 : ref.current;
      return !(!el || el.contains(event.target));
    });

    if (isEventOutside) {
      onClickOutside(event);
    }
  }
}

function useScrollListener(target, onScroll) {
  var scrollRef = useRef({
    x: 0,
    y: 0,
    dx: 0,
    dy: 0
  });
  useEffect(function () {
    if (target.current === null) {
      return;
    }

    handleScroll();
    target.current.addEventListener('scroll', handleScroll);
    return function () {
      if (target.current === null) {
        return;
      }

      target.current.removeEventListener('scroll', handleScroll);
    };
  }, []);

  function handleScroll() {
    if (target.current === null) {
      return;
    }

    var x = target.current.scrollLeft;
    var y = target.current.scrollTop;
    scrollRef.current = {
      x: x,
      y: y,
      dx: x - scrollRef.current.x,
      dy: y - scrollRef.current.y
    };
    onScroll(scrollRef.current);
  }
}

/** call `onScrollable` when target transition from/to scrollable
 * (content overflow hidden behind scroll bar) */

function useScrollableListener(target, onScrollable) {
  var isScrollableRef = useRef({
    x: false,
    y: false
  });
  useEffect(function () {
    onResize();
    window.addEventListener('resize', onResize);
    return function () {
      window.removeEventListener('resize', onResize);
    };
  }, []);

  function onResize() {
    if (target.current === null) {
      return;
    }

    var scrollableX = target.current.scrollWidth > target.current.clientWidth;
    var scrollableY = target.current.scrollHeight > target.current.clientHeight;

    if (isScrollableRef.current.x !== scrollableX || isScrollableRef.current.y !== scrollableY) {
      isScrollableRef.current = {
        x: scrollableX,
        y: scrollableY
      };
      onScrollable(isScrollableRef.current);
    }
  }
}

function useThrottle(call) {
  var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
  var throttling = useRef(false);
  return function () {
    if (!throttling.current) {
      throttling.current = true;
      call.apply(void 0, arguments);
      setTimeout(function () {
        throttling.current = false;
      }, timeout);
    }
  };
}



var index$2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  useCommittedRef: useCommittedRef,
  useDebounce: useDebounce,
  useLoseFocus: useLoseFocus,
  useOnClickOutside: useOnClickOutside,
  useScrollListener: useScrollListener,
  useScrollableListener: useScrollableListener,
  useThrottle: useThrottle
});

var _templateObject$c, _templateObject2$8;
var FreeSizedSvg = styled(InlineSvg)(_templateObject$c || (_templateObject$c = _taggedTemplateLiteral(["\n  ", "\n  vertical-align: middle;\n  width: ", ";\n"])), function (_ref) {
  var height = _ref.height;
  return height && css(_templateObject2$8 || (_templateObject2$8 = _taggedTemplateLiteral(["\n      height: ", "px;\n    "])), height);
}, function (_ref2) {
  var width = _ref2.width;
  return width ? "".concat(width, "px") : 'auto';
});

var _templateObject$d, _templateObject2$9;

/** Base Medium Icon Component */
function MediumIconComponent(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$inverted = _ref.inverted,
      inverted = _ref$inverted === void 0 ? false : _ref$inverted,
      name = _ref.name,
      _ref$noBackground = _ref.noBackground,
      noBackground = _ref$noBackground === void 0 ? false : _ref$noBackground,
      onClick = _ref.onClick,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 32 : _ref$size,
      title = _ref.title,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? "0 0 ".concat(size, " ").concat(size) : _ref$viewBox,
      transform = _ref.transform;
  var height = inverted && !noBackground ? size * 0.6 : size;
  var width = inverted && !noBackground ? '100%' : size;
  return /*#__PURE__*/createElement(FreeSizedSvg, {
    "aria-labelledby": title && 'title',
    className: className,
    clipRule: "evenodd",
    fillRule: "evenodd",
    height: height,
    id: "icon-".concat(name),
    onClick: onClick,
    preserveAspectRatio: "xMidYMid meet",
    transform: transform,
    viewBox: viewBox,
    width: width,
    xmlns: "http://www.w3.org/2000/svg",
    y: inverted && !noBackground ? size / 5 : 0
  }, title && /*#__PURE__*/createElement("title", {
    id: "title"
  }, name), children);
}

var MediumIcon = styled(MediumIconComponent)(_templateObject$d || (_templateObject$d = _taggedTemplateLiteral([""])));
MediumIcon.displayName = 'illustrations.MediumIcon';
/** Base Large Icon Component */

function LargeIconComponent(_ref2) {
  var children = _ref2.children,
      className = _ref2.className,
      _ref2$height = _ref2.height,
      height = _ref2$height === void 0 ? 128 : _ref2$height,
      name = _ref2.name,
      onClick = _ref2.onClick,
      title = _ref2.title,
      viewBox = _ref2.viewBox,
      width = _ref2.width,
      transform = _ref2.transform;
  return /*#__PURE__*/createElement(FreeSizedSvg, {
    "aria-labelledby": title && 'title',
    className: className,
    clipRule: "evenodd",
    fillRule: "evenodd",
    height: height,
    id: "icon-".concat(name),
    onClick: onClick,
    preserveAspectRatio: "xMidYMid meet",
    transform: transform,
    viewBox: viewBox,
    width: width,
    xmlns: "http://www.w3.org/2000/svg"
  }, title && /*#__PURE__*/createElement("title", {
    id: "title"
  }, name), children);
}

var LargeIcon = styled(LargeIconComponent)(_templateObject2$9 || (_templateObject2$9 = _taggedTemplateLiteral([""])));
LargeIcon.displayName = 'illustrations.LargeIcon';

function CircularBackground(_ref) {
  var diameter = _ref.diameter,
      inverted = _ref.inverted;
  return inverted ? /*#__PURE__*/createElement(Circle, {
    diameter: diameter
  }) : /*#__PURE__*/createElement(Disc, {
    diameter: diameter
  });
}

function Circle(_ref2) {
  var diameter = _ref2.diameter;
  var strokeWidth = Math.floor(Number(diameter) / 64) + 1;
  return /*#__PURE__*/createElement("circle", {
    cx: Number(diameter) / 2,
    cy: Number(diameter) / 2,
    r: Number(diameter) / 2 - strokeWidth,
    fill: "none",
    stroke: PRIMARY_WHITE,
    strokeWidth: strokeWidth
  });
}

function Disc(_ref3) {
  var diameter = _ref3.diameter;
  var padding = Math.floor(Number(diameter) / 64) + 1;
  return /*#__PURE__*/createElement("circle", {
    cx: Number(diameter) / 2,
    cy: Number(diameter) / 2,
    r: Number(diameter) / 2 - padding,
    fill: GREY_SHADE_5
  });
}

function PartialDisk(_ref4) {
  var viewBox = _ref4.viewBox,
      _ref4$x = _ref4.x,
      x = _ref4$x === void 0 ? 0 : _ref4$x,
      _ref4$y = _ref4.y,
      y = _ref4$y === void 0 ? 0 : _ref4$y;
  return /*#__PURE__*/createElement("svg", {
    height: "100%",
    preserveAspectRatio: "xMidYMin meet",
    viewBox: viewBox,
    width: "100%",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/createElement("path", {
    fill: GREY_SHADE_5,
    d: "M 14.5 239.32 L 259.81 239.32 C 265.42 220.7 266.89 200.53 263.25 180.08 C 250.88 110.43 184.39 64 114.74 76.38 C 45.09 88.76 -1.33 155.25 11.04 224.89 C 11.92 229.83 13.1 234.63 14.5 239.32 Z",
    transform: "translate(".concat(x, ", ").concat(y, ")")
  }));
}

var _templateObject$e;

/** Base SVG illustration component */
function IllustrationComponent(_ref) {
  var children = _ref.children,
      className = _ref.className,
      height = _ref.height,
      _ref$large = _ref.large,
      large = _ref$large === void 0 ? false : _ref$large,
      name = _ref.name,
      onClick = _ref.onClick,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 128 : _ref$size,
      title = _ref.title,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? "0 0 ".concat(size, " ").concat(size) : _ref$viewBox,
      width = _ref.width;
  return /*#__PURE__*/createElement(FreeSizedSvg, {
    "aria-labelledby": title && 'title',
    className: className,
    clipRule: "evenodd",
    fillRule: "evenodd",
    height: height || size,
    id: "illustration-".concat(name),
    onClick: onClick,
    preserveAspectRatio: "xMidYMid meet",
    viewBox: viewBox,
    width: large ? undefined : width || size,
    xmlns: "http://www.w3.org/2000/svg"
  }, title && /*#__PURE__*/createElement("title", {
    id: "title"
  }, name), children);
}

var Illustration = styled(IllustrationComponent)(_templateObject$e || (_templateObject$e = _taggedTemplateLiteral(["\n  && {\n    overflow: visible;\n  }\n"])));
Illustration.displayName = 'illustrations.Illustration';

function iconTint() {
  var inverted = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return inverted ? PRIMARY_GREEN : BRAND_ACCENT_PURPLE;
}
function RegularIllustration(_ref) {
  var children = _ref.children,
      inverted = _ref.inverted,
      name = _ref.name,
      noBackground = _ref.noBackground,
      size = _ref.size;
  return /*#__PURE__*/createElement(Illustration, {
    name: name,
    size: size
  }, !noBackground && /*#__PURE__*/createElement(CircularBackground, {
    diameter: size,
    inverted: inverted
  }), children);
}
function IrregularIllustration(_ref2) {
  var backgroundOffset = _ref2.backgroundOffset,
      children = _ref2.children,
      name = _ref2.name,
      noBackground = _ref2.noBackground,
      size = _ref2.size,
      viewBox = _ref2.viewBox;
  return /*#__PURE__*/createElement(Illustration, {
    large: true,
    name: name,
    size: size,
    viewBox: viewBox
  }, !noBackground && /*#__PURE__*/createElement(PartialDisk, {
    viewBox: viewBox,
    x: backgroundOffset.x,
    y: backgroundOffset.y
  }), children);
}

var _templateObject$f, _templateObject2$a, _templateObject3$8, _templateObject4$6, _templateObject5$5, _templateObject6$5, _templateObject7$3, _templateObject8$3, _templateObject9$3, _templateObject10$3, _templateObject11$2, _templateObject12$2, _templateObject13$1, _templateObject14$1, _templateObject15$1, _templateObject16$1, _templateObject17$1, _templateObject18$1;
/**
 * MEDIUM SIZED
 */

var BookWithQuestion = styled(function BookWithQuestion(props) {
  var name = 'book-with-question';
  var viewBox = '0 0 200 178';
  return /*#__PURE__*/createElement(RegularIllustration, _extends({
    name: name
  }, props), /*#__PURE__*/createElement(MediumIcon, _extends({}, props, {
    name: name,
    size: props.size,
    viewBox: viewBox
  }), /*#__PURE__*/createElement("path", {
    fill: PRIMARY_SAND,
    d: "M105.43,153.24 C81.77,132.96 22.12,143.59 22.12,143.59 L11.87,33.55 C11.87,33.55 65.2,19.87 95.18,43.2 L105.43,153.24 Z"
  }), /*#__PURE__*/createElement("path", {
    fill: PRIMARY_SAND,
    d: "M105.43,153.24 C124.94,128.93 185.53,128.36 185.53,128.36 L175.28,18.32 C175.28,18.32 120.34,14.74 95.18,43.2 L105.43,153.24 Z"
  }), /*#__PURE__*/createElement("g", {
    fill: PRIMARY_BLACK,
    transform: "translate(0 14)"
  }, /*#__PURE__*/createElement("path", {
    d: "M105.18 39.8C105.85 40.82 106.97 41.38 108.11 41.38 108.77 41.38 109.44 41.19 110.03 40.81 126.28 30.14 147.8 26.97 162.99 26.18 164.92 26.08 166.4 24.43 166.3 22.5 166.2 20.57 164.55 19.07 162.62 19.19 146.57 20.02 123.74 23.43 106.18 34.96 104.56 36.01 104.12 38.18 105.18 39.8zM107.34 47.41C105.72 48.47 105.27 50.64 106.34 52.26 107.01 53.28 108.13 53.84 109.27 53.84 109.93 53.84 110.6 53.65 111.19 53.27 127.44 42.6 148.96 39.43 164.15 38.64 166.08 38.54 167.56 36.89 167.46 34.96 167.36 33.03 165.72 31.53 163.78 31.65 147.72 32.47 124.9 35.88 107.34 47.41zM108.5 59.86C106.88 60.92 106.43 63.09 107.5 64.71 108.17 65.73 109.29 66.29 110.43 66.29 111.09 66.29 111.76 66.1 112.35 65.72 128.6 55.05 150.12 51.88 165.31 51.09 167.24 50.99 168.72 49.34 168.62 47.41 168.52 45.48 166.88 43.97 164.94 44.1 148.88 44.92 126.06 48.33 108.5 59.86zM109.66 72.32C108.04 73.38 107.59 75.55 108.66 77.17 109.33 78.19 110.45 78.75 111.59 78.75 112.25 78.75 112.92 78.56 113.51 78.17 129.76 67.5 151.28 64.33 166.47 63.54 168.4 63.44 169.88 61.79 169.78 59.86 169.68 57.93 168.03 56.44 166.1 56.55 150.04 57.38 127.22 60.79 109.66 72.32z"
  }), /*#__PURE__*/createElement("path", {
    d: "M189.25,19.42 C189.09,17.69 187.68,16.34 185.94,16.25 C185.5,16.23 183.33,16.13 179.9,16.14 L178.76,4 C178.6,2.29 177.22,0.94 175.5,0.83 C174.93,0.79 161.18,-0.06 144.11,2.63 C122.37,6.06 105.78,13.43 94.74,24.55 C81.93,15.78 63.85,11.5 42.18,12.13 C24.91,12.64 11.56,16.02 11,16.16 C9.33,16.59 8.22,18.16 8.38,19.87 L9.51,32.01 C6.14,32.64 4.02,33.13 3.59,33.24 C1.9,33.65 0.76,35.23 0.92,36.97 L11.17,147.01 C11.27,148.12 11.9,149.12 12.86,149.69 C13.41,150.02 14.03,150.19 14.65,150.19 C15.11,150.19 15.58,150.1 16.02,149.91 C16.18,149.84 32.22,143.08 51.14,138.83 C75.47,133.37 93.51,134.47 103.29,142.01 C103.31,142.03 103.33,142.04 103.35,142.05 C103.36,142.06 103.37,142.06 103.38,142.07 C103.45,142.12 103.52,142.16 103.59,142.21 C103.64,142.24 103.69,142.27 103.74,142.3 C103.75,142.31 103.77,142.32 103.78,142.33 C103.79,142.34 103.8,142.34 103.82,142.35 C103.91,142.4 104.01,142.44 104.11,142.48 C104.16,142.5 104.21,142.53 104.27,142.55 C104.29,142.56 104.31,142.57 104.33,142.58 C104.34,142.58 104.36,142.59 104.37,142.59 C104.39,142.59 104.4,142.6 104.41,142.61 C104.5,142.64 104.59,142.65 104.68,142.67 C104.74,142.68 104.79,142.7 104.85,142.71 C105.03,142.74 105.22,142.76 105.4,142.76 C105.4,142.76 105.41,142.76 105.41,142.76 C105.41,142.76 105.41,142.76 105.41,142.76 C105.41,142.76 105.41,142.76 105.41,142.76 C105.41,142.76 105.41,142.76 105.41,142.76 C105.41,142.76 105.41,142.76 105.41,142.76 C105.41,142.76 105.42,142.76 105.42,142.76 C105.44,142.76 105.47,142.75 105.49,142.75 C105.7,142.74 105.9,142.73 106.1,142.69 C106.11,142.69 106.12,142.69 106.13,142.69 C106.14,142.69 106.14,142.69 106.15,142.68 C106.17,142.68 106.18,142.67 106.2,142.67 C106.27,142.65 106.34,142.62 106.41,142.6 C106.52,142.56 106.64,142.54 106.75,142.49 C106.77,142.48 106.8,142.47 106.82,142.46 C106.87,142.44 106.91,142.42 106.96,142.4 C106.98,142.39 107,142.39 107.01,142.38 C107.02,142.37 107.03,142.36 107.05,142.36 C107.06,142.35 107.08,142.35 107.09,142.34 C107.16,142.3 107.23,142.25 107.29,142.21 C107.37,142.16 107.45,142.11 107.52,142.05 C107.56,142.02 107.59,141.99 107.63,141.96 C107.74,141.87 107.85,141.77 107.95,141.66 C107.96,141.65 107.96,141.65 107.97,141.64 C107.98,141.63 108,141.61 108.01,141.6 C116.23,132.39 133.75,127.98 158.67,128.84 C178.05,129.51 195.06,133.2 195.23,133.24 C196.32,133.48 197.46,133.18 198.3,132.44 C199.14,131.7 199.57,130.61 199.47,129.49 L189.25,19.42 Z M172.08,7.71 L181.7,110.96 C169.06,111.48 128.71,114.45 108.23,131.47 L98.81,30.4 C119.61,8.35 160.71,7.5 172.08,7.71 Z M91.84,31.06 L91.86,31.22 L101.26,132.12 C88.77,125.18 71.41,123.26 56.06,123.26 C42.81,123.26 31.06,124.69 25.26,125.53 L15.64,22.29 C26.76,19.97 67.28,13.19 91.84,31.06 Z"
  })), /*#__PURE__*/createElement("path", {
    fill: iconTint(props.inverted),
    d: "M46.25 5.95C42.11 2.94 37.41 1.42 32.35.91 27.44.41 22.6.78 17.88 2.26 11.14 4.38 6.02 8.45 2.91 14.88 1.01 18.81.17 23 .05 27.34.02 28.25.1 29.16.13 30.1 6.17 29.91 12.16 29.72 18.2 29.53 18.21 29.24 18.22 29.04 18.23 28.85 18.49 24.86 20.39 21.96 24.08 20.4 26.9 19.21 29.8 19.34 32.64 20.46 38.27 22.7 38.38 29.98 35.48 33.13 34.3 34.41 32.82 35.13 31.32 35.86 28.15 37.42 24.84 38.75 21.95 40.84 20.94 41.57 20.03 42.38 19.22 43.25 17.4 45.2 16.12 47.52 15.56 50.32 14.99 53.18 15.17 56.04 15.53 58.9 15.66 59.94 15.78 60.98 15.91 62.07 16.3 62.06 16.64 62.05 16.97 62.04 21.13 61.91 25.29 61.78 29.44 61.65 31.22 61.59 31.23 61.59 31.25 59.79 31.28 57.64 31.89 55.75 33.73 54.48 34.67 53.84 35.68 53.3 36.71 52.8 39.27 51.57 41.98 50.6 44.4 49.14 49.21 46.23 52.53 42.06 54.4 36.81 54.53 36.46 54.66 36.11 54.78 35.75 56.3 30.82 56.45 25.81 55.48 20.77 54.3 14.67 51.32 9.64 46.25 5.95zM24.01 72.11C17.27 72.21 11.97 77.48 12.06 83.98 12.15 90.59 17.61 95.75 24.41 95.64 31.34 95.53 36.52 90.28 36.4 83.48 36.28 76.95 30.89 72.01 24.01 72.11zM137.44 89.64L99.81 85.63C96.86 85.32 94.68 88.31 95.88 91.02L111.22 125.61C112.42 128.32 116.11 128.71 117.85 126.32L140.13 95.74C141.89 93.34 140.38 89.96 137.44 89.64z",
    transform: "translate(29 21)"
  })));
})(_templateObject$f || (_templateObject$f = _taggedTemplateLiteral([""])));
var Coaching = styled(function Coaching(props) {
  var name = 'coaching';
  var viewBox = '0 0 209 246';
  return /*#__PURE__*/createElement(RegularIllustration, _extends({
    name: name
  }, props), /*#__PURE__*/createElement(MediumIcon, _extends({}, props, {
    name: name,
    size: props.size,
    viewBox: viewBox
  }), /*#__PURE__*/createElement("g", {
    fill: "none"
  }, /*#__PURE__*/createElement("polygon", {
    fill: PRIMARY_SAND,
    points: "161.46 242.07 9.42 242.07 27.44 43.84 179.48 43.84"
  }), /*#__PURE__*/createElement("path", {
    fill: PRIMARY_SAND,
    d: "M31.92,4.07 C21.03,4.07 12.21,12.89 12.21,23.78 C12.21,34.67 21.03,43.49 31.92,43.49 L182.98,43.49 L182.98,4.07 L31.92,4.07 Z"
  }), /*#__PURE__*/createElement("path", {
    fill: PRIMARY_BLACK,
    d: "M37.75,209.44 C36.31,209.44 34.96,208.54 34.45,207.1 C33.81,205.28 34.77,203.28 36.59,202.64 L48.76,198.35 L53.92,186.52 C54.31,185.63 55.05,184.94 55.97,184.62 L68.14,180.34 L73.29,168.51 C73.68,167.62 74.42,166.93 75.34,166.61 L88.94,161.82 C90.76,161.18 92.76,162.14 93.4,163.96 C94.04,165.78 93.08,167.78 91.26,168.42 L79.09,172.7 L73.94,184.53 C73.55,185.42 72.81,186.11 71.89,186.43 L59.72,190.71 L54.56,202.54 C54.17,203.43 53.43,204.12 52.51,204.44 L38.9,209.23 C38.53,209.38 38.14,209.44 37.75,209.44 Z"
  }), /*#__PURE__*/createElement("g", {
    fill: PRIMARY_BLACK,
    transform: "translate(5)"
  }, /*#__PURE__*/createElement("path", {
    d: "M133.48 197.69C132.11 196.32 129.9 196.32 128.53 197.69L123.12 203.1 117.71 197.69C116.34 196.32 114.13 196.32 112.76 197.69 111.39 199.06 111.39 201.27 112.76 202.64L118.17 208.05 112.76 213.46C111.39 214.83 111.39 217.04 112.76 218.41 113.44 219.09 114.34 219.44 115.23 219.44 116.12 219.44 117.02 219.1 117.7 218.41L123.11 213 128.52 218.41C129.2 219.09 130.1 219.44 130.99 219.44 131.88 219.44 132.78 219.1 133.46 218.41 134.83 217.04 134.83 214.83 133.46 213.46L128.05 208.05 133.46 202.64C134.85 201.27 134.85 199.06 133.48 197.69zM141.34 172.46L39.41 107.34C37.78 106.3 35.62 106.78 34.58 108.41 33.54 110.04 34.02 112.2 35.65 113.24L137.57 178.36C138.15 178.73 138.81 178.91 139.45 178.91 140.6 178.91 141.74 178.34 142.4 177.29 143.44 175.66 142.97 173.5 141.34 172.46z"
  }), /*#__PURE__*/createElement("path", {
    d: "M197.85,89.14 C202.54,59.28 206.65,33.07 199.9,16.14 C199.22,14.2 198.3,12.38 197.16,10.71 C197.15,10.69 197.13,10.66 197.12,10.64 C197.05,10.53 196.97,10.42 196.88,10.32 C192.67,4.42 185.77,0.57 177.99,0.57 L26.92,0.57 C14.12,0.57 3.71,10.98 3.71,23.78 C3.71,33.71 9.98,42.2 18.77,45.51 L0.93,241.75 C0.84,242.73 1.17,243.7 1.83,244.43 C2.49,245.16 3.43,245.57 4.41,245.57 L156.45,245.57 C158.26,245.57 159.77,244.19 159.94,242.39 L162.79,211.08 L199.02,211.55 C199.04,211.55 199.05,211.55 199.07,211.55 C200.3,211.55 201.43,210.91 202.07,209.86 C202.71,208.8 202.74,207.47 202.15,206.38 C184.52,174.02 191.6,128.93 197.85,89.14 Z M10.71,23.78 C10.71,14.84 17.98,7.57 26.92,7.57 L161.4,7.57 C157.31,11.76 154.78,17.48 154.78,23.78 C154.78,30.09 157.32,35.8 161.42,39.99 L26.92,39.99 C17.98,39.99 10.71,32.72 10.71,23.78 Z M153.27,238.57 L8.25,238.57 L25.64,47.34 L170.65,47.34 L153.27,238.57 Z"
  }), /*#__PURE__*/createElement("path", {
    d: "M83.94,161.82 L70.34,166.61 C69.42,166.93 68.68,167.62 68.29,168.51 L63.14,180.34 L50.97,184.62 C50.05,184.94 49.31,185.63 48.92,186.52 L43.76,198.35 L31.59,202.64 C29.77,203.28 28.81,205.28 29.45,207.1 C29.96,208.54 31.31,209.44 32.75,209.44 C33.14,209.44 33.53,209.38 33.91,209.24 L47.52,204.45 C48.44,204.13 49.18,203.44 49.57,202.55 L54.73,190.72 L66.9,186.44 C67.82,186.12 68.56,185.43 68.95,184.54 L74.1,172.71 L86.27,168.43 C88.09,167.79 89.05,165.79 88.41,163.97 C87.77,162.15 85.76,161.18 83.94,161.82 Z"
  })), /*#__PURE__*/createElement("g", {
    fill: iconTint(props.inverted),
    transform: "translate(0 57)"
  }, /*#__PURE__*/createElement("circle", {
    cx: "57.63",
    cy: "18.63",
    r: "12"
  }), /*#__PURE__*/createElement("circle", {
    cx: "90.704",
    cy: "148.229",
    r: "12",
    transform: "rotate(-13.286 90.704 148.23)"
  }), /*#__PURE__*/createElement("path", {
    d: "M133.49 65.32L186.22 30.77 166.58.65 113.8 35.26 109.69 28.98C107.68 25.92 102.98 26.79 102.21 30.37L94.55 65.84C94.06 68.09 95.51 70.3 97.77 70.76L133.35 77.91C136.94 78.63 139.62 74.67 137.61 71.6L133.49 65.32zM43.59 91.42L10.43 68.2C8 66.5 4.64 68.07 4.39 71.02L.86 111.35C.6 114.3 3.64 116.43 6.32 115.17L43.01 98.06C45.7 96.81 46.02 93.12 43.59 91.42z"
  })))));
})(_templateObject2$a || (_templateObject2$a = _taggedTemplateLiteral([""])));
var Coins = styled(function Coins(props) {
  var name = 'coins';
  var viewBox = '13 0 200 182';
  return /*#__PURE__*/createElement(RegularIllustration, _extends({
    name: name
  }, props), /*#__PURE__*/createElement(MediumIcon, _extends({}, props, {
    name: name,
    size: props.size,
    viewBox: viewBox
  }), /*#__PURE__*/createElement("g", {
    fill: "none"
  }, /*#__PURE__*/createElement("path", {
    fill: PRIMARY_BLACK,
    d: "M204.57 44.25l-5.02-7.72a4.53 4.53 0 00-3.46-2.06 4.53 4.53 0 00-3.74 1.48l-12.23 13.38a4.53 4.53 0 00-.47 5.57 4.54 4.54 0 005.27 1.86l17.25-5.66a4.56 4.56 0 002.4-6.85z"
  }), /*#__PURE__*/createElement("g", {
    fill: PRIMARY_BLACK
  }, /*#__PURE__*/createElement("path", {
    d: "M44.07 52.11a4.5 4.5 0 005.37-1.27 4.42 4.42 0 00.17-5.49l-10.5-14.38a4.54 4.54 0 00-7.16-.17l-5.76 7.05a4.47 4.47 0 001.61 6.91l16.27 7.35zM17.69 76.37l17.9.35a4.5 4.5 0 004.46-3.26 4.4 4.4 0 00-2.03-5.1l-15.4-9.06a4.5 4.5 0 00-3.98-.3 4.48 4.48 0 00-2.68 2.96l-2.5 8.72a4.45 4.45 0 004.23 5.7z"
  })), /*#__PURE__*/createElement("path", {
    fill: iconTint(props.inverted),
    d: "M211.7 114.55l-16.62-11.61a1.93 1.93 0 00-3.03 1.4l-1.78 20.12a1.93 1.93 0 002.74 1.9l18.4-8.5a1.92 1.92 0 00.29-3.3zM46.4 131.71l-20.12-1.73a1.94 1.94 0 00-1.92 2.75l8.46 18.39a1.92 1.92 0 003.31.28l11.66-16.66c.86-1.22.08-2.9-1.4-3.03z"
  }), /*#__PURE__*/createElement("path", {
    fill: PRIMARY_SAND,
    d: "M113.3 20.54l1.78.01 2.63.03 2.58.05 1.7.04 1.67.05 1.64.06 1.62.06 1.59.08 2.33.13 2.28.15 1.48.11 1.45.12 1.42.14 1.4.14.34.03.34.04 1.34.16 1.32.16 1.28.18 1.24.18.31.05.3.05 1.2.2.3.05.29.05 1.14.22.28.05.28.06 1.1.23.26.06.26.06 1.04.25 1 .26c7.05 1.9 11.16 4.68 11.31 8.5V45c0 4.03-4.36 6.92-11.91 8.87l-.42.1-1.03.25-.27.06-.27.06-1.09.24-1.13.22-.57.1-1.18.21-1.22.2-1.24.18-1.28.18-1.31.16-1.35.16-.34.04-.34.03-1.4.15-1.41.13-.36.03-.36.03-1.47.12-.37.02-.37.03-1.5.1-1.54.1-1.56.08-2.4.11-1.62.07-1.65.05-1.68.05-1.7.03-1.72.03-1.75.02-1.76.01h-5.35l-1.74-.03-1.72-.03-1.7-.03-1.68-.05-1.65-.05-1.63-.07-2.39-.1-.4-.03-.38-.02-1.55-.09-1.52-.1-1.5-.1-.36-.03-.37-.03-1.45-.12-.36-.03-.35-.04-1.41-.13-1.37-.15-1.35-.16-1.31-.16-1.28-.18-1.25-.18-1.21-.2-1.18-.2-1.15-.22-.55-.11-1.1-.24-.26-.06-.27-.06-1.03-.25c-7.67-1.91-12.18-4.76-12.33-8.75V32.55c.15-3.92 4.5-6.73 11.91-8.65l.42-.1 1.03-.25.27-.07.26-.06 1.1-.23 1.12-.22.58-.1 1.18-.21 1.21-.2 1.25-.19 1.28-.17 1.31-.17 1.35-.15.34-.04.34-.04 1.39-.14 1.42-.13.36-.03.36-.03 1.47-.12.37-.03.37-.02 1.5-.1 1.54-.1 1.56-.09 2.4-.1 1.62-.07 1.65-.05 1.68-.05 1.7-.03 1.72-.03 1.74-.02 1.77-.02h2.64z"
  }), /*#__PURE__*/createElement("path", {
    fill: PRIMARY_BLACK,
    d: "M113.3 20.54l1.78.01 2.63.03 2.58.05 1.7.04 1.67.05 1.64.06 1.62.06 1.59.08 2.33.13 2.28.15 1.48.11 1.45.12 1.42.14 1.4.14.34.03.34.04 1.34.16 1.32.16 1.28.18 1.24.18.31.05.3.05 1.2.2.3.05.29.05 1.14.22.28.05.28.06 1.1.23.26.06.26.06 1.04.25 1 .26c7.05 1.9 11.16 4.68 11.31 8.5V45c0 4.03-4.36 6.92-11.91 8.87l-.42.1-1.03.25-.27.06-.27.06-1.09.24-1.13.22-.57.1-1.18.21-1.22.2-1.24.18-1.28.18-1.31.16-1.35.16-.34.04-.34.03-1.4.15-1.41.13-.36.03-.36.03-1.47.12-.37.02-.37.03-1.5.1-1.54.1-1.56.08-2.4.11-1.62.07-1.65.05-1.68.05-1.7.03-1.72.03-1.75.02-1.76.01h-5.35l-1.74-.03-1.72-.03-1.7-.03-1.68-.05-1.65-.05-1.63-.07-2.39-.1-.4-.03-.38-.02-1.55-.09-1.52-.1-1.5-.1-.36-.03-.37-.03-1.45-.12-.36-.03-.35-.04-1.41-.13-1.37-.15-1.35-.16-1.31-.16-1.28-.18-1.25-.18-1.21-.2-1.18-.2-1.15-.22-.55-.11-1.1-.24-.26-.06-.27-.06-1.03-.25c-7.67-1.91-12.18-4.76-12.33-8.75V32.55c.15-3.92 4.5-6.73 11.91-8.65l.42-.1 1.03-.25.27-.07.26-.06 1.1-.23 1.12-.22.58-.1 1.18-.21 1.21-.2 1.25-.19 1.28-.17 1.31-.17 1.35-.15.34-.04.34-.04 1.39-.14 1.42-.13.36-.03.36-.03 1.47-.12.37-.03.37-.02 1.5-.1 1.54-.1 1.56-.09 2.4-.1 1.62-.07 1.65-.05 1.68-.05 1.7-.03 1.72-.03 1.74-.02 1.77-.02h2.64zm43.17 19.64c-1.3.52-2.77.98-4.39 1.4l-.6.16-1.04.25-.27.06-.27.06-1.09.24-1.13.22-.57.1-1.18.21-1.22.2-1.24.18-1.28.18-1.31.17-1.35.15-.34.04-.34.04-1.4.14-1.41.13-.36.03-.36.03-1.47.12-.37.03-.37.02-1.5.1-1.54.1-1.56.08-2.4.11-1.62.07-1.65.05-1.68.05-1.7.03-1.72.03-1.75.02-1.76.01h-1.8v6.8h.84l2.45-.02 2.43-.03 2.38-.06 1.56-.05 1.54-.06 1.52-.07 1.5-.07 1.48-.08 1.45-.1 2.12-.14 1.38-.11 1.36-.12 1.32-.12 1.3-.13 1.26-.14 1.23-.14 1.19-.15.3-.04.28-.03 1.15-.16 1.1-.17 1.07-.17.26-.04.26-.05 1-.18.25-.04.25-.05.94-.18.24-.05.22-.05.89-.2.84-.2.8-.2.75-.2c3.17-.93 5-1.97 5.12-3.08V40.18zm-43.2-14.2h-1.66l-2.46.01-2.42.04-2.38.06-1.56.05-1.55.06-1.52.06-1.5.08-1.47.08-1.45.09-2.12.15-1.39.1-1.35.12-1.32.13-1.3.13-1.26.13-1.23.15-1.2.14-.29.04-.29.04-1.14.16-1.1.17-1.07.17-.26.04-.26.04-1.01.18-.25.05-.24.04-.95.2-.23.04-.23.05-.88.2-.84.19-.8.2-.75.21c-3.27.95-5.13 2.04-5.13 3.19 0 1.11 1.74 2.16 4.82 3.1l.31.08.75.21.8.2.84.2.22.06.22.05.9.19.24.05.23.04.97.19.25.04.25.05 1.03.17.26.05.27.04 1.08.17 1.13.16 1.16.15.3.04.29.04 1.21.15 1.25.14 1.27.13 1.31.12 1.34.12 1.37.12 1.4.1 1.42.1 2.18.13 1.5.08 1.5.07 1.53.06 1.56.05 1.57.05 2.4.05 2.43.03 1.64.01h1.66l2.45-.02 2.43-.03 2.38-.06 1.56-.05 1.54-.06 1.52-.06 1.5-.08 1.48-.08 1.45-.1 2.12-.14 1.38-.1 1.36-.12 1.32-.13 1.3-.13 1.26-.13 1.23-.15 1.19-.15.3-.03.28-.04 1.15-.16 1.1-.17 1.07-.17.26-.04.26-.04 1-.18.25-.05.25-.05.94-.18.24-.05.22-.05.89-.2.84-.2.8-.2.75-.2c3.27-.96 5.13-2.04 5.13-3.2 0-1.1-1.74-2.16-4.82-3.08l-.31-.1-.75-.2-.8-.21-.84-.2-.22-.05-.22-.05-.9-.19-.24-.05-.23-.04-.97-.19-.25-.04-.25-.05-1.03-.17-.26-.05-.27-.04-1.09-.17-1.12-.16-1.16-.16-.3-.03-.3-.04-1.2-.15-1.25-.14-1.28-.13-1.3-.13-1.35-.12-1.36-.1-1.4-.11-1.42-.1-2.19-.13-1.48-.08-1.51-.07-1.53-.06-1.56-.06-1.57-.04-2.4-.05-2.43-.03-1.64-.01z"
  }), /*#__PURE__*/createElement("path", {
    fill: PRIMARY_SAND,
    d: "M116.47 68.9l1.75.32 2.6.49 2.53.5 1.66.33 1.63.34 1.6.34 1.59.35 1.55.35 2.28.53 2.22.55 1.43.36 1.41.37 1.38.38 1.35.38.33.1.33.1 1.3.38 1.26.39 1.23.4 1.2.4.29.1.3.1 1.13.4.29.1.27.1 1.1.42.26.1.26.1 1.04.42.25.1.25.11.98.43.94.43c6.61 3.1 10.18 6.54 9.66 10.33l-.03.22-2.13 12.04c-.7 3.97-5.5 6.05-13.27 6.66l-.43.04-1.07.06-.27.02h-.27l-1.12.05-1.14.02h-1.79l-1.23-.01-1.26-.04-1.29-.05-1.32-.06-1.35-.08-.34-.02-.35-.03-1.39-.1-1.42-.12-.36-.03-.36-.03-1.46-.14-.37-.04-.38-.03-1.5-.16-1.53-.18-1.55-.18-2.37-.31-1.62-.22-1.63-.24-1.66-.24-1.68-.26-1.7-.27-1.72-.29-1.74-.3-1.77-.3-1.76-.31-1.73-.32-1.72-.32-1.69-.33-1.67-.33-1.64-.34-1.62-.34-1.59-.34-2.33-.53-.39-.08-.38-.1-1.5-.35-1.49-.36-1.45-.37-.36-.09-.36-.09-1.4-.37-.35-.1-.34-.09-1.36-.38-1.33-.38-1.3-.39-1.26-.39-1.23-.4-1.2-.4-1.16-.4-1.13-.4-1.09-.42-.53-.2-1.03-.42-.25-.1-.25-.11-.98-.43c-7.22-3.22-11.16-6.8-10.62-10.76l.03-.22 2.12-12.04.05-.22c.83-3.83 5.6-5.85 13.23-6.45l.43-.03 1.06-.06.27-.02.28-.01 1.11-.04 1.15-.02h3.02l1.26.04 1.29.05 1.32.07 1.35.08.34.02.34.02 1.4.1 1.42.12.36.03.36.04 1.46.14.37.03.37.04 1.5.16 1.53.17 1.56.2 2.37.3 1.61.22 1.64.23 1.66.25 1.68.26 1.7.27 1.72.28 1.74.3 2.6.45z"
  }), /*#__PURE__*/createElement("path", {
    fill: PRIMARY_BLACK,
    d: "M116.47 68.9l1.75.32 2.6.49 2.53.5 1.66.33 1.63.34 1.6.34 1.59.35 1.55.35 2.28.53 2.22.55 1.43.36 1.41.37 1.38.38 1.35.38.33.1.33.1 1.3.38 1.26.39 1.23.4 1.2.4.29.1.3.1 1.13.4.29.1.27.1 1.1.42.26.1.26.1 1.04.42.25.1.25.11.98.43.94.43c6.61 3.1 10.18 6.54 9.66 10.33l-.03.22-2.13 12.04c-.7 3.97-5.5 6.05-13.27 6.66l-.43.04-1.07.06-.27.02h-.27l-1.12.05-1.14.02h-1.79l-1.23-.01-1.26-.04-1.29-.05-1.32-.06-1.35-.08-.34-.02-.35-.03-1.39-.1-1.42-.12-.36-.03-.36-.03-1.46-.14-.37-.04-.38-.03-1.5-.16-1.53-.18-1.55-.18-2.37-.31-1.62-.22-1.63-.24-1.66-.24-1.68-.26-1.7-.27-1.72-.29-1.74-.3-1.77-.3-1.76-.31-1.73-.32-1.72-.32-1.69-.33-1.67-.33-1.64-.34-1.62-.34-1.59-.34-2.33-.53-.39-.08-.38-.1-1.5-.35-1.49-.36-1.45-.37-.36-.09-.36-.09-1.4-.37-.35-.1-.34-.09-1.36-.38-1.33-.38-1.3-.39-1.26-.39-1.23-.4-1.2-.4-1.16-.4-1.13-.4-1.09-.42-.53-.2-1.03-.42-.25-.1-.25-.11-.98-.43c-7.22-3.22-11.16-6.8-10.62-10.76l.03-.22 2.12-12.04.05-.22c.83-3.83 5.6-5.85 13.23-6.45l.43-.03 1.06-.06.27-.02.28-.01 1.11-.04 1.15-.02h3.02l1.26.04 1.29.05 1.32.07 1.35.08.34.02.34.02 1.4.1 1.42.12.36.03.36.04 1.46.14.37.03.37.04 1.5.16 1.53.17 1.56.2 2.37.3 1.61.22 1.64.23 1.66.25 1.68.26 1.7.27 1.72.28 1.74.3 2.6.45zm39.1 26.85c-1.37.27-2.9.48-4.56.62l-.63.04-1.06.07-.27.01-.28.01-1.11.04c-.38.02-.76.02-1.15.03h-1.79l-1.22-.02-1.26-.03-1.3-.05-1.32-.06-1.35-.08-.34-.03-.34-.02-1.4-.1-1.42-.12-.36-.03-.36-.03-1.46-.14-.37-.04-.37-.04-1.5-.16-1.53-.17-1.55-.19-2.38-.3-1.61-.23-1.64-.23-1.66-.25-1.68-.25-1.7-.28-1.72-.28-1.74-.3-1.76-.3-1.18 6.69.81.14 2.43.41 2.39.39 2.35.35 1.55.23 1.53.2 1.51.2 1.49.2 1.46.17 1.45.16 2.12.22 1.38.14 1.35.12 1.33.1 1.3.1 1.26.09 1.23.07 1.2.06.3.01.3.02 1.15.04 1.11.03 1.08.01h2.05l.97-.02h.23l.24-.01.9-.04.87-.05.82-.06.77-.08c3.28-.35 5.28-1.06 5.58-2.14l.03-.1.83-4.74zm-40.08-21.5l-1.62-.29-2.43-.4-2.39-.39-2.36-.36-1.54-.22-1.53-.2-1.51-.2-1.5-.2-1.46-.17-1.44-.16-2.12-.23-1.38-.13-1.35-.12-1.33-.1-1.3-.1-1.26-.09-1.23-.07-1.2-.06-.3-.02h-.3l-1.15-.05-1.12-.03-1.08-.02h-2.05l-.96.02-.24.01h-.23l-.9.05-.87.05-.82.06-.77.08c-3.4.36-5.4 1.1-5.6 2.24-.2 1.1 1.33 2.44 4.2 3.88l.29.15.7.34.75.34.8.34.2.08.21.09.86.35.22.08.22.1.93.34.23.09.24.09.98.35.26.09.25.08 1.04.36 1.08.35 1.12.36.28.09.29.09 1.16.35 1.2.35 1.24.36 1.27.35 1.3.35 1.32.35 1.36.34 1.39.35 2.12.5 1.45.34 1.48.33 1.5.33 1.52.32 1.54.32 2.35.46 2.39.46 1.62.3 1.63.28 2.42.41 2.4.38 2.35.36 1.55.22 1.52.21 1.51.2 1.5.19 1.46.17 1.44.17 2.12.22 1.38.13 1.35.12 1.33.11 1.3.1 1.26.08 1.24.08 1.2.06.3.01.29.01 1.15.04 1.12.03 1.08.02h2.05l.96-.02h.24l.23-.01.9-.04.87-.05.82-.07.77-.07c3.4-.37 5.41-1.11 5.61-2.25.2-1.1-1.33-2.43-4.2-3.88l-.3-.15-.7-.33-.75-.34-.8-.34-.2-.09-.2-.09-.87-.34-.22-.09-.22-.09-.92-.35-.24-.08-.24-.1-.98-.34-.26-.1-.25-.08-1.04-.35-1.08-.36-1.11-.35-.29-.1-.28-.08-1.17-.36-1.2-.35-1.24-.35-1.27-.35-1.3-.35-1.32-.35-1.36-.35-1.38-.34-2.13-.51-1.45-.34-1.48-.33-1.5-.32-1.52-.33-1.54-.31-2.35-.47-2.39-.45-1.62-.3z"
  }), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
    fill: PRIMARY_SAND,
    d: "M110.4 136.06l1.67-.6 2.49-.88 2.44-.84 1.6-.54 1.59-.52 1.56-.5 1.55-.5 1.52-.47 2.24-.68 2.19-.63 1.43-.4 1.4-.39 1.38-.36 1.36-.34.33-.09.34-.08 1.31-.31 1.3-.3 1.26-.27 1.23-.25.3-.06.31-.06 1.2-.22.29-.05.29-.05 1.15-.2.28-.04.28-.04 1.1-.15.28-.04.27-.03 1.06-.12 1.02-.1c7.29-.62 12.1.57 13.54 4.12l.08.2 4.18 11.5c1.38 3.78-1.73 7.99-8.16 12.4l-.36.24-.89.6-.22.14-.24.15-.94.59-.98.6-.51.3-1.04.59-1.07.6-1.1.6-1.15.6-1.18.6-1.2.61-.31.16-.31.15-1.26.6-1.3.61-.32.16-.33.15-1.33.61-.34.15-.34.16-1.38.6-1.41.62-1.44.62-2.21.92-1.51.61-1.53.62-1.56.61-1.59.62-1.6.62-1.64.61-1.66.62-1.67.61-1.69.6-1.66.6-1.65.58-1.62.56-1.61.55-1.6.53-1.56.51-1.55.5-2.29.72-.38.11-.37.12-1.49.44-1.46.43-1.44.4-.36.1-.35.1-1.4.39-.35.09-.35.1-1.36.34-1.35.34-1.31.31-1.3.3-1.25.27-1.24.25-1.2.23-1.19.2-1.15.2-.56.08-1.1.15-.28.04-.27.03-1.06.12c-7.86.82-13.06-.31-14.58-4l-.08-.21-4.18-11.5-.07-.2c-1.2-3.74 1.93-7.87 8.24-12.2l.35-.24.9-.6.22-.14.23-.15.95-.59.98-.6.5-.3 1.04-.59 1.08-.6 1.1-.6 1.15-.6 1.17-.6 1.21-.61.31-.16.3-.15 1.27-.6 1.29-.61.32-.16.33-.15 1.34-.61.34-.15.34-.16 1.38-.6 1.41-.62 1.44-.62 2.2-.92 1.52-.61 1.53-.62 1.56-.61 1.58-.62 1.61-.62 1.63-.61 1.66-.62 2.48-.9z"
  }), /*#__PURE__*/createElement("path", {
    fill: PRIMARY_BLACK,
    d: "M110.4 136.06l1.67-.6 2.49-.88 2.44-.84 1.6-.54 1.59-.52 1.56-.5 1.55-.5 1.52-.47 2.24-.68 2.19-.63 1.43-.4 1.4-.39 1.38-.36 1.36-.34.33-.09.34-.08 1.31-.31 1.3-.3 1.26-.27 1.23-.25.3-.06.31-.06 1.2-.22.29-.05.29-.05 1.15-.2.28-.04.28-.04 1.1-.15.28-.04.27-.03 1.06-.12 1.02-.1c7.29-.62 12.1.57 13.54 4.12l.08.2 4.18 11.5c1.38 3.78-1.73 7.99-8.16 12.4l-.36.24-.89.6-.22.14-.24.15-.94.59-.98.6-.51.3-1.04.59-1.07.6-1.1.6-1.15.6-1.18.6-1.2.61-.31.16-.31.15-1.26.6-1.3.61-.32.16-.33.15-1.33.61-.34.15-.34.16-1.38.6-1.41.62-1.44.62-2.21.92-1.51.61-1.53.62-1.56.61-1.59.62-1.6.62-1.64.61-1.66.62-1.67.61-1.69.6-1.66.6-1.65.58-1.62.56-1.61.55-1.6.53-1.56.51-1.55.5-2.29.72-.38.11-.37.12-1.49.44-1.46.43-1.44.4-.36.1-.35.1-1.4.39-.35.09-.35.1-1.36.34-1.35.34-1.31.31-1.3.3-1.25.27-1.24.25-1.2.23-1.19.2-1.15.2-.56.08-1.1.15-.28.04-.27.03-1.06.12c-7.86.82-13.06-.31-14.58-4l-.08-.21-4.18-11.5-.07-.2c-1.2-3.74 1.93-7.87 8.24-12.2l.35-.24.9-.6.22-.14.23-.15.95-.59.98-.6.5-.3 1.04-.59 1.08-.6 1.1-.6 1.15-.6 1.17-.6 1.21-.61.31-.16.3-.15 1.27-.6 1.29-.61.32-.16.33-.15 1.34-.61.34-.15.34-.16 1.38-.6 1.41-.62 1.44-.62 2.2-.92 1.52-.61 1.53-.62 1.56-.61 1.58-.62 1.61-.62 1.63-.61 1.66-.62 2.48-.9zm47.28 3.69a39.55 39.55 0 01-3.64 2.82l-.52.35-.89.6-.23.14-.23.15-.94.59-.99.6-.5.3-1.04.59-1.07.6-1.11.6-1.14.6-1.18.6-1.21.61-.3.15-.32.16-1.25.6-1.3.61-.32.16-.33.15-1.34.6-.34.16-.34.15-1.38.62-1.4.61-1.45.61-2.2.93-1.51.61-1.54.62-1.56.61-1.58.62-1.6.61-1.64.62-1.66.62-1.68.61 2.33 6.38.77-.28 2.3-.86 2.27-.86 2.22-.87 1.45-.58 1.43-.58 1.4-.58 1.39-.59 1.36-.58 1.33-.58 1.94-.87 1.27-.57 1.23-.57 1.2-.57 1.17-.57 1.14-.56 1.1-.55 1.08-.55.26-.14.26-.13 1.02-.54.98-.53.95-.53.23-.13.23-.13.88-.51.22-.13.21-.13.83-.5.2-.12.2-.12.76-.49.72-.47.68-.47.64-.45c2.66-1.95 4.03-3.56 3.76-4.64l-.03-.1-1.65-4.53zm-45.45 1.42l-1.56.57-2.3.86-2.27.86-2.21.87-1.46.58-1.43.58-1.4.58-1.39.59-1.35.58-1.33.58-1.95.87-1.26.57-1.23.57-1.2.57-1.18.57-1.14.55-1.1.56-1.07.55-.27.13-.26.14-1.02.54-.98.53-.94.53-.23.13-.23.13-.89.51-.21.13-.22.12-.82.5-.2.13-.2.12-.77.49-.72.47-.68.47-.63.45c-2.75 2.01-4.13 3.67-3.73 4.75.38 1.04 2.37 1.44 5.58 1.26l.33-.02.78-.06.81-.08.86-.1.22-.03.23-.03.91-.13.24-.04.24-.03.97-.16.25-.04.25-.05 1.03-.18.26-.05.26-.05 1.08-.22 1.11-.23 1.15-.25.29-.07.29-.06 1.19-.28 1.22-.3 1.24-.3 1.28-.33 1.3-.35 1.32-.36 1.35-.38 1.37-.4 2.1-.62 1.42-.43 1.44-.45 1.46-.47 1.48-.48 1.5-.5 2.26-.77 2.3-.8 1.55-.55 1.55-.57 2.3-.86 2.27-.86 2.22-.87 1.45-.58 1.43-.58 1.4-.59 1.39-.58 1.36-.58 1.33-.58 1.94-.87 1.26-.57 1.24-.57 1.2-.57 1.17-.57 1.14-.56 1.1-.55 1.08-.55.26-.14.26-.13 1.02-.54.98-.53.94-.53.23-.13.23-.13.89-.51.22-.13.2-.13.84-.5.2-.12.2-.12.76-.49.72-.47.68-.47.63-.45c2.76-2.01 4.13-3.67 3.73-4.75-.38-1.05-2.37-1.44-5.58-1.26l-.33.02-.77.06-.82.08-.86.1-.22.03-.22.03-.92.13-.24.04-.23.03-.98.16-.25.04-.25.05-1.02.18-.27.05-.26.05-1.08.22-1.11.23-1.14.25-.3.06-.29.07-1.19.28-1.21.3-1.25.3-1.27.33-1.3.35-1.33.36-1.34.38-1.38.4-2.1.62-1.42.43-1.44.45-1.46.47-1.48.48-1.5.5-2.26.77-2.3.8-1.54.55z"
  })), /*#__PURE__*/createElement("path", {
    fill: iconTint(props.inverted),
    d: "M127 143.3l-7.76-9.62a2.4 2.4 0 01-.15-2.81l6.74-10.37a2.4 2.4 0 00-2.85-3.54l-11.54 4.42c-.96.37-2.06.08-2.71-.73l-7.76-9.62c-1.46-1.81-4.37-.7-4.26 1.63l.63 12.35a2.41 2.41 0 01-1.54 2.37l-11.53 4.42a2.4 2.4 0 00.23 4.55l11.93 3.21a2.4 2.4 0 011.77 2.2l.63 12.34a2.39 2.39 0 004.4 1.2l6.74-10.37a2.4 2.4 0 012.63-1.01l11.93 3.21c2.22.6 3.93-2.02 2.47-3.83z"
  }))));
})(_templateObject3$8 || (_templateObject3$8 = _taggedTemplateLiteral([""])));
var CrackedEgg = styled(function CrackedEgg(props) {
  var name = 'cracked-egg';
  var viewBox = '0 0 267 252';
  return /*#__PURE__*/createElement(RegularIllustration, _extends({
    name: name
  }, props), /*#__PURE__*/createElement(MediumIcon, _extends({}, props, {
    name: name,
    size: props.size,
    viewBox: viewBox
  }), /*#__PURE__*/createElement("g", {
    fill: "none"
  }, /*#__PURE__*/createElement("path", {
    fill: PRIMARY_SAND,
    d: "M105.4 101.54L136.41 50.55 168.81 70.26 190.9 33.94C189.14 31.98 187.35 30.07 185.51 28.27 165.13 8.37 141.96.32 120.26 5.61 120.25 5.61 120.24 5.62 120.23 5.62 91.09 12.74 71.71 43.74 67.29 83.57L105.4 101.54zM174.37 126.23L147.96 99.82 107.44 140.34 68.02 108.49C64.75 121.94 62.96 136.5 62.9699583 151.69 62.98 175.92 71.25 198.14 86.24 214.25 101.12 230.25 121.32 239.05 143.13 239.05 143.14 239.05 143.16 239.05 143.18 239.05 165.07 239.04 185.27 230.3 200.07 214.46 215.05 198.41 223.3 176.08 223.280036 151.59 223.27 128.89 219.42 107.18 212.24 88.36L174.37 126.23z"
  }), /*#__PURE__*/createElement("path", {
    fill: PRIMARY_BLACK,
    d: "M31.19 53.09C30.5 51.9 29.32 51.12 27.96 50.94 26.59 50.76 25.26 51.22 24.28 52.19L15.61 60.86C14.64 61.83 14.19 63.16 14.36 64.52 14.53 65.88 15.31 67.05 16.49 67.75L37.28 80C37.99 80.42 38.76 80.62 39.52 80.62 40.64 80.62 41.74 80.18 42.6 79.33 44.04 77.9 44.32 75.77 43.31 74.01L31.19 53.09zM30.84 97.99L9.78 86.1C8.58 85.42 7.17 85.35 5.9 85.88 4.63 86.42 3.71 87.49 3.37 88.82L.29 100.69C-.05 102.01.23 103.4 1.07 104.48 1.91 105.56 3.17 106.18 4.54 106.19L28.67 106.21C28.67 106.21 28.67 106.21 28.67 106.21 30.69 106.21 32.4 104.89 32.92 102.94 33.44 100.98 32.6 98.99 30.84 97.99zM214.51 87.11C214.09 86 213.13 85.18 211.97 84.93 210.81 84.68 209.6 85.04 208.76 85.88L192.01 102.63 177.62 89.87C176.24 88.65 174.15 88.7 172.84 89.99L157.34 105.25 149.43 97.34C148.06 95.97 145.85 95.97 144.48 97.34L138.44 103.38 117.4 86.89 136.58 55.36 166 73.24C167.65 74.24 169.8 73.72 170.81 72.07L192.9 35.75C193.7 34.43 193.55 32.74 192.51 31.59 190.48 29.33 188.67 27.43 186.96 25.76 165.69 4.98 141.35-3.38 118.43 2.2 118.42 2.2 118.41 2.21 118.39 2.21 88.84 9.43 67.54 40.46 62.8 83.18 62.63 84.67 63.43 86.09 64.79 86.73L87.83 97.6 77.29 112.3 69.21 105.77C68.28 105.02 67.02 104.79 65.89 105.18 64.75 105.56 63.89 106.5 63.61 107.67 60.18 121.78 58.45 136.59 58.4599569 151.69 58.48 176.81 67.07 199.87 82.67 216.63 98.22 233.34 119.34 242.55 142.18 242.55 165.05 242.54 186.16 233.41 201.63 216.84 217.22 200.14 225.8 176.96 225.790009 151.58 225.77 128.71 221.87 106.42 214.51 87.11zM70.06 81.47C74.97 43.03 93.99 15.37 120.05 9.01 120.06 9.01 120.07 9.01 120.07 9 120.07 9 120.08 9 120.08 9 140.57 4.01 162.58 11.74 182.06 30.76 183.16 31.83 184.31 33.02 185.55 34.35L166.64 65.44 137.23 47.55C135.58 46.55 133.43 47.07 132.42 48.72L103.04 97.02 70.06 81.47zM196.51 212.07C182.38 227.2 163.08 235.54 142.13 235.55 121.31 235.55 102.01 227.14 87.8 211.86 73.41 196.4 65.48 175.02 65.4699409 151.68 65.46 139.06 66.72 126.67 69.2 114.74L104.25 143.06C105.64 144.18 107.66 144.08 108.92 142.81L146.97 104.76 170.91 128.69C172.22 130 174.55 130 175.86 128.69L209.83 94.72C215.69 112.02 218.78 131.55 218.79 151.57 218.79 175.19 210.88 196.67 196.51 212.07z",
    transform: "translate(1)"
  }), /*#__PURE__*/createElement("path", {
    fill: iconTint(props.inverted),
    d: "M255.48 149.43C254.8 149.14 254 149.28 253.46 149.79L250.76 152.34C243.41 140.19 230.19 132.69 215.95 132.69 201.71 132.69 188.49 140.19 181.14 152.34L178.27 149.63C177.76 149.15 177.01 149.01 176.36 149.3 175.71 149.58 175.3 150.21 175.3 150.92L175.3 172.92C175.3 195.49 193.47 213.92 215.8 214 215.85 214 215.9 214 215.95 214 226.78 214 236.97 209.79 244.64 202.15 252.35 194.47 256.6 184.24 256.6 173.36L256.6 151.17C256.6 150.4 256.16 149.73 255.48 149.43zM215.26 33.2L242.12 29.31C245.05 28.89 246.43 25.44 244.59 23.12L227.79 1.8C225.96-.53 222.29 1.42108547e-14 221.19 2.76L211.13 27.97C210.03 30.71 212.33 33.62 215.26 33.2zM55.51 144.19L61.15 141.54C60.19 136.24 59.65 130.78 59.52 125.21L52.98 123.96C51.28 123.63 49.98 122.25 49.76 120.53L47.19 100.02C46.71 96.17 41.58 95.19 39.71 98.59L29.74 116.69C28.9 118.21 27.18 119.02 25.48 118.69L5.18 114.8C1.37 114.07-1.15 118.64 1.5 121.47L15.64 136.55C16.83 137.82 17.06 139.7 16.23 141.22L6.26 159.32C4.39 162.72 7.96 166.53 11.47 164.88L30.18 156.1C31.75 155.36 33.62 155.72 34.8 156.99L48.94 172.07C51.59 174.9 56.32 172.68 55.83 168.83L53.26 148.32C53.03 146.59 53.94 144.93 55.51 144.19z",
    transform: "translate(0 29)"
  }))));
})(_templateObject4$6 || (_templateObject4$6 = _taggedTemplateLiteral([""])));
var DeliveryMethods = styled(function DeliveryMethods(props) {
  var name = 'delivery-methods';
  var viewBox = '0 0 191 200';
  return /*#__PURE__*/createElement(RegularIllustration, _extends({
    name: name
  }, props), /*#__PURE__*/createElement(MediumIcon, _extends({}, props, {
    name: name,
    size: props.size,
    viewBox: viewBox
  }), /*#__PURE__*/createElement("rect", {
    width: "65.18",
    height: "68.75",
    x: "80.18",
    y: "33.82",
    fill: PRIMARY_SAND,
    transform: "rotate(.067 112.77 68.195)"
  }), /*#__PURE__*/createElement("rect", {
    width: "115.66",
    height: "73.73",
    x: "4.35",
    y: "81.81",
    fill: PRIMARY_SAND
  }), /*#__PURE__*/createElement("path", {
    fill: PRIMARY_BLACK,
    d: "M91.63,159.05 C89.7,159.05 88.13,157.48 88.13,155.55 L88.13,81.81 C88.13,79.88 89.7,78.31 91.63,78.31 C93.56,78.31 95.13,79.88 95.13,81.81 L95.13,155.54 C95.13,157.48 93.57,159.05 91.63,159.05 Z"
  }), /*#__PURE__*/createElement("rect", {
    width: "36.24",
    height: "73.73",
    x: "91.04",
    y: "81.81",
    fill: PRIMARY_SAND
  }), /*#__PURE__*/createElement("rect", {
    width: "107.443",
    height: "58.122",
    x: "70.361",
    y: "124.876",
    fill: PRIMARY_SAND,
    transform: "rotate(4.157 124.083 153.937)"
  }), /*#__PURE__*/createElement("path", {
    fill: PRIMARY_BLACK,
    d: "M186.81,134.14 L182.91,133.86 L183.26,129.09 C183.26,129.04 183.25,129 183.26,128.95 C183.27,128.8 183.26,128.65 183.25,128.5 C183.24,128.42 183.23,128.35 183.22,128.28 C183.21,128.21 183.21,128.15 183.19,128.08 C183.17,128.01 183.15,127.94 183.13,127.87 C183.11,127.8 183.09,127.73 183.06,127.66 C183.01,127.51 182.94,127.37 182.87,127.24 C182.84,127.19 182.82,127.14 182.8,127.09 C182.69,126.91 182.57,126.73 182.43,126.57 C182.43,126.57 182.42,126.56 182.42,126.56 C182.4,126.54 182.38,126.52 182.36,126.5 C182.24,126.37 182.11,126.24 181.97,126.13 C181.92,126.09 181.86,126.05 181.8,126.01 C181.68,125.93 181.57,125.85 181.44,125.78 C181.38,125.74 181.31,125.71 181.24,125.68 C181.11,125.62 180.97,125.57 180.83,125.52 C180.77,125.5 180.71,125.48 180.65,125.46 C180.45,125.41 180.24,125.37 180.02,125.35 L130.79,121.77 L130.79,106.09 L145.33,106.11 C145.33,106.11 145.33,106.11 145.33,106.11 L164.55,106.11 C166.48,106.11 168.05,104.54 168.05,102.61 L168.05,33.86 C168.05,31.93 166.48,30.36 164.55,30.36 L145.41,30.36 L144.49,30.36 L144.51,17.55 C144.52,8.03 136.78,0.27 127.26,0.26 C127.25,0.26 127.25,0.26 127.24,0.26 C124.83,0.26 122.5,0.76 120.35,1.7 C118.21,0.77 115.88,0.26 113.48,0.26 C113.47,0.26 113.47,0.26 113.46,0.26 C108.86,0.26 104.53,2.05 101.27,5.3 C98.01,8.56 96.2,12.89 96.2,17.5 L96.19,30.29 L80.25,30.27 C80.25,30.27 80.25,30.27 80.25,30.27 C79.32,30.27 78.43,30.64 77.78,31.29 C77.12,31.95 76.75,32.84 76.75,33.76 L76.7,78.3 L4.35,78.3 C2.42,78.3 0.85,79.87 0.85,81.8 L0.85,155.53 C0.85,157.46 2.42,159.03 4.35,159.03 L66.33,159.03 L64.9,178.74 C64.9,178.81 64.91,178.87 64.91,178.93 C64.91,179.06 64.91,179.18 64.92,179.31 C64.93,179.42 64.95,179.53 64.97,179.63 C64.99,179.74 65.02,179.86 65.05,179.97 C65.08,180.08 65.12,180.19 65.16,180.29 C65.2,180.39 65.25,180.49 65.3,180.59 C65.36,180.7 65.42,180.8 65.49,180.91 C65.53,180.97 65.55,181.02 65.59,181.08 C65.61,181.11 65.64,181.13 65.66,181.16 C65.78,181.31 65.91,181.45 66.06,181.58 C66.11,181.62 66.15,181.67 66.2,181.72 C66.39,181.88 66.6,182.01 66.83,182.13 C66.88,182.15 66.93,182.17 66.98,182.19 C67.16,182.27 67.34,182.34 67.53,182.39 C67.62,182.41 67.71,182.42 67.8,182.44 C67.91,182.46 68.02,182.49 68.14,182.5 L72.04,182.78 L71.69,187.55 C71.55,189.48 73,191.15 74.93,191.3 L182.09,199.09 C182.17,199.1 182.26,199.1 182.34,199.1 C183.18,199.1 183.99,198.8 184.63,198.25 C185.33,197.64 185.76,196.78 185.83,195.86 L190.04,137.89 C190.18,135.96 188.74,134.28 186.81,134.14 Z M99.58,155.77 C98.42,154.22 96.23,153.9 94.68,155.06 L72.44,171.64 L75.63,127.81 L105.33,150.74 C106.86,151.92 109.06,151.64 110.24,150.11 C111.42,148.58 111.14,146.38 109.61,145.2 L83.95,125.39 L167.92,131.49 L140.7,146.8 C139.02,147.75 138.42,149.88 139.37,151.57 C140.01,152.71 141.2,153.36 142.42,153.36 C143,153.36 143.59,153.21 144.13,152.91 L175.8,135.09 L172.61,178.99 L155.16,161.79 C153.79,160.43 151.57,160.45 150.21,161.83 C148.85,163.21 148.87,165.42 150.25,166.78 L166.33,182.63 L78.02,176.21 L98.86,160.67 C100.41,159.51 100.73,157.32 99.58,155.77 Z M94.54,119.13 L94.54,85.31 L105.66,85.31 L105.66,109.9 C105.66,111.83 107.23,113.4 109.16,113.4 C111.09,113.4 112.66,111.83 112.66,109.9 L112.66,85.31 L123.78,85.31 L123.78,121.25 L94.54,119.13 Z M137.500016,17.54 L137.48,30.35 L130.7,30.34 L130.72,17.55 C130.72,13.79 129.52,10.23 127.32,7.27 C132.94,7.31 137.51,11.9 137.500016,17.54 Z M116.97,17.52 C116.97,14.78 118.04,12.2 119.99,10.26 C120.1,10.15 120.23,10.04 120.35,9.94 C120.48,10.05 120.61,10.16 120.73,10.28 C122.67,12.22 123.73,14.8 123.73,17.54 L123.71,30.33 L116.96,30.32 L116.97,17.52 Z M103.18,17.52 C103.18,14.78 104.25,12.2 106.2,10.26 C108.12,8.34 110.66,7.29 113.37,7.27 C111.18,10.22 109.97,13.77 109.97,17.51 L109.95,30.32 L103.17,30.31 L103.18,17.52 Z M83.72,37.29 L141.9,37.36 L141.83,99.11 L130.79,99.1 L130.79,81.81 C130.79,79.88 129.22,78.31 127.29,78.31 L91.05,78.31 L91.05,78.31 L83.68,78.31 L83.72,37.29 Z M7.85,152.05 L7.85,85.31 L87.54,85.31 L87.54,118.62 L72.85,117.55 C72.64,117.54 72.43,117.54 72.22,117.57 C72.14,117.58 72.06,117.6 71.98,117.61 C71.85,117.63 71.73,117.66 71.61,117.69 C71.53,117.71 71.44,117.74 71.36,117.78 C71.24,117.82 71.13,117.88 71.01,117.93 C70.94,117.97 70.86,118 70.79,118.04 C70.65,118.12 70.52,118.22 70.39,118.32 C70.36,118.34 70.33,118.36 70.3,118.38 C70.29,118.38 70.29,118.39 70.29,118.39 C70.13,118.53 69.99,118.68 69.86,118.85 C69.82,118.9 69.79,118.95 69.76,119 C69.67,119.12 69.59,119.25 69.52,119.38 C69.48,119.45 69.45,119.52 69.42,119.59 C69.39,119.65 69.35,119.71 69.33,119.78 C69.31,119.84 69.29,119.91 69.27,119.97 C69.25,120.04 69.22,120.12 69.21,120.19 C69.17,120.34 69.15,120.49 69.13,120.64 C69.12,120.68 69.11,120.73 69.11,120.77 L66.84,152.02 L7.85,152.02 L7.85,152.05 Z"
  }), /*#__PURE__*/createElement("path", {
    fill: iconTint(props.inverted),
    d: "M17.48 1.27C16.61.39 15.19.39 14.32 1.27L.64 15.18C-.74 16.58.26 18.96 2.23 18.95L6.27 18.94 6.32 52.83 25.65 52.85 25.59 18.91 29.63 18.9C31.6 18.9 32.59 16.52 31.2 15.12L17.48 1.27zM110.58 25.74C98.81 25.19 88.8 34.29 88.24 46.04 87.68 57.8 96.79 67.82 108.54 68.38 108.89 68.4 109.23 68.4 109.58 68.4 111.69 68.4 113.77 68.09 115.78 67.48 117.88 66.84 118.94 64.41 117.79 62.37 116.97 60.92 115.21 60.35 113.61 60.82 112.08 61.27 110.49 61.46 108.88 61.38 100.98 61 94.86 54.27 95.24 46.37 95.62 38.47 102.36 32.36 110.25 32.73 118.15 33.11 124.27 39.84 123.89 47.74 123.79 49.9 123.22 51.96 122.2 53.84 121.36 54.96 120.66 54.72 120.43 54.64 119.53 54.33 118.62 53.11 118.74 51.17 118.93 47.93 119.17 43.23 119.29 40.83 119.33 39.98 118.68 39.26 117.83 39.22L116.08 39.13C115.9 38.89 115.71 38.67 115.46 38.49 113.75 37.22 111.72 36.49 109.59 36.38 106.75 36.25 104.02 37.23 101.91 39.14 99.8 41.06 98.57 43.68 98.43 46.52 98.29 49.37 99.27 52.09 101.19 54.2 103.11 56.31 105.73 57.54 108.57 57.68 108.74 57.69 108.91 57.69 109.08 57.69 110.46 57.69 111.83 57.41 113.09 56.9 114.2 58.92 115.95 60.48 118.13 61.24 121.79 62.51 125.7 61.1 128.07 57.65 128.11 57.58 128.16 57.5 128.21 57.43 129.83 54.54 130.72 51.38 130.88 48.06 131.44 36.32 122.34 26.3 110.58 25.74zM108.87 51.47C107.69 51.41 106.6 50.9 105.8 50.02 105 49.14 104.6 48.01 104.65 46.83 104.71 45.65 105.22 44.56 106.1 43.76 106.98 42.96 108.09 42.55 109.29 42.61 110.18 42.65 111.02 42.95 111.73 43.48 111.86 43.58 112 43.65 112.14 43.73 112.03 45.94 111.89 48.51 111.77 50.56 110.94 51.2 109.92 51.53 108.87 51.47z",
    transform: "translate(15 106)"
  })));
})(_templateObject5$5 || (_templateObject5$5 = _taggedTemplateLiteral([""])));
var EnvelopeWithHeart = styled(function EnvelopeWithHeart(props) {
  var name = 'envelope-with-heart';
  var viewBox = '0 0 192 178';
  return /*#__PURE__*/createElement(RegularIllustration, _extends({
    name: name
  }, props), /*#__PURE__*/createElement(MediumIcon, _extends({}, props, {
    name: name,
    size: props.size,
    viewBox: viewBox
  }), /*#__PURE__*/createElement("rect", {
    width: "175.992",
    height: "95.201",
    x: "8",
    y: "54.321",
    fill: PRIMARY_SAND,
    transform: "rotate(4.87 95.996 101.921)"
  }), /*#__PURE__*/createElement("path", {
    fill: PRIMARY_SAND,
    d: "M12.36,47.02 L87.35,106.42 C92.05,110.14 98.51,110.69 103.77,107.82 L187.72,61.96 L12.36,47.02 Z"
  }), /*#__PURE__*/createElement("path", {
    fill: PRIMARY_BLACK,
    d: "M191.22,61.84 C191.22,61.78 191.21,61.72 191.2,61.67 C191.2,61.61 191.19,61.55 191.18,61.5 C191.17,61.44 191.16,61.37 191.15,61.31 C191.15,61.29 191.15,61.27 191.14,61.25 C191.13,61.2 191.11,61.15 191.1,61.1 C191.09,61.06 191.08,61.02 191.07,60.98 C191.06,60.95 191.06,60.93 191.05,60.9 C191.05,60.89 191.05,60.89 191.05,60.88 C191.04,60.85 191.02,60.82 191.01,60.79 C190.98,60.72 190.95,60.64 190.92,60.57 C190.88,60.49 190.85,60.41 190.81,60.33 C190.8,60.3 190.78,60.27 190.76,60.25 C190.73,60.2 190.7,60.15 190.66,60.1 C190.61,60.01 190.55,59.93 190.49,59.85 C190.46,59.81 190.44,59.77 190.41,59.73 C190.41,59.73 190.4,59.72 190.4,59.72 C190.38,59.7 190.36,59.69 190.35,59.67 C190.28,59.59 190.21,59.52 190.14,59.46 C190.09,59.41 190.03,59.36 189.97,59.31 C189.95,59.3 189.94,59.28 189.92,59.27 C189.91,59.26 189.9,59.25 189.89,59.25 C189.83,59.21 189.77,59.17 189.72,59.13 C189.66,59.09 189.6,59.04 189.54,59 C189.49,58.97 189.44,58.94 189.39,58.91 C189.34,58.88 189.29,58.86 189.24,58.84 C189.18,58.81 189.13,58.78 189.07,58.76 C188.98,58.72 188.89,58.7 188.8,58.67 C188.75,58.65 188.7,58.63 188.65,58.62 C188.62,58.61 188.59,58.6 188.56,58.59 C188.38,58.55 188.2,58.52 188.02,58.5 L12.66,43.53 C12.47,43.51 12.28,43.51 12.1,43.53 C12.07,43.53 12.05,43.54 12.02,43.54 C11.96,43.55 11.89,43.56 11.83,43.57 C11.74,43.58 11.65,43.6 11.56,43.62 C11.52,43.63 11.48,43.65 11.44,43.66 C11.43,43.66 11.42,43.67 11.41,43.67 C11.34,43.69 11.27,43.71 11.21,43.73 C11.16,43.75 11.11,43.77 11.06,43.79 C11.01,43.81 10.97,43.83 10.92,43.86 C10.87,43.88 10.81,43.91 10.76,43.93 C10.7,43.96 10.64,43.99 10.58,44.03 C10.53,44.06 10.48,44.1 10.43,44.13 C10.35,44.19 10.27,44.24 10.19,44.3 C10.12,44.35 10.06,44.41 10,44.47 C9.92,44.54 9.85,44.61 9.78,44.69 C9.75,44.72 9.72,44.75 9.69,44.78 C9.65,44.82 9.62,44.87 9.59,44.92 C9.54,44.98 9.5,45.05 9.46,45.11 C9.42,45.17 9.38,45.23 9.35,45.29 C9.32,45.34 9.3,45.38 9.27,45.42 C9.27,45.42 9.27,45.43 9.26,45.43 C9.23,45.48 9.22,45.54 9.19,45.59 C9.17,45.63 9.14,45.68 9.13,45.72 C9.12,45.75 9.11,45.78 9.1,45.81 C9.08,45.86 9.06,45.91 9.04,45.96 C9.02,46.01 9.01,46.07 9,46.12 C8.98,46.19 8.96,46.26 8.95,46.33 C8.93,46.42 8.92,46.51 8.91,46.6 C8.91,46.63 8.89,46.67 8.89,46.7 L0.81,141.56 C0.73,142.48 1.02,143.4 1.62,144.11 C2.22,144.82 3.07,145.26 4,145.34 L179.36,160.28 C179.46,160.29 179.56,160.29 179.66,160.29 C181.46,160.29 182.99,158.91 183.14,157.09 L191.22,62.23 C191.22,62.19 191.22,62.16 191.22,62.12 C191.21,62.05 191.22,61.95 191.22,61.84 Z M102.09,104.75 C98.06,106.96 93.12,106.53 89.52,103.68 L23.65,51.5 L175.84,64.47 L102.09,104.75 Z M15.15,55.53 L54.77,100.89 L8.41,134.55 L15.15,55.53 Z M63.5,103.21 L87.28,124.72 C89.68,126.89 92.78,128.01 95.89,128.01 C98.18,128.01 100.48,127.4 102.51,126.17 L128.68,110.28 L130.19,111.81 L170.48,152.54 L13.94,139.19 L63.5,103.21 Z M176.79,148.97 L138.16,109.91 L183.5,70.3 L176.79,148.97 Z"
  }), /*#__PURE__*/createElement("path", {
    fill: iconTint(props.inverted),
    d: "M116.17,14.08 C108.57,14.08 101.99,18.43 98.77,24.77 C95.55,18.43 88.97,14.08 81.37,14.08 C70.6,14.08 61.86,22.81 61.86,33.59 C61.86,58.84 91.13,82.06 98.77,82.06 C106.41,82.06 135.68,55.67 135.68,33.59 C135.68,22.81 126.94,14.08 116.17,14.08 Z"
  })));
})(_templateObject6$5 || (_templateObject6$5 = _taggedTemplateLiteral([""])));
var HeartWithConfetti = styled(function HeartWithConfetti(props) {
  var name = 'heart-with-confetti';
  var viewBox = '0 0 259 257';
  return /*#__PURE__*/createElement(RegularIllustration, _extends({
    name: name
  }, props), /*#__PURE__*/createElement(MediumIcon, _extends({}, props, {
    name: name,
    size: props.size,
    viewBox: viewBox
  }), /*#__PURE__*/createElement("polygon", {
    fill: PRIMARY_SAND,
    points: "123.115 51.178 168.431 4.827 169.365 28.404 190.26 31.791 122.308 93.719"
  }), /*#__PURE__*/createElement("path", {
    fill: PRIMARY_BLACK,
    d: "M196.885355,220.707649 L190.897121,214.739181 C196.07843,209.532646 196.715476,195.140598 186.013101,184.346562 L191.958865,178.378095 C205.804,192.304518 205.676591,211.860772 196.885355,220.707649 Z"
  }), /*#__PURE__*/createElement("path", {
    fill: PRIMARY_SAND,
    d: "M130.335272,254.571362 C141.68444,254.577281 152.97829,252.995661 163.886367,249.872711 L203.000997,211.395147 L203.000997,165.679228 L113.814543,253.428394 C119.287708,254.195415 124.808272,254.577325 130.335272,254.571362 Z"
  }), /*#__PURE__*/createElement("path", {
    fill: PRIMARY_BLACK,
    d: "M168.795047,241.49276 C170.326764,240.747731 172.171652,241.387072 172.915719,242.920769 C173.659787,244.454465 173.02127,246.301737 171.489553,247.046766 C158.321489,253.451726 141.129935,255.998584 119.646353,254.277327 C117.9489,254.141328 116.68295,252.653243 116.818774,250.953597 C116.954598,249.253951 118.440762,247.986365 120.138214,248.122364 C140.594509,249.761315 156.701332,247.375156 168.795047,241.49276 Z"
  }), /*#__PURE__*/createElement("path", {
    fill: PRIMARY_BLACK,
    d: "M98.1412857 194.345213L77.8832196 194.345213 79.8368276 174.323334C79.9606437 173.057164 79.5444918 171.797467 78.6901447 170.852311 77.8545941 169.877525 76.6208028 169.332713 75.3350352 169.370777L55.0769691 169.370777 57.0305771 149.348898C57.1543932 148.082727 56.7382412 146.82303 55.8838941 145.877874 55.0180528 144.94444 53.8041728 144.40842 52.5287847 144.39634L32.2707186 144.39634 34.2243266 124.374461C34.3571235 123.106072 33.9421288 121.841284 33.0830592 120.896195 32.2239897 119.951107 31.0020147 119.415016 29.7225342 119.421903L9.63434702 119.421903 11.5879551 99.4000239C11.7588587 96.9473344 9.93537224 94.8066384 7.47943523 94.5767952 5.02349822 94.3469519 2.83206964 96.1119051 2.5419004 98.5534328L.121125202 123.52787C.00776272868 124.792863.422571215 126.048494 1.26780819 126.998893 2.13061233 127.936552 3.34643105 128.473427 4.62291767 128.480427L24.8809838 128.480427 22.9273757 148.459977C22.7945788 149.728365 23.2095735 150.993154 24.0686431 151.938242 24.9277126 152.883331 26.1496876 153.419422 27.4291682 153.412535L47.6872343 153.412535 45.7336262 173.434414C45.6008293 174.702802 46.0158241 175.967591 46.8748936 176.912679 47.7339631 177.857767 48.9559381 178.393859 50.2354187 178.386972L70.4934848 178.386972 68.5398767 198.408851C68.4160607 199.675021 68.8322126 200.934718 69.6865597 201.879874 70.5654916 202.819789 71.7950335 203.355938 73.0841389 203.361408L98.3111646 203.361408C100.031733 203.527777 101.698003 202.70676 102.610129 201.243192 103.522255 199.779624 103.522255 197.926998 102.610129 196.46343 101.698003 194.999861 100.031733 194.178845 98.3111646 194.345213L98.1412857 194.345213zM74.5281101 62.0653574C75.5757168 63.3313794 77.1287542 64.0743767 78.7750841 64.0971759 79.6440744 64.0872426 80.4999727 63.8848184 81.2807988 63.5045622 83.5665976 62.4535108 84.869189 60.0127223 84.4660293 57.5360951L80.2190553 35.4823975C79.8808675 33.7417464 78.7512114 32.2561479 77.161234 31.4610899 75.5631444 30.6999512 73.7054245 30.6999512 72.1073349 31.4610899L61.7022486 36.3713181C60.2258603 37.1573041 59.1714906 38.551231 58.819664 40.1822319 58.4678375 41.8132329 58.8542342 43.5159021 59.8760497 44.8372289L74.5281101 62.0653574zM31.5062632 75.7801328L51.7643293 85.6852484C54.07591 86.8060949 56.8543738 86.243284 58.5436123 84.312024 60.2328507 82.3807641 60.4134179 79.5605961 58.9841852 77.4309854L46.2432631 58.8483113C45.2771203 57.4274571 43.7134259 56.523508 41.9962891 56.3931971 40.2359675 56.3042541 38.5312415 57.021305 37.3670874 58.3403566L29.8924131 66.8062674C28.7120578 68.1160222 28.2376944 69.912653 28.6183209 71.6318365 28.8826247 73.3864798 29.9496776 74.9192151 31.5062632 75.7801328L31.5062632 75.7801328zM230.476996 58.9752999L221.983048 51.3559802C220.652486 50.2076813 218.877248 49.7110138 217.141498 50.0014345 215.330476 50.2518067 213.750432 51.3541869 212.894524 52.9645033L202.489437 72.9017232C201.253385 75.1868305 201.745305 78.0180756 203.680321 79.7558508 205.615337 81.4936259 208.491681 81.6873091 210.643628 80.224736L229.585132 67.9491654C231.045326 67.0001281 231.997371 65.4445517 232.175786 63.71621 232.382679 61.9582878 231.754385 60.2048712 230.476996 58.9752999zM202.616847 144.480999L140.865844 82.214225 192.933746 35.6517157C194.244403 34.4692751 194.756599 32.6413369 194.250308 30.9531352 193.763467 29.2886212 192.358028 28.0526221 190.64038 27.7784187L172.548271 24.900009 171.741346 4.58182314C171.670178 2.79011942 170.545208 1.2089454 168.872313.549325083 167.199417-.11029523 165.293593.275840857 164.011853 1.53409526L116.827971 49.0701843C115.969689 49.8853843 115.49236 51.0210535 115.511409 52.2025713L114.407196 110.786674C114.517886 112.139148 115.122298 113.404223 116.105986 114.342356L181.679265 180.291801 109.480706 252.717668C113.175574 253.394941 116.955381 253.902896 120.777657 254.241532L188.007256 186.852882C196.883432 194.853168 195.56687 210.557433 190.300622 215.848627L154.031464 252.252043C160.251415 250.95955 166.347367 249.132552 172.250982 246.791531L202.871665 216.144934C203.756642 215.327203 204.250801 214.172841 204.231287 212.970217L204.231287 147.486397C204.110358 146.312005 203.530517 145.232193 202.616847 144.480999zM134.070686 74.0022916L134.070686 74.0022916C133.47611 73.3673483 119.503565 59.0176295 130.121 48.3929114L130.121 48.3929114 163.884444 14.5292683 164.47902 28.2863733C164.576357 30.4256988 166.176962 32.1982785 168.301297 32.5193287L180.659991 34.5088178 135.217369 75.1451895 134.070686 74.0022916z",
    transform: "translate(.13 .203)"
  }), /*#__PURE__*/createElement("g", {
    fill: iconTint(props.inverted),
    transform: "translate(24.236 86.234)"
  }, /*#__PURE__*/createElement("ellipse", {
    cx: "14.238",
    cy: "120.463",
    rx: "13.633",
    ry: "13.757"
  }), /*#__PURE__*/createElement("ellipse", {
    cx: "218.009",
    cy: "65.167",
    rx: "13.632",
    ry: "13.758",
    transform: "rotate(-9.22 218.01 65.167)"
  }), /*#__PURE__*/createElement("path", {
    d: "M131.071884,0.0772949408 C119.510872,0.121294949 108.96907,6.67792873 103.84878,17.0091165 C98.7506977,6.67767002 88.2195865,0.117451523 76.6681463,0.0772949408 C59.7597062,0.193778653 46.1276948,13.9132567 46.1747508,30.7662215 C46.1747508,70.5983318 91.9147831,107.255725 103.84878,107.255725 C115.782777,107.255725 161.565279,65.6881035 161.565279,30.7662215 C161.612335,13.9132567 147.980324,0.193778653 131.071884,0.0772949408 Z"
  }))));
})(_templateObject7$3 || (_templateObject7$3 = _taggedTemplateLiteral([""])));
var Hourglass = styled(function Hourglass(props) {
  var name = 'hourglass';
  var viewBox = '0 0 178 183';
  return /*#__PURE__*/createElement(RegularIllustration, _extends({
    name: name
  }, props), /*#__PURE__*/createElement(MediumIcon, _extends({}, props, {
    name: name,
    size: props.size,
    viewBox: viewBox
  }), /*#__PURE__*/createElement("path", {
    fill: PRIMARY_SAND,
    d: "M135.8,151.41 L135.76,150.89 C135.49,147.74 133.59,145.34 131.51,145.51 L127.89,145.82 L126.85,133.56 L126.8,133.56 C124.59,116.83 112.97,103.12 98.39,97.6 C90.85,94.75 88.44,90.16 87.89,83.75 C87.35,77.34 90.68,71.51 95.92,68.53 L95.92,68.53 C109.66,60.38 118.51,45.17 117.87,28.31 L117.92,28.31 L116.87,15.89 L120.29,15.6 C122.37,15.42 123.84,12.73 123.58,9.58 L123.54,9.06 C123.27,5.91 121.37,3.51 119.29,3.68 L23.11,11.83 C21.03,12.01 19.56,14.7 19.82,17.85 L19.86,18.37 C20.13,21.52 22.03,23.92 24.11,23.75 L27.53,23.46 L28.58,35.88 L28.63,35.88 C30.97,53.62 44.25,67.61 59.78,72.8 C65.88,74.84 67.58,79.91 68.05,85.45 C68.56,91.44 65.68,96.92 61.02,100.05 C46.41,107.96 36.88,123.66 37.54,141.14 L37.49,141.14 L38.53,153.4 L35.31,153.67 C33.23,153.85 31.76,156.54 32.02,159.69 L32.06,160.21 C32.33,163.36 34.23,165.76 36.31,165.59 L132.49,157.44 C134.6,157.25 136.07,154.56 135.8,151.41 Z"
  }), /*#__PURE__*/createElement("path", {
    fill: iconTint(props.inverted),
    d: "M76.11,107.22 L48.66,133.57 C45.01,137.07 47.95,142.81 53.16,142.37 L112.45,137.35 C117.68,136.91 119.59,130.72 115.38,127.9 L83.54,106.57 C81.26,105.05 78.09,105.32 76.11,107.22 Z"
  }), /*#__PURE__*/createElement("path", {
    fill: PRIMARY_BLACK,
    d: "M139.29,151.11 L139.25,150.59 C139.06,148.39 138.29,146.33 137.06,144.78 C135.53,142.84 133.4,141.84 131.21,142.02 L131.08,142.03 L130.34,133.25 C130.32,132.98 130.26,132.72 130.18,132.48 C127.68,115.36 115.75,100.42 99.63,94.32 C93.3,91.92 91.81,88.52 91.38,83.45 C90.97,78.63 93.44,73.97 97.66,71.57 C97.72,71.54 97.78,71.5 97.83,71.47 C112.84,62.51 121.82,46.22 121.4,28.81 C121.44,28.55 121.45,28.28 121.42,28.01 L120.66,19.07 C122.82,18.86 124.72,17.52 125.89,15.38 C126.84,13.65 127.26,11.48 127.07,9.29 L127.03,8.77 C126.84,6.57 126.07,4.51 124.84,2.96 C123.31,1.02 121.18,0.01 118.99,0.2 L22.81,8.35 C18.74,8.7 15.89,13 16.33,18.15 L16.37,18.67 C16.79,23.6 20.04,27.26 23.89,27.26 C24.04,27.26 24.19,27.25 24.34,27.24 L25.1,36.18 C25.12,36.45 25.18,36.71 25.26,36.95 C27.87,54.85 40.93,70.18 58.69,76.11 C62.4,77.35 64.11,80.14 64.58,85.74 C64.96,90.19 62.9,94.51 59.22,97.05 C43.44,105.67 33.61,122.7 34.05,140.63 C34.01,140.89 34,141.16 34.03,141.43 L34.77,150.22 C30.84,150.73 28.13,154.95 28.56,159.98 L28.6,160.5 C29.02,165.43 32.27,169.09 36.12,169.09 C36.29,169.09 36.46,169.08 36.63,169.07 L132.81,160.92 C136.88,160.57 139.73,156.27 139.29,151.11 Z M62.71,103.11 C62.81,103.06 62.9,103 63,102.94 C68.88,98.99 72.16,92.17 71.56,85.14 C71.3,82.06 70.5,72.67 60.91,69.47 C45.7,64.39 34.13,50.7 32.11,35.41 C32.09,35.26 32.06,35.11 32.02,34.97 L31.31,26.64 L46.39,25.36 C48.32,25.2 49.75,23.5 49.58,21.58 C49.42,19.65 47.72,18.22 45.8,18.39 L24.13,20.23 C23.88,19.96 23.44,19.23 23.34,18.07 L23.3,17.55 C23.2,16.39 23.51,15.59 23.71,15.29 L119.26,7.2 C119.51,7.47 119.95,8.2 120.05,9.36 L120.09,9.88 C120.19,11.04 119.88,11.84 119.68,12.14 L97.04,14.06 C95.11,14.22 93.69,15.92 93.85,17.84 C94.01,19.76 95.7,21.2 97.63,21.03 L113.68,19.67 L114.39,27.99 C114.38,28.14 114.37,28.29 114.38,28.44 C114.95,43.57 107.19,57.78 94.14,65.52 C94.12,65.53 94.09,65.55 94.07,65.56 C87.56,69.33 83.77,76.57 84.41,84.05 C85.14,92.63 89.07,97.81 97.16,100.87 C111.1,106.14 121.37,119.15 123.33,134.01 C123.35,134.16 123.38,134.3 123.42,134.45 L124.11,142.62 L41.74,149.6 L41.05,141.44 C41.06,141.29 41.07,141.14 41.06,140.98 C40.47,125.41 48.97,110.55 62.71,103.11 Z M131.9,153.97 L36.35,162.06 C36.1,161.79 35.66,161.06 35.56,159.9 L35.52,159.38 C35.42,158.22 35.73,157.42 35.93,157.12 L131.48,149.03 C131.73,149.3 132.17,150.03 132.27,151.19 L132.31,151.71 C132.41,152.87 132.11,153.66 131.9,153.97 Z"
  }), /*#__PURE__*/createElement("path", {
    fill: PRIMARY_BLACK,
    d: "M19.79 63.79C17.8 63.13 15.86 62.32 13.96 61.38 17.73 65.44 22.19 68.91 27.2 71.59 26.15 68.09 24.04 65.2 19.79 63.79zM111.06 154.28L111.04 153.94C110.85 149.95 107.46 146.86 103.48 147.02L102.85 134.02C102.84 133.76 102.79 133.51 102.72 133.26 100.84 116.05 89.45 100.69 73.55 94.01 67.31 91.39 65.94 87.94 65.7 82.85 65.46 78.02 68.09 73.45 72.4 71.2 72.46 71.17 72.52 71.14 72.58 71.1 87.9 62.68 97.46 46.72 97.66 29.31 97.71 29.05 97.73 28.78 97.71 28.51L97.08 15.51C99 15.4 100.76 14.56 102.05 13.13 103.36 11.69 104.02 9.82 103.93 7.88L103.91 7.53C103.82 5.59 102.97 3.8 101.53 2.49 100.09 1.18 98.21.51 96.28.61L83.62 1.23C83.64 4.08 82.24 6.42 80.3 6.58L76.88 6.87 77.93 19.29 77.88 19.29C78.51 36.15 69.67 51.36 55.93 59.51L55.93 59.51C50.68 62.49 47.35 68.32 47.9 74.73 48.44 81.14 50.86 85.72 58.4 88.58 72.97 94.09 84.6 107.81 86.81 124.54L86.86 124.54 87.9 136.8 91.52 136.49C93.6 136.31 95.51 138.72 95.77 141.87L95.81 142.39C96.08 145.54 94.6 148.23 92.52 148.41L.64 156.19C.24 157.15.03 158.21.09 159.32L.11 159.67C.3 163.56 3.53 166.6 7.38 166.6 7.5 166.6 7.62 166.6 7.74 166.59L104.15 161.89C106.09 161.8 107.88 160.95 109.19 159.51 110.5 158.07 111.15 156.23 111.06 154.28z",
    transform: "translate(40 9)"
  })));
})(_templateObject8$3 || (_templateObject8$3 = _taggedTemplateLiteral([""])));
var Okpal = styled(function Okpal(props) {
  var name = 'okpal';
  var viewBox = '0 0 210 263';
  return /*#__PURE__*/createElement(RegularIllustration, _extends({
    name: name
  }, props), /*#__PURE__*/createElement(MediumIcon, _extends({}, props, {
    name: name,
    size: props.size,
    viewBox: viewBox
  }), /*#__PURE__*/createElement("g", {
    fill: "none"
  }, /*#__PURE__*/createElement("path", {
    fill: PRIMARY_SAND,
    d: "M169.76,241.54 C169.48,241.54 169.2,241.56 168.92,241.58 L166.48,189.97 L163.36,123.84 C162.99,116.02 159.46,108.68 153.58,103.51 L115.93,70.39 L126,13.98 L100.91,4.22 L85.58,9.79 L85.58,21.64 L64.68,17.46 L82.48,70.38 L27.51,115.33 C21.78,120.02 18.31,126.93 17.99,134.33 L13.32,241.54 C13.27,241.54 13.21,241.53 13.16,241.53 C8.23,241.53 4.23,245.53 4.23,250.46 C4.23,255.18 7.9,259.04 12.54,259.36 L12.54,259.39 L169.45,259.39 C174.21,259.39 178.36,255.8 178.66,251.06 C179.01,245.87 174.89,241.54 169.76,241.54 Z"
  }), /*#__PURE__*/createElement("g", {
    fill: iconTint(props.inverted),
    transform: "translate(36 134)"
  }, /*#__PURE__*/createElement("path", {
    d: "M49.41,7.2 C36.56,7.2 23.7,7.24 10.85,7.16 C8.62,7.14 7.86,7.75 7.88,10.07 C8.05,26.74 8.13,43.41 8.12,60.07 C8.12,62.27 8.96,62.62 10.89,62.67 C16.66,62.83 22.47,62.83 28.16,63.62 C33,64.29 37.12,66.94 40.38,70.74 C41.58,72.15 41.6,73.22 40.16,74.54 C36.94,77.49 37.03,77.51 33.99,74.44 C30.73,71.16 26.55,69.97 22.1,69.8 C17.45,69.63 12.78,69.76 8.12,69.73 C3.56,69.7 1.11,67.33 1.08,62.81 C0.96,44.27 0.87,25.72 0.81997137,7.18 C0.81,2.64 3.42,0.08 8.01,0.08 C36.43,0.06 64.84,0.06 93.26,0.1 C94.08,0.1 94.89,0.56 95.7,0.8 C95.3,1.54 94.96,2.32 94.48,3.01 C92.08,6.48 88.82,7.39 84.61,7.28 C72.87,7.01 61.14,7.21 49.41,7.2 Z"
  }), /*#__PURE__*/createElement("path", {
    d: "M54.28 32.31C54.08 35.45 54.13 38.63 53.63 41.72 51.96 51.99 42.2 58.78 31.32 57.44 20.99 56.16 14.42 49.4 13.76 39 13.52 35.2 13.45 31.31 14.01 27.56 15.51 17.44 25.19 10.84 35.89 11.85 46.51 12.86 54.79 21.05 54.28 32.31zM46.48 34.57C46.39 32.81 46.4 31.08 46.18 29.37 45.38 23.04 40.5 18.98 33.82 19.0098349 27.19 19.04 22.13 23.02 21.5 29.13 21.14 32.61 21.13 36.19 21.47 39.67 22.11 46.13 27.28 50.46 33.79 50.4 40.46 50.34 45.35 46.15 46.17 39.69 46.4 37.99 46.39 36.25 46.48 34.57zM82.69 69.76C76.15 69.76 69.62 69.85 63.08 69.71 60.93 69.67 59.43 70.38 57.94 71.85 53.3 76.45 48.58 80.96 43.82 85.44 41.41 87.71 38.37 87.16 37.59 84.29 37.35 83.38 37.58 81.9 38.2 81.28 44.09 75.38 50.05 69.56 56.14 63.87 57.04 63.03 58.73 62.7 60.06 62.7 73.21 62.62 86.36 62.65 99.5 62.65 103 62.65 103 62.64 102.99 59.04 102.97 49.28 102.95 39.53 102.94 29.77 102.94 27.47 106.25 22.55 108.37 21.89 108.75 21.77 109.52 22.25 109.82 22.66 110.08 23.02 109.95 23.67 109.96 24.2 110.02 36.96 110.09 49.71 110.120031 62.47 110.13 67.38 107.74 69.75 102.75 69.77 96.06 69.78 89.37 69.76 82.69 69.76zM59.23 39.5C59.23 36.27 59.2 33.04 59.24 29.81 59.27 27.03 60.7 25.37 62.95 25.36 65.33 25.35 66.82 27.03 66.86 29.9 66.9 32.9 66.85 35.91 66.88 38.91 66.89 39.55 67.1 40.18 67.22 40.82 67.75 40.46 68.35 40.17 68.79 39.73 77.67 30.76 86.53 21.78 95.4 12.8 97.93 10.23 100.46 7.66 103.01 5.11 105.16 2.96 107.18 2.73 108.92 4.41 110.64 6.07 110.54 8.31 108.52 10.35 94.58 24.46 80.63 38.55 66.67 52.64 65.41 53.91 63.98 54.94 62.06 54.1 60.16 53.26 59.23 51.72 59.23 49.63 59.24 46.25 59.23 42.87 59.23 39.49 59.24 39.5 59.23 39.5 59.23 39.5z"
  }), /*#__PURE__*/createElement("path", {
    d: "M85.44,39.52 C86.74,40.17 87.74,40.43 88.41,41.06 C90.82,43.31 93.2,45.6 95.43,48.03 C96.89,49.62 96.8,51.48 95.36,53.11 C93.9,54.76 91.84,54.91 90.16,53.35 C87.69,51.06 85.19,48.74 83.06,46.15 C82.29,45.21 82.05,43.27 82.46,42.09 C82.83,41.02 84.4,40.36 85.44,39.52 Z"
  })), /*#__PURE__*/createElement("path", {
    fill: PRIMARY_BLACK,
    d: "M206.43,243.52 C204.86,241.85 202.83,240.69 200.63,240.18 L195.79,137.66 C195.42,129.74 191.79,122.2 185.84,116.96 L153.55,88.56 L162.23,39.92 C162.52,38.27 161.61,36.65 160.05,36.04 L137.55,27.29 C136.76,26.98 135.88,26.97 135.09,27.26 L126.64,30.33 L129.45,14.58 C129.74,12.93 128.83,11.31 127.27,10.7 L102.19,0.94 C101.4,0.63 100.52,0.62 99.73,0.91 L84.4,6.48 C83.02,6.98 82.1,8.3 82.1,9.77 L82.1,17.35 L65.38,14.01 C64.15,13.77 62.89,14.19 62.07,15.13 C61.24,16.07 60.98,17.37 61.38,18.56 L78.41,69.19 L25.3,112.63 C18.8,117.94 14.86,125.8 14.5,134.19 L9.96,238.47 C4.66,239.89 0.74,244.73 0.74,250.48 C0.74,256.8 5.54,262.12 11.77,262.82 C12.02,262.88 12.29,262.91 12.55,262.91 L57.04,262.91 L169.46,262.91 L197.76,262.91 C203.96,262.91 209.13,258.19 209.52,252.16 C209.72,248.93 208.62,245.87 206.43,243.52 Z M84.89,25.08 C85.92,25.28 86.98,25.02 87.8,24.35 C88.61,23.69 89.08,22.69 89.08,21.64 L89.08,12.25 L100.87,7.96 L122.05,16.19 L113,66.89 L85,66.89 L69.93,22.09 L84.89,25.08 Z M12.79,255.88 C9.96,255.69 7.74,253.31 7.74,250.48 C7.74,247.51 10.14,245.09 13.1,245.05 C13.19,245.06 13.27,245.06 13.33,245.06 C15.2,245.06 16.74,243.59 16.83,241.71 L21.5,134.5 C21.78,128.1 24.78,122.11 29.74,118.06 L83.74,73.9 L114.62,73.9 L151.28,106.15 C156.42,110.67 159.55,117.18 159.87,124.02 L165.43,241.77 C165.47,242.72 165.91,243.62 166.63,244.25 C167.35,244.88 168.3,245.18 169.25,245.09 C169.42,245.07 169.6,245.06 169.77,245.06 C171.29,245.06 172.69,245.67 173.73,246.78 C174.77,247.89 175.28,249.33 175.19,250.86 C175.01,253.7 172.49,255.92 169.47,255.92 L13.02,255.92 C12.94,255.89 12.86,255.88 12.79,255.88 Z"
  }))));
})(_templateObject9$3 || (_templateObject9$3 = _taggedTemplateLiteral([""])));
var PaperPlane$1 = styled(function PaperPlane$1(props) {
  var name = 'paper-plane';
  var viewBox = '0 0 190 178';
  return /*#__PURE__*/createElement(RegularIllustration, _extends({
    name: name
  }, props), /*#__PURE__*/createElement(MediumIcon, _extends({}, props, {
    name: name,
    size: props.size,
    viewBox: viewBox
  }), /*#__PURE__*/createElement(PaperPlane, {
    size: "100%"
  })));
})(_templateObject10$3 || (_templateObject10$3 = _taggedTemplateLiteral([""])));
var Share$1 = styled(function Share(props) {
  var name = 'share';
  var viewBox = '0 0 188 179';
  return /*#__PURE__*/createElement(RegularIllustration, _extends({
    name: name
  }, props), /*#__PURE__*/createElement(MediumIcon, _extends({}, props, {
    name: name,
    size: props.size,
    viewBox: viewBox
  }), /*#__PURE__*/createElement("path", {
    fill: PRIMARY_SAND,
    d: "M148.46,10.27 C131.55,10.27 117.85,23.97 117.85,40.88 C117.85,41.48 117.87,42.08 117.91,42.68 L56.54,70.92 C51.01,65.46 43.41,62.08 35.03,62.08 C18.12,62.08 4.42,75.78 4.42,92.69 C4.42,109.6 18.12,123.3 35.03,123.3 C50.97,123.3 64.05,111.12 65.5,95.56 L130.5,65.64 C135.55,69.31 141.76,71.48 148.47,71.48 C165.38,71.48 179.08,57.78 179.08,40.87 C179.07,23.97 165.37,10.27 148.46,10.27 Z"
  }), /*#__PURE__*/createElement("path", {
    fill: PRIMARY_BLACK,
    d: "M148.46,104.22 C139.19,104.22 130.78,107.94 124.62,113.96 L75.33,94.89 L130.15,69.66 C135.62,73.15 141.91,74.99 148.46,74.99 C167.27,74.99 182.57,59.69 182.57,40.88 C182.57,22.07 167.27,6.77 148.46,6.77 C129.79,6.77 114.58,21.84 114.35,40.46 L57.19,66.77 C51.01,61.47 43.23,58.58 35.02,58.58 C16.21,58.58 0.91,73.88 0.91,92.69 C0.91,111.5 16.21,126.8 35.02,126.8 C44.31,126.8 52.73,123.14 58.89,117.13 L114.36,138.59 C114.5,157.28 129.74,172.44 148.46,172.44 C167.27,172.44 182.57,157.14 182.57,138.33 C182.57,119.52 167.27,104.22 148.46,104.22 Z M35.02,119.8 C20.07,119.8 7.91,107.64 7.91,92.69 C7.91,77.74 20.07,65.58 35.02,65.58 C42.2,65.58 48.96,68.36 54.07,73.41 C55.11,74.44 56.67,74.71 57.99,74.1 L119.36,45.85 C120.67,45.25 121.48,43.9 121.39,42.46 C121.36,41.93 121.34,41.4 121.34,40.87 C121.34,25.92 133.5,13.76 148.45,13.76 C163.4,13.76 175.56,25.92 175.56,40.87 C175.56,55.82 163.4,67.98 148.45,67.98 C142.69,67.98 137.19,66.19 132.54,62.81 C131.52,62.06 130.17,61.93 129.02,62.46 L64.02,92.38 C62.88,92.9 62.11,93.99 62,95.23 C60.71,109.24 49.1,119.8 35.02,119.8 Z"
  }), /*#__PURE__*/createElement("g", {
    fill: iconTint(props.inverted),
    transform: "translate(15 23)"
  }, /*#__PURE__*/createElement("circle", {
    cx: "133.65",
    cy: "115.33",
    r: "16.55"
  }), /*#__PURE__*/createElement("circle", {
    cx: "133.65",
    cy: "17.41",
    r: "16.55"
  }), /*#__PURE__*/createElement("circle", {
    cx: "20.022",
    cy: "69.583",
    r: "16.549",
    transform: "rotate(-13.286 20.022 69.583)"
  }))));
})(_templateObject11$2 || (_templateObject11$2 = _taggedTemplateLiteral([""])));
var SpeechBubbles = styled(function SpeechBubbles(props) {
  var name = 'speech-bubbles';
  var viewBox = '0 0 218 182';
  return /*#__PURE__*/createElement(RegularIllustration, _extends({
    name: name
  }, props), /*#__PURE__*/createElement(MediumIcon, _extends({}, props, {
    name: name,
    size: props.size,
    viewBox: viewBox
  }), /*#__PURE__*/createElement("path", {
    fill: PRIMARY_SAND,
    d: "M100.26,12.55 L31.97,18.44 C15.05,19.9 2.52,34.8 3.97,51.72 L7.17,88.81 C8.63,105.73 23.53,118.26 40.45,116.81 L55.95,115.47 L57.34,131.64 C57.72,136.03 63.11,137.89 66.12,134.68 L86.6,112.83 L108.74,110.92 C125.66,109.46 138.2,94.56 136.74,77.64 L133.54,40.55 C132.08,23.62 117.18,11.09 100.26,12.55 Z"
  }), /*#__PURE__*/createElement("path", {
    fill: PRIMARY_BLACK,
    d: "M183.15,61.77 L138.89,61.77 L137.03,40.24 C136.24,31.13 131.95,22.86 124.95,16.97 C117.95,11.08 109.07,8.27 99.96,9.06 L31.67,14.95 C22.55,15.74 14.29,20.02 8.4,27.03 C2.51,34.04 -0.3,42.9 0.49,52.02 L3.69,89.11 C5.31,107.93 21.95,121.91 40.76,120.29 L52.77,119.25 L53.86,131.93 C54.16,135.35 56.36,138.18 59.6,139.31 C60.54,139.64 61.51,139.8 62.46,139.8 C64.78,139.8 67.01,138.85 68.68,137.07 L88.24,116.2 L92.4,115.84 L92.4,123.37 C92.4,142.26 107.77,157.62 126.65,157.62 L159.26,157.62 L181.81,180.17 C182.48,180.84 183.37,181.2 184.29,181.2 C184.74,181.2 185.2,181.11 185.63,180.93 C186.94,180.39 187.79,179.11 187.79,177.7 L187.79,157.3 C204.48,155.02 217.390005,140.68 217.390005,123.37 L217.390005,96.02 C217.4,77.14 202.03,61.77 183.15,61.77 Z M86.31,109.34 C85.45,109.41 84.65,109.8 84.06,110.43 L63.58,132.28 C62.97,132.93 62.26,132.82 61.9,132.69 C61.54,132.56 60.92,132.22 60.84,131.33 L59.45,115.16 C59.37,114.24 58.93,113.38 58.22,112.78 C57.59,112.25 56.79,111.96 55.97,111.96 C55.87,111.96 55.77,111.96 55.67,111.97 L40.17,113.31 C32.92,113.94 25.86,111.7 20.29,107.01 C14.72,102.32 11.31,95.75 10.68,88.5 L7.48,51.41 C6.19,36.44 17.32,23.21 32.29,21.92 L100.58,16.03 C107.83,15.4 114.89,17.64 120.46,22.33 C126.03,27.02 129.44,33.59 130.07,40.84 L133.27,77.93 C133.9,85.18 131.66,92.24 126.97,97.81 C122.28,103.38 115.71,106.79 108.46,107.42 L86.31,109.34 Z"
  }), /*#__PURE__*/createElement("g", {
    fill: iconTint(props.inverted),
    transform: "translate(24 34)"
  }, /*#__PURE__*/createElement("circle", {
    cx: "130.81",
    cy: "75.7",
    r: "10.71"
  }), /*#__PURE__*/createElement("circle", {
    cx: "159.8",
    cy: "75.7",
    r: "10.71"
  }), /*#__PURE__*/createElement("path", {
    d: "M41.53 20.83L6.5.55C3.94-.94.72.91.72 3.88L.67 44.36C.67 47.32 3.87 49.18 6.44 47.7L41.52 27.5C44.09 26.02 44.09 22.32 41.53 20.83zM95.07 40.29L83.93 31.88C83 31.17 82.62 29.95 83 28.84L87.56 15.65C88.42 13.17 85.6 11.05 83.46 12.55L72.02 20.54C71.06 21.21 69.78 21.19 68.84 20.48L57.7 12.06C55.61 10.48 52.72 12.5 53.48 15.01L57.55 28.36C57.89 29.48 57.47 30.69 56.51 31.37L45.07 39.36C42.92 40.86 43.95 44.23 46.57 44.28L60.53 44.54C61.7 44.56 62.73 45.34 63.07 46.46L67.14 59.81C67.9 62.32 71.43 62.38 72.28 59.91L76.84 46.72C77.22 45.61 78.28 44.88 79.45 44.9L93.41 45.16C96.01 45.2 97.17 41.87 95.07 40.29z"
  }))));
})(_templateObject12$2 || (_templateObject12$2 = _taggedTemplateLiteral([""])));
/**
 * LARGE SIZED
 */

var AllOrNothing = styled(function AllOrNothing(props) {
  var name = 'all-or-nothing';
  var viewBox = '0 0 274 214';
  return /*#__PURE__*/createElement(IrregularIllustration, _extends({
    backgroundOffset: {
      y: -25
    },
    name: name,
    viewBox: viewBox
  }, props), /*#__PURE__*/createElement(LargeIcon, _extends({}, props, {
    height: "100%",
    width: "100%",
    name: name,
    viewBox: viewBox
  }), /*#__PURE__*/createElement("g", {
    fill: "none"
  }, /*#__PURE__*/createElement("g", {
    transform: "translate(86 98)"
  }, /*#__PURE__*/createElement("path", {
    fill: PRIMARY_SAND,
    d: "M68.71,36.72 L68.71,3.5 L31.38,3.5 L31.38,43.59 C29.69,63.53 20.38,76.99 3.59,76.99 L3.59,111.92 L96.79,111.92 L96.79,76.99 C78.13,76.98 68.71,60.37 68.71,36.72 Z"
  }), /*#__PURE__*/createElement("path", {
    fill: PRIMARY_BLACK,
    d: "M96.79,115.41 L3.59,115.41 C1.66,115.41 0.09,113.84 0.09,111.91 L0.09,76.98 C0.09,75.05 1.66,73.48 3.59,73.48 C11.7,73.48 25.61,69.57 27.88,43.43 L27.88,3.5 C27.88,1.57 29.45,0 31.38,0 L68.71,0 C70.64,0 72.21,1.57 72.21,3.5 L72.21,36.72 C72.21,69.9 89.4,73.48 96.79,73.48 C98.72,73.48 100.29,75.05 100.29,76.98 L100.29,111.91 C100.29,113.84 98.72,115.41 96.79,115.41 Z M7.1,108.41 L93.3,108.41 L93.3,80.3 C75.64,78.46 65.22,62.46 65.22,36.72 L65.22,7 L34.89,7 L34.89,43.59 C34.89,43.69 34.89,43.79 34.88,43.89 C33.07,65.26 22.78,78.6 7.1,80.31 L7.1,108.41 L7.1,108.41 Z"
  })), /*#__PURE__*/createElement("path", {
    fill: PRIMARY_SAND,
    d: "M146.64,134.72 L146.64,101.5 L109.31,101.5 L109.31,141.59 C107.62,161.53 98.31,174.99 81.52,174.99 L81.52,209.92 L174.72,209.92 L174.72,174.99 C156.06,174.98 146.64,158.37 146.64,134.72 Z"
  }), /*#__PURE__*/createElement("path", {
    fill: iconTint(props.inverted),
    d: "M246.35 14.44C245.72 14.17 244.99 14.3 244.49 14.77L242.41 16.73C236.28 6.74 225.36.58 213.59.58 201.82.58 190.9 6.73 184.77 16.73L182.55 14.64C182.08 14.19 181.38 14.07 180.79 14.33 180.19 14.59 179.81 15.17 179.81 15.83L179.81 34.03C179.81 52.79 194.91 68.11 213.48 68.17 213.52 68.17 213.56 68.17 213.6 68.17 222.6 68.17 231.07 64.67 237.45 58.32 243.86 51.93 247.39 43.43 247.39 34.39L247.39 16.02C247.38 15.33 246.98 14.71 246.35 14.44zM27.11 41.32C27.11 41.32 27.1 41.32 27.1 41.32 19.94 41.32 13.23 45.84 8.19 54.02 3.27 62.01.57 72.5.579972322 83.54.59 100.17 12 112.7 27.12 112.7 27.12 112.7 27.13 112.7 27.14 112.7 42.27 112.69 53.68 100.14 53.6700066 83.51 53.66 59.85 42 41.32 27.11 41.32z",
    transform: "translate(15)"
  }), /*#__PURE__*/createElement("g", {
    fill: PRIMARY_BLACK,
    transform: "translate(0 81)"
  }, /*#__PURE__*/createElement("path", {
    d: "M227.6 17.31C222.34 17.31 218.02 21.29 217.48 26.4L163.22 39.87 163.22 20.5C163.22 18.57 161.65 17 159.72 17L146.65 17 109.33 17C107.4 17 105.83 18.57 105.83 20.5L105.83 54.13 53.13 67.21C51.3 64.51 48.2 62.73 44.69 62.73 39.07 62.73 34.51 67.29 34.51 72.91 34.51 78.53 39.07 83.09 44.69 83.09 49.95 83.09 54.27 79.11 54.81 74L105.73 61.36C103.21 86.66 89.54 90.49 81.53 90.49 79.6 90.49 78.03 92.06 78.03 93.99L78.03 128.92C78.03 130.85 79.6 132.42 81.53 132.42L174.73 132.42 187.8 132.42C189.73 132.42 191.3 130.85 191.3 128.92L191.3 93.99C191.3 92.06 189.73 90.49 187.8 90.49 180.41 90.49 163.22 86.91 163.22 53.73L163.22 47.09 219.16 33.2C220.99 35.9 224.09 37.68 227.6 37.68 233.22 37.68 237.78 33.12 237.78 27.5 237.78 21.87 233.22 17.31 227.6 17.31zM85.02 97.3C100.7 95.59 110.99 82.25 112.8 60.88 112.81 60.78 112.81 60.68 112.81 60.58L112.81 24 143.13 24 143.13 53.72C143.13 79.47 153.55 95.46 171.21 97.3L171.21 125.41 85.01 125.41 85.01 97.3 85.02 97.3zM269.63.81L189.01.81C187.08.81 185.51 2.38 185.51 4.31 185.51 6.24 187.08 7.81 189.01 7.81L269.63 7.81C271.56 7.81 273.13 6.24 273.13 4.31 273.13 2.38 271.57.81 269.63.81z"
  }), /*#__PURE__*/createElement("path", {
    d: "M88.48,49.19 C88.48,47.26 86.91,45.69 84.98,45.69 L4.37,45.69 C2.44,45.69 0.87,47.26 0.87,49.19 C0.87,51.12 2.44,52.69 4.37,52.69 L84.99,52.69 C86.91,52.69 88.48,51.12 88.48,49.19 Z"
  })))));
})(_templateObject13$1 || (_templateObject13$1 = _taggedTemplateLiteral([""])));
var DiscoverProjects = styled(function DiscoverProjects(props) {
  var name = 'discover-projects';
  var viewBox = '0 0 288 188';
  return /*#__PURE__*/createElement(IrregularIllustration, _extends({
    backgroundOffset: {
      y: -50
    },
    name: name,
    viewBox: viewBox
  }, props), /*#__PURE__*/createElement(LargeIcon, _extends({}, props, {
    height: "100%",
    width: "100%",
    name: name,
    viewBox: viewBox
  }), /*#__PURE__*/createElement("path", {
    fill: PRIMARY_SAND,
    d: "M218.09,50.13 C207.11,31.46 185.02,23.29 165.12,29.06 L159.85,11.05 C158.42,6.15 153.28,3.34 148.38,4.78 L60.37,30.55 C55.47,31.98 52.66,37.12 54.1,42.02 L77.17,120.78 L65.63,126.96 C60.19,130.16 58.37,137.16 61.57,142.6 C64.77,148.04 71.77,149.86 77.21,146.66 L83.55,142.59 L86.51,152.69 C87.94,157.59 93.08,160.4 97.98,158.96 L185.99,133.19 C190.89,131.76 193.7,126.62 192.26,121.72 L191.24,118.23 C194.82,117.16 198.3,115.68 201.61,113.73 C212.31,107.44 219.91,97.36 223.03,85.35 C226.15,73.34 224.38,60.82 218.09,50.13 Z M212.37,82.58 C209.99,91.75 204.19,99.44 196.02,104.24 C193.51,105.72 190.86,106.86 188.14,107.68 L168.21,39.62 C171.43,38.69 174.71,38.22 177.98,38.22 C190.14,38.22 202,44.47 208.6,55.69 C213.41,63.87 214.75,73.41 212.37,82.58 Z"
  }), /*#__PURE__*/createElement("path", {
    fill: iconTint(props.inverted),
    d: "M286.11 55.53L240.2 23.39C237.77 21.69 234.41 23.26 234.16 26.21L229.28 82.04C229.02 84.99 232.06 87.12 234.74 85.86L285.53 62.18C288.22 60.92 288.54 57.23 286.11 55.53zM52.69 21.52L38.01 19.87C36.78 19.73 35.78 18.81 35.53 17.6L32.57 3.13C32.01.41 28.31 1.11022302e-16 27.16 2.52L21.05 15.97C20.54 17.1 19.36 17.77 18.12 17.63L3.44 15.98C.68 15.67-.86 19.07 1.19 20.94L12.1 30.91C13.02 31.75 13.29 33.08 12.78 34.21L6.67 47.66C5.52 50.18 8.28 52.7 10.69 51.33L23.54 44.04C24.62 43.43 25.97 43.58 26.88 44.42L37.79 54.39C39.84 56.26 43.08 54.42 42.53 51.7L39.57 37.23C39.32 36.02 39.88 34.78 40.96 34.17L53.81 26.88C56.2 25.49 55.45 21.83 52.69 21.52z",
    transform: "translate(0 85)"
  }), /*#__PURE__*/createElement("g", {
    fill: PRIMARY_BLACK,
    transform: "translate(50)"
  }, /*#__PURE__*/createElement("path", {
    d: "M43.55,74.96 C50.34,73.09 54.34,66.09 52.11,58.01 C49.05,46.88 41.14,39.68 34.35,41.55 C27.56,43.42 24.55,54.01 27.51,64.78 C29.71,72.75 36.76,76.83 43.55,74.96 Z"
  }), /*#__PURE__*/createElement("path", {
    d: "M171.58,48.07 C163.02,33.51 148.23,24.84 132.57,23.41 L131.91,20.59 C131.14,17.28 129.12,14.46 126.23,12.66 C123.34,10.86 119.93,10.3 116.61,11.07 L113.69,11.75 L113.2,10.06 C111.22,3.32 104.13,-0.56 97.39,1.41 L9.38,27.19 C2.64,29.16 -1.24,36.26 0.73,43 L23,119.04 L13.97,123.88 C13.93,123.9 13.89,123.92 13.85,123.95 C6.76,128.12 4.38,137.29 8.55,144.38 C11.33,149.1 16.32,151.74 21.44,151.74 C24.01,151.74 26.61,151.08 28.98,149.68 C29.02,149.66 29.06,149.63 29.1,149.61 L31.5,148.07 L33.14,153.68 C34.1,156.95 36.27,159.64 39.25,161.28 C41.12,162.3 43.16,162.82 45.23,162.84 C47.47,166.82 51.73,169.34 56.33,169.34 C57.28,169.34 58.25,169.23 59.22,169.01 L148.54,148.22 C151.85,147.45 154.67,145.43 156.47,142.54 C158.27,139.65 158.83,136.23 158.06,132.92 L154.31,116.82 C165.59,109.96 173.61,99.18 176.93,86.37 C180.32,73.3 178.42,59.7 171.58,48.07 Z M7.45,41.03 C6.56,37.99 8.31,34.8 11.35,33.91 L99.36,8.14 C99.9,7.98 100.44,7.91 100.97,7.91 C103.45,7.91 105.75,9.54 106.48,12.04 L110.65,26.28 C107.85,27.31 105.1,28.59 102.44,30.15 C90.81,36.99 82.54,47.95 79.15,61.01 C76.37,71.73 77.16,82.82 81.32,92.88 L78.47,94.55 L77.83,93.47 C76.88,91.85 74.82,91.27 73.16,92.16 L29.3,115.67 L7.45,41.03 Z M78.98,109.21 L65.64,117.78 L59.53,107.39 L73.5,99.9 L78.98,109.21 Z M25.38,143.67 C21.62,145.84 16.79,144.57 14.58,140.82 C12.37,137.07 13.61,132.23 17.34,130 L53.36,110.7 L59.75,121.57 L25.38,143.67 Z M39.86,151.7 L37.64,144.12 L85.6,113.29 C87.18,112.27 87.68,110.19 86.72,108.57 L86.08,107.49 L89.02,105.76 C95.75,113.99 104.88,119.86 115.36,122.58 C119.59,123.68 123.87,124.22 128.12,124.22 C131.77,124.22 135.39,123.8 138.94,123.01 C139.27,124.39 139.1,125.82 138.41,127.08 C137.67,128.43 136.46,129.4 134.99,129.83 L46.98,155.61 C45.51,156.04 43.96,155.87 42.61,155.14 C41.27,154.39 40.29,153.17 39.86,151.7 Z M170.16,84.6 C167.24,95.85 160.12,105.29 150.1,111.18 C140.08,117.07 128.37,118.71 117.12,115.79 C107.4,113.27 99.04,107.6 93.14,99.65 C93.09,99.55 93.06,99.45 93,99.35 L88.94,92.45 C88.82,92.24 88.67,92.05 88.51,91.88 C84.3,82.78 83.37,72.6 85.92,62.76 C88.84,51.51 95.96,42.07 105.98,36.18 C112.89,32.12 120.47,30.18 127.96,30.18 C142.88,30.18 157.44,37.85 165.54,51.62 C171.44,61.64 173.08,73.35 170.16,84.6 Z"
  }), /*#__PURE__*/createElement("path", {
    d: "M127.99,38.23 C125.87,38.23 123.74,38.45 121.63,38.84 L121.62,38.82 C121.4,38.86 121.19,38.91 120.97,38.95 C120.77,38.99 120.58,39.03 120.38,39.07 C118.53,39.48 116.69,40.03 114.89,40.75 L134.73,108.51 C136.51,108.17 138.26,107.68 139.98,107.06 C140.21,106.98 140.43,106.89 140.66,106.8 C140.92,106.7 141.18,106.61 141.44,106.5 L141.44,106.49 C143,105.85 144.54,105.11 146.02,104.23 C147.66,103.27 149.2,102.18 150.63,101 L136.25,39.21 C133.55,38.57 130.78,38.23 127.99,38.23 Z"
  }))));
})(_templateObject14$1 || (_templateObject14$1 = _taggedTemplateLiteral([""])));
var IdeaToAction = styled(function IdeaToAction(props) {
  var name = 'idea-to-action';
  var viewBox = '0 0 304 228';
  return /*#__PURE__*/createElement(IrregularIllustration, _extends({
    backgroundOffset: {
      x: 30,
      y: -12
    },
    name: name,
    viewBox: viewBox
  }, props), /*#__PURE__*/createElement(LargeIcon, _extends({}, props, {
    height: "100%",
    name: name,
    width: "100%",
    viewBox: viewBox
  }), /*#__PURE__*/createElement("g", {
    fill: "none"
  }, /*#__PURE__*/createElement("path", {
    fill: PRIMARY_BLACK,
    d: "M120.75,227.56 C118.82,227.56 117.25,225.99 117.25,224.06 L117.25,146.52 C117.25,144.59 118.82,143.02 120.75,143.02 C122.68,143.02 124.25,144.59 124.25,146.52 L124.25,224.06 C124.25,225.99 122.68,227.56 120.75,227.56 Z"
  }), /*#__PURE__*/createElement("polygon", {
    fill: PRIMARY_SAND,
    points: "162.48 177.67 151.22 147.7 150.6 147.7 150.6 146.52 59.68 146.52 34.52 119.44 4.43 119.44 29.59 146.52 28.96 146.52 28.96 147.28 28.59 147.28 17.33 177.25 28.96 177.25 28.96 224.06 150.6 224.06 150.6 177.67"
  }), /*#__PURE__*/createElement("path", {
    fill: iconTint(props.inverted),
    d: "M108.58 92.41L98.54 88.72 109.27 56.38C110.05 53.81 109.7 51.03 108.3 48.74 108.3 48.74 86.38 14.36 85.8 13.67 85.8 13.67 82.99 9.77 77.2 9.56 72.26 9.41 68.36 13.21 67.7 18.59 67.19 23.87 69.65 26.54 69.65 26.54L89.57 56.06 81.08 97.77 112.11 97.77 112.11 96.7C112.11 94.61 110.63 92.81 108.58 92.41zM46.18 3.44C42.13 6.86 42.03 10.49 42.03 10.49L35.67 45.53.46 69.45 22.67 91.13 23.41 90.37C24.87 88.87 25.07 86.55 23.88 84.83L19.67 74.97 49.54 59.52C51.89 58.23 53.58 56 54.18 53.38 54.18 53.38 62.5 13.47 62.57 12.57 62.57 12.57 63.28 7.82 59.29 3.63 55.86.06 50.41.05 46.18 3.44z",
    transform: "translate(166 129)"
  }), /*#__PURE__*/createElement("path", {
    fill: PRIMARY_SAND,
    d: "M199.59,43.74 C201.8,19.25 223.93,1.34 248.55,4.54 C270.84,7.44 287.42,27.25 286.33,49.7 C285.42,68.48 272.86,83.7 256.19,89.06 L256.01,91.1 C255.55,96.14 251.1,99.86 246.06,99.4 L229.79,97.93 C224.75,97.47 221.03,93.02 221.49,87.98 L221.68,85.85 C221.69,85.77 221.7,85.7 221.71,85.63 C207.18,77.51 197.99,61.39 199.59,43.74 Z"
  }), /*#__PURE__*/createElement("g", {
    fill: PRIMARY_BLACK
  }, /*#__PURE__*/createElement("path", {
    d: "M220.46 121.15C220.22 123.8 222.18 126.15 224.83 126.39L228.08 126.68C228.71 129.46 231.07 131.64 234.06 131.91 237.05 132.18 239.76 130.46 240.88 127.84L244.13 128.13C246.78 128.37 249.13 126.41 249.37 123.76L250.7 109.03 221.79 106.42 220.46 121.15zM249 1.07C236.17-.6 223.58 2.93 213.52 10.99 203.45 19.06 197.27 30.58 196.11 43.42 194.51 61.1 203.06 78.15 218.02 87.5L218.01 87.66C217.38 94.62 222.53 100.79 229.48 101.42L245.74 102.89C246.13 102.92 246.51 102.94 246.89 102.94 253.3 102.94 258.79 98.09 259.48 91.62 276.84 85.05 288.93 68.56 289.83 49.87 291 25.64 273.06 4.2 249 1.07zM282.84 49.54C282.04 66.12 270.9 80.66 255.13 85.74L252.92 86.45 252.53 90.79C252.25 93.9 249.48 96.21 246.38 95.92L230.12 94.45C228.61 94.31 227.25 93.6 226.28 92.44 225.31 91.28 224.85 89.81 224.99 88.3L225.18 86.25C225.19 86.17 225.21 86.08 225.21 85.99L225.45 83.7 223.44 82.58C209.66 74.88 201.68 59.76 203.1 44.06L203.1 44.06C204.09 33.13 209.35 23.33 217.92 16.46 226.48 9.6 237.21 6.6 248.12 8.02 268.57 10.68 283.83 28.92 282.84 49.54z"
  }), /*#__PURE__*/createElement("path", {
    d: "M251.36 46.09L233.94 44.56C232.92 44.47 231.92 44.83 231.19 45.54 230.46 46.25 230.08 47.25 230.14 48.27L232.33 82.06C232.45 83.91 233.99 85.33 235.82 85.33 235.9 85.33 235.97 85.33 236.05 85.32 237.98 85.2 239.44 83.53 239.32 81.6L237.39 51.88 246.75 52.7 241.69 74.81C241.26 76.69 242.44 78.57 244.32 79 246.2 79.43 248.08 78.25 248.51 76.37L254.47 50.35C254.7 49.36 254.48 48.33 253.89 47.51 253.28 46.7 252.36 46.18 251.36 46.09zM175.76 115.94L145.66 115.94C144.69 115.94 143.76 116.35 143.1 117.06L118.98 143.03 61.21 143.03 37.09 117.06C36.43 116.35 35.5 115.94 34.53 115.94L4.43 115.94C3.04 115.94 1.78 116.77 1.22 118.04.66 119.32.92 120.8 1.86 121.82L25.04 146.77 14.05 176.02C13.65 177.1 13.8 178.3 14.45 179.24 15.1 180.18 16.18 180.75 17.33 180.75L25.46 180.75 25.46 224.06C25.46 225.99 27.03 227.56 28.96 227.56L120.13 227.56 150.6 227.56C152.53 227.56 154.1 225.99 154.1 224.06L154.1 181.17 162.49 181.17C163.64 181.17 164.71 180.61 165.37 179.66 166.02 178.72 166.17 177.51 165.77 176.44L154.77 147.18 178.33 121.82C179.28 120.8 179.53 119.32 178.97 118.04 178.41 116.76 177.15 115.94 175.76 115.94zM12.46 122.94L33 122.94 51.66 143.02 31.11 143.02 12.46 122.94zM22.38 173.75L31.01 150.78 115.07 150.78 106.44 173.75 22.38 173.75zM116.63 220.56L32.46 220.56 32.46 180.75 108.86 180.75C110.32 180.75 111.62 179.85 112.14 178.48L116.63 166.54 116.63 220.56 116.63 220.56zM157.43 174.17L154.1 174.17 154.1 165.3 157.43 174.17z"
  })))));
})(_templateObject15$1 || (_templateObject15$1 = _taggedTemplateLiteral([""])));
var Partners = styled(function Partners(props) {
  var name = 'partners';
  var viewBox = '0 0 264 176';
  return /*#__PURE__*/createElement(IrregularIllustration, _extends({
    backgroundOffset: {
      y: -60
    },
    name: name,
    viewBox: viewBox
  }, props), /*#__PURE__*/createElement(LargeIcon, _extends({}, props, {
    height: "100%",
    width: "100%",
    name: name,
    viewBox: viewBox
  }), /*#__PURE__*/createElement("path", {
    fill: PRIMARY_SAND,
    d: "M78.84,119.99 C73.18,126.06 73.52,135.57 79.59,141.23 C85.66,146.89 95.17,146.55 100.83,140.48 L101.34,140.12 C101.34,140.12 103.47,144.91 105.49,146.8 C111.56,152.46 120.77,150.72 129.13,142.62 C129.13,142.62 130.55,144.53 131.45,145.37 C137.52,151.03 148.01,149.49 155.88,139.36 L155.88,139.36 C159.83,142.27 164.72,142.7 169.19,141.29 C192.53,131.95 215.77,116.17 235.86,94.61 C236.56,93.86 237.24,93.11 237.92,92.36 C238.17,92.1 238.44,91.85 238.69,91.58 C257.06,71.87 255.97,40.99 236.26,22.62 C216.94,4.62 186.92,5.32 168.43,23.9 L168.4,23.87 L77.79,121.11 L78.84,119.99 Z"
  }), /*#__PURE__*/createElement("path", {
    fill: PRIMARY_BLACK,
    d: "M246.53,28.55 C246.04,28.1 245.55,27.66 245.05,27.23 C243.15,24.68 241.02,22.27 238.65,20.06 C218.03,0.84 186.38,1.31 166.35,21.04 C166.17,21.17 166,21.32 165.85,21.49 L76.31,117.59 C76.3,117.6 76.29,117.61 76.29,117.61 C76.29,117.61 76.28,117.62 76.28,117.62 L75.25,118.73 L75.25,118.73 C74.98,119.02 74.76,119.35 74.61,119.7 C69.46,127.14 70.41,137.45 77.22,143.8 C78.35,144.85 79.6,145.73 80.92,146.46 C81.9,148.6 83.28,150.59 85.11,152.29 C91.55,158.29 101.15,158.81 108.14,154.07 C108.97,155.45 109.96,156.88 111.01,157.86 C114.08,160.72 117.77,162.12 121.74,162.12 C126.52,162.12 131.69,160.09 136.66,156.11 C136.77,156.22 136.87,156.32 136.98,156.42 C140.24,159.46 144.57,160.93 149.2,160.56 C154.66,160.12 160.02,157.24 164.55,152.37 C168.64,154.31 173.45,154.6 178.15,153.12 C178.23,153.09 178.32,153.06 178.4,153.03 C203.05,143.16 226.54,126.72 246.32,105.49 C247.01,104.75 247.69,104 248.37,103.25 L248.6,103.02 C248.79,102.83 248.97,102.65 249.15,102.45 C268.79,81.36 267.62,48.21 246.53,28.55 Z M153.07,137.3 L153.07,137.3 C153.05,137.32 153.03,137.34 153.02,137.36 C149.41,141.94 144.95,144.76 140.74,145.09 C138.06,145.31 135.68,144.51 133.85,142.8 C133.77,142.72 133.67,142.62 133.56,142.5 C140.3,133.09 144.13,125.87 150.41,111.9 C152.93,113.71 155.93,114.72 159.09,114.77 C159.18,114.77 159.27,114.77 159.36,114.77 C161.19,114.77 162.97,114.44 164.65,113.82 C160.62,126.82 153.16,137.17 153.07,137.3 Z M173.02,109.33 C176.07,110.34 179.35,110.37 182.4,109.43 C182.04,115.73 181.09,125.63 178.65,133.25 C175.14,134.97 171.6,136.56 168.03,137.99 C166.41,138.48 163.75,138.96 160.96,138.08 C164.32,132.77 170.5,121.79 173.02,109.33 Z M126.53,140.27 C121.03,145.53 113.3,149.29 107.88,144.24 C107.21,143.62 106.33,142.19 105.58,140.8 C109.45,136.84 117.39,127.56 127.32,109.68 C127.46,109.83 127.58,109.99 127.72,110.14 C130.58,113.09 134.41,114.76 138.52,114.83 C138.61,114.83 138.7,114.83 138.79,114.83 C139.7,114.83 140.6,114.75 141.48,114.59 C136.41,125.5 132.84,131.66 126.53,140.27 Z M110.65,91.21 C110.68,91.11 110.7,91.02 110.72,90.92 L138.58,61.02 C147.09,71.94 160.14,78.01 173.52,78.01 C179.31,78.01 185.16,76.87 190.73,74.51 C194.07,73.09 197.21,71.27 200.08,69.11 C201.62,67.95 201.93,65.75 200.77,64.21 C199.61,62.67 197.41,62.36 195.87,63.52 C193.45,65.34 190.81,66.87 187.99,68.07 C172.11,74.82 153.54,69.66 143.42,55.82 L170.59,26.66 C170.7,26.57 170.8,26.48 170.91,26.38 C188.24,8.96 215.89,8.44 233.87,25.19 C242.72,33.44 247.83,44.64 248.26,56.73 C248.69,68.82 244.38,80.35 236.13,89.21 C236,89.35 235.87,89.48 235.73,89.62 L235.42,89.94 C235.39,89.97 235.36,90 235.33,90.04 C234.66,90.78 233.99,91.52 233.31,92.25 C219.44,107.14 203.69,119.56 187.03,128.89 C189.12,119.03 189.54,108.41 189.62,104.68 C192.74,100.99 193.98,95.96 192.85,91.21 C192.41,89.33 190.52,88.16 188.64,88.61 C186.76,89.05 185.59,90.94 186.04,92.82 C186.73,95.73 185.85,98.71 183.71,100.79 C180.65,103.75 175.86,103.95 172.57,101.25 C171.71,100.55 170.57,100.29 169.49,100.56 C168.41,100.83 167.53,101.6 167.11,102.62 C166.67,103.69 166.02,104.64 165.18,105.45 C163.57,107.01 161.44,107.85 159.21,107.8 C156.97,107.76 154.88,106.85 153.32,105.24 C152.92,104.83 152.57,104.38 152.32,103.99 L152.09,103.61 C151.46,102.55 150.32,101.91 149.09,101.91 C149.08,101.91 149.07,101.91 149.06,101.91 C147.82,101.92 146.68,102.59 146.06,103.66 C145.67,104.33 145.18,104.96 144.62,105.5 C143.01,107.06 140.89,107.91 138.65,107.85 C136.41,107.81 134.32,106.9 132.76,105.29 C131.75,104.24 131.03,102.95 130.67,101.56 C130.19,99.69 128.29,98.56 126.41,99.04 L125.96,99.16 C125.37,99.31 124.83,99.61 124.39,100.03 C121.06,103.24 115.75,103.15 112.53,99.83 C110.31,97.52 109.59,94.22 110.65,91.21 Z M81.36,122.42 L103.8,98.34 C104.49,100.67 105.74,102.84 107.5,104.67 C110.74,108.03 115.15,109.57 119.48,109.32 C107.3,130.49 98.72,137.69 98.63,137.76 L98.64,137.77 C98.51,137.87 98.38,137.97 98.27,138.1 C96.17,140.35 93.32,141.65 90.24,141.76 C87.17,141.89 84.23,140.77 81.97,138.67 C79.72,136.57 78.42,133.72 78.31,130.64 C78.2,127.59 79.29,124.67 81.36,122.42 Z"
  }), /*#__PURE__*/createElement("path", {
    fill: iconTint(props.inverted),
    d: "M86.06,107.11 C79.41,101.24 72.56,94.95 66.11,88.99 C64.28,87.29 65.28,86.05 67.29,87.66 C74.11,93.13 81.88,99.08 88.76,104.22 L98.36,93.92 C91.35,87.89 83.83,81.14 77.26,74.81 C75.62,73.23 76.38,72.26 78.29,73.8 C84.75,79.01 93.03,85.37 100.83,91.26 L110.86,80.49 C104.04,74.29 96.83,67.55 90.7,61.69 C88.99,60.05 90.13,59.26 92.13,60.85 C99.02,66.29 106.69,72.4 113.43,77.73 L122.66,67.83 C108.64,55.27 91.75,39.22 90.5,38.05 C88.75,36.41 88.08,33.84 91.95,36.34 C95.82,38.84 107.97,46.64 115.64,48.94 C125.62,51.94 136.85,47.1 121.5,36.94 C106.14,26.78 93.07,11.53 93.07,11.53 L93.07,11.53 C92.48,10.81 91.81,10.14 91.08,9.53 C88.93,7.73 86.4,6.61 83.72,6.14 L83.72,6.14 L83.52,6.11 C83.3,6.07 83.08,6.04 82.86,6.01 L49.93,1.03 L49.93,1.04 C40.45,-0.54 27.77,5.41 18.22,16.84 C7.06,30.2 4.04,46.43 10.56,55.02 L10.56,55.02 L10.71,55.2 C10.92,55.47 11.14,55.73 11.38,55.99 C11.38,55.99 21.27,72.7 38.43,87.24 C49.76,96.84 65.29,108.85 76.58,117.32 L86.06,107.11 Z M51.96,45.04 C50.13,44.08 48.56,42.36 51.9,42.99 C55.84,43.73 61.44,44.18 67.13,42.65 C72.74,41.14 77.4,38.3 80.53,35.98 C83.27,33.95 82.87,36.27 81.73,37.96 C78.31,43.03 73.95,46.34 68.93,47.66 C63.61,49.06 57.92,48.18 51.96,45.04 Z"
  })));
})(_templateObject16$1 || (_templateObject16$1 = _taggedTemplateLiteral([""])));
var SecurePayment = styled(function SecurePayment(props) {
  var name = 'secure-payment';
  var viewBox = '0 0 289 203';
  return /*#__PURE__*/createElement(IrregularIllustration, _extends({
    backgroundOffset: {
      y: -35
    },
    name: name,
    viewBox: viewBox
  }, props), /*#__PURE__*/createElement(LargeIcon, _extends({}, props, {
    height: "100%",
    width: "100%",
    name: name,
    viewBox: viewBox
  }), /*#__PURE__*/createElement("g", {
    fill: "none"
  }, /*#__PURE__*/createElement("path", {
    fill: PRIMARY_SAND,
    d: "M282.87,120.8 L173.57,198.22 C170.87,200.13 167.13,199.49 165.22,196.79 L116.33,127.77 C114.42,125.07 115.06,121.33 117.76,119.42 L227.05,42 C229.75,40.09 233.49,40.73 235.4,43.43 L284.29,112.45 C286.21,115.14 285.57,118.89 282.87,120.8 Z"
  }), /*#__PURE__*/createElement("path", {
    fill: PRIMARY_SAND,
    d: "M184.86,160.96 C152.68,158.73 119.62,137.08 73.57,123.65 C36.17,112.74 13.55,119.92 13.55,119.92 L17.97,42.18 C17.97,42.18 40.29,31.54 77.98,42.94 C119.76,55.58 146.15,78.33 190.78,83.91 L184.86,160.96 Z"
  }), /*#__PURE__*/createElement("path", {
    fill: PRIMARY_BLACK,
    d: "M287.15,110.42 L238.26,41.4 C235.23,37.13 229.3,36.11 225.03,39.14 L171.93,76.75 C154.75,72.31 140,65.39 124.62,58.17 C110.57,51.57 96.05,44.75 78.99,39.59 C40.45,27.93 17.42,38.56 16.46,39.02 C15.31,39.57 14.54,40.71 14.47,41.98 L10.05,119.72 C9.98,120.87 10.49,121.97 11.39,122.68 C12.3,123.39 13.49,123.6 14.59,123.26 C14.65,123.24 16.46,122.7 19.83,122.17 L18.09,157.27 C18.03,158.4 18.53,159.5 19.43,160.2 C20.32,160.9 21.5,161.13 22.59,160.8 C22.92,160.7 55.96,151.08 92.13,161.02 C104.03,164.29 114.54,167.4 123.82,170.15 C131.91,172.54 139.55,174.81 146.73,176.76 L162.35,198.82 C163.82,200.89 166,202.26 168.5,202.69 C169.04,202.78 169.58,202.83 170.12,202.83 C172.07,202.83 173.96,202.23 175.59,201.08 L284.89,123.66 L284.89,123.66 C289.16,120.63 290.18,114.69 287.15,110.42 Z M74.55,120.29 C58.01,115.47 44.3,114.08 34,114.08 C26.59,114.08 20.95,114.8 17.31,115.46 L21.34,44.61 C27.26,42.52 47.04,37.24 76.97,46.29 C93.54,51.3 107.83,58.01 121.65,64.5 C142.11,74.11 161.48,83.2 187.03,86.93 L181.64,157.15 C164.52,155.22 146.84,147.89 126.56,139.48 C111.26,133.13 93.91,125.94 74.55,120.29 Z M280.85,117.94 L280.85,117.94 L171.55,195.36 C170.43,196.16 168.87,195.89 168.07,194.77 L146.44,164.24 C158.17,168.64 176.03,173.99 191.82,173.17 C193.57,173.08 194.98,171.71 195.12,169.97 L200.56,104.92 C200.72,103.05 199.37,101.39 197.51,101.16 C195.98,100.97 194.49,100.75 193.01,100.51 L194.26,84.19 C194.4,82.33 193.06,80.68 191.2,80.45 C187.72,80.02 184.37,79.47 181.1,78.84 L229.06,44.87 C229.5,44.56 230,44.41 230.5,44.41 C231.28,44.41 232.05,44.78 232.54,45.46 L281.43,114.48 C282.23,115.59 281.97,117.15 280.85,117.94 Z"
  }), /*#__PURE__*/createElement("path", {
    fill: iconTint(props.inverted),
    d: "M102.9 30.06C89.37 25.58 77.27 17.15 67.55 5.9 61.01-1.68 50.4-1.66 43.85 5.92 34.22 17.06 22.25 25.44 8.88 29.94 3.6 31.72.11 37.64.68 44.04 3.97 80.84 24.6 111.6 52.84 124.95 54.66 125.81 56.76 125.81 58.57 124.95 86.92 111.55 107.6 80.6 110.76 43.6 111.27 37.77 107.72 31.66 102.9 30.06zM171.46 94.62L164.95 85.42C163.17 82.91 159.69 82.32 157.18 84.09L144.19 93.29C141.68 95.07 141.09 98.55 142.86 101.06L149.37 110.26C151.15 112.77 154.63 113.36 157.14 111.59L170.13 102.39C172.64 100.61 173.24 97.13 171.46 94.62z",
    transform: "translate(76)"
  }), /*#__PURE__*/createElement("path", {
    fill: PRIMARY_SAND,
    d: "M150.77,46.68 L147.18,46.68 L147.18,39.27 C147.18,30.75 140.25,23.82 131.64,23.82 C131.64,23.82 131.64,23.82 131.64,23.82 C122.85,24.06 115.58,31.22 115.75,39.38 L115.75,46.68 L112.69,46.68 C110.76,46.68 109.19,48.25 109.19,50.18 L109.19,88.26 C109.19,90.19 110.76,91.76 112.69,91.76 L150.77,91.76 C152.7,91.76 154.27,90.19 154.27,88.26 L154.27,50.18 C154.27,48.25 152.7,46.68 150.77,46.68 Z M122.74,39.31 C122.65,35 126.97,30.95 131.72,30.82 C136.38,30.82 140.17,34.61 140.17,39.27 L140.17,46.68 L122.74,46.68 L122.74,39.31 Z"
  }))));
})(_templateObject17$1 || (_templateObject17$1 = _taggedTemplateLiteral([""])));
var SubmitProject = styled(function SubmitProject(props) {
  var name = 'submit-project';
  var viewBox = '0 0 273 190';
  return /*#__PURE__*/createElement(IrregularIllustration, _extends({
    backgroundOffset: {
      y: -50
    },
    name: name,
    viewBox: viewBox
  }, props), /*#__PURE__*/createElement(LargeIcon, _extends({}, props, {
    height: "100%",
    width: "100%",
    name: name,
    viewBox: viewBox
  }), /*#__PURE__*/createElement("g", {
    transform: "translate(121 61)"
  }, /*#__PURE__*/createElement("polyline", {
    fill: PRIMARY_SAND,
    points: "8.74 28.93 3.62 4.27 16.61 3.59 14.92 23.38"
  }), /*#__PURE__*/createElement("path", {
    fill: PRIMARY_BLACK,
    d: "M8.73,32.43 C7.11,32.43 5.65,31.29 5.31,29.64 L0.19,4.98 C-0.02,3.98 0.22,2.94 0.85,2.13 C1.48,1.32 2.42,0.83 3.44,0.77 L16.43,0.09 C17.45,0.04 18.43,0.42 19.13,1.15 C19.83,1.88 20.19,2.87 20.1,3.88 L18.41,23.66 C18.25,25.59 16.55,27.02 14.62,26.85 C12.69,26.69 11.27,24.99 11.43,23.06 L12.78,7.28 L7.88,7.54 L12.17,28.21 C12.56,30.1 11.35,31.96 9.45,32.35 C9.21,32.41 8.97,32.43 8.73,32.43 Z"
  })), /*#__PURE__*/createElement("path", {
    fill: PRIMARY_SAND,
    d: "M188.98,149.12 L88.3,156.12 C83.21,156.47 78.79,152.63 78.44,147.54 L69.67,21.34 C69.32,16.25 73.16,11.83 78.25,11.48 L178.93,4.48 C184.02,4.13 188.44,7.97 188.79,13.06 L197.56,139.26 C197.91,144.36 194.07,148.77 188.98,149.12 Z"
  }), /*#__PURE__*/createElement("g", {
    fill: PRIMARY_BLACK
  }, /*#__PURE__*/createElement("path", {
    d: "M44.86 79.02C44.16 77.09 42.63 75.63 40.68 75.02 38.72 74.4 36.64 74.72 34.96 75.9L22.98 84.27C21.31 85.44 20.29 87.28 20.19 89.32 20.09 91.36 20.92 93.29 22.47 94.62L44.32 113.33C45.56 114.39 47.06 114.92 48.57 114.92 49.86 114.92 51.17 114.53 52.31 113.73 54.79 112.01 55.77 108.94 54.73 106.1L44.86 79.02zM39.06 128.21L16.97 109.69C15.4 108.37 13.35 107.87 11.34 108.31 9.34 108.75 7.69 110.07 6.82 111.93L.63 125.17C-.23 127.02-.2 129.12.74 130.94 1.67 132.76 3.36 134.01 5.37 134.39L33.65 139.67C34.07 139.75 34.49 139.79 34.9 139.79 37.4 139.79 39.67 138.38 40.78 136.03 42.07 133.3 41.38 130.16 39.06 128.21zM121.95 109.5L122.5 120.48C122.6 122.46 124.28 123.98 126.26 123.89L128.68 123.77C129.43 125.75 131.39 127.11 133.63 127 135.86 126.89 137.68 125.34 138.23 123.29L140.65 123.17C142.63 123.07 144.15 121.39 144.06 119.41L143.51 108.43 121.95 109.5zM131.06 28.19C121.2 28.29 112.06 32.3 105.31 39.46 98.56 46.63 95.12 55.98 95.61 65.81L95.61 65.81C96.27 79.15 104.33 90.98 116.35 96.55 116.83 101.85 121.31 105.92 126.62 105.92 126.79 105.92 126.96 105.92 127.14 105.91L139.27 105.31C142.02 105.17 144.56 103.97 146.41 101.93 148.1 100.07 149.03 97.71 149.08 95.22 161.21 88.33 168.38 74.75 167.09 60.72 165.39 42.28 149.57 28 131.06 28.19zM143.97 89.99L141.89 91 142.08 94.83C142.12 95.71 141.82 96.56 141.23 97.22 140.64 97.88 139.82 98.26 138.94 98.31L126.81 98.91C124.97 98.99 123.42 97.59 123.33 95.76L123.26 94.25 123.26 94.16 123.2 91.75 121.03 90.91C110.42 86.8 103.19 76.8 102.63 65.45L102.63 65.45C102.24 57.54 105.01 50.01 110.44 44.25 115.87 38.49 123.22 35.27 131.16 35.18 146.05 34.97 158.78 46.51 160.15 61.34 161.21 73.27 154.72 84.78 143.97 89.99z"
  }), /*#__PURE__*/createElement("path", {
    d: "M137.74,54.56 L123.99,55.51 C122.97,55.58 122.03,56.09 121.42,56.91 C120.81,57.73 120.59,58.77 120.81,59.77 L126.68,85.81 C127.05,87.44 128.49,88.54 130.09,88.54 C130.34,88.54 130.6,88.51 130.86,88.45 C132.75,88.03 133.93,86.15 133.51,84.27 L128.54,62.21 L134.15,61.82 L133.06,74.74 C132.9,76.67 134.33,78.36 136.25,78.52 C138.18,78.68 139.87,77.25 140.03,75.33 L141.47,58.34 C141.56,57.32 141.19,56.32 140.48,55.59 C139.76,54.86 138.77,54.49 137.74,54.56 Z"
  }), /*#__PURE__*/createElement("path", {
    d: "M207.94,19.38 L192.72,19.33 L192.27,12.82 C192.03,9.42 190.49,6.32 187.92,4.09 C185.35,1.86 182.05,0.75 178.67,0.99 L77.99,7.99 C74.59,8.23 71.49,9.77 69.26,12.34 C67.03,14.91 65.93,18.19 66.16,21.59 L74.93,147.79 C75.17,151.18 76.71,154.28 79.28,156.52 C81.62,158.56 84.55,159.65 87.62,159.65 C87.92,159.65 88.22,159.64 88.52,159.62 L93.85,159.25 C94.33,165.82 99.81,171.03 106.5,171.05 L207.42,171.38 C207.43,171.38 207.45,171.38 207.46,171.38 C214.47,171.38 220.18,165.69 220.2,158.68 L220.610327,32.17 C220.66,25.14 214.97,19.41 207.94,19.38 Z M88.05,152.63 C86.52,152.73 85.04,152.24 83.88,151.23 C82.72,150.22 82.03,148.83 81.92,147.3 L73.15,21.1 C73.04,19.57 73.54,18.09 74.55,16.93 C75.56,15.77 76.95,15.08 78.48,14.97 L179.16,7.97 C179.3,7.96 179.43,7.96 179.57,7.96 C180.95,7.96 182.28,8.45 183.33,9.37 C184.49,10.38 185.18,11.77 185.29,13.3 L194.06,139.5 C194.28,142.66 191.89,145.41 188.73,145.63 C188.73,145.63 188.73,145.63 188.73,145.63 L88.05,152.63 Z"
  })), /*#__PURE__*/createElement("path", {
    fill: iconTint(props.inverted),
    d: "M259.15,64.65 L259.15,64.65 L232.64,44.48 C232.47,44.34 232.29,44.21 232.11,44.08 L231.95,43.96 L231.95,43.96 C229.74,42.37 227.18,41.33 224.39,41.04 C223.44,40.94 222.5,40.93 221.57,41.01 L221.57,41.01 C221.57,41.01 201.52,42.25 183.53,38.3 C165.55,34.35 169.89,45.79 179,50.86 C185.99,54.76 200.06,58.05 204.54,59.09 C209.02,60.13 206.72,61.43 204.32,61.32 C203.72,61.29 200.44,61.16 195.61,60.93 L200.58,132.45 C202.19,132.63 203.77,132.79 205.3,132.94 C227.68,135.13 246.56,130.59 246.56,130.59 C246.9,130.58 247.25,130.56 247.59,130.52 L247.82,130.5 L247.82,130.49 C258.53,129.2 268.07,115.72 269.89,98.41 C271.45,83.6 266.89,70.36 259.15,64.65 Z M217.44,97.73 C212.11,94.73 208.45,90.67 206.72,85.76 C204.89,80.57 205.3,74.83 207.94,68.63 C208.75,66.73 210.34,65.02 209.98,68.4 C209.56,72.39 209.57,78 211.57,83.55 C213.54,89.02 216.74,93.43 219.31,96.36 C221.56,98.93 219.21,98.73 217.44,97.73 Z"
  })));
})(_templateObject18$1 || (_templateObject18$1 = _taggedTemplateLiteral([""])));

var TwoToned$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  BookWithQuestion: BookWithQuestion,
  Coaching: Coaching,
  Coins: Coins,
  CrackedEgg: CrackedEgg,
  DeliveryMethods: DeliveryMethods,
  EnvelopeWithHeart: EnvelopeWithHeart,
  HeartWithConfetti: HeartWithConfetti,
  Hourglass: Hourglass,
  Okpal: Okpal,
  PaperPlane: PaperPlane$1,
  Share: Share$1,
  SpeechBubbles: SpeechBubbles,
  AllOrNothing: AllOrNothing,
  DiscoverProjects: DiscoverProjects,
  IdeaToAction: IdeaToAction,
  Partners: Partners,
  SecurePayment: SecurePayment,
  SubmitProject: SubmitProject
});



var index$3 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  twoToned: TwoToned$1,
  Illustration: Illustration
});

function HorizontalLogo(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1125.09 283.52"
  }, props), /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("path", {
    id: "reuse-0",
    d: "M115.31 172.41v.18h-.18l.18-.18z",
    className: "cls-1"
  }), /*#__PURE__*/createElement("path", {
    id: "reuse-1",
    d: "m172.61 115.31-.01.02v-.02h.01z",
    className: "cls-1"
  })), /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("style", null, ".cls-1{fill:#f6f1ec}.cls-2{fill:#d2edf7}")), /*#__PURE__*/createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/createElement("g", {
    id: "Calque_1",
    "data-name": "Calque 1"
  }, /*#__PURE__*/createElement("path", {
    d: "M371.92 198.17h6.91v33.25a17.33 17.33 0 0 1-5.44 13.17 18.64 18.64 0 0 1-13.09 5 18.85 18.85 0 0 1-13.17-5 17.28 17.28 0 0 1-5.37-13.17v-33.25h6.92v33.25a10.86 10.86 0 0 0 3.38 8.31 12.1 12.1 0 0 0 16.48 0 10.86 10.86 0 0 0 3.38-8.31Zm20.22 0H399v44.28h20.67v6.4h-27.53Zm65.03 0h6.91v33.25a17.33 17.33 0 0 1-5.44 13.17 19.74 19.74 0 0 1-26.26 0 17.24 17.24 0 0 1-5.38-13.17v-33.25h6.91v33.25a10.87 10.87 0 0 0 3.39 8.31 12.09 12.09 0 0 0 16.47 0 10.87 10.87 0 0 0 3.39-8.31Zm20.22 0h6.84v44.28h20.67v6.4h-27.51Zm36.41 0h30v6.4h-23.16v16.18h20.23v6.4h-20.23v15.3h23.91v6.4H513.8Zm60.68 50.68v-50.68h19.64c7 0 12.58 2.43 16.62 7.21s6.18 10.81 6.18 18.24-2.06 13.39-6.11 18.17-9.63 7.06-16.69 7.06Zm6.84-6.4h12.8c5.07 0 9-1.76 11.77-5.22s4.19-8.09 4.19-13.61-1.4-10.15-4.19-13.68-6.7-5.37-11.77-5.37h-12.8Zm46.41-44.28h30v6.4h-23.16v16.18h20.23v6.4h-20.23v15.3h23.91v6.4h-30.75Zm44.5 36.04a8.63 8.63 0 0 0 3.16 6.26 11.15 11.15 0 0 0 7.73 2.72c6.1 0 9.56-3.24 10.22-7.43.37-5-3.31-7.87-8.61-9l-6.54-1.62q-12.36-3.19-12.36-13.24a12.59 12.59 0 0 1 4.85-10.22 17.33 17.33 0 0 1 11.55-4 17.09 17.09 0 0 1 11.7 4.12 13.54 13.54 0 0 1 4.63 10.74h-6.84c0-5-4-8.31-9.56-8.31a11 11 0 0 0-6.69 2.13 6.64 6.64 0 0 0-2.8 5.52c0 3.53 2.43 5.88 7.21 7.06l6.62 1.62c9.63 2.43 14.49 7.94 13.53 15.89a14 14 0 0 1-5.22 9.49q-4.51 3.75-11.69 3.75a18.35 18.35 0 0 1-12.66-4.69 14.25 14.25 0 0 1-5.07-10.82Zm38.39-36.04h6.84v50.68h-6.84Zm55.17 10.67a18.26 18.26 0 0 0-25.53 1 20.11 20.11 0 0 0 0 27.51 17.87 17.87 0 0 0 13.32 5.65 17.53 17.53 0 0 0 11.4-3.68 13.22 13.22 0 0 0 4.78-10h-14.42v-6h22.22c0 17.36-9 26.19-24 26.19a24.36 24.36 0 0 1-18.15-7.51 26.56 26.56 0 0 1 0-36.85 25.43 25.43 0 0 1 35.31-.88Zm57.59 40.01h-6.55l-23.09-38.17v38.17h-6.84v-50.68h6.76l22.88 37.88v-37.88h6.84Zm36.7-14.64a8.63 8.63 0 0 0 3.16 6.26 11.15 11.15 0 0 0 7.73 2.72c6.1 0 9.56-3.24 10.22-7.43.37-5-3.31-7.87-8.61-9l-6.58-1.67q-12.36-3.19-12.36-13.24a12.57 12.57 0 0 1 4.86-10.22 17.28 17.28 0 0 1 11.54-4 17.09 17.09 0 0 1 11.7 4.12 13.54 13.54 0 0 1 4.63 10.74h-6.84c0-5-4-8.31-9.56-8.31a11.06 11.06 0 0 0-6.69 2.13 6.64 6.64 0 0 0-2.8 5.52c0 3.53 2.43 5.88 7.21 7.06l6.62 1.62c9.64 2.43 14.49 7.94 13.53 15.89a14 14 0 0 1-5.22 9.49q-4.51 3.75-11.69 3.75a18.35 18.35 0 0 1-12.62-4.64 14.25 14.25 0 0 1-5.07-10.82Zm56.64 14.64h-7.07v-23.32l-19.19-27.36h8.16l14.57 20.52 14.71-20.52h8.23l-19.41 27.36ZM946 234.21a8.63 8.63 0 0 0 3.16 6.26 11.15 11.15 0 0 0 7.73 2.72c6.1 0 9.56-3.24 10.22-7.43.37-5-3.31-7.87-8.61-9l-6.5-1.67q-12.36-3.19-12.36-13.24a12.57 12.57 0 0 1 4.86-10.22 17.28 17.28 0 0 1 11.54-4 17.09 17.09 0 0 1 11.7 4.12 13.54 13.54 0 0 1 4.63 10.74h-6.84c0-5-4-8.31-9.56-8.31a11.06 11.06 0 0 0-6.69 2.13 6.64 6.64 0 0 0-2.8 5.52c0 3.53 2.43 5.88 7.21 7.06l6.62 1.62c9.64 2.43 14.49 7.94 13.53 15.89a14 14 0 0 1-5.22 9.49q-4.52 3.75-11.69 3.75a18.35 18.35 0 0 1-12.71-4.64 14.25 14.25 0 0 1-5.07-10.82Zm33.16-36.04h37.66v6.48h-15.37v44.2h-6.92v-44.2h-15.37Zm46.63 0h30v6.4h-23.17v16.18h20.23v6.4h-20.23v15.3h23.91v6.4h-30.75Zm69 37.22 17.87-37.22h6.25l6.18 50.68h-6.77l-4.63-38.1-15.82 32.51h-6l-16-32.51-4.63 38.1h-6.77l6.18-50.68h6.25ZM371 155.24h-29.24L363 34.58h49.91c13.31 0 22.77 4 28.37 11.91q8.62 11.82 5.72 28.37a49.15 49.15 0 0 1-15.76 28.37c-8.57 7.88-19.43 11.77-32.74 11.77h-20.66Zm16.81-95.09-5.43 29.6h19.26c17.17.87 23.29-30.65 5.43-29.6ZM523 155.24h-73l21.15-120.66h29.6l-16.82 95.09h43.43Zm33.94-11.03c-7.88-8.58-10.51-19.44-8.23-32.92l13.48-76.71h29.42l-13.48 76.71c-1.93 10.5 5.42 18 15.06 18a21.58 21.58 0 0 0 13.48-5.07 19.94 19.94 0 0 0 7.88-13L628 34.58h29.42L644 111.29a51.22 51.22 0 0 1-19.79 32.92q-16.27 12.6-35.72 12.61-19.74 0-31.55-12.61ZM733.26 108l46.4-73.38h24.69l-6.47 120.66h-30.13l4-65-33.27 51h-22.04l-15.58-51-18.92 65h-30.12l36.08-120.7h24.34Zm164.92 47.24h-79.86l21.19-120.66h78.28l-4.37 25.57h-49l-4.2 23.12h43.08l-4.55 25h-43.12l-3.63 21.4h50.61Z"
  }), /*#__PURE__*/createElement("use", {
    xlinkHref: "#reuse-0",
    className: "cls-1"
  }), /*#__PURE__*/createElement("use", {
    xlinkHref: "#reuse-0",
    className: "cls-2"
  }), /*#__PURE__*/createElement("path", {
    d: "M283.52 55.84a2.19 2.19 0 0 0-2.19-2.19H234.5l44.13-44a2.19 2.19 0 0 0 0-3.1 2.19 2.19 0 0 0-3.1 0l-45.65 45.51V2.19A2.19 2.19 0 0 0 227.69 0a2.2 2.2 0 0 0-2.2 2.19v51.46H172.6V2.19A2.19 2.19 0 0 0 170.4 0a2.19 2.19 0 0 0-2.19 2.19v51.46h-52.9V2.19A2.19 2.19 0 0 0 113.12 0a2.19 2.19 0 0 0-2.19 2.19v51.46H58V2.19A2.19 2.19 0 0 0 55.84 0a2.19 2.19 0 0 0-2.19 2.19v51.46H2.19A2.19 2.19 0 0 0 0 55.84 2.19 2.19 0 0 0 2.19 58h51.46v52.9H2.19A2.19 2.19 0 0 0 0 113.12a2.19 2.19 0 0 0 2.19 2.19h51.46v52.9H2.19A2.19 2.19 0 0 0 0 170.4a2.19 2.19 0 0 0 2.19 2.19h51.46v52.9H2.19A2.19 2.19 0 0 0 0 227.68a2.2 2.2 0 0 0 2.19 2.2h49.24L9.31 274.76a2.18 2.18 0 0 0 0 3.1 2.19 2.19 0 0 0 3.1 0l41.24-44v47.48a2.19 2.19 0 0 0 2.19 2.19 2.19 2.19 0 0 0 2.16-2.2v-51.45h52.9v51.45a2.19 2.19 0 0 0 2.19 2.19 2.19 2.19 0 0 0 2.19-2.19v-51.45h52.9v51.45a2.19 2.19 0 0 0 2.19 2.19 2.19 2.19 0 0 0 2.2-2.19v-51.45h52.89v51.45a2.2 2.2 0 0 0 2.2 2.19 2.19 2.19 0 0 0 2.19-2.19v-51.45h51.45a2.2 2.2 0 0 0 2.19-2.2 2.19 2.19 0 0 0-2.19-2.19h-51.42v-52.9h51.45a2.19 2.19 0 0 0 2.19-2.19 2.19 2.19 0 0 0-2.19-2.19h-51.45v-52.9h51.45a2.19 2.19 0 0 0 2.19-2.19 2.19 2.19 0 0 0-2.19-2.19h-51.45V58h51.45a2.19 2.19 0 0 0 2.19-2.16ZM58 58h52.9v52.9H58Zm167.49 167.49H172.6v-52.9h52.89Zm0-114.56-4.38 4.38h4.38v52.9H172.6v-4.38l-8.77 8.76h4.38v52.9h-52.9v-4.38l-4.38 4.38H58v-52.9l4.39-4.38H58v-52.9h52.9v4.39l8.77-8.77h-4.39V58h52.9v4.38L172.6 58h51.29L198.2 83.63l3.1 3.1 24.19-24.11Z",
    className: "cls-2"
  }), /*#__PURE__*/createElement("path", {
    fill: "#18a5d6",
    d: "M115.31 172.41v.18h-.18l.18-.18z"
  }), /*#__PURE__*/createElement("use", {
    xlinkHref: "#reuse-1",
    className: "cls-1"
  }), /*#__PURE__*/createElement("path", {
    fill: "#074f68",
    d: "M110.93 119.7v50.88l-2.02 2.01-50.88 50.7v-50.7l52.9-52.89zm52.9 52.89-52.9 52.9H62.04l48.89-48.71 4.2-4.19h48.7zm4.38-110.18v51.1l-1.81 1.8-51.09 50.91v-50.91l52.9-52.9zm52.9 52.9-52.9 52.9h-48.68l48.68-48.51 4.39-4.37.01-.02h48.5zm-22.92-31.68-25.59 25.51V58.03l25.59 25.6zm27.3 27.3h-48.48l24.29-24.2 24.19 24.2z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#fff",
    d: "m225.49 110.93-4.38 4.38H172.6v.02l-4.39 4.37-48.68 48.51h48.68l-4.38 4.38h-48.52v-.18l-.18.18-4.2 4.19-48.89 48.71h-4.01v-2.2l50.88-50.7 2.02-2.01V119.7l4.38-4.39v50.91l51.09-50.91 1.81-1.8v-51.1l4.39-4.38v51.11l25.59-25.51 3.11 3.1-24.29 24.2h48.48z"
  }), /*#__PURE__*/createElement("use", {
    xlinkHref: "#reuse-1",
    className: "cls-1"
  }))));
}

var Plume = /*#__PURE__*/Object.freeze({
  __proto__: null,
  HorizontalLogo: HorizontalLogo
});

function HorizontalLogo$1() {
  return /*#__PURE__*/createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 506.93 157",
    width: "104",
    height: "32.1"
  }, /*#__PURE__*/createElement("path", {
    d: "M112.37 122.21a36.15 36.15 0 0 1-32.09-19.5 2 2 0 0 0-3.55 0 36.17 36.17 0 1 1 .37-32.58 17.91 17.91 0 0 0 .84 24.56.8.8 0 0 0 1.12 0 17.91 17.91 0 0 0 .84-24.56 36.16 36.16 0 1 1 32.46 52.07z",
    fill: "#FFF"
  }), /*#__PURE__*/createElement("path", {
    d: "M156 33.11a3.27 3.27 0 0 0-4.63 0L146 38.49a78.49 78.49 0 0 0-135 0l-5.41-5.38A3.27 3.27 0 0 0 0 35.43V78.5a78.5 78.5 0 0 0 157 0V35.43a3.27 3.27 0 0 0-1-2.32zm-43.67 89.09a36.15 36.15 0 0 1-32.09-19.5 2 2 0 0 0-3.55 0 36.17 36.17 0 1 1 .37-32.58 17.91 17.91 0 0 0 .84 24.56.8.8 0 0 0 1.12 0 17.91 17.91 0 0 0 .84-24.56 36.16 36.16 0 1 1 32.46 52.07z"
  }), /*#__PURE__*/createElement("path", {
    d: "M43.34 57.86a15.83 15.83 0 1 1-3 0 22.83 22.83 0 1 0 3 0z",
    fill: "#18A5D6"
  }), /*#__PURE__*/createElement("path", {
    d: "M45.25 60.69a6 6 0 0 1 2.27 4.72 5.69 5.69 0 0 1-11.37 0 6 6 0 0 1 2.18-4.57l.34-.33a4.05 4.05 0 0 0 1.63-2.61 15.47 15.47 0 1 0 3 0h-.12c.12.9 1.11 1.92 2.07 2.79z",
    fill: "#18A5D6"
  }), /*#__PURE__*/createElement("path", {
    d: "M45.25 60.69a6 6 0 0 1 2.27 4.72 5.69 5.69 0 0 1-11.37 0 6 6 0 0 1 2.18-4.57l.34-.33a4.05 4.05 0 0 0 1.63-2.61 15.47 15.47 0 1 0 3 0h-.12c.12.9 1.11 1.92 2.07 2.79z",
    fill: "#004E69"
  }), /*#__PURE__*/createElement("path", {
    d: "M116.56 57.87a15.48 15.48 0 1 1-2.92 0 23 23 0 1 0 2.92 0z",
    fill: "#F01446"
  }), /*#__PURE__*/createElement("path", {
    d: "M118.58 60.69a6 6 0 0 1 2.27 4.72 5.69 5.69 0 0 1-11.37 0 6 6 0 0 1 2.18-4.57l.34-.33c.87-.84 1.56-1.51 1.63-2.59a15.82 15.82 0 1 0 2.92 0c.11.9 1.08 1.91 2.03 2.77z",
    fill: "#F01446"
  }), /*#__PURE__*/createElement("path", {
    d: "M118.58 60.69a6 6 0 0 1 2.27 4.72 5.69 5.69 0 0 1-11.37 0 6 6 0 0 1 2.18-4.57l.34-.33c.87-.84 1.56-1.51 1.63-2.59a15.82 15.82 0 1 0 2.92 0c.11.9 1.08 1.91 2.03 2.77z",
    fill: "#8B0020"
  }), /*#__PURE__*/createElement("path", {
    d: "M113.65 57.86z",
    fill: "#fff"
  }), /*#__PURE__*/createElement("path", {
    d: "M240.08 87.91c0 10.66-5.19 15.17-12.84 15.17s-12.85-4.51-12.85-15.17v-22a2 2 0 0 0-2.15-2l-16.54 1.47a2 2 0 0 0-1.81 2v20.53c0 22.82 13.39 34.3 33.34 34.3s33.34-11.61 33.34-34.3v-26a2 2 0 0 0-2.15-2l-16.54 1.45a2 2 0 0 0-1.81 2zm129.25 0c0 10.66-5.19 15.17-12.84 15.17s-12.85-4.51-12.85-15.17V54.6a2 2 0 0 0-2.15-2l-16.54 1.45a2 2 0 0 0-1.81 2v31.86c0 22.82 13.39 34.3 33.34 34.3s33.34-11.61 33.34-34.3V50.56a2 2 0 0 0-2.15-2L371.13 50a2 2 0 0 0-1.81 2zm33.33 12.02v18.52a2 2 0 0 0 2 2h37.64a2 2 0 0 0 2-2v-16.54a2 2 0 0 0-2-2h-19.14V47.64a2 2 0 0 0-2.15-2l-16.54 1.45a2 2 0 0 0-1.81 2zm-129.25 0v18.52a2 2 0 0 0 2 2h37.66a2 2 0 0 0 2-2v-16.54a2 2 0 0 0-2-2h-19.16v-41a2 2 0 0 0-2.15-2l-16.54 1.45a2 2 0 0 0-1.81 2zm233.52-43.01V40.31a2 2 0 0 0-2.15-2l-46.94 4.11a2 2 0 0 0-1.81 2v74a2 2 0 0 0 2 2H505a2 2 0 0 0 2-2v-16.51a2 2 0 0 0-2-2h-28.46v-11.1h17.28a2 2 0 0 0 2-2V73a2 2 0 0 0-2-2h-17.28v-9.61l28.59-2.5a2 2 0 0 0 1.8-1.97z"
  }));
}
function OwlOnlyLogo() {
  return /*#__PURE__*/createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "136",
    height: "136",
    viewBox: "0 0 140 140"
  }, /*#__PURE__*/createElement("g", {
    fill: "none"
  }, /*#__PURE__*/createElement("path", {
    d: "M96.866 105.612c-11.983 0-22.375-6.793-27.548-16.736a1.707 1.707 0 0 0-3.044 0c-5.172 9.943-15.565 16.736-27.548 16.736-17.879 0-32.227-15.117-30.96-33.267 1.06-15.177 13.269-27.51 28.435-28.71 13.295-1.05 24.993 6.286 30.39 17.278-2.378 2.714-3.832 6.257-3.832 10.15 0 4.276 1.749 8.136 4.557 10.932a.686.686 0 0 0 .96 0c2.809-2.796 4.557-6.656 4.557-10.933 0-3.892-1.454-7.435-3.832-10.15 5.397-10.99 17.096-18.327 30.39-17.276 15.167 1.199 27.375 13.532 28.434 28.71 1.268 18.149-13.08 33.266-30.96 33.266",
    fill: "#FFF"
  }), /*#__PURE__*/createElement("path", {
    d: "M96.866 105.612c-11.983 0-22.375-6.793-27.548-16.736a1.707 1.707 0 0 0-3.044 0c-5.172 9.943-15.565 16.736-27.548 16.736-17.879 0-32.227-15.117-30.96-33.267 1.06-15.177 13.269-27.51 28.435-28.71 13.295-1.05 24.993 6.286 30.39 17.278-2.378 2.714-3.832 6.257-3.832 10.15 0 4.276 1.749 8.136 4.557 10.932a.686.686 0 0 0 .96 0c2.809-2.796 4.557-6.656 4.557-10.933 0-3.892-1.454-7.435-3.832-10.15 5.397-10.99 17.096-18.327 30.39-17.276 15.167 1.199 27.375 13.532 28.434 28.71 1.268 18.149-13.08 33.266-30.96 33.266m37.49-76.476a2.808 2.808 0 0 0-3.975 0l-4.615 4.614C114.023 13.975 92.463.713 67.796.713S21.57 13.975 9.827 33.75l-4.614-4.614a2.802 2.802 0 0 0-1.988-.823 2.806 2.806 0 0 0-2.81 2.811v36.97c0 37.215 30.167 67.383 67.381 67.383s67.382-30.168 67.382-67.382V31.124c0-.718-.275-1.439-.823-1.988",
    fill: "#000"
  }), /*#__PURE__*/createElement("path", {
    d: "M37.62 50.382c6.77.65 12.09 6.334 12.135 13.277.048 7.418-5.925 13.475-13.344 13.525-7.42.05-13.476-5.92-13.523-13.34-.05-7.004 5.28-12.764 12.115-13.43l.002-.022c-10.298.682-18.413 9.261-18.344 19.718.074 10.86 8.938 19.601 19.792 19.528 10.86-.074 19.599-8.934 19.528-19.796-.07-10.37-8.171-18.794-18.361-19.46",
    fill: "#18A5D6"
  }), /*#__PURE__*/createElement("path", {
    d: "M39.254 52.808c1.18 1.119 1.96 2.233 1.949 4.055-.01 2.626-2.232 4.76-4.953 4.772-2.597-.017-4.791-2.222-4.807-4.815-.012-2.12 1.213-3.295 1.872-3.926l.29-.282c.743-.716 1.328-1.288 1.397-2.199-6.834.667-12.165 6.428-12.114 13.43.047 7.42 6.103 13.393 13.523 13.341 7.42-.05 13.392-6.106 13.344-13.524-.046-6.945-5.366-12.628-12.135-13.279l-.107-.004c.07.809.916 1.68 1.74 2.431",
    fill: "#18A5D6"
  }), /*#__PURE__*/createElement("path", {
    d: "M39.254 52.808c1.18 1.119 1.96 2.233 1.949 4.055-.01 2.626-2.232 4.76-4.953 4.772-2.597-.017-4.791-2.222-4.807-4.815-.012-2.12 1.213-3.295 1.872-3.926l.29-.282c.743-.716 1.328-1.288 1.397-2.199-6.834.667-12.165 6.428-12.114 13.43.047 7.42 6.103 13.393 13.523 13.341 7.42-.05 13.392-6.106 13.344-13.524-.046-6.945-5.366-12.628-12.135-13.279l-.107-.004c.07.809.916 1.68 1.74 2.431",
    fill: "#004E69"
  }), /*#__PURE__*/createElement("path", {
    d: "m100.463 50.383.002.018c6.895.608 12.289 6.397 12.239 13.443-.048 7.42-6.104 13.392-13.524 13.34-7.42-.05-13.391-6.107-13.344-13.525.046-6.937 5.357-12.616 12.119-13.275-10.182.673-18.275 9.095-18.345 19.458-.07 10.862 8.667 19.722 19.528 19.796 10.854.073 19.719-8.668 19.793-19.528.07-10.5-8.112-19.105-18.468-19.727",
    fill: "#F01446"
  }), /*#__PURE__*/createElement("path", {
    d: "M102.203 52.808c1.18 1.118 1.959 2.232 1.949 4.055-.01 2.625-2.231 4.76-4.953 4.772-2.598-.018-4.79-2.222-4.807-4.814-.011-2.12 1.213-3.296 1.871-3.927l.292-.283c.75-.724 1.342-1.299 1.4-2.227-6.761.658-12.073 6.338-12.119 13.275-.047 7.418 5.924 13.474 13.345 13.525 7.42.051 13.475-5.92 13.522-13.34.051-7.046-5.343-12.836-12.237-13.444.083.802.919 1.665 1.737 2.408",
    fill: "#F01446"
  }), /*#__PURE__*/createElement("path", {
    d: "M102.203 52.808c1.18 1.118 1.959 2.232 1.949 4.055-.01 2.625-2.231 4.76-4.953 4.772-2.598-.018-4.79-2.222-4.807-4.814-.011-2.12 1.213-3.296 1.871-3.927l.292-.283c.75-.724 1.342-1.299 1.4-2.227-6.761.658-12.073 6.338-12.119 13.275-.047 7.418 5.924 13.474 13.345 13.525 7.42.051 13.475-5.92 13.522-13.34.051-7.046-5.343-12.836-12.237-13.444.083.802.919 1.665 1.737 2.408",
    fill: "#8B0020"
  }), /*#__PURE__*/createElement("path", {
    d: "m97.972 50.382-.017.001h.017",
    fill: "#FFF"
  })));
}

var Ulule = /*#__PURE__*/Object.freeze({
  __proto__: null,
  HorizontalLogo: HorizontalLogo$1,
  OwlOnlyLogo: OwlOnlyLogo
});



var index$4 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  plume: Plume,
  ulule: Ulule
});

var _templateObject$g, _templateObject2$b, _templateObject3$9, _templateObject4$7, _templateObject5$6, _templateObject6$6, _templateObject7$4, _templateObject8$4, _templateObject9$4, _templateObject10$4;
var focusedBorder = css(_templateObject$g || (_templateObject$g = _taggedTemplateLiteral(["\n  border: 1px solid ", ";\n"])), PRIMARY_BLUE);
var errorBorder = css(_templateObject2$b || (_templateObject2$b = _taggedTemplateLiteral(["\n  border: 1px dashed ", ";\n"])), SECONDARY_RED);
var successBorder = css(_templateObject3$9 || (_templateObject3$9 = _taggedTemplateLiteral(["\n  border: 1px solid ", ";\n"])), PRIMARY_GREEN);
var defaultBorder = css(_templateObject4$7 || (_templateObject4$7 = _taggedTemplateLiteral(["\n  border: 1px solid ", ";\n"])), GREY_SHADE_5);
var Input = styled.input(_templateObject5$6 || (_templateObject5$6 = _taggedTemplateLiteral(["\n  height: 50px;\n  border-radius: 2px;\n  padding: 15px;\n  font-family: ", ";\n  font-size: 15px;\n  font-weight: 400;\n  outline-color: ", ";\n  background-color: ", ";\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  box-sizing: border-box;\n\n  &:focus {\n    ", ";\n    outline: none;\n  }\n\n  &::placeholder {\n    font-family: ", ";\n    color: ", ";\n    font-size: 15px;\n    font-weight: 400;\n  }\n\n  ", "\n\n  &:disabled {\n    ", "\n    color: ", ";\n    background-color: ", ";\n  }\n"])), PRIMARY_FONT, PRIMARY_BLUE, PRIMARY_WHITE, focusedBorder, PRIMARY_FONT, GREY_SHADE_3, function (_ref) {
  var status = _ref.status;

  if (status === 'error') {
    return errorBorder;
  }

  if (status === 'success') {
    return successBorder;
  }

  return defaultBorder;
}, defaultBorder, GREY_SHADE_3, GREY_SHADE_6);
var HiddenFocusableInput = styled.input(_templateObject6$6 || (_templateObject6$6 = _taggedTemplateLiteral(["\n  position: absolute;\n  display: inline-block;\n  cursor: pointer;\n  opacity: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n"])));
var ComposedWrapper = styled.div(_templateObject7$4 || (_templateObject7$4 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  ", "\n  background-color: ", ";\n\n  ", ", ", ":focus {\n    background-color: transparent;\n    border: none;\n  }\n\n  &:focus-within {\n    ", "\n  }\n\n  ", "\n\n  &[disabled] {\n    ", "\n    background-color: ", ";\n  }\n"])), defaultBorder, PRIMARY_WHITE, Input, Input, focusedBorder, function (_ref2) {
  var status = _ref2.status;

  if (status === 'error') {
    return errorBorder;
  }

  if (status === 'success') {
    return successBorder;
  }

  return defaultBorder;
}, defaultBorder, GREY_SHADE_6);
var Count = styled.span(_templateObject8$4 || (_templateObject8$4 = _taggedTemplateLiteral(["\n  font-size: 10px;\n  font-family: ", ";\n  font-weight: 500;\n  ", "\n"])), PRIMARY_FONT, function (_ref3) {
  var isError = _ref3.isError;

  if (isError) {
    return css(_templateObject9$4 || (_templateObject9$4 = _taggedTemplateLiteral(["\n        color: ", ";\n      "])), SECONDARY_RED);
  } else {
    return css(_templateObject10$4 || (_templateObject10$4 = _taggedTemplateLiteral(["\n        color: ", ";\n      "])), GREY_SHADE_1);
  }
});

var _input = /*#__PURE__*/Object.freeze({
  __proto__: null,
  focusedBorder: focusedBorder,
  errorBorder: errorBorder,
  successBorder: successBorder,
  defaultBorder: defaultBorder,
  Input: Input,
  HiddenFocusableInput: HiddenFocusableInput,
  ComposedWrapper: ComposedWrapper,
  Count: Count
});

var _templateObject$h, _templateObject2$c, _templateObject3$a, _templateObject4$8, _templateObject5$7, _templateObject6$7, _templateObject7$5, _templateObject8$5, _templateObject9$5, _templateObject10$5, _templateObject11$3, _templateObject12$3, _templateObject13$2, _templateObject14$2, _templateObject15$2, _templateObject16$2, _templateObject17$2, _templateObject18$2;
var bounce = keyframes(_templateObject$h || (_templateObject$h = _taggedTemplateLiteral(["\n  30% {\n    transform: scale(1.4);\n  }\n\n  50% {\n    transform: scale(0.8);\n  }\n\n  100% {\n    transform: scale(1);\n  }\n"])));
var debounce = keyframes(_templateObject2$c || (_templateObject2$c = _taggedTemplateLiteral(["\n  30% {\n    transform: scale(0.8);\n  }\n\n  50% {\n    transform: scale(0.7);\n  }\n\n  100% {\n    transform: scale(1);\n  }\n"])));
var Base = styled.button(_templateObject3$a || (_templateObject3$a = _taggedTemplateLiteral(["\n  align-items: center;\n  border-radius: 2px;\n  border: none;\n  box-sizing: border-box;\n  cursor: pointer;\n  display: inline-flex;\n  font-family: ", ";\n  font-weight: 900;\n  height: 50px;\n  justify-content: center;\n  outline: none;\n  padding: 10px 40px;\n  text-align: center;\n  text-transform: uppercase;\n  transition: 0.3s ease;\n  text-decoration: none;\n\n  &::-moz-focus-inner {\n    border: 0;\n  }\n\n  &:focus {\n    outline: none;\n  }\n"])), PRIMARY_FONT);
var smallButtonCss = css(_templateObject4$8 || (_templateObject4$8 = _taggedTemplateLiteral(["\n  font-size: 13px;\n  line-height: 18px;\n"])));
var mediumButtonCss = css(_templateObject5$7 || (_templateObject5$7 = _taggedTemplateLiteral(["\n  font-size: 17px;\n  line-height: 18px;\n"])));
var buttonColors = {
  black: {
    base: PRIMARY_BLACK,
    hover: PRIMARY_BLACK_HOVER,
    hoverOutlined: PRIMARY_BLACK
  },
  blue: {
    base: PRIMARY_BLUE,
    hover: PRIMARY_BLUE_HOVER,
    hoverOutlined: PRIMARY_BLUE
  },
  green: {
    base: PRIMARY_GREEN,
    hover: PRIMARY_GREEN_HOVER,
    hoverOutlined: PRIMARY_GREEN
  },
  grey: {
    base: GREY_SHADE_4,
    text: PRIMARY_WHITE
  },
  red: {
    base: PRIMARY_RED,
    hover: PRIMARY_RED_HOVER,
    hoverOutlined: PRIMARY_RED
  },
  white: {
    base: PRIMARY_WHITE,
    hover: PRIMARY_WHITE,
    hoverOutlined: PRIMARY_BLUE
  }
};
var Button = styled(Base)(_templateObject6$7 || (_templateObject6$7 = _taggedTemplateLiteral(["\n  line-height: 18px;\n\n  &:disabled {\n    ", "\n\n  }\n\n  ", "\n\n  ", "\n\n  ", "}\n"])), function (_ref) {
  var loading = _ref.loading;
  return !loading && css(_templateObject7$5 || (_templateObject7$5 = _taggedTemplateLiteral(["\n        background-color: ", ";\n        border: 2px solid ", ";\n        color: ", ";\n        pointer-events: none;\n        cursor: not-allowed;\n      "])), buttonColors['grey'].base, buttonColors['grey'].base, buttonColors['grey'].text);
}, function (_ref2) {
  var _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? 'small' : _ref2$size;

  if (size === 'medium') {
    return mediumButtonCss;
  }

  return smallButtonCss;
}, function (_ref3) {
  var loading = _ref3.loading;
  return loading && css(_templateObject8$5 || (_templateObject8$5 = _taggedTemplateLiteral(["\n      cursor: wait;\n    "])));
}, function (_ref4) {
  var _ref4$kind = _ref4.kind,
      kind = _ref4$kind === void 0 ? 'primary' : _ref4$kind,
      _ref4$color = _ref4.color,
      color = _ref4$color === void 0 ? 'blue' : _ref4$color,
      _ref4$loading = _ref4.loading,
      loading = _ref4$loading === void 0 ? false : _ref4$loading;

  if (kind === 'secondary') {
    return css(_templateObject9$5 || (_templateObject9$5 = _taggedTemplateLiteral(["\n        background-color: transparent;\n        border: 2px solid ", ";\n        color: ", ";\n\n        ", "\n      "])), buttonColors[color].base, buttonColors[color].base, !loading && css(_templateObject10$5 || (_templateObject10$5 = _taggedTemplateLiteral(["\n            &:hover {\n              border: 2px solid ", ";\n              background-color: ", ";\n              color: ", ";\n            }\n\n            &:disabled {\n              border: 2px solid ", ";\n              color: ", ";\n              cursor: default;\n            }\n          "])), buttonColors[color].hoverOutlined, buttonColors[color].hoverOutlined, PRIMARY_WHITE, GREY_SHADE_4, GREY_SHADE_4));
  }

  return css(_templateObject11$3 || (_templateObject11$3 = _taggedTemplateLiteral(["\n      background-color: ", ";\n      color: ", ";\n\n      ", "\n    "])), buttonColors[color].base, PRIMARY_WHITE, !loading && css(_templateObject12$3 || (_templateObject12$3 = _taggedTemplateLiteral(["\n          &:hover {\n            background-color: ", ";\n          }\n\n          &:disabled {\n            background-color: ", ";\n            cursor: default;\n          }\n        "])), buttonColors[color].hover, GREY_SHADE_4));
});
Button.displayName = 'S.button.Button';
var CallToAction = styled(Button)(_templateObject13$2 || (_templateObject13$2 = _taggedTemplateLiteral(["\n  width: 100%;\n\n  ", " {\n    height: 22px;\n    ", ";\n    width: 22px;\n  }\n"])), Icon, function (_ref5) {
  var _ref5$onlyGlyph = _ref5.onlyGlyph,
      onlyGlyph = _ref5$onlyGlyph === void 0 ? false : _ref5$onlyGlyph;
  return !onlyGlyph && css(_templateObject14$2 || (_templateObject14$2 = _taggedTemplateLiteral(["\n        margin-right: 10px;\n      "])));
});
CallToAction.displayName = 'S.button.CallToAction';
/** @deprecated use the `LinkButton` component instead */

var TextButton = styled.button(_templateObject15$2 || (_templateObject15$2 = _taggedTemplateLiteral(["\n  cursor: pointer;\n  background: transparent;\n  border: none;\n  color: ", ";\n  font-family: ", ";\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 18px;\n  margin: 0;\n  padding: 13px;\n  width: 100%;\n\n  &:hover {\n    text-decoration: underline;\n  }\n"])), GREY_SHADE_3, PRIMARY_FONT);
TextButton.displayName = 'S.button.TextButton';
var RoundButton = styled(Base)(_templateObject16$2 || (_templateObject16$2 = _taggedTemplateLiteral(["\n  height: 32px;\n  padding: 0 15px;\n  border-radius: 19px;\n  ", ";\n  box-shadow: 0 1px 2px 1px rgba(35, 34, 33, 0.1);\n  color: ", ";\n  background-color: ", ";\n\n  ", " {\n    height: 17px;\n    width: 17px;\n    margin: 0 0 0 6px;\n    color: ", ";\n    transition: 0.3s ease;\n    animation: ", " cubic-bezier(0.04, 0.4, 0.5, 0.95) 0.8s forwards 1;\n  }\n\n  ", "\n"])), smallButtonCss, GREY_SHADE_1, PRIMARY_WHITE, Icon, GREY_SHADE_4, function (_ref6) {
  var active = _ref6.active;
  return active ? debounce : bounce;
}, function (_ref7) {
  var active = _ref7.active,
      hover = _ref7.hover;

  if (active && hover) {
    return css(_templateObject17$2 || (_templateObject17$2 = _taggedTemplateLiteral(["\n        color: ", ";\n        ", " {\n          color: ", ";\n        }\n        background-color: ", ";\n      "])), PRIMARY_WHITE, Icon, PRIMARY_WHITE, PRIMARY_RED);
  } else if (active && !hover || !active && hover) {
    return css(_templateObject18$2 || (_templateObject18$2 = _taggedTemplateLiteral(["\n        ", " {\n          color: ", ";\n        }\n      "])), Icon, PRIMARY_BLUE);
  }
});
RoundButton.displayName = 'S.button.RoundButton';

var _button = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Base: Base,
  buttonColors: buttonColors,
  Button: Button,
  CallToAction: CallToAction,
  TextButton: TextButton,
  RoundButton: RoundButton
});

var _templateObject$i, _templateObject2$d, _templateObject3$b, _templateObject4$9, _templateObject5$8;
var ResultWrapper = styled.li(_templateObject$i || (_templateObject$i = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 15px;\n  color: ", ";\n  line-height: 18px;\n  background-color: ", ";\n  padding: 6px;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  user-select: none;\n"])), PRIMARY_FONT, PRIMARY_BLACK, function (_ref) {
  var isFocused = _ref.isFocused;
  return isFocused ? hexToRgb(PRIMARY_BLUE, 0.05) : 'transparent';
});
var Wrapper = styled(ComposedWrapper)(_templateObject2$d || (_templateObject2$d = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"])));
var Input$1 = styled(Input)(_templateObject3$b || (_templateObject3$b = _taggedTemplateLiteral(["\n  flex: 1 1 auto;\n  width: 0;\n  border: none;\n  padding-left: 0;\n  padding-right: 0;\n"])));
var SearchIcon = styled(Search).attrs({
  size: 18
})(_templateObject4$9 || (_templateObject4$9 = _taggedTemplateLiteral(["\n  color: ", ";\n  flex: 0 0 auto;\n  margin: 0 13px;\n"])), GREY_SHADE_4);
var Clear = styled(TextButton)(_templateObject5$8 || (_templateObject5$8 = _taggedTemplateLiteral(["\n  width: auto;\n  color: ", ";\n  flex: 0 0 auto;\n  margin: 0 10px;\n"])), GREY_SHADE_4);

var _autocomplete = /*#__PURE__*/Object.freeze({
  __proto__: null,
  ResultWrapper: ResultWrapper,
  Wrapper: Wrapper,
  Input: Input$1,
  SearchIcon: SearchIcon,
  Clear: Clear
});

var _templateObject$j, _templateObject2$e, _templateObject3$c, _templateObject4$a, _templateObject5$9, _templateObject6$8, _templateObject7$6, _templateObject8$6, _templateObject9$6, _templateObject10$6, _templateObject11$4, _templateObject12$4, _templateObject13$3, _templateObject14$3, _templateObject15$3, _templateObject16$3, _templateObject17$3, _templateObject18$3, _templateObject19$1, _templateObject20$1, _templateObject21$1, _templateObject22$1, _templateObject23$1;
var Base$1 = styled.div(_templateObject$j || (_templateObject$j = _taggedTemplateLiteral(["\n  color: ", ";\n  font-family: ", ";\n  margin: 0;\n  padding: 0;\n"])), PRIMARY_BLACK, PRIMARY_FONT);
var XXXL = styled(Base$1)(_templateObject2$e || (_templateObject2$e = _taggedTemplateLiteral(["\n  font-size: 76px;\n  font-style: italic;\n  font-weight: 900;\n  line-height: 76px;\n"])));
XXXL.displayName = 'S.heading.XXXL';
var XXL = styled(Base$1)(_templateObject3$c || (_templateObject3$c = _taggedTemplateLiteral(["\n  font-size: 65px;\n  line-height: 65px;\n  font-weight: 900;\n"])));
XXL.displayName = 'S.heading.XXL';
var XL = styled(Base$1)(_templateObject4$a || (_templateObject4$a = _taggedTemplateLiteral(["\n  font-size: 44px;\n  line-height: 44px;\n  font-weight: 900;\n"])));
XL.displayName = 'S.heading.XL';
var _largeStyle = css(_templateObject5$9 || (_templateObject5$9 = _taggedTemplateLiteral(["\n  font-size: 30px;\n  line-height: 31px;\n  font-weight: 900;\n"])));
var L = styled(Base$1)(_templateObject6$8 || (_templateObject6$8 = _taggedTemplateLiteral(["\n  ", "\n"])), _largeStyle);
L.displayName = 'S.heading.L';
var serifM = styled(Base$1)(_templateObject7$6 || (_templateObject7$6 = _taggedTemplateLiteral(["\n  font-size: 26px;\n  line-height: 35px;\n  font-family: ", ";\n"])), SECONDARY_FONT);
serifM.displayName = 'S.heading.serifM';
var _mediumStyle = css(_templateObject8$6 || (_templateObject8$6 = _taggedTemplateLiteral(["\n  font-size: 26px;\n  line-height: 34px;\n  font-weight: 500;\n"])));
var M = styled(Base$1)(_templateObject9$6 || (_templateObject9$6 = _taggedTemplateLiteral(["\n  ", "\n"])), _mediumStyle);
M.displayName = 'S.heading.M';
var _smallStyle = css(_templateObject10$6 || (_templateObject10$6 = _taggedTemplateLiteral(["\n  font-size: 23px;\n  line-height: 30px;\n  font-weight: 500;\n"])));
var S = styled(Base$1)(_templateObject11$4 || (_templateObject11$4 = _taggedTemplateLiteral(["\n  ", "\n"])), _smallStyle);
S.displayName = 'S.heading.S';
var _xSmallStyle = css(_templateObject12$4 || (_templateObject12$4 = _taggedTemplateLiteral(["\n  font-size: 19px;\n  line-height: 26px;\n  font-weight: 600;\n"])));
var XS = styled(Base$1)(_templateObject13$3 || (_templateObject13$3 = _taggedTemplateLiteral(["\n  ", "\n"])), _xSmallStyle);
XS.displayName = 'S.heading.XS';
var _xxSmallStyle = css(_templateObject14$3 || (_templateObject14$3 = _taggedTemplateLiteral(["\n  font-size: 18px;\n  line-height: 24px;\n  font-weight: 500;\n"])));
var XXS = styled(Base$1)(_templateObject15$3 || (_templateObject15$3 = _taggedTemplateLiteral(["\n  ", "\n"])), _xxSmallStyle);
XXS.displayName = 'S.heading.XXS';
var _xxxSmallStyle = css(_templateObject16$3 || (_templateObject16$3 = _taggedTemplateLiteral(["\n  font-size: 16px;\n  line-height: 22px;\n  font-weight: 600;\n"])));
var XXXS = styled(Base$1)(_templateObject17$3 || (_templateObject17$3 = _taggedTemplateLiteral(["\n  ", "\n"])), _xxxSmallStyle);
XXXS.displayName = 'S.heading.XXXS';
var _xxxxSmallStyle = css(_templateObject18$3 || (_templateObject18$3 = _taggedTemplateLiteral(["\n  font-size: 15px;\n  line-height: 18px;\n  font-weight: 700;\n  color: ", ";\n  text-transform: uppercase;\n"])), GREY_SHADE_2);
var XXXXS = styled(Base$1)(_templateObject19$1 || (_templateObject19$1 = _taggedTemplateLiteral(["\n  ", "\n"])), _xxxxSmallStyle);
XXXXS.displayName = 'S.heading.XXXXS';
var Card1 = styled(Base$1)(_templateObject20$1 || (_templateObject20$1 = _taggedTemplateLiteral(["\n  font-size: 13px;\n  line-height: 18px;\n  font-weight: 500;\n  color: ", ";\n"])), GREY_SHADE_1);
Card1.displayName = 'S.heading.Card1';
var Card2 = styled(Base$1)(_templateObject21$1 || (_templateObject21$1 = _taggedTemplateLiteral(["\n  font-size: 12px;\n  line-height: 16px;\n  font-weight: 400;\n  color: ", ";\n"])), GREY_SHADE_1);
Card2.displayName = 'S.heading.Card2';
var Card3 = styled(Base$1)(_templateObject22$1 || (_templateObject22$1 = _taggedTemplateLiteral(["\n  font-size: 12px;\n  line-height: 16px;\n  font-weight: 300;\n  color: ", ";\n"])), GREY_SHADE_1);
Card3.displayName = 'S.heading.Card3';
var XXXXXS = styled(Base$1)(_templateObject23$1 || (_templateObject23$1 = _taggedTemplateLiteral(["\n  font-size: 10px;\n  line-height: 12px;\n  font-weight: 500;\n  color: ", ";\n  text-transform: uppercase;\n"])), GREY_SHADE_1);
XXXXXS.displayName = 'S.heading.XXXXXS';

var _heading = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Base: Base$1,
  XXXL: XXXL,
  XXL: XXL,
  XL: XL,
  _largeStyle: _largeStyle,
  L: L,
  serifM: serifM,
  _mediumStyle: _mediumStyle,
  M: M,
  _smallStyle: _smallStyle,
  S: S,
  _xSmallStyle: _xSmallStyle,
  XS: XS,
  _xxSmallStyle: _xxSmallStyle,
  XXS: XXS,
  _xxxSmallStyle: _xxxSmallStyle,
  XXXS: XXXS,
  _xxxxSmallStyle: _xxxxSmallStyle,
  XXXXS: XXXXS,
  Card1: Card1,
  Card2: Card2,
  Card3: Card3,
  XXXXXS: XXXXXS
});

var _templateObject$k, _templateObject2$f, _templateObject3$d, _templateObject4$b, _templateObject5$a, _templateObject6$9, _templateObject7$7, _templateObject8$7, _templateObject9$7, _templateObject10$7, _templateObject11$5;
var Flag = styled.img(_templateObject$k || (_templateObject$k = _taggedTemplateLiteral(["\n  width: 20px;\n  height: 15px;\n  margin: 0 8px 0 4px;\n"])));
Flag.displayName = 'S.image.Flag';
var Avatar = styled.img(_templateObject2$f || (_templateObject2$f = _taggedTemplateLiteral(["\n  object-fit: cover;\n  border-radius: 50%;\n  background-image: ", ";\n  background-position: center;\n  background-size: cover;\n  border: 2px solid ", ";\n  ", "\n"])), function (props) {
  return props.src ? "url(".concat(props.src, ")") : undefined;
}, PRIMARY_WHITE, function (_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'small' : _ref$type;

  if (type === 'small') {
    return css(_templateObject3$d || (_templateObject3$d = _taggedTemplateLiteral(["\n        width: 36px;\n        height: 36px;\n      "])));
  } else if (type === 'extra-small') {
    return css(_templateObject4$b || (_templateObject4$b = _taggedTemplateLiteral(["\n        width: 30px;\n        height: 30px;\n      "])));
  } else if (type === 'large') {
    return css(_templateObject5$a || (_templateObject5$a = _taggedTemplateLiteral(["\n        width: 90px;\n        height: 90px;\n      "])));
  } else if (type === 'extra-large') {
    return css(_templateObject6$9 || (_templateObject6$9 = _taggedTemplateLiteral(["\n        width: 160px;\n        height: 160px;\n      "])));
  } else {
    return css(_templateObject7$7 || (_templateObject7$7 = _taggedTemplateLiteral(["\n        width: 52px;\n        height: 52px;\n      "])));
  }
});
Avatar.displayName = 'S.image.Avatar';
var Pastille = styled.div(_templateObject8$7 || (_templateObject8$7 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50%;\n  box-shadow: ", ";\n\n  * {\n    max-width: 80px;\n    max-height: 80px;\n    text-align: center;\n  }\n\n  ", "\n"])), function (_ref2) {
  var _ref2$noBorder = _ref2.noBorder,
      noBorder = _ref2$noBorder === void 0 ? false : _ref2$noBorder;
  return noBorder ? 'none !important' : '0 0 0 5px ' + PRIMARY_WHITE;
}, function (_ref3) {
  var _ref3$size = _ref3.size,
      size = _ref3$size === void 0 ? 'medium' : _ref3$size;

  if (size === 'extraSmall') {
    return css(_templateObject9$7 || (_templateObject9$7 = _taggedTemplateLiteral(["\n        height: 40px;\n        width: 40px;\n        box-shadow: 0 0 0 2px ", ";\n      "])), PRIMARY_WHITE);
  }

  if (size === 'small') {
    return css(_templateObject10$7 || (_templateObject10$7 = _taggedTemplateLiteral(["\n        height: 60px;\n        width: 60px;\n        box-shadow: 0 0 0 2px ", ";\n      "])), PRIMARY_WHITE);
  }

  if (size === 'medium') {
    return css(_templateObject11$5 || (_templateObject11$5 = _taggedTemplateLiteral(["\n        width: 120px;\n        height: 120px;\n        box-shadow: 0 0 0 5px ", ";\n      "])), PRIMARY_WHITE);
  }
});
Pastille.displayName = 'S.image.Pastille';

var _image = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Flag: Flag,
  Avatar: Avatar,
  Pastille: Pastille
});

var _templateObject$l, _templateObject2$g, _templateObject3$e, _templateObject4$c, _templateObject5$b, _templateObject6$a, _templateObject7$8, _templateObject8$8;
var Wrapper$1 = styled.a(_templateObject$l || (_templateObject$l = _taggedTemplateLiteral(["\n  min-width: 220px;\n  min-height: 70px;\n  max-width: 320px;\n  max-height: 244px;\n  border-radius: 4px;\n  position: relative;\n  cursor: pointer;\n  display: block;\n  transition: all 150ms ease-out;\n\n  &:hover {\n    transition: all 200ms ease-in-out;\n    box-shadow: 2px 2px 14px ", ";\n  }\n\n  &::before {\n    content: '';\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    border-radius: 4px;\n    background: linear-gradient(transparent 0%, rgba(0, 0, 0, 0.6) 100%);\n    height: 129px;\n  }\n"])), GREY_SHADE_5);
var Container = styled.div(_templateObject2$g || (_templateObject2$g = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  padding: 0 11px 0 15px;\n  align-items: center;\n  box-sizing: border-box;\n"])));
var Info$1 = styled.div(_templateObject3$e || (_templateObject3$e = _taggedTemplateLiteral(["\n  padding-right: 10px;\n"])));
var Title = styled(L)(_templateObject4$c || (_templateObject4$c = _taggedTemplateLiteral(["\n  color: ", ";\n"])), PRIMARY_WHITE);
var Avatar$1 = styled(Avatar)(_templateObject5$b || (_templateObject5$b = _taggedTemplateLiteral(["\n  flex-grow: 0;\n  flex-shrink: 0;\n  align-self: flex-end;\n  margin: 0 0 18px;\n"])));
var Description = styled(Card1)(_templateObject6$a || (_templateObject6$a = _taggedTemplateLiteral(["\n  color: ", ";\n  margin: 5px 0 15px;\n"])), PRIMARY_WHITE);
var Img = styled.img(_templateObject7$8 || (_templateObject7$8 = _taggedTemplateLiteral(["\n  width: 100%;\n  border-radius: 4px;\n  flex: 1 1 auto;\n  object-fit: cover;\n  display: flex;\n  max-height: 244px;\n  min-height: 244px;\n  min-width: 320px;\n"])));
var SubButton = styled.div(_templateObject8$8 || (_templateObject8$8 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: -7%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));

var _channelCard = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Wrapper: Wrapper$1,
  Container: Container,
  Info: Info$1,
  Title: Title,
  Avatar: Avatar$1,
  Description: Description,
  Img: Img,
  SubButton: SubButton
});

var _templateObject$m, _templateObject2$h, _templateObject3$f, _templateObject4$d, _templateObject5$c;
var Checkmark = styled(Check).attrs({
  size: 18
})(_templateObject$m || (_templateObject$m = _taggedTemplateLiteral(["\n  border-radius: 2px;\n  border: 2px solid ", ";\n  box-sizing: border-box;\n  padding: 2px;\n  background-color: ", ";\n  vertical-align: baseline;\n\n  /* override specificity of svg:not([fill]) in reset css */\n  && {\n    fill: transparent;\n  }\n\n  ", "\n\n  ", "\n"])), GREY_SHADE_4, PRIMARY_WHITE, function (_ref) {
  var status = _ref.status;

  if (status === 'checked') {
    return css(_templateObject2$h || (_templateObject2$h = _taggedTemplateLiteral(["\n        background-color: ", ";\n        border-color: ", ";\n        /* override specificity of svg:not([fill]) in reset css */\n        && {\n          fill: ", ";\n        }\n      "])), PRIMARY_BLUE, PRIMARY_BLUE, PRIMARY_WHITE);
  }

  if (status === 'error') {
    return css(_templateObject3$f || (_templateObject3$f = _taggedTemplateLiteral(["\n        border-color: ", ";\n      "])), PRIMARY_RED);
  }

  if (status === 'focused') {
    return css(_templateObject4$d || (_templateObject4$d = _taggedTemplateLiteral(["\n        border-color: ", ";\n      "])), GREY_SHADE_3);
  }

  return '';
}, function (_ref2) {
  var disabled = _ref2.disabled,
      status = _ref2.status;

  if (disabled) {
    return css(_templateObject5$c || (_templateObject5$c = _taggedTemplateLiteral(["\n        background-color: ", ";\n        border-color: ", ";\n        /* override specificity of svg:not([fill]) in reset css */\n        && {\n          fill: ", ";\n        }\n      "])), GREY_SHADE_6, GREY_SHADE_4, status !== 'checked' ? 'transparent' : GREY_SHADE_4);
  }
});

var _checkbox = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Checkmark: Checkmark
});

var _templateObject$n, _templateObject2$i;
var SkewedContainer = styled.div(_templateObject$n || (_templateObject$n = _taggedTemplateLiteral(["\n  margin-top: -20px;\n  padding: 35px 0 60px;\n  transform-origin: top left;\n  transform: skew(0, -5deg);\n"])));
SkewedContainer.displayName = 'S.container.SkewedContainer'; // WARNING: the risk is that on some browsers the content can be blurred
// an alternative is to use ::before / ::after to generate a triangle

var SkewedContent = styled.div(_templateObject2$i || (_templateObject2$i = _taggedTemplateLiteral(["\n  transform: skew(0, 5deg);\n"])));
SkewedContent.displayName = 'S.container.SkewedContent';

var _container = /*#__PURE__*/Object.freeze({
  __proto__: null,
  SkewedContainer: SkewedContainer,
  SkewedContent: SkewedContent
});

var _templateObject$o;
var Group = styled.div(_templateObject$o || (_templateObject$o = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n"])));

var _controls = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Group: Group
});

var _templateObject$p, _templateObject2$j, _templateObject3$g, _templateObject4$e, _templateObject5$d, _templateObject6$b, _templateObject7$9, _templateObject8$9, _templateObject9$8, _templateObject10$8;
var _baseStyle = css(_templateObject$p || (_templateObject$p = _taggedTemplateLiteral(["\n  color: ", ";\n  font-family: ", ";\n  margin: 0;\n  padding: 0;\n"])), PRIMARY_BLACK, PRIMARY_FONT);
var Base$2 = styled.p(_templateObject2$j || (_templateObject2$j = _taggedTemplateLiteral(["\n  ", "\n"])), _baseStyle);
var smallStyle = css(_templateObject3$g || (_templateObject3$g = _taggedTemplateLiteral(["\n  ", ";\n  font-size: 14px;\n  line-height: 22px;\n  font-weight: 400;\n"])), _baseStyle);
var mediumStyle = css(_templateObject4$e || (_templateObject4$e = _taggedTemplateLiteral(["\n  ", ";\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: 300;\n"])), _baseStyle);
var largeStyle = css(_templateObject5$d || (_templateObject5$d = _taggedTemplateLiteral(["\n  ", ";\n  font-size: 18px;\n  line-height: 26px;\n  font-weight: 300;\n"])), _baseStyle);
var XS$1 = styled(Base$2)(_templateObject6$b || (_templateObject6$b = _taggedTemplateLiteral(["\n  font-size: 11px;\n  line-height: 16px;\n"])));
XS$1.displayName = 'S.copy.XS';
var S$1 = styled(Base$2)(_templateObject7$9 || (_templateObject7$9 = _taggedTemplateLiteral(["\n  ", "\n"])), smallStyle);
S$1.displayName = 'S.copy.S';
var M$1 = styled(Base$2)(_templateObject8$9 || (_templateObject8$9 = _taggedTemplateLiteral(["\n  ", "\n"])), mediumStyle);
M$1.displayName = 'S.copy.M';
var L$1 = styled(Base$2)(_templateObject9$8 || (_templateObject9$8 = _taggedTemplateLiteral(["\n  ", "\n"])), largeStyle);
L$1.displayName = 'S.copy.L';
var Serif = styled(Base$2)(_templateObject10$8 || (_templateObject10$8 = _taggedTemplateLiteral(["\n  font-size: 18px;\n  line-height: 26px;\n  font-family: ", ";\n"])), SECONDARY_FONT);
Serif.displayName = 'S.copy.Serif';

var _copy = /*#__PURE__*/Object.freeze({
  __proto__: null,
  _baseStyle: _baseStyle,
  Base: Base$2,
  smallStyle: smallStyle,
  mediumStyle: mediumStyle,
  largeStyle: largeStyle,
  XS: XS$1,
  S: S$1,
  M: M$1,
  L: L$1,
  Serif: Serif
});

var _templateObject$q, _templateObject2$k, _templateObject3$h, _templateObject4$f;
var DropdownStyle = css(_templateObject$q || (_templateObject$q = _taggedTemplateLiteral(["\n  background-color: ", ";\n  box-shadow: 1px 4px 3px 1px rgba(0, 0, 0, 0.12);\n"])), PRIMARY_WHITE);
var Dropdown = styled.div(_templateObject2$k || (_templateObject2$k = _taggedTemplateLiteral(["\n  ", "\n"])), DropdownStyle);
var MenuDropdownTitle = styled.div(_templateObject3$h || (_templateObject3$h = _taggedTemplateLiteral(["\n  ", " {\n    margin-right: 7px;\n  }\n\n  a {\n    ", ";\n  }\n"])), Icon, function (_ref) {
  var isOpen = _ref.isOpen;

  if (isOpen) {
    return css(_templateObject4$f || (_templateObject4$f = _taggedTemplateLiteral(["\n          color: ", ";\n        "])), PRIMARY_BLUE);
  }
});

var _dropdown = /*#__PURE__*/Object.freeze({
  __proto__: null,
  DropdownStyle: DropdownStyle,
  Dropdown: Dropdown,
  MenuDropdownTitle: MenuDropdownTitle
});

var _templateObject$r, _templateObject2$l, _templateObject3$i, _templateObject4$g, _templateObject5$e, _templateObject6$c, _templateObject7$a, _templateObject8$a, _templateObject9$9, _templateObject10$9;
var Description$1 = styled.span(_templateObject$r || (_templateObject$r = _taggedTemplateLiteral(["\n  font-family: ", ", sans-serif;\n  font-weight: 300;\n  font-size: 15px;\n  line-height: 22px;\n  color: ", ";\n"])), PRIMARY_FONT, PRIMARY_BLACK); // TODO: rename application wide to Field or Wrapper

var Label = styled.div(_templateObject2$l || (_templateObject2$l = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n"]))); // TODO: rename application wide to Label

var ActualLabel = styled.label(_templateObject3$i || (_templateObject3$i = _taggedTemplateLiteral([""])));
var Status = styled.div(_templateObject4$g || (_templateObject4$g = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n"])));
var TitleWrapper = styled.div(_templateObject5$e || (_templateObject5$e = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: baseline;\n\n  @media screen and ", " {\n    flex-direction: row;\n  }\n"])), TABLET);
var Title$1 = styled.span(_templateObject6$c || (_templateObject6$c = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-weight: 400;\n  font-size: 15px;\n  line-height: 20px;\n  color: ", ";\n  margin-right: 15px;\n"])), PRIMARY_FONT, PRIMARY_BLACK);
var Context = styled.span(_templateObject7$a || (_templateObject7$a = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-weight: 400;\n  font-size: 10px;\n  line-height: 14px;\n  color: ", ";\n  text-transform: uppercase;\n  white-space: pre;\n  overflow: hidden;\n"])), PRIMARY_FONT, GREY_SHADE_3);
var Message = styled.div(_templateObject8$a || (_templateObject8$a = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-weight: 500;\n  font-size: 13px;\n  line-height: 22px;\n  ", "\n"])), PRIMARY_FONT, function (_ref) {
  var type = _ref.type;

  if (type === 'error') {
    return css(_templateObject9$9 || (_templateObject9$9 = _taggedTemplateLiteral(["\n        color: ", ";\n      "])), SECONDARY_RED);
  }

  if (type === 'success') {
    return css(_templateObject10$9 || (_templateObject10$9 = _taggedTemplateLiteral(["\n        color: ", ";\n      "])), PRIMARY_GREEN);
  }
});

var _field = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Description: Description$1,
  Label: Label,
  ActualLabel: ActualLabel,
  Status: Status,
  TitleWrapper: TitleWrapper,
  Title: Title$1,
  Context: Context,
  Message: Message
});

var _templateObject$s, _templateObject2$m;
var Wrapper$2 = styled.span(_templateObject$s || (_templateObject$s = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"])));
var Bullet = styled.sup(_templateObject2$m || (_templateObject2$m = _taggedTemplateLiteral(["\n  align-items: baseline;\n  color: ", ";\n  display: inline-flex;\n  flex-shrink: 0;\n  font-size: 11px;\n  font-weight: 500;\n  justify-content: center;\n  line-height: inherit;\n  margin-left: 6px;\n  top: 0px;\n\n  &::before {\n    background-color: ", ";\n    border-radius: 6px;\n    content: '';\n    margin-right: 3px;\n    min-height: 6px;\n    min-width: 6px;\n  }\n"])), SECONDARY_RED, SECONDARY_RED);
Bullet.displayName = 'S.jewel.Bullet';

var _jewel = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Wrapper: Wrapper$2,
  Bullet: Bullet
});

var _templateObject$t, _templateObject2$n, _templateObject3$j, _templateObject4$h, _templateObject5$f, _templateObject6$d, _templateObject7$b, _templateObject8$b, _templateObject9$a, _templateObject10$a, _templateObject11$6;
var withIconStyle = css(_templateObject$t || (_templateObject$t = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n\n  ", " {\n    color: ", ";\n    margin-right: 5px;\n  }\n\n  ", " + * {\n    vertical-align: middle;\n  }\n"])), Icon, GREY_SHADE_4, Icon);
var _baseStyle$1 = css(_templateObject2$n || (_templateObject2$n = _taggedTemplateLiteral(["\n  cursor: pointer;\n  font-family: ", ";\n  font-weight: 600;\n  outline: none;\n  text-decoration: none;\n  transition: color 200ms ease-in-out;\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n"])), PRIMARY_FONT, function (_ref) {
  var _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  return disabled && css(_templateObject3$j || (_templateObject3$j = _taggedTemplateLiteral(["\n      &[href] {\n        pointer-events: none;\n        opacity: 0.4;\n      }\n\n      opacity: 0.4;\n    "])));
}, function (_ref2) {
  var _ref2$underlined = _ref2.underlined,
      underlined = _ref2$underlined === void 0 ? false : _ref2$underlined;
  return underlined && css(_templateObject4$h || (_templateObject4$h = _taggedTemplateLiteral(["\n      text-decoration: underline;\n    "])));
}, function (_ref3) {
  var _ref3$uppercase = _ref3.uppercase,
      uppercase = _ref3$uppercase === void 0 ? false : _ref3$uppercase;
  return uppercase && css(_templateObject5$f || (_templateObject5$f = _taggedTemplateLiteral(["\n      text-transform: uppercase;\n    "])));
}, function (_ref4) {
  var _ref4$withIcon = _ref4.withIcon,
      withIcon = _ref4$withIcon === void 0 ? false : _ref4$withIcon;
  return withIcon && withIconStyle;
});
var Base$3 = styled.a(_templateObject6$d || (_templateObject6$d = _taggedTemplateLiteral(["\n  ", "\n"])), _baseStyle$1);
var _primaryTintedColor = css(_templateObject7$b || (_templateObject7$b = _taggedTemplateLiteral(["\n  color: ", ";\n"])), PRIMARY_BLUE);
var _primaryStyle = css(_templateObject8$b || (_templateObject8$b = _taggedTemplateLiteral(["\n  ", ";\n\n  &:active,\n  &:hover {\n    &[href] {\n      color: ", ";\n    }\n  }\n"])), function (_ref5) {
  var _ref5$tinted = _ref5.tinted,
      tinted = _ref5$tinted === void 0 ? false : _ref5$tinted;
  return tinted ? _primaryTintedColor : "color: ".concat(PRIMARY_BLACK);
}, PRIMARY_BLUE_HOVER);
var Primary = styled(Base$3)(_templateObject9$a || (_templateObject9$a = _taggedTemplateLiteral(["\n  ", "\n"])), _primaryStyle);
Primary.displayName = 'S.link.Primary';
var Secondary = styled(Base$3)(_templateObject10$a || (_templateObject10$a = _taggedTemplateLiteral(["\n  color: ", ";\n  font-weight: 400;\n\n  &:active,\n  &:hover {\n    &[href] {\n      text-decoration: underline;\n    }\n  }\n"])), GREY_SHADE_3);
Secondary.displayName = 'S.link.Secondary';
var Inverted = styled(Base$3)(_templateObject11$6 || (_templateObject11$6 = _taggedTemplateLiteral(["\n  color: ", ";\n\n  &:hover,\n  &:active {\n    &[href] {\n      text-decoration: underline;\n    }\n  }\n"])), PRIMARY_WHITE);
Inverted.displayName = 'S.link.Inverted';

var _link = /*#__PURE__*/Object.freeze({
  __proto__: null,
  _baseStyle: _baseStyle$1,
  Base: Base$3,
  _primaryTintedColor: _primaryTintedColor,
  _primaryStyle: _primaryStyle,
  Primary: Primary,
  Secondary: Secondary,
  Inverted: Inverted
});

var _templateObject$u, _templateObject2$o;
var MiniTitle = styled(Card1)(_templateObject$u || (_templateObject$u = _taggedTemplateLiteral(["\n  -moz-box-orient: vertical;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  bottom: 10px;\n  color: ", ";\n  display: -webkit-box;\n  overflow: hidden;\n  position: absolute;\n  width: 80%;\n  word-break: normal;\n"])), PRIMARY_WHITE);
var MiniWrapper = styled.a(_templateObject2$o || (_templateObject2$o = _taggedTemplateLiteral(["\n  background-color: ", ";\n  background-image: ", ";\n  background-position: center;\n  background-size: cover;\n  border-radius: 4px;\n  box-sizing: border-box;\n  cursor: pointer;\n  display: block;\n  height: 80px;\n  max-width: 110px;\n  min-width: 72px;\n  padding: 10px;\n  position: relative;\n\n  &::before {\n    background: linear-gradient(transparent 0%, rgba(0, 0, 0, 0.6) 100%);\n    border-radius: 4px;\n    bottom: 0;\n    content: '';\n    height: 80px;\n    left: 0;\n    position: absolute;\n    right: 0;\n  }\n\n  &:hover {\n    box-shadow: 2px 2px 14px ", ";\n  }\n\n  @media screen and ", " {\n    width: 104px;\n  }\n"])), function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return backgroundColor ? "".concat(backgroundColor) : "".concat(PRIMARY_WHITE);
}, function (_ref2) {
  var image = _ref2.image;
  return image ? "url(".concat(image, ")") : undefined;
}, GREY_SHADE_5, TABLET);

var _miniChannelCard = /*#__PURE__*/Object.freeze({
  __proto__: null,
  MiniTitle: MiniTitle,
  MiniWrapper: MiniWrapper
});

var _templateObject$v, _templateObject2$p, _templateObject3$k, _templateObject4$i, _templateObject5$g;
var Overlay = styled.div(_templateObject$v || (_templateObject$v = _taggedTemplateLiteral(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background-color: rgba(0, 0, 0, 0.7);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: ", ";\n"])), MODAL);
var Wrapper$3 = styled.div(_templateObject2$p || (_templateObject2$p = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: ", ";\n\n  &::before {\n    content: '';\n    width: 100%;\n    height: 50px;\n    background: ", ";\n    display: block;\n  }\n\n  ", " {\n    color: ", ";\n    left: 13px;\n    position: absolute;\n    top: 16px;\n    &:hover {\n      cursor: pointer;\n    }\n  }\n\n  @media screen and ", " {\n    width: 100%;\n    max-width: 540px;\n    border: 1px solid ", ";\n    position: relative;\n\n    &::before {\n      height: 20px;\n      background: ", ";\n    }\n\n    ", " {\n      left: auto;\n      top: 13px;\n      right: 13px;\n      color: ", ";\n    }\n  }\n"])), PRIMARY_WHITE, PRIMARY_BLUE, Close, PRIMARY_WHITE, TABLET, GREY_SHADE_5, PRIMARY_WHITE, Close, GREY_SHADE_4);
var Body = styled.div(_templateObject3$k || (_templateObject3$k = _taggedTemplateLiteral(["\n  padding: 15px 24px;\n"])));
var SmallWrapper = styled(Wrapper$3)(_templateObject4$i || (_templateObject4$i = _taggedTemplateLiteral(["\n  box-shadow: rgba(0, 0, 0, 0.5) 0 2px 3px;\n\n  @media screen and ", " {\n    border: none;\n  }\n\n  &::before {\n    height: 0;\n  }\n\n  ", " {\n    top: 16px;\n    color: ", ";\n  }\n"])), TABLET, Close, PRIMARY_WHITE);
var Title$2 = styled(Card1)(_templateObject5$g || (_templateObject5$g = _taggedTemplateLiteral(["\n  background: ", ";\n  color: ", ";\n  padding: 13px 37px;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n"])), PRIMARY_BLUE, PRIMARY_WHITE);

var _modal = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Overlay: Overlay,
  Wrapper: Wrapper$3,
  Body: Body,
  SmallWrapper: SmallWrapper,
  Title: Title$2
});

var _templateObject$w, _templateObject2$q, _templateObject3$l, _templateObject4$j, _templateObject5$h, _templateObject6$e, _templateObject7$c, _templateObject8$c, _templateObject9$b, _templateObject10$b, _templateObject11$7, _templateObject12$5, _templateObject13$4, _templateObject14$4, _templateObject15$4, _templateObject16$4;
var BaseNotification = styled.div(_templateObject$w || (_templateObject$w = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 24px;\n"])), PRIMARY_FONT);
var fixedNotificationColor = {
  alert: SECONDARY_YELLOW,
  error: PRIMARY_RED,
  info: PRIMARY_BLUE,
  success: PRIMARY_GREEN
};
var Callout = styled(BaseNotification)(_templateObject2$q || (_templateObject2$q = _taggedTemplateLiteral(["\n  color: ", ";\n  ", "\n\n  ", "\n"])), PRIMARY_BLACK, function (_ref) {
  var type = _ref.type;
  return css(_templateObject3$l || (_templateObject3$l = _taggedTemplateLiteral(["\n      background-color: ", ";\n      ", " {\n        color: ", ";\n      }\n    "])), hexToRgb(fixedNotificationColor[type], type == 'info' ? 0.1 : 0.15), Icon, fixedNotificationColor[type]);
}, function (props) {
  if (props.size === 'small') {
    return css(_templateObject4$j || (_templateObject4$j = _taggedTemplateLiteral(["\n        padding: 8px;\n        font-size: 13px;\n        font-weight: 600;\n        line-height: 18px;\n      "])));
  }

  if (props.size === 'medium') {
    return css(_templateObject5$h || (_templateObject5$h = _taggedTemplateLiteral(["\n        padding: 18px 15px;\n      "])));
  }
});
var CalloutBackground = styled.div(_templateObject6$e || (_templateObject6$e = _taggedTemplateLiteral(["\n  background-color: white;\n"])));
var CalloutWrapper = styled.div(_templateObject7$c || (_templateObject7$c = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n\n  ", " {\n    flex: 0 0 18px;\n    position: relative;\n    ", ";\n  }\n"])), Icon, function (props) {
  if (props.size === 'small') {
    return css(_templateObject8$c || (_templateObject8$c = _taggedTemplateLiteral(["\n          margin-right: 6px;\n          top: 0;\n        "])));
  } else if (props.size === 'medium') {
    return css(_templateObject9$b || (_templateObject9$b = _taggedTemplateLiteral(["\n          margin-right: 15px;\n          top: 4px;\n        "])));
  }
});
var flashNotificationColor = {
  success: PRIMARY_GREEN,
  info: PRIMARY_BLACK,
  alert: SECONDARY_RED,
  notification: PRIMARY_BLUE
};
var FlashNotification = styled(BaseNotification)(_templateObject10$b || (_templateObject10$b = _taggedTemplateLiteral(["\n  z-index: ", ";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  padding: 18px 36px;\n  color: ", ";\n  ", "\n"])), TOAST, PRIMARY_WHITE, function (_ref2) {
  var type = _ref2.type;
  return css(_templateObject11$7 || (_templateObject11$7 = _taggedTemplateLiteral(["\n      background-color: ", ";\n    "])), flashNotificationColor[type]);
});
var FlashNotificationWrapper = styled.div(_templateObject12$5 || (_templateObject12$5 = _taggedTemplateLiteral(["\n  text-align: center;\n\n  ", " {\n    color: ", ";\n    position: absolute;\n    right: 18px;\n    top: 8px;\n  }\n\n  @media screen and ", " {\n    ", " {\n      position: absolute;\n      right: 18px;\n      color: ", ";\n      top: 50%;\n      transform: translateY(-50%);\n    }\n  }\n"])), Close, PRIMARY_WHITE, LAPTOP, Close, PRIMARY_WHITE); // TODO : Maybe we need to export this in other file

var CenterSlot = styled.div(_templateObject13$4 || (_templateObject13$4 = _taggedTemplateLiteral([""])));
var LeftSlot = styled.div(_templateObject14$4 || (_templateObject14$4 = _taggedTemplateLiteral([""])));
var RightSlot = styled.div(_templateObject15$4 || (_templateObject15$4 = _taggedTemplateLiteral([""])));
var FlashNotificationChildren = styled.span(_templateObject16$4 || (_templateObject16$4 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: ", ";\n  width: 100%;\n  flex-wrap: wrap;\n  align-items: center;\n  flex-direction: column;\n\n  @media screen and ", " {\n    flex-wrap: nowrap;\n    display: flex;\n    flex-direction: row;\n  }\n\n  ", " {\n    flex: 1;\n    flex-direction: row;\n\n    @media screen and ", " {\n      position: absolute;\n      left: 50%;\n      transform: translateX(-50%);\n    }\n  }\n"])), function (_ref3) {
  var isMultipleContent = _ref3.isMultipleContent;
  return isMultipleContent ? 'space-between' : 'center';
}, LAPTOP, CenterSlot, LAPTOP_L);

var _notification = /*#__PURE__*/Object.freeze({
  __proto__: null,
  BaseNotification: BaseNotification,
  Callout: Callout,
  CalloutBackground: CalloutBackground,
  CalloutWrapper: CalloutWrapper,
  FlashNotification: FlashNotification,
  FlashNotificationWrapper: FlashNotificationWrapper,
  CenterSlot: CenterSlot,
  LeftSlot: LeftSlot,
  RightSlot: RightSlot,
  FlashNotificationChildren: FlashNotificationChildren
});

var _templateObject$x, _templateObject2$r, _templateObject3$m, _templateObject4$k, _templateObject5$i, _templateObject6$f, _templateObject7$d, _templateObject8$d, _templateObject9$c, _templateObject10$c, _templateObject11$8, _templateObject12$6, _templateObject13$5, _templateObject14$5, _templateObject15$5, _templateObject16$5;
var Label$1 = styled.div(_templateObject$x || (_templateObject$x = _taggedTemplateLiteral(["\n  display: inline;\n  width: 100%;\n  font-family: ", ";\n  font-size: 13px;\n  line-height: 18px;\n  padding-right: 12px;\n  ", "\n"])), PRIMARY_FONT, function (_ref) {
  var status = _ref.status;

  if (status === 'disabled') {
    return css(_templateObject2$r || (_templateObject2$r = _taggedTemplateLiteral(["\n        color: ", ";\n      "])), GREY_SHADE_4);
  }

  if (status === 'selected') {
    return css(_templateObject3$m || (_templateObject3$m = _taggedTemplateLiteral(["\n        color: ", ";\n      "])), PRIMARY_BLUE);
  }

  return css(_templateObject4$k || (_templateObject4$k = _taggedTemplateLiteral(["\n      color: ", ";\n    "])), PRIMARY_BLACK);
});
var MonoSelectedIcon = styled(CheckCircle).attrs({
  size: 12
})(_templateObject5$i || (_templateObject5$i = _taggedTemplateLiteral(["\n  margin: 0 6px 0 0;\n  stroke: ", ";\n  stroke-width: 2px;\n  ", "\n"])), PRIMARY_WHITE, function (_ref2) {
  var status = _ref2.status;

  if (status === 'selected') {
    return css(_templateObject6$f || (_templateObject6$f = _taggedTemplateLiteral(["\n        color: ", ";\n      "])), PRIMARY_BLUE);
  }

  if (status === 'disabled') {
    return css(_templateObject7$d || (_templateObject7$d = _taggedTemplateLiteral(["\n        color: transparent;\n      "])));
  }

  if (status === 'default') {
    return css(_templateObject8$d || (_templateObject8$d = _taggedTemplateLiteral(["\n        color: transparent;\n      "])));
  }
});
var MultiSelectedIcon = styled(Check$1).attrs({
  size: 12
})(_templateObject9$c || (_templateObject9$c = _taggedTemplateLiteral(["\n  margin: 0 6px 0 0;\n  border-style: solid;\n  border-width: 2px;\n  stroke-width: 4px;\n  color: ", ";\n  ", "\n"])), PRIMARY_WHITE, function (_ref3) {
  var status = _ref3.status;

  if (status === 'selected') {
    return css(_templateObject10$c || (_templateObject10$c = _taggedTemplateLiteral(["\n        stroke: currentColor;\n        border-color: ", ";\n        background-color: ", ";\n      "])), PRIMARY_BLUE, PRIMARY_BLUE);
  }

  if (status === 'disabled') {
    return css(_templateObject11$8 || (_templateObject11$8 = _taggedTemplateLiteral(["\n        border-color: ", ";\n        stroke: transparent;\n      "])), GREY_SHADE_5);
  }

  if (status === 'default') {
    return css(_templateObject12$6 || (_templateObject12$6 = _taggedTemplateLiteral(["\n        border-color: ", ";\n        stroke: transparent;\n      "])), GREY_SHADE_4);
  }
});
var Wrapper$4 = styled.li(_templateObject13$5 || (_templateObject13$5 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  padding: 6px 16px 6px 10px;\n  user-select: none;\n  outline: none;\n  ", "\n  ", "\n\n  ", ", ", " {\n    flex: 0 0 12px;\n  }\n"])), function (_ref4) {
  var focused = _ref4.focused;

  if (focused) {
    return css(_templateObject14$5 || (_templateObject14$5 = _taggedTemplateLiteral(["\n        background-color: ", ";\n      "])), hexToRgb(PRIMARY_BLUE, 0.05));
  } else {
    return css(_templateObject15$5 || (_templateObject15$5 = _taggedTemplateLiteral(["\n        background-color: ", ";\n      "])), PRIMARY_WHITE);
  }
}, function (_ref5) {
  var filtered = _ref5.filtered;

  if (filtered) {
    return css(_templateObject16$5 || (_templateObject16$5 = _taggedTemplateLiteral(["\n        /* don't use display:none keep width of dropdown even if largest item is filtered.\n        Instead, reduce vertical dimension to 0 (height and padding) and hide overflow */\n        visibility: hidden;\n        height: 0;\n        overflow: hidden;\n        padding: 0 16px 0 10px;\n      "])));
  }
}, MonoSelectedIcon, MultiSelectedIcon);

var _option = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Label: Label$1,
  MonoSelectedIcon: MonoSelectedIcon,
  MultiSelectedIcon: MultiSelectedIcon,
  Wrapper: Wrapper$4
});

var _templateObject$y, _templateObject2$s;
var colorByScore = {
  worst: SECONDARY_RED,
  bad: SECONDARY_RED,
  weak: SECONDARY_PURPLE,
  good: SECONDARY_PURPLE,
  strong: PRIMARY_BLUE
};
var Indicator = styled(Message)(_templateObject$y || (_templateObject$y = _taggedTemplateLiteral(["\n  color: ", ";\n"])), GREY_SHADE_1);
var Strength = styled.span(_templateObject2$s || (_templateObject2$s = _taggedTemplateLiteral(["\n  color: ", ";\n"])), function (props) {
  return colorByScore[props.score];
});

var _password = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Indicator: Indicator,
  Strength: Strength
});

var _templateObject$z, _templateObject2$t, _templateObject3$n, _templateObject4$l, _templateObject5$j;
var Wrapper$5 = styled(ComposedWrapper)(_templateObject$z || (_templateObject$z = _taggedTemplateLiteral(["\n  position: relative;\n\n  &::after {\n    content: '';\n    display: block;\n    flex: 0 0 1px;\n    order: 1;\n    background-color: ", ";\n  }\n\n  &:focus-within::after {\n    background-color: ", ";\n  }\n\n  &&::after {\n    ", "\n  }\n"])), GREY_SHADE_5, PRIMARY_BLUE, function (_ref) {
  var disabled = _ref.disabled;

  if (disabled) {
    return css(_templateObject2$t || (_templateObject2$t = _taggedTemplateLiteral(["\n          background-color: ", ";\n        "])), GREY_SHADE_5);
  }
});
var Input$2 = styled(Input)(_templateObject3$n || (_templateObject3$n = _taggedTemplateLiteral(["\n  width: 100%;\n  order: 2;\n"])));
var CountryPrefix = styled.span(_templateObject4$l || (_templateObject4$l = _taggedTemplateLiteral(["\n  color: ", ";\n"])), GREY_SHADE_3);
var CountryName = styled.span(_templateObject5$j || (_templateObject5$j = _taggedTemplateLiteral([""])));

var _phone = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Wrapper: Wrapper$5,
  Input: Input$2,
  CountryPrefix: CountryPrefix,
  CountryName: CountryName
});

var _templateObject$A, _templateObject2$u, _templateObject3$o;
var DiscreetText = styled.span(_templateObject$A || (_templateObject$A = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 12px;\n  font-weight: ", ";\n"])), GREY_SHADE_2, function (_ref) {
  var _ref$light = _ref.light,
      light = _ref$light === void 0 ? false : _ref$light;
  return light ? 300 : 400;
});
var ProjectCardTitle = styled.h2(_templateObject2$u || (_templateObject2$u = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 23px;\n  margin: 0;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n"])), function (props) {
  return primary(props);
});
var HorizontalCardWrapper = styled.a(_templateObject3$o || (_templateObject3$o = _taggedTemplateLiteral(["\n  color: ", ";\n  cursor: pointer;\n  display: flex;\n  font-family: ", ";\n  line-height: 1.23;\n  min-width: 280px;\n  text-decoration: none;\n  width: 100%;\n\n  ", " {\n    margin-bottom: 5px;\n  }\n\n  &:hover ", " {\n    text-decoration: underline;\n  }\n"])), PRIMARY_BLACK, PRIMARY_FONT, ProjectCardTitle, ProjectCardTitle);

var _projectCard = /*#__PURE__*/Object.freeze({
  __proto__: null,
  DiscreetText: DiscreetText,
  ProjectCardTitle: ProjectCardTitle,
  HorizontalCardWrapper: HorizontalCardWrapper
});

var _templateObject$B, _templateObject2$v, _templateObject3$p, _templateObject4$m, _templateObject5$k, _templateObject6$g, _templateObject7$e, _templateObject8$e, _templateObject9$d, _templateObject10$d;
var Radiomark = styled.span(_templateObject$B || (_templateObject$B = _taggedTemplateLiteral(["\n  display: inline-block;\n  color: inherit;\n  fill: currentColor;\n  vertical-align: baseline;\n  border: 2px solid ", ";\n  position: relative;\n  border-radius: 50%;\n  background-color: ", ";\n  box-sizing: border-box;\n  ", "\n  ", "\n  ", "\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    top: 3px;\n    left: 3px;\n    border-radius: 50%;\n    background-color: ", ";\n    ", "\n    ", "\n    ", "\n  }\n"])), GREY_SHADE_4, PRIMARY_WHITE, function (_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 18 : _ref$size;
  return css(_templateObject2$v || (_templateObject2$v = _taggedTemplateLiteral(["\n    width: ", "px;\n    height: ", "px;\n  "])), size, size);
}, function (_ref2) {
  var status = _ref2.status;

  if (status === 'checked') {
    return css(_templateObject3$p || (_templateObject3$p = _taggedTemplateLiteral(["\n        border-color: ", ";\n      "])), PRIMARY_BLUE);
  }

  if (status === 'focused') {
    return css(_templateObject4$m || (_templateObject4$m = _taggedTemplateLiteral(["\n        border-color: ", ";\n      "])), GREY_SHADE_3);
  }
}, function (_ref3) {
  var disabled = _ref3.disabled;
  return disabled && css(_templateObject5$k || (_templateObject5$k = _taggedTemplateLiteral(["\n      border-color: ", ";\n      background-color: ", ";\n    "])), GREY_SHADE_4, GREY_SHADE_6);
}, PRIMARY_BLUE, function (_ref4) {
  var _ref4$size = _ref4.size,
      size = _ref4$size === void 0 ? 18 : _ref4$size;
  return css(_templateObject6$g || (_templateObject6$g = _taggedTemplateLiteral(["\n      width: ", "px;\n      height: ", "px;\n    "])), size - 10, size - 10);
}, function (_ref5) {
  var status = _ref5.status;

  if (status !== 'checked') {
    return css(_templateObject7$e || (_templateObject7$e = _taggedTemplateLiteral(["\n          display: none;\n        "])));
  }
}, function (_ref6) {
  var disabled = _ref6.disabled;
  return disabled && css(_templateObject8$e || (_templateObject8$e = _taggedTemplateLiteral(["\n        background-color: ", ";\n      "])), GREY_SHADE_4);
});
var SmallGroup = styled.div(_templateObject9$d || (_templateObject9$d = _taggedTemplateLiteral(["\n  display: inline-flex;\n  flex-direction: column;\n"])));
var BigGroup = styled.div(_templateObject10$d || (_templateObject10$d = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n"])));

var _radio = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Radiomark: Radiomark,
  SmallGroup: SmallGroup,
  BigGroup: BigGroup
});

var _templateObject$C, _templateObject2$w, _templateObject3$q, _templateObject4$n, _templateObject5$l, _templateObject6$h, _templateObject7$f, _templateObject8$f, _templateObject9$e, _templateObject10$e, _templateObject11$9, _templateObject12$7;
var Quantity = styled(XXXXXS)(_templateObject$C || (_templateObject$C = _taggedTemplateLiteral(["\n  color: ", ";\n  text-transform: uppercase;\n  text-align: right;\n"])), GREY_SHADE_3);
var SoldOut = styled(XXXXXS)(_templateObject2$w || (_templateObject2$w = _taggedTemplateLiteral(["\n  color: ", ";\n  margin: 4px 0 -4px;\n"])), GREY_SHADE_3);
var SoonSoldOut = styled(SoldOut)(_templateObject3$q || (_templateObject3$q = _taggedTemplateLiteral(["\n  color: ", ";\n"])), PRIMARY_BLUE);
var Description$2 = styled(S$1)(_templateObject4$n || (_templateObject4$n = _taggedTemplateLiteral(["\n  color: ", ";\n  font-weight: 300;\n\n  ul {\n    padding-left: 40px;\n  }\n\n  ul,\n  ol {\n    margin: 1em 0;\n    padding-left: 40px;\n\n    li {\n      line-height: 1.618;\n    }\n\n    ul,\n    ol {\n      margin: 0;\n    }\n  }\n\n  strong {\n    font-weight: bold;\n  }\n\n  & img {\n    max-width: 100%;\n  }\n"])), PRIMARY_BLACK);
var Title$3 = styled(XXXS)(_templateObject5$l || (_templateObject5$l = _taggedTemplateLiteral(["\n  color: ", ";\n"])), PRIMARY_BLACK);
var Picture = styled.img(_templateObject6$h || (_templateObject6$h = _taggedTemplateLiteral(["\n  max-width: 100%;\n\n  @media screen and ", " {\n    max-width: ", ";\n  }\n"])), TABLET, function (_ref) {
  var format = _ref.format;
  return format === 'wide' ? '70%' : '100%';
});
var Conversion = styled(Card3)(_templateObject7$f || (_templateObject7$f = _taggedTemplateLiteral(["\n  color: ", ";\n  margin-left: 12px;\n  font-weight: 500;\n\n  ", " {\n    margin-right: 4px;\n    color: ", ";\n    vertical-align: bottom;\n  }\n"])), GREY_SHADE_2, Currency, GREY_SHADE_4);
var OriginalPrice = styled(XS)(_templateObject8$f || (_templateObject8$f = _taggedTemplateLiteral([""])));
var Price = styled.div(_templateObject9$e || (_templateObject9$e = _taggedTemplateLiteral(["\n  display: inline-flex;\n  flex-direction: row;\n  align-items: center;\n  color: ", ";\n\n  ", " {\n    position: relative;\n    top: 1px;\n  }\n\n  ", " {\n    color: inherit;\n  }\n"])), PRIMARY_BLUE, Conversion, OriginalPrice);
var Action = styled(Card1)(_templateObject10$e || (_templateObject10$e = _taggedTemplateLiteral(["\n  ", " {\n    color: ", ";\n    position: relative;\n    top: -2px;\n    margin-right: 6px;\n  }\n"])), Icon, GREY_SHADE_4);
var ActiveLabel = styled.span(_templateObject11$9 || (_templateObject11$9 = _taggedTemplateLiteral(["\n  color: ", ";\n"])), PRIMARY_BLUE);
var InactiveLabel = styled.span(_templateObject12$7 || (_templateObject12$7 = _taggedTemplateLiteral(["\n  color: ", ";\n"])), GREY_SHADE_3);

var _reward = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Quantity: Quantity,
  SoldOut: SoldOut,
  SoonSoldOut: SoonSoldOut,
  Description: Description$2,
  Title: Title$3,
  Picture: Picture,
  Conversion: Conversion,
  OriginalPrice: OriginalPrice,
  Price: Price,
  Action: Action,
  ActiveLabel: ActiveLabel,
  InactiveLabel: InactiveLabel
});

var _templateObject$D, _templateObject2$x, _templateObject3$r, _templateObject4$o, _templateObject5$m, _templateObject6$i, _templateObject7$g, _templateObject8$g, _templateObject9$f, _templateObject10$f, _templateObject11$a, _templateObject12$8;
var Label$2 = styled.span(_templateObject$D || (_templateObject$D = _taggedTemplateLiteral(["\n  color: ", ";\n  font-family: ", ";\n  line-height: 20px;\n  font-size: 15px;\n  margin-right: 20px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  display: flex;\n  ", "\n"])), PRIMARY_BLACK, PRIMARY_FONT, function (_ref) {
  var disabled = _ref.disabled;

  if (disabled) {
    return css(_templateObject2$x || (_templateObject2$x = _taggedTemplateLiteral(["\n        color: ", ";\n      "])), GREY_SHADE_3);
  }
});
var Button$1 = styled.button(_templateObject3$r || (_templateObject3$r = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  border: 1px solid ", ";\n  padding: 14px 13px;\n  user-select: none;\n  background: ", ";\n  height: 50px;\n  box-sizing: border-box;\n  width: 100%;\n\n  &:focus {\n    outline: none;\n  }\n\n  &:hover {\n    border: 1px solid ", ";\n    color: ", ";\n  }\n\n  &:disabled {\n    border: 1px solid ", ";\n    background-color: ", ";\n  }\n\n  ", "\n"])), GREY_SHADE_5, PRIMARY_WHITE, PRIMARY_BLUE, PRIMARY_BLUE, GREY_SHADE_5, GREY_SHADE_6, function (_ref2) {
  var status = _ref2.status;

  if (status === 'focused') {
    return css(_templateObject4$o || (_templateObject4$o = _taggedTemplateLiteral(["\n        border: 1px solid ", ";\n        color: ", ";\n      "])), PRIMARY_BLUE, PRIMARY_BLUE);
  }

  if (status === 'error') {
    return css(_templateObject5$m || (_templateObject5$m = _taggedTemplateLiteral(["\n        border: 1px dashed ", ";\n      "])), PRIMARY_RED);
  }
});
var Drawer = styled.div(_templateObject6$i || (_templateObject6$i = _taggedTemplateLiteral(["\n  height: 0;\n  ", ";\n"])), function (_ref3) {
  var isOpen = _ref3.isOpen;

  if (!isOpen) {
    return css(_templateObject7$g || (_templateObject7$g = _taggedTemplateLiteral(["\n        visibility: hidden;\n      "])));
  }
});
var ScrollList = styled.ul(_templateObject8$g || (_templateObject8$g = _taggedTemplateLiteral(["\n  position: relative; /* make this the offsetParent of all children (used for scroll) */\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  background-color: ", ";\n  ", "\n"])), PRIMARY_WHITE, function (_ref4) {
  var height = _ref4.height;

  if (height !== undefined) {
    return css(_templateObject9$f || (_templateObject9$f = _taggedTemplateLiteral(["\n        max-height: ", "px;\n        overflow-y: auto;\n      "])), height);
  }
});
var CaretDown$2 = styled(CaretDown).attrs({
  size: 10
})(_templateObject10$f || (_templateObject10$f = _taggedTemplateLiteral(["\n  color: ", ";\n"])), GREY_SHADE_4);
var MultiSelectButton = styled(Button)(_templateObject11$a || (_templateObject11$a = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
var SearchBox = styled.div(_templateObject12$8 || (_templateObject12$8 = _taggedTemplateLiteral(["\n  padding: 10px;\n"])));

var _select = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Label: Label$2,
  Button: Button$1,
  Drawer: Drawer,
  ScrollList: ScrollList,
  CaretDown: CaretDown$2,
  MultiSelectButton: MultiSelectButton,
  SearchBox: SearchBox
});

var _templateObject$E, _templateObject2$y, _templateObject3$s, _templateObject4$p, _templateObject5$n;
var loading = keyframes(_templateObject$E || (_templateObject$E = _taggedTemplateLiteral(["\n  from {\n    opacity: 0.2;\n    transform: scale(0.8);\n  }\n\n  50% {\n    opacity: 1;\n    transform: scale(1);\n  }\n\n  to {\n    opacity: 0.2;\n    transform: scale(0.8);\n  }\n"])));
var Dot = styled.span(_templateObject2$y || (_templateObject2$y = _taggedTemplateLiteral(["\n  animation: ", " 1.2s infinite ease-in-out both;\n  animation-delay: ", "ms;\n  background-color: ", ";\n  border-radius: 50%;\n  display: inline-block;\n  overflow: hidden;\n  margin: 0;\n  padding: 0;\n  text-indent: -9999px;\n  ", "\n"])), loading, function (_ref) {
  var _ref$delay = _ref.delay,
      delay = _ref$delay === void 0 ? 0 : _ref$delay;
  return delay;
}, function (props) {
  return primary(props);
}, function (_ref2) {
  var _ref2$small = _ref2.small,
      small = _ref2$small === void 0 ? false : _ref2$small;

  if (small) {
    return css(_templateObject3$s || (_templateObject3$s = _taggedTemplateLiteral(["\n        width: 6px;\n        height: 6px;\n        margin: 0 3px;\n      "])));
  } else {
    return css(_templateObject4$p || (_templateObject4$p = _taggedTemplateLiteral(["\n        width: 10px;\n        height: 10px;\n        margin: 0 4px;\n      "])));
  }
});
var Spinner = styled.div(_templateObject5$n || (_templateObject5$n = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));

var _spinner = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Dot: Dot,
  Spinner: Spinner
});

var _templateObject$F, _templateObject2$z, _templateObject3$t, _templateObject4$q, _templateObject5$o, _templateObject6$j, _templateObject7$h, _templateObject8$h;
var List = styled.ul(_templateObject$F || (_templateObject$F = _taggedTemplateLiteral(["\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  justify-content: space-between;\n  overflow-x: auto;\n  overflow-y: hidden;\n\n  &::after {\n    content: '';\n    background-image: linear-gradient(to right, rgba(255, 255, 255, 0), #fff 50%);\n    display: block;\n    height: 100%;\n    position: absolute;\n    pointer-events: none;\n    right: 0;\n    top: 0;\n    z-index: 2;\n    width: ", "px;\n    ", "\n  }\n"])), function (_ref) {
  var shadowWidth = _ref.shadowWidth;
  return shadowWidth;
}, function (_ref2) {
  var scrollable = _ref2.scrollable;

  if (scrollable) {
    return css(_templateObject2$z || (_templateObject2$z = _taggedTemplateLiteral(["\n          display: block;\n        "])));
  } else {
    return css(_templateObject3$t || (_templateObject3$t = _taggedTemplateLiteral(["\n          display: none;\n        "])));
  }
});
var Item = styled.li(_templateObject4$q || (_templateObject4$q = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  padding: 0 15px;\n  position: relative;\n\n  &::after {\n    content: '';\n    background-color: ", ";\n    bottom: 0;\n    height: 4px;\n    left: 50%;\n    position: absolute;\n    transform: translateX(-50%);\n\n    ", "\n  }\n\n  @media screen and ", " {\n    ", "\n\n    ", "\n  }\n"])), PRIMARY_BLACK, function (_ref3) {
  var active = _ref3.active;

  if (active) {
    return css(_templateObject5$o || (_templateObject5$o = _taggedTemplateLiteral(["\n          width: 100%;\n          opacity: 1;\n        "])));
  } else {
    return css(_templateObject6$j || (_templateObject6$j = _taggedTemplateLiteral(["\n          width: 0;\n          opacity: 0;\n          transition: all 0.2s ease;\n        "])));
  }
}, TABLET, function (_ref4) {
  var active = _ref4.active;

  if (!active) {
    return css(_templateObject7$h || (_templateObject7$h = _taggedTemplateLiteral(["\n          &:hover {\n            &::after {\n              width: 100%;\n              opacity: 1;\n            }\n          }\n        "])));
  }
}, function (_ref5) {
  var disabled = _ref5.disabled;

  if (disabled) {
    return css(_templateObject8$h || (_templateObject8$h = _taggedTemplateLiteral(["\n          &:hover {\n            &::after {\n              width: 100%;\n              opacity: 0.4;\n            }\n          }\n        "])));
  }
});

var _tab = /*#__PURE__*/Object.freeze({
  __proto__: null,
  List: List,
  Item: Item
});

var _templateObject$G, _templateObject2$A, _templateObject3$u, _templateObject4$r, _templateObject5$p, _templateObject6$k, _templateObject7$i, _templateObject8$i, _templateObject9$g, _templateObject10$g, _templateObject11$b, _templateObject12$9, _templateObject13$6;
var Tag$1 = styled.div(_templateObject$G || (_templateObject$G = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-radius: 2px;\n  color: ", ";\n  display: inline-block;\n  font-family: ", ";\n  font-size: 10px;\n  font-weight: bold;\n  height: 20px;\n  line-height: 20px;\n  padding: 0em 0.6em;\n  text-transform: uppercase;\n  width: max-content;\n\n  /* Color */\n  ", "\n\n  /* Size */\n  ", "\n\n  /* Tag with icon */\n  span[role=img] {\n    margin-right: 6px\n  }\n"])), GREY_SHADE_5, GREY_SHADE_1, PRIMARY_FONT, function (props) {
  if (props.color === 'blue') {
    return css(_templateObject2$A || (_templateObject2$A = _taggedTemplateLiteral(["\n        color: ", ";\n        background-color: ", ";\n      "])), PRIMARY_WHITE, PRIMARY_BLUE);
  }

  if (props.color === 'dark-blue') {
    return css(_templateObject3$u || (_templateObject3$u = _taggedTemplateLiteral(["\n        color: ", ";\n        background-color: ", ";\n      "])), PRIMARY_WHITE, BLUE_SHADE_2);
  }

  if (props.color === 'dark-green') {
    return css(_templateObject4$r || (_templateObject4$r = _taggedTemplateLiteral(["\n        color: ", ";\n        background-color: ", ";\n      "])), PRIMARY_WHITE, BRAND_ACCENT_GREEN);
  }

  if (props.color === 'green') {
    return css(_templateObject5$p || (_templateObject5$p = _taggedTemplateLiteral(["\n        color: ", ";\n        background-color: ", ";\n      "])), PRIMARY_WHITE, PRIMARY_GREEN);
  }

  if (props.color === 'grey') {
    return css(_templateObject6$k || (_templateObject6$k = _taggedTemplateLiteral(["\n        color: ", ";\n        background-color: ", ";\n      "])), GREY_SHADE_1, GREY_SHADE_5);
  }

  if (props.color === 'indigo') {
    return css(_templateObject7$i || (_templateObject7$i = _taggedTemplateLiteral(["\n        color: ", ";\n        background-color: ", ";\n      "])), PRIMARY_WHITE, SECONDARY_INDIGO);
  }

  if (props.color === 'light-blue') {
    return css(_templateObject8$i || (_templateObject8$i = _taggedTemplateLiteral(["\n        color: ", ";\n        background-color: ", ";\n      "])), BLUE_SHADE_2, BLUE_SHADE_1);
  }

  if (props.color === 'red') {
    return css(_templateObject9$g || (_templateObject9$g = _taggedTemplateLiteral(["\n        color: ", ";\n        background-color: ", ";\n      "])), PRIMARY_WHITE, RED_SHADE_2);
  }

  if (props.color === 'yellow') {
    return css(_templateObject10$g || (_templateObject10$g = _taggedTemplateLiteral(["\n        color: ", ";\n        background-color: ", ";\n      "])), PRIMARY_WHITE, SECONDARY_YELLOW);
  }
}, function (props) {
  if (props.size === 'small') {
    return css(_templateObject11$b || (_templateObject11$b = _taggedTemplateLiteral(["\n        font-size: 8px;\n        font-weight: 600;\n      "])));
  }

  if (props.size === 'big') {
    return css(_templateObject12$9 || (_templateObject12$9 = _taggedTemplateLiteral(["\n        font-size: 15px;\n      "])));
  }
});
Tag$1.displayName = 'S.tag.Tag';
var RoundTag = styled.button(_templateObject13$6 || (_templateObject13$6 = _taggedTemplateLiteral(["\n  border: 1px solid ", ";\n  background-color: ", ";\n  border-radius: 16px;\n  display: inline-flex;\n  padding: 4px 16px 4px 12px;\n\n  &::-moz-focus-inner {\n    border: 0;\n  }\n\n  &:focus,\n  &:active {\n    outline: none;\n  }\n\n  ", " {\n    color: ", ";\n    margin-right: 7px;\n    margin-top: 3px;\n  }\n"])), GREY_SHADE_5, PRIMARY_WHITE, Icon, GREY_SHADE_7);
RoundTag.displayName = 'S.tag.RoundTag';

var _tag = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Tag: Tag$1,
  RoundTag: RoundTag
});

var _templateObject$H, _templateObject2$B, _templateObject3$v, _templateObject4$s;
var TextArea = styled.textarea(_templateObject$H || (_templateObject$H = _taggedTemplateLiteral(["\n  border-radius: 2px;\n  padding: 15px;\n  font-family: ", ";\n  font-size: 15px;\n  font-weight: 400;\n  outline-color: ", ";\n  background-color: ", ";\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  box-sizing: border-box;\n\n  &:focus {\n    ", ";\n    outline: none;\n  }\n\n  &::placeholder {\n    font-family: ", ";\n    color: ", ";\n    font-size: 15px;\n    font-weight: 400;\n  }\n\n  ", "\n\n  &:disabled {\n    ", "\n    color: ", ";\n    background-color: ", ";\n  }\n"])), PRIMARY_FONT, PRIMARY_BLUE, PRIMARY_WHITE, focusedBorder, PRIMARY_FONT, GREY_SHADE_3, function (_ref) {
  var status = _ref.status;

  if (status === 'error') {
    return errorBorder;
  }

  if (status === 'success') {
    return successBorder;
  }

  return defaultBorder;
}, defaultBorder, GREY_SHADE_3, GREY_SHADE_6);
var Count$1 = styled.span(_templateObject2$B || (_templateObject2$B = _taggedTemplateLiteral(["\n  font-size: 10px;\n  font-family: ", ";\n  font-weight: 500;\n  ", "\n"])), PRIMARY_FONT, function (_ref2) {
  var isError = _ref2.isError;

  if (isError) {
    return css(_templateObject3$v || (_templateObject3$v = _taggedTemplateLiteral(["\n        color: ", ";\n      "])), SECONDARY_RED);
  } else {
    return css(_templateObject4$s || (_templateObject4$s = _taggedTemplateLiteral(["\n        color: ", ";\n      "])), GREY_SHADE_1);
  }
});

var _textarea = /*#__PURE__*/Object.freeze({
  __proto__: null,
  TextArea: TextArea,
  Count: Count$1
});

var _templateObject$I, _templateObject2$C, _templateObject3$w, _templateObject4$t, _templateObject5$q, _templateObject6$l, _templateObject7$j, _templateObject8$j, _templateObject9$h, _templateObject10$h, _templateObject11$c, _templateObject12$a, _templateObject13$7;
var BlockAnchor = styled.div(_templateObject$I || (_templateObject$I = _taggedTemplateLiteral(["\n  position: relative;\n"])));
var InlineAnchor = styled.span(_templateObject2$C || (_templateObject2$C = _taggedTemplateLiteral(["\n  position: relative;\n"])));
var Tooltip = styled.div(_templateObject3$w || (_templateObject3$w = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  width: 226px;\n  border: 1px solid ", ";\n  align-items: center;\n  background-color: ", ";\n  bottom: 30px;\n  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.12);\n  box-sizing: border-box;\n  left: 50%;\n  right: auto;\n  top: auto;\n  padding: 9px;\n  position: absolute;\n  transform: translateX(-50%);\n  height: min-content;\n  z-index: ", ";\n\n  ", "\n  ", "\n  ", "\n\n  span,\n  p {\n    font-size: 13px;\n    line-height: 22px;\n  }\n\n  &::after {\n    content: '';\n    display: inline-block;\n    height: 12px;\n    width: 12px;\n    box-shadow: 3px 3px 3px 0 rgba(0, 0, 0, 0.12);\n    transform: rotate(45deg) translateY(50%);\n    position: absolute;\n    bottom: -1px;\n    top: auto;\n    background-color: white;\n    left: 50%;\n\n    ", "\n  }\n"])), GREY_SHADE_5, PRIMARY_WHITE, ABOVE, function (_ref) {
  var position = _ref.position;

  if (position === 'right') {
    return css(_templateObject4$t || (_templateObject4$t = _taggedTemplateLiteral(["\n        left: 100%;\n        right: 0px;\n        top: 50%;\n        transform: translate(0%, -50%);\n      "])));
  } else if (position === 'left') {
    return css(_templateObject5$q || (_templateObject5$q = _taggedTemplateLiteral(["\n        left: auto;\n        right: 100%;\n        top: 50%;\n        transform: translate(0%, -50%);\n      "])));
  } else if (position === 'bottom') {
    return css(_templateObject6$l || (_templateObject6$l = _taggedTemplateLiteral(["\n        bottom: 0px;\n      "])));
  }
}, function (_ref2) {
  var _ref2$fitToContent = _ref2.fitToContent,
      fitToContent = _ref2$fitToContent === void 0 ? false : _ref2$fitToContent;

  if (fitToContent) {
    return css(_templateObject7$j || (_templateObject7$j = _taggedTemplateLiteral(["\n        width: max-content;\n      "])));
  }

  return css(_templateObject8$j || (_templateObject8$j = _taggedTemplateLiteral(["\n      width: 226px;\n    "])));
}, function (_ref3) {
  var open = _ref3.open;

  if (open) {
    return css(_templateObject9$h || (_templateObject9$h = _taggedTemplateLiteral(["\n        display: inline-flex;\n      "])));
  } else {
    return css(_templateObject10$h || (_templateObject10$h = _taggedTemplateLiteral(["\n        display: none;\n      "])));
  }
}, function (_ref4) {
  var position = _ref4.position;

  if (position === 'right') {
    return css(_templateObject11$c || (_templateObject11$c = _taggedTemplateLiteral(["\n          bottom: auto;\n          top: 50%;\n          left: -9px;\n          box-shadow: -1px 3px 2px 0 rgba(0, 0, 0, 0.12);\n          transform: rotate(45deg) translateY(-50%);\n        "])));
  } else if (position === 'left') {
    return css(_templateObject12$a || (_templateObject12$a = _taggedTemplateLiteral(["\n          bottom: auto;\n          top: 50%;\n          right: -2px;\n          left: auto;\n          box-shadow: 2px -2px 3px rgba(0, 0, 0, 0.12);\n          transform: rotate(45deg) translateY(-50%);\n        "])));
  } else if (position === 'bottom') {
    return css(_templateObject13$7 || (_templateObject13$7 = _taggedTemplateLiteral(["\n          bottom: auto;\n          top: -10px;\n          box-shadow: -1px -1px 2px 0 rgba(0, 0, 0, 0.12);\n        "])));
  }
});
Tooltip.displayName = 'S.tooltip.Tooltip';

var _tooltip = /*#__PURE__*/Object.freeze({
  __proto__: null,
  BlockAnchor: BlockAnchor,
  InlineAnchor: InlineAnchor,
  Tooltip: Tooltip
});

var _templateObject$J, _templateObject2$D;
var CardWrapper = styled.a(_templateObject$J || (_templateObject$J = _taggedTemplateLiteral(["\n  align-items: center;\n  border: 1px solid ", ";\n  box-sizing: border-box;\n  color: ", ";\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  overflow: hidden;\n  padding: 10px;\n  position: relative;\n  text-decoration: none;\n  max-width: 180px;\n\n  &:hover {\n    transition: all 200ms ease-in-out;\n    box-shadow: 2px 2px 14px ", ";\n  }\n\n  ", " {\n    height: auto;\n    max-width: 160px;\n    min-width: 100px;\n    width: 160px;\n  }\n"])), GREY_SHADE_5, PRIMARY_BLACK, GREY_SHADE_5, Avatar);
CardWrapper.displayName = 'S.userCard.CardWrapper';
var CardName = styled(Card1)(_templateObject2$D || (_templateObject2$D = _taggedTemplateLiteral(["\n  display: block;\n  margin-top: 10px;\n  overflow: hidden;\n  text-align: center;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"])));
CardName.displayName = 'S.userCard.CardName';

var _userCard = /*#__PURE__*/Object.freeze({
  __proto__: null,
  CardWrapper: CardWrapper,
  CardName: CardName
});

var _templateObject$K;
var UserLabel = styled(Base$3)(_templateObject$K || (_templateObject$K = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n\n  ", " {\n    margin-right: 7px;\n  }\n"])), Avatar);
UserLabel.displayName = 'S.userLabel.UserLabel';

var _userLabel = /*#__PURE__*/Object.freeze({
  __proto__: null,
  UserLabel: UserLabel
});

var autocomplete = _autocomplete;
var button = _button;
var channelCard = _channelCard;
var card = {
  channel: _miniChannelCard,
  project: _projectCard
};
var checkbox = _checkbox;
var container = _container;
var controls = _controls;
var copy = _copy;
var dropdown = _dropdown;
var field = _field;
var heading = _heading;
var image = _image;
var input = _input;
var jewel = _jewel;
var link = _link;
var modal = _modal;
var notification = _notification;
var option = _option;
var password = _password;
var phone = _phone;
var radio = _radio;
var reward = _reward;
var select = _select;
var spinner = _spinner;
var tab = _tab;
var tag = _tag;
var textarea = _textarea;
var tooltip = _tooltip;
var userCard = _userCard;
var userLabel = _userLabel;

var index$5 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  autocomplete: autocomplete,
  button: button,
  channelCard: channelCard,
  card: card,
  checkbox: checkbox,
  container: container,
  controls: controls,
  copy: copy,
  dropdown: dropdown,
  field: field,
  heading: heading,
  image: image,
  input: input,
  jewel: jewel,
  link: link,
  modal: modal,
  notification: notification,
  option: option,
  password: password,
  phone: phone,
  radio: radio,
  reward: reward,
  select: select,
  spinner: spinner,
  tab: tab,
  tag: tag,
  textarea: textarea,
  tooltip: tooltip,
  userCard: userCard,
  userLabel: userLabel
});

var _templateObject$L;
var CURRENCY_CONFIG = {
  USD: {
    symbol: '$'
  },
  CAD: {
    symbol: '$CA'
  },
  AUD: {
    symbol: '$AU'
  },
  NZD: {
    symbol: 'NZD'
  },
  GBP: {
    symbol: '£'
  },
  DKK: {
    symbol: 'kr'
  },
  SEK: {
    symbol: 'kr'
  },
  NOK: {
    symbol: 'kr'
  },
  EUR: {
    symbol: '€'
  },
  CHF: {
    symbol: 'CHF'
  }
};
var NUMBER_FORMAT_CONFIG = {
  en: {
    format: '%s%v',
    thousand: ',',
    decimal: '.'
  },
  fr: {
    format: '%v %s',
    thousand: ' ',
    decimal: ','
  },
  it: {
    format: '%s%v',
    decimal: ',',
    thousand: '.'
  },
  nl: {
    format: '%s %v',
    decimal: ',',
    thousand: '.'
  },
  de: {
    format: '%v %s',
    decimal: ',',
    thousand: '.'
  },
  es: {
    format: '%v %s',
    decimal: ',',
    thousand: '.'
  },
  ca: {
    format: '%v %s',
    decimal: ',',
    thousand: '.'
  },
  pt: {
    format: '%s%v',
    decimal: ',',
    thousand: '.'
  }
};
var LocaleMoneyFormatProvider = /*#__PURE__*/function (_React$Component) {
  _inherits(LocaleMoneyFormatProvider, _React$Component);

  var _super = _createSuper(LocaleMoneyFormatProvider);

  function LocaleMoneyFormatProvider() {
    _classCallCheck(this, LocaleMoneyFormatProvider);

    return _super.apply(this, arguments);
  }

  _createClass(LocaleMoneyFormatProvider, [{
    key: "render",
    value: function render() {
      var currencyConfig = CURRENCY_CONFIG[this.props.currency] || {};
      var numberFormatConfig = NUMBER_FORMAT_CONFIG[this.props.lang] || {};
      return this.props.children(_objectSpread2(_objectSpread2({}, currencyConfig), numberFormatConfig));
    }
  }]);

  return LocaleMoneyFormatProvider;
}(Component);
LocaleMoneyFormatProvider.defaultProps = {
  currency: 'USD',
  lang: 'en'
};
LocaleMoneyFormatProvider.propTypes = {
  currency: string,
  lang: string,
  children: func.isRequired
};
var FormatedMoney = function FormatedMoney(_ref) {
  var amount = _ref.amount,
      symbol = _ref.symbol,
      precision = _ref.precision,
      thousand = _ref.thousand,
      decimal = _ref.decimal,
      format = _ref.format;
  return /*#__PURE__*/createElement(Fragment, null, accounting.formatMoney(amount, symbol, precision, thousand, decimal, format));
};
FormatedMoney.defaultProps = {
  amount: 0,
  precision: 0
};
FormatedMoney.propTypes = {
  amount: number,
  symbol: string.isRequired,
  precision: number,
  thousand: string.isRequired,
  decimal: string.isRequired,
  format: string.isRequired
};
var MoneyExchangeProvider = /*#__PURE__*/function (_React$Component2) {
  _inherits(MoneyExchangeProvider, _React$Component2);

  var _super2 = _createSuper(MoneyExchangeProvider);

  function MoneyExchangeProvider() {
    _classCallCheck(this, MoneyExchangeProvider);

    return _super2.apply(this, arguments);
  }

  _createClass(MoneyExchangeProvider, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          rates = _this$props.rates,
          amount = _this$props.amount,
          from = _this$props.from,
          to = _this$props.to,
          children = _this$props.children;
      if (from === to) return children(amount);
      var inBaseCurrency = amount / rates[from];
      var convertedAmount = inBaseCurrency * rates[to];
      return children(convertedAmount);
    }
  }]);

  return MoneyExchangeProvider;
}(Component);
MoneyExchangeProvider.defaultProps = {
  amount: 0
};
MoneyExchangeProvider.propTypes = {
  amount: number,
  from: string.isRequired,
  to: string.isRequired,
  rates: object,
  children: func.isRequired
}; // NOTE: number must be a non-breaking word

var Wrapper$6 = styled.span(_templateObject$L || (_templateObject$L = _taggedTemplateLiteral(["\n  display: inline-block;\n  text-decoration: inherit;\n  color: inherit;\n"])));
/** Money, money ! */

var LocaleMoneyDisplayer = /*#__PURE__*/function (_React$Component3) {
  _inherits(LocaleMoneyDisplayer, _React$Component3);

  var _super3 = _createSuper(LocaleMoneyDisplayer);

  function LocaleMoneyDisplayer() {
    _classCallCheck(this, LocaleMoneyDisplayer);

    return _super3.apply(this, arguments);
  }

  _createClass(LocaleMoneyDisplayer, [{
    key: "render",
    value: function render() {
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      if (targetCurrency && (!rates || rates.length === 0)) {
        throw new Error('If targetCurrency props is passed, you have to pass rates props also.');
      }

      var _this$props2 = this.props,
          rates = _this$props2.rates,
          amount = _this$props2.amount,
          currency = _this$props2.currency,
          targetCurrency = _this$props2.targetCurrency,
          localeFormat = _this$props2.localeFormat,
          precision = _this$props2.precision;
      return /*#__PURE__*/createElement(MoneyExchangeProvider, {
        rates: rates,
        amount: amount,
        from: currency,
        to: targetCurrency || currency
      }, function (value) {
        return /*#__PURE__*/createElement(LocaleMoneyFormatProvider, {
          lang: localeFormat,
          currency: targetCurrency || currency
        }, function (options) {
          return /*#__PURE__*/createElement(Wrapper$6, null, /*#__PURE__*/createElement(FormatedMoney, _extends({
            amount: value,
            precision: precision
          }, options)));
        });
      });
    }
  }]);

  return LocaleMoneyDisplayer;
}(Component);
LocaleMoneyDisplayer.defaultProps = {
  amount: 0,
  localeFormat: 'en'
};
LocaleMoneyDisplayer.propTypes = {
  precision: number,
  amount: number,
  currency: string.isRequired,
  targetCurrency: string,
  localeFormat: string.isRequired,
  rates: object
};
LocaleMoneyDisplayer.displayName = 'legacy.LocaleMoneyDisplayer';

var _templateObject$M;
var LinkComponent = /*#__PURE__*/forwardRef(function LinkComponent(_ref, ref) {
  var children = _ref.children,
      _ref$kind = _ref.kind,
      kind = _ref$kind === void 0 ? 'primary' : _ref$kind,
      props = _objectWithoutProperties(_ref, ["children", "kind"]);

  switch (kind) {
    case 'secondary':
      return /*#__PURE__*/createElement(Secondary, _extends({
        ref: ref
      }, props), children);

    case 'inverted':
      return /*#__PURE__*/createElement(Inverted, _extends({
        ref: ref
      }, props), children);
  }

  return /*#__PURE__*/createElement(Primary, _extends({
    ref: ref
  }, props), children);
});
var Link$1 = styled(LinkComponent)(_templateObject$M || (_templateObject$M = _taggedTemplateLiteral([""])));
Link$1.displayName = 'Link';

var _templateObject$N, _templateObject2$E;

function LinkButtonComponent(_ref) {
  var children = _ref.children,
      className = _ref.className,
      buttonProps = _objectWithoutProperties(_ref, ["children", "className"]);

  return /*#__PURE__*/createElement(Link$1, _extends({
    forwardedAs: "button",
    className: className
  }, buttonProps), children);
}

var LinkButton = styled(LinkButtonComponent)(_templateObject$N || (_templateObject$N = _taggedTemplateLiteral(["\n  padding: 13px;\n  cursor: pointer;\n  background: transparent;\n  border: none;\n\n  &:hover {\n    ", "\n  }\n"])), function (_ref2) {
  var _ref2$kind = _ref2.kind,
      kind = _ref2$kind === void 0 ? 'primary' : _ref2$kind;
  return kind === 'secondary' && css(_templateObject2$E || (_templateObject2$E = _taggedTemplateLiteral(["\n        text-decoration: underline;\n      "])));
});
LinkButton.displayName = 'LinkButton';

var _templateObject$O;

function SpinnerComponent(_ref) {
  var _ref$small = _ref.small,
      small = _ref$small === void 0 ? false : _ref$small,
      divProps = _objectWithoutProperties(_ref, ["small"]);

  return /*#__PURE__*/createElement(Spinner, divProps, /*#__PURE__*/createElement(Dot, {
    small: small,
    delay: 0
  }), /*#__PURE__*/createElement(Dot, {
    small: small,
    delay: 160
  }), /*#__PURE__*/createElement(Dot, {
    small: small,
    delay: 320
  }));
}

var Spinner$1 = styled(SpinnerComponent)(_templateObject$O || (_templateObject$O = _taggedTemplateLiteral([""])));
Spinner$1.displayName = 'Spinner';

var _templateObject$P, _templateObject2$F, _templateObject3$x, _templateObject4$u, _templateObject5$r;

function ButtonComponent(_ref) {
  var _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading,
      children = _ref.children,
      disabled = _ref.disabled,
      props = _objectWithoutProperties(_ref, ["loading", "children", "disabled"]);

  var _useTransition = useTransition(loading),
      step = _useTransition.step,
      unmounted = _useTransition.unmounted,
      onTransitionEnd = _useTransition.onTransitionEnd;

  return /*#__PURE__*/createElement(ButtonWrapper, _extends({}, props, {
    loading: loading,
    disabled: loading || disabled,
    step: step,
    unmounted: unmounted
  }), /*#__PURE__*/createElement(Label$3, null, children), " ", /*#__PURE__*/createElement(Spinner$1, {
    onTransitionEnd: onTransitionEnd
  }));
}

var Label$3 = styled.span(_templateObject$P || (_templateObject$P = _taggedTemplateLiteral([""])));
var ButtonWrapper = styled(Button)(_templateObject2$F || (_templateObject2$F = _taggedTemplateLiteral(["\n  position: relative;\n\n  ", " {\n    position: absolute;\n    transition: opacity 0.3s ease;\n    opacity: ", ";\n  }\n\n  ", " {\n    transition: opacity 0.3s ease;\n    opacity: ", ";\n  }\n\n  ", " {\n    ", "\n  }\n"])), Spinner, function (_ref2) {
  var step = _ref2.step,
      unmounted = _ref2.unmounted;
  return step === 'during' && !unmounted ? 1 : 0;
}, Label$3, function (_ref3) {
  var step = _ref3.step,
      unmounted = _ref3.unmounted;
  return step !== 'during' || unmounted ? 1 : 0;
}, Dot, function (_ref4) {
  var _ref4$kind = _ref4.kind,
      kind = _ref4$kind === void 0 ? 'primary' : _ref4$kind,
      _ref4$color = _ref4.color,
      color = _ref4$color === void 0 ? 'blue' : _ref4$color;

  if (kind === 'primary') {
    return css(_templateObject3$x || (_templateObject3$x = _taggedTemplateLiteral(["\n          background-color: ", ";\n        }\n      "])), PRIMARY_WHITE);
  }

  return css(_templateObject4$u || (_templateObject4$u = _taggedTemplateLiteral(["\n        background-color: ", ";\n      "])), buttonColors[color].base);
});
var Button$2 = styled(ButtonComponent)(_templateObject5$r || (_templateObject5$r = _taggedTemplateLiteral([""])));
Button$2.defaultProps = {
  loading: false
};
Button$2.displayName = 'Button';

var _templateObject$Q;
var calloutGlyphs = {
  alert: Alert,
  error: TimesCircle,
  info: Info,
  success: Success
};

function CalloutComponent(_ref) {
  var className = _ref.className,
      children = _ref.children,
      type = _ref.type,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size;
  var Glyph = calloutGlyphs[type];
  return /*#__PURE__*/createElement(CalloutBackground, {
    className: className
  }, /*#__PURE__*/createElement(Callout, {
    type: type,
    size: size
  }, /*#__PURE__*/createElement(CalloutWrapper, {
    size: size
  }, /*#__PURE__*/createElement(Glyph, {
    size: 18
  }), /*#__PURE__*/createElement("span", null, children))));
}

var Callout$1 = styled(CalloutComponent)(_templateObject$Q || (_templateObject$Q = _taggedTemplateLiteral([""])));
Callout$1.displayName = 'Callout';

var _templateObject$R;

function EggProgressComponent(_ref) {
  var progress = _ref.progress,
      iconProps = _objectWithoutProperties(_ref, ["progress"]);

  if (progress < 100) {
    return /*#__PURE__*/createElement(EggPartial, _extends({}, iconProps, {
      progress: progress
    }));
  }

  return /*#__PURE__*/createElement(EggFull, iconProps);
}

var EggProgress = styled(EggProgressComponent)(_templateObject$R || (_templateObject$R = _taggedTemplateLiteral([""])));
EggProgress.displayName = 'EggProgress';

var _templateObject$S;
function GoalLabel(_ref) {
  var currency = _ref.currency,
      goal = _ref.goal,
      language = _ref.language,
      productsSoldCount = _ref.productsSoldCount,
      progress = _ref.progress,
      raisedAmount = _ref.raisedAmount,
      rates = _ref.rates,
      targetCurrency = _ref.targetCurrency,
      type = _ref.type;
  var label = type === 'presale' ? "".concat(productsSoldCount, " / ").concat(goal) : /*#__PURE__*/createElement(LocaleMoneyDisplayer, {
    amount: raisedAmount,
    currency: currency,
    localeFormat: language,
    rates: rates,
    targetCurrency: targetCurrency
  });
  return /*#__PURE__*/createElement(Wrapper$7, null, /*#__PURE__*/createElement(EggProgress, {
    progress: progress,
    size: 16
  }), label);
}
var Wrapper$7 = styled.div(_templateObject$S || (_templateObject$S = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  white-space: normal;\n  overflow: visible;\n\n  ", " {\n    margin-right: 3px;\n  }\n"])), EggProgress);

var _templateObject$T, _templateObject2$G, _templateObject3$y, _templateObject4$v;

/** HorizontalProjectCard is a presentational component for projects. With the shape of a card. It's laid horizontally, too. */
function HorizontalProjectCardComponent(_ref) {
  var project = _ref.project,
      rates = _ref.rates,
      targetCurrency = _ref.targetCurrency,
      translation = _ref.translation;
  return /*#__PURE__*/createElement(card.project.HorizontalCardWrapper, {
    href: project.absoluteUrl
  }, /*#__PURE__*/createElement(Picture$1, {
    url: project.picture
  }), /*#__PURE__*/createElement(ContentWrapper, null, /*#__PURE__*/createElement(card.project.ProjectCardTitle, null, project.name), project.subtitle && /*#__PURE__*/createElement(Subtitle, null, project.subtitle), /*#__PURE__*/createElement(card.project.DiscreetText, {
    light: true
  }, project.isOnline ? /*#__PURE__*/createElement(GoalLabel, {
    currency: project.currency,
    goal: project.goal,
    language: project.language,
    productsSoldCount: project.productsSoldCount,
    progress: project.progress,
    rates: rates,
    raisedAmount: project.raisedAmount,
    targetCurrency: targetCurrency,
    type: project.type
  }) : translation['comingSoon'])));
}

var HorizontalProjectCard = styled(HorizontalProjectCardComponent)(_templateObject$T || (_templateObject$T = _taggedTemplateLiteral([""])));
HorizontalProjectCard.displayName = 'HorizontalProjectCard';
// FIXME: These styles should be moved to be re-used for classic project card?
var ContentWrapper = styled.div(_templateObject2$G || (_templateObject2$G = _taggedTemplateLiteral(["\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"])));
var Picture$1 = styled.div(_templateObject3$y || (_templateObject3$y = _taggedTemplateLiteral(["\n  background-color: ", ";\n  background-image: ", ";\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  height: 35px;\n  margin: 6px 10px 0 0;\n  max-width: 60px;\n  width: 100%;\n"])), GREY_SHADE_6, function (_ref2) {
  var url = _ref2.url;
  return url ? "url(".concat(url, ")") : undefined;
});
var Subtitle = styled.span(_templateObject4$v || (_templateObject4$v = _taggedTemplateLiteral(["\n  display: block;\n  font-size: 13px;\n  font-weight: 500;\n  margin-bottom: 12px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"])));

var _templateObject$U;

function ChannelCardComponent(_ref) {
  var avatar = _ref.avatar,
      button = _ref.button,
      description = _ref.description,
      href = _ref.href,
      src = _ref.src,
      title = _ref.title;
  return /*#__PURE__*/createElement(channelCard.Wrapper, {
    href: href
  }, /*#__PURE__*/createElement(channelCard.Img, {
    src: src,
    alt: ""
  }), /*#__PURE__*/createElement(channelCard.Container, null, /*#__PURE__*/createElement(channelCard.Info, null, /*#__PURE__*/createElement(channelCard.Title, {
    as: "span"
  }, title), /*#__PURE__*/createElement(channelCard.Description, {
    as: "p"
  }, description)), /*#__PURE__*/createElement(channelCard.Avatar, {
    src: avatar
  })), button && /*#__PURE__*/createElement(channelCard.SubButton, {
    // prevents route transition from S.channelCard.Wrapper (<a>)
    onClick: function onClick(e) {
      e.preventDefault();
    }
  }, button));
}

var ChannelCard = styled(ChannelCardComponent)(_templateObject$U || (_templateObject$U = _taggedTemplateLiteral([""])));
ChannelCard.displayName = 'ChannelCard';
ChannelCard.defaultProps = {};

var _templateObject$V;

function FlashComponent(_ref) {
  var className = _ref.className,
      _ref$closable = _ref.closable,
      closable = _ref$closable === void 0 ? true : _ref$closable,
      children = _ref.children,
      type = _ref.type,
      onClose = _ref.onClose;
  var isMultipleContent = Array.isArray(children);
  return /*#__PURE__*/createElement(FlashNotification, {
    type: type,
    className: className
  }, /*#__PURE__*/createElement(FlashNotificationWrapper, null, /*#__PURE__*/createElement(FlashNotificationChildren, {
    isMultipleContent: isMultipleContent
  }, children), closable && /*#__PURE__*/createElement(Close, {
    size: 10,
    onClick: onClose
  })));
}

var Flash = styled(FlashComponent)(_templateObject$V || (_templateObject$V = _taggedTemplateLiteral([""])));
Flash.displayName = 'Flash';

function scrollToVisibility(container, target) {
  if (!container || !target) return;
  var targetPos = target.offsetTop;
  var targetHeight = target.clientHeight;
  var containerHeight = container.clientHeight;
  var containerScrolled = container.scrollTop;

  if (targetPos < containerScrolled) {
    // target over scroll window, must scroll up to see it
    var y = targetPos;
    container.scroll(0, y);
  } else if (targetPos + targetHeight > containerScrolled + containerHeight) {
    // target under scroll window, must scroll down to see it
    var _y = targetPos + targetHeight - containerHeight;

    container.scroll(0, _y);
  }
}

var _templateObject$W;
var SearchInputComponent = /*#__PURE__*/forwardRef(function SearchInputComponent(_ref, ref) {
  var className = _ref.className,
      translations = _ref.translations,
      inputProps = _objectWithoutProperties(_ref, ["className", "translations"]);

  var inputRef = useRef(null);

  function handleClear() {
    /* We want to clear the input.
       We can't change `inputProps.value` since it's just a props passed.
       We could set the value on a ref of the input, but this would not dispatch a
      change event, so the UI would not be refreshed with the value set.
      We aditionaly need to dispatch an `input` event for React to dispatch a change
      event.
       BUT React messes with the value setter on the input, so we need to do a bit of
      prototype black magic to get the original value setter.
       (see https://stackoverflow.com/questions/23892547/what-is-the-best-way-to-trigger-onchange-event-in-react-js#46012210)
    */
    var input = inputRef.current;
    var valueDescriptor = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value');
    var nativeValueSetter = valueDescriptor === null || valueDescriptor === void 0 ? void 0 : valueDescriptor.set;

    if (input === null || nativeValueSetter === undefined) {
      return;
    }

    var event = document.createEvent('Event');
    event.initEvent('input', true, true);
    nativeValueSetter.call(input, '');
    input.dispatchEvent(event);
  }

  var setRef = useCallback(function setRef(node) {
    var anyInputRef = inputRef;
    anyInputRef.current = node;

    if (ref) {
      var anyRef = ref;

      if (typeof ref === 'function') {
        ref(node);
      } else {
        anyRef.current = node;
      }
    }
  }, []);
  return /*#__PURE__*/createElement(autocomplete.Wrapper, {
    className: className
  }, /*#__PURE__*/createElement(autocomplete.SearchIcon, null), /*#__PURE__*/createElement(autocomplete.Input, _extends({}, inputProps, {
    type: "text",
    ref: setRef
  })), inputProps.value && translations && /*#__PURE__*/createElement(autocomplete.Clear, {
    onClick: handleClear
  }, translations.clear));
});
/** Clearable text field. Will forward any other props to the underlying `<input>` */

var SearchInput = styled(SearchInputComponent)(_templateObject$W || (_templateObject$W = _taggedTemplateLiteral([""])));
SearchInput.displayName = 'SearchInput';

var _templateObject$X;
var AutocompleteComponent = /*#__PURE__*/forwardRef(function AutocompleteComponent(props, ref) {

  if ('query' in props) {
    return /*#__PURE__*/createElement(ControlledAutocomplete, _extends({}, props, {
      ref: ref
    }));
  } else {
    return /*#__PURE__*/createElement(UncontrolledAutocomplete, _extends({}, props, {
      ref: ref
    }));
  }
});
var UncontrolledAutocomplete = /*#__PURE__*/forwardRef(function UncontrolledAutocomplete(_ref, inputRef) {
  var className = _ref.className,
      renderResult = _ref.renderResult,
      fetch = _ref.fetch,
      _ref$onResultSelect = _ref.onResultSelect,
      onResultSelect = _ref$onResultSelect === void 0 ? function () {} : _ref$onResultSelect,
      _ref$initialQuery = _ref.initialQuery,
      initialQuery = _ref$initialQuery === void 0 ? '' : _ref$initialQuery,
      _ref$onQueryChange = _ref.onQueryChange,
      onQueryChange = _ref$onQueryChange === void 0 ? function () {} : _ref$onQueryChange,
      renderNoResult = _ref.renderNoResult,
      height = _ref.height,
      translations = _ref.translations,
      renderResultExtra = _ref.renderResultExtra,
      inputProps = _objectWithoutProperties(_ref, ["className", "renderResult", "fetch", "onResultSelect", "initialQuery", "onQueryChange", "renderNoResult", "height", "translations", "renderResultExtra"]);

  var _React$useState = useState(initialQuery),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      query = _React$useState2[0],
      setQuery = _React$useState2[1];

  function handleChange(query) {
    onQueryChange && onQueryChange(query);
    setQuery(query);
  }

  function handleResultSelect(result) {
    onResultSelect && onResultSelect(result);
    setQuery(result.label);
  }

  return /*#__PURE__*/createElement(ControlledAutocomplete, _extends({
    ref: inputRef,
    translations: translations,
    className: className,
    renderResult: renderResult,
    fetch: fetch,
    onResultSelect: handleResultSelect,
    query: query,
    onQueryChange: handleChange,
    height: height,
    renderNoResult: renderNoResult,
    renderResultExtra: renderResultExtra
  }, inputProps));
});
var currentId = 0;
var ids = new WeakMap();
var ControlledAutocomplete = /*#__PURE__*/forwardRef(function ControlledAutocomplete(_ref2, inputRef) {
  var className = _ref2.className,
      _ref2$renderResult = _ref2.renderResult,
      Result = _ref2$renderResult === void 0 ? function (_ref3) {
    var result = _ref3.result;
    return /*#__PURE__*/createElement(Fragment, null, result.label);
  } : _ref2$renderResult,
      fetch = _ref2.fetch,
      _ref2$onResultSelect = _ref2.onResultSelect,
      onResultSelect = _ref2$onResultSelect === void 0 ? function () {} : _ref2$onResultSelect,
      _ref2$query = _ref2.query,
      query = _ref2$query === void 0 ? '' : _ref2$query,
      _ref2$onQueryChange = _ref2.onQueryChange,
      onQueryChange = _ref2$onQueryChange === void 0 ? function () {} : _ref2$onQueryChange,
      height = _ref2.height,
      translations = _ref2.translations,
      _ref2$renderNoResult = _ref2.renderNoResult,
      NoResult = _ref2$renderNoResult === void 0 ? function () {
    return /*#__PURE__*/createElement(Fragment, null);
  } : _ref2$renderNoResult,
      _ref2$renderResultExt = _ref2.renderResultExtra,
      ResultExtra = _ref2$renderResultExt === void 0 ? function () {
    return /*#__PURE__*/createElement(Fragment, null);
  } : _ref2$renderResultExt,
      inputProps = _objectWithoutProperties(_ref2, ["className", "renderResult", "fetch", "onResultSelect", "query", "onQueryChange", "height", "translations", "renderNoResult", "renderResultExtra"]);

  var _autocomplete$useAuto = useAutocompleteList(query, onResultSelect, fetch),
      isOpen = _autocomplete$useAuto.isOpen,
      close = _autocomplete$useAuto.close,
      results = _autocomplete$useAuto.results,
      register = _autocomplete$useAuto.register;

  var autocompleteBoxRef = useRef(null);
  var listBoxRef = useRef(null);
  useLoseFocus(autocompleteBoxRef, function () {
    isOpen && close();
  }, [isOpen]);

  function handleChange(event) {
    onQueryChange(event.target.value);
  }

  return /*#__PURE__*/createElement("div", {
    className: className,
    ref: autocompleteBoxRef
  }, /*#__PURE__*/createElement(AutocompleteContextProvider, {
    value: register
  }, /*#__PURE__*/createElement(SearchInput, _extends({}, inputProps, {
    ref: inputRef,
    translations: translations,
    value: query,
    onChange: handleChange
  })), /*#__PURE__*/createElement(select.Drawer, {
    isOpen: isOpen
  }, /*#__PURE__*/createElement(dropdown.Dropdown, null, /*#__PURE__*/createElement(select.ScrollList, {
    height: height,
    ref: listBoxRef,
    tabIndex: -1
  }, results.length === 0 ? /*#__PURE__*/createElement(NoResult, {
    close: close
  }) : /*#__PURE__*/createElement(Fragment, null, results.map(function (result, i) {
    if (!ids.has(result)) {
      ids.set(result, currentId++);

      if (currentId === Number.MAX_SAFE_INTEGER) {
        currentId = 0;
      }
    }

    var id = ids.get(result);
    return /*#__PURE__*/createElement(AutocompleteResult, {
      scrollRef: listBoxRef,
      result: result,
      key: id + ':' + i
    }, /*#__PURE__*/createElement(Result, {
      result: result
    }));
  }), /*#__PURE__*/createElement(ResultExtra, {
    close: close
  })))))));
});

function AutocompleteResult(_ref4) {
  var result = _ref4.result,
      scrollRef = _ref4.scrollRef,
      children = _ref4.children;
  var ref = useRef(null);

  var _autocomplete$useAuto2 = useAutocompleteItem(_objectSpread2(_objectSpread2({}, result), {}, {
    handleFocus: function handleFocus() {
      var _scrollRef$current;

      scrollToVisibility((_scrollRef$current = scrollRef === null || scrollRef === void 0 ? void 0 : scrollRef.current) !== null && _scrollRef$current !== void 0 ? _scrollRef$current : null, ref.current);
    }
  })),
      select = _autocomplete$useAuto2.select,
      focus = _autocomplete$useAuto2.focus,
      isFocused = _autocomplete$useAuto2.isFocused;

  return /*#__PURE__*/createElement(autocomplete.ResultWrapper, {
    ref: ref,
    onMouseDown: select,
    onMouseMove: function onMouseMove() {
      return focus(result.value);
    },
    onFocus: function onFocus() {
      return focus(result.value);
    },
    isFocused: isFocused
  }, children);
}

var Autocomplete = styled(AutocompleteComponent)(_templateObject$X || (_templateObject$X = _taggedTemplateLiteral([""])));
Autocomplete.displayName = 'Autocomplete';

var _templateObject$Y, _templateObject2$H, _templateObject3$z, _templateObject4$w, _templateObject5$s, _templateObject6$m, _templateObject7$k, _templateObject8$k, _templateObject9$i, _templateObject10$i, _templateObject11$d;
var DefaultCheckmark = styled(checkbox.Checkmark).attrs({
  status: undefined
})(_templateObject$Y || (_templateObject$Y = _taggedTemplateLiteral(["\n  display: inline-block;\n"])));
var CheckedCheckmark = styled(checkbox.Checkmark).attrs({
  status: 'checked'
})(_templateObject2$H || (_templateObject2$H = _taggedTemplateLiteral(["\n  display: none;\n"])));
var FocusedCheckmark = styled(checkbox.Checkmark).attrs({
  status: 'focused'
})(_templateObject3$z || (_templateObject3$z = _taggedTemplateLiteral(["\n  display: none;\n"])));
var ErrorCheckmark = styled(checkbox.Checkmark).attrs({
  status: 'error'
})(_templateObject4$w || (_templateObject4$w = _taggedTemplateLiteral(["\n  display: none;\n"])));
var styleCheckToggle = function styleCheckToggle(input, follow, styles) {
  return css(_templateObject5$s || (_templateObject5$s = _taggedTemplateLiteral(["\n  ", ":focus + ", " {\n    ", " {\n      display: inline-block;\n    }\n\n    ", ", ", ", ", " {\n      display: none;\n    }\n\n    ", "\n  }\n\n  ", ":checked + ", " {\n    ", " {\n      display: inline-block;\n    }\n\n    ", ", ", ", ", " {\n      display: none;\n    }\n\n    ", "\n  }\n\n  ", ":disabled + ", " {\n    ", "\n  }\n"])), input, follow, FocusedCheckmark, DefaultCheckmark, CheckedCheckmark, ErrorCheckmark, styles === null || styles === void 0 ? void 0 : styles.focus, input, follow, CheckedCheckmark, DefaultCheckmark, FocusedCheckmark, ErrorCheckmark, styles === null || styles === void 0 ? void 0 : styles.on, input, follow, styles === null || styles === void 0 ? void 0 : styles.disabled);
};
var ControlledCheckboxWrapper = styled.div(_templateObject6$m || (_templateObject6$m = _taggedTemplateLiteral(["\n  position: relative;\n  width: 18px;\n  height: 18px;\n  ", "\n"])), function (_ref) {
  var isError = _ref.isError;

  if (isError) {
    return css(_templateObject7$k || (_templateObject7$k = _taggedTemplateLiteral(["\n        ", " {\n          display: inline-block;\n        }\n        ", ", ", ", ", " {\n          display: none;\n        }\n      "])), ErrorCheckmark, DefaultCheckmark, FocusedCheckmark, CheckedCheckmark);
  }
});

function ControlledCheckboxComponent(_ref2) {
  var className = _ref2.className,
      error = _ref2.error,
      disabled = _ref2.disabled;
  return /*#__PURE__*/createElement(ControlledCheckboxWrapper, {
    className: className,
    isError: error !== undefined
  }, /*#__PURE__*/createElement(DefaultCheckmark, {
    disabled: disabled
  }), /*#__PURE__*/createElement(FocusedCheckmark, {
    disabled: disabled
  }), /*#__PURE__*/createElement(CheckedCheckmark, {
    disabled: disabled
  }), /*#__PURE__*/createElement(ErrorCheckmark, {
    disabled: disabled
  }));
}

var ControlledCheckbox = styled(ControlledCheckboxComponent)(_templateObject8$k || (_templateObject8$k = _taggedTemplateLiteral([""])));
var Container$1 = styled.div(_templateObject9$i || (_templateObject9$i = _taggedTemplateLiteral([""])));
var CheckboxWrapper = styled.div(_templateObject10$i || (_templateObject10$i = _taggedTemplateLiteral(["\n  ", "\n"])), styleCheckToggle(input.HiddenFocusableInput, Container$1, {}));

/** will forward any other props to the underlying `<input>` */
function CheckboxComponent(_ref3) {
  var className = _ref3.className,
      error = _ref3.error,
      inputProps = _objectWithoutProperties(_ref3, ["className", "error"]);

  return /*#__PURE__*/createElement(CheckboxWrapper, {
    className: className
  }, /*#__PURE__*/createElement(input.HiddenFocusableInput, _extends({
    type: "checkbox"
  }, inputProps)), /*#__PURE__*/createElement(Container$1, null, /*#__PURE__*/createElement(ControlledCheckboxComponent, {
    error: error,
    disabled: inputProps.disabled
  })));
}

var Checkbox = styled(CheckboxComponent)(_templateObject11$d || (_templateObject11$d = _taggedTemplateLiteral([""])));
Checkbox.displayName = 'Checkbox';

var _templateObject$Z;

function FieldComponent(_ref) {
  var label = _ref.label,
      context = _ref.context,
      htmlFor = _ref.htmlFor,
      description = _ref.description,
      children = _ref.children,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["label", "context", "htmlFor", "description", "children", "className"]);

  return /*#__PURE__*/createElement(field.Label, _extends({
    className: className
  }, props), /*#__PURE__*/createElement(field.ActualLabel, {
    htmlFor: htmlFor
  }, label !== undefined && /*#__PURE__*/createElement(field.TitleWrapper, null, /*#__PURE__*/createElement(field.Title, null, label), context !== undefined && /*#__PURE__*/createElement(field.Context, null, context))), description && /*#__PURE__*/createElement(field.Description, null, description), children);
}

var Field = styled(FieldComponent)(_templateObject$Z || (_templateObject$Z = _taggedTemplateLiteral([""])));

var _templateObject$_;

function FieldStatusComponent(_ref) {
  var className = _ref.className,
      error = _ref.error,
      success = _ref.success,
      children = _ref.children;
  return /*#__PURE__*/createElement(field.Status, {
    className: className
  }, error && /*#__PURE__*/createElement(field.Message, {
    type: "error"
  }, error), success && /*#__PURE__*/createElement(field.Message, {
    type: "success"
  }, success), children);
}

var FieldStatus = styled(FieldStatusComponent)(_templateObject$_ || (_templateObject$_ = _taggedTemplateLiteral([""])));

var _templateObject$$, _templateObject2$I;
var AutocompleteFieldWrapper = styled(Field)(_templateObject$$ || (_templateObject$$ = _taggedTemplateLiteral(["\n  ", " {\n    margin-top: 10px;\n  }\n\n  ", ", ", " {\n    margin-bottom: 7px;\n  }\n"])), field.Status, field.Title, field.Description);
var AutocompleteFieldComponent = /*#__PURE__*/forwardRef(function AutocompleteFieldComponent(_ref, ref) {
  var className = _ref.className,
      label = _ref.label,
      description = _ref.description,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? String(Math.random()) : _ref$id,
      error = _ref.error,
      success = _ref.success,
      context = _ref.context,
      autocompleteProps = _objectWithoutProperties(_ref, ["className", "label", "description", "id", "error", "success", "context"]);

  return /*#__PURE__*/createElement(AutocompleteFieldWrapper, {
    className: className,
    htmlFor: id,
    label: label,
    context: context,
    description: description
  }, /*#__PURE__*/createElement(Autocomplete, _extends({}, autocompleteProps, {
    id: id,
    ref: ref
  })), (error || success) && /*#__PURE__*/createElement(FieldStatus, {
    error: error,
    success: success
  }));
});
var AutocompleteField = styled(AutocompleteFieldComponent)(_templateObject2$I || (_templateObject2$I = _taggedTemplateLiteral([""])));
AutocompleteField.displayName = 'AutocompleteField';

var _templateObject$10, _templateObject2$J, _templateObject3$A, _templateObject4$x;
var StyledCheckboxField = styled(Field)(_templateObject$10 || (_templateObject$10 = _taggedTemplateLiteral(["\n  ", " {\n    width: 100%;\n  }\n"])), field.Status);
var CheckboxFieldWrapper = styled.div(_templateObject2$J || (_templateObject2$J = _taggedTemplateLiteral(["\n  position: relative;\n  padding-left: 28px;\n\n  ", " {\n    left: 0;\n    width: 18px;\n    height: 18px;\n    top: 2px;\n  }\n\n  ", " {\n    order: 1;\n    position: absolute;\n    top: 2px;\n    left: 0;\n  }\n\n  ", " {\n    width: 100%;\n  }\n\n  ", "\n"])), input.HiddenFocusableInput, ControlledCheckboxWrapper, field.Status, styleCheckToggle(input.HiddenFocusableInput, StyledCheckboxField, {
  disabled: css(_templateObject3$A || (_templateObject3$A = _taggedTemplateLiteral(["\n      ", " {\n        color: ", ";\n      }\n    "])), field.Title, GREY_SHADE_3)
}));

/** will forward any other props to the underlying `<input>` */
function CheckboxFieldComponent(_ref) {
  var className = _ref.className,
      label = _ref.label,
      description = _ref.description,
      error = _ref.error,
      success = _ref.success,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? String(Math.random()) : _ref$id,
      inputProps = _objectWithoutProperties(_ref, ["className", "label", "description", "error", "success", "id"]);

  return /*#__PURE__*/createElement(CheckboxFieldWrapper, {
    className: className
  }, /*#__PURE__*/createElement(input.HiddenFocusableInput, _extends({
    type: "checkbox"
  }, inputProps, {
    id: id
  })), /*#__PURE__*/createElement(StyledCheckboxField, {
    htmlFor: id,
    label: label,
    description: description
  }, /*#__PURE__*/createElement(ControlledCheckbox, _extends({}, inputProps, {
    error: error,
    disabled: inputProps.disabled
  })), /*#__PURE__*/createElement(FieldStatus, {
    error: error,
    success: success
  })));
}

var CheckboxField = styled(CheckboxFieldComponent)(_templateObject4$x || (_templateObject4$x = _taggedTemplateLiteral([""])));
CheckboxField.displayName = 'CheckboxField';

var scrollContext = /*#__PURE__*/createContext(null);
function useScrollContext() {
  return useContext(scrollContext);
}

var _templateObject$11, _templateObject2$K;
function SelectComponent(props) {

  if (props.selected !== undefined) {
    return /*#__PURE__*/createElement(ControlledSelect, props);
  } else {
    return /*#__PURE__*/createElement(UncontrolledSelect, props);
  }
}

function UncontrolledSelect(_ref) {
  var _ref$initialSelected = _ref.initialSelected,
      initialSelected = _ref$initialSelected === void 0 ? [] : _ref$initialSelected,
      disabled = _ref.disabled,
      multiple = _ref.multiple,
      onChange = _ref.onChange,
      children = _ref.children,
      onClose = _ref.onClose,
      onOpen = _ref.onOpen,
      className = _ref.className,
      disableInitFocus = _ref.disableInitFocus,
      status = _ref.status,
      filterable = _ref.filterable,
      placeholder = _ref.placeholder,
      filterPlaceholder = _ref.filterPlaceholder,
      height = _ref.height,
      id = _ref.id;
  var initialSelectedOptions;

  if (multiple) {
    initialSelectedOptions = initialSelected;
  } else {
    initialSelectedOptions = initialSelected[0] ? [initialSelected[0]] : [];
  }

  var _React$useState = useState(initialSelectedOptions),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      selected = _React$useState2[0],
      setSelected = _React$useState2[1];

  function handleChange(selected) {
    onChange && onChange(selected);
    setSelected(selected.map(function (option) {
      return option.value;
    }));
  }

  return /*#__PURE__*/createElement(ControlledSelect, {
    disabled: disabled,
    disableInitFocus: disableInitFocus,
    selected: selected,
    onChange: handleChange,
    multiple: multiple,
    onClose: onClose,
    onOpen: onOpen,
    className: className,
    id: id,
    filterable: filterable,
    placeholder: placeholder,
    filterPlaceholder: filterPlaceholder,
    status: status,
    height: height
  }, children);
}

function ControlledSelect(_ref2) {
  var _ref2$selected = _ref2.selected,
      selected = _ref2$selected === void 0 ? [] : _ref2$selected,
      disabled = _ref2.disabled,
      _ref2$disableInitFocu = _ref2.disableInitFocus,
      disableInitFocus = _ref2$disableInitFocu === void 0 ? false : _ref2$disableInitFocu,
      children = _ref2.children,
      _ref2$multiple = _ref2.multiple,
      multiple = _ref2$multiple === void 0 ? false : _ref2$multiple,
      _ref2$onChange = _ref2.onChange,
      onChange = _ref2$onChange === void 0 ? function () {} : _ref2$onChange,
      _ref2$onClose = _ref2.onClose,
      onClose = _ref2$onClose === void 0 ? function () {} : _ref2$onClose,
      _ref2$onOpen = _ref2.onOpen,
      onOpen = _ref2$onOpen === void 0 ? function () {} : _ref2$onOpen,
      height = _ref2.height,
      placeholder = _ref2.placeholder,
      id = _ref2.id,
      className = _ref2.className,
      _ref2$filterable = _ref2.filterable,
      filterable = _ref2$filterable === void 0 ? false : _ref2$filterable,
      filterPlaceholder = _ref2.filterPlaceholder,
      status = _ref2.status;

  var _useSelect = useSelect$1(selected, onClose, onChange, multiple, disableInitFocus, filterable),
      _useSelect2 = _slicedToArray(_useSelect, 5),
      _useSelect2$ = _useSelect2[0],
      isOpen = _useSelect2$.isOpen,
      selectedOptions = _useSelect2$.selectedOptions,
      open = _useSelect2$.open,
      close = _useSelect2$.close,
      register = _useSelect2$.register,
      selectBoxRef = _useSelect2[1],
      scrollRef = _useSelect2[2],
      onFilter = _useSelect2[3],
      filter = _useSelect2[4];

  function openHandler() {
    onOpen();
    open();
  }

  return /*#__PURE__*/createElement("div", {
    ref: selectBoxRef,
    className: className
  }, /*#__PURE__*/createElement(SelectButton, {
    disabled: disabled,
    id: id,
    onClick: isOpen ? close : openHandler,
    status: status
  }, label(selectedOptions, placeholder || '')), /*#__PURE__*/createElement(SelectDrawer, {
    close: close,
    isOpen: isOpen,
    height: height,
    scrollRef: scrollRef,
    register: register,
    multiple: multiple,
    filterable: filterable,
    filter: filter,
    onFilter: onFilter,
    filterPlaceholder: filterPlaceholder
  }, children));
}

function useSelect$1(selected, onClose, onChange, multiple, disableInitFocus, filterable) {
  var selectBoxref = useRef(null);
  var listBoxRef = useRef(null);

  var _React$useState3 = useState(''),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      filter = _React$useState4[0],
      setFilter = _React$useState4[1];

  var _React$useState5 = useState(''),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      debouncedFilter = _React$useState6[0],
      setDebouncedFilter = _React$useState6[1];

  var debouncedUpdateFilter = useDebounce(setDebouncedFilter, false);
  var selectApi = useSelect(selected, selectBoxref, function (selected) {
    onClose(selected);
    setDebouncedFilter('');
    setFilter('');
  }, onChange, multiple, disableInitFocus, filterable ? debouncedFilter : undefined);
  useLoseFocus(selectBoxref, function () {
    selectApi.isOpen && selectApi.close();
  }, [selectApi.isOpen]);

  var updateFilter = function updateFilter(filter) {
    setFilter(filter);
    debouncedUpdateFilter(filter);
  };

  return [selectApi, selectBoxref, listBoxRef, updateFilter, filter];
}

function SelectButtonComponent(_ref3) {
  var className = _ref3.className,
      disabled = _ref3.disabled,
      id = _ref3.id,
      onClick = _ref3.onClick,
      status = _ref3.status,
      children = _ref3.children;
  return /*#__PURE__*/createElement(select.Button, {
    className: className,
    type: "button",
    disabled: disabled,
    onClick: onClick,
    status: status,
    tabIndex: 0,
    id: id
  }, /*#__PURE__*/createElement(select.Label, null, children), /*#__PURE__*/createElement(select.CaretDown, null));
}

var SelectButton = styled(SelectButtonComponent)(_templateObject$11 || (_templateObject$11 = _taggedTemplateLiteral([""])));
function SelectDrawer(_ref4) {
  var isOpen = _ref4.isOpen,
      height = _ref4.height,
      scrollRef = _ref4.scrollRef,
      register = _ref4.register,
      children = _ref4.children,
      multiple = _ref4.multiple,
      close = _ref4.close,
      filterable = _ref4.filterable,
      filter = _ref4.filter,
      onFilter = _ref4.onFilter,
      filterPlaceholder = _ref4.filterPlaceholder;
  return /*#__PURE__*/createElement(select.Drawer, {
    isOpen: isOpen
  }, /*#__PURE__*/createElement(dropdown.Dropdown, null, filterable && /*#__PURE__*/createElement(select.SearchBox, null, /*#__PURE__*/createElement(SearchInput, {
    placeholder: filterPlaceholder,
    value: filter,
    onChange: function onChange(evt) {
      return onFilter(evt.target.value);
    }
  })), /*#__PURE__*/createElement(select.ScrollList, {
    height: height,
    ref: scrollRef,
    tabIndex: -1
  }, /*#__PURE__*/createElement(scrollContext.Provider, {
    value: scrollRef
  }, /*#__PURE__*/createElement(SelectContextProvider, {
    value: register
  }, children))), multiple && /*#__PURE__*/createElement(select.MultiSelectButton, {
    type: "button",
    onClick: close,
    tabIndex: 0
  }, "Valider")));
}
function label(selectedOptions, placeholder) {
  return selectedOptions.length === 0 ? placeholder : selectedOptions.map(function (option) {
    return option.label;
  }).join(', ');
}
/** Replicate the native `<select>` behaviour (search by prefix, focus on hover, keyboard navigable). Usually used with `<Option>`.*/

var Select = styled(SelectComponent)(_templateObject2$K || (_templateObject2$K = _taggedTemplateLiteral(["\n  &:hover ", " {\n    border: 1px solid ", ";\n    color: ", ";\n  }\n"])), select.Button, PRIMARY_BLUE, PRIMARY_BLUE);
Select.displayName = 'Select';

var _templateObject$12, _templateObject2$L, _templateObject3$B, _templateObject4$y;

function DropdownComponent(_ref) {
  var children = _ref.children,
      selectProps = _objectWithoutProperties(_ref, ["children"]);

  return /*#__PURE__*/createElement(Select, selectProps, children);
}
/** Variant of `<Select>`, see there for the props */


var Dropdown$1 = styled(DropdownComponent)(_templateObject$12 || (_templateObject$12 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  flex-direction: column;\n  align-items: flex-end;\n  cursor: pointer;\n\n  ", ", ", ", ", " {\n    display: inline-block\n  }\n\n  ", " {\n    margin-top: 10px;\n\n    ", ";\n  }\n\n  ", " {\n    width: auto;\n    border: none;\n    padding-right: 0;\n    max-width: 100%;\n    cursor: pointer;\n    height: auto;\n    padding: 0;\n\n    ", " {\n      color: ", ";\n      flex: 0 0 10px;\n    }\n\n    ", " {\n      ", ";\n    }\n\n    ", ";\n  }\n\n  &:hover ", " {\n    border:none;\n\n    ", ", ", " {\n      color: ", ";\n    }\n  }\n"])), select.Drawer, dropdown.Dropdown, select.ScrollList, select.Drawer, function (_ref2) {
  var _ref2$mode = _ref2.mode,
      mode = _ref2$mode === void 0 ? 'block' : _ref2$mode;

  if (mode === 'inline') {
    return css(_templateObject2$L || (_templateObject2$L = _taggedTemplateLiteral(["\n          position: absolute;\n          right: 0px;\n          top: 20px;\n        "])));
  }
}, select.Button, select.CaretDown, PRIMARY_BLACK, select.Label, function (_ref3) {
  var _ref3$mode = _ref3.mode,
      mode = _ref3$mode === void 0 ? 'block' : _ref3$mode;

  if (mode === 'inline') {
    return css(_templateObject3$B || (_templateObject3$B = _taggedTemplateLiteral(["\n            margin-right: 13px;\n          "])));
  }
}, function (_ref4) {
  var _ref4$mode = _ref4.mode,
      mode = _ref4$mode === void 0 ? 'block' : _ref4$mode;

  if (mode === 'inline') {
    return css(_templateObject4$y || (_templateObject4$y = _taggedTemplateLiteral(["\n          background-color: transparent;\n        "])));
  }
}, select.Button, select.Label, select.CaretDown, PRIMARY_BLUE);
Dropdown$1.displayName = 'Dropdown';

var _templateObject$13, _templateObject2$M, _templateObject3$C, _templateObject4$z;
var DropdownFieldWrapper = styled(Field)(_templateObject$13 || (_templateObject$13 = _taggedTemplateLiteral(["\n  display: inline-flex;\n\n  ", " {\n    margin-top: 0px;\n  }\n\n  ", ":hover, ", ":hover + ", " {\n    ", " {\n      border: 2px solid ", ";\n    }\n    ", ", ", " {\n      color: ", ";\n    }\n  }\n\n  ", " {\n    ", "\n    border-radius: 2px;\n  }\n\n  ", " {\n    width: 100%;\n    padding: 10px 15px;\n  }\n\n  ", " {\n    background: ", ";\n    margin: 0 5px -12px;\n    position: relative;\n    cursor: pointer;\n  }\n\n  ", " {\n    margin: 0;\n    font-size: 10px;\n    text-transform: uppercase;\n    color: ", ";\n    line-height: 10px;\n    padding: 7px;\n  }\n\n  ", " {\n    margin-top: 10px;\n  }\n"])), select.Drawer, Dropdown$1, field.ActualLabel, Dropdown$1, select.Button, PRIMARY_BLUE, select.Label, select.CaretDown, PRIMARY_BLUE, select.Button, function (_ref) {
  var status = _ref.status;

  if (status === 'error') {
    return css(_templateObject2$M || (_templateObject2$M = _taggedTemplateLiteral(["\n          border: 2px dashed ", ";\n        "])), PRIMARY_RED);
  } else {
    return css(_templateObject3$C || (_templateObject3$C = _taggedTemplateLiteral(["\n          border: 2px solid black;\n        "])));
  }
}, select.Button, field.ActualLabel, PRIMARY_WHITE, field.Title, GREY_SHADE_3, field.Status);

function DropdownFieldComponent(_ref2) {
  var className = _ref2.className,
      label = _ref2.label,
      description = _ref2.description,
      error = _ref2.error,
      _ref2$id = _ref2.id,
      id = _ref2$id === void 0 ? String(Math.random()) : _ref2$id,
      children = _ref2.children,
      context = _ref2.context,
      selectProps = _objectWithoutProperties(_ref2, ["className", "label", "description", "error", "id", "children", "context"]);

  var status = 'default';

  if (error !== undefined) {
    status = 'error';
  }

  return /*#__PURE__*/createElement(DropdownFieldWrapper, {
    status: status,
    className: className,
    htmlFor: id,
    label: label,
    description: description,
    context: context
  }, /*#__PURE__*/createElement(Dropdown$1, _extends({}, selectProps, {
    id: id
  }), children), error && /*#__PURE__*/createElement(FieldStatus, {
    error: error
  }));
}
/** extends `<Select>`, see there for additional props */


var DropdownField = styled(DropdownFieldComponent)(_templateObject4$z || (_templateObject4$z = _taggedTemplateLiteral([""])));
DropdownField.displayName = 'DropdownField';

var ERROR_STATUS_CLASS = 'field-status-error';
var SUCCESS_STATUS_CLASS = 'field-status-success';
var ERROR_STATUS_SELECTOR = ".".concat(ERROR_STATUS_CLASS);
var SUCCESS_STATUS_SELECTOR = ".".concat(SUCCESS_STATUS_CLASS);

var _templateObject$14, _templateObject2$N;
var TextFieldWrapper = styled(Field)(_templateObject$14 || (_templateObject$14 = _taggedTemplateLiteral(["\n  ", " {\n    margin-top: 4px;\n  }\n\n  ", " {\n    margin-top: 10px;\n    flex: 0 0 auto;\n    margin-left: auto;\n  }\n\n  ", ", ", " {\n    margin-bottom: 7px;\n  }\n\n  ", " {\n    width: 100%;\n  }\n"])), field.Message, input.Count, field.Title, field.Description, input.Input);

function TextFieldComponent(_ref) {
  var className = _ref.className,
      label = _ref.label,
      description = _ref.description,
      error = _ref.error,
      success = _ref.success,
      children = _ref.children,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? String(Math.random()) : _ref$id,
      inputProps = _objectWithoutProperties(_ref, ["className", "label", "description", "error", "success", "children", "id"]);

  var status = 'default';

  if (error && !success) {
    status = 'error';
  }

  if (success && !error) {
    status = 'success';
  }

  var _React$useState = useState(0),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      length = _React$useState2[0],
      setLength = _React$useState2[1];

  var maxLength = inputProps.maxLength;

  function handleChange(event) {
    var onChange = inputProps.onChange;
    onChange && onChange(event);

    if (maxLength !== undefined) {
      setLength(event.target.value.length);
    }
  }

  return /*#__PURE__*/createElement(TextFieldWrapper, {
    className: className,
    htmlFor: id,
    label: label,
    description: description
  }, children, /*#__PURE__*/createElement(input.Input, _extends({}, inputProps, {
    onChange: handleChange,
    status: status,
    id: id
  })), (error || success || maxLength !== undefined) && /*#__PURE__*/createElement(FieldStatus, {
    error: error,
    success: success
  }, maxLength !== undefined && /*#__PURE__*/createElement(input.Count, {
    isError: length > maxLength
  }, length, "/", maxLength)));
}
/** will forward any other props to the underlying `<input>` */


var TextField = styled(TextFieldComponent)(_templateObject2$N || (_templateObject2$N = _taggedTemplateLiteral([""])));
TextField.displayName = 'TextField';

var _templateObject$15;
/* TODO: Maybe this component should be extracted ? it seems very specific to connect */

function PasswordFieldComponent(_ref) {
  var className = _ref.className,
      label = _ref.label,
      description = _ref.description,
      feedback = _ref.feedback,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? String(Math.random()) : _ref$id,
      error = _ref.error,
      inputProps = _objectWithoutProperties(_ref, ["className", "label", "description", "feedback", "id", "error"]);

  var status = 'default';

  if (error === true) {
    status = 'error';
  }

  return /*#__PURE__*/createElement(TextFieldWrapper, {
    className: className,
    htmlFor: id,
    label: label,
    description: description
  }, /*#__PURE__*/createElement(input.Input, _extends({}, inputProps, {
    type: "password",
    status: status,
    id: id
  })), feedback && /*#__PURE__*/createElement(FieldStatus, null, /*#__PURE__*/createElement(password.Indicator, null, /*#__PURE__*/createElement(password.Strength, {
    score: feedback.score
  }, feedback.strength), ' ', feedback.suggestions.join(' '))));
}
/** will forward any other props to the underlying `<input>` */


var PasswordField = styled(PasswordFieldComponent)(_templateObject$15 || (_templateObject$15 = _taggedTemplateLiteral([""])));
PasswordField.displayName = 'PasswordField';

var _templateObject$16;

function OptionComponent(_ref) {
  var _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      title = _ref.title,
      label = _ref.label,
      value = _ref.value,
      _ref$onToggle = _ref.onToggle,
      onToggle = _ref$onToggle === void 0 ? function () {} : _ref$onToggle,
      _ref$onFocus = _ref.onFocus,
      onFocus = _ref$onFocus === void 0 ? function () {} : _ref$onFocus,
      children = _ref.children,
      className = _ref.className;
  var ref = useRef(null);
  var scrollRef = useScrollContext();

  function handleFocus() {
    var _scrollRef$current;

    onFocus && onFocus();
    scrollToVisibility((_scrollRef$current = scrollRef === null || scrollRef === void 0 ? void 0 : scrollRef.current) !== null && _scrollRef$current !== void 0 ? _scrollRef$current : null, ref.current);
  }

  var _select$useOption = useOption({
    value: value,
    label: label,
    disabled: disabled,
    handleToggle: onToggle,
    handleFocus: handleFocus
  }),
      isSelected = _select$useOption.isSelected,
      multiple = _select$useOption.multiple,
      toggle = _select$useOption.toggle,
      isFocused = _select$useOption.isFocused,
      focus = _select$useOption.focus,
      isFiltered = _select$useOption.isFiltered;

  var status = 'default';

  if (isSelected) {
    status = 'selected';
  }

  if (disabled) {
    status = 'disabled';
  }

  return /*#__PURE__*/createElement(OptionInner, {
    ref: ref,
    title: title,
    status: status,
    className: className,
    multiple: multiple,
    value: value,
    focus: focus,
    isFocused: isFocused,
    isSelected: isSelected,
    isFiltered: isFiltered,
    toggle: toggle
  }, children);
}

var OptionInner = /*#__PURE__*/memo( /*#__PURE__*/forwardRef(function OptionInner(_ref2, ref) {
  var value = _ref2.value,
      title = _ref2.title,
      isFocused = _ref2.isFocused,
      isSelected = _ref2.isSelected,
      isFiltered = _ref2.isFiltered,
      focus = _ref2.focus,
      toggle = _ref2.toggle,
      className = _ref2.className,
      multiple = _ref2.multiple,
      children = _ref2.children,
      status = _ref2.status;
  var renderedChildren = typeof children === 'function' ? children({
    isFocused: isFocused,
    isSelected: isSelected,
    isFiltered: isFiltered
  }) : children;
  return /*#__PURE__*/createElement(option.Wrapper, {
    ref: ref,
    title: title,
    focused: isFocused,
    onMouseMove: function onMouseMove() {
      return focus(value);
    },
    onFocus: function onFocus() {
      return focus(value);
    },
    onClick: toggle,
    tabIndex: -1,
    className: className,
    filtered: isFiltered
  }, multiple ? /*#__PURE__*/createElement(option.MultiSelectedIcon, {
    status: status
  }) : /*#__PURE__*/createElement(option.MonoSelectedIcon, {
    status: status
  }), /*#__PURE__*/createElement(option.Label, {
    status: status
  }, renderedChildren));
}));
OptionInner.displayName = 'OptionInner';
/** Usually used with `<Select>` */

var Option = styled(OptionComponent)(_templateObject$16 || (_templateObject$16 = _taggedTemplateLiteral([""])));
Option.displayName = 'Option';

var _templateObject$17, _templateObject2$O;
var CountryOption = /*#__PURE__*/memo(function ContryOption(_ref) {
  var country = _ref.country;
  return /*#__PURE__*/createElement(PrefixOption, {
    value: country,
    label: country.content
  }, /*#__PURE__*/createElement(image.Flag, {
    src: country.flag,
    alt: country.content
  }), /*#__PURE__*/createElement(phone.CountryPrefix, null, "+", String(country.prefix)), /*#__PURE__*/createElement(phone.CountryName, null, country.content));
}, function () {
  return true;
});
var PrefixOption = styled(Option)(_templateObject$17 || (_templateObject$17 = _taggedTemplateLiteral(["\n  ", " {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    width: 100%;\n  }\n\n  ", " {\n    flex: 0 0 20px;\n  }\n\n  ", " {\n    flex: 0 0 40px;\n    text-align: right;\n    margin: 0 8px 0 4px;\n  }\n\n  ", " {\n    flex: 1;\n  }\n"])), option.Label, image.Flag, phone.CountryPrefix, phone.CountryName);
var PrefixList = /*#__PURE__*/memo(function PrefixList(_ref2) {
  var isOpen = _ref2.isOpen,
      close = _ref2.close,
      scrollRef = _ref2.scrollRef,
      countries = _ref2.countries,
      register = _ref2.register,
      filter = _ref2.filter,
      onFilter = _ref2.onFilter,
      filterPlaceholder = _ref2.filterPlaceholder;
  return /*#__PURE__*/createElement(SelectDrawer, {
    close: close,
    isOpen: isOpen,
    height: 200,
    scrollRef: scrollRef,
    register: register,
    multiple: false,
    filterable: true,
    filter: filter,
    onFilter: onFilter,
    filterPlaceholder: filterPlaceholder
  }, countries.map(function (country, index) {
    return /*#__PURE__*/createElement(CountryOption, {
      country: country,
      key: index
    });
  }));
});

function PrefixSelectComponent(_ref3) {
  var className = _ref3.className,
      id = _ref3.id,
      disabled = _ref3.disabled,
      countries = _ref3.countries,
      selectedCountry = _ref3.selectedCountry,
      filterPlaceholder = _ref3.filterPlaceholder,
      onChange = _ref3.onChange;

  var _useSelect = useSelect$1([selectedCountry], function () {}, function (selected) {
    var option = selected[0];
    onChange && onChange(option.value);
  }, false, false, true),
      _useSelect2 = _slicedToArray(_useSelect, 5),
      _useSelect2$ = _useSelect2[0],
      isOpen = _useSelect2$.isOpen,
      open = _useSelect2$.open,
      close = _useSelect2$.close,
      register = _useSelect2$.register,
      selectBoxRef = _useSelect2[1],
      scrollRef = _useSelect2[2],
      onFilter = _useSelect2[3],
      filter = _useSelect2[4];

  return /*#__PURE__*/createElement("div", {
    ref: selectBoxRef,
    className: className
  }, /*#__PURE__*/createElement(SelectButton, {
    disabled: disabled,
    id: id,
    onClick: isOpen ? close : open,
    status: "default"
  }, /*#__PURE__*/createElement(image.Flag, {
    src: selectedCountry.flag,
    alt: selectedCountry.content
  }), selectedCountry.value, " +", String(selectedCountry.prefix)), /*#__PURE__*/createElement(PrefixList, {
    isOpen: isOpen,
    close: close,
    scrollRef: scrollRef,
    countries: countries,
    register: register,
    onFilter: onFilter,
    filter: filter,
    filterPlaceholder: filterPlaceholder
  }));
}

var PrefixSelect = styled(PrefixSelectComponent)(_templateObject2$O || (_templateObject2$O = _taggedTemplateLiteral(["\n  ", " {\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: -1px;\n    z-index: 10;\n  }\n\n  ", " {\n    border: 1px solid ", ";\n    border-top: none;\n  }\n\n  ", " {\n    color: ", ";\n  }\n\n  ", " {\n    padding: 10px;\n\n    ", " {\n      margin-right: 10px;\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n    }\n  }\n"])), select.Drawer, dropdown.Dropdown, PRIMARY_BLUE, select.CaretDown, PRIMARY_BLACK, SelectButton, select.Label);

// This file is a workaround for a bug in web browsers' "native"
// ES6 importing system which is uncapable of importing "*.json" files.
// https://github.com/catamphetamine/libphonenumber-js/issues/239
var metadata = {"version":4,"country_calling_codes":{"1":["US","AG","AI","AS","BB","BM","BS","CA","DM","DO","GD","GU","JM","KN","KY","LC","MP","MS","PR","SX","TC","TT","VC","VG","VI"],"7":["RU","KZ"],"20":["EG"],"27":["ZA"],"30":["GR"],"31":["NL"],"32":["BE"],"33":["FR"],"34":["ES"],"36":["HU"],"39":["IT","VA"],"40":["RO"],"41":["CH"],"43":["AT"],"44":["GB","GG","IM","JE"],"45":["DK"],"46":["SE"],"47":["NO","SJ"],"48":["PL"],"49":["DE"],"51":["PE"],"52":["MX"],"53":["CU"],"54":["AR"],"55":["BR"],"56":["CL"],"57":["CO"],"58":["VE"],"60":["MY"],"61":["AU","CC","CX"],"62":["ID"],"63":["PH"],"64":["NZ"],"65":["SG"],"66":["TH"],"81":["JP"],"82":["KR"],"84":["VN"],"86":["CN"],"90":["TR"],"91":["IN"],"92":["PK"],"93":["AF"],"94":["LK"],"95":["MM"],"98":["IR"],"211":["SS"],"212":["MA","EH"],"213":["DZ"],"216":["TN"],"218":["LY"],"220":["GM"],"221":["SN"],"222":["MR"],"223":["ML"],"224":["GN"],"225":["CI"],"226":["BF"],"227":["NE"],"228":["TG"],"229":["BJ"],"230":["MU"],"231":["LR"],"232":["SL"],"233":["GH"],"234":["NG"],"235":["TD"],"236":["CF"],"237":["CM"],"238":["CV"],"239":["ST"],"240":["GQ"],"241":["GA"],"242":["CG"],"243":["CD"],"244":["AO"],"245":["GW"],"246":["IO"],"247":["AC"],"248":["SC"],"249":["SD"],"250":["RW"],"251":["ET"],"252":["SO"],"253":["DJ"],"254":["KE"],"255":["TZ"],"256":["UG"],"257":["BI"],"258":["MZ"],"260":["ZM"],"261":["MG"],"262":["RE","YT"],"263":["ZW"],"264":["NA"],"265":["MW"],"266":["LS"],"267":["BW"],"268":["SZ"],"269":["KM"],"290":["SH","TA"],"291":["ER"],"297":["AW"],"298":["FO"],"299":["GL"],"350":["GI"],"351":["PT"],"352":["LU"],"353":["IE"],"354":["IS"],"355":["AL"],"356":["MT"],"357":["CY"],"358":["FI","AX"],"359":["BG"],"370":["LT"],"371":["LV"],"372":["EE"],"373":["MD"],"374":["AM"],"375":["BY"],"376":["AD"],"377":["MC"],"378":["SM"],"380":["UA"],"381":["RS"],"382":["ME"],"383":["XK"],"385":["HR"],"386":["SI"],"387":["BA"],"389":["MK"],"420":["CZ"],"421":["SK"],"423":["LI"],"500":["FK"],"501":["BZ"],"502":["GT"],"503":["SV"],"504":["HN"],"505":["NI"],"506":["CR"],"507":["PA"],"508":["PM"],"509":["HT"],"590":["GP","BL","MF"],"591":["BO"],"592":["GY"],"593":["EC"],"594":["GF"],"595":["PY"],"596":["MQ"],"597":["SR"],"598":["UY"],"599":["CW","BQ"],"670":["TL"],"672":["NF"],"673":["BN"],"674":["NR"],"675":["PG"],"676":["TO"],"677":["SB"],"678":["VU"],"679":["FJ"],"680":["PW"],"681":["WF"],"682":["CK"],"683":["NU"],"685":["WS"],"686":["KI"],"687":["NC"],"688":["TV"],"689":["PF"],"690":["TK"],"691":["FM"],"692":["MH"],"850":["KP"],"852":["HK"],"853":["MO"],"855":["KH"],"856":["LA"],"880":["BD"],"886":["TW"],"960":["MV"],"961":["LB"],"962":["JO"],"963":["SY"],"964":["IQ"],"965":["KW"],"966":["SA"],"967":["YE"],"968":["OM"],"970":["PS"],"971":["AE"],"972":["IL"],"973":["BH"],"974":["QA"],"975":["BT"],"976":["MN"],"977":["NP"],"992":["TJ"],"993":["TM"],"994":["AZ"],"995":["GE"],"996":["KG"],"998":["UZ"]},"countries":{"AC":["247","00","(?:[01589]\\d|[46])\\d{4}",[5,6]],"AD":["376","00","(?:1|6\\d)\\d{7}|[135-9]\\d{5}",[6,8,9],[["(\\d{3})(\\d{3})","$1 $2",["[135-9]"]],["(\\d{4})(\\d{4})","$1 $2",["1"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"]]]],"AE":["971","00","(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}",[5,6,7,8,9,10,11,12],[["(\\d{3})(\\d{2,9})","$1 $2",["60|8"]],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[236]|[479][2-8]"],"0$1"],["(\\d{3})(\\d)(\\d{5})","$1 $2 $3",["[479]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["5"],"0$1"]],"0"],"AF":["93","00","[2-7]\\d{8}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[2-7]"],"0$1"]],"0"],"AG":["1","011","(?:268|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([457]\\d{6})$","268$1",0,"268"],"AI":["1","011","(?:264|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2457]\\d{6})$","264$1",0,"264"],"AL":["355","00","(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",[6,7,8,9],[["(\\d{3})(\\d{3,4})","$1 $2",["80|9"],"0$1"],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["4[2-6]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2358][2-5]|4"],"0$1"],["(\\d{3})(\\d{5})","$1 $2",["[23578]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["6"],"0$1"]],"0"],"AM":["374","00","(?:[1-489]\\d|55|60|77)\\d{6}",[8],[["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[89]0"],"0 $1"],["(\\d{3})(\\d{5})","$1 $2",["2|3[12]"],"(0$1)"],["(\\d{2})(\\d{6})","$1 $2",["1|47"],"(0$1)"],["(\\d{2})(\\d{6})","$1 $2",["[3-9]"],"0$1"]],"0"],"AO":["244","00","[29]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[29]"]]]],"AR":["54","00","11\\d{8}|(?:[2368]|9\\d)\\d{9}",[10,11],[["(\\d{4})(\\d{2})(\\d{4})","$1 $2-$3",["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])","2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)","2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]","2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"],"0$1",1],["(\\d{2})(\\d{4})(\\d{4})","$1 $2-$3",["1"],"0$1",1],["(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["[68]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2-$3",["[23]"],"0$1",1],["(\\d)(\\d{4})(\\d{2})(\\d{4})","$2 15-$3-$4",["9(?:2[2-469]|3[3-578])","9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))","9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)","9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]","9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"],"0$1",0,"$1 $2 $3-$4"],["(\\d)(\\d{2})(\\d{4})(\\d{4})","$2 15-$3-$4",["91"],"0$1",0,"$1 $2 $3-$4"],["(\\d)(\\d{3})(\\d{3})(\\d{4})","$2 15-$3-$4",["9"],"0$1",0,"$1 $2 $3-$4"]],"0",0,"0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?","9$1"],"AS":["1","011","(?:[58]\\d\\d|684|900)\\d{7}",[10],0,"1",0,"1|([267]\\d{6})$","684$1",0,"684"],"AT":["43","00","1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",[4,5,6,7,8,9,10,11,12,13],[["(\\d)(\\d{3,12})","$1 $2",["1(?:11|[2-9])"],"0$1"],["(\\d{3})(\\d{2})","$1 $2",["517"],"0$1"],["(\\d{2})(\\d{3,5})","$1 $2",["5[079]"],"0$1"],["(\\d{3})(\\d{3,10})","$1 $2",["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"],"0$1"],["(\\d{4})(\\d{3,9})","$1 $2",["[2-467]|5[2-6]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["5"],"0$1"],["(\\d{2})(\\d{4})(\\d{4,7})","$1 $2 $3",["5"],"0$1"]],"0"],"AU":["61","001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","1(?:[0-79]\\d{7,8}|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}",[5,6,7,8,9,10],[["(\\d{2})(\\d{3,4})","$1 $2",["16"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,4})","$1 $2 $3",["16"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["14|4"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["[2378]"],"(0$1)"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:30|[89])"]]],"0",0,"0|(183[12])",0,0,0,[["8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-7]|3[2-4]|[4-6]\\d))|91(?:[0-57-9]\\d|6[0135-9])\\d)\\d{3}|(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8])|8(?:6[0-8]|[78]\\d|9[02-9]))\\d{6}",[9]],["4(?:83[0-38]|93[0-4])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}",[9]],["180(?:0\\d{3}|2)\\d{3}",[7,10]],["190[0-26]\\d{6}",[10]],0,0,0,["163\\d{2,6}",[5,6,7,8,9]],["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",[9]],["13(?:00\\d{3}|45[0-4])\\d{3}|13\\d{4}",[6,8,10]]],"0011"],"AW":["297","00","(?:[25-79]\\d\\d|800)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[25-9]"]]]],"AX":["358","00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))","2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",[5,6,7,8,9,10,11,12],0,"0",0,0,0,0,"18",0,"00"],"AZ":["994","00","365\\d{6}|(?:[124579]\\d|60|88)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["90"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[28]|2|365|46","1[28]|2|365|46","1[28]|2|365(?:[0-46-9]|5[0-35-9])|46"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[13-9]"],"0$1"]],"0"],"BA":["387","00","6\\d{8}|(?:[35689]\\d|49|70)\\d{6}",[8,9],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["6[1-3]|[7-9]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2-$3",["[3-5]|6[56]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["6"],"0$1"]],"0"],"BB":["1","011","(?:246|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2-9]\\d{6})$","246$1",0,"246"],"BD":["880","00","1\\d{9}|2\\d{7,8}|88\\d{4,6}|(?:8[0-79]|9\\d)\\d{4,8}|(?:[346]\\d|[57])\\d{5,8}",[6,7,8,9,10],[["(\\d{2})(\\d{4,6})","$1-$2",["31[5-8]|[459]1"],"0$1"],["(\\d{3})(\\d{3,7})","$1-$2",["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:28|4[14]|5)|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"],"0$1"],["(\\d{4})(\\d{3,6})","$1-$2",["[13-9]"],"0$1"],["(\\d)(\\d{7,8})","$1-$2",["2"],"0$1"]],"0"],"BE":["32","00","4\\d{8}|[1-9]\\d{7}",[8,9],[["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["(?:80|9)0"],"0$1"],["(\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[239]|4[23]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[15-8]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["4"],"0$1"]],"0"],"BF":["226","00","[025-7]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[025-7]"]]]],"BG":["359","00","[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",[6,7,8,9],[["(\\d)(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["2"],"0$1"],["(\\d{3})(\\d{4})","$1 $2",["43[1-6]|70[1-9]"],"0$1"],["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"],"0$1"],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["(?:70|8)0"],"0$1"],["(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3",["43[1-7]|7"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[48]|9[08]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1"]],"0"],"BH":["973","00","[136-9]\\d{7}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[13679]|8[047]"]]]],"BI":["257","00","(?:[267]\\d|31)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2367]"]]]],"BJ":["229","00","(?:[2689]\\d|51)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[25689]"]]]],"BL":["590","00","(?:590|69\\d|976)\\d{6}",[9],0,"0",0,0,0,0,0,[["590(?:2[7-9]|5[12]|87)\\d{4}"],["69(?:0\\d\\d|1(?:2[29]|3[0-5]))\\d{4}"],0,0,0,0,0,0,["976[01]\\d{5}"]]],"BM":["1","011","(?:441|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2-8]\\d{6})$","441$1",0,"441"],"BN":["673","00","[2-578]\\d{6}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-578]"]]]],"BO":["591","00(?:1\\d)?","(?:[2-467]\\d\\d|8001)\\d{5}",[8,9],[["(\\d)(\\d{7})","$1 $2",["[23]|4[46]"]],["(\\d{8})","$1",["[67]"]],["(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["8"]]],"0",0,"0(1\\d)?"],"BQ":["599","00","(?:[34]1|7\\d)\\d{5}",[7],0,0,0,0,0,0,"[347]"],"BR":["55","00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)","(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-24679]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}",[8,9,10,11],[["(\\d{4})(\\d{4})","$1-$2",["300|4(?:0[02]|37)","4(?:02|37)0|[34]00"]],["(\\d{3})(\\d{2,3})(\\d{4})","$1 $2 $3",["(?:[358]|90)0"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1 $2-$3",["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"],"($1)"],["(\\d{2})(\\d{5})(\\d{4})","$1 $2-$3",["[16][1-9]|[2-57-9]"],"($1)"]],"0",0,"(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?","$2"],"BS":["1","011","(?:242|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([3-8]\\d{6})$","242$1",0,"242"],"BT":["975","00","[17]\\d{7}|[2-8]\\d{6}",[7,8],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[2-68]|7[246]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[67]|7"]]]],"BW":["267","00","(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}",[7,8,10],[["(\\d{2})(\\d{5})","$1 $2",["90"]],["(\\d{3})(\\d{4})","$1 $2",["[24-6]|3[15-79]"]],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[37]"]],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["0"]],["(\\d{3})(\\d{4})(\\d{3})","$1 $2 $3",["8"]]]],"BY":["375","810","(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}",[6,7,8,9,10,11],[["(\\d{3})(\\d{3})","$1 $2",["800"],"8 $1"],["(\\d{3})(\\d{2})(\\d{2,4})","$1 $2 $3",["800"],"8 $1"],["(\\d{4})(\\d{2})(\\d{3})","$1 $2-$3",["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])","1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"],"8 0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2-$3-$4",["1(?:[56]|7[467])|2[1-3]"],"8 0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["[1-4]"],"8 0$1"],["(\\d{3})(\\d{3,4})(\\d{4})","$1 $2 $3",["[89]"],"8 $1"]],"8",0,"0|80?",0,0,0,0,"8~10"],"BZ":["501","00","(?:0800\\d|[2-8])\\d{6}",[7,11],[["(\\d{3})(\\d{4})","$1-$2",["[2-8]"]],["(\\d)(\\d{3})(\\d{4})(\\d{3})","$1-$2-$3-$4",["0"]]]],"CA":["1","011","(?:[2-8]\\d|90)\\d{8}",[10],0,"1",0,0,0,0,0,[["(?:2(?:04|[23]6|[48]9|50)|3(?:06|43|6[57])|4(?:03|1[68]|3[178]|50)|5(?:06|1[49]|48|79|8[17])|6(?:04|13|39|47|72)|7(?:0[59]|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}"],[""],["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"],["900[2-9]\\d{6}"],["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[12]|33|44|66|77|88)|622)[2-9]\\d{6}"],0,0,0,["600[2-9]\\d{6}"]]],"CC":["61","001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","1(?:[0-79]\\d|8[0-24-9])\\d{7}|[148]\\d{8}|1\\d{5,7}",[6,7,8,9,10],0,"0",0,"0|([59]\\d{7})$","8$1",0,0,[["8(?:51(?:0(?:02|31|60|89)|118)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}",[9]],["4(?:83[0-38]|93[0-4])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}",[9]],["180(?:0\\d{3}|2)\\d{3}",[7,10]],["190[0-26]\\d{6}",[10]],0,0,0,0,["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",[9]],["13(?:00\\d{3}|45[0-4])\\d{3}|13\\d{4}",[6,8,10]]],"0011"],"CD":["243","00","[189]\\d{8}|[1-68]\\d{6}",[7,9],[["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["88"],"0$1"],["(\\d{2})(\\d{5})","$1 $2",["[1-6]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[89]"],"0$1"]],"0"],"CF":["236","00","(?:[27]\\d{3}|8776)\\d{4}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[278]"]]]],"CG":["242","00","222\\d{6}|(?:0\\d|80)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["801"]],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["8"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[02]"]]]],"CH":["41","00","8\\d{11}|[2-9]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8[047]|90"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-79]|81"],"0$1"],["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["8"],"0$1"]],"0"],"CI":["225","00","[02]\\d{9}|[02-9]\\d{7}",[8,10],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[03-9]|2(?:[02-4]|1[023578])","[03-9]|2(?:[02-4]|1(?:[02357]|80))"]],["(\\d{2})(\\d{2})(\\d)(\\d{5})","$1 $2 $3 $4",["2"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3 $4",["0"]]]],"CK":["682","00","[2-578]\\d{4}",[5],[["(\\d{2})(\\d{3})","$1 $2",["[2-578]"]]]],"CL":["56","(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0","12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",[9,10,11],[["(\\d{5})(\\d{4})","$1 $2",["219","2196"],"($1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["44"]],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2[1-3]"],"($1)"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["9[2-9]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"],"($1)"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["60|8"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]],["(\\d{3})(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3 $4",["60"]]]],"CM":["237","00","(?:[26]\\d\\d|88)\\d{6}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["88"]],["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[26]"]]]],"CN":["86","00|1(?:[12]\\d|79)\\d\\d00","1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}",[7,8,9,10,11,12],[["(\\d{2})(\\d{5,6})","$1 $2",["(?:10|2[0-57-9])[19]","(?:10|2[0-57-9])(?:10|9[56])","(?:10|2[0-57-9])(?:100|9[56])"],"0$1"],["(\\d{3})(\\d{5,6})","$1 $2",["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]","(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]","85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])","85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["(?:4|80)0"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["10|2(?:[02-57-9]|1[1-9])","10|2(?:[02-57-9]|1[1-9])","10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"],"0$1",1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"],"0$1",1],["(\\d{3})(\\d{7,8})","$1 $2",["9"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["80"],"0$1",1],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["[3-578]"],"0$1",1],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["1[3-9]"]],["(\\d{2})(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3 $4",["[12]"],"0$1",1]],"0",0,"0|(1(?:[12]\\d|79)\\d\\d)",0,0,0,0,"00"],"CO":["57","00(?:4(?:[14]4|56)|[579])","(?:1\\d|3)\\d{9}|[124-8]\\d{7}",[8,10,11],[["(\\d)(\\d{7})","$1 $2",["[14][2-9]|[25-8]"],"($1)"],["(\\d{3})(\\d{7})","$1 $2",["3"]],["(\\d)(\\d{3})(\\d{7})","$1-$2-$3",["1"],"0$1",0,"$1 $2 $3"]],"0",0,"0([3579]|4(?:[14]4|56))?"],"CR":["506","00","(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}",[8,10],[["(\\d{4})(\\d{4})","$1 $2",["[2-7]|8[3-9]"]],["(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["[89]"]]],0,0,"(19(?:0[0-2468]|1[09]|20|66|77|99))"],"CU":["53","119","[27]\\d{6,7}|[34]\\d{5,7}|(?:5|8\\d\\d)\\d{7}",[6,7,8,10],[["(\\d{2})(\\d{4,6})","$1 $2",["2[1-4]|[34]"],"(0$1)"],["(\\d)(\\d{6,7})","$1 $2",["7"],"(0$1)"],["(\\d)(\\d{7})","$1 $2",["5"],"0$1"],["(\\d{3})(\\d{7})","$1 $2",["8"],"0$1"]],"0"],"CV":["238","0","(?:[2-59]\\d\\d|800)\\d{4}",[7],[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[2-589]"]]]],"CW":["599","00","(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["[3467]"]],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["9[4-8]"]]],0,0,0,0,0,"[69]"],"CX":["61","001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","1(?:[0-79]\\d|8[0-24-9])\\d{7}|[148]\\d{8}|1\\d{5,7}",[6,7,8,9,10],0,"0",0,"0|([59]\\d{7})$","8$1",0,0,[["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|235)|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",[9]],["4(?:83[0-38]|93[0-4])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}",[9]],["180(?:0\\d{3}|2)\\d{3}",[7,10]],["190[0-26]\\d{6}",[10]],0,0,0,0,["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",[9]],["13(?:00\\d{3}|45[0-4])\\d{3}|13\\d{4}",[6,8,10]]],"0011"],"CY":["357","00","(?:[279]\\d|[58]0)\\d{6}",[8],[["(\\d{2})(\\d{6})","$1 $2",["[257-9]"]]]],"CZ":["420","00","(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[2-8]|9[015-7]"]],["(\\d{2})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]],["(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]]]],"DE":["49","00","[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:[12]\\d|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[05]\\d|31|[46][1-8])\\d{1,9}",[4,5,6,7,8,9,10,11,12,13,14,15],[["(\\d{2})(\\d{3,13})","$1 $2",["3[02]|40|[68]9"],"0$1"],["(\\d{3})(\\d{3,12})","$1 $2",["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1","2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"],"0$1"],["(\\d{4})(\\d{2,11})","$1 $2",["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]","[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"],"0$1"],["(\\d{3})(\\d{4})","$1 $2",["138"],"0$1"],["(\\d{5})(\\d{2,10})","$1 $2",["3"],"0$1"],["(\\d{3})(\\d{5,11})","$1 $2",["181"],"0$1"],["(\\d{3})(\\d)(\\d{4,10})","$1 $2 $3",["1(?:3|80)|9"],"0$1"],["(\\d{3})(\\d{7,8})","$1 $2",["1[67]"],"0$1"],["(\\d{3})(\\d{7,12})","$1 $2",["8"],"0$1"],["(\\d{5})(\\d{6})","$1 $2",["185","1850","18500"],"0$1"],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["7"],"0$1"],["(\\d{4})(\\d{7})","$1 $2",["18[68]"],"0$1"],["(\\d{5})(\\d{6})","$1 $2",["15[0568]"],"0$1"],["(\\d{4})(\\d{7})","$1 $2",["15[1279]"],"0$1"],["(\\d{3})(\\d{8})","$1 $2",["18"],"0$1"],["(\\d{3})(\\d{2})(\\d{7,8})","$1 $2 $3",["1(?:6[023]|7)"],"0$1"],["(\\d{4})(\\d{2})(\\d{7})","$1 $2 $3",["15[279]"],"0$1"],["(\\d{3})(\\d{2})(\\d{8})","$1 $2 $3",["15"],"0$1"]],"0"],"DJ":["253","00","(?:2\\d|77)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[27]"]]]],"DK":["45","00","[2-9]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-9]"]]]],"DM":["1","011","(?:[58]\\d\\d|767|900)\\d{7}",[10],0,"1",0,"1|([2-7]\\d{6})$","767$1",0,"767"],"DO":["1","011","(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,0,0,0,"8001|8[024]9"],"DZ":["213","00","(?:[1-4]|[5-79]\\d|80)\\d{7}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[1-4]"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["9"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-8]"],"0$1"]],"0"],"EC":["593","00","1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}",[8,9,10,11],[["(\\d)(\\d{3})(\\d{4})","$1 $2-$3",["[2-7]"],"(0$1)",0,"$1-$2-$3"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["9"],"0$1"],["(\\d{4})(\\d{3})(\\d{3,4})","$1 $2 $3",["1"]]],"0"],"EE":["372","00","8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}",[7,8,10],[["(\\d{3})(\\d{4})","$1 $2",["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88","[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]],["(\\d{4})(\\d{3,4})","$1 $2",["[45]|8(?:00|[1-49])","[45]|8(?:00[1-9]|[1-49])"]],["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["7"]],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["8"]]]],"EG":["20","00","[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",[8,9,10],[["(\\d)(\\d{7,8})","$1 $2",["[23]"],"0$1"],["(\\d{2})(\\d{6,7})","$1 $2",["1[35]|[4-6]|8[2468]|9[235-7]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[189]"],"0$1"]],"0"],"EH":["212","00","[5-8]\\d{8}",[9],0,"0",0,0,0,0,"528[89]"],"ER":["291","00","[178]\\d{6}",[7],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[178]"],"0$1"]],"0"],"ES":["34","00","[5-9]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[89]00"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-9]"]]]],"ET":["251","00","(?:11|[2-59]\\d)\\d{7}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-59]"],"0$1"]],"0"],"FI":["358","00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))","[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}",[5,6,7,8,9,10,11,12],[["(\\d)(\\d{4,9})","$1 $2",["[2568][1-8]|3(?:0[1-9]|[1-9])|9"],"0$1"],["(\\d{3})(\\d{3,7})","$1 $2",["[12]00|[368]|70[07-9]"],"0$1"],["(\\d{2})(\\d{4,8})","$1 $2",["[1245]|7[135]"],"0$1"],["(\\d{2})(\\d{6,10})","$1 $2",["7"],"0$1"]],"0",0,0,0,0,"1[03-79]|[2-9]",0,"00"],"FJ":["679","0(?:0|52)","45\\d{5}|(?:0800\\d|[235-9])\\d{6}",[7,11],[["(\\d{3})(\\d{4})","$1 $2",["[235-9]|45"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["0"]]],0,0,0,0,0,0,0,"00"],"FK":["500","00","[2-7]\\d{4}",[5]],"FM":["691","00","(?:[39]\\d\\d|820)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[389]"]]]],"FO":["298","00","[2-9]\\d{5}",[6],[["(\\d{6})","$1",["[2-9]"]]],0,0,"(10(?:01|[12]0|88))"],"FR":["33","00","[1-9]\\d{8}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0 $1"],["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[1-79]"],"0$1"]],"0"],"GA":["241","00","(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}",[7,8],[["(\\d)(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-7]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["11|[67]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["0"]]],0,0,"0(11\\d{6}|6[256]\\d{6}|7[47]\\d{6})","$1"],"GB":["44","00","[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",[7,9,10],[["(\\d{3})(\\d{4})","$1 $2",["800","8001","80011","800111","8001111"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["845","8454","84546","845464"],"0$1"],["(\\d{3})(\\d{6})","$1 $2",["800"],"0$1"],["(\\d{5})(\\d{4,5})","$1 $2",["1(?:38|5[23]|69|76|94)","1(?:(?:38|69)7|5(?:24|39)|768|946)","1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"],"0$1"],["(\\d{4})(\\d{5,6})","$1 $2",["1(?:[2-69][02-9]|[78])"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["[25]|7(?:0|6[02-9])","[25]|7(?:0|6(?:[03-9]|2[356]))"],"0$1"],["(\\d{4})(\\d{6})","$1 $2",["7"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[1389]"],"0$1"]],"0",0,0,0,0,0,[["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[03])|4(?:[0-5]\\d\\d|69[7-9])|(?:5[0-26-9]|6[0-4]|[78][0-49])\\d\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[02]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",[9,10]],["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}",[10]],["80[08]\\d{7}|800\\d{6}|8001111"],["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d",[7,10]],["70\\d{8}",[10]],0,["(?:3[0347]|55)\\d{8}",[10]],["76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|81|9[139])\\d{6}",[10]],["56\\d{8}",[10]]],0," x"],"GD":["1","011","(?:473|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2-9]\\d{6})$","473$1",0,"473"],"GE":["995","00","(?:[3-57]\\d\\d|800)\\d{6}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["70"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["32"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[57]"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[348]"],"0$1"]],"0"],"GF":["594","00","(?:[56]94|976)\\d{6}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[569]"],"0$1"]],"0"],"GG":["44","00","(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",[7,9,10],0,"0",0,"0|([25-9]\\d{5})$","1481$1",0,0,[["1481[25-9]\\d{5}",[10]],["7(?:(?:781|839)\\d|911[17])\\d{5}",[10]],["80[08]\\d{7}|800\\d{6}|8001111"],["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d",[7,10]],["70\\d{8}",[10]],0,["(?:3[0347]|55)\\d{8}",[10]],["76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|81|9[139])\\d{6}",[10]],["56\\d{8}",[10]]]],"GH":["233","00","(?:[235]\\d{3}|800)\\d{5}",[8,9],[["(\\d{3})(\\d{5})","$1 $2",["8"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[235]"],"0$1"]],"0"],"GI":["350","00","(?:[25]\\d\\d|606)\\d{5}",[8],[["(\\d{3})(\\d{5})","$1 $2",["2"]]]],"GL":["299","00","(?:19|[2-689]\\d)\\d{4}",[6],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["19|[2-689]"]]]],"GM":["220","00","[2-9]\\d{6}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-9]"]]]],"GN":["224","00","722\\d{6}|(?:3|6\\d)\\d{7}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["3"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[67]"]]]],"GP":["590","00","(?:590|69\\d|976)\\d{6}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[569]"],"0$1"]],"0",0,0,0,0,0,[["590(?:0[1-68]|1[0-2]|2[0-68]|3[1289]|4[0-24-9]|5[3-579]|6[0189]|7[08]|8[0-689]|9\\d)\\d{4}"],["69(?:0\\d\\d|1(?:2[29]|3[0-5]))\\d{4}"],0,0,0,0,0,0,["976[01]\\d{5}"]]],"GQ":["240","00","222\\d{6}|(?:3\\d|55|[89]0)\\d{7}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[235]"]],["(\\d{3})(\\d{6})","$1 $2",["[89]"]]]],"GR":["30","00","5005000\\d{3}|8\\d{9,10}|(?:[269]\\d|70)\\d{8}",[10,11],[["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["21|7"]],["(\\d{4})(\\d{6})","$1 $2",["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[2689]"]],["(\\d{3})(\\d{3})(\\d{5})","$1 $2 $3",["8"]]]],"GT":["502","00","(?:1\\d{3}|[2-7])\\d{7}",[8,11],[["(\\d{4})(\\d{4})","$1 $2",["[2-7]"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]]]],"GU":["1","011","(?:[58]\\d\\d|671|900)\\d{7}",[10],0,"1",0,"1|([3-9]\\d{6})$","671$1",0,"671"],"GW":["245","00","[49]\\d{8}|4\\d{6}",[7,9],[["(\\d{3})(\\d{4})","$1 $2",["40"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[49]"]]]],"GY":["592","001","(?:862\\d|9008)\\d{3}|(?:[2-46]\\d|77)\\d{5}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-46-9]"]]]],"HK":["852","00(?:30|5[09]|[126-9]?)","8[0-46-9]\\d{6,7}|9\\d{4}(?:\\d(?:\\d(?:\\d{4})?)?)?|(?:[235-79]\\d|46)\\d{6}",[5,6,7,8,9,11],[["(\\d{3})(\\d{2,5})","$1 $2",["900","9003"]],["(\\d{4})(\\d{4})","$1 $2",["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"]],["(\\d{3})(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]]],0,0,0,0,0,0,0,"00"],"HN":["504","00","8\\d{10}|[237-9]\\d{7}",[8,11],[["(\\d{4})(\\d{4})","$1-$2",["[237-9]"]]]],"HR":["385","00","(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}",[6,7,8,9],[["(\\d{2})(\\d{2})(\\d{2,3})","$1 $2 $3",["6[01]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["8"],"0$1"],["(\\d)(\\d{4})(\\d{3})","$1 $2 $3",["1"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[67]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["9"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-5]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"],"0$1"]],"0"],"HT":["509","00","[2-489]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[2-489]"]]]],"HU":["36","00","[235-7]\\d{8}|[1-9]\\d{7}",[8,9],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["1"],"(06 $1)"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"],"(06 $1)"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-9]"],"06 $1"]],"06"],"ID":["62","00[89]","(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}",[7,8,9,10,11,12,13],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["15"]],["(\\d{2})(\\d{5,9})","$1 $2",["2[124]|[36]1"],"(0$1)"],["(\\d{3})(\\d{5,7})","$1 $2",["800"],"0$1"],["(\\d{3})(\\d{5,8})","$1 $2",["[2-79]"],"(0$1)"],["(\\d{3})(\\d{3,4})(\\d{3})","$1-$2-$3",["8[1-35-9]"],"0$1"],["(\\d{3})(\\d{6,8})","$1 $2",["1"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["804"],"0$1"],["(\\d{3})(\\d)(\\d{3})(\\d{3})","$1 $2 $3 $4",["80"],"0$1"],["(\\d{3})(\\d{4})(\\d{4,5})","$1-$2-$3",["8"],"0$1"]],"0"],"IE":["353","00","(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",[7,8,9,10],[["(\\d{2})(\\d{5})","$1 $2",["2[24-9]|47|58|6[237-9]|9[35-9]"],"(0$1)"],["(\\d{3})(\\d{5})","$1 $2",["[45]0"],"(0$1)"],["(\\d)(\\d{3,4})(\\d{4})","$1 $2 $3",["1"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2569]|4[1-69]|7[14]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["70"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["81"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[78]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["4"],"(0$1)"],["(\\d{2})(\\d)(\\d{3})(\\d{4})","$1 $2 $3 $4",["8"],"0$1"]],"0"],"IL":["972","0(?:0|1[2-9])","1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",[7,8,9,10,11,12],[["(\\d{4})(\\d{3})","$1-$2",["125"]],["(\\d{4})(\\d{2})(\\d{2})","$1-$2-$3",["121"]],["(\\d)(\\d{3})(\\d{4})","$1-$2-$3",["[2-489]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["[57]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1-$2-$3",["12"]],["(\\d{4})(\\d{6})","$1-$2",["159"]],["(\\d)(\\d{3})(\\d{3})(\\d{3})","$1-$2-$3-$4",["1[7-9]"]],["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})","$1-$2 $3-$4",["15"]]],"0"],"IM":["44","00","1624\\d{6}|(?:[3578]\\d|90)\\d{8}",[10],0,"0",0,"0|([5-8]\\d{5})$","1624$1",0,"74576|(?:16|7[56])24"],"IN":["91","00","(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}",[8,9,10,11,12,13],[["(\\d{8})","$1",["5(?:0|2[23]|3[03]|[67]1|88)","5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)","5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"],0,1],["(\\d{4})(\\d{4,5})","$1 $2",["180","1800"],0,1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["140"],0,1],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["11|2[02]|33|4[04]|79[1-7]|80[2-46]","11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])","11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"],"0$1",1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]","1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]","1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"],"0$1",1],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807","1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]","1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"],"0$1",1],["(\\d{5})(\\d{5})","$1 $2",["[6-9]"],"0$1",1],["(\\d{4})(\\d{2,4})(\\d{4})","$1 $2 $3",["1(?:6|8[06])","1(?:6|8[06]0)"],0,1],["(\\d{4})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["18"],0,1]],"0"],"IO":["246","00","3\\d{6}",[7],[["(\\d{3})(\\d{4})","$1 $2",["3"]]]],"IQ":["964","00","(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",[8,9,10],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-6]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"]],"0"],"IR":["98","00","[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}",[4,5,6,7,10],[["(\\d{4,5})","$1",["96"],"0$1"],["(\\d{2})(\\d{4,5})","$1 $2",["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["9"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["[1-8]"],"0$1"]],"0"],"IS":["354","00|1(?:0(?:01|[12]0)|100)","(?:38\\d|[4-9])\\d{6}",[7,9],[["(\\d{3})(\\d{4})","$1 $2",["[4-9]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["3"]]],0,0,0,0,0,0,0,"00"],"IT":["39","00","0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",[6,7,8,9,10,11],[["(\\d{2})(\\d{4,6})","$1 $2",["0[26]"]],["(\\d{3})(\\d{3,6})","$1 $2",["0[13-57-9][0159]|8(?:03|4[17]|9[245])","0[13-57-9][0159]|8(?:03|4[17]|9(?:2|[45][0-4]))"]],["(\\d{4})(\\d{2,6})","$1 $2",["0(?:[13-579][2-46-8]|8[236-8])"]],["(\\d{4})(\\d{4})","$1 $2",["894"]],["(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[26]|5"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["1[4679]|[38]"]],["(\\d{3})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[13-57-9][0159]"]],["(\\d{2})(\\d{4})(\\d{5})","$1 $2 $3",["0[26]"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["0"]],["(\\d{3})(\\d{4})(\\d{4,5})","$1 $2 $3",["3"]]],0,0,0,0,0,0,[["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"],["3[1-9]\\d{8}|3[2-9]\\d{7}",[9,10]],["80(?:0\\d{3}|3)\\d{3}",[6,9]],["(?:0878\\d\\d|89(?:2|4[5-9]\\d))\\d{3}|89[45][0-4]\\d\\d|(?:1(?:44|6[346])|89(?:5[5-9]|9))\\d{6}",[6,8,9,10]],["1(?:78\\d|99)\\d{6}",[9,10]],0,0,0,["55\\d{8}",[10]],["84(?:[08]\\d{3}|[17])\\d{3}",[6,9]]]],"JE":["44","00","1534\\d{6}|(?:[3578]\\d|90)\\d{8}",[10],0,"0",0,"0|([0-24-8]\\d{5})$","1534$1",0,0,[["1534[0-24-8]\\d{5}"],["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}"],["80(?:07(?:35|81)|8901)\\d{4}"],["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"],["701511\\d{4}"],0,["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"],["76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|81|9[139])\\d{6}"],["56\\d{8}"]]],"JM":["1","011","(?:[58]\\d\\d|658|900)\\d{7}",[10],0,"1",0,0,0,0,"658|876"],"JO":["962","00","(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}",[8,9],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2356]|87"],"(0$1)"],["(\\d{3})(\\d{5,6})","$1 $2",["[89]"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["70"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["7"],"0$1"]],"0"],"JP":["81","010","00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}",[8,9,10,11,12,13,14,15,16,17],[["(\\d{3})(\\d{3})(\\d{3})","$1-$2-$3",["(?:12|57|99)0"],"0$1"],["(\\d{4})(\\d)(\\d{4})","$1-$2-$3",["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51|63)|9(?:49|80|9[16])","1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9]|636)|9(?:496|802|9(?:1[23]|69))|1(?:45|58)[67]","1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9]|636[457-9])|9(?:496|802|9(?:1[23]|69))|1(?:45|58)[67]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["60"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1-$2-$3",["[36]|4(?:2[09]|7[01])","[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[27-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])","1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9])|5(?:2|3[045]|4[0-369]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|49|51|6(?:[0-24]|36|5[0-3589]|72|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:49|55|83)[29]|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]","1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]","1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|7[015-9]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17|3[015-9]))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9(?:[019]|4[1-3]|6(?:[0-47-9]|5[01346-9])))|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|829(?:2|66)|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"],"0$1"],["(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3",["[14]|[289][2-9]|5[3-9]|7[2-4679]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["800"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[257-9]"],"0$1"]],"0"],"KE":["254","000","(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}",[7,8,9,10],[["(\\d{2})(\\d{5,7})","$1 $2",["[24-6]"],"0$1"],["(\\d{3})(\\d{6})","$1 $2",["[17]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[89]"],"0$1"]],"0"],"KG":["996","00","8\\d{9}|(?:[235-8]\\d|99)\\d{7}",[9,10],[["(\\d{4})(\\d{5})","$1 $2",["3(?:1[346]|[24-79])"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[235-79]|88"],"0$1"],["(\\d{3})(\\d{3})(\\d)(\\d{2,3})","$1 $2 $3 $4",["8"],"0$1"]],"0"],"KH":["855","00[14-9]","1\\d{9}|[1-9]\\d{7,8}",[8,9,10],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-9]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],"0"],"KI":["686","00","(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}",[5,8],0,"0"],"KM":["269","00","[3478]\\d{6}",[7],[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[3478]"]]]],"KN":["1","011","(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2-7]\\d{6})$","869$1",0,"869"],"KP":["850","00|99","85\\d{6}|(?:19\\d|[2-7])\\d{7}",[8,10],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["8"],"0$1"],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2-7]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"]],"0"],"KR":["82","00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))","00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}",[5,6,8,9,10,11,12,13,14],[["(\\d{2})(\\d{3,4})","$1-$2",["(?:3[1-3]|[46][1-4]|5[1-5])1"],"0$1"],["(\\d{4})(\\d{4})","$1-$2",["1"]],["(\\d)(\\d{3,4})(\\d{4})","$1-$2-$3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["60|8"],"0$1"],["(\\d{2})(\\d{3,4})(\\d{4})","$1-$2-$3",["[1346]|5[1-5]"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[57]"],"0$1"],["(\\d{2})(\\d{5})(\\d{4})","$1-$2-$3",["5"],"0$1"]],"0",0,"0(8(?:[1-46-8]|5\\d\\d))?"],"KW":["965","00","(?:18|[2569]\\d\\d)\\d{5}",[7,8],[["(\\d{4})(\\d{3,4})","$1 $2",["[169]|2(?:[235]|4[1-35-9])|52"]],["(\\d{3})(\\d{5})","$1 $2",["[25]"]]]],"KY":["1","011","(?:345|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2-9]\\d{6})$","345$1",0,"345"],"KZ":["7","810","33622\\d{5}|(?:7\\d|80)\\d{8}",[10],0,"8",0,0,0,0,"33|7",0,"8~10"],"LA":["856","00","[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}",[8,9,10],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["2[13]|3[14]|[4-8]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["30[013-9]"],"0$1"],["(\\d{2})(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3 $4",["[23]"],"0$1"]],"0"],"LB":["961","00","[7-9]\\d{7}|[13-9]\\d{6}",[7,8],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[7-9]"]]],"0"],"LC":["1","011","(?:[58]\\d\\d|758|900)\\d{7}",[10],0,"1",0,"1|([2-8]\\d{6})$","758$1",0,"758"],"LI":["423","00","90\\d{5}|(?:[2378]|6\\d\\d)\\d{6}",[7,9],[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[237-9]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["69"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"]]],"0",0,"0|(1001)"],"LK":["94","00","[1-9]\\d{8}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[1-689]"],"0$1"]],"0"],"LR":["231","00","(?:2|33|5\\d|77|88)\\d{7}|[4-6]\\d{6}",[7,8,9],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[4-6]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[3578]"],"0$1"]],"0"],"LS":["266","00","(?:[256]\\d\\d|800)\\d{5}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[2568]"]]]],"LT":["370","00","(?:[3469]\\d|52|[78]0)\\d{6}",[8],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["52[0-7]"],"(8-$1)",1],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[7-9]"],"8 $1",1],["(\\d{2})(\\d{6})","$1 $2",["37|4(?:[15]|6[1-8])"],"(8-$1)",1],["(\\d{3})(\\d{5})","$1 $2",["[3-6]"],"(8-$1)",1]],"8",0,"[08]"],"LU":["352","00","35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}",[4,5,6,7,8,9,10,11],[["(\\d{2})(\\d{3})","$1 $2",["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]],["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["20[2-689]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})","$1 $2 $3 $4",["2(?:[0367]|4[3-8])"]],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["80[01]|90[015]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["20"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})","$1 $2 $3 $4 $5",["2(?:[0367]|4[3-8])"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})","$1 $2 $3 $4",["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]],0,0,"(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"],"LV":["371","00","(?:[268]\\d|90)\\d{6}",[8],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[269]|8[01]"]]]],"LY":["218","00","[2-9]\\d{8}",[9],[["(\\d{2})(\\d{7})","$1-$2",["[2-9]"],"0$1"]],"0"],"MA":["212","00","[5-8]\\d{8}",[9],[["(\\d{5})(\\d{4})","$1-$2",["5(?:29|38)","5(?:29|38)[89]","5(?:29|38)[89]0"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5[45]"],"0$1"],["(\\d{4})(\\d{5})","$1-$2",["5(?:2[2-489]|3[5-9]|9)|892","5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|892"],"0$1"],["(\\d{2})(\\d{7})","$1-$2",["8"],"0$1"],["(\\d{3})(\\d{6})","$1-$2",["[5-7]"],"0$1"]],"0",0,0,0,0,0,[["5(?:29(?:[189][05]|2[29]|3[01])|38[89][05])\\d{4}|5(?:2(?:[015-7]\\d|2[02-9]|3[0-578]|4[02-46-8]|8[0235-7]|90)|3(?:[0-47]\\d|5[02-9]|6[02-8]|80|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"],["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:0[0-8]|6[1267]|7[0-37]))\\d{6}"],["80\\d{7}"],["89\\d{7}"],0,0,0,0,["592(?:4[0-2]|93)\\d{4}"]]],"MC":["377","00","870\\d{5}|(?:[349]|6\\d)\\d{7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["4"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[39]"]],["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["6"],"0$1"]],"0"],"MD":["373","00","(?:[235-7]\\d|[89]0)\\d{6}",[8],[["(\\d{3})(\\d{5})","$1 $2",["[89]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["22|3"],"0$1"],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[25-7]"],"0$1"]],"0"],"ME":["382","00","(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-9]"],"0$1"]],"0"],"MF":["590","00","(?:590|69\\d|976)\\d{6}",[9],0,"0",0,0,0,0,0,[["590(?:0[079]|[14]3|[27][79]|30|5[0-268]|87)\\d{4}"],["69(?:0\\d\\d|1(?:2[29]|3[0-5]))\\d{4}"],0,0,0,0,0,0,["976[01]\\d{5}"]]],"MG":["261","00","[23]\\d{8}",[9],[["(\\d{2})(\\d{2})(\\d{3})(\\d{2})","$1 $2 $3 $4",["[23]"],"0$1"]],"0",0,"0|([24-9]\\d{6})$","20$1"],"MH":["692","011","329\\d{4}|(?:[256]\\d|45)\\d{5}",[7],[["(\\d{3})(\\d{4})","$1-$2",["[2-6]"]]],"1"],"MK":["389","00","[2-578]\\d{7}",[8],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[347]"],"0$1"],["(\\d{3})(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["[58]"],"0$1"]],"0"],"ML":["223","00","[24-9]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24-9]"]]]],"MM":["95","00","1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}",[6,7,8,9,10],[["(\\d)(\\d{2})(\\d{3})","$1 $2 $3",["16|2"],"0$1"],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"],"0$1"],["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[12]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[4-7]|8[1-35]"],"0$1"],["(\\d)(\\d{3})(\\d{4,6})","$1 $2 $3",["9(?:2[0-4]|[35-9]|4[137-9])"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"],["(\\d)(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["92"],"0$1"],["(\\d)(\\d{5})(\\d{4})","$1 $2 $3",["9"],"0$1"]],"0"],"MN":["976","001","[12]\\d{7,9}|[57-9]\\d{7}",[8,9,10],[["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[12]1"],"0$1"],["(\\d{4})(\\d{4})","$1 $2",["[57-9]"]],["(\\d{3})(\\d{5,6})","$1 $2",["[12]2[1-3]"],"0$1"],["(\\d{4})(\\d{5,6})","$1 $2",["[12](?:27|3[2-8]|4[2-68]|5[1-4689])","[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"],"0$1"],["(\\d{5})(\\d{4,5})","$1 $2",["[12]"],"0$1"]],"0"],"MO":["853","00","(?:28|[68]\\d)\\d{6}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[268]"]]]],"MP":["1","011","[58]\\d{9}|(?:67|90)0\\d{7}",[10],0,"1",0,"1|([2-9]\\d{6})$","670$1",0,"670"],"MQ":["596","00","69\\d{7}|(?:59|97)6\\d{6}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[569]"],"0$1"]],"0"],"MR":["222","00","(?:[2-4]\\d\\d|800)\\d{5}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-48]"]]]],"MS":["1","011","(?:[58]\\d\\d|664|900)\\d{7}",[10],0,"1",0,"1|([34]\\d{6})$","664$1",0,"664"],"MT":["356","00","3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[2357-9]"]]]],"MU":["230","0(?:0|[24-7]0|3[03])","(?:[2-468]|5\\d)\\d{6}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["[2-46]|8[013]"]],["(\\d{4})(\\d{4})","$1 $2",["5"]]],0,0,0,0,0,0,0,"020"],"MV":["960","0(?:0|19)","(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}",[7,10],[["(\\d{3})(\\d{4})","$1-$2",["[3467]|9[13-9]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[89]"]]],0,0,0,0,0,0,0,"00"],"MW":["265","00","1\\d{6}(?:\\d{2})?|(?:[23]1|77|88|99)\\d{7}",[7,9],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["1[2-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["2"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[137-9]"],"0$1"]],"0"],"MX":["52","0[09]","(?:1(?:[01467]\\d|[2359][1-9]|8[1-79])|[2-9]\\d)\\d{8}",[10,11],[["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["33|5[56]|81"],0,1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[2-9]"],0,1],["(\\d)(\\d{2})(\\d{4})(\\d{4})","$2 $3 $4",["1(?:33|5[56]|81)"],0,1],["(\\d)(\\d{3})(\\d{3})(\\d{4})","$2 $3 $4",["1"],0,1]],"01",0,"0(?:[12]|4[45])|1",0,0,0,0,"00"],"MY":["60","00","1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",[8,9,10],[["(\\d)(\\d{3})(\\d{4})","$1-$2 $3",["[4-79]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1-$2 $3",["1(?:[02469]|[378][1-9])|8"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1-$2 $3",["3"],"0$1"],["(\\d)(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3-$4",["1[36-8]"]],["(\\d{3})(\\d{3})(\\d{4})","$1-$2 $3",["15"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1-$2 $3",["1"],"0$1"]],"0"],"MZ":["258","00","(?:2|8\\d)\\d{7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["2|8[2-79]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"]]]],"NA":["264","00","[68]\\d{7,8}",[8,9],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["88"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["6"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["87"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"]],"0"],"NC":["687","00","[2-57-9]\\d{5}",[6],[["(\\d{2})(\\d{2})(\\d{2})","$1.$2.$3",["[2-57-9]"]]]],"NE":["227","00","[027-9]\\d{7}",[8],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["08"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[089]|2[013]|7[04]"]]]],"NF":["672","00","[13]\\d{5}",[6],[["(\\d{2})(\\d{4})","$1 $2",["1[0-3]"]],["(\\d)(\\d{5})","$1 $2",["[13]"]]],0,0,"([0-258]\\d{4})$","3$1"],"NG":["234","009","(?:[124-7]|9\\d{3})\\d{6}|[1-9]\\d{7}|[78]\\d{9,13}",[7,8,10,11,12,13,14],[["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["78"],"0$1"],["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[12]|9(?:0[3-9]|[1-9])"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["[3-7]|8[2-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[7-9]"],"0$1"],["(\\d{3})(\\d{4})(\\d{4,5})","$1 $2 $3",["[78]"],"0$1"],["(\\d{3})(\\d{5})(\\d{5,6})","$1 $2 $3",["[78]"],"0$1"]],"0"],"NI":["505","00","(?:1800|[25-8]\\d{3})\\d{4}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[125-8]"]]]],"NL":["31","00","(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|[89]\\d{6,9}|1\\d{4,5}",[5,6,7,8,9,10],[["(\\d{3})(\\d{4,7})","$1 $2",["[89]0"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["66"],"0$1"],["(\\d)(\\d{8})","$1 $2",["6"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-57-9]"],"0$1"]],"0"],"NO":["47","00","(?:0|[2-9]\\d{3})\\d{4}",[5,8],[["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[489]|5[89]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[235-7]"]]],0,0,0,0,0,"[02-689]|7[0-8]"],"NP":["977","00","(?:1\\d|9)\\d{9}|[1-9]\\d{7}",[8,10,11],[["(\\d)(\\d{7})","$1-$2",["1[2-6]"],"0$1"],["(\\d{2})(\\d{6})","$1-$2",["1[01]|[2-8]|9(?:[1-579]|6[2-6])"],"0$1"],["(\\d{3})(\\d{7})","$1-$2",["9"]]],"0"],"NR":["674","00","(?:444|(?:55|8\\d)\\d|666)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[4-68]"]]]],"NU":["683","00","(?:[47]|888\\d)\\d{3}",[4,7],[["(\\d{3})(\\d{4})","$1 $2",["8"]]]],"NZ":["64","0(?:0|161)","[29]\\d{7,9}|50\\d{5}(?:\\d{2,3})?|6[0-35-9]\\d{6}|7\\d{7,8}|8\\d{4,9}|(?:11\\d|[34])\\d{7}",[5,6,7,8,9,10],[["(\\d{2})(\\d{3,8})","$1 $2",["8[1-579]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["50[036-8]|[89]0","50(?:[0367]|88)|[89]0"],"0$1"],["(\\d)(\\d{3})(\\d{4})","$1-$2 $3",["24|[346]|7[2-57-9]|9[2-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["2(?:10|74)|[59]|80"],"0$1"],["(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["1|2[028]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,5})","$1 $2 $3",["2(?:[169]|7[0-35-9])|7|86"],"0$1"]],"0",0,0,0,0,0,0,"00"],"OM":["968","00","(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}",[7,8,9],[["(\\d{3})(\\d{4,6})","$1 $2",["[58]"]],["(\\d{2})(\\d{6})","$1 $2",["2"]],["(\\d{4})(\\d{4})","$1 $2",["[179]"]]]],"PA":["507","00","8\\d{9}|[68]\\d{7}|[1-57-9]\\d{6}",[7,8,10],[["(\\d{3})(\\d{4})","$1-$2",["[1-57-9]"]],["(\\d{4})(\\d{4})","$1-$2",["[68]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]]]],"PE":["51","19(?:1[124]|77|90)00","(?:[14-8]|9\\d)\\d{7}",[8,9],[["(\\d{3})(\\d{5})","$1 $2",["80"],"(0$1)"],["(\\d)(\\d{7})","$1 $2",["1"],"(0$1)"],["(\\d{2})(\\d{6})","$1 $2",["[4-8]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"]]],"0",0,0,0,0,0,0,0," Anexo "],"PF":["689","00","[48]\\d{7}|4\\d{5}",[6,8],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["44"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[48]"]]]],"PG":["675","00|140[1-3]","(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["18|[2-69]|85"]],["(\\d{4})(\\d{4})","$1 $2",["[78]"]]],0,0,0,0,0,0,0,"00"],"PH":["63","00","1800\\d{7,9}|(?:2|[89]\\d{4})\\d{5}|[2-8]\\d{8}|[28]\\d{7}",[6,8,9,10,11,12,13],[["(\\d)(\\d{5})","$1 $2",["2"],"(0$1)"],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["2"],"(0$1)"],["(\\d{4})(\\d{4,6})","$1 $2",["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2","3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"],"(0$1)"],["(\\d{5})(\\d{4})","$1 $2",["346|4(?:27|9[35])|883","3469|4(?:279|9(?:30|56))|8834"],"(0$1)"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[3-7]|8[2-8]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[89]"],"0$1"],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]],["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})","$1 $2 $3 $4",["1"]]],"0"],"PK":["92","00","122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",[8,9,10,11,12],[["(\\d{3})(\\d{3})(\\d{2,7})","$1 $2 $3",["[89]0"],"0$1"],["(\\d{4})(\\d{5})","$1 $2",["1"]],["(\\d{3})(\\d{6,7})","$1 $2",["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])","9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"],"(0$1)"],["(\\d{2})(\\d{7,8})","$1 $2",["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"],"(0$1)"],["(\\d{5})(\\d{5})","$1 $2",["58"],"(0$1)"],["(\\d{3})(\\d{7})","$1 $2",["3"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["[24-9]"],"(0$1)"]],"0"],"PL":["48","00","6\\d{5}(?:\\d{2})?|8\\d{9}|[1-9]\\d{6}(?:\\d{2})?",[6,7,8,9,10],[["(\\d{5})","$1",["19"]],["(\\d{3})(\\d{3})","$1 $2",["11|64"]],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1","(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]],["(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["64"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[2-8]|[2-7]|8[1-79]|9[145]"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["8"]]]],"PM":["508","00","[45]\\d{5}",[6],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["[45]"],"0$1"]],"0"],"PR":["1","011","(?:[589]\\d\\d|787)\\d{7}",[10],0,"1",0,0,0,0,"787|939"],"PS":["970","00","[2489]2\\d{6}|(?:1\\d|5)\\d{8}",[8,9,10],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2489]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["5"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],"0"],"PT":["351","00","(?:[26-9]\\d|30)\\d{7}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["2[12]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[236-9]"]]]],"PW":["680","01[12]","(?:[24-8]\\d\\d|345|900)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-9]"]]]],"PY":["595","00","59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}",[6,7,8,9,10,11],[["(\\d{3})(\\d{3,6})","$1 $2",["[2-9]0"],"0$1"],["(\\d{2})(\\d{5})","$1 $2",["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"],"(0$1)"],["(\\d{3})(\\d{4,5})","$1 $2",["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["87"]],["(\\d{3})(\\d{6})","$1 $2",["9(?:[5-79]|8[1-6])"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[2-8]"],"0$1"],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["9"]]],"0"],"QA":["974","00","[2-7]\\d{7}|(?:2\\d\\d|800)\\d{4}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["2[126]|8"]],["(\\d{4})(\\d{4})","$1 $2",["[2-7]"]]]],"RE":["262","00","9769\\d{5}|(?:26|[68]\\d)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2689]"],"0$1"]],"0",0,0,0,0,"26[23]|69|[89]"],"RO":["40","00","(?:[237]\\d|[89]0)\\d{7}|[23]\\d{5}",[6,9],[["(\\d{3})(\\d{3})","$1 $2",["2[3-6]","2[3-6]\\d9"],"0$1"],["(\\d{2})(\\d{4})","$1 $2",["219|31"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[23]1"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[237-9]"],"0$1"]],"0",0,0,0,0,0,0,0," int "],"RS":["381","00","38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}",[6,7,8,9,10,11,12],[["(\\d{3})(\\d{3,9})","$1 $2",["(?:2[389]|39)0|[7-9]"],"0$1"],["(\\d{2})(\\d{5,10})","$1 $2",["[1-36]"],"0$1"]],"0"],"RU":["7","810","[347-9]\\d{9}",[10],[["(\\d{4})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["7(?:1[0-8]|2[1-9])","7(?:1(?:[0-6]2|7|8[27])|2(?:1[23]|[2-9]2))","7(?:1(?:[0-6]2|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"],"8 ($1)",1],["(\\d{5})(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["7(?:1[0-68]|2[1-9])","7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))","7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"],"8 ($1)",1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"8 ($1)",1],["(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["[3489]"],"8 ($1)",1]],"8",0,0,0,0,"3[04-689]|[489]",0,"8~10"],"RW":["250","00","(?:06|[27]\\d\\d|[89]00)\\d{6}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["0"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[7-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["2"]]],"0"],"SA":["966","00","92\\d{7}|(?:[15]|8\\d)\\d{8}",[9,10],[["(\\d{4})(\\d{5})","$1 $2",["9"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["5"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["81"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]]],"0"],"SB":["677","0[01]","(?:[1-6]|[7-9]\\d\\d)\\d{4}",[5,7],[["(\\d{2})(\\d{5})","$1 $2",["7|8[4-9]|9(?:[1-8]|9[0-8])"]]]],"SC":["248","010|0[0-2]","8000\\d{3}|(?:[249]\\d|64)\\d{5}",[7],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[246]|9[57]"]]],0,0,0,0,0,0,0,"00"],"SD":["249","00","[19]\\d{8}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[19]"],"0$1"]],"0"],"SE":["46","00","(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}",[6,7,8,9,10],[["(\\d{2})(\\d{2,3})(\\d{2})","$1-$2 $3",["20"],"0$1",0,"$1 $2 $3"],["(\\d{3})(\\d{4})","$1-$2",["9(?:00|39|44)"],"0$1",0,"$1 $2"],["(\\d{2})(\\d{3})(\\d{2})","$1-$2 $3",["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"],"0$1",0,"$1 $2 $3"],["(\\d)(\\d{2,3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["8"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2,3})(\\d{2})","$1-$2 $3",["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"],"0$1",0,"$1 $2 $3"],["(\\d{3})(\\d{2,3})(\\d{3})","$1-$2 $3",["9(?:00|39|44)"],"0$1",0,"$1 $2 $3"],["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"],"0$1",0,"$1 $2 $3 $4"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["10|7"],"0$1",0,"$1 $2 $3 $4"],["(\\d)(\\d{3})(\\d{3})(\\d{2})","$1-$2 $3 $4",["8"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1-$2 $3 $4",["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2})(\\d{2})(\\d{3})","$1-$2 $3 $4",["9"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1-$2 $3 $4 $5",["[26]"],"0$1",0,"$1 $2 $3 $4 $5"]],"0"],"SG":["65","0[0-3]\\d","(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}",[8,10,11],[["(\\d{4})(\\d{4})","$1 $2",["[369]|8(?:0[1-3]|[1-9])"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]],["(\\d{4})(\\d{4})(\\d{3})","$1 $2 $3",["7"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]]]],"SH":["290","00","(?:[256]\\d|8)\\d{3}",[4,5],0,0,0,0,0,0,"[256]"],"SI":["386","00|10(?:22|66|88|99)","[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}",[5,6,7,8],[["(\\d{2})(\\d{3,6})","$1 $2",["8[09]|9"],"0$1"],["(\\d{3})(\\d{5})","$1 $2",["59|8"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[37][01]|4[0139]|51|6"],"0$1"],["(\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[1-57]"],"(0$1)"]],"0",0,0,0,0,0,0,"00"],"SJ":["47","00","0\\d{4}|(?:[4589]\\d|79)\\d{6}",[5,8],0,0,0,0,0,0,"79"],"SK":["421","00","[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",[6,7,9],[["(\\d)(\\d{2})(\\d{3,4})","$1 $2 $3",["21"],"0$1"],["(\\d{2})(\\d{2})(\\d{2,3})","$1 $2 $3",["[3-5][1-8]1","[3-5][1-8]1[67]"],"0$1"],["(\\d)(\\d{3})(\\d{3})(\\d{2})","$1/$2 $3 $4",["2"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[689]"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1/$2 $3 $4",["[3-5]"],"0$1"]],"0"],"SL":["232","00","(?:[2378]\\d|66|99)\\d{6}",[8],[["(\\d{2})(\\d{6})","$1 $2",["[236-9]"],"(0$1)"]],"0"],"SM":["378","00","(?:0549|[5-7]\\d)\\d{6}",[8,10],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-7]"]],["(\\d{4})(\\d{6})","$1 $2",["0"]]],0,0,"([89]\\d{5})$","0549$1"],"SN":["221","00","(?:[378]\\d{4}|93330)\\d{4}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[379]"]]]],"SO":["252","00","[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}",[6,7,8,9],[["(\\d{2})(\\d{4})","$1 $2",["8[125]"]],["(\\d{6})","$1",["[134]"]],["(\\d)(\\d{6})","$1 $2",["[15]|2[0-79]|3[0-46-8]|4[0-7]"]],["(\\d)(\\d{7})","$1 $2",["24|[67]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[3478]|64|90"]],["(\\d{2})(\\d{5,7})","$1 $2",["1|28|6[1-35-9]|9[2-9]"]]],"0"],"SR":["597","00","(?:[2-5]|68|[78]\\d)\\d{5}",[6,7],[["(\\d{2})(\\d{2})(\\d{2})","$1-$2-$3",["56"]],["(\\d{3})(\\d{3})","$1-$2",["[2-5]"]],["(\\d{3})(\\d{4})","$1-$2",["[6-8]"]]]],"SS":["211","00","[19]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[19]"],"0$1"]],"0"],"ST":["239","00","(?:22|9\\d)\\d{5}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[29]"]]]],"SV":["503","00","[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?",[7,8,11],[["(\\d{3})(\\d{4})","$1 $2",["[89]"]],["(\\d{4})(\\d{4})","$1 $2",["[267]"]],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["[89]"]]]],"SX":["1","011","7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|(5\\d{6})$","721$1",0,"721"],"SY":["963","00","[1-39]\\d{8}|[1-5]\\d{7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-5]"],"0$1",1],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1",1]],"0"],"SZ":["268","00","0800\\d{4}|(?:[237]\\d|900)\\d{6}",[8,9],[["(\\d{4})(\\d{4})","$1 $2",["[0237]"]],["(\\d{5})(\\d{4})","$1 $2",["9"]]]],"TA":["290","00","8\\d{3}",[4],0,0,0,0,0,0,"8"],"TC":["1","011","(?:[58]\\d\\d|649|900)\\d{7}",[10],0,"1",0,"1|([2-479]\\d{6})$","649$1",0,"649"],"TD":["235","00|16","(?:22|[69]\\d|77)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2679]"]]],0,0,0,0,0,0,0,"00"],"TG":["228","00","[279]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[279]"]]]],"TH":["66","00[1-9]","1\\d{9}|[1689]\\d{8}|[1-57]\\d{7}",[8,9,10],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[13-9]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],"0"],"TJ":["992","810","(?:[02]0|11|[3-57-9]\\d)\\d{7}",[9],[["(\\d{6})(\\d)(\\d{2})","$1 $2 $3",["331","3317"],0,1],["(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["[34]7|91[78]"],0,1],["(\\d{4})(\\d)(\\d{4})","$1 $2 $3",["3"],0,1],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[02457-9]|11"],0,1]],"8",0,0,0,0,0,0,"8~10"],"TK":["690","00","[2-47]\\d{3,6}",[4,5,6,7]],"TL":["670","00","7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["[2-489]|70"]],["(\\d{4})(\\d{4})","$1 $2",["7"]]]],"TM":["993","810","[1-6]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2-$3-$4",["12"],"(8 $1)"],["(\\d{3})(\\d)(\\d{2})(\\d{2})","$1 $2-$3-$4",["[1-5]"],"(8 $1)"],["(\\d{2})(\\d{6})","$1 $2",["6"],"8 $1"]],"8",0,0,0,0,0,0,"8~10"],"TN":["216","00","[2-57-9]\\d{7}",[8],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2-57-9]"]]]],"TO":["676","00","(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}",[5,7],[["(\\d{2})(\\d{3})","$1-$2",["[2-4]|50|6[09]|7[0-24-69]|8[05]"]],["(\\d{4})(\\d{3})","$1 $2",["0"]],["(\\d{3})(\\d{4})","$1 $2",["[5-9]"]]]],"TR":["90","00","4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}",[7,10,12,13],[["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["512|8[01589]|90"],"0$1",1],["(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5(?:[0-59]|61)","5(?:[0-59]|616)","5(?:[0-59]|6161)"],"0$1",1],["(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24][1-8]|3[1-9]"],"(0$1)",1],["(\\d{3})(\\d{3})(\\d{6,7})","$1 $2 $3",["80"],"0$1",1]],"0"],"TT":["1","011","(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2-46-8]\\d{6})$","868$1",0,"868"],"TV":["688","00","(?:2|7\\d\\d|90)\\d{4}",[5,6,7],[["(\\d{2})(\\d{3})","$1 $2",["2"]],["(\\d{2})(\\d{4})","$1 $2",["90"]],["(\\d{2})(\\d{5})","$1 $2",["7"]]]],"TW":["886","0(?:0[25-79]|19)","[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",[7,8,9,10,11],[["(\\d{2})(\\d)(\\d{4})","$1 $2 $3",["202"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[258]0"],"0$1"],["(\\d)(\\d{3,4})(\\d{4})","$1 $2 $3",["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]","[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[49]"],"0$1"],["(\\d{2})(\\d{4})(\\d{4,5})","$1 $2 $3",["7"],"0$1"]],"0",0,0,0,0,0,0,0,"#"],"TZ":["255","00[056]","(?:[26-8]\\d|41|90)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["[89]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[24]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[67]"],"0$1"]],"0"],"UA":["380","00","[89]\\d{9}|[3-9]\\d{8}",[9,10],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]","6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["4[45][0-5]|5(?:0|6[37])|6(?:[12][018]|[36-8])|7|89|9[1-9]|(?:48|57)[0137-9]","4[45][0-5]|5(?:0|6(?:3[14-7]|7))|6(?:[12][018]|[36-8])|7|89|9[1-9]|(?:48|57)[0137-9]"],"0$1"],["(\\d{4})(\\d{5})","$1 $2",["[3-6]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[89]"],"0$1"]],"0",0,0,0,0,0,0,"0~0"],"UG":["256","00[057]","800\\d{6}|(?:[29]0|[347]\\d)\\d{7}",[9],[["(\\d{4})(\\d{5})","$1 $2",["202","2024"],"0$1"],["(\\d{3})(\\d{6})","$1 $2",["[27-9]|4(?:6[45]|[7-9])"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["[34]"],"0$1"]],"0"],"US":["1","011","[2-9]\\d{9}",[10],[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",["[2-9]"],0,1,"$1-$2-$3"]],"1",0,0,0,0,0,[["(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[01356]|3[0-24679]|4[167]|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[0235]|58|6[39]|7[0589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-47]|7[013-5]|8[056])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[0179]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[02-59]|8[156])|8(?:0[1-68]|1[02-8]|2[08]|3[0-289]|4[3578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[0179]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"],[""],["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"],["900[2-9]\\d{6}"],["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"]]],"UY":["598","0(?:0|1[3-9]\\d)","4\\d{9}|[249]\\d{7}|(?:[49]\\d|80)\\d{5}",[7,8,10],[["(\\d{3})(\\d{4})","$1 $2",["405|8|90"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1"],["(\\d{4})(\\d{4})","$1 $2",["[24]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["4"],"0$1"]],"0",0,0,0,0,0,0,"00"," int. "],"UZ":["998","810","55501\\d{4}|(?:33|[679]\\d|88)\\d{7}",[9],[["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[35-9]"],"8 $1"]],"8",0,0,0,0,0,0,"8~10"],"VA":["39","00","0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",[6,7,8,9,10,11],0,0,0,0,0,0,"06698"],"VC":["1","011","(?:[58]\\d\\d|784|900)\\d{7}",[10],0,"1",0,"1|([2-7]\\d{6})$","784$1",0,"784"],"VE":["58","00","[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}",[10],[["(\\d{3})(\\d{7})","$1-$2",["[24-689]"],"0$1"]],"0"],"VG":["1","011","(?:284|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2-578]\\d{6})$","284$1",0,"284"],"VI":["1","011","[58]\\d{9}|(?:34|90)0\\d{7}",[10],0,"1",0,"1|([2-9]\\d{6})$","340$1",0,"340"],"VN":["84","00","[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}",[7,8,9,10],[["(\\d{2})(\\d{5})","$1 $2",["80"],"0$1",1],["(\\d{4})(\\d{4,6})","$1 $2",["1"],0,1],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[69]"],"0$1",1],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[3578]"],"0$1",1],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["2[48]"],"0$1",1],["(\\d{3})(\\d{4})(\\d{3})","$1 $2 $3",["2"],"0$1",1]],"0"],"VU":["678","00","[48]8\\d{3}|(?:[23]|[579]\\d\\d)\\d{4}",[5,7],[["(\\d{3})(\\d{4})","$1 $2",["[579]"]]]],"WF":["681","00","(?:[45]0|68|72|8\\d)\\d{4}",[6],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["[4-8]"]]]],"WS":["685","0","(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",[5,6,7,10],[["(\\d{5})","$1",["[2-5]|6[1-9]"]],["(\\d{3})(\\d{3,7})","$1 $2",["[68]"]],["(\\d{2})(\\d{5})","$1 $2",["7"]]]],"XK":["383","00","[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}",[8,9],[["(\\d{3})(\\d{5})","$1 $2",["[89]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2-4]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[23]"],"0$1"]],"0"],"YE":["967","00","(?:1|7\\d)\\d{7}|[1-7]\\d{6}",[7,8,9],[["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-6]|7[24-68]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["7"],"0$1"]],"0"],"YT":["262","00","80\\d{7}|(?:26|63)9\\d{6}",[9],0,"0",0,0,0,0,"269|63"],"ZA":["27","00","[1-79]\\d{8}|8\\d{4,9}",[5,6,7,8,9,10],[["(\\d{2})(\\d{3,4})","$1 $2",["8[1-4]"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["8[1-4]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["860"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"]],"0"],"ZM":["260","00","(?:63|80)0\\d{6}|(?:21|[79]\\d)\\d{7}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[28]"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["[79]"],"0$1"]],"0"],"ZW":["263","00","2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}",[5,6,7,8,9,10],[["(\\d{3})(\\d{3,5})","$1 $2",["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"],"0$1"],["(\\d)(\\d{3})(\\d{2,4})","$1 $2 $3",["[49]"],"0$1"],["(\\d{3})(\\d{4})","$1 $2",["80"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2","2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)","2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"],"0$1"],["(\\d{4})(\\d{6})","$1 $2",["8"],"0$1"],["(\\d{2})(\\d{3,5})","$1 $2",["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["29[013-9]|39|54"],"0$1"],["(\\d{4})(\\d{3,5})","$1 $2",["(?:25|54)8","258|5483"],"0$1"]],"0"]},"nonGeographic":{"800":["800",0,"[1-9]\\d{7}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[1-9]"]]],0,0,0,0,0,0,[0,0,["[1-9]\\d{7}"]]],"808":["808",0,"[1-9]\\d{7}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[1-9]"]]],0,0,0,0,0,0,[0,0,0,0,0,0,0,0,0,["[1-9]\\d{7}"]]],"870":["870",0,"7\\d{11}|[35-7]\\d{8}",[9,12],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[35-7]"]]],0,0,0,0,0,0,[0,["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"]]],"878":["878",0,"10\\d{10}",[12],[["(\\d{2})(\\d{5})(\\d{5})","$1 $2 $3",["1"]]],0,0,0,0,0,0,[0,0,0,0,0,0,0,0,["10\\d{10}"]]],"881":["881",0,"[0-36-9]\\d{8}",[9],[["(\\d)(\\d{3})(\\d{5})","$1 $2 $3",["[0-36-9]"]]],0,0,0,0,0,0,[0,["[0-36-9]\\d{8}"]]],"882":["882",0,"[13]\\d{6}(?:\\d{2,5})?|285\\d{9}|[19]\\d{7}",[7,8,9,10,11,12],[["(\\d{2})(\\d{5})","$1 $2",["16|342"]],["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[19]"]],["(\\d{2})(\\d{4})(\\d{3})","$1 $2 $3",["3[23]"]],["(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["1"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["34[57]"]],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["34"]],["(\\d{2})(\\d{4,5})(\\d{5})","$1 $2 $3",["[1-3]"]]],0,0,0,0,0,0,[0,["3(?:37\\d\\d|42)\\d{4}|3(?:2|47|7\\d{3})\\d{7}",[7,9,10,12]],0,0,0,0,0,0,["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:(?:285\\d\\d|3(?:45|[69]\\d{3}))\\d|9[89])\\d{6}"]]],"883":["883",0,"51\\d{7}(?:\\d{3})?",[9,12],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["510"]],["(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["510"]],["(\\d{4})(\\d{4})(\\d{4})","$1 $2 $3",["5"]]],0,0,0,0,0,0,[0,0,0,0,0,0,0,0,["51[013]0\\d{8}|5100\\d{5}"]]],"888":["888",0,"\\d{11}",[11],[["(\\d{3})(\\d{3})(\\d{5})","$1 $2 $3"]],0,0,0,0,0,0,[0,0,0,0,0,0,["\\d{11}"]]],"979":["979",0,"[1359]\\d{8}",[9],[["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["[1359]"]]],0,0,0,0,0,0,[0,0,0,["[1359]\\d{8}"]]]}};

// Importing from `.json.js` a workaround for a bug in web browsers' "native"

function _classCallCheck$1(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// https://stackoverflow.com/a/46971044/970769
var ParseError = function ParseError(code) {
  _classCallCheck$1(this, ParseError);

  this.name = this.constructor.name;
  this.message = code;
  this.stack = new Error(code).stack;
};
ParseError.prototype = Object.create(Error.prototype);
ParseError.prototype.constructor = ParseError;

// The minimum length of the national significant number.
var MIN_LENGTH_FOR_NSN = 2; // The ITU says the maximum length should be 15,
// but one can find longer numbers in Germany.

var MAX_LENGTH_FOR_NSN = 17; // The maximum length of the country calling code.

var MAX_LENGTH_COUNTRY_CODE = 3; // Digits accepted in phone numbers
// (ascii, fullwidth, arabic-indic, and eastern arabic digits).

var VALID_DIGITS = "0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9"; // `DASHES` will be right after the opening square bracket of the "character class"

var DASHES = "-\u2010-\u2015\u2212\u30FC\uFF0D";
var SLASHES = "\uFF0F/";
var DOTS = "\uFF0E.";
var WHITESPACE = " \xA0\xAD\u200B\u2060\u3000";
var BRACKETS = "()\uFF08\uFF09\uFF3B\uFF3D\\[\\]"; // export const OPENING_BRACKETS = '(\uFF08\uFF3B\\\['

var TILDES = "~\u2053\u223C\uFF5E"; // Regular expression of acceptable punctuation found in phone numbers. This
// excludes punctuation found as a leading character only. This consists of dash
// characters, white space characters, full stops, slashes, square brackets,
// parentheses and tildes. Full-width variants are also present.

var VALID_PUNCTUATION = "".concat(DASHES).concat(SLASHES).concat(DOTS).concat(WHITESPACE).concat(BRACKETS).concat(TILDES);
var PLUS_CHARS = "+\uFF0B"; // const LEADING_PLUS_CHARS_PATTERN = new RegExp('^[' + PLUS_CHARS + ']+')

// Copy-pasted from:
// https://github.com/substack/semver-compare/blob/master/index.js
//
// Inlining this function because some users reported issues with
// importing from `semver-compare` in a browser with ES6 "native" modules.
//
// Fixes `semver-compare` not being able to compare versions with alpha/beta/etc "tags".
// https://github.com/catamphetamine/libphonenumber-js/issues/381
function compare (a, b) {
  a = a.split('-');
  b = b.split('-');
  var pa = a[0].split('.');
  var pb = b[0].split('.');

  for (var i = 0; i < 3; i++) {
    var na = Number(pa[i]);
    var nb = Number(pb[i]);
    if (na > nb) return 1;
    if (nb > na) return -1;
    if (!isNaN(na) && isNaN(nb)) return 1;
    if (isNaN(na) && !isNaN(nb)) return -1;
  }

  if (a[1] && b[1]) {
    return a[1] > b[1] ? 1 : a[1] < b[1] ? -1 : 0;
  }

  return !a[1] && b[1] ? 1 : a[1] && !b[1] ? -1 : 0;
}

function _typeof$1(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$1 = function _typeof(obj) { return typeof obj; }; } else { _typeof$1 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$1(obj); }

function _classCallCheck$2(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$1(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$1(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$1(Constructor.prototype, protoProps); if (staticProps) _defineProperties$1(Constructor, staticProps); return Constructor; }

var V3 = '1.2.0'; // Moved `001` country code to "nonGeographic" section of metadata.

var V4 = '1.7.35';
var DEFAULT_EXT_PREFIX = ' ext. ';
var CALLING_CODE_REG_EXP = /^\d+$/;
/**
 * See: https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md
 */

var Metadata =
/*#__PURE__*/
function () {
  function Metadata(metadata) {
    _classCallCheck$2(this, Metadata);

    validateMetadata(metadata);
    this.metadata = metadata;
    setVersion.call(this, metadata);
  }

  _createClass$1(Metadata, [{
    key: "getCountries",
    value: function getCountries() {
      return Object.keys(this.metadata.countries).filter(function (_) {
        return _ !== '001';
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function getCountryMetadata(countryCode) {
      return this.metadata.countries[countryCode];
    }
  }, {
    key: "nonGeographic",
    value: function nonGeographic() {
      if (this.v1 || this.v2 || this.v3) return; // `nonGeographical` was a typo.
      // It's present in metadata generated from `1.7.35` to `1.7.37`.

      return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function hasCountry(country) {
      return this.getCountryMetadata(country) !== undefined;
    }
  }, {
    key: "hasCallingCode",
    value: function hasCallingCode(callingCode) {
      if (this.getCountryCodesForCallingCode(callingCode)) {
        return true;
      }

      if (this.nonGeographic()) {
        if (this.nonGeographic()[callingCode]) {
          return true;
        }
      } else {
        // A hacky workaround for old custom metadata (generated before V4).
        var countryCodes = this.countryCallingCodes()[callingCode];

        if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') {
          return true;
        }
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function isNonGeographicCallingCode(callingCode) {
      if (this.nonGeographic()) {
        return this.nonGeographic()[callingCode] ? true : false;
      } else {
        return this.getCountryCodesForCallingCode(callingCode) ? false : true;
      }
    } // Deprecated.

  }, {
    key: "country",
    value: function country(countryCode) {
      return this.selectNumberingPlan(countryCode);
    }
  }, {
    key: "selectNumberingPlan",
    value: function selectNumberingPlan(countryCode, callingCode) {
      // Supports just passing `callingCode` as the first argument.
      if (countryCode && CALLING_CODE_REG_EXP.test(countryCode)) {
        callingCode = countryCode;
        countryCode = null;
      }

      if (countryCode && countryCode !== '001') {
        if (!this.hasCountry(countryCode)) {
          throw new Error("Unknown country: ".concat(countryCode));
        }

        this.numberingPlan = new NumberingPlan(this.getCountryMetadata(countryCode), this);
      } else if (callingCode) {
        if (!this.hasCallingCode(callingCode)) {
          throw new Error("Unknown calling code: ".concat(callingCode));
        }

        this.numberingPlan = new NumberingPlan(this.getNumberingPlanMetadata(callingCode), this);
      } else {
        this.numberingPlan = undefined;
      }

      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function getCountryCodesForCallingCode(callingCode) {
      var countryCodes = this.countryCallingCodes()[callingCode];

      if (countryCodes) {
        // Metadata before V4 included "non-geographic entity" calling codes
        // inside `country_calling_codes` (for example, `"881":["001"]`).
        // Now the semantics of `country_calling_codes` has changed:
        // it's specifically for "countries" now.
        // Older versions of custom metadata will simply skip parsing
        // "non-geographic entity" phone numbers with new versions
        // of this library: it's not considered a bug,
        // because such numbers are extremely rare,
        // and developers extremely rarely use custom metadata.
        if (countryCodes.length === 1 && countryCodes[0].length === 3) {
          return;
        }

        return countryCodes;
      }
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function getCountryCodeForCallingCode(callingCode) {
      var countryCodes = this.getCountryCodesForCallingCode(callingCode);

      if (countryCodes) {
        return countryCodes[0];
      }
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function getNumberingPlanMetadata(callingCode) {
      var countryCode = this.getCountryCodeForCallingCode(callingCode);

      if (countryCode) {
        return this.getCountryMetadata(countryCode);
      }

      if (this.nonGeographic()) {
        var metadata = this.nonGeographic()[callingCode];

        if (metadata) {
          return metadata;
        }
      } else {
        // A hacky workaround for old custom metadata (generated before V4).
        var countryCodes = this.countryCallingCodes()[callingCode];

        if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') {
          return this.metadata.countries['001'];
        }
      }
    } // Deprecated.

  }, {
    key: "countryCallingCode",
    value: function countryCallingCode() {
      return this.numberingPlan.callingCode();
    } // Deprecated.

  }, {
    key: "IDDPrefix",
    value: function IDDPrefix() {
      return this.numberingPlan.IDDPrefix();
    } // Deprecated.

  }, {
    key: "defaultIDDPrefix",
    value: function defaultIDDPrefix() {
      return this.numberingPlan.defaultIDDPrefix();
    } // Deprecated.

  }, {
    key: "nationalNumberPattern",
    value: function nationalNumberPattern() {
      return this.numberingPlan.nationalNumberPattern();
    } // Deprecated.

  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      return this.numberingPlan.possibleLengths();
    } // Deprecated.

  }, {
    key: "formats",
    value: function formats() {
      return this.numberingPlan.formats();
    } // Deprecated.

  }, {
    key: "nationalPrefixForParsing",
    value: function nationalPrefixForParsing() {
      return this.numberingPlan.nationalPrefixForParsing();
    } // Deprecated.

  }, {
    key: "nationalPrefixTransformRule",
    value: function nationalPrefixTransformRule() {
      return this.numberingPlan.nationalPrefixTransformRule();
    } // Deprecated.

  }, {
    key: "leadingDigits",
    value: function leadingDigits() {
      return this.numberingPlan.leadingDigits();
    } // Deprecated.

  }, {
    key: "hasTypes",
    value: function hasTypes() {
      return this.numberingPlan.hasTypes();
    } // Deprecated.

  }, {
    key: "type",
    value: function type(_type) {
      return this.numberingPlan.type(_type);
    } // Deprecated.

  }, {
    key: "ext",
    value: function ext() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function countryCallingCodes() {
      if (this.v1) return this.metadata.country_phone_code_to_countries;
      return this.metadata.country_calling_codes;
    } // Deprecated.

  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function chooseCountryByCountryCallingCode(callingCode) {
      return this.selectNumberingPlan(callingCode);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function hasSelectedNumberingPlan() {
      return this.numberingPlan !== undefined;
    }
  }]);

  return Metadata;
}();

var NumberingPlan =
/*#__PURE__*/
function () {
  function NumberingPlan(metadata, globalMetadataObject) {
    _classCallCheck$2(this, NumberingPlan);

    this.globalMetadataObject = globalMetadataObject;
    this.metadata = metadata;
    setVersion.call(this, globalMetadataObject.metadata);
  }

  _createClass$1(NumberingPlan, [{
    key: "callingCode",
    value: function callingCode() {
      return this.metadata[0];
    } // Formatting information for regions which share
    // a country calling code is contained by only one region
    // for performance reasons. For example, for NANPA region
    // ("North American Numbering Plan Administration",
    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
    // it will be contained in the metadata for `US`.

  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function getDefaultCountryMetadataForRegion() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    }
  }, {
    key: "IDDPrefix",
    value: function IDDPrefix() {
      if (this.v1 || this.v2) return;
      return this.metadata[1];
    }
  }, {
    key: "defaultIDDPrefix",
    value: function defaultIDDPrefix() {
      if (this.v1 || this.v2) return;
      return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function nationalNumberPattern() {
      if (this.v1 || this.v2) return this.metadata[1];
      return this.metadata[2];
    }
  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      if (this.v1) return;
      return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function _getFormats(metadata) {
      return metadata[this.v1 ? 2 : this.v2 ? 3 : 4];
    } // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".

  }, {
    key: "formats",
    value: function formats() {
      var _this = this;

      var formats = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return formats.map(function (_) {
        return new Format(_, _this);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function nationalPrefix() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function _getNationalPrefixFormattingRule(metadata) {
      return metadata[this.v1 ? 4 : this.v2 ? 5 : 6];
    } // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".

  }, {
    key: "nationalPrefixFormattingRule",
    value: function nationalPrefixFormattingRule() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function _nationalPrefixForParsing() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function nationalPrefixForParsing() {
      // If `national_prefix_for_parsing` is not set explicitly,
      // then infer it from `national_prefix` (if any)
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function nationalPrefixTransformRule() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function _getNationalPrefixIsOptionalWhenFormatting() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    } // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".

  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function leadingDigits() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function types() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function hasTypes() {
      // Versions 1.2.0 - 1.2.4: can be `[]`.

      /* istanbul ignore next */
      if (this.types() && this.types().length === 0) {
        return false;
      } // Versions <= 1.2.4: can be `undefined`.
      // Version >= 1.2.5: can be `0`.


      return !!this.types();
    }
  }, {
    key: "type",
    value: function type(_type2) {
      if (this.hasTypes() && getType(this.types(), _type2)) {
        return new Type(getType(this.types(), _type2), this);
      }
    }
  }, {
    key: "ext",
    value: function ext() {
      if (this.v1 || this.v2) return DEFAULT_EXT_PREFIX;
      return this.metadata[13] || DEFAULT_EXT_PREFIX;
    }
  }]);

  return NumberingPlan;
}();

var Format =
/*#__PURE__*/
function () {
  function Format(format, metadata) {
    _classCallCheck$2(this, Format);

    this._format = format;
    this.metadata = metadata;
  }

  _createClass$1(Format, [{
    key: "pattern",
    value: function pattern() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function format() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function leadingDigitsPatterns() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function nationalPrefixFormattingRule() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function nationalPrefixIsMandatoryWhenFormattingInNationalFormat() {
      // National prefix is omitted if there's no national prefix formatting rule
      // set for this country, or when the national prefix formatting rule
      // contains no national prefix itself, or when this rule is set but
      // national prefix is optional for this phone number format
      // (and it is not enforced explicitly)
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    } // Checks whether national prefix formatting rule contains national prefix.

  }, {
    key: "usesNationalPrefix",
    value: function usesNationalPrefix() {
      return this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
      !FIRST_GROUP_ONLY_PREFIX_PATTERN.test(this.nationalPrefixFormattingRule()) // In compressed metadata, `this.nationalPrefixFormattingRule()` is `0`
      // when `national_prefix_formatting_rule` is not present.
      // So, `true` or `false` are returned explicitly here, so that
      // `0` number isn't returned.
      ? true : false;
    }
  }, {
    key: "internationalFormat",
    value: function internationalFormat() {
      return this._format[5] || this.format();
    }
  }]);

  return Format;
}();
/**
 * A pattern that is used to determine if the national prefix formatting rule
 * has the first group only, i.e., does not start with the national prefix.
 * Note that the pattern explicitly allows for unbalanced parentheses.
 */


var FIRST_GROUP_ONLY_PREFIX_PATTERN = /^\(?\$1\)?$/;

var Type =
/*#__PURE__*/
function () {
  function Type(type, metadata) {
    _classCallCheck$2(this, Type);

    this.type = type;
    this.metadata = metadata;
  }

  _createClass$1(Type, [{
    key: "pattern",
    value: function pattern() {
      if (this.metadata.v1) return this.type;
      return this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      if (this.metadata.v1) return;
      return this.type[1] || this.metadata.possibleLengths();
    }
  }]);

  return Type;
}();

function getType(types, type) {
  switch (type) {
    case 'FIXED_LINE':
      return types[0];

    case 'MOBILE':
      return types[1];

    case 'TOLL_FREE':
      return types[2];

    case 'PREMIUM_RATE':
      return types[3];

    case 'PERSONAL_NUMBER':
      return types[4];

    case 'VOICEMAIL':
      return types[5];

    case 'UAN':
      return types[6];

    case 'PAGER':
      return types[7];

    case 'VOIP':
      return types[8];

    case 'SHARED_COST':
      return types[9];
  }
}

function validateMetadata(metadata) {
  if (!metadata) {
    throw new Error('[libphonenumber-js] `metadata` argument not passed. Check your arguments.');
  } // `country_phone_code_to_countries` was renamed to
  // `country_calling_codes` in `1.0.18`.


  if (!is_object(metadata) || !is_object(metadata.countries)) {
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(is_object(metadata) ? 'an object of shape: { ' + Object.keys(metadata).join(', ') + ' }' : 'a ' + type_of(metadata) + ': ' + metadata, "."));
  }
} // Babel transforms `typeof` into some "branches"
// so istanbul will show this as "branch not covered".

/* istanbul ignore next */

var is_object = function is_object(_) {
  return _typeof$1(_) === 'object';
}; // Babel transforms `typeof` into some "branches"
// so istanbul will show this as "branch not covered".

/* istanbul ignore next */


var type_of = function type_of(_) {
  return _typeof$1(_);
};
/**
 * Returns "country calling code" for a country.
 * Throws an error if the country doesn't exist or isn't supported by this library.
 * @param  {string} country
 * @param  {object} metadata
 * @return {string}
 * @example
 * // Returns "44"
 * getCountryCallingCode("GB")
 */

function getCountryCallingCode(country, metadata) {
  metadata = new Metadata(metadata);

  if (metadata.hasCountry(country)) {
    return metadata.country(country).countryCallingCode();
  }

  throw new Error("Unknown country: ".concat(country));
}
function isSupportedCountry(country, metadata) {
  // metadata = new Metadata(metadata)
  // return metadata.hasCountry(country)
  return metadata.countries[country] !== undefined;
}

function setVersion(metadata) {
  var version = metadata.version;

  if (typeof version === 'number') {
    this.v1 = version === 1;
    this.v2 = version === 2;
    this.v3 = version === 3;
    this.v4 = version === 4;
  } else {
    if (!version) {
      this.v1 = true;
    } else if (compare(version, V3) === -1) {
      this.v2 = true;
    } else if (compare(version, V4) === -1) {
      this.v3 = true;
    } else {
      this.v4 = true;
    }
  }
} // const ISO_COUNTRY_CODE = /^[A-Z]{2}$/
// function isCountryCode(countryCode) {
// 	return ISO_COUNTRY_CODE.test(countryCodeOrCountryCallingCode)
// }

var RFC3966_EXTN_PREFIX = ';ext=';
/**
 * Helper method for constructing regular expressions for parsing. Creates
 * an expression that captures up to max_length digits.
 * @return {string} RegEx pattern to capture extension digits.
 */

var getExtensionDigitsPattern = function getExtensionDigitsPattern(maxLength) {
  return "([".concat(VALID_DIGITS, "]{1,").concat(maxLength, "})");
};
/**
 * Helper initialiser method to create the regular-expression pattern to match
 * extensions.
 * Copy-pasted from Google's `libphonenumber`:
 * https://github.com/google/libphonenumber/blob/55b2646ec9393f4d3d6661b9c82ef9e258e8b829/javascript/i18n/phonenumbers/phonenumberutil.js#L759-L766
 * @return {string} RegEx pattern to capture extensions.
 */


function createExtensionPattern(purpose) {
  // We cap the maximum length of an extension based on the ambiguity of the way
  // the extension is prefixed. As per ITU, the officially allowed length for
  // extensions is actually 40, but we don't support this since we haven't seen real
  // examples and this introduces many false interpretations as the extension labels
  // are not standardized.

  /** @type {string} */
  var extLimitAfterExplicitLabel = '20';
  /** @type {string} */

  var extLimitAfterLikelyLabel = '15';
  /** @type {string} */

  var extLimitAfterAmbiguousChar = '9';
  /** @type {string} */

  var extLimitWhenNotSure = '6';
  /** @type {string} */

  var possibleSeparatorsBetweenNumberAndExtLabel = "[ \xA0\\t,]*"; // Optional full stop (.) or colon, followed by zero or more spaces/tabs/commas.

  /** @type {string} */

  var possibleCharsAfterExtLabel = "[:\\.\uFF0E]?[ \xA0\\t,-]*";
  /** @type {string} */

  var optionalExtnSuffix = "#?"; // Here the extension is called out in more explicit way, i.e mentioning it obvious
  // patterns like "ext.".

  /** @type {string} */

  var explicitExtLabels = "(?:e?xt(?:ensi(?:o\u0301?|\xF3))?n?|\uFF45?\uFF58\uFF54\uFF4E?|\u0434\u043E\u0431|anexo)"; // One-character symbols that can be used to indicate an extension, and less
  // commonly used or more ambiguous extension labels.

  /** @type {string} */

  var ambiguousExtLabels = "(?:[x\uFF58#\uFF03~\uFF5E]|int|\uFF49\uFF4E\uFF54)"; // When extension is not separated clearly.

  /** @type {string} */

  var ambiguousSeparator = "[- ]+"; // This is the same as possibleSeparatorsBetweenNumberAndExtLabel, but not matching
  // comma as extension label may have it.

  /** @type {string} */

  var possibleSeparatorsNumberExtLabelNoComma = "[ \xA0\\t]*"; // ",," is commonly used for auto dialling the extension when connected. First
  // comma is matched through possibleSeparatorsBetweenNumberAndExtLabel, so we do
  // not repeat it here. Semi-colon works in Iphone and Android also to pop up a
  // button with the extension number following.

  /** @type {string} */

  var autoDiallingAndExtLabelsFound = "(?:,{2}|;)";
  /** @type {string} */

  var rfcExtn = RFC3966_EXTN_PREFIX + getExtensionDigitsPattern(extLimitAfterExplicitLabel);
  /** @type {string} */

  var explicitExtn = possibleSeparatorsBetweenNumberAndExtLabel + explicitExtLabels + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterExplicitLabel) + optionalExtnSuffix;
  /** @type {string} */

  var ambiguousExtn = possibleSeparatorsBetweenNumberAndExtLabel + ambiguousExtLabels + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
  /** @type {string} */

  var americanStyleExtnWithSuffix = ambiguousSeparator + getExtensionDigitsPattern(extLimitWhenNotSure) + "#";
  /** @type {string} */

  var autoDiallingExtn = possibleSeparatorsNumberExtLabelNoComma + autoDiallingAndExtLabelsFound + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterLikelyLabel) + optionalExtnSuffix;
  /** @type {string} */

  var onlyCommasExtn = possibleSeparatorsNumberExtLabelNoComma + "(?:,)+" + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix; // The first regular expression covers RFC 3966 format, where the extension is added
  // using ";ext=". The second more generic where extension is mentioned with explicit
  // labels like "ext:". In both the above cases we allow more numbers in extension than
  // any other extension labels. The third one captures when single character extension
  // labels or less commonly used labels are used. In such cases we capture fewer
  // extension digits in order to reduce the chance of falsely interpreting two
  // numbers beside each other as a number + extension. The fourth one covers the
  // special case of American numbers where the extension is written with a hash
  // at the end, such as "- 503#". The fifth one is exclusively for extension
  // autodialling formats which are used when dialling and in this case we accept longer
  // extensions. The last one is more liberal on the number of commas that acts as
  // extension labels, so we have a strict cap on the number of digits in such extensions.

  return rfcExtn + "|" + explicitExtn + "|" + ambiguousExtn + "|" + americanStyleExtnWithSuffix + "|" + autoDiallingExtn + "|" + onlyCommasExtn;
}

//  Checks we have at least three leading digits, and only valid punctuation,
//  alpha characters and digits in the phone number. Does not include extension
//  data. The symbol 'x' is allowed here as valid punctuation since it is often
//  used as a placeholder for carrier codes, for example in Brazilian phone
//  numbers. We also allow multiple '+' characters at the start.
//
//  Corresponds to the following:
//  [digits]{minLengthNsn}|
//  plus_sign*
//  (([punctuation]|[star])*[digits]){3,}([punctuation]|[star]|[digits]|[alpha])*
//
//  The first reg-ex is to allow short numbers (two digits long) to be parsed if
//  they are entered as "15" etc, but only if there is no punctuation in them.
//  The second expression restricts the number of digits to three or more, but
//  then allows them to be in international form, and to have alpha-characters
//  and punctuation. We split up the two reg-exes here and combine them when
//  creating the reg-ex VALID_PHONE_NUMBER_PATTERN itself so we can prefix it
//  with ^ and append $ to each branch.
//
//  "Note VALID_PUNCTUATION starts with a -,
//   so must be the first in the range" (c) Google devs.
//  (wtf did they mean by saying that; probably nothing)
//

var MIN_LENGTH_PHONE_NUMBER_PATTERN = '[' + VALID_DIGITS + ']{' + MIN_LENGTH_FOR_NSN + '}'; //
// And this is the second reg-exp:
// (see MIN_LENGTH_PHONE_NUMBER_PATTERN for a full description of this reg-exp)
//

var VALID_PHONE_NUMBER = '[' + PLUS_CHARS + ']{0,1}' + '(?:' + '[' + VALID_PUNCTUATION + ']*' + '[' + VALID_DIGITS + ']' + '){3,}' + '[' + VALID_PUNCTUATION + VALID_DIGITS + ']*';
var VALID_PHONE_NUMBER_WITH_EXTENSION = VALID_PHONE_NUMBER + // Phone number extensions
'(?:' + createExtensionPattern() + ')?'; // The combined regular expression for valid phone numbers:
//

var VALID_PHONE_NUMBER_PATTERN = new RegExp( // Either a short two-digit-only phone number
'^' + MIN_LENGTH_PHONE_NUMBER_PATTERN + '$' + '|' + // Or a longer fully parsed phone number (min 3 characters)
'^' + VALID_PHONE_NUMBER_WITH_EXTENSION + '$', 'i'); // Checks to see if the string of characters could possibly be a phone number at
// all. At the moment, checks to see that the string begins with at least 2
// digits, ignoring any punctuation commonly found in phone numbers. This method
// does not require the number to be normalized in advance - but does assume
// that leading non-number symbols have been removed, such as by the method
// `extract_possible_number`.
//

function isViablePhoneNumber(number) {
  return number.length >= MIN_LENGTH_FOR_NSN && VALID_PHONE_NUMBER_PATTERN.test(number);
}

// 1 or more valid digits, for use when parsing.

var EXTN_PATTERN = new RegExp('(?:' + createExtensionPattern() + ')$', 'i'); // Strips any extension (as in, the part of the number dialled after the call is
// connected, usually indicated with extn, ext, x or similar) from the end of
// the number, and returns it.

function extractExtension(number) {
  var start = number.search(EXTN_PATTERN);

  if (start < 0) {
    return {};
  } // If we find a potential extension, and the number preceding this is a viable
  // number, we assume it is an extension.


  var numberWithoutExtension = number.slice(0, start);
  var matches = number.match(EXTN_PATTERN);
  var i = 1;

  while (i < matches.length) {
    if (matches[i]) {
      return {
        number: numberWithoutExtension,
        ext: matches[i]
      };
    }

    i++;
  }
}

// These mappings map a character (key) to a specific digit that should
// replace it for normalization purposes. Non-European digits that
// may be used in phone numbers are mapped to a European equivalent.
//
// E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
//
var DIGITS = {
  '0': '0',
  '1': '1',
  '2': '2',
  '3': '3',
  '4': '4',
  '5': '5',
  '6': '6',
  '7': '7',
  '8': '8',
  '9': '9',
  "\uFF10": '0',
  // Fullwidth digit 0
  "\uFF11": '1',
  // Fullwidth digit 1
  "\uFF12": '2',
  // Fullwidth digit 2
  "\uFF13": '3',
  // Fullwidth digit 3
  "\uFF14": '4',
  // Fullwidth digit 4
  "\uFF15": '5',
  // Fullwidth digit 5
  "\uFF16": '6',
  // Fullwidth digit 6
  "\uFF17": '7',
  // Fullwidth digit 7
  "\uFF18": '8',
  // Fullwidth digit 8
  "\uFF19": '9',
  // Fullwidth digit 9
  "\u0660": '0',
  // Arabic-indic digit 0
  "\u0661": '1',
  // Arabic-indic digit 1
  "\u0662": '2',
  // Arabic-indic digit 2
  "\u0663": '3',
  // Arabic-indic digit 3
  "\u0664": '4',
  // Arabic-indic digit 4
  "\u0665": '5',
  // Arabic-indic digit 5
  "\u0666": '6',
  // Arabic-indic digit 6
  "\u0667": '7',
  // Arabic-indic digit 7
  "\u0668": '8',
  // Arabic-indic digit 8
  "\u0669": '9',
  // Arabic-indic digit 9
  "\u06F0": '0',
  // Eastern-Arabic digit 0
  "\u06F1": '1',
  // Eastern-Arabic digit 1
  "\u06F2": '2',
  // Eastern-Arabic digit 2
  "\u06F3": '3',
  // Eastern-Arabic digit 3
  "\u06F4": '4',
  // Eastern-Arabic digit 4
  "\u06F5": '5',
  // Eastern-Arabic digit 5
  "\u06F6": '6',
  // Eastern-Arabic digit 6
  "\u06F7": '7',
  // Eastern-Arabic digit 7
  "\u06F8": '8',
  // Eastern-Arabic digit 8
  "\u06F9": '9' // Eastern-Arabic digit 9

};
function parseDigit(character) {
  return DIGITS[character];
}
/**
 * Parses phone number digits from a string.
 * Drops all punctuation leaving only digits.
 * Also converts wide-ascii and arabic-indic numerals to conventional numerals.
 * E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
 * @param  {string} string
 * @return {string}
 * @example
 * ```js
 * parseDigits('8 (800) 555')
 * // Outputs '8800555'.
 * ```
 */

function parseDigits(string) {
  var result = ''; // Using `.split('')` here instead of normal `for ... of`
  // because the importing application doesn't neccessarily include an ES6 polyfill.
  // The `.split('')` approach discards "exotic" UTF-8 characters
  // (the ones consisting of four bytes) but digits
  // (including non-European ones) don't fall into that range
  // so such "exotic" characters would be discarded anyway.

  for (var _iterator = string.split(''), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var character = _ref;
    var digit = parseDigit(character);

    if (digit) {
      result += digit;
    }
  }

  return result;
}

/**
 * Parses phone number characters from a string.
 * Drops all punctuation leaving only digits and the leading `+` sign (if any).
 * Also converts wide-ascii and arabic-indic numerals to conventional numerals.
 * E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
 * @param  {string} string
 * @return {string}
 * @example
 * ```js
 * // Outputs '8800555'.
 * parseIncompletePhoneNumber('8 (800) 555')
 * // Outputs '+7800555'.
 * parseIncompletePhoneNumber('+7 800 555')
 * ```
 */

function parseIncompletePhoneNumber(string) {
  var result = ''; // Using `.split('')` here instead of normal `for ... of`
  // because the importing application doesn't neccessarily include an ES6 polyfill.
  // The `.split('')` approach discards "exotic" UTF-8 characters
  // (the ones consisting of four bytes) but digits
  // (including non-European ones) don't fall into that range
  // so such "exotic" characters would be discarded anyway.

  for (var _iterator = string.split(''), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var character = _ref;
    result += parsePhoneNumberCharacter(character, result) || '';
  }

  return result;
}
/**
 * Parses next character while parsing phone number digits (including a `+`)
 * from text: discards everything except `+` and digits, and `+` is only allowed
 * at the start of a phone number.
 * For example, is used in `react-phone-number-input` where it uses
 * [`input-format`](https://gitlab.com/catamphetamine/input-format).
 * @param  {string} character - Yet another character from raw input string.
 * @param  {string?} prevParsedCharacters - Previous parsed characters.
 * @param  {object} meta - Optional custom use-case-specific metadata.
 * @return {string?} The parsed character.
 */

function parsePhoneNumberCharacter(character, prevParsedCharacters) {
  // Only allow a leading `+`.
  if (character === '+') {
    // If this `+` is not the first parsed character
    // then discard it.
    if (prevParsedCharacters) {
      return;
    }

    return '+';
  } // Allow digits.


  return parseDigit(character);
}

/**
 * Merges two arrays.
 * @param  {*} a
 * @param  {*} b
 * @return {*}
 */
function mergeArrays(a, b) {
  var merged = a.slice();

  for (var _iterator = b, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var element = _ref;

    if (a.indexOf(element) < 0) {
      merged.push(element);
    }
  }

  return merged.sort(function (a, b) {
    return a - b;
  }); // ES6 version, requires Set polyfill.
  // let merged = new Set(a)
  // for (const element of b) {
  // 	merged.add(i)
  // }
  // return Array.from(merged).sort((a, b) => a - b)
}

function checkNumberLength(nationalNumber, metadata) {
  return checkNumberLengthForType(nationalNumber, undefined, metadata);
} // Checks whether a number is possible for the country based on its length.
// Should only be called for the "new" metadata which has "possible lengths".

function checkNumberLengthForType(nationalNumber, type, metadata) {
  var type_info = metadata.type(type); // There should always be "<possiblePengths/>" set for every type element.
  // This is declared in the XML schema.
  // For size efficiency, where a sub-description (e.g. fixed-line)
  // has the same "<possiblePengths/>" as the "general description", this is missing,
  // so we fall back to the "general description". Where no numbers of the type
  // exist at all, there is one possible length (-1) which is guaranteed
  // not to match the length of any real phone number.

  var possible_lengths = type_info && type_info.possibleLengths() || metadata.possibleLengths(); // let local_lengths    = type_info && type.possibleLengthsLocal() || metadata.possibleLengthsLocal()
  // Metadata before version `1.0.18` didn't contain `possible_lengths`.

  if (!possible_lengths) {
    return 'IS_POSSIBLE';
  }

  if (type === 'FIXED_LINE_OR_MOBILE') {
    // No such country in metadata.

    /* istanbul ignore next */
    if (!metadata.type('FIXED_LINE')) {
      // The rare case has been encountered where no fixedLine data is available
      // (true for some non-geographic entities), so we just check mobile.
      return checkNumberLengthForType(nationalNumber, 'MOBILE', metadata);
    }

    var mobile_type = metadata.type('MOBILE');

    if (mobile_type) {
      // Merge the mobile data in if there was any. "Concat" creates a new
      // array, it doesn't edit possible_lengths in place, so we don't need a copy.
      // Note that when adding the possible lengths from mobile, we have
      // to again check they aren't empty since if they are this indicates
      // they are the same as the general desc and should be obtained from there.
      possible_lengths = mergeArrays(possible_lengths, mobile_type.possibleLengths()); // The current list is sorted; we need to merge in the new list and
      // re-sort (duplicates are okay). Sorting isn't so expensive because
      // the lists are very small.
      // if (local_lengths) {
      // 	local_lengths = mergeArrays(local_lengths, mobile_type.possibleLengthsLocal())
      // } else {
      // 	local_lengths = mobile_type.possibleLengthsLocal()
      // }
    }
  } // If the type doesn't exist then return 'INVALID_LENGTH'.
  else if (type && !type_info) {
      return 'INVALID_LENGTH';
    }

  var actual_length = nationalNumber.length; // In `libphonenumber-js` all "local-only" formats are dropped for simplicity.
  // // This is safe because there is never an overlap beween the possible lengths
  // // and the local-only lengths; this is checked at build time.
  // if (local_lengths && local_lengths.indexOf(nationalNumber.length) >= 0)
  // {
  // 	return 'IS_POSSIBLE_LOCAL_ONLY'
  // }

  var minimum_length = possible_lengths[0];

  if (minimum_length === actual_length) {
    return 'IS_POSSIBLE';
  }

  if (minimum_length > actual_length) {
    return 'TOO_SHORT';
  }

  if (possible_lengths[possible_lengths.length - 1] < actual_length) {
    return 'TOO_LONG';
  } // We skip the first element since we've already checked it.


  return possible_lengths.indexOf(actual_length, 1) >= 0 ? 'IS_POSSIBLE' : 'INVALID_LENGTH';
}

function isPossiblePhoneNumber(input, options, metadata) {
  /* istanbul ignore if */
  if (options === undefined) {
    options = {};
  }

  metadata = new Metadata(metadata);

  if (options.v2) {
    if (!input.countryCallingCode) {
      throw new Error('Invalid phone number object passed');
    }

    metadata.selectNumberingPlan(input.countryCallingCode);
  } else {
    if (!input.phone) {
      return false;
    }

    if (input.country) {
      if (!metadata.hasCountry(input.country)) {
        throw new Error("Unknown country: ".concat(input.country));
      }

      metadata.country(input.country);
    } else {
      if (!input.countryCallingCode) {
        throw new Error('Invalid phone number object passed');
      }

      metadata.selectNumberingPlan(input.countryCallingCode);
    }
  }

  if (metadata.possibleLengths()) {
    return isPossibleNumber(input.phone || input.nationalNumber, metadata);
  } else {
    // There was a bug between `1.7.35` and `1.7.37` where "possible_lengths"
    // were missing for "non-geographical" numbering plans.
    // Just assume the number is possible in such cases:
    // it's unlikely that anyone generated their custom metadata
    // in that short period of time (one day).
    // This code can be removed in some future major version update.
    if (input.countryCallingCode && metadata.isNonGeographicCallingCode(input.countryCallingCode)) {
      // "Non-geographic entities" did't have `possibleLengths`
      // due to a bug in metadata generation process.
      return true;
    } else {
      throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
    }
  }
}
function isPossibleNumber(nationalNumber, metadata) {
  //, isInternational) {
  switch (checkNumberLength(nationalNumber, metadata)) {
    case 'IS_POSSIBLE':
      return true;
    // This library ignores "local-only" phone numbers (for simplicity).
    // See the readme for more info on what are "local-only" phone numbers.
    // case 'IS_POSSIBLE_LOCAL_ONLY':
    // 	return !isInternational

    default:
      return false;
  }
}

function _slicedToArray$1(arr, i) { return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _nonIterableRest$1(); }

function _nonIterableRest$1() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit$1(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$1(arr) { if (Array.isArray(arr)) return arr; }

/**
 * @param  {string} text - Phone URI (RFC 3966).
 * @return {object} `{ ?number, ?ext }`.
 */

function parseRFC3966(text) {
  var number;
  var ext; // Replace "tel:" with "tel=" for parsing convenience.

  text = text.replace(/^tel:/, 'tel=');

  for (var _iterator = text.split(';'), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var part = _ref;

    var _part$split = part.split('='),
        _part$split2 = _slicedToArray$1(_part$split, 2),
        name = _part$split2[0],
        value = _part$split2[1];

    switch (name) {
      case 'tel':
        number = value;
        break;

      case 'ext':
        ext = value;
        break;

      case 'phone-context':
        // Only "country contexts" are supported.
        // "Domain contexts" are ignored.
        if (value[0] === '+') {
          number = value + number;
        }

        break;
    }
  } // If the phone number is not viable, then abort.


  if (!isViablePhoneNumber(number)) {
    return {};
  }

  var result = {
    number: number
  };

  if (ext) {
    result.ext = ext;
  }

  return result;
}
/**
 * @param  {object} - `{ ?number, ?extension }`.
 * @return {string} Phone URI (RFC 3966).
 */

function formatRFC3966(_ref2) {
  var number = _ref2.number,
      ext = _ref2.ext;

  if (!number) {
    return '';
  }

  if (number[0] !== '+') {
    throw new Error("\"formatRFC3966()\" expects \"number\" to be in E.164 format.");
  }

  return "tel:".concat(number).concat(ext ? ';ext=' + ext : '');
}

/**
 * Checks whether the entire input sequence can be matched
 * against the regular expression.
 * @return {boolean}
 */
function matchesEntirely(text, regular_expression) {
  // If assigning the `''` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  text = text || '';
  return new RegExp('^(?:' + regular_expression + ')$').test(text);
}

var NON_FIXED_LINE_PHONE_TYPES = ['MOBILE', 'PREMIUM_RATE', 'TOLL_FREE', 'SHARED_COST', 'VOIP', 'PERSONAL_NUMBER', 'PAGER', 'UAN', 'VOICEMAIL']; // Finds out national phone number type (fixed line, mobile, etc)

function getNumberType(input, options, metadata) {
  // If assigning the `{}` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  options = options || {}; // When `parse()` returned `{}`
  // meaning that the phone number is not a valid one.

  if (!input.country) {
    return;
  }

  metadata = new Metadata(metadata);
  metadata.selectNumberingPlan(input.country, input.countryCallingCode);
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // The following is copy-pasted from the original function:
  // https://github.com/googlei18n/libphonenumber/blob/3ea547d4fbaa2d0b67588904dfa5d3f2557c27ff/javascript/i18n/phonenumbers/phonenumberutil.js#L2835
  // Is this national number even valid for this country

  if (!matchesEntirely(nationalNumber, metadata.nationalNumberPattern())) {
    return;
  } // Is it fixed line number


  if (isNumberTypeEqualTo(nationalNumber, 'FIXED_LINE', metadata)) {
    // Because duplicate regular expressions are removed
    // to reduce metadata size, if "mobile" pattern is ""
    // then it means it was removed due to being a duplicate of the fixed-line pattern.
    //
    if (metadata.type('MOBILE') && metadata.type('MOBILE').pattern() === '') {
      return 'FIXED_LINE_OR_MOBILE';
    } // v1 metadata.
    // Legacy.
    // Deprecated.


    if (!metadata.type('MOBILE')) {
      return 'FIXED_LINE_OR_MOBILE';
    } // Check if the number happens to qualify as both fixed line and mobile.
    // (no such country in the minimal metadata set)

    /* istanbul ignore if */


    if (isNumberTypeEqualTo(nationalNumber, 'MOBILE', metadata)) {
      return 'FIXED_LINE_OR_MOBILE';
    }

    return 'FIXED_LINE';
  }

  for (var _i = 0, _NON_FIXED_LINE_PHONE = NON_FIXED_LINE_PHONE_TYPES; _i < _NON_FIXED_LINE_PHONE.length; _i++) {
    var type = _NON_FIXED_LINE_PHONE[_i];

    if (isNumberTypeEqualTo(nationalNumber, type, metadata)) {
      return type;
    }
  }
}
function isNumberTypeEqualTo(nationalNumber, type, metadata) {
  type = metadata.type(type);

  if (!type || !type.pattern()) {
    return false;
  } // Check if any possible number lengths are present;
  // if so, we use them to avoid checking
  // the validation pattern if they don't match.
  // If they are absent, this means they match
  // the general description, which we have
  // already checked before a specific number type.


  if (type.possibleLengths() && type.possibleLengths().indexOf(nationalNumber.length) < 0) {
    return false;
  }

  return matchesEntirely(nationalNumber, type.pattern());
}

/**
 * Checks if a given phone number is valid.
 *
 * If the `number` is a string, it will be parsed to an object,
 * but only if it contains only valid phone number characters (including punctuation).
 * If the `number` is an object, it is used as is.
 *
 * The optional `defaultCountry` argument is the default country.
 * I.e. it does not restrict to just that country,
 * e.g. in those cases where several countries share
 * the same phone numbering rules (NANPA, Britain, etc).
 * For example, even though the number `07624 369230`
 * belongs to the Isle of Man ("IM" country code)
 * calling `isValidNumber('07624369230', 'GB', metadata)`
 * still returns `true` because the country is not restricted to `GB`,
 * it's just that `GB` is the default one for the phone numbering rules.
 * For restricting the country see `isValidNumberForRegion()`
 * though restricting a country might not be a good idea.
 * https://github.com/googlei18n/libphonenumber/blob/master/FAQ.md#when-should-i-use-isvalidnumberforregion
 *
 * Examples:
 *
 * ```js
 * isValidNumber('+78005553535', metadata)
 * isValidNumber('8005553535', 'RU', metadata)
 * isValidNumber('88005553535', 'RU', metadata)
 * isValidNumber({ phone: '8005553535', country: 'RU' }, metadata)
 * ```
 */

function isValidNumber(input, options, metadata) {
  // If assigning the `{}` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  options = options || {};
  metadata = new Metadata(metadata); // This is just to support `isValidNumber({})`
  // for cases when `parseNumber()` returns `{}`.

  if (!input.country) {
    return false;
  }

  metadata.selectNumberingPlan(input.country, input.countryCallingCode); // By default, countries only have type regexps when it's required for
  // distinguishing different countries having the same `countryCallingCode`.

  if (metadata.hasTypes()) {
    return getNumberType(input, options, metadata.metadata) !== undefined;
  } // If there are no type regexps for this country in metadata then use
  // `nationalNumberPattern` as a "better than nothing" replacement.


  var national_number = options.v2 ? input.nationalNumber : input.phone;
  return matchesEntirely(national_number, metadata.nationalNumberPattern());
}

//
// E.g. "(999) 111-22-33" -> "999 111 22 33"
//
// For some reason Google's metadata contains `<intlFormat/>`s with brackets and dashes.
// Meanwhile, there's no single opinion about using punctuation in international phone numbers.
//
// For example, Google's `<intlFormat/>` for USA is `+1 213-373-4253`.
// And here's a quote from WikiPedia's "North American Numbering Plan" page:
// https://en.wikipedia.org/wiki/North_American_Numbering_Plan
//
// "The country calling code for all countries participating in the NANP is 1.
// In international format, an NANP number should be listed as +1 301 555 01 00,
// where 301 is an area code (Maryland)."
//
// I personally prefer the international format without any punctuation.
// For example, brackets are remnants of the old age, meaning that the
// phone number part in brackets (so called "area code") can be omitted
// if dialing within the same "area".
// And hyphens were clearly introduced for splitting local numbers into memorizable groups.
// For example, remembering "5553535" is difficult but "555-35-35" is much simpler.
// Imagine a man taking a bus from home to work and seeing an ad with a phone number.
// He has a couple of seconds to memorize that number until it passes by.
// If it were spaces instead of hyphens the man wouldn't necessarily get it,
// but with hyphens instead of spaces the grouping is more explicit.
// I personally think that hyphens introduce visual clutter,
// so I prefer replacing them with spaces in international numbers.
// In the modern age all output is done on displays where spaces are clearly distinguishable
// so hyphens can be safely replaced with spaces without losing any legibility.
//

function applyInternationalSeparatorStyle(formattedNumber) {
  return formattedNumber.replace(new RegExp("[".concat(VALID_PUNCTUATION, "]+"), 'g'), ' ').trim();
}

// first group is not used in the national pattern (e.g. Argentina) so the $1
// group does not match correctly. Therefore, we use `\d`, so that the first
// group actually used in the pattern will be matched.

var FIRST_GROUP_PATTERN = /(\$\d)/;
function formatNationalNumberUsingFormat(number, format, _ref) {
  var useInternationalFormat = _ref.useInternationalFormat,
      withNationalPrefix = _ref.withNationalPrefix,
      carrierCode = _ref.carrierCode,
      metadata = _ref.metadata;
  var formattedNumber = number.replace(new RegExp(format.pattern()), useInternationalFormat ? format.internationalFormat() : // This library doesn't use `domestic_carrier_code_formatting_rule`,
  // because that one is only used when formatting phone numbers
  // for dialing from a mobile phone, and this is not a dialing library.
  // carrierCode && format.domesticCarrierCodeFormattingRule()
  // 	// First, replace the $CC in the formatting rule with the desired carrier code.
  // 	// Then, replace the $FG in the formatting rule with the first group
  // 	// and the carrier code combined in the appropriate way.
  // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
  // 	: (
  // 		withNationalPrefix && format.nationalPrefixFormattingRule()
  // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
  // 			: format.format()
  // 	)
  withNationalPrefix && format.nationalPrefixFormattingRule() ? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule()) : format.format());

  if (useInternationalFormat) {
    return applyInternationalSeparatorStyle(formattedNumber);
  }

  return formattedNumber;
}

/**
 * Pattern that makes it easy to distinguish whether a region has a single
 * international dialing prefix or not. If a region has a single international
 * prefix (e.g. 011 in USA), it will be represented as a string that contains
 * a sequence of ASCII digits, and possibly a tilde, which signals waiting for
 * the tone. If there are multiple available international prefixes in a
 * region, they will be represented as a regex string that always contains one
 * or more characters that are not ASCII digits or a tilde.
 */

var SINGLE_IDD_PREFIX_REG_EXP = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/; // For regions that have multiple IDD prefixes
// a preferred IDD prefix is returned.

function getIddPrefix(country, callingCode, metadata) {
  var countryMetadata = new Metadata(metadata);
  countryMetadata.selectNumberingPlan(country, callingCode);

  if (SINGLE_IDD_PREFIX_REG_EXP.test(countryMetadata.IDDPrefix())) {
    return countryMetadata.IDDPrefix();
  }

  return countryMetadata.defaultIDDPrefix();
}

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty$1(target, key, source[key]); }); } return target; }

function _defineProperty$1(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var DEFAULT_OPTIONS = {
  formatExtension: function formatExtension(formattedNumber, extension, metadata) {
    return "".concat(formattedNumber).concat(metadata.ext()).concat(extension);
  } // Formats a phone number
  //
  // Example use cases:
  //
  // ```js
  // formatNumber('8005553535', 'RU', 'INTERNATIONAL')
  // formatNumber('8005553535', 'RU', 'INTERNATIONAL', metadata)
  // formatNumber({ phone: '8005553535', country: 'RU' }, 'INTERNATIONAL')
  // formatNumber({ phone: '8005553535', country: 'RU' }, 'INTERNATIONAL', metadata)
  // formatNumber('+78005553535', 'NATIONAL')
  // formatNumber('+78005553535', 'NATIONAL', metadata)
  // ```
  //

};
function formatNumber$1(input, format, options, metadata) {
  // Apply default options.
  if (options) {
    options = _objectSpread({}, DEFAULT_OPTIONS, options);
  } else {
    options = DEFAULT_OPTIONS;
  }

  metadata = new Metadata(metadata);

  if (input.country && input.country !== '001') {
    // Validate `input.country`.
    if (!metadata.hasCountry(input.country)) {
      throw new Error("Unknown country: ".concat(input.country));
    }

    metadata.country(input.country);
  } else if (input.countryCallingCode) {
    metadata.selectNumberingPlan(input.countryCallingCode);
  } else return input.phone || '';

  var countryCallingCode = metadata.countryCallingCode();
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // This variable should have been declared inside `case`s
  // but Babel has a bug and it says "duplicate variable declaration".

  var number;

  switch (format) {
    case 'NATIONAL':
      // Legacy argument support.
      // (`{ country: ..., phone: '' }`)
      if (!nationalNumber) {
        return '';
      }

      number = formatNationalNumber(nationalNumber, input.carrierCode, 'NATIONAL', metadata, options);
      return addExtension(number, input.ext, metadata, options.formatExtension);

    case 'INTERNATIONAL':
      // Legacy argument support.
      // (`{ country: ..., phone: '' }`)
      if (!nationalNumber) {
        return "+".concat(countryCallingCode);
      }

      number = formatNationalNumber(nationalNumber, null, 'INTERNATIONAL', metadata, options);
      number = "+".concat(countryCallingCode, " ").concat(number);
      return addExtension(number, input.ext, metadata, options.formatExtension);

    case 'E.164':
      // `E.164` doesn't define "phone number extensions".
      return "+".concat(countryCallingCode).concat(nationalNumber);

    case 'RFC3966':
      return formatRFC3966({
        number: "+".concat(countryCallingCode).concat(nationalNumber),
        ext: input.ext
      });
    // For reference, here's Google's IDD formatter:
    // https://github.com/google/libphonenumber/blob/32719cf74e68796788d1ca45abc85dcdc63ba5b9/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L1546
    // Not saying that this IDD formatter replicates it 1:1, but it seems to work.
    // Who would even need to format phone numbers in IDD format anyway?

    case 'IDD':
      if (!options.fromCountry) {
        return; // throw new Error('`fromCountry` option not passed for IDD-prefixed formatting.')
      }

      var formattedNumber = formatIDD(nationalNumber, input.carrierCode, countryCallingCode, options.fromCountry, metadata);
      return addExtension(formattedNumber, input.ext, metadata, options.formatExtension);

    default:
      throw new Error("Unknown \"format\" argument passed to \"formatNumber()\": \"".concat(format, "\""));
  }
}

function formatNationalNumber(number, carrierCode, formatAs, metadata, options) {
  var format = chooseFormatForNumber(metadata.formats(), number);

  if (!format) {
    return number;
  }

  return formatNationalNumberUsingFormat(number, format, {
    useInternationalFormat: formatAs === 'INTERNATIONAL',
    withNationalPrefix: format.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && options && options.nationalPrefix === false ? false : true,
    carrierCode: carrierCode,
    metadata: metadata
  });
}

function chooseFormatForNumber(availableFormats, nationalNnumber) {
  for (var _iterator = availableFormats, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var format = _ref;

    // Validate leading digits
    if (format.leadingDigitsPatterns().length > 0) {
      // The last leading_digits_pattern is used here, as it is the most detailed
      var lastLeadingDigitsPattern = format.leadingDigitsPatterns()[format.leadingDigitsPatterns().length - 1]; // If leading digits don't match then move on to the next phone number format

      if (nationalNnumber.search(lastLeadingDigitsPattern) !== 0) {
        continue;
      }
    } // Check that the national number matches the phone number format regular expression


    if (matchesEntirely(nationalNnumber, format.pattern())) {
      return format;
    }
  }
}

function addExtension(formattedNumber, ext, metadata, formatExtension) {
  return ext ? formatExtension(formattedNumber, ext, metadata) : formattedNumber;
}

function formatIDD(nationalNumber, carrierCode, countryCallingCode, fromCountry, metadata) {
  var fromCountryCallingCode = getCountryCallingCode(fromCountry, metadata.metadata); // When calling within the same country calling code.

  if (fromCountryCallingCode === countryCallingCode) {
    var formattedNumber = formatNationalNumber(nationalNumber, carrierCode, 'NATIONAL', metadata); // For NANPA regions, return the national format for these regions
    // but prefix it with the country calling code.

    if (countryCallingCode === '1') {
      return countryCallingCode + ' ' + formattedNumber;
    } // If regions share a country calling code, the country calling code need
    // not be dialled. This also applies when dialling within a region, so this
    // if clause covers both these cases. Technically this is the case for
    // dialling from La Reunion to other overseas departments of France (French
    // Guiana, Martinique, Guadeloupe), but not vice versa - so we don't cover
    // this edge case for now and for those cases return the version including
    // country calling code. Details here:
    // http://www.petitfute.com/voyage/225-info-pratiques-reunion
    //


    return formattedNumber;
  }

  var iddPrefix = getIddPrefix(fromCountry, undefined, metadata.metadata);

  if (iddPrefix) {
    return "".concat(iddPrefix, " ").concat(countryCallingCode, " ").concat(formatNationalNumber(nationalNumber, null, 'INTERNATIONAL', metadata));
  }
}

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty$2(target, key, source[key]); }); } return target; }

function _defineProperty$2(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck$3(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$2(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$2(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$2(Constructor.prototype, protoProps); if (staticProps) _defineProperties$2(Constructor, staticProps); return Constructor; }

var PhoneNumber =
/*#__PURE__*/
function () {
  function PhoneNumber(countryCallingCode, nationalNumber, metadata) {
    _classCallCheck$3(this, PhoneNumber);

    if (!countryCallingCode) {
      throw new TypeError('`country` or `countryCallingCode` not passed');
    }

    if (!nationalNumber) {
      throw new TypeError('`nationalNumber` not passed');
    }

    var _metadata = new Metadata(metadata); // If country code is passed then derive `countryCallingCode` from it.
    // Also store the country code as `.country`.


    if (isCountryCode(countryCallingCode)) {
      this.country = countryCallingCode;

      _metadata.country(countryCallingCode);

      countryCallingCode = _metadata.countryCallingCode();
    }

    this.countryCallingCode = countryCallingCode;
    this.nationalNumber = nationalNumber;
    this.number = '+' + this.countryCallingCode + this.nationalNumber;
    this.metadata = metadata;
  }

  _createClass$2(PhoneNumber, [{
    key: "isPossible",
    value: function isPossible() {
      return isPossiblePhoneNumber(this, {
        v2: true
      }, this.metadata);
    }
  }, {
    key: "isValid",
    value: function isValid() {
      return isValidNumber(this, {
        v2: true
      }, this.metadata);
    }
  }, {
    key: "isNonGeographic",
    value: function isNonGeographic() {
      var metadata = new Metadata(this.metadata);
      return metadata.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function isEqual(phoneNumber) {
      return this.number === phoneNumber.number && this.ext === phoneNumber.ext;
    } // // Is just an alias for `this.isValid() && this.country === country`.
    // // https://github.com/googlei18n/libphonenumber/blob/master/FAQ.md#when-should-i-use-isvalidnumberforregion
    // isValidForRegion(country) {
    // 	return isValidNumberForRegion(this, country, { v2: true }, this.metadata)
    // }

  }, {
    key: "getType",
    value: function getType() {
      return getNumberType(this, {
        v2: true
      }, this.metadata);
    }
  }, {
    key: "format",
    value: function format(_format, options) {
      return formatNumber$1(this, _format, options ? _objectSpread$1({}, options, {
        v2: true
      }) : {
        v2: true
      }, this.metadata);
    }
  }, {
    key: "formatNational",
    value: function formatNational(options) {
      return this.format('NATIONAL', options);
    }
  }, {
    key: "formatInternational",
    value: function formatInternational(options) {
      return this.format('INTERNATIONAL', options);
    }
  }, {
    key: "getURI",
    value: function getURI(options) {
      return this.format('RFC3966', options);
    }
  }]);

  return PhoneNumber;
}();

var isCountryCode = function isCountryCode(value) {
  return /^[A-Z]{2}$/.test(value);
};

var CAPTURING_DIGIT_PATTERN = new RegExp('([' + VALID_DIGITS + '])');
function stripIddPrefix(number, country, callingCode, metadata) {
  if (!country) {
    return;
  } // Check if the number is IDD-prefixed.


  var countryMetadata = new Metadata(metadata);
  countryMetadata.selectNumberingPlan(country, callingCode);
  var IDDPrefixPattern = new RegExp(countryMetadata.IDDPrefix());

  if (number.search(IDDPrefixPattern) !== 0) {
    return;
  } // Strip IDD prefix.


  number = number.slice(number.match(IDDPrefixPattern)[0].length); // If there're any digits after an IDD prefix,
  // then those digits are a country calling code.
  // Since no country code starts with a `0`,
  // the code below validates that the next digit (if present) is not `0`.

  var matchedGroups = number.match(CAPTURING_DIGIT_PATTERN);

  if (matchedGroups && matchedGroups[1] != null && matchedGroups[1].length > 0) {
    if (matchedGroups[1] === '0') {
      return;
    }
  }

  return number;
}

/**
 * Strips any national prefix (such as 0, 1) present in a
 * (possibly incomplete) number provided.
 * "Carrier codes" are only used  in Colombia and Brazil,
 * and only when dialing within those countries from a mobile phone to a fixed line number.
 * Sometimes it won't actually strip national prefix
 * and will instead prepend some digits to the `number`:
 * for example, when number `2345678` is passed with `VI` country selected,
 * it will return `{ number: "3402345678" }`, because `340` area code is prepended.
 * @param {string} number — National number digits.
 * @param {object} metadata — Metadata with country selected.
 * @return {object} `{ nationalNumber: string, nationalPrefix: string? carrierCode: string? }`.
 */
function extractNationalNumberFromPossiblyIncompleteNumber(number, metadata) {
  if (number && metadata.numberingPlan.nationalPrefixForParsing()) {
    // See METADATA.md for the description of
    // `national_prefix_for_parsing` and `national_prefix_transform_rule`.
    // Attempt to parse the first digits as a national prefix.
    var prefixPattern = new RegExp('^(?:' + metadata.numberingPlan.nationalPrefixForParsing() + ')');
    var prefixMatch = prefixPattern.exec(number);

    if (prefixMatch) {
      var nationalNumber;
      var carrierCode; // https://gitlab.com/catamphetamine/libphonenumber-js/-/blob/master/METADATA.md#national_prefix_for_parsing--national_prefix_transform_rule
      // If a `national_prefix_for_parsing` has any "capturing groups"
      // then it means that the national (significant) number is equal to
      // those "capturing groups" transformed via `national_prefix_transform_rule`,
      // and nothing could be said about the actual national prefix:
      // what is it and was it even there.
      // If a `national_prefix_for_parsing` doesn't have any "capturing groups",
      // then everything it matches is a national prefix.
      // To determine whether `national_prefix_for_parsing` matched any
      // "capturing groups", the value of the result of calling `.exec()`
      // is looked at, and if it has non-undefined values where there're
      // "capturing groups" in the regular expression, then it means
      // that "capturing groups" have been matched.
      // It's not possible to tell whether there'll be any "capturing gropus"
      // before the matching process, because a `national_prefix_for_parsing`
      // could exhibit both behaviors.

      var capturedGroupsCount = prefixMatch.length - 1;
      var hasCapturedGroups = capturedGroupsCount > 0 && prefixMatch[capturedGroupsCount];

      if (metadata.nationalPrefixTransformRule() && hasCapturedGroups) {
        nationalNumber = number.replace(prefixPattern, metadata.nationalPrefixTransformRule()); // If there's more than one captured group,
        // then carrier code is the second one.

        if (capturedGroupsCount > 1) {
          carrierCode = prefixMatch[1];
        }
      } // If there're no "capturing groups",
      // or if there're "capturing groups" but no
      // `national_prefix_transform_rule`,
      // then just strip the national prefix from the number,
      // and possibly a carrier code.
      // Seems like there could be more.
      else {
          // `prefixBeforeNationalNumber` is the whole substring matched by
          // the `national_prefix_for_parsing` regular expression.
          // There seem to be no guarantees that it's just a national prefix.
          // For example, if there's a carrier code, it's gonna be a
          // part of `prefixBeforeNationalNumber` too.
          var prefixBeforeNationalNumber = prefixMatch[0];
          nationalNumber = number.slice(prefixBeforeNationalNumber.length); // If there's at least one captured group,
          // then carrier code is the first one.

          if (hasCapturedGroups) {
            carrierCode = prefixMatch[1];
          }
        } // Tries to guess whether a national prefix was present in the input.
      // This is not something copy-pasted from Google's library:
      // they don't seem to have an equivalent for that.
      // So this isn't an "officially approved" way of doing something like that.
      // But since there seems no other existing method, this library uses it.


      var nationalPrefix;

      if (hasCapturedGroups) {
        var possiblePositionOfTheFirstCapturedGroup = number.indexOf(prefixMatch[1]);
        var possibleNationalPrefix = number.slice(0, possiblePositionOfTheFirstCapturedGroup); // Example: an Argentinian (AR) phone number `0111523456789`.
        // `prefixMatch[0]` is `01115`, and `$1` is `11`,
        // and the rest of the phone number is `23456789`.
        // The national number is transformed via `9$1` to `91123456789`.
        // National prefix `0` is detected being present at the start.
        // if (possibleNationalPrefix.indexOf(metadata.numberingPlan.nationalPrefix()) === 0) {

        if (possibleNationalPrefix === metadata.numberingPlan.nationalPrefix()) {
          nationalPrefix = metadata.numberingPlan.nationalPrefix();
        }
      } else {
        nationalPrefix = prefixMatch[0];
      }

      return {
        nationalNumber: nationalNumber,
        nationalPrefix: nationalPrefix,
        carrierCode: carrierCode
      };
    }
  }

  return {
    nationalNumber: number
  };
}

/**
 * Strips national prefix and carrier code from a complete phone number.
 * The difference from the non-"FromCompleteNumber" function is that
 * it won't extract national prefix if the resultant number is too short
 * to be a complete number for the selected phone numbering plan.
 * @param  {string} number — Complete phone number digits.
 * @param  {Metadata} metadata — Metadata with a phone numbering plan selected.
 * @return {object} `{ nationalNumber: string, carrierCode: string? }`.
 */

function extractNationalNumber(number, metadata) {
  // Parsing national prefixes and carrier codes
  // is only required for local phone numbers
  // but some people don't understand that
  // and sometimes write international phone numbers
  // with national prefixes (or maybe even carrier codes).
  // http://ucken.blogspot.ru/2016/03/trunk-prefixes-in-skype4b.html
  // Google's original library forgives such mistakes
  // and so does this library, because it has been requested:
  // https://github.com/catamphetamine/libphonenumber-js/issues/127
  var _extractNationalNumbe = extractNationalNumberFromPossiblyIncompleteNumber(number, metadata),
      nationalNumber = _extractNationalNumbe.nationalNumber,
      carrierCode = _extractNationalNumbe.carrierCode;

  if (!shouldExtractNationalPrefix(number, nationalNumber, metadata)) {
    // Don't strip the national prefix.
    return {
      nationalNumber: number
    };
  } // If a national prefix has been extracted, check to see
  // if the resultant number isn't too short.
  // Same code in Google's `libphonenumber`:
  // https://github.com/google/libphonenumber/blob/e326fa1fc4283bb05eb35cb3c15c18f98a31af33/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L3291-L3302
  // For some reason, they do this check right after the `national_number_pattern` check
  // this library does in `shouldExtractNationalPrefix()` function.
  // Why is there a second "resultant" number validity check?
  // They don't provide an explanation.
  // This library just copies the behavior.


  if (number.length !== nationalNumber.length + (carrierCode ? carrierCode.length : 0)) {
    // If not using legacy generated metadata (before version `1.0.18`)
    // then it has "possible lengths", so use those to validate the number length.
    if (metadata.possibleLengths()) {
      // "We require that the NSN remaining after stripping the national prefix and
      // carrier code be long enough to be a possible length for the region.
      // Otherwise, we don't do the stripping, since the original number could be
      // a valid short number."
      // https://github.com/google/libphonenumber/blob/876268eb1ad6cdc1b7b5bef17fc5e43052702d57/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L3236-L3250
      switch (checkNumberLength(nationalNumber, metadata)) {
        case 'TOO_SHORT':
        case 'INVALID_LENGTH':
          // case 'IS_POSSIBLE_LOCAL_ONLY':
          // Don't strip the national prefix.
          return {
            nationalNumber: number
          };
      }
    }
  }

  return {
    nationalNumber: nationalNumber,
    carrierCode: carrierCode
  };
} // In some countries, the same digit could be a national prefix
// or a leading digit of a valid phone number.
// For example, in Russia, national prefix is `8`,
// and also `800 555 35 35` is a valid number
// in which `8` is not a national prefix, but the first digit
// of a national (significant) number.
// Same's with Belarus:
// `82004910060` is a valid national (significant) number,
// but `2004910060` is not.
// To support such cases (to prevent the code from always stripping
// national prefix), a condition is imposed: a national prefix
// is not extracted when the original number is "viable" and the
// resultant number is not, a "viable" national number being the one
// that matches `national_number_pattern`.

function shouldExtractNationalPrefix(number, nationalSignificantNumber, metadata) {
  // The equivalent in Google's code is:
  // https://github.com/google/libphonenumber/blob/e326fa1fc4283bb05eb35cb3c15c18f98a31af33/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L2969-L3004
  if (matchesEntirely(number, metadata.nationalNumberPattern()) && !matchesEntirely(nationalSignificantNumber, metadata.nationalNumberPattern())) {
    return false;
  } // Just "possible" number check would be more relaxed, so it's not used.
  // if (isPossibleNumber(number, metadata) &&
  // 	!isPossibleNumber(numberWithNationalPrefixExtracted, metadata)) {
  // 	return false
  // }


  return true;
}

/**
 * Sometimes some people incorrectly input international phone numbers
 * without the leading `+`. This function corrects such input.
 * @param  {string} number — Phone number digits.
 * @param  {string?} country
 * @param  {string?} callingCode
 * @param  {object} metadata
 * @return {object} `{ countryCallingCode: string?, number: string }`.
 */

function extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(number, country, callingCode, metadata) {
  var countryCallingCode = country ? getCountryCallingCode(country, metadata) : callingCode;

  if (number.indexOf(countryCallingCode) === 0) {
    metadata = new Metadata(metadata);
    metadata.selectNumberingPlan(country, callingCode);
    var possibleShorterNumber = number.slice(countryCallingCode.length);

    var _extractNationalNumbe = extractNationalNumber(possibleShorterNumber, metadata),
        possibleShorterNationalNumber = _extractNationalNumbe.nationalNumber;

    var _extractNationalNumbe2 = extractNationalNumber(number, metadata),
        nationalNumber = _extractNationalNumbe2.nationalNumber; // If the number was not valid before but is valid now,
    // or if it was too long before, we consider the number
    // with the country calling code stripped to be a better result
    // and keep that instead.
    // For example, in Germany (+49), `49` is a valid area code,
    // so if a number starts with `49`, it could be both a valid
    // national German number or an international number without
    // a leading `+`.


    if (!matchesEntirely(nationalNumber, metadata.nationalNumberPattern()) && matchesEntirely(possibleShorterNationalNumber, metadata.nationalNumberPattern()) || checkNumberLength(nationalNumber, metadata) === 'TOO_LONG') {
      return {
        countryCallingCode: countryCallingCode,
        number: possibleShorterNumber
      };
    }
  }

  return {
    number: number
  };
}

/**
 * Converts a phone number digits (possibly with a `+`)
 * into a calling code and the rest phone number digits.
 * The "rest phone number digits" could include
 * a national prefix, carrier code, and national
 * (significant) number.
 * @param  {string} number — Phone number digits (possibly with a `+`).
 * @param  {string} [country] — Default country.
 * @param  {string} [callingCode] — Default calling code (some phone numbering plans are non-geographic).
 * @param  {object} metadata
 * @return {object} `{ countryCallingCode: string?, number: string }`
 * @example
 * // Returns `{ countryCallingCode: "1", number: "2133734253" }`.
 * extractCountryCallingCode('2133734253', 'US', null, metadata)
 * extractCountryCallingCode('2133734253', null, '1', metadata)
 * extractCountryCallingCode('+12133734253', null, null, metadata)
 * extractCountryCallingCode('+12133734253', 'RU', null, metadata)
 */

function extractCountryCallingCode(number, country, callingCode, metadata) {
  if (!number) {
    return {};
  } // If this is not an international phone number,
  // then either extract an "IDD" prefix, or extract a
  // country calling code from a number by autocorrecting it
  // by prepending a leading `+` in cases when it starts
  // with the country calling code.
  // https://wikitravel.org/en/International_dialling_prefix
  // https://github.com/catamphetamine/libphonenumber-js/issues/376


  if (number[0] !== '+') {
    // Convert an "out-of-country" dialing phone number
    // to a proper international phone number.
    var numberWithoutIDD = stripIddPrefix(number, country, callingCode, metadata); // If an IDD prefix was stripped then
    // convert the number to international one
    // for subsequent parsing.

    if (numberWithoutIDD && numberWithoutIDD !== number) {
      number = '+' + numberWithoutIDD;
    } else {
      // Check to see if the number starts with the country calling code
      // for the default country. If so, we remove the country calling code,
      // and do some checks on the validity of the number before and after.
      // https://github.com/catamphetamine/libphonenumber-js/issues/376
      if (country || callingCode) {
        var _extractCountryCallin = extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(number, country, callingCode, metadata),
            countryCallingCode = _extractCountryCallin.countryCallingCode,
            shorterNumber = _extractCountryCallin.number;

        if (countryCallingCode) {
          return {
            countryCallingCode: countryCallingCode,
            number: shorterNumber
          };
        }
      }

      return {
        number: number
      };
    }
  } // Fast abortion: country codes do not begin with a '0'


  if (number[1] === '0') {
    return {};
  }

  metadata = new Metadata(metadata); // The thing with country phone codes
  // is that they are orthogonal to each other
  // i.e. there's no such country phone code A
  // for which country phone code B exists
  // where B starts with A.
  // Therefore, while scanning digits,
  // if a valid country code is found,
  // that means that it is the country code.
  //

  var i = 2;

  while (i - 1 <= MAX_LENGTH_COUNTRY_CODE && i <= number.length) {
    var _countryCallingCode = number.slice(1, i);

    if (metadata.hasCallingCode(_countryCallingCode)) {
      metadata.selectNumberingPlan(_countryCallingCode);
      return {
        countryCallingCode: _countryCallingCode,
        number: number.slice(i)
      };
    }

    i++;
  }

  return {};
}

function getCountryByCallingCode(callingCode, nationalPhoneNumber, metadata) {


  var possibleCountries = metadata.getCountryCodesForCallingCode(callingCode);

  if (!possibleCountries) {
    return;
  } // If there's just one country corresponding to the country code,
  // then just return it, without further phone number digits validation.


  if (possibleCountries.length === 1) {
    return possibleCountries[0];
  }

  return selectCountryFromList(possibleCountries, nationalPhoneNumber, metadata.metadata);
}

function selectCountryFromList(possibleCountries, nationalPhoneNumber, metadata) {
  // Re-create `metadata` because it will be selecting a `country`.
  metadata = new Metadata(metadata);

  for (var _iterator = possibleCountries, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var country = _ref;
    metadata.country(country); // Leading digits check would be the simplest one

    if (metadata.leadingDigits()) {
      if (nationalPhoneNumber && nationalPhoneNumber.search(metadata.leadingDigits()) === 0) {
        return country;
      }
    } // Else perform full validation with all of those
    // fixed-line/mobile/etc regular expressions.
    else if (getNumberType({
        phone: nationalPhoneNumber,
        country: country
      }, undefined, metadata.metadata)) {
        return country;
      }
  }
}

// This is a port of Google Android `libphonenumber`'s
// This prevents malicious input from consuming CPU.

var MAX_INPUT_STRING_LENGTH = 250; // This consists of the plus symbol, digits, and arabic-indic digits.

var PHONE_NUMBER_START_PATTERN = new RegExp('[' + PLUS_CHARS + VALID_DIGITS + ']'); // Regular expression of trailing characters that we want to remove.
// A trailing `#` is sometimes used when writing phone numbers with extensions in US.
// Example: "+1 (645) 123 1234-910#" number has extension "910".

var AFTER_PHONE_NUMBER_END_PATTERN = new RegExp('[^' + VALID_DIGITS + '#' + ']+$');
//
// ```js
// parse('8 (800) 555-35-35', 'RU')
// parse('8 (800) 555-35-35', 'RU', metadata)
// parse('8 (800) 555-35-35', { country: { default: 'RU' } })
// parse('8 (800) 555-35-35', { country: { default: 'RU' } }, metadata)
// parse('+7 800 555 35 35')
// parse('+7 800 555 35 35', metadata)
// ```
//

function parse(text, options, metadata) {
  // If assigning the `{}` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  options = options || {};
  metadata = new Metadata(metadata); // Validate `defaultCountry`.

  if (options.defaultCountry && !metadata.hasCountry(options.defaultCountry)) {
    if (options.v2) {
      throw new ParseError('INVALID_COUNTRY');
    }

    throw new Error("Unknown country: ".concat(options.defaultCountry));
  } // Parse the phone number.


  var _parseInput = parseInput(text, options.v2, options.extract),
      formattedPhoneNumber = _parseInput.number,
      ext = _parseInput.ext; // If the phone number is not viable then return nothing.


  if (!formattedPhoneNumber) {
    if (options.v2) {
      throw new ParseError('NOT_A_NUMBER');
    }

    return {};
  }

  var _parsePhoneNumber = parsePhoneNumber(formattedPhoneNumber, options.defaultCountry, options.defaultCallingCode, metadata),
      country = _parsePhoneNumber.country,
      nationalNumber = _parsePhoneNumber.nationalNumber,
      countryCallingCode = _parsePhoneNumber.countryCallingCode,
      carrierCode = _parsePhoneNumber.carrierCode;

  if (!metadata.hasSelectedNumberingPlan()) {
    if (options.v2) {
      throw new ParseError('INVALID_COUNTRY');
    }

    return {};
  } // Validate national (significant) number length.


  if (!nationalNumber || nationalNumber.length < MIN_LENGTH_FOR_NSN) {
    // Won't throw here because the regexp already demands length > 1.

    /* istanbul ignore if */
    if (options.v2) {
      throw new ParseError('TOO_SHORT');
    } // Google's demo just throws an error in this case.


    return {};
  } // Validate national (significant) number length.
  //
  // A sidenote:
  //
  // They say that sometimes national (significant) numbers
  // can be longer than `MAX_LENGTH_FOR_NSN` (e.g. in Germany).
  // https://github.com/googlei18n/libphonenumber/blob/7e1748645552da39c4e1ba731e47969d97bdb539/resources/phonenumber.proto#L36
  // Such numbers will just be discarded.
  //


  if (nationalNumber.length > MAX_LENGTH_FOR_NSN) {
    if (options.v2) {
      throw new ParseError('TOO_LONG');
    } // Google's demo just throws an error in this case.


    return {};
  }

  if (options.v2) {
    var phoneNumber = new PhoneNumber(countryCallingCode, nationalNumber, metadata.metadata);

    if (country) {
      phoneNumber.country = country;
    }

    if (carrierCode) {
      phoneNumber.carrierCode = carrierCode;
    }

    if (ext) {
      phoneNumber.ext = ext;
    }

    return phoneNumber;
  } // Check if national phone number pattern matches the number.
  // National number pattern is different for each country,
  // even for those ones which are part of the "NANPA" group.


  var valid = (options.extended ? metadata.hasSelectedNumberingPlan() : country) ? matchesEntirely(nationalNumber, metadata.nationalNumberPattern()) : false;

  if (!options.extended) {
    return valid ? result(country, nationalNumber, ext) : {};
  } // isInternational: countryCallingCode !== undefined


  return {
    country: country,
    countryCallingCode: countryCallingCode,
    carrierCode: carrierCode,
    valid: valid,
    possible: valid ? true : options.extended === true && metadata.possibleLengths() && isPossibleNumber(nationalNumber, metadata) ? true : false,
    phone: nationalNumber,
    ext: ext
  };
}
/**
 * Extracts a formatted phone number from text.
 * Doesn't guarantee that the extracted phone number
 * is a valid phone number (for example, doesn't validate its length).
 * @param  {string} text
 * @param  {boolean} [extract] — If `false`, then will parse the entire `text` as a phone number.
 * @param  {boolean} [throwOnError] — By default, it won't throw if the text is too long.
 * @return {string}
 * @example
 * // Returns "(213) 373-4253".
 * extractFormattedPhoneNumber("Call (213) 373-4253 for assistance.")
 */

function extractFormattedPhoneNumber(text, extract, throwOnError) {
  if (!text) {
    return;
  }

  if (text.length > MAX_INPUT_STRING_LENGTH) {
    if (throwOnError) {
      throw new ParseError('TOO_LONG');
    }

    return;
  }

  if (extract === false) {
    return text;
  } // Attempt to extract a possible number from the string passed in


  var startsAt = text.search(PHONE_NUMBER_START_PATTERN);

  if (startsAt < 0) {
    return;
  }

  return text // Trim everything to the left of the phone number
  .slice(startsAt) // Remove trailing non-numerical characters
  .replace(AFTER_PHONE_NUMBER_END_PATTERN, '');
}
/**
 * @param  {string} text - Input.
 * @param  {boolean} v2 - Legacy API functions don't pass `v2: true` flag.
 * @param  {boolean} [extract] - Whether to extract a phone number from `text`, or attempt to parse the entire text as a phone number.
 * @return {object} `{ ?number, ?ext }`.
 */


function parseInput(text, v2, extract) {
  // Parse RFC 3966 phone number URI.
  if (text && text.indexOf('tel:') === 0) {
    return parseRFC3966(text);
  }

  var number = extractFormattedPhoneNumber(text, extract, v2); // If the phone number is not viable, then abort.

  if (!number || !isViablePhoneNumber(number)) {
    return {};
  } // Attempt to parse extension first, since it doesn't require region-specific
  // data and we want to have the non-normalised number here.


  var withExtensionStripped = extractExtension(number);

  if (withExtensionStripped.ext) {
    return withExtensionStripped;
  }

  return {
    number: number
  };
}
/**
 * Creates `parse()` result object.
 */


function result(country, nationalNumber, ext) {
  var result = {
    country: country,
    phone: nationalNumber
  };

  if (ext) {
    result.ext = ext;
  }

  return result;
}
/**
 * Parses a viable phone number.
 * @param {string} formattedPhoneNumber — Example: "(213) 373-4253".
 * @param {string} [defaultCountry]
 * @param {string} [defaultCallingCode]
 * @param {Metadata} metadata
 * @return {object} Returns `{ country: string?, countryCallingCode: string?, nationalNumber: string? }`.
 */


function parsePhoneNumber(formattedPhoneNumber, defaultCountry, defaultCallingCode, metadata) {
  // Extract calling code from phone number.
  var _extractCountryCallin = extractCountryCallingCode(parseIncompletePhoneNumber(formattedPhoneNumber), defaultCountry, defaultCallingCode, metadata.metadata),
      countryCallingCode = _extractCountryCallin.countryCallingCode,
      number = _extractCountryCallin.number; // Choose a country by `countryCallingCode`.


  var country;

  if (countryCallingCode) {
    metadata.selectNumberingPlan(countryCallingCode);
  } // If `formattedPhoneNumber` is in "national" format
  // then `number` is defined and `countryCallingCode` isn't.
  else if (number && (defaultCountry || defaultCallingCode)) {
      metadata.selectNumberingPlan(defaultCountry, defaultCallingCode);

      if (defaultCountry) {
        country = defaultCountry;
      }

      countryCallingCode = defaultCallingCode || getCountryCallingCode(defaultCountry, metadata.metadata);
    } else return {};

  if (!number) {
    return {
      countryCallingCode: countryCallingCode
    };
  }

  var _extractNationalNumbe = extractNationalNumber(parseIncompletePhoneNumber(number), metadata),
      nationalNumber = _extractNationalNumbe.nationalNumber,
      carrierCode = _extractNationalNumbe.carrierCode; // Sometimes there are several countries
  // corresponding to the same country phone code
  // (e.g. NANPA countries all having `1` country phone code).
  // Therefore, to reliably determine the exact country,
  // national (significant) number should have been parsed first.
  //
  // When `metadata.json` is generated, all "ambiguous" country phone codes
  // get their countries populated with the full set of
  // "phone number type" regular expressions.
  //


  var exactCountry = getCountryByCallingCode(countryCallingCode, nationalNumber, metadata);

  if (exactCountry) {
    country = exactCountry;
    /* istanbul ignore if */

    if (exactCountry === '001') ; else {
      metadata.country(country);
    }
  }

  return {
    country: country,
    countryCallingCode: countryCallingCode,
    nationalNumber: nationalNumber,
    carrierCode: carrierCode
  };
}

function _defineProperties$3(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$3(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$3(Constructor.prototype, protoProps); if (staticProps) _defineProperties$3(Constructor, staticProps); return Constructor; }

function _classCallCheck$4(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// https://medium.com/dsinjs/implementing-lru-cache-in-javascript-94ba6755cda9
var Node = function Node(key, value) {
  var next = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var prev = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  _classCallCheck$4(this, Node);

  this.key = key;
  this.value = value;
  this.next = next;
  this.prev = prev;
};

var LRUCache =
/*#__PURE__*/
function () {
  //set default limit of 10 if limit is not passed.
  function LRUCache() {
    var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;

    _classCallCheck$4(this, LRUCache);

    this.size = 0;
    this.limit = limit;
    this.head = null;
    this.tail = null;
    this.cache = {};
  } // Write Node to head of LinkedList
  // update cache with Node key and Node reference


  _createClass$3(LRUCache, [{
    key: "put",
    value: function put(key, value) {
      this.ensureLimit();

      if (!this.head) {
        this.head = this.tail = new Node(key, value);
      } else {
        var node = new Node(key, value, this.head);
        this.head.prev = node;
        this.head = node;
      } //Update the cache map


      this.cache[key] = this.head;
      this.size++;
    } // Read from cache map and make that node as new Head of LinkedList

  }, {
    key: "get",
    value: function get(key) {
      if (this.cache[key]) {
        var value = this.cache[key].value; // node removed from it's position and cache

        this.remove(key); // write node again to the head of LinkedList to make it most recently used

        this.put(key, value);
        return value;
      }

      console.log("Item not available in cache for key ".concat(key));
    }
  }, {
    key: "ensureLimit",
    value: function ensureLimit() {
      if (this.size === this.limit) {
        this.remove(this.tail.key);
      }
    }
  }, {
    key: "remove",
    value: function remove(key) {
      var node = this.cache[key];

      if (node.prev !== null) {
        node.prev.next = node.next;
      } else {
        this.head = node.next;
      }

      if (node.next !== null) {
        node.next.prev = node.prev;
      } else {
        this.tail = node.prev;
      }

      delete this.cache[key];
      this.size--;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.head = null;
      this.tail = null;
      this.size = 0;
      this.cache = {};
    } // // Invokes the callback function with every node of the chain and the index of the node.
    // forEach(fn) {
    //   let node = this.head;
    //   let counter = 0;
    //   while (node) {
    //     fn(node, counter);
    //     node = node.next;
    //     counter++;
    //   }
    // }
    // // To iterate over LRU with a 'for...of' loop
    // *[Symbol.iterator]() {
    //   let node = this.head;
    //   while (node) {
    //     yield node;
    //     node = node.next;
    //   }
    // }

  }]);

  return LRUCache;
}();

function _classCallCheck$5(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$4(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$4(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$4(Constructor.prototype, protoProps); if (staticProps) _defineProperties$4(Constructor, staticProps); return Constructor; }
// countries being used for the same doc with ~10 patterns for each country. Some pages will have
// a lot more countries in use, but typically fewer numbers for each so expanding the cache for
// that use-case won't have a lot of benefit.

var RegExpCache =
/*#__PURE__*/
function () {
  function RegExpCache(size) {
    _classCallCheck$5(this, RegExpCache);

    this.cache = new LRUCache(size);
  }

  _createClass$4(RegExpCache, [{
    key: "getPatternForRegExp",
    value: function getPatternForRegExp(pattern) {
      var regExp = this.cache.get(pattern);

      if (!regExp) {
        regExp = new RegExp('^' + pattern);
        this.cache.put(pattern, regExp);
      }

      return regExp;
    }
  }]);

  return RegExpCache;
}();

/** Returns a regular expression quantifier with an upper and lower limit. */
function limit(lower, upper) {
  if (lower < 0 || upper <= 0 || upper < lower) {
    throw new TypeError();
  }

  return "{".concat(lower, ",").concat(upper, "}");
}
/**
 * Trims away any characters after the first match of {@code pattern} in {@code candidate},
 * returning the trimmed version.
 */

function trimAfterFirstMatch(regexp, string) {
  var index = string.search(regexp);

  if (index >= 0) {
    return string.slice(0, index);
  }

  return string;
}
function startsWith(string, substring) {
  return string.indexOf(substring) === 0;
}
function endsWith(string, substring) {
  return string.indexOf(substring, string.length - substring.length) === string.length - substring.length;
}

// Javascript doesn't support UTF-8 regular expressions.
// So mimicking them here.
// Copy-pasted from `PhoneNumberMatcher.js`.

/**
 * "\p{Z}" is any kind of whitespace or invisible separator ("Separator").
 * http://www.regular-expressions.info/unicode.html
 * "\P{Z}" is the reverse of "\p{Z}".
 * "\p{N}" is any kind of numeric character in any script ("Number").
 * "\p{Nd}" is a digit zero through nine in any script except "ideographic scripts" ("Decimal_Digit_Number").
 * "\p{Sc}" is a currency symbol ("Currency_Symbol").
 * "\p{L}" is any kind of letter from any language ("Letter").
 * "\p{Mn}" is "non-spacing mark".
 *
 * Javascript doesn't support Unicode Regular Expressions
 * so substituting it with this explicit set of characters.
 *
 * https://stackoverflow.com/questions/13210194/javascript-regex-equivalent-of-a-za-z-using-pl
 * https://github.com/danielberndt/babel-plugin-utf-8-regex/blob/master/src/transformer.js
 */
var _pZ = " \xA0\u1680\u180E\u2000-\u200A\u2028\u2029\u202F\u205F\u3000";
var pZ = "[".concat(_pZ, "]");
var PZ = "[^".concat(_pZ, "]");
var _pN = "0-9\xB2\xB3\xB9\xBC-\xBE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D66-\u0D75\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19"; // const pN = `[${_pN}]`

var _pNd = "0-9\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0BE6-\u0BEF\u0C66-\u0C6F\u0CE6-\u0CEF\u0D66-\u0D6F\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F29\u1040-\u1049\u1090-\u1099\u17E0-\u17E9\u1810-\u1819\u1946-\u194F\u19D0-\u19D9\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\uA620-\uA629\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19";
var pNd = "[".concat(_pNd, "]");
var _pL = "A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC";
var pL = "[".concat(_pL, "]");
var pL_regexp = new RegExp(pL);
var _pSc = "$\xA2-\xA5\u058F\u060B\u09F2\u09F3\u09FB\u0AF1\u0BF9\u0E3F\u17DB\u20A0-\u20B9\uA838\uFDFC\uFE69\uFF04\uFFE0\uFFE1\uFFE5\uFFE6";
var pSc = "[".concat(_pSc, "]");
var pSc_regexp = new RegExp(pSc);
var _pMn = "\u0300-\u036F\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08E4-\u08FE\u0900-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09C1-\u09C4\u09CD\u09E2\u09E3\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0B01\u0B3C\u0B3F\u0B41-\u0B44\u0B4D\u0B56\u0B62\u0B63\u0B82\u0BC0\u0BCD\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0CBC\u0CBF\u0CC6\u0CCC\u0CCD\u0CE2\u0CE3\u0D41-\u0D44\u0D4D\u0D62\u0D63\u0DCA\u0DD2-\u0DD4\u0DD6\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1B00-\u1B03\u1B34\u1B36-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1DC0-\u1DE6\u1DFC-\u1DFF\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302D\u3099\u309A\uA66F\uA674-\uA67D\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA8C4\uA8E0-\uA8F1\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE26";
var pMn = "[".concat(_pMn, "]");
var pMn_regexp = new RegExp(pMn);
var _InBasic_Latin = "\0-\x7F";
var _InLatin_1_Supplement = "\x80-\xFF";
var _InLatin_Extended_A = "\u0100-\u017F";
var _InLatin_Extended_Additional = "\u1E00-\u1EFF";
var _InLatin_Extended_B = "\u0180-\u024F";
var _InCombining_Diacritical_Marks = "\u0300-\u036F";
var latinLetterRegexp = new RegExp('[' + _InBasic_Latin + _InLatin_1_Supplement + _InLatin_Extended_A + _InLatin_Extended_Additional + _InLatin_Extended_B + _InCombining_Diacritical_Marks + ']');
/**
 * Helper method to determine if a character is a Latin-script letter or not.
 * For our purposes, combining marks should also return true since we assume
 * they have been added to a preceding Latin character.
 */

function isLatinLetter(letter) {
  // Combining marks are a subset of non-spacing-mark.
  if (!pL_regexp.test(letter) && !pMn_regexp.test(letter)) {
    return false;
  }

  return latinLetterRegexp.test(letter);
}
function isInvalidPunctuationSymbol(character) {
  return character === '%' || pSc_regexp.test(character);
}

/**
 * Leniency when finding potential phone numbers in text segments
 * The levels here are ordered in increasing strictness.
 */

var Leniency = {
  /**
   * Phone numbers accepted are "possible", but not necessarily "valid".
   */
  POSSIBLE: function POSSIBLE(number, candidate, metadata) {
    return true;
  },

  /**
   * Phone numbers accepted are "possible" and "valid".
   * Numbers written in national format must have their national-prefix
   * present if it is usually written for a number of this type.
   */
  VALID: function VALID(number, candidate, metadata) {
    if (!isValidNumber(number, undefined, metadata) || !containsOnlyValidXChars(number, candidate.toString())) {
      return false;
    } // Skipped for simplicity.
    // return isNationalPrefixPresentIfRequired(number, metadata)


    return true;
  },

  /**
   * Phone numbers accepted are "valid" and
   * are grouped in a possible way for this locale. For example, a US number written as
   * "65 02 53 00 00" and "650253 0000" are not accepted at this leniency level, whereas
   * "650 253 0000", "650 2530000" or "6502530000" are.
   * Numbers with more than one '/' symbol in the national significant number
   * are also dropped at this level.
   *
   * Warning: This level might result in lower coverage especially for regions outside of
   * country code "+1". If you are not sure about which level to use,
   * email the discussion group libphonenumber-discuss@googlegroups.com.
   */
  STRICT_GROUPING: function STRICT_GROUPING(number, candidate, metadata, regExpCache) {
    var candidateString = candidate.toString();

    if (!isValidNumber(number, undefined, metadata) || !containsOnlyValidXChars(number, candidateString) || containsMoreThanOneSlashInNationalNumber(number, candidateString) || !isNationalPrefixPresentIfRequired(number)) {
      return false;
    }

    return checkNumberGroupingIsValid(number, candidate, metadata, allNumberGroupsRemainGrouped, regExpCache);
  },

  /**
   * Phone numbers accepted are {@linkplain PhoneNumberUtil#isValidNumber(PhoneNumber) valid} and
   * are grouped in the same way that we would have formatted it, or as a single block. For
   * example, a US number written as "650 2530000" is not accepted at this leniency level, whereas
   * "650 253 0000" or "6502530000" are.
   * Numbers with more than one '/' symbol are also dropped at this level.
   * <p>
   * Warning: This level might result in lower coverage especially for regions outside of country
   * code "+1". If you are not sure about which level to use, email the discussion group
   * libphonenumber-discuss@googlegroups.com.
   */
  EXACT_GROUPING: function EXACT_GROUPING(number, candidate, metadata, regExpCache) {
    var candidateString = candidate.toString();

    if (!isValidNumber(number, undefined, metadata) || !containsOnlyValidXChars(number, candidateString) || containsMoreThanOneSlashInNationalNumber(number, candidateString) || !isNationalPrefixPresentIfRequired(number)) {
      return false;
    }

    return checkNumberGroupingIsValid(number, candidate, metadata, allNumberGroupsAreExactlyPresent, regExpCache);
  }
};

function containsOnlyValidXChars(number, candidate, metadata) {
  // The characters 'x' and 'X' can be (1) a carrier code, in which case they always precede the
  // national significant number or (2) an extension sign, in which case they always precede the
  // extension number. We assume a carrier code is more than 1 digit, so the first case has to
  // have more than 1 consecutive 'x' or 'X', whereas the second case can only have exactly 1 'x'
  // or 'X'. We ignore the character if it appears as the last character of the string.
  for (var index = 0; index < candidate.length - 1; index++) {
    var charAtIndex = candidate.charAt(index);

    if (charAtIndex === 'x' || charAtIndex === 'X') {
      var charAtNextIndex = candidate.charAt(index + 1);

      if (charAtNextIndex === 'x' || charAtNextIndex === 'X') {
        // This is the carrier code case, in which the 'X's always precede the national
        // significant number.
        index++;

        if (util.isNumberMatch(number, candidate.substring(index)) != MatchType.NSN_MATCH) {
          return false;
        } // This is the extension sign case, in which the 'x' or 'X' should always precede the
        // extension number.

      } else if (parseDigits(candidate.substring(index)) !== number.ext) {
        return false;
      }
    }
  }

  return true;
}

function isNationalPrefixPresentIfRequired(number, _metadata) {
  // First, check how we deduced the country code. If it was written in international format, then
  // the national prefix is not required.
  if (number.getCountryCodeSource() != 'FROM_DEFAULT_COUNTRY') {
    return true;
  }

  var phoneNumberRegion = util.getRegionCodeForCountryCode(number.getCountryCode());
  var metadata = util.getMetadataForRegion(phoneNumberRegion);

  if (metadata == null) {
    return true;
  } // Check if a national prefix should be present when formatting this number.


  var nationalNumber = util.getNationalSignificantNumber(number);
  var formatRule = util.chooseFormattingPatternForNumber(metadata.numberFormats(), nationalNumber); // To do this, we check that a national prefix formatting rule was present
  // and that it wasn't just the first-group symbol ($1) with punctuation.

  if (formatRule && formatRule.getNationalPrefixFormattingRule().length > 0) {
    if (formatRule.getNationalPrefixOptionalWhenFormatting()) {
      // The national-prefix is optional in these cases, so we don't need to check if it was
      // present.
      return true;
    }

    if (PhoneNumberUtil.formattingRuleHasFirstGroupOnly(formatRule.getNationalPrefixFormattingRule())) {
      // National Prefix not needed for this number.
      return true;
    } // Normalize the remainder.


    var rawInputCopy = PhoneNumberUtil.normalizeDigitsOnly(number.getRawInput()); // Check if we found a national prefix and/or carrier code at the start of the raw input, and
    // return the result.

    return util.maybeStripNationalPrefixAndCarrierCode(rawInputCopy, metadata, null);
  }

  return true;
}

function containsMoreThanOneSlashInNationalNumber(number, candidate) {
  var firstSlashInBodyIndex = candidate.indexOf('/');

  if (firstSlashInBodyIndex < 0) {
    // No slashes, this is okay.
    return false;
  } // Now look for a second one.


  var secondSlashInBodyIndex = candidate.indexOf('/', firstSlashInBodyIndex + 1);

  if (secondSlashInBodyIndex < 0) {
    // Only one slash, this is okay.
    return false;
  } // If the first slash is after the country calling code, this is permitted.


  var candidateHasCountryCode = number.getCountryCodeSource() === CountryCodeSource.FROM_NUMBER_WITH_PLUS_SIGN || number.getCountryCodeSource() === CountryCodeSource.FROM_NUMBER_WITHOUT_PLUS_SIGN;

  if (candidateHasCountryCode && PhoneNumberUtil.normalizeDigitsOnly(candidate.substring(0, firstSlashInBodyIndex)) === String(number.getCountryCode())) {
    // Any more slashes and this is illegal.
    return candidate.slice(secondSlashInBodyIndex + 1).indexOf('/') >= 0;
  }

  return true;
}

function checkNumberGroupingIsValid(number, candidate, metadata, checkGroups, regExpCache) {
  var normalizedCandidate = normalizeDigits(candidate, true
  /* keep non-digits */
  );
  var formattedNumberGroups = getNationalNumberGroups(metadata, number, null);

  if (checkGroups(metadata, number, normalizedCandidate, formattedNumberGroups)) {
    return true;
  } // If this didn't pass, see if there are any alternate formats that match, and try them instead.


  var alternateFormats = MetadataManager.getAlternateFormatsForCountry(number.getCountryCode());
  var nationalSignificantNumber = util.getNationalSignificantNumber(number);

  if (alternateFormats) {
    for (var _iterator = alternateFormats.numberFormats(), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var alternateFormat = _ref;

      if (alternateFormat.leadingDigitsPatterns().length > 0) {
        // There is only one leading digits pattern for alternate formats.
        var leadingDigitsRegExp = regExpCache.getPatternForRegExp('^' + alternateFormat.leadingDigitsPatterns()[0]);

        if (!leadingDigitsRegExp.test(nationalSignificantNumber)) {
          // Leading digits don't match; try another one.
          continue;
        }
      }

      formattedNumberGroups = getNationalNumberGroups(metadata, number, alternateFormat);

      if (checkGroups(metadata, number, normalizedCandidate, formattedNumberGroups)) {
        return true;
      }
    }
  }

  return false;
}
/**
 * Helper method to get the national-number part of a number, formatted without any national
 * prefix, and return it as a set of digit blocks that would be formatted together following
 * standard formatting rules.
 */


function getNationalNumberGroups(metadata, number, formattingPattern) {
  if (formattingPattern) {
    // We format the NSN only, and split that according to the separator.
    var nationalSignificantNumber = util.getNationalSignificantNumber(number);
    return util.formatNsnUsingPattern(nationalSignificantNumber, formattingPattern, 'RFC3966', metadata).split('-');
  } // This will be in the format +CC-DG1-DG2-DGX;ext=EXT where DG1..DGX represents groups of digits.


  var rfc3966Format = formatNumber(number, 'RFC3966', metadata); // We remove the extension part from the formatted string before splitting it into different
  // groups.

  var endIndex = rfc3966Format.indexOf(';');

  if (endIndex < 0) {
    endIndex = rfc3966Format.length;
  } // The country-code will have a '-' following it.


  var startIndex = rfc3966Format.indexOf('-') + 1;
  return rfc3966Format.slice(startIndex, endIndex).split('-');
}

function allNumberGroupsAreExactlyPresent(metadata, number, normalizedCandidate, formattedNumberGroups) {
  var candidateGroups = normalizedCandidate.split(NON_DIGITS_PATTERN); // Set this to the last group, skipping it if the number has an extension.

  var candidateNumberGroupIndex = number.hasExtension() ? candidateGroups.length - 2 : candidateGroups.length - 1; // First we check if the national significant number is formatted as a block.
  // We use contains and not equals, since the national significant number may be present with
  // a prefix such as a national number prefix, or the country code itself.

  if (candidateGroups.length == 1 || candidateGroups[candidateNumberGroupIndex].contains(util.getNationalSignificantNumber(number))) {
    return true;
  } // Starting from the end, go through in reverse, excluding the first group, and check the
  // candidate and number groups are the same.


  var formattedNumberGroupIndex = formattedNumberGroups.length - 1;

  while (formattedNumberGroupIndex > 0 && candidateNumberGroupIndex >= 0) {
    if (candidateGroups[candidateNumberGroupIndex] !== formattedNumberGroups[formattedNumberGroupIndex]) {
      return false;
    }

    formattedNumberGroupIndex--;
    candidateNumberGroupIndex--;
  } // Now check the first group. There may be a national prefix at the start, so we only check
  // that the candidate group ends with the formatted number group.


  return candidateNumberGroupIndex >= 0 && endsWith(candidateGroups[candidateNumberGroupIndex], formattedNumberGroups[0]);
}

function allNumberGroupsRemainGrouped(metadata, number, normalizedCandidate, formattedNumberGroups) {
  var fromIndex = 0;

  if (number.getCountryCodeSource() !== CountryCodeSource.FROM_DEFAULT_COUNTRY) {
    // First skip the country code if the normalized candidate contained it.
    var countryCode = String(number.getCountryCode());
    fromIndex = normalizedCandidate.indexOf(countryCode) + countryCode.length();
  } // Check each group of consecutive digits are not broken into separate groupings in the
  // {@code normalizedCandidate} string.


  for (var i = 0; i < formattedNumberGroups.length; i++) {
    // Fails if the substring of {@code normalizedCandidate} starting from {@code fromIndex}
    // doesn't contain the consecutive digits in formattedNumberGroups[i].
    fromIndex = normalizedCandidate.indexOf(formattedNumberGroups[i], fromIndex);

    if (fromIndex < 0) {
      return false;
    } // Moves {@code fromIndex} forward.


    fromIndex += formattedNumberGroups[i].length();

    if (i == 0 && fromIndex < normalizedCandidate.length()) {
      // We are at the position right after the NDC. We get the region used for formatting
      // information based on the country code in the phone number, rather than the number itself,
      // as we do not need to distinguish between different countries with the same country
      // calling code and this is faster.
      var region = util.getRegionCodeForCountryCode(number.getCountryCode());

      if (util.getNddPrefixForRegion(region, true) != null && Character.isDigit(normalizedCandidate.charAt(fromIndex))) {
        // This means there is no formatting symbol after the NDC. In this case, we only
        // accept the number if there is no formatting symbol at all in the number, except
        // for extensions. This is only important for countries with national prefixes.
        var nationalSignificantNumber = util.getNationalSignificantNumber(number);
        return startsWith(normalizedCandidate.slice(fromIndex - formattedNumberGroups[i].length), nationalSignificantNumber);
      }
    }
  } // The check here makes sure that we haven't mistakenly already used the extension to
  // match the last group of the subscriber number. Note the extension cannot have
  // formatting in-between digits.


  return normalizedCandidate.slice(fromIndex).contains(number.getExtension());
}

// of parsing. This allows us to strip off parts of the number that are actually the start of
// another number, such as for: (530) 583-6985 x302/x2303 -> the second extension here makes this
// actually two phone numbers, (530) 583-6985 x302 and (530) 583-6985 x2303. We remove the second
// extension so that the first number is parsed correctly.
//
// Matches a slash (\ or /) followed by a space followed by an `x`.
//

var SECOND_NUMBER_START_PATTERN = /[\\/] *x/;
function parsePreCandidate(candidate) {
  // Check for extra numbers at the end.
  // TODO: This is the place to start when trying to support extraction of multiple phone number
  // from split notations (+41 79 123 45 67 / 68).
  return trimAfterFirstMatch(SECOND_NUMBER_START_PATTERN, candidate);
}

// Matches strings that look like dates using "/" as a separator.
// Examples: 3/10/2011, 31/10/96 or 08/31/95.
var SLASH_SEPARATED_DATES = /(?:(?:[0-3]?\d\/[01]?\d)|(?:[01]?\d\/[0-3]?\d))\/(?:[12]\d)?\d{2}/; // Matches timestamps.
// Examples: "2012-01-02 08:00".
// Note that the reg-ex does not include the
// trailing ":\d\d" -- that is covered by TIME_STAMPS_SUFFIX.

var TIME_STAMPS = /[12]\d{3}[-/]?[01]\d[-/]?[0-3]\d +[0-2]\d$/;
var TIME_STAMPS_SUFFIX_LEADING = /^:[0-5]\d/;
function isValidPreCandidate(candidate, offset, text) {
  // Skip a match that is more likely to be a date.
  if (SLASH_SEPARATED_DATES.test(candidate)) {
    return false;
  } // Skip potential time-stamps.


  if (TIME_STAMPS.test(candidate)) {
    var followingText = text.slice(offset + candidate.length);

    if (TIME_STAMPS_SUFFIX_LEADING.test(followingText)) {
      return false;
    }
  }

  return true;
}

// Copy-pasted from `PhoneNumberMatcher.js`.
var OPENING_PARENS = "(\\[\uFF08\uFF3B";
var CLOSING_PARENS = ")\\]\uFF09\uFF3D";
var NON_PARENS = "[^".concat(OPENING_PARENS).concat(CLOSING_PARENS, "]");
var LEAD_CLASS = "[".concat(OPENING_PARENS).concat(PLUS_CHARS, "]"); // Punctuation that may be at the start of a phone number - brackets and plus signs.

var LEAD_CLASS_LEADING = new RegExp('^' + LEAD_CLASS); // Limit on the number of pairs of brackets in a phone number.

var BRACKET_PAIR_LIMIT = limit(0, 3);
/**
 * Pattern to check that brackets match. Opening brackets should be closed within a phone number.
 * This also checks that there is something inside the brackets. Having no brackets at all is also
 * fine.
 *
 * An opening bracket at the beginning may not be closed, but subsequent ones should be.  It's
 * also possible that the leading bracket was dropped, so we shouldn't be surprised if we see a
 * closing bracket first. We limit the sets of brackets in a phone number to four.
 */

var MATCHING_BRACKETS_ENTIRE = new RegExp('^' + "(?:[" + OPENING_PARENS + "])?" + "(?:" + NON_PARENS + "+" + "[" + CLOSING_PARENS + "])?" + NON_PARENS + "+" + "(?:[" + OPENING_PARENS + "]" + NON_PARENS + "+[" + CLOSING_PARENS + "])" + BRACKET_PAIR_LIMIT + NON_PARENS + "*" + '$');
/**
 * Matches strings that look like publication pages. Example:
 * <pre>Computing Complete Answers to Queries in the Presence of Limited Access Patterns.
 * Chen Li. VLDB J. 12(3): 211-227 (2003).</pre>
 *
 * The string "211-227 (2003)" is not a telephone number.
 */

var PUB_PAGES = /\d{1,5}-+\d{1,5}\s{0,4}\(\d{1,4}/;
function isValidCandidate(candidate, offset, text, leniency) {
  // Check the candidate doesn't contain any formatting
  // which would indicate that it really isn't a phone number.
  if (!MATCHING_BRACKETS_ENTIRE.test(candidate) || PUB_PAGES.test(candidate)) {
    return;
  } // If leniency is set to VALID or stricter, we also want to skip numbers that are surrounded
  // by Latin alphabetic characters, to skip cases like abc8005001234 or 8005001234def.


  if (leniency !== 'POSSIBLE') {
    // If the candidate is not at the start of the text,
    // and does not start with phone-number punctuation,
    // check the previous character.
    if (offset > 0 && !LEAD_CLASS_LEADING.test(candidate)) {
      var previousChar = text[offset - 1]; // We return null if it is a latin letter or an invalid punctuation symbol.

      if (isInvalidPunctuationSymbol(previousChar) || isLatinLetter(previousChar)) {
        return false;
      }
    }

    var lastCharIndex = offset + candidate.length;

    if (lastCharIndex < text.length) {
      var nextChar = text[lastCharIndex];

      if (isInvalidPunctuationSymbol(nextChar) || isLatinLetter(nextChar)) {
        return false;
      }
    }
  }

  return true;
}

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty$3(target, key, source[key]); }); } return target; }

function _classCallCheck$6(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$5(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$5(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$5(Constructor.prototype, protoProps); if (staticProps) _defineProperties$5(Constructor, staticProps); return Constructor; }

function _defineProperty$3(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var EXTN_PATTERNS_FOR_MATCHING = createExtensionPattern();
/**
 * Patterns used to extract phone numbers from a larger phone-number-like pattern. These are
 * ordered according to specificity. For example, white-space is last since that is frequently
 * used in numbers, not just to separate two numbers. We have separate patterns since we don't
 * want to break up the phone-number-like text on more than one different kind of symbol at one
 * time, although symbols of the same type (e.g. space) can be safely grouped together.
 *
 * Note that if there is a match, we will always check any text found up to the first match as
 * well.
 */

var INNER_MATCHES = [// Breaks on the slash - e.g. "651-234-2345/332-445-1234"
'\\/+(.*)/', // Note that the bracket here is inside the capturing group, since we consider it part of the
// phone number. Will match a pattern like "(650) 223 3345 (754) 223 3321".
'(\\([^(]*)', // Breaks on a hyphen - e.g. "12345 - 332-445-1234 is my number."
// We require a space on either side of the hyphen for it to be considered a separator.
"(?:".concat(pZ, "-|-").concat(pZ, ")").concat(pZ, "*(.+)"), // Various types of wide hyphens. Note we have decided not to enforce a space here, since it's
// possible that it's supposed to be used to break two numbers without spaces, and we haven't
// seen many instances of it used within a number.
"[\u2012-\u2015\uFF0D]".concat(pZ, "*(.+)"), // Breaks on a full stop - e.g. "12345. 332-445-1234 is my number."
"\\.+".concat(pZ, "*([^.]+)"), // Breaks on space - e.g. "3324451234 8002341234"
"".concat(pZ, "+(").concat(PZ, "+)")]; // Limit on the number of leading (plus) characters.

var leadLimit = limit(0, 2); // Limit on the number of consecutive punctuation characters.

var punctuationLimit = limit(0, 4);
/* The maximum number of digits allowed in a digit-separated block. As we allow all digits in a
 * single block, set high enough to accommodate the entire national number and the international
 * country code. */

var digitBlockLimit = MAX_LENGTH_FOR_NSN + MAX_LENGTH_COUNTRY_CODE; // Limit on the number of blocks separated by punctuation.
// Uses digitBlockLimit since some formats use spaces to separate each digit.

var blockLimit = limit(0, digitBlockLimit);
/* A punctuation sequence allowing white space. */

var punctuation = "[".concat(VALID_PUNCTUATION, "]") + punctuationLimit; // A digits block without punctuation.

var digitSequence = pNd + limit(1, digitBlockLimit);
/**
 * Phone number pattern allowing optional punctuation.
 * The phone number pattern used by `find()`, similar to
 * VALID_PHONE_NUMBER, but with the following differences:
 * <ul>
 *   <li>All captures are limited in order to place an upper bound to the text matched by the
 *       pattern.
 * <ul>
 *   <li>Leading punctuation / plus signs are limited.
 *   <li>Consecutive occurrences of punctuation are limited.
 *   <li>Number of digits is limited.
 * </ul>
 *   <li>No whitespace is allowed at the start or end.
 *   <li>No alpha digits (vanity numbers such as 1-800-SIX-FLAGS) are currently supported.
 * </ul>
 */

var PATTERN = '(?:' + LEAD_CLASS + punctuation + ')' + leadLimit + digitSequence + '(?:' + punctuation + digitSequence + ')' + blockLimit + '(?:' + EXTN_PATTERNS_FOR_MATCHING + ')?'; // Regular expression of trailing characters that we want to remove.
// We remove all characters that are not alpha or numerical characters.
// The hash character is retained here, as it may signify
// the previous block was an extension.
//
// // Don't know what does '&&' mean here.
// const UNWANTED_END_CHAR_PATTERN = new RegExp(`[[\\P{N}&&\\P{L}]&&[^#]]+$`)
//

var UNWANTED_END_CHAR_PATTERN = new RegExp("[^".concat(_pN).concat(_pL, "#]+$"));
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || Math.pow(2, 53) - 1;
/**
 * A stateful class that finds and extracts telephone numbers from {@linkplain CharSequence text}.
 * Instances can be created using the {@linkplain PhoneNumberUtil#findNumbers factory methods} in
 * {@link PhoneNumberUtil}.
 *
 * <p>Vanity numbers (phone numbers using alphabetic digits such as <tt>1-800-SIX-FLAGS</tt> are
 * not found.
 *
 * <p>This class is not thread-safe.
 */

var PhoneNumberMatcher =
/*#__PURE__*/
function () {
  /** The iteration tristate. */

  /** The next index to start searching at. Undefined in {@link State#DONE}. */
  // A cache for frequently used country-specific regular expressions. Set to 32 to cover ~2-3
  // countries being used for the same doc with ~10 patterns for each country. Some pages will have
  // a lot more countries in use, but typically fewer numbers for each so expanding the cache for
  // that use-case won't have a lot of benefit.

  /**
   * Creates a new instance. See the factory methods in {@link PhoneNumberUtil} on how to obtain a
   * new instance.
   *
   * @param util  the phone number util to use
   * @param text  the character sequence that we will search, null for no text
   * @param country  the country to assume for phone numbers not written in international format
   *     (with a leading plus, or with the international dialing prefix of the specified region).
   *     May be null or "ZZ" if only numbers with a leading plus should be
   *     considered.
   * @param leniency  the leniency to use when evaluating candidate phone numbers
   * @param maxTries  the maximum number of invalid numbers to try before giving up on the text.
   *     This is to cover degenerate cases where the text has a lot of false positives in it. Must
   *     be {@code >= 0}.
   */
  function PhoneNumberMatcher() {
    var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var metadata = arguments.length > 2 ? arguments[2] : undefined;

    _classCallCheck$6(this, PhoneNumberMatcher);

    _defineProperty$3(this, "state", 'NOT_READY');

    _defineProperty$3(this, "searchIndex", 0);

    _defineProperty$3(this, "regExpCache", new RegExpCache(32));

    options = _objectSpread$2({}, options, {
      defaultCallingCode: options.defaultCallingCode,
      defaultCountry: options.defaultCountry && isSupportedCountry(options.defaultCountry, metadata) ? options.defaultCountry : undefined,
      leniency: options.leniency || options.extended ? 'POSSIBLE' : 'VALID',
      maxTries: options.maxTries || MAX_SAFE_INTEGER
    });

    if (!options.leniency) {
      throw new TypeError('`Leniency` not supplied');
    }

    if (options.maxTries < 0) {
      throw new TypeError('`maxTries` not supplied');
    }

    this.text = text;
    this.options = options;
    this.metadata = metadata;
    /** The degree of validation requested. */

    this.leniency = Leniency[options.leniency];

    if (!this.leniency) {
      throw new TypeError("Unknown leniency: ".concat(options.leniency, "."));
    }
    /** The maximum number of retries after matching an invalid number. */


    this.maxTries = options.maxTries;
    this.PATTERN = new RegExp(PATTERN, 'ig');
  }
  /**
   * Attempts to find the next subsequence in the searched sequence on or after {@code searchIndex}
   * that represents a phone number. Returns the next match, null if none was found.
   *
   * @param index  the search index to start searching at
   * @return  the phone number match found, null if none can be found
   */


  _createClass$5(PhoneNumberMatcher, [{
    key: "find",
    value: function find() {
      // // Reset the regular expression.
      // this.PATTERN.lastIndex = index
      var matches;

      while (this.maxTries > 0 && (matches = this.PATTERN.exec(this.text)) !== null) {
        var candidate = matches[0];
        var offset = matches.index;
        candidate = parsePreCandidate(candidate);

        if (isValidPreCandidate(candidate, offset, this.text)) {
          var match = // Try to come up with a valid match given the entire candidate.
          this.parseAndVerify(candidate, offset, this.text) // If that failed, try to find an "inner match" -
          // there might be a phone number within this candidate.
          || this.extractInnerMatch(candidate, offset, this.text);

          if (match) {
            if (this.options.v2) {
              var phoneNumber = new PhoneNumber(match.country || match.countryCallingCode, match.phone, this.metadata);

              if (match.ext) {
                phoneNumber.ext = match.ext;
              }

              return {
                startsAt: match.startsAt,
                endsAt: match.endsAt,
                number: phoneNumber
              };
            }

            return match;
          }
        }

        this.maxTries--;
      }
    }
    /**
     * Attempts to extract a match from `substring`
     * if the substring itself does not qualify as a match.
     */

  }, {
    key: "extractInnerMatch",
    value: function extractInnerMatch(substring, offset, text) {
      for (var _i = 0, _INNER_MATCHES = INNER_MATCHES; _i < _INNER_MATCHES.length; _i++) {
        var innerMatchPattern = _INNER_MATCHES[_i];
        var isFirstMatch = true;
        var candidateMatch = void 0;
        var innerMatchRegExp = new RegExp(innerMatchPattern, 'g');

        while (this.maxTries > 0 && (candidateMatch = innerMatchRegExp.exec(substring)) !== null) {
          if (isFirstMatch) {
            // We should handle any group before this one too.
            var _candidate = trimAfterFirstMatch(UNWANTED_END_CHAR_PATTERN, substring.slice(0, candidateMatch.index));

            var _match = this.parseAndVerify(_candidate, offset, text);

            if (_match) {
              return _match;
            }

            this.maxTries--;
            isFirstMatch = false;
          }

          var candidate = trimAfterFirstMatch(UNWANTED_END_CHAR_PATTERN, candidateMatch[1]); // Java code does `groupMatcher.start(1)` here,
          // but there's no way in javascript to get a `candidate` start index,
          // therefore resort to using this kind of an approximation.
          // (`groupMatcher` is called `candidateInSubstringMatch` in this javascript port)
          // https://stackoverflow.com/questions/15934353/get-index-of-each-capture-in-a-javascript-regex

          var candidateIndexGuess = substring.indexOf(candidate, candidateMatch.index);
          var match = this.parseAndVerify(candidate, offset + candidateIndexGuess, text);

          if (match) {
            return match;
          }

          this.maxTries--;
        }
      }
    }
    /**
     * Parses a phone number from the `candidate` using `parseNumber` and
     * verifies it matches the requested `leniency`. If parsing and verification succeed,
     * a corresponding `PhoneNumberMatch` is returned, otherwise this method returns `null`.
     *
     * @param candidate  the candidate match
     * @param offset  the offset of {@code candidate} within {@link #text}
     * @return  the parsed and validated phone number match, or null
     */

  }, {
    key: "parseAndVerify",
    value: function parseAndVerify(candidate, offset, text) {
      if (!isValidCandidate(candidate, offset, text, this.options.leniency)) {
        return;
      }

      var number = parse(candidate, {
        extended: true,
        defaultCountry: this.options.defaultCountry,
        defaultCallingCode: this.options.defaultCallingCode
      }, this.metadata);

      if (!number.possible) {
        return;
      }

      if (this.leniency(number, candidate, this.metadata, this.regExpCache)) {
        // // We used parseAndKeepRawInput to create this number,
        // // but for now we don't return the extra values parsed.
        // // TODO: stop clearing all values here and switch all users over
        // // to using rawInput() rather than the rawString() of PhoneNumberMatch.
        // number.clearCountryCodeSource()
        // number.clearRawInput()
        // number.clearPreferredDomesticCarrierCode()
        var result = {
          startsAt: offset,
          endsAt: offset + candidate.length,
          phone: number.phone
        };

        if (number.country && number.country !== '001') {
          result.country = number.country;
        } else {
          result.countryCallingCode = number.countryCallingCode;
        }

        if (number.ext) {
          result.ext = number.ext;
        }

        return result;
      }
    }
  }, {
    key: "hasNext",
    value: function hasNext() {
      if (this.state === 'NOT_READY') {
        this.lastMatch = this.find(); // (this.searchIndex)

        if (this.lastMatch) {
          // this.searchIndex = this.lastMatch.endsAt
          this.state = 'READY';
        } else {
          this.state = 'DONE';
        }
      }

      return this.state === 'READY';
    }
  }, {
    key: "next",
    value: function next() {
      // Check the state and find the next match as a side-effect if necessary.
      if (!this.hasNext()) {
        throw new Error('No next element');
      } // Don't retain that memory any longer than necessary.


      var result = this.lastMatch;
      this.lastMatch = null;
      this.state = 'NOT_READY';
      return result;
    }
  }]);

  return PhoneNumberMatcher;
}();

function _classCallCheck$7(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$6(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$6(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$6(Constructor.prototype, protoProps); if (staticProps) _defineProperties$6(Constructor, staticProps); return Constructor; }

function _defineProperty$4(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var AsYouTypeState =
/*#__PURE__*/
function () {
  function AsYouTypeState(_ref) {
    var _this = this;

    var onCountryChange = _ref.onCountryChange,
        onCallingCodeChange = _ref.onCallingCodeChange;

    _classCallCheck$7(this, AsYouTypeState);

    _defineProperty$4(this, "update", function (properties) {
      for (var _i = 0, _Object$keys = Object.keys(properties); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];
        _this[key] = properties[key];
      }
    });

    this.onCountryChange = onCountryChange;
    this.onCallingCodeChange = onCallingCodeChange;
  }

  _createClass$6(AsYouTypeState, [{
    key: "reset",
    value: function reset(defaultCountry, defaultCallingCode) {
      this.international = false;
      this.IDDPrefix = undefined;
      this.missingPlus = undefined;
      this.callingCode = undefined;
      this.digits = '';
      this.resetNationalSignificantNumber();
      this.initCountryAndCallingCode(defaultCountry, defaultCallingCode);
    }
  }, {
    key: "resetNationalSignificantNumber",
    value: function resetNationalSignificantNumber() {
      this.nationalSignificantNumber = this.getNationalDigits();
      this.nationalSignificantNumberMatchesInput = true;
      this.nationalPrefix = undefined;
      this.carrierCode = undefined;
      this.complexPrefixBeforeNationalSignificantNumber = undefined;
    }
  }, {
    key: "initCountryAndCallingCode",
    value: function initCountryAndCallingCode(country, callingCode) {
      this.setCountry(country);
      this.setCallingCode(callingCode);
    }
  }, {
    key: "setCountry",
    value: function setCountry(country) {
      this.country = country;
      this.onCountryChange(country);
    }
  }, {
    key: "setCallingCode",
    value: function setCallingCode(callingCode) {
      this.callingCode = callingCode;
      return this.onCallingCodeChange(this.country, callingCode);
    }
  }, {
    key: "startInternationalNumber",
    value: function startInternationalNumber() {
      // Prepend the `+` to parsed input.
      this.international = true; // If a default country was set then reset it
      // because an explicitly international phone
      // number is being entered.

      this.initCountryAndCallingCode();
    }
  }, {
    key: "appendDigits",
    value: function appendDigits(nextDigits) {
      this.digits += nextDigits;
    }
  }, {
    key: "appendNationalSignificantNumberDigits",
    value: function appendNationalSignificantNumberDigits(nextDigits) {
      this.nationalSignificantNumber += nextDigits;
    }
    /**
     * Returns the part of `this.digits` that corresponds to the national number.
     * Basically, all digits that have been input by the user, except for the
     * international prefix and the country calling code part
     * (if the number is an international one).
     * @return {string}
     */

  }, {
    key: "getNationalDigits",
    value: function getNationalDigits() {
      if (this.international) {
        return this.digits.slice((this.IDDPrefix ? this.IDDPrefix.length : 0) + (this.callingCode ? this.callingCode.length : 0));
      }

      return this.digits;
    }
  }, {
    key: "getDigitsWithoutInternationalPrefix",
    value: function getDigitsWithoutInternationalPrefix() {
      if (this.international) {
        if (this.IDDPrefix) {
          return this.digits.slice(this.IDDPrefix.length);
        }
      }

      return this.digits;
    }
  }]);

  return AsYouTypeState;
}();

// Should be the same as `DIGIT_PLACEHOLDER` in `libphonenumber-metadata-generator`.
var DIGIT_PLACEHOLDER = 'x'; // '\u2008' (punctuation space)

var DIGIT_PLACEHOLDER_MATCHER = new RegExp(DIGIT_PLACEHOLDER); // Counts all occurences of a symbol in a string.
// http://stackoverflow.com/questions/202605/repeat-string-javascript

function repeat(string, times) {
  if (times < 1) {
    return '';
  }

  var result = '';

  while (times > 1) {
    if (times & 1) {
      result += string;
    }

    times >>= 1;
    string += string;
  }

  return result + string;
}
function cutAndStripNonPairedParens(string, cutBeforeIndex) {
  if (string[cutBeforeIndex] === ')') {
    cutBeforeIndex++;
  }

  return stripNonPairedParens(string.slice(0, cutBeforeIndex));
}
function stripNonPairedParens(string) {
  var dangling_braces = [];
  var i = 0;

  while (i < string.length) {
    if (string[i] === '(') {
      dangling_braces.push(i);
    } else if (string[i] === ')') {
      dangling_braces.pop();
    }

    i++;
  }

  var start = 0;
  var cleared_string = '';
  dangling_braces.push(string.length);

  for (var _i2 = 0, _dangling_braces = dangling_braces; _i2 < _dangling_braces.length; _i2++) {
    var index = _dangling_braces[_i2];
    cleared_string += string.slice(start, index);
    start = index + 1;
  }

  return cleared_string;
}
function populateTemplateWithDigits(template, position, digits) {
  // Using `.split('')` to iterate through a string here
  // to avoid requiring `Symbol.iterator` polyfill.
  // `.split('')` is generally not safe for Unicode,
  // but in this particular case for `digits` it is safe.
  // for (const digit of digits)
  for (var _iterator2 = digits.split(''), _isArray2 = Array.isArray(_iterator2), _i3 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
    var _ref2;

    if (_isArray2) {
      if (_i3 >= _iterator2.length) break;
      _ref2 = _iterator2[_i3++];
    } else {
      _i3 = _iterator2.next();
      if (_i3.done) break;
      _ref2 = _i3.value;
    }

    var digit = _ref2;

    // If there is room for more digits in current `template`,
    // then set the next digit in the `template`,
    // and return the formatted digits so far.
    // If more digits are entered than the current format could handle.
    if (template.slice(position + 1).search(DIGIT_PLACEHOLDER_MATCHER) < 0) {
      return;
    }

    position = template.search(DIGIT_PLACEHOLDER_MATCHER);
    template = template.replace(DIGIT_PLACEHOLDER_MATCHER, digit);
  }

  return [template, position];
}

function formatCompleteNumber(state, format, _ref) {
  var metadata = _ref.metadata,
      shouldTryNationalPrefixFormattingRule = _ref.shouldTryNationalPrefixFormattingRule,
      getSeparatorAfterNationalPrefix = _ref.getSeparatorAfterNationalPrefix;
  var matcher = new RegExp("^(?:".concat(format.pattern(), ")$"));

  if (matcher.test(state.nationalSignificantNumber)) {
    return formatNationalNumberWithAndWithoutNationalPrefixFormattingRule(state, format, {
      metadata: metadata,
      shouldTryNationalPrefixFormattingRule: shouldTryNationalPrefixFormattingRule,
      getSeparatorAfterNationalPrefix: getSeparatorAfterNationalPrefix
    });
  }
}
function canFormatCompleteNumber(nationalSignificantNumber, metadata) {
  return checkNumberLength(nationalSignificantNumber, metadata) === 'IS_POSSIBLE';
}

function formatNationalNumberWithAndWithoutNationalPrefixFormattingRule(state, format, _ref2) {
  var metadata = _ref2.metadata,
      shouldTryNationalPrefixFormattingRule = _ref2.shouldTryNationalPrefixFormattingRule,
      getSeparatorAfterNationalPrefix = _ref2.getSeparatorAfterNationalPrefix;
  // `format` has already been checked for `nationalPrefix` requirement.
  var nationalSignificantNumber = state.nationalSignificantNumber,
      international = state.international,
      nationalPrefix = state.nationalPrefix,
      carrierCode = state.carrierCode; // Format the number with using `national_prefix_formatting_rule`.
  // If the resulting formatted number is a valid formatted number, then return it.
  //
  // Google's AsYouType formatter is different in a way that it doesn't try
  // to format using the "national prefix formatting rule", and instead it
  // simply prepends a national prefix followed by a " " character.
  // This code does that too, but as a fallback.
  // The reason is that "national prefix formatting rule" may use parentheses,
  // which wouldn't be included has it used the simpler Google's way.
  //

  if (shouldTryNationalPrefixFormattingRule(format)) {
    var formattedNumber = formatNationalNumber$1(state, format, {
      useNationalPrefixFormattingRule: true,
      getSeparatorAfterNationalPrefix: getSeparatorAfterNationalPrefix,
      metadata: metadata
    });

    if (formattedNumber) {
      return formattedNumber;
    }
  } // Format the number without using `national_prefix_formatting_rule`.


  return formatNationalNumber$1(state, format, {
    useNationalPrefixFormattingRule: false,
    getSeparatorAfterNationalPrefix: getSeparatorAfterNationalPrefix,
    metadata: metadata
  });
}

function formatNationalNumber$1(state, format, _ref3) {
  var metadata = _ref3.metadata,
      useNationalPrefixFormattingRule = _ref3.useNationalPrefixFormattingRule,
      getSeparatorAfterNationalPrefix = _ref3.getSeparatorAfterNationalPrefix;
  var formattedNationalNumber = formatNationalNumberUsingFormat(state.nationalSignificantNumber, format, {
    carrierCode: state.carrierCode,
    useInternationalFormat: state.international,
    withNationalPrefix: useNationalPrefixFormattingRule,
    metadata: metadata
  });

  if (!useNationalPrefixFormattingRule) {
    if (state.nationalPrefix) {
      // If a national prefix was extracted, then just prepend it,
      // followed by a " " character.
      formattedNationalNumber = state.nationalPrefix + getSeparatorAfterNationalPrefix(format) + formattedNationalNumber;
    } else if (state.complexPrefixBeforeNationalSignificantNumber) {
      formattedNationalNumber = state.complexPrefixBeforeNationalSignificantNumber + ' ' + formattedNationalNumber;
    }
  }

  if (isValidFormattedNationalNumber(formattedNationalNumber, state)) {
    return formattedNationalNumber;
  }
} // Check that the formatted phone number contains exactly
// the same digits that have been input by the user.
// For example, when "0111523456789" is input for `AR` country,
// the extracted `this.nationalSignificantNumber` is "91123456789",
// which means that the national part of `this.digits` isn't simply equal to
// `this.nationalPrefix` + `this.nationalSignificantNumber`.
//
// Also, a `format` can add extra digits to the `this.nationalSignificantNumber`
// being formatted via `metadata[country].national_prefix_transform_rule`.
// For example, for `VI` country, it prepends `340` to the national number,
// and if this check hasn't been implemented, then there would be a bug
// when `340` "area coude" is "duplicated" during input for `VI` country:
// https://github.com/catamphetamine/libphonenumber-js/issues/318
//
// So, all these "gotchas" are filtered out.
//
// In the original Google's code, the comments say:
// "Check that we didn't remove nor add any extra digits when we matched
// this formatting pattern. This usually happens after we entered the last
// digit during AYTF. Eg: In case of MX, we swallow mobile token (1) when
// formatted but AYTF should retain all the number entered and not change
// in order to match a format (of same leading digits and length) display
// in that way."
// "If it's the same (i.e entered number and format is same), then it's
// safe to return this in formatted number as nothing is lost / added."
// Otherwise, don't use this format.
// https://github.com/google/libphonenumber/commit/3e7c1f04f5e7200f87fb131e6f85c6e99d60f510#diff-9149457fa9f5d608a11bb975c6ef4bc5
// https://github.com/google/libphonenumber/commit/3ac88c7106e7dcb553bcc794b15f19185928a1c6#diff-2dcb77e833422ee304da348b905cde0b
//


function isValidFormattedNationalNumber(formattedNationalNumber, state) {
  return parseDigits(formattedNationalNumber) === state.getNationalDigits();
}

function _classCallCheck$8(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$7(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$7(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$7(Constructor.prototype, protoProps); if (staticProps) _defineProperties$7(Constructor, staticProps); return Constructor; }

function _defineProperty$5(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
// Could be any digit, I guess.

var DUMMY_DIGIT = '9'; // I don't know why is it exactly `15`

var LONGEST_NATIONAL_PHONE_NUMBER_LENGTH = 15; // Create a phone number consisting only of the digit 9 that matches the
// `number_pattern` by applying the pattern to the "longest phone number" string.

var LONGEST_DUMMY_PHONE_NUMBER = repeat(DUMMY_DIGIT, LONGEST_NATIONAL_PHONE_NUMBER_LENGTH); // A set of characters that, if found in a national prefix formatting rules, are an indicator to
// us that we should separate the national prefix from the number when formatting.

var NATIONAL_PREFIX_SEPARATORS_PATTERN = /[- ]/; // Deprecated: Google has removed some formatting pattern related code from their repo.
// An example of a character class is "[1-4]".

var CREATE_CHARACTER_CLASS_PATTERN =  function () {
  return /\[([^\[\]])*\]/g;
}; // Any digit in a regular expression that actually denotes a digit. For
// example, in the regular expression "80[0-2]\d{6,10}", the first 2 digits
// (8 and 0) are standalone digits, but the rest are not.
// Two look-aheads are needed because the number following \\d could be a
// two-digit number, since the phone number can be as long as 15 digits.


var CREATE_STANDALONE_DIGIT_PATTERN =  function () {
  return /\d(?=[^,}][^,}])/g;
}; // A regular expression that is used to determine if a `format` is
// suitable to be used in the "as you type formatter".
// A `format` is suitable when the resulting formatted number has
// the same digits as the user has entered.
//
// In the simplest case, that would mean that the format
// doesn't add any additional digits when formatting a number.
// Google says that it also shouldn't add "star" (`*`) characters,
// like it does in some Israeli formats.
// Such basic format would only contain "valid punctuation"
// and "captured group" identifiers ($1, $2, etc).
//
// An example of a format that adds additional digits:
//
// Country: `AR` (Argentina).
// Format:
// {
//    "pattern": "(\\d)(\\d{2})(\\d{4})(\\d{4})",
//    "leading_digits_patterns": ["91"],
//    "national_prefix_formatting_rule": "0$1",
//    "format": "$2 15-$3-$4",
//    "international_format": "$1 $2 $3-$4"
// }
//
// In the format above, the `format` adds `15` to the digits when formatting a number.
// A sidenote: this format actually is suitable because `national_prefix_for_parsing`
// has previously removed `15` from a national number, so re-adding `15` in `format`
// doesn't actually result in any extra digits added to user's input.
// But verifying that would be a complex procedure, so the code chooses a simpler path:
// it simply filters out all `format`s that contain anything but "captured group" ids.
//
// This regular expression is called `ELIGIBLE_FORMAT_PATTERN` in Google's
// `libphonenumber` code.
//


var NON_ALTERING_FORMAT_REG_EXP = new RegExp('^' + '[' + VALID_PUNCTUATION + ']*' + '(\\$\\d[' + VALID_PUNCTUATION + ']*)+' + '$'); // This is the minimum length of the leading digits of a phone number
// to guarantee the first "leading digits pattern" for a phone number format
// to be preemptive.

var MIN_LEADING_DIGITS_LENGTH = 3;

var AsYouTypeFormatter =
/*#__PURE__*/
function () {
  function AsYouTypeFormatter(_ref) {
    var _this = this;

    var state = _ref.state,
        metadata = _ref.metadata;

    _classCallCheck$8(this, AsYouTypeFormatter);

    _defineProperty$5(this, "getSeparatorAfterNationalPrefix", function (format) {
      // `US` metadata doesn't have a `national_prefix_formatting_rule`,
      // so the `if` condition below doesn't apply to `US`,
      // but in reality there shoudl be a separator
      // between a national prefix and a national (significant) number.
      // So `US` national prefix separator is a "special" "hardcoded" case.
      if (_this.isNANP) {
        return ' ';
      } // If a `format` has a `national_prefix_formatting_rule`
      // and that rule has a separator after a national prefix,
      // then it means that there should be a separator
      // between a national prefix and a national (significant) number.


      if (format && format.nationalPrefixFormattingRule() && NATIONAL_PREFIX_SEPARATORS_PATTERN.test(format.nationalPrefixFormattingRule())) {
        return ' ';
      } // At this point, there seems to be no clear evidence that
      // there should be a separator between a national prefix
      // and a national (significant) number. So don't insert one.


      return '';
    });

    _defineProperty$5(this, "shouldTryNationalPrefixFormattingRule", function (format, _ref2) {
      var international = _ref2.international,
          nationalPrefix = _ref2.nationalPrefix;

      if (format.nationalPrefixFormattingRule()) {
        // In some countries, `national_prefix_formatting_rule` is `($1)`,
        // so it applies even if the user hasn't input a national prefix.
        // `format.usesNationalPrefix()` detects such cases.
        var usesNationalPrefix = format.usesNationalPrefix();

        if (usesNationalPrefix && nationalPrefix || !usesNationalPrefix && !international) {
          return true;
        }
      }
    });

    this.metadata = metadata;
    this.resetFormat();
  }

  _createClass$7(AsYouTypeFormatter, [{
    key: "resetFormat",
    value: function resetFormat() {
      this.chosenFormat = undefined;
      this.template = undefined;
      this.nationalNumberTemplate = undefined;
      this.populatedNationalNumberTemplate = undefined;
      this.populatedNationalNumberTemplatePosition = -1;
    }
  }, {
    key: "reset",
    value: function reset(numberingPlan, state) {
      this.resetFormat();

      if (numberingPlan) {
        this.isNANP = numberingPlan.callingCode() === '1';
        this.matchingFormats = numberingPlan.formats();

        if (state.nationalSignificantNumber) {
          this.narrowDownMatchingFormats(state);
        }
      } else {
        this.isNANP = undefined;
        this.matchingFormats = [];
      }
    }
  }, {
    key: "format",
    value: function format(nextDigits, state) {
      var _this2 = this;

      // See if the phone number digits can be formatted as a complete phone number.
      // If not, use the results from `formatNationalNumberWithNextDigits()`,
      // which formats based on the chosen formatting pattern.
      //
      // Attempting to format complete phone number first is how it's done
      // in Google's `libphonenumber`, so this library just follows it.
      // Google's `libphonenumber` code doesn't explain in detail why does it
      // attempt to format digits as a complete phone number
      // instead of just going with a previoulsy (or newly) chosen `format`:
      //
      // "Checks to see if there is an exact pattern match for these digits.
      //  If so, we should use this instead of any other formatting template
      //  whose leadingDigitsPattern also matches the input."
      //
      if (canFormatCompleteNumber(state.nationalSignificantNumber, this.metadata)) {
        for (var _iterator = this.matchingFormats, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
          var _ref3;

          if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref3 = _iterator[_i++];
          } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref3 = _i.value;
          }

          var format = _ref3;
          var formattedCompleteNumber = formatCompleteNumber(state, format, {
            metadata: this.metadata,
            shouldTryNationalPrefixFormattingRule: function shouldTryNationalPrefixFormattingRule(format) {
              return _this2.shouldTryNationalPrefixFormattingRule(format, {
                international: state.international,
                nationalPrefix: state.nationalPrefix
              });
            },
            getSeparatorAfterNationalPrefix: this.getSeparatorAfterNationalPrefix
          });

          if (formattedCompleteNumber) {
            this.resetFormat();
            this.chosenFormat = format;
            this.setNationalNumberTemplate(formattedCompleteNumber.replace(/\d/g, DIGIT_PLACEHOLDER), state);
            this.populatedNationalNumberTemplate = formattedCompleteNumber; // With a new formatting template, the matched position
            // using the old template needs to be reset.

            this.populatedNationalNumberTemplatePosition = this.template.lastIndexOf(DIGIT_PLACEHOLDER);
            return formattedCompleteNumber;
          }
        }
      } // Format the digits as a partial (incomplete) phone number
      // using the previously chosen formatting pattern (or a newly chosen one).


      return this.formatNationalNumberWithNextDigits(nextDigits, state);
    } // Formats the next phone number digits.

  }, {
    key: "formatNationalNumberWithNextDigits",
    value: function formatNationalNumberWithNextDigits(nextDigits, state) {
      var previouslyChosenFormat = this.chosenFormat; // Choose a format from the list of matching ones.

      var newlyChosenFormat = this.chooseFormat(state);

      if (newlyChosenFormat) {
        if (newlyChosenFormat === previouslyChosenFormat) {
          // If it can format the next (current) digits
          // using the previously chosen phone number format
          // then return the updated formatted number.
          return this.formatNextNationalNumberDigits(nextDigits);
        } else {
          // If a more appropriate phone number format
          // has been chosen for these "leading digits",
          // then re-format the national phone number part
          // using the newly selected format.
          return this.formatNextNationalNumberDigits(state.getNationalDigits());
        }
      }
    }
  }, {
    key: "narrowDownMatchingFormats",
    value: function narrowDownMatchingFormats(_ref4) {
      var _this3 = this;

      var nationalSignificantNumber = _ref4.nationalSignificantNumber,
          nationalPrefix = _ref4.nationalPrefix,
          international = _ref4.international;
      var leadingDigits = nationalSignificantNumber; // "leading digits" pattern list starts with a
      // "leading digits" pattern fitting a maximum of 3 leading digits.
      // So, after a user inputs 3 digits of a national (significant) phone number
      // this national (significant) number can already be formatted.
      // The next "leading digits" pattern is for 4 leading digits max,
      // and the "leading digits" pattern after it is for 5 leading digits max, etc.
      // This implementation is different from Google's
      // in that it searches for a fitting format
      // even if the user has entered less than
      // `MIN_LEADING_DIGITS_LENGTH` digits of a national number.
      // Because some leading digit patterns already match for a single first digit.

      var leadingDigitsPatternIndex = leadingDigits.length - MIN_LEADING_DIGITS_LENGTH;

      if (leadingDigitsPatternIndex < 0) {
        leadingDigitsPatternIndex = 0;
      }

      this.matchingFormats = this.matchingFormats.filter(function (format) {
        return _this3.formatSuits(format, international, nationalPrefix) && _this3.formatMatches(format, leadingDigits, leadingDigitsPatternIndex);
      }); // If there was a phone number format chosen
      // and it no longer holds given the new leading digits then reset it.
      // The test for this `if` condition is marked as:
      // "Reset a chosen format when it no longer holds given the new leading digits".
      // To construct a valid test case for this one can find a country
      // in `PhoneNumberMetadata.xml` yielding one format for 3 `<leadingDigits>`
      // and yielding another format for 4 `<leadingDigits>` (Australia in this case).

      if (this.chosenFormat && this.matchingFormats.indexOf(this.chosenFormat) === -1) {
        this.resetFormat();
      }
    }
  }, {
    key: "formatSuits",
    value: function formatSuits(format, international, nationalPrefix) {
      // When a prefix before a national (significant) number is
      // simply a national prefix, then it's parsed as `this.nationalPrefix`.
      // In more complex cases, a prefix before national (significant) number
      // could include a national prefix as well as some "capturing groups",
      // and in that case there's no info whether a national prefix has been parsed.
      // If national prefix is not used when formatting a phone number
      // using this format, but a national prefix has been entered by the user,
      // and was extracted, then discard such phone number format.
      // In Google's "AsYouType" formatter code, the equivalent would be this part:
      // https://github.com/google/libphonenumber/blob/0a45cfd96e71cad8edb0e162a70fcc8bd9728933/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L175-L184
      if (nationalPrefix && !format.usesNationalPrefix() && // !format.domesticCarrierCodeFormattingRule() &&
      !format.nationalPrefixIsOptionalWhenFormattingInNationalFormat()) {
        return false;
      } // If national prefix is mandatory for this phone number format
      // and there're no guarantees that a national prefix is present in user input
      // then discard this phone number format as not suitable.
      // In Google's "AsYouType" formatter code, the equivalent would be this part:
      // https://github.com/google/libphonenumber/blob/0a45cfd96e71cad8edb0e162a70fcc8bd9728933/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L185-L193


      if (!international && !nationalPrefix && format.nationalPrefixIsMandatoryWhenFormattingInNationalFormat()) {
        return false;
      }

      return true;
    }
  }, {
    key: "formatMatches",
    value: function formatMatches(format, leadingDigits, leadingDigitsPatternIndex) {
      var leadingDigitsPatternsCount = format.leadingDigitsPatterns().length; // If this format is not restricted to a certain
      // leading digits pattern then it fits.

      if (leadingDigitsPatternsCount === 0) {
        return true;
      } // Start excluding any non-matching formats only when the
      // national number entered so far is at least 3 digits long,
      // otherwise format matching would give false negatives.
      // For example, when the digits entered so far are `2`
      // and the leading digits pattern is `21` –
      // it's quite obvious in this case that the format could be the one
      // but due to the absence of further digits it would give false negative.


      if (leadingDigits.length < MIN_LEADING_DIGITS_LENGTH) {
        return true;
      } // If at least `MIN_LEADING_DIGITS_LENGTH` digits of a national number are available
      // then format matching starts narrowing down the list of possible formats
      // (only previously matched formats are considered for next digits).


      leadingDigitsPatternIndex = Math.min(leadingDigitsPatternIndex, leadingDigitsPatternsCount - 1);
      var leadingDigitsPattern = format.leadingDigitsPatterns()[leadingDigitsPatternIndex]; // Brackets are required for `^` to be applied to
      // all or-ed (`|`) parts, not just the first one.

      return new RegExp("^(".concat(leadingDigitsPattern, ")")).test(leadingDigits);
    }
  }, {
    key: "getFormatFormat",
    value: function getFormatFormat(format, international) {
      return international ? format.internationalFormat() : format.format();
    }
  }, {
    key: "chooseFormat",
    value: function chooseFormat(state) {
      var _this4 = this;

      var _loop2 = function _loop2() {
        if (_isArray2) {
          if (_i2 >= _iterator2.length) return "break";
          _ref5 = _iterator2[_i2++];
        } else {
          _i2 = _iterator2.next();
          if (_i2.done) return "break";
          _ref5 = _i2.value;
        }

        var format = _ref5;

        // If this format is currently being used
        // and is still suitable, then stick to it.
        if (_this4.chosenFormat === format) {
          return "break";
        } // Sometimes, a formatting rule inserts additional digits in a phone number,
        // and "as you type" formatter can't do that: it should only use the digits
        // that the user has input.
        //
        // For example, in Argentina, there's a format for mobile phone numbers:
        //
        // {
        //    "pattern": "(\\d)(\\d{2})(\\d{4})(\\d{4})",
        //    "leading_digits_patterns": ["91"],
        //    "national_prefix_formatting_rule": "0$1",
        //    "format": "$2 15-$3-$4",
        //    "international_format": "$1 $2 $3-$4"
        // }
        //
        // In that format, `international_format` is used instead of `format`
        // because `format` inserts `15` in the formatted number,
        // and `AsYouType` formatter should only use the digits
        // the user has actually input, without adding any extra digits.
        // In this case, it wouldn't make a difference, because the `15`
        // is first stripped when applying `national_prefix_for_parsing`
        // and then re-added when using `format`, so in reality it doesn't
        // add any new digits to the number, but to detect that, the code
        // would have to be more complex: it would have to try formatting
        // the digits using the format and then see if any digits have
        // actually been added or removed, and then, every time a new digit
        // is input, it should re-check whether the chosen format doesn't
        // alter the digits.
        //
        // Google's code doesn't go that far, and so does this library:
        // it simply requires that a `format` doesn't add any additonal
        // digits to user's input.
        //
        // Also, people in general should move from inputting phone numbers
        // in national format (possibly with national prefixes)
        // and use international phone number format instead:
        // it's a logical thing in the modern age of mobile phones,
        // globalization and the internet.
        //

        /* istanbul ignore if */


        if (!NON_ALTERING_FORMAT_REG_EXP.test(_this4.getFormatFormat(format, state.international))) {
          return "continue";
        }

        if (!_this4.createTemplateForFormat(format, state)) {
          // Remove the format if it can't generate a template.
          _this4.matchingFormats = _this4.matchingFormats.filter(function (_) {
            return _ !== format;
          });
          return "continue";
        }

        _this4.chosenFormat = format;
        return "break";
      };

      // When there are multiple available formats, the formatter uses the first
      // format where a formatting template could be created.
      _loop: for (var _iterator2 = this.matchingFormats.slice(), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
        var _ref5;

        var _ret = _loop2();

        switch (_ret) {
          case "break":
            break _loop;

          case "continue":
            continue;
        }
      }

      if (!this.chosenFormat) {
        // No format matches the national (significant) phone number.
        this.resetFormat();
      }

      return this.chosenFormat;
    }
  }, {
    key: "createTemplateForFormat",
    value: function createTemplateForFormat(format, state) {
      // The formatter doesn't format numbers when numberPattern contains '|', e.g.
      // (20|3)\d{4}. In those cases we quickly return.
      // (Though there's no such format in current metadata)

      /* istanbul ignore if */
      if ( format.pattern().indexOf('|') >= 0) {
        return;
      } // Get formatting template for this phone number format


      var template = this.getTemplateForFormat(format, state); // If the national number entered is too long
      // for any phone number format, then abort.

      if (template) {
        this.setNationalNumberTemplate(template, state);
        return true;
      }
    }
  }, {
    key: "getInternationalPrefixBeforeCountryCallingCode",
    value: function getInternationalPrefixBeforeCountryCallingCode(_ref6, options) {
      var IDDPrefix = _ref6.IDDPrefix,
          missingPlus = _ref6.missingPlus;

      if (IDDPrefix) {
        return options && options.spacing === false ? IDDPrefix : IDDPrefix + ' ';
      }

      if (missingPlus) {
        return '';
      }

      return '+';
    }
  }, {
    key: "getTemplate",
    value: function getTemplate(state) {
      if (!this.template) {
        return;
      } // `this.template` holds the template for a "complete" phone number.
      // The currently entered phone number is most likely not "complete",
      // so trim all non-populated digits.


      var index = -1;
      var i = 0;
      var internationalPrefix = state.international ? this.getInternationalPrefixBeforeCountryCallingCode(state, {
        spacing: false
      }) : '';

      while (i < internationalPrefix.length + state.getDigitsWithoutInternationalPrefix().length) {
        index = this.template.indexOf(DIGIT_PLACEHOLDER, index + 1);
        i++;
      }

      return cutAndStripNonPairedParens(this.template, index + 1);
    }
  }, {
    key: "setNationalNumberTemplate",
    value: function setNationalNumberTemplate(template, state) {
      this.nationalNumberTemplate = template;
      this.populatedNationalNumberTemplate = template; // With a new formatting template, the matched position
      // using the old template needs to be reset.

      this.populatedNationalNumberTemplatePosition = -1; // For convenience, the public `.template` property
      // contains the whole international number
      // if the phone number being input is international:
      // 'x' for the '+' sign, 'x'es for the country phone code,
      // a spacebar and then the template for the formatted national number.

      if (state.international) {
        this.template = this.getInternationalPrefixBeforeCountryCallingCode(state).replace(/[\d\+]/g, DIGIT_PLACEHOLDER) + repeat(DIGIT_PLACEHOLDER, state.callingCode.length) + ' ' + template;
      } else {
        this.template = template;
      }
    }
    /**
     * Generates formatting template for a national phone number,
     * optionally containing a national prefix, for a format.
     * @param  {Format} format
     * @param  {string} nationalPrefix
     * @return {string}
     */

  }, {
    key: "getTemplateForFormat",
    value: function getTemplateForFormat(format, _ref7) {
      var nationalSignificantNumber = _ref7.nationalSignificantNumber,
          international = _ref7.international,
          nationalPrefix = _ref7.nationalPrefix,
          complexPrefixBeforeNationalSignificantNumber = _ref7.complexPrefixBeforeNationalSignificantNumber;
      var pattern = format.pattern();
      /* istanbul ignore else */

      {
        pattern = pattern // Replace anything in the form of [..] with \d
        .replace(CREATE_CHARACTER_CLASS_PATTERN(), '\\d') // Replace any standalone digit (not the one in `{}`) with \d
        .replace(CREATE_STANDALONE_DIGIT_PATTERN(), '\\d');
      } // Generate a dummy national number (consisting of `9`s)
      // that fits this format's `pattern`.
      //
      // This match will always succeed,
      // because the "longest dummy phone number"
      // has enough length to accomodate any possible
      // national phone number format pattern.
      //


      var digits = LONGEST_DUMMY_PHONE_NUMBER.match(pattern)[0]; // If the national number entered is too long
      // for any phone number format, then abort.

      if (nationalSignificantNumber.length > digits.length) {
        return;
      } // Get a formatting template which can be used to efficiently format
      // a partial number where digits are added one by one.
      // Below `strictPattern` is used for the
      // regular expression (with `^` and `$`).
      // This wasn't originally in Google's `libphonenumber`
      // and I guess they don't really need it
      // because they're not using "templates" to format phone numbers
      // but I added `strictPattern` after encountering
      // South Korean phone number formatting bug.
      //
      // Non-strict regular expression bug demonstration:
      //
      // this.nationalSignificantNumber : `111111111` (9 digits)
      //
      // pattern : (\d{2})(\d{3,4})(\d{4})
      // format : `$1 $2 $3`
      // digits : `9999999999` (10 digits)
      //
      // '9999999999'.replace(new RegExp(/(\d{2})(\d{3,4})(\d{4})/g), '$1 $2 $3') = "99 9999 9999"
      //
      // template : xx xxxx xxxx
      //
      // But the correct template in this case is `xx xxx xxxx`.
      // The template was generated incorrectly because of the
      // `{3,4}` variability in the `pattern`.
      //
      // The fix is, if `this.nationalSignificantNumber` has already sufficient length
      // to satisfy the `pattern` completely then `this.nationalSignificantNumber`
      // is used instead of `digits`.


      var strictPattern = new RegExp('^' + pattern + '$');
      var nationalNumberDummyDigits = nationalSignificantNumber.replace(/\d/g, DUMMY_DIGIT); // If `this.nationalSignificantNumber` has already sufficient length
      // to satisfy the `pattern` completely then use it
      // instead of `digits`.

      if (strictPattern.test(nationalNumberDummyDigits)) {
        digits = nationalNumberDummyDigits;
      }

      var numberFormat = this.getFormatFormat(format, international);
      var nationalPrefixIncludedInTemplate; // If a user did input a national prefix (and that's guaranteed),
      // and if a `format` does have a national prefix formatting rule,
      // then see if that national prefix formatting rule
      // prepends exactly the same national prefix the user has input.
      // If that's the case, then use the `format` with the national prefix formatting rule.
      // Otherwise, use  the `format` without the national prefix formatting rule,
      // and prepend a national prefix manually to it.

      if (this.shouldTryNationalPrefixFormattingRule(format, {
        international: international,
        nationalPrefix: nationalPrefix
      })) {
        var numberFormatWithNationalPrefix = numberFormat.replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule()); // If `national_prefix_formatting_rule` of a `format` simply prepends
        // national prefix at the start of a national (significant) number,
        // then such formatting can be used with `AsYouType` formatter.
        // There seems to be no `else` case: everywhere in metadata,
        // national prefix formatting rule is national prefix + $1,
        // or `($1)`, in which case such format isn't even considered
        // when the user has input a national prefix.

        /* istanbul ignore else */

        if (parseDigits(format.nationalPrefixFormattingRule()) === (nationalPrefix || '') + parseDigits('$1')) {
          numberFormat = numberFormatWithNationalPrefix;
          nationalPrefixIncludedInTemplate = true; // Replace all digits of the national prefix in the formatting template
          // with `DIGIT_PLACEHOLDER`s.

          if (nationalPrefix) {
            var i = nationalPrefix.length;

            while (i > 0) {
              numberFormat = numberFormat.replace(/\d/, DIGIT_PLACEHOLDER);
              i--;
            }
          }
        }
      } // Generate formatting template for this phone number format.


      var template = digits // Format the dummy phone number according to the format.
      .replace(new RegExp(pattern), numberFormat) // Replace each dummy digit with a DIGIT_PLACEHOLDER.
      .replace(new RegExp(DUMMY_DIGIT, 'g'), DIGIT_PLACEHOLDER); // If a prefix of a national (significant) number is not as simple
      // as just a basic national prefix, then just prepend such prefix
      // before the national (significant) number, optionally spacing
      // the two with a whitespace.

      if (!nationalPrefixIncludedInTemplate) {
        if (complexPrefixBeforeNationalSignificantNumber) {
          // Prepend the prefix to the template manually.
          template = repeat(DIGIT_PLACEHOLDER, complexPrefixBeforeNationalSignificantNumber.length) + ' ' + template;
        } else if (nationalPrefix) {
          // Prepend national prefix to the template manually.
          template = repeat(DIGIT_PLACEHOLDER, nationalPrefix.length) + this.getSeparatorAfterNationalPrefix(format) + template;
        }
      }

      if (international) {
        template = applyInternationalSeparatorStyle(template);
      }

      return template;
    }
  }, {
    key: "formatNextNationalNumberDigits",
    value: function formatNextNationalNumberDigits(digits) {
      var result = populateTemplateWithDigits(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition, digits);

      if (!result) {
        // Reset the format.
        this.resetFormat();
        return;
      }

      this.populatedNationalNumberTemplate = result[0];
      this.populatedNationalNumberTemplatePosition = result[1]; // Return the formatted phone number so far.

      return cutAndStripNonPairedParens(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1); // The old way which was good for `input-format` but is not so good
      // for `react-phone-number-input`'s default input (`InputBasic`).
      // return closeNonPairedParens(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1)
      // 	.replace(new RegExp(DIGIT_PLACEHOLDER, 'g'), ' ')
    }
  }]);

  return AsYouTypeFormatter;
}();

function _slicedToArray$2(arr, i) { return _arrayWithHoles$2(arr) || _iterableToArrayLimit$2(arr, i) || _nonIterableRest$2(); }

function _nonIterableRest$2() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit$2(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$2(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck$9(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$8(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$8(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$8(Constructor.prototype, protoProps); if (staticProps) _defineProperties$8(Constructor, staticProps); return Constructor; }
var VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART = '[' + VALID_PUNCTUATION + VALID_DIGITS + ']+';
var VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART_PATTERN = new RegExp('^' + VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART + '$', 'i');
var VALID_FORMATTED_PHONE_NUMBER_PART = '(?:' + '[' + PLUS_CHARS + ']' + '[' + VALID_PUNCTUATION + VALID_DIGITS + ']*' + '|' + '[' + VALID_PUNCTUATION + VALID_DIGITS + ']+' + ')';
var AFTER_PHONE_NUMBER_DIGITS_END_PATTERN = new RegExp('[^' + VALID_PUNCTUATION + VALID_DIGITS + ']+' + '.*' + '$'); // Tests whether `national_prefix_for_parsing` could match
// different national prefixes.
// Matches anything that's not a digit or a square bracket.

var COMPLEX_NATIONAL_PREFIX = /[^\d\[\]]/;

var AsYouTypeParser =
/*#__PURE__*/
function () {
  function AsYouTypeParser(_ref) {
    var defaultCountry = _ref.defaultCountry,
        defaultCallingCode = _ref.defaultCallingCode,
        metadata = _ref.metadata,
        onNationalSignificantNumberChange = _ref.onNationalSignificantNumberChange;

    _classCallCheck$9(this, AsYouTypeParser);

    this.defaultCountry = defaultCountry;
    this.defaultCallingCode = defaultCallingCode;
    this.metadata = metadata;
    this.onNationalSignificantNumberChange = onNationalSignificantNumberChange;
  }

  _createClass$8(AsYouTypeParser, [{
    key: "input",
    value: function input(text, state) {
      var _extractFormattedDigi = extractFormattedDigitsAndPlus(text),
          _extractFormattedDigi2 = _slicedToArray$2(_extractFormattedDigi, 2),
          formattedDigits = _extractFormattedDigi2[0],
          hasPlus = _extractFormattedDigi2[1];

      var digits = parseDigits(formattedDigits); // Checks for a special case: just a leading `+` has been entered.

      var justLeadingPlus;

      if (hasPlus) {
        if (!state.digits) {
          state.startInternationalNumber();

          if (!digits) {
            justLeadingPlus = true;
          }
        }
      }

      if (digits) {
        this.inputDigits(digits, state);
      }

      return {
        digits: digits,
        justLeadingPlus: justLeadingPlus
      };
    }
    /**
     * Inputs "next" phone number digits.
     * @param  {string} digits
     * @return {string} [formattedNumber] Formatted national phone number (if it can be formatted at this stage). Returning `undefined` means "don't format the national phone number at this stage".
     */

  }, {
    key: "inputDigits",
    value: function inputDigits(nextDigits, state) {
      var digits = state.digits;
      var hasReceivedThreeLeadingDigits = digits.length < 3 && digits.length + nextDigits.length >= 3; // Append phone number digits.

      state.appendDigits(nextDigits); // Attempt to extract IDD prefix:
      // Some users input their phone number in international format,
      // but in an "out-of-country" dialing format instead of using the leading `+`.
      // https://github.com/catamphetamine/libphonenumber-js/issues/185
      // Detect such numbers as soon as there're at least 3 digits.
      // Google's library attempts to extract IDD prefix at 3 digits,
      // so this library just copies that behavior.
      // I guess that's because the most commot IDD prefixes are
      // `00` (Europe) and `011` (US).
      // There exist really long IDD prefixes too:
      // for example, in Australia the default IDD prefix is `0011`,
      // and it could even be as long as `14880011`.
      // An IDD prefix is extracted here, and then every time when
      // there's a new digit and the number couldn't be formatted.

      if (hasReceivedThreeLeadingDigits) {
        this.extractIddPrefix(state);
      }

      if (this.isWaitingForCountryCallingCode(state)) {
        if (!this.extractCountryCallingCode(state)) {
          return;
        }
      } else {
        state.appendNationalSignificantNumberDigits(nextDigits);
      } // If a phone number is being input in international format,
      // then it's not valid for it to have a national prefix.
      // Still, some people incorrectly input such numbers with a national prefix.
      // In such cases, only attempt to strip a national prefix if the number becomes too long.
      // (but that is done later, not here)


      if (!state.international) {
        if (!this.hasExtractedNationalSignificantNumber) {
          this.extractNationalSignificantNumber(state.getNationalDigits(), state.update);
        }
      }
    }
  }, {
    key: "isWaitingForCountryCallingCode",
    value: function isWaitingForCountryCallingCode(_ref2) {
      var international = _ref2.international,
          callingCode = _ref2.callingCode;
      return international && !callingCode;
    } // Extracts a country calling code from a number
    // being entered in internatonal format.

  }, {
    key: "extractCountryCallingCode",
    value: function extractCountryCallingCode$1(state) {
      var _extractCountryCallin = extractCountryCallingCode('+' + state.getDigitsWithoutInternationalPrefix(), this.defaultCountry, this.defaultCallingCode, this.metadata.metadata),
          countryCallingCode = _extractCountryCallin.countryCallingCode,
          number = _extractCountryCallin.number;

      if (countryCallingCode) {
        state.setCallingCode(countryCallingCode);
        state.update({
          nationalSignificantNumber: number
        });
        return true;
      }
    }
  }, {
    key: "reset",
    value: function reset(numberingPlan) {
      if (numberingPlan) {
        this.hasSelectedNumberingPlan = true;

        var nationalPrefixForParsing = numberingPlan._nationalPrefixForParsing();

        this.couldPossiblyExtractAnotherNationalSignificantNumber = nationalPrefixForParsing && COMPLEX_NATIONAL_PREFIX.test(nationalPrefixForParsing);
      } else {
        this.hasSelectedNumberingPlan = undefined;
        this.couldPossiblyExtractAnotherNationalSignificantNumber = undefined;
      }
    }
    /**
     * Extracts a national (significant) number from user input.
     * Google's library is different in that it only applies `national_prefix_for_parsing`
     * and doesn't apply `national_prefix_transform_rule` after that.
     * https://github.com/google/libphonenumber/blob/a3d70b0487875475e6ad659af404943211d26456/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L539
     * @return {boolean} [extracted]
     */

  }, {
    key: "extractNationalSignificantNumber",
    value: function extractNationalSignificantNumber(nationalDigits, setState) {
      if (!this.hasSelectedNumberingPlan) {
        return;
      }

      var _extractNationalNumbe = extractNationalNumberFromPossiblyIncompleteNumber(nationalDigits, this.metadata),
          nationalPrefix = _extractNationalNumbe.nationalPrefix,
          nationalNumber = _extractNationalNumbe.nationalNumber,
          carrierCode = _extractNationalNumbe.carrierCode;

      if (nationalNumber === nationalDigits) {
        return;
      }

      this.onExtractedNationalNumber(nationalPrefix, carrierCode, nationalNumber, nationalDigits, setState);
      return true;
    }
    /**
     * In Google's code this function is called "attempt to extract longer NDD".
     * "Some national prefixes are a substring of others", they say.
     * @return {boolean} [result] — Returns `true` if extracting a national prefix produced different results from what they were.
     */

  }, {
    key: "extractAnotherNationalSignificantNumber",
    value: function extractAnotherNationalSignificantNumber(nationalDigits, prevNationalSignificantNumber, setState) {
      if (!this.hasExtractedNationalSignificantNumber) {
        return this.extractNationalSignificantNumber(nationalDigits, setState);
      }

      if (!this.couldPossiblyExtractAnotherNationalSignificantNumber) {
        return;
      }

      var _extractNationalNumbe2 = extractNationalNumberFromPossiblyIncompleteNumber(nationalDigits, this.metadata),
          nationalPrefix = _extractNationalNumbe2.nationalPrefix,
          nationalNumber = _extractNationalNumbe2.nationalNumber,
          carrierCode = _extractNationalNumbe2.carrierCode; // If a national prefix has been extracted previously,
      // then it's always extracted as additional digits are added.
      // That's assuming `extractNationalNumberFromPossiblyIncompleteNumber()`
      // doesn't do anything different from what it currently does.
      // So, just in case, here's this check, though it doesn't occur.

      /* istanbul ignore if */


      if (nationalNumber === prevNationalSignificantNumber) {
        return;
      }

      this.onExtractedNationalNumber(nationalPrefix, carrierCode, nationalNumber, nationalDigits, setState);
      return true;
    }
  }, {
    key: "onExtractedNationalNumber",
    value: function onExtractedNationalNumber(nationalPrefix, carrierCode, nationalSignificantNumber, nationalDigits, setState) {
      var complexPrefixBeforeNationalSignificantNumber;
      var nationalSignificantNumberMatchesInput; // This check also works with empty `this.nationalSignificantNumber`.

      var nationalSignificantNumberIndex = nationalDigits.lastIndexOf(nationalSignificantNumber); // If the extracted national (significant) number is the
      // last substring of the `digits`, then it means that it hasn't been altered:
      // no digits have been removed from the national (significant) number
      // while applying `national_prefix_transform_rule`.
      // https://gitlab.com/catamphetamine/libphonenumber-js/-/blob/master/METADATA.md#national_prefix_for_parsing--national_prefix_transform_rule

      if (nationalSignificantNumberIndex >= 0 && nationalSignificantNumberIndex === nationalDigits.length - nationalSignificantNumber.length) {
        nationalSignificantNumberMatchesInput = true; // If a prefix of a national (significant) number is not as simple
        // as just a basic national prefix, then such prefix is stored in
        // `this.complexPrefixBeforeNationalSignificantNumber` property and will be
        // prepended "as is" to the national (significant) number to produce
        // a formatted result.

        var prefixBeforeNationalNumber = nationalDigits.slice(0, nationalSignificantNumberIndex); // `prefixBeforeNationalNumber` is always non-empty,
        // because `onExtractedNationalNumber()` isn't called
        // when a national (significant) number hasn't been actually "extracted":
        // when a national (significant) number is equal to the national part of `digits`,
        // then `onExtractedNationalNumber()` doesn't get called.

        if (prefixBeforeNationalNumber !== nationalPrefix) {
          complexPrefixBeforeNationalSignificantNumber = prefixBeforeNationalNumber;
        }
      }

      setState({
        nationalPrefix: nationalPrefix,
        carrierCode: carrierCode,
        nationalSignificantNumber: nationalSignificantNumber,
        nationalSignificantNumberMatchesInput: nationalSignificantNumberMatchesInput,
        complexPrefixBeforeNationalSignificantNumber: complexPrefixBeforeNationalSignificantNumber
      }); // `onExtractedNationalNumber()` is only called when
      // the national (significant) number actually did change.

      this.hasExtractedNationalSignificantNumber = true;
      this.onNationalSignificantNumberChange();
    }
  }, {
    key: "reExtractNationalSignificantNumber",
    value: function reExtractNationalSignificantNumber(state) {
      // Attempt to extract a national prefix.
      //
      // Some people incorrectly input national prefix
      // in an international phone number.
      // For example, some people write British phone numbers as `+44(0)...`.
      //
      // Also, in some rare cases, it is valid for a national prefix
      // to be a part of an international phone number.
      // For example, mobile phone numbers in Mexico are supposed to be
      // dialled internationally using a `1` national prefix,
      // so the national prefix will be part of an international number.
      //
      // Quote from:
      // https://www.mexperience.com/dialing-cell-phones-in-mexico/
      //
      // "Dialing a Mexican cell phone from abroad
      // When you are calling a cell phone number in Mexico from outside Mexico,
      // it’s necessary to dial an additional “1” after Mexico’s country code
      // (which is “52”) and before the area code.
      // You also ignore the 045, and simply dial the area code and the
      // cell phone’s number.
      //
      // If you don’t add the “1”, you’ll receive a recorded announcement
      // asking you to redial using it.
      //
      // For example, if you are calling from the USA to a cell phone
      // in Mexico City, you would dial +52 – 1 – 55 – 1234 5678.
      // (Note that this is different to calling a land line in Mexico City
      // from abroad, where the number dialed would be +52 – 55 – 1234 5678)".
      //
      // Google's demo output:
      // https://libphonenumber.appspot.com/phonenumberparser?number=%2b5215512345678&country=MX
      //
      if (this.extractAnotherNationalSignificantNumber(state.getNationalDigits(), state.nationalSignificantNumber, state.update)) {
        return true;
      } // If no format matches the phone number, then it could be
      // "a really long IDD" (quote from a comment in Google's library).
      // An IDD prefix is first extracted when the user has entered at least 3 digits,
      // and then here — every time when there's a new digit and the number
      // couldn't be formatted.
      // For example, in Australia the default IDD prefix is `0011`,
      // and it could even be as long as `14880011`.
      //
      // Could also check `!hasReceivedThreeLeadingDigits` here
      // to filter out the case when this check duplicates the one
      // already performed when there're 3 leading digits,
      // but it's not a big deal, and in most cases there
      // will be a suitable `format` when there're 3 leading digits.
      //


      if (this.extractIddPrefix(state)) {
        this.extractCallingCodeAndNationalSignificantNumber(state);
        return true;
      } // Google's AsYouType formatter supports sort of an "autocorrection" feature
      // when it "autocorrects" numbers that have been input for a country
      // with that country's calling code.
      // Such "autocorrection" feature looks weird, but different people have been requesting it:
      // https://github.com/catamphetamine/libphonenumber-js/issues/376
      // https://github.com/catamphetamine/libphonenumber-js/issues/375
      // https://github.com/catamphetamine/libphonenumber-js/issues/316


      if (this.fixMissingPlus(state)) {
        this.extractCallingCodeAndNationalSignificantNumber(state);
        return true;
      }
    }
  }, {
    key: "extractIddPrefix",
    value: function extractIddPrefix(state) {
      // An IDD prefix can't be present in a number written with a `+`.
      // Also, don't re-extract an IDD prefix if has already been extracted.
      var international = state.international,
          IDDPrefix = state.IDDPrefix,
          digits = state.digits,
          nationalSignificantNumber = state.nationalSignificantNumber;

      if (international || IDDPrefix) {
        return;
      } // Some users input their phone number in "out-of-country"
      // dialing format instead of using the leading `+`.
      // https://github.com/catamphetamine/libphonenumber-js/issues/185
      // Detect such numbers.


      var numberWithoutIDD = stripIddPrefix(digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata);

      if (numberWithoutIDD !== undefined && numberWithoutIDD !== digits) {
        // If an IDD prefix was stripped then convert the IDD-prefixed number
        // to international number for subsequent parsing.
        state.update({
          IDDPrefix: digits.slice(0, digits.length - numberWithoutIDD.length)
        });
        this.startInternationalNumber(state);
        return true;
      }
    }
  }, {
    key: "fixMissingPlus",
    value: function fixMissingPlus(state) {
      if (!state.international) {
        var _extractCountryCallin2 = extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(state.digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata),
            newCallingCode = _extractCountryCallin2.countryCallingCode,
            number = _extractCountryCallin2.number;

        if (newCallingCode) {
          state.update({
            missingPlus: true
          });
          this.startInternationalNumber(state);
          return true;
        }
      }
    }
  }, {
    key: "startInternationalNumber",
    value: function startInternationalNumber(state) {
      state.startInternationalNumber(); // If a national (significant) number has been extracted before, reset it.

      if (state.nationalSignificantNumber) {
        state.resetNationalSignificantNumber();
        this.onNationalSignificantNumberChange();
        this.hasExtractedNationalSignificantNumber = undefined;
      }
    }
  }, {
    key: "extractCallingCodeAndNationalSignificantNumber",
    value: function extractCallingCodeAndNationalSignificantNumber(state) {
      if (this.extractCountryCallingCode(state)) {
        // `this.extractCallingCode()` is currently called when the number
        // couldn't be formatted during the standard procedure.
        // Normally, the national prefix would be re-extracted
        // for an international number if such number couldn't be formatted,
        // but since it's already not able to be formatted,
        // there won't be yet another retry, so also extract national prefix here.
        this.extractNationalSignificantNumber(state.getNationalDigits(), state.update);
      }
    }
  }]);

  return AsYouTypeParser;
}();

function extractFormattedPhoneNumber$1(text) {
  // Attempt to extract a possible number from the string passed in.
  var startsAt = text.search(VALID_FORMATTED_PHONE_NUMBER_PART);

  if (startsAt < 0) {
    return;
  } // Trim everything to the left of the phone number.


  text = text.slice(startsAt); // Trim the `+`.

  var hasPlus;

  if (text[0] === '+') {
    hasPlus = true;
    text = text.slice('+'.length);
  } // Trim everything to the right of the phone number.


  text = text.replace(AFTER_PHONE_NUMBER_DIGITS_END_PATTERN, ''); // Re-add the previously trimmed `+`.

  if (hasPlus) {
    text = '+' + text;
  }

  return text;
}
/**
 * Extracts formatted phone number digits (and a `+`) from text (if there're any).
 * @param  {string} text
 * @return {any[]}
 */


function _extractFormattedDigitsAndPlus(text) {
  // Extract a formatted phone number part from text.
  var extractedNumber = extractFormattedPhoneNumber$1(text) || ''; // Trim a `+`.

  if (extractedNumber[0] === '+') {
    return [extractedNumber.slice('+'.length), true];
  }

  return [extractedNumber];
}
/**
 * Extracts formatted phone number digits (and a `+`) from text (if there're any).
 * @param  {string} text
 * @return {any[]}
 */


function extractFormattedDigitsAndPlus(text) {
  var _extractFormattedDigi3 = _extractFormattedDigitsAndPlus(text),
      _extractFormattedDigi4 = _slicedToArray$2(_extractFormattedDigi3, 2),
      formattedDigits = _extractFormattedDigi4[0],
      hasPlus = _extractFormattedDigi4[1]; // If the extracted phone number part
  // can possibly be a part of some valid phone number
  // then parse phone number characters from a formatted phone number.


  if (!VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART_PATTERN.test(formattedDigits)) {
    formattedDigits = '';
  }

  return [formattedDigits, hasPlus];
}

function _typeof$2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$2 = function _typeof(obj) { return typeof obj; }; } else { _typeof$2 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$2(obj); }

function _slicedToArray$3(arr, i) { return _arrayWithHoles$3(arr) || _iterableToArrayLimit$3(arr, i) || _nonIterableRest$3(); }

function _nonIterableRest$3() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit$3(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$3(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck$a(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$9(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$9(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$9(Constructor.prototype, protoProps); if (staticProps) _defineProperties$9(Constructor, staticProps); return Constructor; }

var AsYouType =
/*#__PURE__*/
function () {
  /**
   * @param {(string|object)?} [optionsOrDefaultCountry] - The default country used for parsing non-international phone numbers. Can also be an `options` object.
   * @param {Object} metadata
   */
  function AsYouType(optionsOrDefaultCountry, metadata) {
    _classCallCheck$a(this, AsYouType);

    this.metadata = new Metadata(metadata);

    var _this$getCountryAndCa = this.getCountryAndCallingCode(optionsOrDefaultCountry),
        _this$getCountryAndCa2 = _slicedToArray$3(_this$getCountryAndCa, 2),
        defaultCountry = _this$getCountryAndCa2[0],
        defaultCallingCode = _this$getCountryAndCa2[1];

    this.defaultCountry = defaultCountry;
    this.defaultCallingCode = defaultCallingCode;
    this.reset();
  }

  _createClass$9(AsYouType, [{
    key: "getCountryAndCallingCode",
    value: function getCountryAndCallingCode(optionsOrDefaultCountry) {
      // Set `defaultCountry` and `defaultCallingCode` options.
      var defaultCountry;
      var defaultCallingCode; // Turns out `null` also has type "object". Weird.

      if (optionsOrDefaultCountry) {
        if (_typeof$2(optionsOrDefaultCountry) === 'object') {
          defaultCountry = optionsOrDefaultCountry.defaultCountry;
          defaultCallingCode = optionsOrDefaultCountry.defaultCallingCode;
        } else {
          defaultCountry = optionsOrDefaultCountry;
        }
      }

      if (defaultCountry && !this.metadata.hasCountry(defaultCountry)) {
        defaultCountry = undefined;
      }

      return [defaultCountry, defaultCallingCode];
    }
    /**
     * Inputs "next" phone number characters.
     * @param  {string} text
     * @return {string} Formatted phone number characters that have been input so far.
     */

  }, {
    key: "input",
    value: function input(text) {
      var _this$parser$input = this.parser.input(text, this.state),
          digits = _this$parser$input.digits,
          justLeadingPlus = _this$parser$input.justLeadingPlus;

      if (justLeadingPlus) {
        this.formattedOutput = '+';
      } else if (digits) {
        this.determineTheCountryIfNeeded(); // Match the available formats by the currently available leading digits.

        if (this.state.nationalSignificantNumber) {
          this.formatter.narrowDownMatchingFormats(this.state);
        }

        var formattedNationalNumber;

        if (this.metadata.hasSelectedNumberingPlan()) {
          formattedNationalNumber = this.formatter.format(digits, this.state);
        }

        if (formattedNationalNumber === undefined) {
          // See if another national (significant) number could be re-extracted.
          if (this.parser.reExtractNationalSignificantNumber(this.state)) {
            this.determineTheCountryIfNeeded(); // If it could, then re-try formatting the new national (significant) number.

            var nationalDigits = this.state.getNationalDigits();

            if (nationalDigits) {
              formattedNationalNumber = this.formatter.format(nationalDigits, this.state);
            }
          }
        }

        this.formattedOutput = formattedNationalNumber ? this.getFullNumber(formattedNationalNumber) : this.getNonFormattedNumber();
      }

      return this.formattedOutput;
    }
  }, {
    key: "reset",
    value: function reset() {
      var _this = this;

      this.state = new AsYouTypeState({
        onCountryChange: function onCountryChange(country) {
          // Before version `1.6.0`, the official `AsYouType` formatter API
          // included the `.country` property of an `AsYouType` instance.
          // Since that property (along with the others) have been moved to
          // `this.state`, `this.country` property is emulated for compatibility
          // with the old versions.
          _this.country = country;
        },
        onCallingCodeChange: function onCallingCodeChange(country, callingCode) {
          _this.metadata.selectNumberingPlan(country, callingCode);

          _this.formatter.reset(_this.metadata.numberingPlan, _this.state);

          _this.parser.reset(_this.metadata.numberingPlan);
        }
      });
      this.formatter = new AsYouTypeFormatter({
        state: this.state,
        metadata: this.metadata
      });
      this.parser = new AsYouTypeParser({
        defaultCountry: this.defaultCountry,
        defaultCallingCode: this.defaultCallingCode,
        metadata: this.metadata,
        state: this.state,
        onNationalSignificantNumberChange: function onNationalSignificantNumberChange() {
          _this.determineTheCountryIfNeeded();

          _this.formatter.reset(_this.metadata.numberingPlan, _this.state);
        }
      });
      this.state.reset(this.defaultCountry, this.defaultCallingCode);
      this.formattedOutput = '';
      return this;
    }
    /**
     * Returns `true` if the phone number is being input in international format.
     * In other words, returns `true` if and only if the parsed phone number starts with a `"+"`.
     * @return {boolean}
     */

  }, {
    key: "isInternational",
    value: function isInternational() {
      return this.state.international;
    }
    /**
     * Returns the "country calling code" part of the phone number.
     * Returns `undefined` if the number is not being input in international format.
     * Returns "country calling code" for "non-geographic" phone numbering plans too.
     * @return {string} [callingCode]
     */

  }, {
    key: "getCallingCode",
    value: function getCallingCode() {
      return this.state.callingCode;
    } // A legacy alias.

  }, {
    key: "getCountryCallingCode",
    value: function getCountryCallingCode() {
      return this.getCallingCode();
    }
    /**
     * Returns a two-letter country code of the phone number.
     * Returns `undefined` for "non-geographic" phone numbering plans.
     * Returns `undefined` if no phone number has been input yet.
     * @return {string} [country]
     */

  }, {
    key: "getCountry",
    value: function getCountry() {
      var _this$state = this.state,
          digits = _this$state.digits,
          country = _this$state.country; // If no digits have been input yet,
      // then `this.country` is the `defaultCountry`.
      // Won't return the `defaultCountry` in such case.

      if (!digits) {
        return;
      }

      var countryCode = country;

      return countryCode;
    }
  }, {
    key: "determineTheCountryIfNeeded",
    value: function determineTheCountryIfNeeded() {
      // Suppose a user enters a phone number in international format,
      // and there're several countries corresponding to that country calling code,
      // and a country has been derived from the number, and then
      // a user enters one more digit and the number is no longer
      // valid for the derived country, so the country should be re-derived
      // on every new digit in those cases.
      //
      // If the phone number is being input in national format,
      // then it could be a case when `defaultCountry` wasn't specified
      // when creating `AsYouType` instance, and just `defaultCallingCode` was specified,
      // and that "calling code" could correspond to a "non-geographic entity",
      // or there could be several countries corresponding to that country calling code.
      // In those cases, `this.country` is `undefined` and should be derived
      // from the number. Again, if country calling code is ambiguous, then
      // `this.country` should be re-derived with each new digit.
      //
      if (!this.state.country || this.isCountryCallingCodeAmbiguous()) {
        this.determineTheCountry();
      }
    } // Prepends `+CountryCode ` in case of an international phone number

  }, {
    key: "getFullNumber",
    value: function getFullNumber(formattedNationalNumber) {
      var _this2 = this;

      if (this.isInternational()) {
        var prefix = function prefix(text) {
          return _this2.formatter.getInternationalPrefixBeforeCountryCallingCode(_this2.state, {
            spacing: text ? true : false
          }) + text;
        };

        var callingCode = this.state.callingCode;

        if (!callingCode) {
          return prefix("".concat(this.state.getDigitsWithoutInternationalPrefix()));
        }

        if (!formattedNationalNumber) {
          return prefix(callingCode);
        }

        return prefix("".concat(callingCode, " ").concat(formattedNationalNumber));
      }

      return formattedNationalNumber;
    }
  }, {
    key: "getNonFormattedNationalNumberWithPrefix",
    value: function getNonFormattedNationalNumberWithPrefix() {
      var _this$state2 = this.state,
          nationalSignificantNumber = _this$state2.nationalSignificantNumber,
          complexPrefixBeforeNationalSignificantNumber = _this$state2.complexPrefixBeforeNationalSignificantNumber,
          nationalPrefix = _this$state2.nationalPrefix;
      var number = nationalSignificantNumber;
      var prefix = complexPrefixBeforeNationalSignificantNumber || nationalPrefix;

      if (prefix) {
        number = prefix + number;
      }

      return number;
    }
  }, {
    key: "getNonFormattedNumber",
    value: function getNonFormattedNumber() {
      var nationalSignificantNumberMatchesInput = this.state.nationalSignificantNumberMatchesInput;
      return this.getFullNumber(nationalSignificantNumberMatchesInput ? this.getNonFormattedNationalNumberWithPrefix() : this.state.getNationalDigits());
    }
  }, {
    key: "getNonFormattedTemplate",
    value: function getNonFormattedTemplate() {
      var number = this.getNonFormattedNumber();

      if (number) {
        return number.replace(/[\+\d]/g, DIGIT_PLACEHOLDER);
      }
    }
  }, {
    key: "isCountryCallingCodeAmbiguous",
    value: function isCountryCallingCodeAmbiguous() {
      var callingCode = this.state.callingCode;
      var countryCodes = this.metadata.getCountryCodesForCallingCode(callingCode);
      return countryCodes && countryCodes.length > 1;
    } // Determines the country of the phone number
    // entered so far based on the country phone code
    // and the national phone number.

  }, {
    key: "determineTheCountry",
    value: function determineTheCountry() {
      this.state.setCountry(getCountryByCallingCode(this.isInternational() ? this.state.callingCode : this.defaultCallingCode, this.state.nationalSignificantNumber, this.metadata));
    }
    /**
     * Returns an instance of `PhoneNumber` class.
     * Will return `undefined` if no national (significant) number
     * digits have been entered so far, or if no `defaultCountry` has been
     * set and the user enters a phone number not in international format.
     */

  }, {
    key: "getNumber",
    value: function getNumber() {
      var _this$state3 = this.state,
          nationalSignificantNumber = _this$state3.nationalSignificantNumber,
          carrierCode = _this$state3.carrierCode;

      if (this.isInternational()) {
        if (!this.state.callingCode) {
          return;
        }
      } else {
        if (!this.state.country && !this.defaultCallingCode) {
          return;
        }
      }

      if (!nationalSignificantNumber) {
        return;
      }

      var countryCode = this.getCountry();
      var callingCode = this.getCountryCallingCode() || this.defaultCallingCode;
      var phoneNumber = new PhoneNumber(countryCode || callingCode, nationalSignificantNumber, this.metadata.metadata);

      if (carrierCode) {
        phoneNumber.carrierCode = carrierCode;
      } // Phone number extensions are not supported by "As You Type" formatter.


      return phoneNumber;
    }
    /**
     * Returns `true` if the phone number is "possible".
     * Is just a shortcut for `PhoneNumber.isPossible()`.
     * @return {boolean}
     */

  }, {
    key: "isPossible",
    value: function isPossible() {
      var phoneNumber = this.getNumber();

      if (!phoneNumber) {
        return false;
      }

      return phoneNumber.isPossible();
    }
    /**
     * Returns `true` if the phone number is "valid".
     * Is just a shortcut for `PhoneNumber.isValid()`.
     * @return {boolean}
     */

  }, {
    key: "isValid",
    value: function isValid() {
      var phoneNumber = this.getNumber();

      if (!phoneNumber) {
        return false;
      }

      return phoneNumber.isValid();
    }
    /**
     * @deprecated
     * This method is used in `react-phone-number-input/source/input-control.js`
     * in versions before `3.0.16`.
     */

  }, {
    key: "getNationalNumber",
    value: function getNationalNumber() {
      return this.state.nationalSignificantNumber;
    }
    /**
     * Returns the phone number characters entered by the user.
     * @return {string}
     */

  }, {
    key: "getChars",
    value: function getChars() {
      return (this.state.international ? '+' : '') + this.state.digits;
    }
    /**
     * Returns the template for the formatted phone number.
     * @return {string}
     */

  }, {
    key: "getTemplate",
    value: function getTemplate() {
      return this.formatter.getTemplate(this.state) || this.getNonFormattedTemplate() || '';
    }
  }]);

  return AsYouType;
}();

function PhoneNumberMatcher$1(text, options) {
	return PhoneNumberMatcher.call(this, text, options, metadata)
}
PhoneNumberMatcher$1.prototype = Object.create(PhoneNumberMatcher.prototype, {});
PhoneNumberMatcher$1.prototype.constructor = PhoneNumberMatcher$1;

function AsYouType$1(country) {
	return AsYouType.call(this, country, metadata)
}

AsYouType$1.prototype = Object.create(AsYouType.prototype, {});
AsYouType$1.prototype.constructor = AsYouType$1;

function Metadata$1() {
	return Metadata.call(this, metadata)
}

Metadata$1.prototype = Object.create(Metadata.prototype, {});
Metadata$1.prototype.constructor = Metadata$1;

function _classCallCheck$b(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$a(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$a(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$a(Constructor.prototype, protoProps); if (staticProps) _defineProperties$a(Constructor, staticProps); return Constructor; }

function _defineProperty$6(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var WHITESPACE_IN_THE_BEGINNING_PATTERN = new RegExp('^[' + WHITESPACE + ']+');
var PUNCTUATION_IN_THE_END_PATTERN = new RegExp('[' + VALID_PUNCTUATION + ']+$'); // // Regular expression for getting opening brackets for a valid number
/**
 * Extracts a parseable phone number including any opening brackets, etc.
 * @param  {string} text - Input.
 * @return {object} `{ ?number, ?startsAt, ?endsAt }`.
 */

var PhoneNumberSearch =
/*#__PURE__*/
function () {
  // Iteration tristate.
  function PhoneNumberSearch(text, options, metadata) {
    _classCallCheck$b(this, PhoneNumberSearch);

    _defineProperty$6(this, "state", 'NOT_READY');

    this.text = text; // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.

    this.options = options || {};
    this.metadata = metadata;
    this.regexp = new RegExp(VALID_PHONE_NUMBER_WITH_EXTENSION, 'ig');
  }

  _createClass$a(PhoneNumberSearch, [{
    key: "find",
    value: function find() {
      var matches = this.regexp.exec(this.text);

      if (!matches) {
        return;
      }

      var number = matches[0];
      var startsAt = matches.index;
      number = number.replace(WHITESPACE_IN_THE_BEGINNING_PATTERN, '');
      startsAt += matches[0].length - number.length; // Fixes not parsing numbers with whitespace in the end.
      // Also fixes not parsing numbers with opening parentheses in the end.
      // https://github.com/catamphetamine/libphonenumber-js/issues/252

      number = number.replace(PUNCTUATION_IN_THE_END_PATTERN, '');
      number = parsePreCandidate(number);
      var result = this.parseCandidate(number, startsAt);

      if (result) {
        return result;
      } // Tail recursion.
      // Try the next one if this one is not a valid phone number.


      return this.find();
    }
  }, {
    key: "parseCandidate",
    value: function parseCandidate(number, startsAt) {
      if (!isValidPreCandidate(number, startsAt, this.text)) {
        return;
      } // Don't parse phone numbers which are non-phone numbers
      // due to being part of something else (e.g. a UUID).
      // https://github.com/catamphetamine/libphonenumber-js/issues/213
      // Copy-pasted from Google's `PhoneNumberMatcher.js` (`.parseAndValidate()`).


      if (!isValidCandidate(number, startsAt, this.text, this.options.extended ? 'POSSIBLE' : 'VALID')) {
        return;
      } // // Prepend any opening brackets left behind by the
      // // `PHONE_NUMBER_START_PATTERN` regexp.
      // const text_before_number = text.slice(this.searching_from, startsAt)
      // const full_number_starts_at = text_before_number.search(BEFORE_NUMBER_DIGITS_PUNCTUATION)
      // if (full_number_starts_at >= 0)
      // {
      // 	number   = text_before_number.slice(full_number_starts_at) + number
      // 	startsAt = full_number_starts_at
      // }
      //
      // this.searching_from = matches.lastIndex


      var result = parse(number, this.options, this.metadata);

      if (!result.phone) {
        return;
      }

      result.startsAt = startsAt;
      result.endsAt = startsAt + number.length;
      return result;
    }
  }, {
    key: "hasNext",
    value: function hasNext() {
      if (this.state === 'NOT_READY') {
        this.last_match = this.find();

        if (this.last_match) {
          this.state = 'READY';
        } else {
          this.state = 'DONE';
        }
      }

      return this.state === 'READY';
    }
  }, {
    key: "next",
    value: function next() {
      // Check the state and find the next match as a side-effect if necessary.
      if (!this.hasNext()) {
        throw new Error('No next element');
      } // Don't retain that memory any longer than necessary.


      var result = this.last_match;
      this.last_match = null;
      this.state = 'NOT_READY';
      return result;
    }
  }]);

  return PhoneNumberSearch;
}();

function PhoneNumberSearch$1(text, options) {
	PhoneNumberSearch.call(this, text, options, metadata);
}

// Deprecated.
PhoneNumberSearch$1.prototype = Object.create(PhoneNumberSearch.prototype, {});
PhoneNumberSearch$1.prototype.constructor = PhoneNumberSearch$1;

var _templateObject$18;
var parser = new AsYouType$1('US');

function PhoneInputComponent(_ref) {
  var className = _ref.className,
      countries = _ref.countries,
      value = _ref.value,
      onChange = _ref.onChange,
      disabled = _ref.disabled,
      defaultCountry = _ref.defaultCountry,
      status = _ref.status,
      filterPlaceholder = _ref.filterPlaceholder,
      inputProps = _objectWithoutProperties(_ref, ["className", "countries", "value", "onChange", "disabled", "defaultCountry", "status", "filterPlaceholder"]);

  parser.reset();
  parser.input(value.number);
  var number = parser.getNumber();
  var numberCountry = value.country || (number === null || number === void 0 ? void 0 : number.country) || defaultCountry;
  var country = countries.find(function (country) {
    return numberCountry === country.value;
  }) || countries[0];
  var nationalNumber = number ? number.nationalNumber : '';
  var nationalNumberRef = useRef(nationalNumber);
  nationalNumberRef.current = nationalNumber;

  function handleCountryChange(country) {
    // PrefixSelect is memo'ed to avoid rerendering all countries all the time
    // so handleCountryChange binding to onChange will happen only once on mount.
    // to have access to the current nationalNumber, we must use a ref
    var number = "+".concat(country.prefix).concat(nationalNumberRef.current);
    onChange && onChange({
      number: number.replace(/\s/g, ''),
      country: country.value
    });
  }

  function handleNationalChange(evt) {
    var number = "+".concat(country.prefix).concat(evt.target.value);
    onChange && onChange({
      number: number.replace(/\s/g, ''),
      country: country.value
    });
  }

  return /*#__PURE__*/createElement(phone.Wrapper, {
    className: className,
    disabled: disabled,
    status: status
  }, /*#__PURE__*/createElement(PrefixSelect, {
    disabled: disabled,
    countries: countries,
    selectedCountry: country,
    onChange: handleCountryChange,
    filterPlaceholder: filterPlaceholder
  }), /*#__PURE__*/createElement(phone.Input, _extends({}, inputProps, {
    type: "tel",
    disabled: disabled,
    value: String(nationalNumber),
    onChange: handleNationalChange
  })));
}
/** will forward any other props to the underlying `<input>` */


var PhoneInput = styled(PhoneInputComponent)(_templateObject$18 || (_templateObject$18 = _taggedTemplateLiteral(["\n  /* no border on select button, border done by <S.phone.Wrapper> */\n  ", " {\n    border: none;\n\n    &:focus,\n    &:hover,\n    &:disabled {\n      border: none;\n    }\n  }\n"])), select.Button);
PhoneInput.displayName = 'PhoneInput';

var _templateObject$19, _templateObject2$P;
var PhoneFieldWrapper = styled(Field)(_templateObject$19 || (_templateObject$19 = _taggedTemplateLiteral(["\n  ", " {\n    margin-top: -2px;\n    margin-bottom: 7px;\n\n    @media screen and ", " {\n      margin-top: 0px;\n      margin-bottom: 0px;\n    }\n  }\n\n  ", " {\n    margin-top: 10px;\n  }\n\n  ", ", ", " {\n    margin-bottom: 7px;\n  }\n"])), field.Context, TABLET, field.Status, field.Title, field.Description);

function PhoneFieldComponent(_ref) {
  var className = _ref.className,
      label = _ref.label,
      context = _ref.context,
      description = _ref.description,
      error = _ref.error,
      success = _ref.success,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? String(Math.random()) : _ref$id,
      inputProps = _objectWithoutProperties(_ref, ["className", "label", "context", "description", "error", "success", "id"]);

  var status = 'default';

  if (error !== undefined && success === undefined) {
    status = 'error';
  }

  if (success !== undefined && error === undefined) {
    status = 'success';
  }

  return /*#__PURE__*/createElement(PhoneFieldWrapper, {
    className: className,
    htmlFor: id,
    label: label,
    description: description,
    context: context
  }, /*#__PURE__*/createElement(PhoneInput, _extends({}, inputProps, {
    id: id,
    status: status
  })), (error || success) && /*#__PURE__*/createElement(FieldStatus, {
    error: error,
    success: success
  }));
}
/** extends `<PhoneInput>`, see there for additional props */


var PhoneField = styled(PhoneFieldComponent)(_templateObject2$P || (_templateObject2$P = _taggedTemplateLiteral([""])));
PhoneField.displayName = 'PhoneField';

var _templateObject$1a, _templateObject2$Q, _templateObject3$D, _templateObject4$A, _templateObject5$t, _templateObject6$n, _templateObject7$l, _templateObject8$l, _templateObject9$j;
var DefaultRadiomark = styled(radio.Radiomark).attrs({
  size: 18,
  status: undefined
})(_templateObject$1a || (_templateObject$1a = _taggedTemplateLiteral(["\n  display: inline-block;\n"])));
var CheckedRadiomark = styled(radio.Radiomark).attrs({
  size: 18,
  status: 'checked'
})(_templateObject2$Q || (_templateObject2$Q = _taggedTemplateLiteral(["\n  display: none;\n"])));
var FocusedRadiomark = styled(radio.Radiomark).attrs({
  size: 18,
  status: 'focused'
})(_templateObject3$D || (_templateObject3$D = _taggedTemplateLiteral(["\n  display: none;\n"])));
var styleRadioToggle = function styleRadioToggle(input, follow, styles) {
  return css(_templateObject4$A || (_templateObject4$A = _taggedTemplateLiteral(["\n  ", ":focus + ", " {\n    ", " {\n      display: inline-block;\n    }\n\n    ", ", ", " {\n      display: none;\n    }\n\n    ", "\n  }\n\n  ", ":checked + ", " {\n    ", " {\n      display: inline-block;\n    }\n\n    ", ", ", " {\n      display: none;\n    }\n\n    ", "\n  }\n\n  ", ":disabled + ", " {\n    ", "\n  }\n"])), input, follow, FocusedRadiomark, DefaultRadiomark, CheckedRadiomark, styles === null || styles === void 0 ? void 0 : styles.focus, input, follow, CheckedRadiomark, DefaultRadiomark, FocusedRadiomark, styles === null || styles === void 0 ? void 0 : styles.checked, input, follow, styles === null || styles === void 0 ? void 0 : styles.disabled);
};
var ControlledRadioInputWrapper = styled.div(_templateObject5$t || (_templateObject5$t = _taggedTemplateLiteral(["\n  width: 18px;\n  height: 18px;\n"])));

function ControlledRadioInputComponent(_ref) {
  var className = _ref.className,
      disabled = _ref.disabled,
      children = _ref.children;
  return /*#__PURE__*/createElement(ControlledRadioInputWrapper, {
    className: className
  }, children, /*#__PURE__*/createElement(DefaultRadiomark, {
    disabled: disabled
  }), /*#__PURE__*/createElement(FocusedRadiomark, {
    disabled: disabled
  }), /*#__PURE__*/createElement(CheckedRadiomark, {
    disabled: disabled
  }));
}

var ControlledRadioInput = styled(ControlledRadioInputComponent)(_templateObject6$n || (_templateObject6$n = _taggedTemplateLiteral([""])));
var Container$2 = styled.div(_templateObject7$l || (_templateObject7$l = _taggedTemplateLiteral([""])));
var RadioInputWrapper = styled.div(_templateObject8$l || (_templateObject8$l = _taggedTemplateLiteral(["\n  ", "\n"])), styleRadioToggle(input.HiddenFocusableInput, Container$2, {}));

/** will forward any other props to the underlying `<input>` */
function RadioInputComponent(_ref2) {
  var className = _ref2.className,
      inputProps = _objectWithoutProperties(_ref2, ["className"]);

  return /*#__PURE__*/createElement(RadioInputWrapper, {
    className: className
  }, /*#__PURE__*/createElement(input.HiddenFocusableInput, _extends({
    type: "checkbox"
  }, inputProps)), /*#__PURE__*/createElement(Container$2, null, /*#__PURE__*/createElement(ControlledRadioInput, {
    disabled: inputProps.disabled
  })));
}

var RadioInput = styled(RadioInputComponent)(_templateObject9$j || (_templateObject9$j = _taggedTemplateLiteral([""])));
RadioInput.displayName = 'RadioInput';

var _templateObject$1b, _templateObject2$R, _templateObject3$E, _templateObject4$B;
var SmallRadioList = styled.div(_templateObject$1b || (_templateObject$1b = _taggedTemplateLiteral(["\n  display: inline-flex;\n  flex-direction: row;\n  ", "\n\n  ", " {\n    border: none !important;\n    padding: 9px 9px 9px 25px;\n  }\n\n  ", " {\n    display: none;\n  }\n\n  ", " {\n    font-size: 13px;\n    line-height: 18px;\n  }\n\n  ", ":disabled ~ ", " {\n    background-color: ", ";\n  }\n"])), function (_ref) {
  var isError = _ref.isError;
  return isError && css(_templateObject2$R || (_templateObject2$R = _taggedTemplateLiteral(["\n      border: 1px dashed ", ";\n    "])), PRIMARY_RED);
}, Field, field.Description, field.Title, input.HiddenFocusableInput, Field, PRIMARY_WHITE);
var BigRadioList = styled.div(_templateObject3$E || (_templateObject3$E = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  margin-top: 1px;\n  background-color: ", ";\n\n  ", " ", " {\n    background-color: transparent;\n    min-height: 50px;\n    margin-top: -1px;\n  }\n\n  ", " {\n    flex: 0;\n  }\n\n  ", " {\n    flex: 0;\n  }\n"])), PRIMARY_WHITE, RadioField, Field, field.TitleWrapper, field.Description);
var radioGroupContext = /*#__PURE__*/createContext(undefined);

function RadioGroupFieldComponent(_ref2) {
  var className = _ref2.className,
      _ref2$type = _ref2.type,
      type = _ref2$type === void 0 ? 'big' : _ref2$type,
      error = _ref2.error,
      children = _ref2.children,
      _ref2$name = _ref2.name,
      name = _ref2$name === void 0 ? String(Math.random()) : _ref2$name;

  if (type === 'big') {
    return /*#__PURE__*/createElement(radio.BigGroup, {
      className: className
    }, /*#__PURE__*/createElement(BigRadioList, {
      isError: error !== undefined
    }, /*#__PURE__*/createElement(radioGroupContext.Provider, {
      value: {
        name: name,
        type: type
      }
    }, children)), /*#__PURE__*/createElement(FieldStatus, {
      error: error
    }));
  } else {
    return /*#__PURE__*/createElement(radio.SmallGroup, {
      className: className
    }, /*#__PURE__*/createElement(SmallRadioList, {
      isError: error !== undefined
    }, /*#__PURE__*/createElement(radioGroupContext.Provider, {
      value: {
        name: name,
        type: type
      }
    }, children)), /*#__PURE__*/createElement(FieldStatus, {
      error: error
    }));
  }
}
/** usually used with `<RadioField>`. */


var RadioGroupField = styled(RadioGroupFieldComponent)(_templateObject4$B || (_templateObject4$B = _taggedTemplateLiteral([""])));
RadioGroupField.displayName = 'RadioGroupField';

var _templateObject$1c, _templateObject2$S, _templateObject3$F, _templateObject4$C, _templateObject5$u, _templateObject6$o;
var StyledRadioField = styled(Field)(_templateObject$1c || (_templateObject$1c = _taggedTemplateLiteral(["\n  position: relative;\n  padding: 12px 12px 12px 40px;\n  background-color: ", ";\n  border: ", ";\n  border-radius: 2px;\n  justify-content: space-evenly;\n\n  ", " {\n    width: 100%;\n  }\n\n  ", ":focus ~ & {\n    border-color: ", ";\n  }\n\n  ", ":checked ~ & {\n    border-color: ", ";\n    border-style: solid;\n    ", " {\n      color: ", ";\n    }\n  }\n\n  ", ":disabled ~ & {\n    border-color: ", ";\n    border-style: solid;\n    background-color: ", ";\n    ", " {\n      color: ", ";\n    }\n  }\n"])), PRIMARY_WHITE, function (_ref) {
  var isError = _ref.isError;
  return isError ? "1px dashed ".concat(PRIMARY_RED) : "1px solid ".concat(GREY_SHADE_5);
}, field.Status, input.HiddenFocusableInput, function (_ref2) {
  var isError = _ref2.isError;
  return isError ? PRIMARY_RED : GREY_SHADE_4;
}, input.HiddenFocusableInput, PRIMARY_BLUE, field.Title, PRIMARY_BLUE, input.HiddenFocusableInput, GREY_SHADE_6, GREY_SHADE_6, field.Title, GREY_SHADE_4);
var RadioFieldWrapper = styled.div(_templateObject2$S || (_templateObject2$S = _taggedTemplateLiteral(["\n  position: relative;\n\n  ", " {\n    width: 18px;\n    height: 18px;\n  }\n\n  ", ", ", " {\n    position: absolute;\n    ", "\n\n    /*\n      We want <RadioInput> and <S.input.HiddenFocusableInput> to be supperposed (click on <RadioInput> = click on <S.input.HiddenFocusableInput> = check the radio control)\n      We want <RadioInput> left to <StyledRadioField> and vertically centered.\n      This could be done with flex positioning but :\n        - we would need to have <RadioInput> as as sibling of <StyledRadioField> (impossible given <Field> definition)\n        - it would be difficult to have <S.input.HiddenFocusableInput> over <RadioInput> unless they where child of the same parent (impossible because we need <S.input.HiddenFocusableInput> as sibling of <StyledRadioField> for css selector shenaningans for :checked styling).\n      This leaves us  with top: 50% + translate as last resort for the vertical centering.\n    */\n    top: 50%;\n    transform: translateY(-50%);\n    margin: 0;\n  }\n\n  ", "\n"])), input.HiddenFocusableInput, ControlledRadioInput, input.HiddenFocusableInput, function (_ref3) {
  var type = _ref3.type;

  if (type === 'small') {
    return css(_templateObject3$F || (_templateObject3$F = _taggedTemplateLiteral(["\n          left: 0;\n        "])));
  } else {
    return css(_templateObject4$C || (_templateObject4$C = _taggedTemplateLiteral(["\n          left: 12px;\n        "])));
  }
}, styleRadioToggle(input.HiddenFocusableInput, StyledRadioField, {
  checked: css(_templateObject5$u || (_templateObject5$u = _taggedTemplateLiteral(["\n      position: relative;\n      z-index: 1;\n    "])))
}));

function RadioFieldComponent(_ref4) {
  var className = _ref4.className,
      _ref4$isError = _ref4.isError,
      isError = _ref4$isError === void 0 ? false : _ref4$isError,
      label = _ref4.label,
      description = _ref4.description,
      _ref4$id = _ref4.id,
      id = _ref4$id === void 0 ? String(Math.random()) : _ref4$id,
      children = _ref4.children,
      context = _ref4.context,
      inputProps = _objectWithoutProperties(_ref4, ["className", "isError", "label", "description", "id", "children", "context"]);

  var groupContext = useContext(radioGroupContext);
  var type = 'small';

  if (groupContext !== undefined) {
    inputProps.name = inputProps.name || groupContext.name;
    type = groupContext.type || type;
  }

  return /*#__PURE__*/createElement(RadioFieldWrapper, {
    className: className,
    type: type
  }, children, /*#__PURE__*/createElement(input.HiddenFocusableInput, _extends({
    type: "radio"
  }, inputProps, {
    id: id
  })), /*#__PURE__*/createElement(StyledRadioField, {
    isError: isError,
    htmlFor: id,
    label: label,
    description: description,
    context: context
  }, /*#__PURE__*/createElement(ControlledRadioInput, {
    disabled: inputProps.disabled
  })));
}
/** extends `<RadioInput>`, see there for additional props. Usually used with `<RadioGroupField>`. */


var RadioField = styled(RadioFieldComponent)(_templateObject6$o || (_templateObject6$o = _taggedTemplateLiteral([""])));
RadioField.displayName = 'RadioField';

var _templateObject$1d, _templateObject2$T;
var SelectFieldWrapper = styled(Field)(_templateObject$1d || (_templateObject$1d = _taggedTemplateLiteral(["\n  ", " {\n    margin-top: 10px;\n  }\n\n  ", ", ", " {\n    margin-bottom: 7px;\n  }\n"])), field.Status, field.Title, field.Description);

function SelectFieldComponent(_ref) {
  var className = _ref.className,
      label = _ref.label,
      description = _ref.description,
      error = _ref.error,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? String(Math.random()) : _ref$id,
      children = _ref.children,
      context = _ref.context,
      selectProps = _objectWithoutProperties(_ref, ["className", "label", "description", "error", "id", "children", "context"]);

  var status = 'default';

  if (error !== undefined) {
    status = 'error';
  }

  return /*#__PURE__*/createElement(SelectFieldWrapper, {
    className: className,
    htmlFor: id,
    label: label,
    description: description,
    context: context
  }, /*#__PURE__*/createElement(Select, _extends({}, selectProps, {
    status: status,
    id: id
  }), children), error && /*#__PURE__*/createElement(FieldStatus, {
    error: error
  }));
}
/** extends `<Select>`, see there for additional props */


var SelectField = styled(SelectFieldComponent)(_templateObject2$T || (_templateObject2$T = _taggedTemplateLiteral([""])));
SelectField.displayName = 'SelectField';

var _templateObject$1e, _templateObject2$U;
var TextAreaFieldWrapper = styled(Field)(_templateObject$1e || (_templateObject$1e = _taggedTemplateLiteral(["\n  ", " {\n    margin-top: 4px;\n  }\n\n  ", " {\n    margin-top: 10px;\n    flex: 0 0 auto;\n    margin-left: auto;\n  }\n\n  ", ", ", " {\n    margin-bottom: 7px;\n  }\n\n  ", " {\n    width: 100%;\n  }\n"])), field.Message, input.Count, field.Title, field.Description, input.Input);

function TextAreaFieldComponent(_ref) {
  var className = _ref.className,
      label = _ref.label,
      description = _ref.description,
      error = _ref.error,
      context = _ref.context,
      success = _ref.success,
      children = _ref.children,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? String(Math.random()) : _ref$id,
      resetRef = _ref.resetRef,
      inputProps = _objectWithoutProperties(_ref, ["className", "label", "description", "error", "context", "success", "children", "id", "resetRef"]);

  /* this classList is used to add a class depending on the status of the field. this is
  used to easily scroll to the first error field of a form. Other solutions (like refs)
  are way too heavy (and frankly a PITA) for such a simple problem. We would
  have to track an array of refs for each rendered error message, to do so we
  would need a ton of forwardRef in field components ...
  Using className and `querySelector` for this use-case (scrolling to the first error
  message) is innocuous. The component doing the scrolling is also the one responsible
  for displaying those error message in the first place (usualy `<Formik>`), so there is no
  tight coupling.
  Remember, with great power comes great responsibilities. Don't abuse the
  power of `querySelector`, and don't use this as an excuse to indulge in
  old school DOM manipulation */
  var classList = [className];
  var status = 'default';

  if (error && !success) {
    status = 'error';
    classList.push(ERROR_STATUS_CLASS);
  }

  if (success && !error) {
    status = 'success';
    classList.push(SUCCESS_STATUS_CLASS);
  }

  var _React$useState = useState(0),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      length = _React$useState2[0],
      setLength = _React$useState2[1]; // This. This is bad. Don't do that unless you have a very good reason. Here we
  // want to be able to reset the field, and have the `count` update to display 0.
  // Since `length` is in a state, there is no way to update it from outside the
  // component ... unless we pass the update function to a parent via a `ref`.
  // This is a dirty hack, but every other options would be a dirty hack. This
  // solution is the simplest of the dirty hack we could think of.
  // To avoid slipping further, we voluntarly limited the function passed to the ref
  // to have it only set the state to 0, so it can only be used to reset the component.


  useEffect(function () {
    if (resetRef !== undefined) {

      resetRef.current = function () {
        return setLength(0);
      };

      return function () {
        resetRef.current = null;
      };
    }
  }, []);
  var maxLength = inputProps.maxLength;

  function handleChange(event) {
    var onChange = inputProps.onChange;
    onChange && onChange(event);

    if (maxLength !== undefined) {
      setLength(event.target.value.length);
    }
  }

  return /*#__PURE__*/createElement(TextAreaFieldWrapper, {
    className: classList.filter(Boolean).join(' '),
    htmlFor: id,
    label: label,
    description: description,
    context: context
  }, children, /*#__PURE__*/createElement(textarea.TextArea, _extends({}, inputProps, {
    onChange: handleChange,
    status: status,
    id: id
  })), (error || success || maxLength !== undefined) && /*#__PURE__*/createElement(FieldStatus, {
    error: error,
    success: success
  }, maxLength !== undefined && /*#__PURE__*/createElement(input.Count, {
    isError: length > maxLength
  }, length, "/", maxLength)));
}
/** will forward any other props to the underlying `<input>` */


var TextAreaField = styled(TextAreaFieldComponent)(_templateObject2$U || (_templateObject2$U = _taggedTemplateLiteral([""])));
TextAreaField.displayName = 'TextAreaField';

var _templateObject$1f;

function JewelComponent(_ref) {
  var children = _ref.children,
      number = _ref.number;
  return /*#__PURE__*/createElement(jewel.Wrapper, null, children, /*#__PURE__*/createElement(jewel.Bullet, null, number));
}

var Jewel = styled(JewelComponent)(_templateObject$1f || (_templateObject$1f = _taggedTemplateLiteral([""])));
Jewel.displayName = 'Jewel';

var _templateObject$1g;
/** MenuDropdown base */

var MenuDropdown = styled(Dropdown$1)(_templateObject$1g || (_templateObject$1g = _taggedTemplateLiteral(["\n  ", " {\n    padding: 0 0 0 14px;\n  }\n\n  ", " {\n    display: flex;\n    flex-direction: column;\n    left: 0;\n    position: absolute;\n    /* this position absolute can make\n    problem if we use this in bottom of document */\n    top: 26px;\n    min-width: 170px;\n  }\n\n  ", " {\n    position: relative;\n    padding: 14px;\n  }\n\n  ", " {\n    order: 1;\n  }\n\n  ", " {\n    order: 2;\n    margin-left: 15px;\n    margin-right: 0px;\n  }\n"])), select.Button, select.Drawer, dropdown.Dropdown, select.CaretDown, select.Label);
MenuDropdown.displayName = 'MenuDropdown';

var _templateObject$1h, _templateObject2$V, _templateObject3$G, _templateObject4$D;
var Wrapper$8 = fromBottom(modal.Wrapper);
function ModalComponent(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$closable = _ref.closable,
      closable = _ref$closable === void 0 ? false : _ref$closable,
      onClose = _ref.onClose,
      open = _ref.open;
  var modalRef = useRef(null);

  function handleOverlayClick(event) {
    if (modalRef.current === null) {
      return;
    }

    if (closable && !modalRef.current.contains(event.target)) {
      onClose();
    }
  }

  var _useTransition = useTransition(open),
      step = _useTransition.step,
      unmounted = _useTransition.unmounted,
      onTransitionEnd = _useTransition.onTransitionEnd;

  if (unmounted) {
    return null;
  }

  return /*#__PURE__*/createElement(modal.Overlay, {
    className: className,
    onClick: handleOverlayClick
  }, /*#__PURE__*/createElement(Wrapper$8, {
    step: step,
    onTransitionEnd: onTransitionEnd,
    ref: modalRef
  }, closable && /*#__PURE__*/createElement(Close, {
    size: 14,
    onClick: onClose
  }), /*#__PURE__*/createElement(modal.Body, null, children)));
}
var Modal = styled(ModalComponent)(_templateObject$1h || (_templateObject$1h = _taggedTemplateLiteral([""])));
Modal.displayName = 'Modal';
var SmallWrapper$1 = fromBottom(modal.SmallWrapper);
function SmallModalComponent(_ref2) {
  var children = _ref2.children,
      className = _ref2.className,
      closable = _ref2.closable,
      onClose = _ref2.onClose,
      open = _ref2.open,
      title = _ref2.title;

  var _useTransition2 = useTransition(open),
      step = _useTransition2.step,
      unmounted = _useTransition2.unmounted,
      onTransitionEnd = _useTransition2.onTransitionEnd;

  if (unmounted) {
    return null;
  }

  return /*#__PURE__*/createElement(SmallWrapper$1, {
    className: className,
    step: step,
    onTransitionEnd: onTransitionEnd
  }, /*#__PURE__*/createElement(modal.Title, null, title), closable && /*#__PURE__*/createElement(Close, {
    size: 14,
    onClick: onClose
  }), /*#__PURE__*/createElement(modal.Body, null, children));
}
var SmallModal = styled(SmallModalComponent)(_templateObject2$V || (_templateObject2$V = _taggedTemplateLiteral([""])));
SmallModal.displayName = 'SmallModal';
function OverlayModalComponent(_ref3) {
  var children = _ref3.children,
      className = _ref3.className,
      closable = _ref3.closable,
      onClose = _ref3.onClose,
      open = _ref3.open;

  if (!open) {
    return null;
  }

  return /*#__PURE__*/createElement(modal.Overlay, {
    className: className
  }, /*#__PURE__*/createElement(DisableBodyScroll, null), /*#__PURE__*/createElement(modal.Wrapper, null, closable && /*#__PURE__*/createElement(Close, {
    size: 14,
    onClick: onClose
  }), /*#__PURE__*/createElement(modal.Body, null, children)));
}
var DisableBodyScroll = createGlobalStyle(_templateObject3$G || (_templateObject3$G = _taggedTemplateLiteral(["\n  body {\n    overflow: hidden\n  }\n"])));
var OverlayModal = styled(OverlayModalComponent)(_templateObject4$D || (_templateObject4$D = _taggedTemplateLiteral(["\n  ", " {\n    max-width: none;\n    position: absolute;\n    overflow: auto;\n\n    &::before {\n      content: none;\n    }\n\n    ", " {\n      left: auto;\n      top: 20px;\n      right: 20px;\n      color: ", ";\n      width: 22px;\n      height: 22px;\n    }\n  }\n"])), modal.Wrapper, Close, GREY_SHADE_4);
SmallModal.displayName = 'OverlayModal';

var _templateObject$1i;

function MiniChannelCardComponent(_ref) {
  var backgroundColor = _ref.backgroundColor,
      href = _ref.href,
      image = _ref.image,
      title = _ref.title;
  return /*#__PURE__*/createElement(card.channel.MiniWrapper, {
    backgroundColor: backgroundColor,
    href: href,
    image: image
  }, /*#__PURE__*/createElement(card.channel.MiniTitle, null, title));
}

var MiniChannelCard = styled(MiniChannelCardComponent)(_templateObject$1i || (_templateObject$1i = _taggedTemplateLiteral([""])));
MiniChannelCard.displayName = 'MiniChannelCard';

var _templateObject$1j;

function PastilleComponent(_ref) {
  var size = _ref.size,
      noBorder = _ref.noBorder,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["size", "noBorder", "children"]);

  return /*#__PURE__*/createElement(image.Pastille, _extends({
    size: size,
    noBorder: noBorder
  }, rest), children);
}

var Pastille$1 = styled(PastilleComponent)(_templateObject$1j || (_templateObject$1j = _taggedTemplateLiteral([""])));
Pastille$1.displayName = 'Pastille';

var _templateObject$1k;

function TagComponent(_ref) {
  var children = _ref.children,
      color = _ref.color,
      size = _ref.size,
      props = _objectWithoutProperties(_ref, ["children", "color", "size"]);

  return /*#__PURE__*/createElement(tag.Tag, _extends({
    color: color,
    size: size
  }, props), children);
}

var Tag$2 = styled(TagComponent)(_templateObject$1k || (_templateObject$1k = _taggedTemplateLiteral([""])));
Tag$2.displayName = 'Tag';

var _templateObject$1l;

function PriceComponent(_ref) {
  var className = _ref.className,
      reward$1 = _ref.reward,
      conversion = _ref.conversion,
      rates = _ref.rates,
      translations = _ref.translations;
  var precision = Number.isInteger(reward$1.price) ? 0 : 2;
  return /*#__PURE__*/createElement(reward.Price, {
    className: className
  }, /*#__PURE__*/createElement(reward.OriginalPrice, null, /*#__PURE__*/createElement(translations.price, null, /*#__PURE__*/createElement(LocaleMoneyDisplayer, {
    precision: precision,
    rates: rates,
    amount: reward$1.price,
    currency: reward$1.currency,
    targetCurrency: reward$1.currency,
    localeFormat: conversion.locale
  }))), conversion.currency !== undefined && /*#__PURE__*/createElement(reward.Conversion, null, /*#__PURE__*/createElement(Currency, {
    size: 15,
    currency: conversion.currency
  }), "~", /*#__PURE__*/createElement(LocaleMoneyDisplayer, {
    precision: precision,
    rates: rates,
    amount: reward$1.price,
    currency: reward$1.currency,
    targetCurrency: conversion.currency,
    localeFormat: conversion.locale
  })));
}

var Price$1 = styled(PriceComponent)(_templateObject$1l || (_templateObject$1l = _taggedTemplateLiteral([""])));

var Type$1;

(function (Type) {
  Type[Type["SELECTED"] = 0] = "SELECTED";
  Type[Type["UNSELECTED"] = 1] = "UNSELECTED";
  Type[Type["PROJECT"] = 2] = "PROJECT";
})(Type$1 || (Type$1 = {}));

function state(reward, variants, mode, selected, isProjectFinished) {
  var _reward$stock, _reward$stock2;

  var hasVariants = variants.length > 0;
  var rewardStockTotal = hasVariants ? variants.reduce(function (stock, variant) {
    var _variant$stock;

    return ((_variant$stock = variant.stock) === null || _variant$stock === void 0 ? void 0 : _variant$stock.total) == null || stock == null ? null : variant.stock.total + stock;
  }, 0) : (_reward$stock = reward.stock) === null || _reward$stock === void 0 ? void 0 : _reward$stock.total;
  var rewardStockTaken = hasVariants ? variants.reduce(function (stock, variant) {
    var _variant$stock2;

    return ((_variant$stock2 = variant.stock) === null || _variant$stock2 === void 0 ? void 0 : _variant$stock2.total) == null || stock == null ? null : variant.stock.taken + stock;
  }, 0) : (_reward$stock2 = reward.stock) === null || _reward$stock2 === void 0 ? void 0 : _reward$stock2.taken;
  var rewardStockRemaining = Number(rewardStockTotal) - Number(rewardStockTaken);
  var allVariantsTaken = variants && variants.every(function (variant) {
    return variant.stock && variant.stock.taken >= Number(variant.stock.total);
  });
  return {
    isPreview: mode === 'preview',
    isDisabled: isProjectFinished || rewardStockTotal !== null && (hasVariants ? allVariantsTaken : Number(rewardStockTaken) >= Number(rewardStockTotal)),
    isSoonSoldOut: rewardStockTotal !== null ? rewardStockRemaining <= 5 && rewardStockTotal !== rewardStockRemaining : false,
    hasVariants: hasVariants,
    isProjectFinished: isProjectFinished,
    isDropdown: variants.length > 5 && variants.every(function (variant) {
      return typeof variant.description === 'string';
    }),
    type: mode === 'project' ? Type$1.PROJECT : selected ? Type$1.SELECTED : Type$1.UNSELECTED
  };
}

function state$1(variant, mode, selected, isProjectFinished) {
  return {
    isPreview: mode === 'preview',
    isDisabled: isDisabled(),
    isSoonSoldOut: isSoonSoldOut(),
    hasVariants: false,
    isProjectFinished: isProjectFinished,
    isDropdown: false,
    type: mode === 'project' ? Type$1.PROJECT : selected ? Type$1.SELECTED : Type$1.UNSELECTED
  };

  function isDisabled() {
    var stock = variant.stock;

    if (stock !== undefined && stock.total !== null && stock.total !== undefined) {
      return stock.taken >= stock.total;
    }

    return false;
  }

  function isSoonSoldOut() {
    var stock = variant.stock;

    if (stock !== undefined && stock.total !== null && stock.total !== undefined) {
      var remaining = stock.total - stock.taken;
      return remaining <= 5 && stock.total !== remaining;
    }

    return false;
  }
}

function isSoonSoldOut(_ref) {
  var isPreview = _ref.isPreview,
      isDisabled = _ref.isDisabled,
      isSoonSoldOut = _ref.isSoonSoldOut;
  return !isPreview && !isDisabled && isSoonSoldOut;
}
function isProject(_ref2) {
  var isPreview = _ref2.isPreview,
      isDisabled = _ref2.isDisabled,
      type = _ref2.type;
  return !isPreview && !isDisabled && type === Type$1.PROJECT;
}
function isSelected(_ref3) {
  var isPreview = _ref3.isPreview,
      isDisabled = _ref3.isDisabled,
      type = _ref3.type;
  return !isPreview && !isDisabled && type === Type$1.SELECTED;
}
function isDisabled(_ref5) {
  var isPreview = _ref5.isPreview,
      isDisabled = _ref5.isDisabled,
      isProjectFinished = _ref5.isProjectFinished;
  return isProjectFinished || !isPreview && isDisabled;
}
function isPreview(_ref6) {
  var isPreview = _ref6.isPreview;
  return isPreview;
}
function hasVariants(_ref7) {
  var hasVariants = _ref7.hasVariants;
  return hasVariants;
}
function isProjectFinished(_ref8) {
  var isProjectFinished = _ref8.isProjectFinished;
  return isProjectFinished;
}
function isDropdown(_ref9) {
  var isDropdown = _ref9.isDropdown;
  return isDropdown;
}

var _templateObject$1m;

function ActionComponent(_ref) {
  var className = _ref.className,
      state = _ref.state,
      short = _ref.short,
      translations = _ref.translations;

  if (isProject(state)) {
    return /*#__PURE__*/createElement(reward.Action, {
      className: className
    }, /*#__PURE__*/createElement(Plus, {
      size: 12
    }), !short && /*#__PURE__*/createElement(reward.ActiveLabel, null, translations.choose));
  }

  if (isSelected(state)) {
    return /*#__PURE__*/createElement(reward.Action, {
      as: "span",
      className: className
    }, short && /*#__PURE__*/createElement(Minus, {
      size: 12
    }), !short && /*#__PURE__*/createElement(reward.InactiveLabel, null, translations.remove));
  }

  return /*#__PURE__*/createElement(reward.Action, {
    as: "span",
    className: className
  }, /*#__PURE__*/createElement(Plus, {
    size: 12
  }), !short && /*#__PURE__*/createElement(reward.ActiveLabel, null, translations.add));
}

var Action$1 = styled(ActionComponent)(_templateObject$1m || (_templateObject$1m = _taggedTemplateLiteral([""])));

var _templateObject$1n;

function PictureComponent(_ref) {
  var className = _ref.className,
      loading = _ref.loading,
      withNativeLazyLoad = _ref.withNativeLazyLoad,
      picture = _ref.picture,
      format = _ref.format;

  if (loading === 'lazy') {
    return /*#__PURE__*/createElement(LazyImage, {
      nativeLazyLoad: withNativeLazyLoad
    }, /*#__PURE__*/createElement(reward.Picture, {
      format: format,
      src: picture.src,
      srcSet: picture.srcSet,
      className: className
    }));
  }

  return /*#__PURE__*/createElement(reward.Picture, {
    format: format,
    src: picture.src,
    srcSet: picture.srcSet,
    className: className
  });
}

var Picture$2 = styled(PictureComponent)(_templateObject$1n || (_templateObject$1n = _taggedTemplateLiteral([""])));

var _templateObject$1o;

function ContentComponent(_ref) {
  var className = _ref.className,
      loading = _ref.loading,
      withNativeLazyLoad = _ref.withNativeLazyLoad,
      reward$1 = _ref.reward,
      format = _ref.format;
  return /*#__PURE__*/createElement("div", {
    className: className
  }, reward$1.picture && /*#__PURE__*/createElement(Picture$2, {
    loading: loading,
    withNativeLazyLoad: withNativeLazyLoad,
    picture: reward$1.picture,
    format: format
  }), reward$1.title && /*#__PURE__*/createElement(reward.Title, null, reward$1.title), reward$1.description && /*#__PURE__*/createElement(reward.Description, {
    as: "div",
    dangerouslySetInnerHTML: reward$1.description
  }));
}

var Content = styled(ContentComponent)(_templateObject$1o || (_templateObject$1o = _taggedTemplateLiteral(["\n  ", " {\n    margin: 20px 0;\n  }\n\n  ", " {\n    margin: 20px 0;\n    display: block;\n  }\n\n  ", " {\n    margin: 20px 0;\n  }\n"])), reward.Title, Picture$2, reward.Description);

function Status$1(_ref) {
  var state = _ref.state,
      translations = _ref.translations;

  if (!isProjectFinished(state)) {
    if (isSoonSoldOut(state)) {
      return /*#__PURE__*/createElement(reward.SoonSoldOut, {
        as: "span"
      }, translations.soonSoldOut);
    } else if (isDisabled(state)) {
      return /*#__PURE__*/createElement(reward.SoldOut, {
        as: "span"
      }, translations.soldOut);
    }
  }

  return null;
}

var _templateObject$1p;

function AvailabilityComponent(_ref) {
  var className = _ref.className,
      stock = _ref.stock,
      state = _ref.state,
      translations = _ref.translations;
  return /*#__PURE__*/createElement("div", {
    className: className
  }, /*#__PURE__*/createElement(reward.Quantity, {
    as: "span"
  }, (hasVariants(state) || isDisabled(state)) && stock !== null && stock !== void 0 && stock.taken ? /*#__PURE__*/createElement(translations.supporters, {
    taken: stock.taken
  }) : stock !== null && stock !== void 0 && stock.total && stock !== null && stock !== void 0 && stock.taken ? /*#__PURE__*/createElement(translations.availability, {
    taken: stock.taken,
    total: stock.total
  }) : stock !== null && stock !== void 0 && stock.total && stock !== null && stock !== void 0 && stock.available ? /*#__PURE__*/createElement(translations.limitedAvailability, {
    available: stock.available
  }) : stock !== null && stock !== void 0 && stock.taken ? /*#__PURE__*/createElement(translations.supporters, {
    taken: stock.taken
  }) : null), /*#__PURE__*/createElement(Status$1, {
    state: state,
    translations: translations
  }));
}

var Availability = styled(AvailabilityComponent)(_templateObject$1p || (_templateObject$1p = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: end;\n"])));

var cardContext = /*#__PURE__*/createContext(undefined);
function useCardContext() {
  var context = useContext(cardContext);

  if (context === undefined) {
    throw Error('card context is not defined');
  }

  return context;
}
function CardContextProvider(_ref) {
  var value = _ref.value,
      children = _ref.children;
  return /*#__PURE__*/createElement(cardContext.Provider, {
    value: value
  }, children);
}

var _templateObject$1q, _templateObject2$W, _templateObject3$H, _templateObject4$E, _templateObject5$v, _templateObject6$p, _templateObject7$m, _templateObject8$m, _templateObject9$k, _templateObject10$j, _templateObject11$e, _templateObject12$b, _templateObject13$8;

function RewardCardComponent(_ref) {
  var className = _ref.className,
      mode = _ref.mode,
      _ref$selected = _ref.selected,
      selected = _ref$selected === void 0 ? false : _ref$selected,
      reward = _ref.reward,
      conversion = _ref.conversion,
      rates = _ref.rates,
      translations = _ref.translations,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? 'eager' : _ref$loading,
      _ref$withNativeLazyLo = _ref.withNativeLazyLoad,
      withNativeLazyLoad = _ref$withNativeLazyLo === void 0 ? true : _ref$withNativeLazyLo,
      isProjectFinished$1 = _ref.isProjectFinished,
      children = _ref.children,
      format = _ref.format,
      handlers = _ref.handlers,
      Tag = _ref.tag;
  var variants = Children.toArray(children).filter(function (node) {
    return _typeof(node) === 'object' && node !== null && 'props' in node && 'variant' in node.props;
  }).map(function (node) {
    return node.props.variant;
  });
  var state$1 = state(reward, variants, mode, selected, isProjectFinished$1);
  var hasAction = !isDisabled(state$1) && !hasVariants(state$1) && mode !== 'preview';
  return /*#__PURE__*/createElement(Card, {
    state: state$1,
    className: className,
    format: format,
    onClick: onClick
  }, Tag && /*#__PURE__*/createElement(Tag, null, translations.tag), /*#__PURE__*/createElement(Header, {
    disabled: isDisabled(state$1)
  }, /*#__PURE__*/createElement(Price$1, {
    reward: reward,
    conversion: conversion,
    rates: rates,
    translations: translations
  }), hasAction && /*#__PURE__*/createElement(Action$1, {
    state: state$1,
    short: false,
    translations: translations
  })), /*#__PURE__*/createElement(Content, {
    disabled: isDisabled(state$1),
    reward: reward,
    loading: loading,
    withNativeLazyLoad: withNativeLazyLoad,
    format: format
  }), /*#__PURE__*/createElement(CardContextProvider, {
    value: {
      mode: mode,
      isProjectFinished: isProjectFinished$1,
      translations: translations
    }
  }, /*#__PURE__*/createElement(Select, {
    placeholder: translations.choose,
    selected: [],
    height: 423,
    filterable: Array.isArray(children) ? children.length > 10 : false
  }, children)), /*#__PURE__*/createElement(Footer, {
    disabled: isDisabled(state$1)
  }, reward.deliveryDate && /*#__PURE__*/createElement(Delivery, null, /*#__PURE__*/createElement(Calendar, {
    size: 21
  }), /*#__PURE__*/createElement(DeliveryDate, {
    as: "time"
  }, reward.deliveryDate)), /*#__PURE__*/createElement(Availability, {
    stock: reward.stock,
    state: state$1,
    translations: translations
  })));

  function onClick(event) {
    var target = event.target;
    var currentTarget = event.currentTarget;
    var parentLink = target.closest('a[href]');

    if (parentLink !== null && currentTarget.contains(parentLink)) {
      return;
    }

    if (isPreview(state$1) || hasVariants(state$1)) {
      return;
    }

    if (isProjectFinished(state$1) || isProject(state$1)) {
      handlers.onClick && handlers.onClick();
    } else if (isSelected(state$1)) {
      handlers.onRemove && handlers.onRemove();
    } else if (!isSelected(state$1) && !isDisabled(state$1)) {
      handlers.onAdd && handlers.onAdd();
    }
  }
}

var DeliveryDate = styled(heading.XXXXXS)(_templateObject$1q || (_templateObject$1q = _taggedTemplateLiteral(["\n  color: ", ";\n  text-transform: uppercase;\n"])), GREY_SHADE_3);
var Delivery = styled.span(_templateObject2$W || (_templateObject2$W = _taggedTemplateLiteral(["\n  ", " {\n    color: ", ";\n  }\n\n  ", " {\n    margin-left: 9px;\n  }\n"])), Calendar, GREY_SHADE_4, DeliveryDate);
var Footer = styled.footer(_templateObject3$H || (_templateObject3$H = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: baseline;\n  justify-content: flex-start;\n  margin: 20px 0 0;\n\n  ", " {\n    margin-right: auto;\n  }\n  ", " {\n    margin-left: auto;\n  }\n"])), Delivery, Availability);
var Header = styled.header(_templateObject4$E || (_templateObject4$E = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  margin: 0 0 20px;\n\n  ", " {\n    position: relative;\n    top: 1px;\n  }\n"])), Action$1);
var Card = styled.section(_templateObject5$v || (_templateObject5$v = _taggedTemplateLiteral(["\n  position: relative;\n  max-width: 100%;\n  word-wrap: break-word;\n  min-width: 300px;\n  border: 1px solid ", ";\n  box-sizing: border-box;\n  border-radius: 2px;\n\n  /* MARGIN/PADDING HANDLING */\n\n  /* margin needs to be set on element, instead of padding on the container, to allow\n  margin override for <Select> if it is displayed as a list */\n  padding: 5% 0;\n  ", ", ", ", ", ", ", " {\n    /* We want those elements to be 90% of container width. This means margins\n    of 5% of container width so those margins are (5/90)*100 % of element\n    width */\n    margin-left: ", "%;\n    margin-right: ", "%;\n  }\n\n ", " {\n    padding: 0px;\n    border: 0px;\n  }\n\n  ", "\n\n\n  /* STATE HANDLING */\n\n  ", "\n\n  /* RESET SELECT */\n\n  ", ", ", " {\n    display: none;\n  }\n  ", " {\n    color: ", ";\n  }\n  ", " {\n    position: relative;\n    background-color: ", ";\n  }\n\n  /* SELECT AS LIST */\n\n  ", "\n\n  /* TAG POSITION */\n\n  ", " {\n    position: absolute;\n    left: 5%;\n    top: -10px;\n    font-size: 10px;\n    padding: 0 6px;\n    border-radius: 1px;\n    font-weight: 900;\n\n    ", "\n  }\n"])), GREY_SHADE_5, Footer, Content, Header, Select, 5 / 90 * 100, 5 / 90 * 100, select.SearchBox, function (_ref2) {
  var format = _ref2.format;

  if (format === 'wide') {
    return css(_templateObject6$p || (_templateObject6$p = _taggedTemplateLiteral(["\n        @media screen and ", " {\n          padding: 3% 0;\n          ", ", ", ", ", ", ", " {\n            /* Same here but with 3% instead of 5% of container */\n            margin-left: ", "%;\n            margin-right: ", "%;\n          }\n        }\n      "])), TABLET, Footer, Content, Header, Select, 3 / 90 * 100, 3 / 90 * 100);
  }
}, function (_ref3) {
  var state = _ref3.state;

  if (isDisabled(state)) {
    return css(_templateObject7$m || (_templateObject7$m = _taggedTemplateLiteral(["\n        border-color: ", ";\n\n        /* opacity set on elements instead of container to have fully opaque hidden/featured tag */\n        ", ", ", ", ", ", ", " {\n          opacity: 0.5;\n        }\n        ", ", ", ", ", " {\n          color: ", ";\n        }\n      "])), GREY_SHADE_6, Footer, Header, Content, select.Button, reward.Title, reward.Description, Price$1, GREY_SHADE_3);
  } else if (isSelected(state) && !hasVariants(state)) {
    return css(_templateObject8$m || (_templateObject8$m = _taggedTemplateLiteral(["\n        cursor: pointer;\n        border-width: 2px;\n        border-color: ", ";\n      "])), hexToRgb(PRIMARY_BLUE, 0.5));
  } else if (!hasVariants(state)) {
    return css(_templateObject9$k || (_templateObject9$k = _taggedTemplateLiteral(["\n        cursor: pointer;\n\n        &:hover {\n          border-color: ", ";\n\n          ", " ", " {\n            color: ", ";\n          }\n        }\n      "])), hexToRgb(PRIMARY_BLUE, 0.5), Action$1, Icon, PRIMARY_BLUE);
  }
}, option.MultiSelectedIcon, option.MonoSelectedIcon, option.Label, PRIMARY_BLACK, option.Wrapper, PRIMARY_WHITE, function (_ref4) {
  var state = _ref4.state;

  if (!isDropdown(state)) {
    return css(_templateObject10$j || (_templateObject10$j = _taggedTemplateLiteral(["\n        ", " {\n          display: none;\n        }\n        ", " {\n          box-shadow: none;\n        }\n        ", " {\n          visibility: visible;\n          height: auto;\n        }\n        ", " {\n          visibility: visible;\n          height: auto;\n          overflow: visible;\n          background-color: ", ";\n        }\n        @media screen and not ", " {\n          ", " {\n            margin: 0;\n          }\n        }\n      "])), select.Button, dropdown.Dropdown, select.Drawer, option.Wrapper, PRIMARY_WHITE, MOBILE_L, Select);
  } else {
    return css(_templateObject11$e || (_templateObject11$e = _taggedTemplateLiteral(["\n        ", " {\n          position: relative;\n          z-index: 10;\n        }\n      "])), dropdown.Dropdown);
  }
}, Tag$2, function (_ref5) {
  var format = _ref5.format;

  if (format === 'wide') {
    return css(_templateObject12$b || (_templateObject12$b = _taggedTemplateLiteral(["\n          @media screen and ", " {\n            left: 3%;\n          }\n        "])), TABLET);
  }
});
var RewardCard = styled(RewardCardComponent)(_templateObject13$8 || (_templateObject13$8 = _taggedTemplateLiteral([""])));
RewardCard.displayName = 'RewardCard';

var _templateObject$1r;

function QuantityComponent(_ref) {
  var className = _ref.className,
      stock = _ref.stock,
      translations = _ref.translations;
  return /*#__PURE__*/createElement(reward.Quantity, {
    className: className
  }, stock !== null && stock !== void 0 && stock.total ? /*#__PURE__*/createElement(Fragment, null, stock.taken, " / ", stock.total) : stock !== null && stock !== void 0 && stock.taken ? /*#__PURE__*/createElement(translations.supporters, {
    taken: stock.taken
  }) : null);
}

var Quantity$1 = styled(QuantityComponent)(_templateObject$1r || (_templateObject$1r = _taggedTemplateLiteral([""])));

var _templateObject$1s, _templateObject2$X, _templateObject3$I, _templateObject4$F, _templateObject5$w, _templateObject6$q, _templateObject7$n, _templateObject8$n, _templateObject9$l;
function Variant(_ref) {
  var variant = _ref.variant,
      handlers = _ref.handlers,
      _ref$selected = _ref.selected,
      selected = _ref$selected === void 0 ? false : _ref$selected;
  var context = useCardContext();
  var state = state$1(variant, context.mode, selected, context.isProjectFinished);
  return /*#__PURE__*/createElement(StyledOption, {
    state: state,
    label: typeof variant.description === 'string' ? variant.description : variant.description.__html,
    value: variant.id,
    onToggle: onClick
  }, function (_ref2) {
    var isFiltered = _ref2.isFiltered;
    return /*#__PURE__*/createElement(StyledOptionContainer, {
      isFiltered: isFiltered
    }, /*#__PURE__*/createElement(Action$1, {
      state: state,
      translations: context.translations,
      short: true
    }), /*#__PURE__*/createElement(Label$4, null, /*#__PURE__*/createElement(Content$1, null, /*#__PURE__*/createElement(Status$1, {
      state: state,
      translations: context.translations
    }), typeof variant.description === 'string' ? /*#__PURE__*/createElement(Description$3, null, variant.description) : /*#__PURE__*/createElement(HTMLDescription, {
      dangerouslySetInnerHTML: variant.description
    })), /*#__PURE__*/createElement(Quantity$1, {
      stock: variant.stock,
      translations: context.translations
    })));
  });

  function onClick() {
    if (state.isDisabled || isPreview(state)) {
      return;
    }

    if (isProjectFinished(state) || isProject(state)) {
      handlers.onClick && handlers.onClick();
    } else {
      if (!isSelected(state)) {
        handlers.onAdd && handlers.onAdd();
      } else {
        handlers.onRemove && handlers.onRemove();
      }
    }
  }
}
var Description$3 = styled.div(_templateObject$1s || (_templateObject$1s = _taggedTemplateLiteral(["\n  margin: 0 10px 0 0;\n  font-weight: 500;\n"])));
var HTMLDescription = styled(Description$3)(_templateObject2$X || (_templateObject2$X = _taggedTemplateLiteral(["\n  margin: 0 10px 0 0;\n  font-weight: 300;\n\n  & p {\n    margin: 0;\n  }\n\n  & strong {\n    font-weight: 500;\n  }\n"])));
var Label$4 = styled.div(_templateObject3$I || (_templateObject3$I = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: baseline;\n\n  ", " {\n    flex: 0 0 auto;\n    margin-left: auto;\n  }\n"])), Quantity$1);
var Content$1 = styled.div(_templateObject4$F || (_templateObject4$F = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n\n  ", ", ", " {\n    margin: 0 0 2px;\n  }\n"])), reward.SoonSoldOut, reward.SoldOut);
var StyledOptionContainer = styled.span(_templateObject5$w || (_templateObject5$w = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: ", ";\n  width: 100%;\n"])), function (_ref3) {
  var isFiltered = _ref3.isFiltered;
  return isFiltered ? '0' : '4% 4% 4% 1.5%';
});
var StyledOption = styled(Option)(_templateObject6$q || (_templateObject6$q = _taggedTemplateLiteral(["\n  border: 1px solid ", ";\n  padding: 0px;\n\n  &:not(:last-child) {\n    margin-bottom: -2px;\n  }\n\n  ", "\n\n  ", " {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    padding: 0;\n  }\n\n  ", " {\n    flex: 1;\n  }\n"])), GREY_SHADE_5, function (_ref4) {
  var state = _ref4.state;

  if (isDisabled(state)) {
    return css(_templateObject7$n || (_templateObject7$n = _taggedTemplateLiteral(["\n        border-color: ", ";\n\n        ", ", ", " {\n          opacity: 0.5;\n        }\n\n        ", " {\n          color: ", ";\n        }\n        ", " {\n          visibility: hidden;\n        }\n      "])), GREY_SHADE_6, Action$1, Label$4, Description$3, GREY_SHADE_3, Action$1);
  } else {
    return css(_templateObject8$n || (_templateObject8$n = _taggedTemplateLiteral(["\n        cursor: pointer;\n        ", "\n\n        &:hover {\n          border-color: ", ";\n          z-index: 2;\n\n          ", " ", " {\n            color: ", ";\n          }\n        }\n      "])), function () {
      if (isSelected(state)) {
        return css(_templateObject9$l || (_templateObject9$l = _taggedTemplateLiteral(["\n              z-index: 1;\n              border-color: ", ";\n            "])), PRIMARY_BLUE);
      }
    }, hexToRgb(PRIMARY_BLUE, 0.5), Action$1, Icon, PRIMARY_BLUE);
  }
}, option.Label, Label$4);

var _templateObject$1t;

function HiddenComponent(_ref) {
  var className = _ref.className,
      children = _ref.children;
  return /*#__PURE__*/createElement(Tag$2, {
    color: "green",
    size: "small",
    className: className
  }, children);
}

var Hidden = styled(HiddenComponent)(_templateObject$1t || (_templateObject$1t = _taggedTemplateLiteral([""])));

var _templateObject$1u;

function FeaturedComponent(_ref) {
  var className = _ref.className,
      children = _ref.children;
  return /*#__PURE__*/createElement(Tag$2, {
    color: "light-blue",
    size: "small",
    className: className
  }, /*#__PURE__*/createElement(Star$1, {
    size: 12
  }), " ", children);
}

var Featured = styled(FeaturedComponent)(_templateObject$1u || (_templateObject$1u = _taggedTemplateLiteral(["\n  ", " {\n    vertical-align: sub;\n    margin-right: 3px;\n  }\n"])), Star$1);



var _tag$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Hidden: Hidden,
  Featured: Featured
});

var tag$1 = _tag$1;

var _templateObject$1v;

function RoundButtonComponent(_ref) {
  var className = _ref.className,
      _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active,
      contents = _ref.contents,
      buttonProps = _objectWithoutProperties(_ref, ["className", "active", "contents"]);

  var _React$useState = useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      hover = _React$useState2[0],
      setHover = _React$useState2[1];

  var _React$useState3 = useState(active),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      realActive = _React$useState4[0],
      setRealActive = _React$useState4[1];

  var _React$useState5 = useState(hover),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      realHover = _React$useState6[0],
      setRealHover = _React$useState6[1];

  useEffect(function () {
    setRealActive(active);
    setRealHover(hover);
  }, [hover]);
  useEffect(function () {
    setRealActive(active);
    setRealHover(false);
  }, [active]);
  return /*#__PURE__*/createElement(button.RoundButton, _extends({
    className: className,
    active: realActive,
    hover: realHover,
    onMouseEnter: function onMouseEnter() {
      return setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHover(false);
    }
  }, buttonProps), getContent());

  function getContent() {
    return realHover && realActive ? contents.activeHover || contents.active : !realHover && realActive ? contents.active : realHover && !realActive ? contents.inactiveHover || contents.inactive : !realHover && !realActive ? contents.inactive : undefined;
  }
}

var RoundButton$1 = styled(RoundButtonComponent)(_templateObject$1v || (_templateObject$1v = _taggedTemplateLiteral([""])));
RoundButton$1.displayName = 'RoundButton';

var _templateObject$1w;

function RoundTagComponent(_ref) {
  var className = _ref.className,
      children = _ref.children,
      tagProps = _objectWithoutProperties(_ref, ["className", "children"]);

  return /*#__PURE__*/createElement(tag.RoundTag, _extends({
    className: className
  }, tagProps), children);
}

var RoundTag$1 = styled(RoundTagComponent)(_templateObject$1w || (_templateObject$1w = _taggedTemplateLiteral([""])));
RoundTag$1.displayName = 'RoundTag';

var _templateObject$1x, _templateObject2$Y;
var icons = {
  facebook: Facebook,
  twitter: Twitter,
  messenger: Messenger,
  linkedin: LinkedIn,
  instagram: Instagram,
  whatsapp: WhatsApp
};
var bgColors = {
  facebook: FACEBOOK,
  twitter: TWITTER,
  messenger: MESSENGER,
  linkedin: LINKEDIN,
  instagram: INSTAGRAM,
  whatsapp: WHATSAPP
};
function SocialButtonComponent(_ref) {
  var platform = _ref.platform,
      children = _ref.children,
      buttonProps = _objectWithoutProperties(_ref, ["platform", "children"]);

  var PlatformIcon = icons[platform];
  return /*#__PURE__*/createElement(button.CallToAction, _extends({}, buttonProps, {
    onlyGlyph: !children
  }), /*#__PURE__*/createElement(PlatformIcon, null), children);
}
var SocialButton = styled(SocialButtonComponent)(_templateObject$1x || (_templateObject$1x = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref2) {
  var platform = _ref2.platform;

  if (platform in bgColors) {
    return css(_templateObject2$Y || (_templateObject2$Y = _taggedTemplateLiteral(["\n        background-color: ", ";\n        &:hover {\n          background-color: ", ";\n        }\n      "])), bgColors[platform], hexToRgb(bgColors[platform], 0.85));
  }
});
SocialButton.displayName = 'SocialButton';

var _templateObject$1y;

function SkewedBannerComponent(_ref) {
  var children = _ref.children,
      _ref$skewedBorder = _ref.skewedBorder,
      skewedBorder = _ref$skewedBorder === void 0 ? 'bottom' : _ref$skewedBorder,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["children", "skewedBorder", "className"]);

  return /*#__PURE__*/createElement(container.SkewedContainer, _extends({
    className: className,
    skewedBorder: skewedBorder
  }, props), /*#__PURE__*/createElement(container.SkewedContent, null, children));
}

var SkewedBanner = styled(SkewedBannerComponent)(_templateObject$1y || (_templateObject$1y = _taggedTemplateLiteral([""])));
SkewedBanner.displayName = 'SkewedBanner';
SkewedBanner.defaultProps = {
  skewedBorder: 'bottom'
};

var _templateObject$1z, _templateObject2$Z;

function TabMenuComponent(_ref) {
  var className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "children"]);

  var scrollerRef = useRef(null);

  var _React$useState = useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isScrollable = _React$useState2[0],
      setIsScrollable = _React$useState2[1];

  useScrollableListener(scrollerRef, function (scrollable) {
    setIsScrollable(scrollable.x);
  });

  var _React$useState3 = useState(60),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      shadowWidth = _React$useState4[0],
      setShadowWidth = _React$useState4[1];

  useScrollListener(scrollerRef, function (_ref2) {
    var x = _ref2.x,
        dx = _ref2.dx;

    if (scrollerRef.current === null) {
      return;
    }

    var scrollableWidth = scrollerRef.current.scrollWidth - scrollerRef.current.clientWidth;

    if (x > scrollableWidth - 60) {
      setShadowWidth(scrollableWidth - x);
    } else {
      setShadowWidth(60);
    }
  });
  return /*#__PURE__*/createElement(tab.List, _extends({
    className: className,
    shadowWidth: shadowWidth,
    scrollable: isScrollable,
    ref: scrollerRef
  }, props), children);
}

function TabComponent(_ref3) {
  var className = _ref3.className,
      children = _ref3.children,
      _ref3$active = _ref3.active,
      active = _ref3$active === void 0 ? false : _ref3$active,
      _ref3$disabled = _ref3.disabled,
      disabled = _ref3$disabled === void 0 ? false : _ref3$disabled,
      props = _objectWithoutProperties(_ref3, ["className", "children", "active", "disabled"]);

  return /*#__PURE__*/createElement(tab.Item, _extends({
    active: active,
    className: className,
    disabled: disabled
  }, props), children);
}

var TabMenu = styled(TabMenuComponent)(_templateObject$1z || (_templateObject$1z = _taggedTemplateLiteral([""])));
TabMenu.displayName = 'TabMenu';
var Tab = styled(TabComponent)(_templateObject2$Z || (_templateObject2$Z = _taggedTemplateLiteral([""])));
Tab.displayName = 'Tab';

var _templateObject$1A;

function TooltipComponent(_ref) {
  var children = _ref.children,
      _ref$fitToContent = _ref.fitToContent,
      fitToContent = _ref$fitToContent === void 0 ? false : _ref$fitToContent,
      _ref$open = _ref.open,
      open = _ref$open === void 0 ? false : _ref$open,
      position = _ref.position,
      props = _objectWithoutProperties(_ref, ["children", "fitToContent", "open", "position"]);

  return /*#__PURE__*/createElement(tooltip.Tooltip, _extends({}, props, {
    fitToContent: fitToContent,
    open: open,
    position: position
  }), children);
}

var Tooltip$1 = styled(TooltipComponent)(_templateObject$1A || (_templateObject$1A = _taggedTemplateLiteral([""])));
Tooltip$1.displayName = 'Tooltip';

var _templateObject$1B;

function UserCardComponent(_ref) {
  var className = _ref.className,
      href = _ref.href,
      src = _ref.src,
      username = _ref.username,
      anchorProps = _objectWithoutProperties(_ref, ["className", "href", "src", "username"]);

  return /*#__PURE__*/createElement(userCard.CardWrapper, _extends({
    href: href,
    className: className
  }, anchorProps), /*#__PURE__*/createElement(image.Avatar, {
    type: "extra-large",
    src: src
  }), /*#__PURE__*/createElement(userCard.CardName, null, username));
}

var UserCard = styled(UserCardComponent)(_templateObject$1B || (_templateObject$1B = _taggedTemplateLiteral([""])));
UserCard.displayName = 'UserCard';
UserCard.defaultProps = {};

var _templateObject$1C;

function UserLabelComponent(_ref) {
  var avatar = _ref.avatar,
      className = _ref.className,
      href = _ref.href,
      name = _ref.name,
      size = _ref.size,
      tag = _ref.tag,
      rest = _objectWithoutProperties(_ref, ["avatar", "className", "href", "name", "size", "tag"]);

  return /*#__PURE__*/createElement(userLabel.UserLabel, _extends({
    href: href,
    className: className
  }, rest), /*#__PURE__*/createElement(image.Avatar, {
    src: avatar,
    type: size
  }), /*#__PURE__*/createElement(heading.XXXS, null, name, " ", tag && /*#__PURE__*/createElement(Tag$2, {
    color: tag.color
  }, tag.label)));
}

var UserLabel$1 = styled(UserLabelComponent)(_templateObject$1C || (_templateObject$1C = _taggedTemplateLiteral([""])));
UserLabel$1.displayName = 'UserLabel';

/**
 * Copyright 2016 Google Inc. All Rights Reserved.
 *
 * Licensed under the W3C SOFTWARE AND DOCUMENT NOTICE AND LICENSE.
 *
 *  https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 *
 */
(function () {

  if (typeof window !== 'object') {
    return;
  } // Exit early if all IntersectionObserver and IntersectionObserverEntry
  // features are natively supported.


  if ('IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype) {
    // Minimal polyfill for Edge 15's lack of `isIntersecting`
    // See: https://github.com/w3c/IntersectionObserver/issues/211
    if (!('isIntersecting' in window.IntersectionObserverEntry.prototype)) {
      Object.defineProperty(window.IntersectionObserverEntry.prototype, 'isIntersecting', {
        get: function () {
          return this.intersectionRatio > 0;
        }
      });
    }

    return;
  }
  /**
   * A local reference to the document.
   */


  var document = window.document;
  /**
   * Creates the global IntersectionObserverEntry constructor.
   * https://w3c.github.io/IntersectionObserver/#intersection-observer-entry
   * @param {Object} entry A dictionary of instance properties.
   * @constructor
   */

  function IntersectionObserverEntry(entry) {
    this.time = entry.time;
    this.target = entry.target;
    this.rootBounds = entry.rootBounds;
    this.boundingClientRect = entry.boundingClientRect;
    this.intersectionRect = entry.intersectionRect || getEmptyRect();
    this.isIntersecting = !!entry.intersectionRect; // Calculates the intersection ratio.

    var targetRect = this.boundingClientRect;
    var targetArea = targetRect.width * targetRect.height;
    var intersectionRect = this.intersectionRect;
    var intersectionArea = intersectionRect.width * intersectionRect.height; // Sets intersection ratio.

    if (targetArea) {
      // Round the intersection ratio to avoid floating point math issues:
      // https://github.com/w3c/IntersectionObserver/issues/324
      this.intersectionRatio = Number((intersectionArea / targetArea).toFixed(4));
    } else {
      // If area is zero and is intersecting, sets to 1, otherwise to 0
      this.intersectionRatio = this.isIntersecting ? 1 : 0;
    }
  }
  /**
   * Creates the global IntersectionObserver constructor.
   * https://w3c.github.io/IntersectionObserver/#intersection-observer-interface
   * @param {Function} callback The function to be invoked after intersection
   *     changes have queued. The function is not invoked if the queue has
   *     been emptied by calling the `takeRecords` method.
   * @param {Object=} opt_options Optional configuration options.
   * @constructor
   */


  function IntersectionObserver(callback, opt_options) {
    var options = opt_options || {};

    if (typeof callback != 'function') {
      throw new Error('callback must be a function');
    }

    if (options.root && options.root.nodeType != 1) {
      throw new Error('root must be an Element');
    } // Binds and throttles `this._checkForIntersections`.


    this._checkForIntersections = throttle(this._checkForIntersections.bind(this), this.THROTTLE_TIMEOUT); // Private properties.

    this._callback = callback;
    this._observationTargets = [];
    this._queuedEntries = [];
    this._rootMarginValues = this._parseRootMargin(options.rootMargin); // Public properties.

    this.thresholds = this._initThresholds(options.threshold);
    this.root = options.root || null;
    this.rootMargin = this._rootMarginValues.map(function (margin) {
      return margin.value + margin.unit;
    }).join(' ');
  }
  /**
   * The minimum interval within which the document will be checked for
   * intersection changes.
   */


  IntersectionObserver.prototype.THROTTLE_TIMEOUT = 100;
  /**
   * The frequency in which the polyfill polls for intersection changes.
   * this can be updated on a per instance basis and must be set prior to
   * calling `observe` on the first target.
   */

  IntersectionObserver.prototype.POLL_INTERVAL = null;
  /**
   * Use a mutation observer on the root element
   * to detect intersection changes.
   */

  IntersectionObserver.prototype.USE_MUTATION_OBSERVER = true;
  /**
   * Starts observing a target element for intersection changes based on
   * the thresholds values.
   * @param {Element} target The DOM element to observe.
   */

  IntersectionObserver.prototype.observe = function (target) {
    var isTargetAlreadyObserved = this._observationTargets.some(function (item) {
      return item.element == target;
    });

    if (isTargetAlreadyObserved) {
      return;
    }

    if (!(target && target.nodeType == 1)) {
      throw new Error('target must be an Element');
    }

    this._registerInstance();

    this._observationTargets.push({
      element: target,
      entry: null
    });

    this._monitorIntersections();

    this._checkForIntersections();
  };
  /**
   * Stops observing a target element for intersection changes.
   * @param {Element} target The DOM element to observe.
   */


  IntersectionObserver.prototype.unobserve = function (target) {
    this._observationTargets = this._observationTargets.filter(function (item) {
      return item.element != target;
    });

    if (!this._observationTargets.length) {
      this._unmonitorIntersections();

      this._unregisterInstance();
    }
  };
  /**
   * Stops observing all target elements for intersection changes.
   */


  IntersectionObserver.prototype.disconnect = function () {
    this._observationTargets = [];

    this._unmonitorIntersections();

    this._unregisterInstance();
  };
  /**
   * Returns any queue entries that have not yet been reported to the
   * callback and clears the queue. This can be used in conjunction with the
   * callback to obtain the absolute most up-to-date intersection information.
   * @return {Array} The currently queued entries.
   */


  IntersectionObserver.prototype.takeRecords = function () {
    var records = this._queuedEntries.slice();

    this._queuedEntries = [];
    return records;
  };
  /**
   * Accepts the threshold value from the user configuration object and
   * returns a sorted array of unique threshold values. If a value is not
   * between 0 and 1 and error is thrown.
   * @private
   * @param {Array|number=} opt_threshold An optional threshold value or
   *     a list of threshold values, defaulting to [0].
   * @return {Array} A sorted list of unique and valid threshold values.
   */


  IntersectionObserver.prototype._initThresholds = function (opt_threshold) {
    var threshold = opt_threshold || [0];
    if (!Array.isArray(threshold)) threshold = [threshold];
    return threshold.sort().filter(function (t, i, a) {
      if (typeof t != 'number' || isNaN(t) || t < 0 || t > 1) {
        throw new Error('threshold must be a number between 0 and 1 inclusively');
      }

      return t !== a[i - 1];
    });
  };
  /**
   * Accepts the rootMargin value from the user configuration object
   * and returns an array of the four margin values as an object containing
   * the value and unit properties. If any of the values are not properly
   * formatted or use a unit other than px or %, and error is thrown.
   * @private
   * @param {string=} opt_rootMargin An optional rootMargin value,
   *     defaulting to '0px'.
   * @return {Array<Object>} An array of margin objects with the keys
   *     value and unit.
   */


  IntersectionObserver.prototype._parseRootMargin = function (opt_rootMargin) {
    var marginString = opt_rootMargin || '0px';
    var margins = marginString.split(/\s+/).map(function (margin) {
      var parts = /^(-?\d*\.?\d+)(px|%)$/.exec(margin);

      if (!parts) {
        throw new Error('rootMargin must be specified in pixels or percent');
      }

      return {
        value: parseFloat(parts[1]),
        unit: parts[2]
      };
    }); // Handles shorthand.

    margins[1] = margins[1] || margins[0];
    margins[2] = margins[2] || margins[0];
    margins[3] = margins[3] || margins[1];
    return margins;
  };
  /**
   * Starts polling for intersection changes if the polling is not already
   * happening, and if the page's visibility state is visible.
   * @private
   */


  IntersectionObserver.prototype._monitorIntersections = function () {
    if (!this._monitoringIntersections) {
      this._monitoringIntersections = true; // If a poll interval is set, use polling instead of listening to
      // resize and scroll events or DOM mutations.

      if (this.POLL_INTERVAL) {
        this._monitoringInterval = setInterval(this._checkForIntersections, this.POLL_INTERVAL);
      } else {
        addEvent(window, 'resize', this._checkForIntersections, true);
        addEvent(document, 'scroll', this._checkForIntersections, true);

        if (this.USE_MUTATION_OBSERVER && 'MutationObserver' in window) {
          this._domObserver = new MutationObserver(this._checkForIntersections);

          this._domObserver.observe(document, {
            attributes: true,
            childList: true,
            characterData: true,
            subtree: true
          });
        }
      }
    }
  };
  /**
   * Stops polling for intersection changes.
   * @private
   */


  IntersectionObserver.prototype._unmonitorIntersections = function () {
    if (this._monitoringIntersections) {
      this._monitoringIntersections = false;
      clearInterval(this._monitoringInterval);
      this._monitoringInterval = null;
      removeEvent(window, 'resize', this._checkForIntersections, true);
      removeEvent(document, 'scroll', this._checkForIntersections, true);

      if (this._domObserver) {
        this._domObserver.disconnect();

        this._domObserver = null;
      }
    }
  };
  /**
   * Scans each observation target for intersection changes and adds them
   * to the internal entries queue. If new entries are found, it
   * schedules the callback to be invoked.
   * @private
   */


  IntersectionObserver.prototype._checkForIntersections = function () {
    var rootIsInDom = this._rootIsInDom();

    var rootRect = rootIsInDom ? this._getRootRect() : getEmptyRect();

    this._observationTargets.forEach(function (item) {
      var target = item.element;
      var targetRect = getBoundingClientRect(target);

      var rootContainsTarget = this._rootContainsTarget(target);

      var oldEntry = item.entry;

      var intersectionRect = rootIsInDom && rootContainsTarget && this._computeTargetAndRootIntersection(target, rootRect);

      var newEntry = item.entry = new IntersectionObserverEntry({
        time: now(),
        target: target,
        boundingClientRect: targetRect,
        rootBounds: rootRect,
        intersectionRect: intersectionRect
      });

      if (!oldEntry) {
        this._queuedEntries.push(newEntry);
      } else if (rootIsInDom && rootContainsTarget) {
        // If the new entry intersection ratio has crossed any of the
        // thresholds, add a new entry.
        if (this._hasCrossedThreshold(oldEntry, newEntry)) {
          this._queuedEntries.push(newEntry);
        }
      } else {
        // If the root is not in the DOM or target is not contained within
        // root but the previous entry for this target had an intersection,
        // add a new record indicating removal.
        if (oldEntry && oldEntry.isIntersecting) {
          this._queuedEntries.push(newEntry);
        }
      }
    }, this);

    if (this._queuedEntries.length) {
      this._callback(this.takeRecords(), this);
    }
  };
  /**
   * Accepts a target and root rect computes the intersection between then
   * following the algorithm in the spec.
   * TODO(philipwalton): at this time clip-path is not considered.
   * https://w3c.github.io/IntersectionObserver/#calculate-intersection-rect-algo
   * @param {Element} target The target DOM element
   * @param {Object} rootRect The bounding rect of the root after being
   *     expanded by the rootMargin value.
   * @return {?Object} The final intersection rect object or undefined if no
   *     intersection is found.
   * @private
   */


  IntersectionObserver.prototype._computeTargetAndRootIntersection = function (target, rootRect) {
    // If the element isn't displayed, an intersection can't happen.
    if (window.getComputedStyle(target).display == 'none') return;
    var targetRect = getBoundingClientRect(target);
    var intersectionRect = targetRect;
    var parent = getParentNode(target);
    var atRoot = false;

    while (!atRoot) {
      var parentRect = null;
      var parentComputedStyle = parent.nodeType == 1 ? window.getComputedStyle(parent) : {}; // If the parent isn't displayed, an intersection can't happen.

      if (parentComputedStyle.display == 'none') return;

      if (parent == this.root || parent == document) {
        atRoot = true;
        parentRect = rootRect;
      } else {
        // If the element has a non-visible overflow, and it's not the <body>
        // or <html> element, update the intersection rect.
        // Note: <body> and <html> cannot be clipped to a rect that's not also
        // the document rect, so no need to compute a new intersection.
        if (parent != document.body && parent != document.documentElement && parentComputedStyle.overflow != 'visible') {
          parentRect = getBoundingClientRect(parent);
        }
      } // If either of the above conditionals set a new parentRect,
      // calculate new intersection data.


      if (parentRect) {
        intersectionRect = computeRectIntersection(parentRect, intersectionRect);
        if (!intersectionRect) break;
      }

      parent = getParentNode(parent);
    }

    return intersectionRect;
  };
  /**
   * Returns the root rect after being expanded by the rootMargin value.
   * @return {Object} The expanded root rect.
   * @private
   */


  IntersectionObserver.prototype._getRootRect = function () {
    var rootRect;

    if (this.root) {
      rootRect = getBoundingClientRect(this.root);
    } else {
      // Use <html>/<body> instead of window since scroll bars affect size.
      var html = document.documentElement;
      var body = document.body;
      rootRect = {
        top: 0,
        left: 0,
        right: html.clientWidth || body.clientWidth,
        width: html.clientWidth || body.clientWidth,
        bottom: html.clientHeight || body.clientHeight,
        height: html.clientHeight || body.clientHeight
      };
    }

    return this._expandRectByRootMargin(rootRect);
  };
  /**
   * Accepts a rect and expands it by the rootMargin value.
   * @param {Object} rect The rect object to expand.
   * @return {Object} The expanded rect.
   * @private
   */


  IntersectionObserver.prototype._expandRectByRootMargin = function (rect) {
    var margins = this._rootMarginValues.map(function (margin, i) {
      return margin.unit == 'px' ? margin.value : margin.value * (i % 2 ? rect.width : rect.height) / 100;
    });

    var newRect = {
      top: rect.top - margins[0],
      right: rect.right + margins[1],
      bottom: rect.bottom + margins[2],
      left: rect.left - margins[3]
    };
    newRect.width = newRect.right - newRect.left;
    newRect.height = newRect.bottom - newRect.top;
    return newRect;
  };
  /**
   * Accepts an old and new entry and returns true if at least one of the
   * threshold values has been crossed.
   * @param {?IntersectionObserverEntry} oldEntry The previous entry for a
   *    particular target element or null if no previous entry exists.
   * @param {IntersectionObserverEntry} newEntry The current entry for a
   *    particular target element.
   * @return {boolean} Returns true if a any threshold has been crossed.
   * @private
   */


  IntersectionObserver.prototype._hasCrossedThreshold = function (oldEntry, newEntry) {
    // To make comparing easier, an entry that has a ratio of 0
    // but does not actually intersect is given a value of -1
    var oldRatio = oldEntry && oldEntry.isIntersecting ? oldEntry.intersectionRatio || 0 : -1;
    var newRatio = newEntry.isIntersecting ? newEntry.intersectionRatio || 0 : -1; // Ignore unchanged ratios

    if (oldRatio === newRatio) return;

    for (var i = 0; i < this.thresholds.length; i++) {
      var threshold = this.thresholds[i]; // Return true if an entry matches a threshold or if the new ratio
      // and the old ratio are on the opposite sides of a threshold.

      if (threshold == oldRatio || threshold == newRatio || threshold < oldRatio !== threshold < newRatio) {
        return true;
      }
    }
  };
  /**
   * Returns whether or not the root element is an element and is in the DOM.
   * @return {boolean} True if the root element is an element and is in the DOM.
   * @private
   */


  IntersectionObserver.prototype._rootIsInDom = function () {
    return !this.root || containsDeep(document, this.root);
  };
  /**
   * Returns whether or not the target element is a child of root.
   * @param {Element} target The target element to check.
   * @return {boolean} True if the target element is a child of root.
   * @private
   */


  IntersectionObserver.prototype._rootContainsTarget = function (target) {
    return containsDeep(this.root || document, target);
  };
  /**
   * Adds the instance to the global IntersectionObserver registry if it isn't
   * already present.
   * @private
   */


  IntersectionObserver.prototype._registerInstance = function () {
  };
  /**
   * Removes the instance from the global IntersectionObserver registry.
   * @private
   */


  IntersectionObserver.prototype._unregisterInstance = function () {
  };
  /**
   * Returns the result of the performance.now() method or null in browsers
   * that don't support the API.
   * @return {number} The elapsed time since the page was requested.
   */


  function now() {
    return window.performance && performance.now && performance.now();
  }
  /**
   * Throttles a function and delays its execution, so it's only called at most
   * once within a given time period.
   * @param {Function} fn The function to throttle.
   * @param {number} timeout The amount of time that must pass before the
   *     function can be called again.
   * @return {Function} The throttled function.
   */


  function throttle(fn, timeout) {
    var timer = null;
    return function () {
      if (!timer) {
        timer = setTimeout(function () {
          fn();
          timer = null;
        }, timeout);
      }
    };
  }
  /**
   * Adds an event handler to a DOM node ensuring cross-browser compatibility.
   * @param {Node} node The DOM node to add the event handler to.
   * @param {string} event The event name.
   * @param {Function} fn The event handler to add.
   * @param {boolean} opt_useCapture Optionally adds the even to the capture
   *     phase. Note: this only works in modern browsers.
   */


  function addEvent(node, event, fn, opt_useCapture) {
    if (typeof node.addEventListener == 'function') {
      node.addEventListener(event, fn, opt_useCapture || false);
    } else if (typeof node.attachEvent == 'function') {
      node.attachEvent('on' + event, fn);
    }
  }
  /**
   * Removes a previously added event handler from a DOM node.
   * @param {Node} node The DOM node to remove the event handler from.
   * @param {string} event The event name.
   * @param {Function} fn The event handler to remove.
   * @param {boolean} opt_useCapture If the event handler was added with this
   *     flag set to true, it should be set to true here in order to remove it.
   */


  function removeEvent(node, event, fn, opt_useCapture) {
    if (typeof node.removeEventListener == 'function') {
      node.removeEventListener(event, fn, opt_useCapture || false);
    } else if (typeof node.detatchEvent == 'function') {
      node.detatchEvent('on' + event, fn);
    }
  }
  /**
   * Returns the intersection between two rect objects.
   * @param {Object} rect1 The first rect.
   * @param {Object} rect2 The second rect.
   * @return {?Object} The intersection rect or undefined if no intersection
   *     is found.
   */


  function computeRectIntersection(rect1, rect2) {
    var top = Math.max(rect1.top, rect2.top);
    var bottom = Math.min(rect1.bottom, rect2.bottom);
    var left = Math.max(rect1.left, rect2.left);
    var right = Math.min(rect1.right, rect2.right);
    var width = right - left;
    var height = bottom - top;
    return width >= 0 && height >= 0 && {
      top: top,
      bottom: bottom,
      left: left,
      right: right,
      width: width,
      height: height
    };
  }
  /**
   * Shims the native getBoundingClientRect for compatibility with older IE.
   * @param {Element} el The element whose bounding rect to get.
   * @return {Object} The (possibly shimmed) rect of the element.
   */


  function getBoundingClientRect(el) {
    var rect;

    try {
      rect = el.getBoundingClientRect();
    } catch (err) {// Ignore Windows 7 IE11 "Unspecified error"
      // https://github.com/w3c/IntersectionObserver/pull/205
    }

    if (!rect) return getEmptyRect(); // Older IE

    if (!(rect.width && rect.height)) {
      rect = {
        top: rect.top,
        right: rect.right,
        bottom: rect.bottom,
        left: rect.left,
        width: rect.right - rect.left,
        height: rect.bottom - rect.top
      };
    }

    return rect;
  }
  /**
   * Returns an empty rect object. An empty rect is returned when an element
   * is not in the DOM.
   * @return {Object} The empty rect.
   */


  function getEmptyRect() {
    return {
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      width: 0,
      height: 0
    };
  }
  /**
   * Checks to see if a parent element contains a child element (including inside
   * shadow DOM).
   * @param {Node} parent The parent element.
   * @param {Node} child The child element.
   * @return {boolean} True if the parent node contains the child node.
   */


  function containsDeep(parent, child) {
    var node = child;

    while (node) {
      if (node == parent) return true;
      node = getParentNode(node);
    }

    return false;
  }
  /**
   * Gets the parent node of an element or its host element if the parent node
   * is a shadow root.
   * @param {Node} node The node whose parent to get.
   * @return {Node|null} The parent node or null if no parent exists.
   */


  function getParentNode(node) {
    var parent = node.parentNode;

    if (parent && parent.nodeType == 11 && parent.host) {
      // If the parent is a shadow root, return the host element.
      return parent.host;
    }

    if (parent && parent.assignedSlot) {
      // If the parent is distributed in a <slot>, return the parent of a slot.
      return parent.assignedSlot.parentNode;
    }

    return parent;
  } // Exposes the constructors globally.


  window.IntersectionObserver = IntersectionObserver;
  window.IntersectionObserverEntry = IntersectionObserverEntry;
})();

function BasicVideo(_ref) {
  var className = _ref.className,
      onReady = _ref.onReady,
      autoplay = _ref.autoplay,
      html = _ref.dangerouslySetInnerHTML.__html;
  var video = autoplay ? setParams(html, {
    mute: 1,
    autoplay: 1
  }) : setParams(html, {
    autoplay: 1
  });
  onReady && onReady();
  return /*#__PURE__*/createElement("div", {
    className: className,
    dangerouslySetInnerHTML: {
      __html: video
    }
  });
}

function setParam() {
  var videoHtml = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var param = arguments.length > 1 ? arguments[1] : undefined;
  var value = arguments.length > 2 ? arguments[2] : undefined;
  var paramAlreadySet = new RegExp("[?&]".concat(param, "="));
  var hasQueryParams = /\?[^=]+=/;
  var srcAttribute = /src="(\S+)"/;

  if (paramAlreadySet.test(videoHtml)) {
    return videoHtml;
  }

  var match = videoHtml.match(srcAttribute);
  if (match === null) return videoHtml;
  var url = match[1];
  var lastCharacter = url.charAt(url.length - 1);

  if (lastCharacter === '?' || lastCharacter === '&') {
    return videoHtml.replace(srcAttribute, "src=\"".concat(url).concat(param, "=").concat(value, "\""));
  }

  if (hasQueryParams.test(url)) {
    return videoHtml.replace(srcAttribute, "src=\"".concat(url, "&").concat(param, "=").concat(value, "\""));
  }

  return videoHtml.replace(srcAttribute, "src=\"".concat(url, "?").concat(param, "=").concat(value, "\""));
}

function setParams() {
  var videoHtml = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var params = arguments.length > 1 ? arguments[1] : undefined;

  for (var param in params) {
    var value = params[param];
    videoHtml = setParam(videoHtml, param, value);
  }

  return videoHtml;
}

function FacebookVideo(_ref) {
  var className = _ref.className,
      autoplay = _ref.autoplay,
      onReady = _ref.onReady,
      html = _ref.dangerouslySetInnerHTML.__html;
  var videoRef = useRef(null);
  useEffect(function () {
    if (!FB) {
      throw Error('Facebook SDK is not loaded');
    }

    var id = String(Math.random());

    if (videoRef.current !== null) {
      var fbVideo = videoRef.current.querySelector('.fb-video');

      if (fbVideo !== null) {
        fbVideo.setAttribute('data-autoplay', 'true');
        fbVideo.setAttribute('id', id);
      }

      FB.XFBML.parse(videoRef.current);
      FB.Event.subscribe('xfbml.ready', function (msg) {
        if (msg.type === 'video' && msg.id === id) {
          onReady && onReady();

          if (autoplay) {
            msg.instance.mute();
          } else {
            msg.instance.unmute();
          }
        }
      });
    }
  }, []);
  return /*#__PURE__*/createElement("div", {
    className: className,
    ref: videoRef,
    dangerouslySetInnerHTML: {
      __html: html
    }
  });
}

var _templateObject$1D, _templateObject2$_, _templateObject3$J, _templateObject4$G, _templateObject5$x, _templateObject6$r;
var VideoLoaderWrapper = styled.div(_templateObject$1D || (_templateObject$1D = _taggedTemplateLiteral(["\n  height: 100%;\n  margin: 0 auto;\n  overflow: hidden;\n  position: relative;\n  text-align: center;\n\n  ", " {\n    circle {\n      fill: ", ";\n      opacity: 0.9;\n    }\n    polygon {\n      fill: ", ";\n    }\n  }\n\n  &:hover {\n    cursor: pointer;\n\n    ", " {\n      polygon {\n        fill: ", ";\n      }\n    }\n  }\n"])), VideoPlay, PRIMARY_WHITE, PRIMARY_BLUE, VideoPlay, PRIMARY_BLUE_HOVER);
var VideoLoaderButton = styled.div(_templateObject2$_ || (_templateObject2$_ = _taggedTemplateLiteral(["\n  left: 50%;\n  position: absolute;\n  top: 50%;\n  transform: translate(-50%, -50%);\n"])));
var VideoLoaderThumbnail = styled.img(_templateObject3$J || (_templateObject3$J = _taggedTemplateLiteral(["\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n"]))); // TODO: Improve support for non-16/9 videos

var VideoWrapper = styled.div(_templateObject4$G || (_templateObject4$G = _taggedTemplateLiteral(["\n  background-color: black;\n  height: 0;\n  padding-bottom: 56.25%;\n  position: relative;\n  ", "\n\n  iframe,\n  video {\n    height: 100%;\n    left: 0;\n    position: absolute;\n    top: 0;\n    width: 100%;\n  }\n"])), function (_ref) {
  var videoLoaded = _ref.videoLoaded;

  if (!videoLoaded) {
    return css(_templateObject5$x || (_templateObject5$x = _taggedTemplateLiteral(["\n        visibility: hidden;\n      "])));
  }
});

var useEnterView = function useEnterView(onEnterView, threshold) {
  var ref = useRef(null);
  useEffect(function () {
    // TODO: FIXME: we create an intersection observer after each render. We should create once and keep a ref.
    // References to window object must be done in useEffect or componentDidMount to be
    // ignored by gatsby when building the DS website. Otherwise we get
    // `XXX is not defined` errors
    var observer = new window.IntersectionObserver(function (entries) {
      var hasEnteredView = entries.some(function (entry) {
        return entry.intersectionRatio >= threshold;
      });

      if (hasEnteredView) {
        onEnterView();
      }
    }, {
      threshold: threshold
    });

    if (ref.current !== null) {
      // TODO : check error ref.current "Argument of type null is..."
      observer.observe(ref.current);
    }
  });
  return ref;
};

function VideoLoaderComponent(_ref2) {
  var autoplay = _ref2.autoplay,
      className = _ref2.className,
      placeholder = _ref2.placeholder,
      provider = _ref2.provider,
      srcSet = _ref2.srcSet,
      videoHtml = _ref2.videoHtml;

  var _React$useState = useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      videoMounted = _React$useState2[0],
      setVideoMounted = _React$useState2[1];

  var _React$useState3 = useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      videoLoaded = _React$useState4[0],
      setVideoLoaded = _React$useState4[1];

  var ref = useEnterView(function () {
    if (autoplay) {
      setVideoMounted(true);
    }
  }, 1);
  var VideoElement = getVideoElement(provider);
  return /*#__PURE__*/createElement(Fragment, null, !videoLoaded && /*#__PURE__*/createElement(VideoLoaderWrapper, {
    ref: ref,
    className: className,
    onClick: function onClick(event) {
      event.preventDefault();
      setVideoMounted(true);
    }
  }, /*#__PURE__*/createElement(VideoLoaderButton, null, !videoMounted && /*#__PURE__*/createElement(VideoPlay, {
    size: 72
  }), videoMounted && /*#__PURE__*/createElement(Spinner$1, null)), /*#__PURE__*/createElement(VideoLoaderThumbnail, {
    src: placeholder,
    srcSet: srcSet
  })), videoMounted && /*#__PURE__*/createElement(VideoWrapper, {
    videoLoaded: videoLoaded,
    className: className
  }, /*#__PURE__*/createElement(VideoElement, {
    onReady: function onReady() {
      return setVideoLoaded(true);
    },
    autoplay: autoplay,
    dangerouslySetInnerHTML: {
      __html: videoHtml
    }
  })));
}

var VideoLoader = styled(VideoLoaderComponent)(_templateObject6$r || (_templateObject6$r = _taggedTemplateLiteral([""])));
VideoLoader.displayName = 'VideoLoader';

function getVideoElement(provider) {
  if (provider === 'Facebook') {
    return FacebookVideo;
  }

  return BasicVideo;
}

var _templateObject$1E;

function WysiwygContentComponent(_ref) {
  var _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? 'eager' : _ref$loading,
      nativeLazyLoad = _ref.nativeLazyLoad,
      dangerouslySetInnerHTML = _ref.dangerouslySetInnerHTML,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, ["loading", "nativeLazyLoad", "dangerouslySetInnerHTML", "className"]);

  if (loading === 'lazy') {
    return /*#__PURE__*/createElement(LazyWysiwyg, {
      nativeLazyLoad: nativeLazyLoad
    }, /*#__PURE__*/createElement("div", _extends({
      className: className,
      dangerouslySetInnerHTML: dangerouslySetInnerHTML
    }, rest)));
  } else {
    return /*#__PURE__*/createElement("div", _extends({
      className: className,
      dangerouslySetInnerHTML: dangerouslySetInnerHTML
    }, rest));
  }
}

var WysiwygContent = styled(WysiwygContentComponent)(_templateObject$1E || (_templateObject$1E = _taggedTemplateLiteral(["\n  a {\n    ", "\n    ", "\n    ", "\n    font-weight: 300;\n    overflow-wrap: break-word;\n  }\n\n  blockquote {\n    ", "\n    display: inline-flex;\n    line-height: 38px;\n    margin-left: 0;\n\n    &::before {\n      border-left: 2px ", " solid;\n      content: \"\";\n      padding-right: 26px;\n    }\n  }\n\n  h1 {\n    ", "\n  }\n\n  h2 {\n    ", "\n  }\n\n  h3 {\n    ", "\n  }\n\n  h4 {\n    ", "\n  }\n\n  h5 {\n    ", "\n  }\n\n  h6 {\n    ", "\n  }\n\n  iframe,\n  img {\n    max-width: 100%;\n  }\n\n  /* Exclude Soundcloud widgets from height assignment. When we alter height, Soundcloud fails to compute\n  ** the correct height on mobile and hides the track list.\n   */\n  iframe:not([src*=\"soundcloud.com\"]),\n  img {\n    /* NOTE: Force auto-height to avoid user-defined custom values breaking aspect ratio on small screens. */\n    @media not screen and ", " {\n      height: auto !important;\n    }\n  }\n\n  img[align=\"left\"],\n  img[style*=\"float:left\"],\n  img[style*=\"float: left\"] {\n    margin-right: 40px;\n  }\n\n  img[align=\"right\"],\n  img[style*=\"float:right\"],\n  img[style*=\"float: right\"] {\n    margin-left: 40px;\n  }\n\n  li {\n    ", "\n\n    & > p {\n      display: inline;\n    }\n  }\n\n  ol,\n  p,\n  strong,\n  ul {\n    ", "\n    margin: 1em 0;\n  }\n\n  ol,\n  strong,\n  ul {\n    color: inherit;\n  }\n\n  ol,\n  ul {\n    padding-left: 20px;\n  }\n\n  ol {\n    counter-reset: item;\n\n    & > li {\n      counter-increment: item;\n      list-style-type: none;\n      margin: 0;\n      padding: 0 0 0 2em;\n      text-indent: -2em;\n\n      &::before {\n        content: counter(item) \".\";\n        display: inline-block;\n        font-weight: 500;\n        padding-right: 0.5em;\n        text-align: right;\n        width: 1em;\n      }\n    }\n  }\n\n  && {\n    strong {\n      font-weight: bold;\n    }\n  }\n\n  ul {\n    list-style: none;\n\n    & > li::before {\n      content: \"\u2022\";\n      padding-right: 0.5em;\n    }\n  }\n"])), link._baseStyle, link._primaryStyle, link._primaryTintedColor, heading._largeStyle, GREY_SHADE_5, heading._mediumStyle, heading._smallStyle, heading._xSmallStyle, heading._xxSmallStyle, heading._xxxSmallStyle, heading._xxxxSmallStyle, TABLET, copy.largeStyle, copy.largeStyle);
WysiwygContent.displayName = 'WysiwygContent';

if (typeof window !== 'undefined') {
  window.OWL_KIT_COMPONENTS_VERSION = '"1.0.0-beta.29" / "production"';
} // eslint-disable-next-line no-undef

export { Autocomplete, AutocompleteField, AutocompleteFieldWrapper, breakpoints as BREAKPOINTS, BigRadioList, Button$2 as Button, colors as COLORS, Callout$1 as Callout, ChannelCard, Checkbox, CheckboxField, CheckboxFieldWrapper, ControlledCheckbox, ControlledCheckboxWrapper, ControlledRadioInput, ControlledRadioInputWrapper, Dropdown$1 as Dropdown, DropdownField, DropdownFieldWrapper, ERROR_STATUS_CLASS, ERROR_STATUS_SELECTOR, EggProgress, fonts as FONTS, Field, FieldStatus, Flash, HorizontalProjectCard, Jewel, Link$1 as Link, LinkButton, MenuDropdown, MiniChannelCard, Modal, ModalComponent, NUMBER_FORMAT_CONFIG, Option, OverlayModal, OverlayModalComponent, PasswordField, Pastille$1 as Pastille, PhoneField, PhoneFieldWrapper, PhoneInput, PrefixSelect, RadioField, RadioFieldWrapper, RadioGroupField, RadioInput, RewardCard, RoundButton$1 as RoundButton, RoundTag$1 as RoundTag, sizes as SIZES, SUCCESS_STATUS_CLASS, SUCCESS_STATUS_SELECTOR, SearchInput, Select, SelectButton, SelectComponent, SelectDrawer, SelectField, SelectFieldWrapper, SkewedBanner, SmallModal, SmallModalComponent, SmallRadioList, SocialButton, SocialButtonComponent, Spinner$1 as Spinner, StyledCheckboxField, StyledRadioField, Tab, TabMenu, Tag$2 as Tag, TextAreaField, TextAreaFieldWrapper, TextField, TextFieldWrapper, Tooltip$1 as Tooltip, UserCard, UserLabel$1 as UserLabel, Variant, VideoLoader, WysiwygContent, zindex as ZINDEX, index as behaviours, index$1 as glyphs, index$2 as hooks, index$3 as illustrations, label, index$4 as logos, radioGroupContext, styleCheckToggle, styleRadioToggle, index$5 as styles, tag$1 as tag, useSelect$1 as useSelect };
//# sourceMappingURL=next.esm.js.map
